/**
 * Auto-generated TypeScript file for book sfd_basic_skills
 * Generated from book_build/books/sfd_basic_skills
 */

import { AppBook } from '../types';

export const booksfd_basic_skills: AppBook = {
  "book_id": "sfd_basic_skills",
  "title": "SFD Basic Skills Manual",
  "chapters": {
    "1": {
      "chapter_id": "1",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_20_75b69eee",
          "question": "The Corey Wrench is used to remove and replace the fire hydrant caps.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Corey Wrench is used to remove and replace the fire hydrant caps.' This supports the statement, indicating that the Corey Wrench is indeed used for these specific tasks. This is important for firefighters to know as it affects how they would handle and operate the equipment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_20_4e01a321",
          "question": "The Galvin Wrench is not designed to open or close the main stem of a fire hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts the statement, saying 'The Galvin Wrench is designed to be used to open or close the main stem of a fire hydrant.' This means that the Galvin Wrench is indeed designed for this purpose. Understanding the correct use of this tool is crucial for firefighters to ensure efficient and effective operation during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_20_cc848c56",
          "question": "The Corey Wrench can be used to open a hydrant\u2019s main stem if there is an obstruction that will not allow the Galvin wrench to spin completely.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text confirms this by stating, 'It can also be used to open a hydrant\u2019s main stem if there is an obstruction that will not allow the Galvin wrench to spin completely.' This indicates that the Corey Wrench can be used as a backup tool in case of obstructions. This knowledge can be vital for firefighters in emergency situations where quick decision-making is required.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_20_03f4b38e",
          "question": "The Galvin Wrench and the Corey Wrench cannot be used in conjunction to open or close the \u201cfoot valve\u201d of a hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'The box end may be used, in conjunction with the Corey Wrench, to open or close the \u201cfoot valve\u201d of a hydrant.' This suggests that these two tools can indeed be used together for this purpose. This is a critical operational concern for firefighters, as it affects how they would approach the task of opening or closing a hydrant's foot valve.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_20_f3ea58bc",
          "question": "The five-sided hole in the Galvin Wrench does not correspond with the shape of the hydrant main stem nut.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'The five-sided hole in the middle of the wrench corresponds with the shape of the hydrant main stem nut.' This means that the Galvin Wrench is specifically designed to fit the hydrant main stem nut. Understanding this can help firefighters use the tool more effectively and safely during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_36_3795fae0",
          "question": "The Cutter and the Spreader from the Seattle Fire Department Tool Specifications have the same weight.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'CUTTER \u2212 Weight: 42.5 lbs.' and 'SPREADER \u2212 Weight: 42.5 lbs.' This means both tools have the same weight. This could be important in situations where firefighters need to choose between these tools based on their weight and the physical strength of the firefighter.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_36_79ba0225",
          "question": "The Telescopic Ram has a higher maximum spread force in its 2nd section compared to the 1st section.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'TELESCOPIC RAM \u2212 Max. Spread Force 1st Section: 49,145 lbs. \u2212 Max. Spread Force 2nd Section: 18,210 lbs.' This indicates that the maximum spread force is higher in the 1st section than in the 2nd section. This could impact the choice of tool depending on the force required in a rescue operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_36_2b510816",
          "question": "The Hand Operated Combination Tool has a lower maximum pulling force than the Combination Tool.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'COMBINATION TOOL \u2212 Maximum Pulling Force: 14,358 lbs.' and 'HAND OPERATED COMBINATION TOOL \u2212 Maxi mum Pulling Force: 6,590 lbs.' This means the Hand Operated Combination Tool has a lower maximum pulling force. This could impact the choice of tool depending on the pulling force required in a rescue operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_36_cae6aecb",
          "question": "The maximum spreading travel of the Spreader is greater than that of the Combination Tool.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'SPREADER \u2212 Maximum Spreading Travel: 27 \u00bc\u201d' and 'COMBINATION TOOL \u2212 Maximum Spreading Travel: 14 \u00bc\u201d'. This means the Spreader has a greater maximum spreading travel than the Combination Tool. This could be a deciding factor when needing to spread materials over a larger distance in a rescue operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_36_87f79296",
          "question": "The Telescopic Mini Ram has a lower weight than the Telescopic Ram.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'TELESCOPIC RAM \u2212 Weight: 40 lbs.' and 'TELESCOPIC MINI RAM \u2212 Weight: 27 lbs.' This means the Telescopic Mini Ram has a lower weight than the Telescopic Ram. This could be important in situations where firefighters need to choose between these tools based on their weight and the physical strength of the firefighter.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_16_6eab90c0",
          "question": "The Seattle Fire Department Fog Applicator is only used for fire extinguishment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Uses - Fire extinguishment, when a small amount of water is indicated. - Small space fires, attic, wall, etc.' This implies that the fog applicator is not only used for fire extinguishment but also for small space fires. This is important for firefighters to understand as it affects their tactical decisions and equipment usage during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_16_f5b32e70",
          "question": "The Fog Applicator can be used without a nozzle shut off.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Safety - Must be used with a nozzle shut off.' This contradicts the statement, indicating that the fog applicator must always be used with a nozzle shut off. This is a critical safety consideration for firefighters to prevent uncontrolled water flow and potential injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_16_9c3a0d1c",
          "question": "The Fog Applicator is suitable for small space fires such as attics and walls.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Uses - Small space fires, attic, wall, etc.' This supports the statement that the fog applicator is suitable for small space fires. This has implications for firefighting tactics, particularly in residential or confined space scenarios where the fog applicator can be effectively used.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_16_9db99be1",
          "question": "The Seattle Fire Department Fog Applicator comes in sizes varying from 48 to 112 inches long.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Sizes: varying from 48 to 112 inches long.' This confirms the statement that the fog applicator comes in various sizes. This is important for firefighters to understand as it affects operational considerations, such as storage, transport, and handling of the equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_16_3dfc9426",
          "question": "The Fog Applicator is used when a large amount of water is indicated.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Uses - Fire extinguishment, when a small amount of water is indicated.' This contradicts the statement, indicating that the fog applicator is used when a small amount of water is indicated. This is a key operational consideration for firefighters, as it affects their choice of equipment and tactics in scenarios where water supply or water damage is a concern.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_6_6d6a31f9",
          "question": "A Sister Coupling is similar to a Double Female and is used to connect two unequal male ends.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states: 'A Sister Coupling is similar to a Double Female. However, the female threads are of differing sizes to connect two unequal male ends.' This supports the statement. The correct use of equipment like the Sister Coupling can ensure efficient water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_6_85e2b69b",
          "question": "A Brother Coupling is used to connect two equal female ends.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states: 'A Brother Coupling is similar to a Double Male. However, the male threads are of differing sizes. It is used to connect two unequal female ends.' This contradicts the statement. Understanding the correct use of equipment like the Brother Coupling can affect the efficiency of water delivery in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_6_598ed93f",
          "question": "A Sister Coupling and a Brother Coupling have the same thread sizes.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states: 'A Sister Coupling is similar to a Double Female. However, the female threads are of differing sizes to connect two unequal male ends.' and 'A Brother Coupling is similar to a Double Male. However, the male threads are of differing sizes. It is used to connect two unequal female ends.' This contradicts the statement. Understanding the differences in equipment can help firefighters make appropriate decisions during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_6_d19670ed",
          "question": "A Brother Coupling is similar to a Double Male.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states: 'A Brother Coupling is similar to a Double Male. However, the male threads are of differing sizes. It is used to connect two unequal female ends.' This supports the statement. Knowing the similarities and differences between equipment can help firefighters choose the right tool for the job.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_6_a560c172",
          "question": "The sizes for both Sister and Brother Couplings range from 2 \u00bd\u201d to 4\u201d.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states: '2 \u00bd\u201d to 4\u201d Sister Brother Coupling.' This supports the statement. Understanding the size range of these couplings can help firefighters ensure they have the right equipment for different hose connections.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_7_b4ec982c",
          "question": "A Storz Adaptor Coupling is used to connect SFD hose to hydrants or appliances of neighboring fire departments.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"A Storz Adaptor Coupling has male NST threads which connect to a 'sexless' coupling that uses a quick connect fitting. It is used to couple SFD hose to hydrants or appliances of neighboring fire departments.\" This statement directly supports the question. The firefighting implication is that this tool allows for interoperability between different fire departments, which can be crucial in mutual aid situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_7_d860ae05",
          "question": "To release coupled hose from a Storz Adaptor Coupling, the rocker buttons need to be twisted.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"To release coupled hose, the rocker buttons need to be depressed.\" This statement directly contradicts the question, which states that the buttons need to be twisted. The correct firefighting implication is that understanding how to correctly operate equipment is vital for efficient and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_7_ec3a86ff",
          "question": "The SFD routinely uses Storz fittings.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"NOTE: The SFD does not routinely use Storz fittings.\" This statement directly contradicts the question. The firefighting implication is that firefighters need to be aware of the equipment their department routinely uses and how it may differ from what other departments use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_7_1a11b139",
          "question": "Storz Adaptor Couplings are used in several surrounding cities on mutual aid.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"They are used in several of our surrounding cities on mutual aid.\" This statement directly supports the question. The firefighting implication is that understanding the equipment used by neighboring departments can facilitate smoother operations during mutual aid responses.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_7_896ceed8",
          "question": "Storz Adaptor Couplings have female NST threads.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"A Storz Adaptor Coupling has male NST threads which connect to a 'sexless' coupling that uses a quick connect fitting.\" This statement directly contradicts the question, which states that the Storz Adaptor Couplings have female NST threads. The correct firefighting implication is that knowing the specifics of firefighting equipment, such as thread types, is important for proper use and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_17_60b21e28",
          "question": "Bolt cutters are used by the Seattle Fire Department for forcible entry.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Seattle Fire Department Bolt Cutters Uses - Forcible entry'. This indicates that bolt cutters are indeed used for forcible entry by the Seattle Fire Department. In firefighting operations, forcible entry is a crucial tactic used to gain access to a structure, especially when time is of the essence and lives are at stake.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_17_77c6514e",
          "question": "The bolt cutters do not require any maintenance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Maintenance - Wipe clean - Keep cutter gaps tight by using adjustment screws'. This contradicts the statement that bolt cutters do not require any maintenance. Regular maintenance of equipment is crucial in firefighting operations to ensure tools are in working order and can perform optimally during emergencies.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_17_946bd6c9",
          "question": "Using bolt cutters does not require any safety gear.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Safety - Use proper safety gear (gloves and eye protection)'. This contradicts the statement that using bolt cutters does not require any safety gear. Safety is paramount in firefighting operations to protect firefighters from potential injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_17_ddabdad4",
          "question": "The bolt cutters' gaps can be adjusted using screws.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Keep cutter gaps tight by using adjustment screws'. This supports the statement that the bolt cutters' gaps can be adjusted using screws. Proper adjustment of equipment is important in firefighting operations to ensure the effectiveness and efficiency of the tools used.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_17_60c0add2",
          "question": "Bolt cutters are only used for cutting bolts.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Seattle Fire Department Bolt Cutters Uses - Forcible entry'. This contradicts the statement that bolt cutters are only used for cutting bolts. In firefighting operations, bolt cutters can be used for a variety of tasks, including forcible entry into locked or blocked areas.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_40_90c28f97",
          "question": "The Thermal Imager Camera (TIC) can only detect heat signatures through smoke.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In addition to smoke, the TIC will recognize a significant heat signature through sheet rock, lathe and plaster, and acoustic ceiling tile.' This contradicts the statement that TIC can only detect heat signatures through smoke. It is important for firefighters to understand that TIC can detect heat signatures through various materials, not just smoke. This can aid in locating hidden fires and trapped victims.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_40_bb133855",
          "question": "The Thermal Imager Camera (TIC) is a standard equipment on all engine companies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is standard equipment on Truck Companies and Battalion Chiefs\u2019 vehicles and select engine companies.' This contradicts the statement that TIC is standard equipment on all engine companies. Understanding the distribution of equipment across different units can impact decision-making during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_40_5a7fc1e4",
          "question": "The Thermal Imager Camera (TIC) uses thermographic technology to detect thermal radiation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Using thermographic technology, the TIC detects thermal (infrared) radiation from fire and trapped victims.' This supports the statement that TIC uses thermographic technology to detect thermal radiation. This technology can greatly assist in search and rescue operations and detecting hidden fires.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_40_01d56012",
          "question": "The Thermal Imager Camera (TIC) requires regular inspection and cleaning after use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Maintenance - Inspect and clean after use.' This supports the statement that TIC requires regular inspection and cleaning after use. Proper maintenance of firefighting equipment is crucial to ensure its functionality and longevity.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_40_93cd0b1c",
          "question": "The Thermal Imager Camera (TIC) is not water resistant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Specifications (many TIC variations are currently in use) - Water resistant.' This contradicts the statement that TIC is not water resistant. Understanding the specifications of firefighting equipment can impact its use in different firefighting scenarios, such as operations involving water.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_37_cd4d20a2",
          "question": "The type of extinguisher to be used depends on the fuel to be extinguished.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Choose the proper type of extinguisher for the fuel to be extinguished.' This implies that different types of fires require different types of extinguishers, based on the fuel involved. This is crucial for firefighters to understand as using the wrong type of extinguisher can be ineffective or even dangerous.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_37_a48eb319",
          "question": "All fire extinguishers are of the same weight.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text provides different weights for different types of extinguishers, for example, 'SELF WEIGHT 4 LBS 9 LBS 38 LBS 28 LBS 34 LBS'. This indicates that extinguishers vary in weight. This is important for firefighters to know as they need to be able to handle the equipment effectively in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_37_2c2bf826",
          "question": "After use, fire extinguishers do not need any maintenance or inspection.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Maintenance - Inspect for damage. - Check gauge for adequate pressure - Tag and send to Services after use.' This indicates that fire extinguishers require maintenance and inspection after use. This is important for firefighters to ensure the readiness and effectiveness of the equipment for future use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_37_7ad27394",
          "question": "The propellant used in all fire extinguishers is the same.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text lists different propellants for different types of extinguishers, for example, 'PROPELLENT NITROGEN AIR'. This indicates that different extinguishers use different propellants. This is important for firefighters to understand as the type of propellant can affect the extinguisher's performance and handling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_37_9c2f98da",
          "question": "The lever locking pin should always be in place in a fire extinguisher.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '- Ensure lever locking pin is in place.' This implies that the lever locking pin is an important safety feature of fire extinguishers. This is crucial for firefighters to ensure the extinguisher is safe to use and will function correctly when needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_21_8703db15",
          "question": "All bars used by the fire department are designed to be used by a single firefighter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Bars are designed to be carried and used by a single firefighter. However, some require a second operator equipped with a striking tool to accomplish the task.' This implies that while most bars are designed for single use, some require a second operator, contradicting the statement in the question. In firefighting operations, understanding the correct use of equipment is crucial for efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_21_360a1b4e",
          "question": "Bars used by the fire department can be used for prying, breaking, ramming, clawing, pulling, moving and lifting.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Uses - Forcible entry, heavy rescue - Prying, breaking, ramming, clawing, pulling, moving and lifting.' This supports the statement in the question. Understanding the versatile uses of bars can help firefighters make effective decisions during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_21_843e8197",
          "question": "Bars used by the fire department do not require any maintenance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Maintenance - Clean and inspect after use. Use a file to remove nicks. - Can be painted or left bare with light coat of oil.' This contradicts the statement in the question. Proper maintenance of firefighting equipment is crucial to ensure its longevity and reliability during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_21_af81d37a",
          "question": "Firefighters should rely on their brute strength rather than the mechanical advantage of the tool when using bars.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Choose the appropriate tool for the job. Allow the mechanical advantage of the tool do the work, not brute strength.' This contradicts the statement in the question. Using tools effectively can reduce physical strain on firefighters and increase operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_21_97b3743d",
          "question": "Firefighters should wear proper safety gear, including helmet, gloves, eye protection and boots when using bars.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Safety - Wear proper safety gear (helmet, gloves, eye and boots).' This supports the statement in the question. Wearing appropriate safety gear is essential to protect firefighters from potential injuries during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_10_f03d638a",
          "question": "A Hydrant Gate controls the flow of water from a 2 \u00bd\u201d hose port of a fire hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A Hydrant Gate is a gated valve fitting that controls the flow of water from a 2 \u00bd\u201d hose port of a fire hydrant.' This supports the statement and indicates that understanding the function of a Hydrant Gate is crucial for firefighters in managing water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_10_dd467bfc",
          "question": "A Hose Clamp is used to increase the flow of water in a fire hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Hose Clamp is a device used to compress fire hose in order to shut off the flow of water while in operation.' This contradicts the statement and highlights the importance of understanding how to control water flow during firefighting operations, which can be critical in situations where water supply is limited.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_10_1847aeee",
          "question": "When releasing the clamp, a firefighter should face the direction of the flow (source).",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Face the direction of the flow (destination) when releasing the clamp.' This contradicts the statement and emphasizes the importance of proper technique when handling equipment, which can affect safety and efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_10_93f2ad63",
          "question": "A Hydrant Gate typically has a 2 \u00bd\u201d to 4\u201d Increaser attached to the male threads.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is typically kept with a 2 \u00bd\u201d to 4\u201d Increaser attached to the male threads.' This supports the statement and indicates that understanding the components of firefighting equipment is important for proper operation and maintenance.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_10_a64ff1eb",
          "question": "A Hose Clamp can be applied to an uncharged line to increase flow.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It can also be applied to an uncharged line to prevent flow.' This contradicts the statement and highlights the importance of understanding the function of a Hose Clamp, which can be used to control water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_26_5853e75a",
          "question": "The Positive Pressure Ventilation Fan is used for removing heat, smoke and fire gases from the fire scene.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Positive Pressure Ventilation Fan is an efficient mechanical method of removing heat, smoke and fire gases.' This supports the statement that the fan is used for removing heat, smoke, and fire gases. This is important for firefighters as it can help to improve visibility and reduce the intensity of the fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_26_3ed18cae",
          "question": "The Positive Pressure Ventilation Fan should be refueled before each use.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Refuel after each use.' This contradicts the statement that the fan should be refueled before each use. Proper maintenance of firefighting equipment is crucial for its effective operation during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_26_0152ca45",
          "question": "The Positive Pressure Ventilation Fan can be operated in an enclosed area without any safety concerns.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Use caution when operating in an enclosed area. Carbon Monoxide Contained in the exhaust fumes may reach dangerous levels.' This contradicts the statement that the fan can be operated in an enclosed area without any safety concerns. Firefighters need to be aware of this to prevent carbon monoxide poisoning.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_26_49615472",
          "question": "The Positive Pressure Ventilation Fan uses unleaded fuel.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Direct drive, 4 cycle using unleaded (white stripe) fuel.' This supports the statement that the fan uses unleaded fuel. Understanding the type of fuel used by the fan is important for firefighters for proper maintenance and operation of the equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_26_88dd4041",
          "question": "The Positive Pressure Ventilation Fan does not require any engine work.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Send to Services for engine work.' This contradicts the statement that the fan does not require any engine work. Regular engine work is necessary to ensure the efficient operation of the fan during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_30_4dbe1c00",
          "question": "The circular saw is a stationary tool that requires a fixed power source.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The circular saw is a portable saw carried on Truck Companies. It requires a power source but is mobile and easy to use.' This contradicts the statement that the circular saw is stationary and requires a fixed power source. The portability of the circular saw allows firefighters to use it in various locations during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_30_e3728a85",
          "question": "The circular saw is only designed to cut metal materials.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is designed to cut or rip wood materials.' This contradicts the statement that the circular saw is only designed to cut metal materials. Understanding the proper materials for the circular saw is crucial for firefighters to ensure effective and safe operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_30_8498e8cf",
          "question": "The circular saw requires regular maintenance such as blade replacement and cleaning.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Maintenance - Keep unit clean. - Replace blade as needed.' This supports the statement that the circular saw requires regular maintenance. Regular maintenance of firefighting equipment is essential to ensure its functionality and longevity during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_30_5a1da5b3",
          "question": "The circular saw blade stops immediately after the trigger is released.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Blade continues to rotate after trigger is released.' This contradicts the statement that the circular saw blade stops immediately after the trigger is released. This is a critical safety consideration for firefighters when using the circular saw during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_30_4c4b16b2",
          "question": "Proper safety gear such as gloves, eye protection, and boots should be worn when using the circular saw.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Safety - Wear proper safety gear (gloves, eye protection, and boots).' This supports the statement that proper safety gear should be worn when using the circular saw. Wearing appropriate safety gear is crucial for firefighters to prevent injuries during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_31_22ac9c49",
          "question": "The Rope Rescue Equipment carried by Truck Companies in Seattle Fire Department are designed to assist in the rescue of persons trapped in only high angle situations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Truck Companies carry an array of Rope Rescue Equipment designed to assist in the rescue of persons trapped in low or high angle situations.' This contradicts the question statement as it mentions both low and high angle situations. Understanding the range of situations where Rope Rescue Equipment can be used is crucial for firefighters to make effective rescue decisions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_31_04184a6e",
          "question": "The Rope Rescue Equipment provides a mechanical advantage to evacuate the victim to safety when properly applied.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When properly applied, the gear will provide a safe and efficient mechanical advantage to evacuate the victim to safety.' This supports the question statement. Knowing how to properly apply the equipment is a key safety and operational concern for firefighters during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_31_aa66374e",
          "question": "The materials used in the Rope Rescue Equipment include nylon webbing, kernmantle rope, steel and plastic.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Materials include nylon webbing, kernmantle rope, steel and aluminum.' This contradicts the question statement as it mentions aluminum instead of plastic. Understanding the materials used in the equipment can affect its handling, maintenance, and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_31_96f57f6c",
          "question": "The Rope Rescue Equipment can be used in cave-in situations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Uses - Low and high angle rescue, cave - in.' This supports the question statement. Knowing the variety of situations where the equipment can be used helps firefighters to make tactical decisions during different types of rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_31_42764341",
          "question": "Rescue rope does not need to be replaced after use in an actual rescue incident.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Rescue rope must be replaced after use in actual rescue incident.' This contradicts the question statement. Proper maintenance and replacement of equipment is a crucial aspect of firefighter safety and operational readiness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_27_33b5a6d8",
          "question": "The chainsaw is not suitable for ventilation purposes in firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The chainsaw is considered the best saw for ventilation.' This directly contradicts the question statement, indicating that the chainsaw is indeed suitable for ventilation purposes in firefighting operations. Ventilation is a critical firefighting tactic used to release heat and smoke from a structure, improving conditions for both firefighters and potential victims.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_27_3d85d36a",
          "question": "A chainsaw can be used to 'feel' the structural members beneath the roofing materials during firefighting operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The chainsaw can be used to \u201cfeel\u201d the structural members beneath the roofing materials.' This supports the question statement. This ability to 'feel' the structural members can help prevent unnecessary damage to the rafters and/or joists, which is crucial in preserving the structural integrity of the building during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_27_5ad2680c",
          "question": "The chainsaw is heavier than other saws, making it difficult to work from ladders.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The chainsaws light weight also makes it easy to work from ladders and in places where heavier saws would not be safe.' This directly contradicts the question statement, indicating that the chainsaw is actually lighter than other saws, making it easier to work from ladders. This is important for firefighters as they often need to work from heights and in confined spaces where heavier equipment would be unsafe or impractical.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_27_2646d75d",
          "question": "The chainsaw requires refuelling and oil check after each use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Refuel and check oil after each use.' This supports the question statement. Regular maintenance, including refuelling and checking oil, is essential to ensure the chainsaw's reliability and operational readiness, which can be critical in emergency firefighting situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_27_aa4ddc70",
          "question": "During training, chaps are not required when using the chainsaw.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Chaps are required for use during training but are not required during emergency use.' This directly contradicts the question statement, indicating that chaps are indeed required during training. This is an important safety consideration when using chainsaws, as chaps can provide protection against potential injuries from the chainsaw.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_11_6227ed52",
          "question": "The flow rates of the Seattle Fire Department Portable Ground Monitor do not depend on the nozzle size.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Flow rates depend on nozzle size (see Smooth Bore Nozzles)'. This contradicts the statement, indicating that the flow rates of the Portable Ground Monitor do indeed depend on the size of the nozzle. This is a key operational consideration for firefighters, as it impacts the amount of water that can be delivered to a fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_11_d2afe3f5",
          "question": "The Portable Ground Monitor is used to deliver powerful streams of water over short distances.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Monitors are used to deliver powerful streams of water over long distances'. This contradicts the statement, indicating that the Portable Ground Monitor is designed for long-range water delivery. This is an important tactical consideration when dealing with large-scale fires or fires in hard-to-reach locations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_11_79d1441f",
          "question": "It is not necessary to ensure that the Portable Ground Monitor is footed or anchored.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ensure that the Monitor is footed or anchored to counteract the strong nozzle reaction'. This contradicts the statement, indicating that it is crucial to secure the Portable Ground Monitor to counteract the force of the water being expelled. This is a vital safety consideration for firefighters to prevent the equipment from moving or tipping over during operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_11_d449f7a4",
          "question": "The Portable Ground Monitor should be kept lubricated and checked for loose tips as part of its maintenance.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Keep lubricated and check for loose tips'. This supports the statement, indicating that these are key maintenance tasks for the Portable Ground Monitor. Proper maintenance is essential for ensuring the reliability and effectiveness of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_11_743c8014",
          "question": "The Portable Ground Monitor is not designed to be ground mounted.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ground mounted'. This contradicts the statement, indicating that the Portable Ground Monitor is indeed designed to be mounted on the ground. This is an important operational consideration, as it affects the stability of the equipment during use and the tactics that can be employed in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_2_96d18137",
          "question": "The appropriate equipment and tools are not necessary for firefighters to accomplish their assigned tasks.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Without the appropriate equipment and tools, it would be impossible for firefighters to accomplish their assigned tasks.' This directly contradicts the statement in the question. The implication for firefighting is that having the right tools and equipment is essential for successful operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_2_bad55781",
          "question": "Firefighting equipment and tools must be maintained clean and in good working order.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Furthermore, they must be maintained clean and in good working order.' This directly supports the statement in the question. The implication for firefighting is that regular maintenance of equipment and tools is crucial for their effective operation and for the safety of the firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_2_fa4e5fd2",
          "question": "The section provides detailed information on each piece of equipment and specific methods of placing it into operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'While not providing detailed information on each piece of equipment or specific methods of placing it into operation...' This directly contradicts the statement in the question. The firefighting implication is that while this section provides an overview, firefighters must seek additional training or resources for detailed operation methods.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_2_61f838a1",
          "question": "Knowledge and proficiency of equipment and tools is not essential for success in recruit school and throughout their career.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Knowledge and proficiency of equipment and tools will be essential for success in recruit school and throughout their career.' This directly contradicts the statement in the question. The implication for firefighting is that understanding and being able to use firefighting tools and equipment is crucial for a successful firefighting career.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_2_b4d84710",
          "question": "The section is intended to assist new members recognize and understand the purpose of these fire service tools.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is also the intent to assist new members recognize and understand the purpose of these fire service tools.' This directly supports the statement in the question. The firefighting implication is that understanding the purpose and function of each tool is important for new members to effectively and safely conduct firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_28_e88a0bd6",
          "question": "The rotary saw carried by the Seattle Fire Department truck companies can be used for a variety of objectives due to its three different blades.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The rotary saw is a power saw that is carried on Seattle Fire Department truck companies. It has three different blades that allow it to be used for a variety of objectives.' This supports the statement as it directly mentions the versatility of the rotary saw due to its three different blades. This is important in firefighting as it allows for adaptability in different situations such as forcible entry, heavy rescue, or ventilation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_28_2f95bf54",
          "question": "The rotary saw is ineffective on hardwood flooring.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts the statement by saying, 'The Rotary Saw is very effective on hardw ood flooring.' This means that the rotary saw is indeed effective on hardwood flooring. This is crucial in firefighting scenarios where cutting through hardwood flooring may be necessary for rescue or ventilation purposes.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_28_9601774c",
          "question": "The rotary saw requires a hose-line and dry chemical extinguisher when cutting near flammable liquids.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying, 'If cutting near flammable liquids, a hose -line and dry chemical extinguisher is required.' This is a crucial safety measure in firefighting operations to prevent the ignition of flammable liquids by sparks produced during the operation of the saw.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_28_890f8092",
          "question": "The rotary saw does not produce sparks while in operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'It is common for the saw to produce sparks w hile in operation.' This means that the rotary saw does produce sparks when in operation. This is an important consideration in firefighting as it could potentially ignite flammable materials.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_28_fab17378",
          "question": "The rotary saw's blade should be replaced if it is smaller than 9 inches.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying, 'Repla ce blade if smaller than 9 inche s.' This indicates that the size of the blade is important for the effective operation of the saw. This is a crucial maintenance consideration in firefighting to ensure the saw is always ready and effective for use in various operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_12_2fc29b1f",
          "question": "The nozzle pressure for handlines is 80 PSI at the tip.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Nozzle pressure is 50 PSI at the tip for handlines'. This contradicts the statement in the question. Correct nozzle pressure is crucial for effective firefighting operations as it directly affects the reach and penetration of the water stream.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_12_78f75f76",
          "question": "The 1 \u215c\u201d size nozzle is used for monitors and has a GPM of 500.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text specifies 'SIZE GPM 1 \u215c\u201d 500'. This supports the statement in the question. Understanding the GPM output of different nozzle sizes is important for firefighters to ensure sufficient water supply for fire suppression.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_12_d5876db4",
          "question": "Smooth Bore Nozzle Tips are not used for fire attacks requiring deeper penetration.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Fire attack, when deeper penetration is needed'. This contradicts the statement in the question. Knowing when to use specific equipment like Smooth Bore Nozzle Tips is crucial for effective firefighting tactics.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_12_65dc6a78",
          "question": "Portable monitors should be properly footed for safety.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Ensure portable monitors are properly footed'. This supports the statement in the question. Proper footing of portable monitors is a safety measure to prevent equipment failure and potential injury.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_12_2f57c409",
          "question": "The 2 \u00bd\u201d size nozzle is used for handlines and has a GPM of 1650.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies '2 \u00bd\u201d 1650' under the section for monitors, not handlines. This contradicts the statement in the question. Correct understanding of equipment specifications is vital for effective and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_32_de937b80",
          "question": "A Class 3 Harness is worn by the firefighter in rescue applications for comfort.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Class 3 Harness \u2013 worn by the firefighter in rescue applications.' While the text does not explicitly mention comfort, the primary purpose of the Class 3 Harness is for safety during rescue applications, not comfort. The harness ensures that the firefighter is securely attached to the rope system, reducing the risk of falls and injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_32_7ee9ed49",
          "question": "The 12 mm Rescue Rope is used for main, belay, and accessory lines in rope rescue applications.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '12 mm Rescue Rope \u2013 low-stretch braided kernmantle rope used for main, belay, and accessory lines in rope rescue applications.' This supports the statement that the 12 mm Rescue Rope is used for main, belay, and accessory lines in rope rescue applications. Understanding the correct use of this rope is crucial for safe and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_32_55fd7bbc",
          "question": "The Prussik-Minding Pulley is used to connect components in rope systems.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Locking Steel Carabiner \u2013 used to connect components in rope systems.' This contradicts the statement that the Prussik-Minding Pulley is used to connect components in rope systems. In fact, the Prussik-Minding Pulley is used to create directional changes and mechanical advantages. Misunderstanding the use of these components could lead to ineffective or unsafe rope systems during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_32_6e32b5f8",
          "question": "The Brake Rack is a frictioning device used in lowering systems.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Brake Rack \u2013 frictioning device used in lowering systems.' This supports the statement that the Brake Rack is a frictioning device used in lowering systems. Understanding the function of the Brake Rack is important for safely lowering firefighters or victims during rope rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_32_7f563a7b",
          "question": "The Load Releasing Hitch allows the user to extend a loaded rope system under control.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Load Releasing Hitch \u2013 the LRH is tied using a 30\u2019 8mm cord and two locking steel carabiners. It allows the user to extend a loaded rope system under control.' This supports the statement that the Load Releasing Hitch allows the user to extend a loaded rope system under control. This knowledge is crucial for maintaining control of the rope system during rescue operations, which can enhance safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_24_d01a9b13",
          "question": "Salvage and overhaul tools are only used during the active firefighting phase.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Salvage and overhaul tools are essential for post-fire operations.' This directly contradicts the statement, indicating that these tools are used after the active firefighting phase, during the salvage and overhaul operations. Understanding when to use specific tools is crucial for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_24_91636331",
          "question": "Engine Companies are equipped with the same amount of tools as Truck Companies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Truck Companies carry an extensive complement of tools. Engine Companies are equipped with a more limited supply of tools.' This directly contradicts the statement. Understanding the different equipment capacities of Truck and Engine Companies can affect decision-making and tactics during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_24_318b3e6d",
          "question": "Shovels used in firefighting can have either wood or fiberglass shafts.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Shovels include scoop, folding, square, roof and round point. - Wood or fiberglass shafts.' This supports the statement. Knowing the materials used in tool construction can have implications for safety and durability during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_24_89b5aca0",
          "question": "The heads of the tools do not require any maintenance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Inspect heads for loose handles. - Heads should be painted or oiled to prevent rust.' This directly contradicts the statement. Regular maintenance of firefighting tools is essential to ensure their longevity and reliability during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_24_c4bb500b",
          "question": "It is not necessary to wear safety gear when using salvage and overhaul tools.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Wear appropriate safety gear.' This directly contradicts the statement. Wearing safety gear is a critical aspect of firefighter safety, even during post-fire operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_25_0958ea64",
          "question": "The Seattle Fire Department Portable Electrical Generator uses diesel fuel.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '- Uses unleaded fuel (white stripe)'. This contradicts the statement that the generator uses diesel fuel. Using the correct fuel is crucial for the proper operation and maintenance of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_25_2e8e3ae9",
          "question": "The Portable Electrical Generator can be used as a power source for operating lights, power tools, and submersible pumps.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Uses - Portable source of electricity. - Power for operating lights, power tools, submersible pumps, etc.'. This supports the statement that the generator can be used to power various equipment. Understanding the capabilities of the generator can help firefighters plan and execute operations more effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_25_ad2ffaf3",
          "question": "The Portable Electrical Generator should be sent to Services for cleaning.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Maintenance - Keep unit clean. - Refuel after use and store in ready condition. - Send to Services for engine repair and servicing.'. This contradicts the statement that the generator should be sent to Services for cleaning. It is important for firefighters to understand the correct maintenance procedures to ensure the longevity and reliability of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_25_aaf2196d",
          "question": "The Portable Electrical Generator can pose an electrical hazard in wet conditions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Also, use cautiously in wet conditions. Rain/snow and/or wet hands may present an electrical hazard.'. This supports the statement that the generator can pose an electrical hazard in wet conditions. Firefighters must be aware of this risk to ensure their safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_25_fa0cfbb3",
          "question": "The Portable Electrical Generator does not produce any Carbon Monoxide.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Use caution when operating in an enclosed area. Carbon Monoxide contained in the exhaust fumes may reach dangerous levels.'. This contradicts the statement that the generator does not produce any Carbon Monoxide. Firefighters must be aware of this risk to avoid potential Carbon Monoxide poisoning.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_33_79335a7f",
          "question": "The portable air monitor is used to monitor only Carbon Monoxide (CO) and Oxygen (O2) levels.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The portable air monitor is a gas monitor that allows the user to continuously monitor 4 atmospheric conditions: Carbon Monoxide (CO), Oxygen (O2), Hydrogen Sulfide (H2S), Lower Explosive Limit (LEL) \u2013 of combustible gasses'. This contradicts the question statement, which claims that only CO and O2 are monitored. The correct firefighting implications are that the monitor is used to detect not only CO and O2, but also H2S and combustible gasses, which is crucial for ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_33_be6be790",
          "question": "The portable air monitor has non-replaceable sensors and filters.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Replaceable sensors and filters'. This contradicts the question statement, which claims that the sensors and filters are non-replaceable. The correct firefighting implications are that the sensors and filters of the monitor can be replaced, which is important for maintaining the functionality and accuracy of the device during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_33_837572c3",
          "question": "The portable air monitor is used in confined space rescue operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Uses - Confined space rescue, overhaul atmospheric concerns, carbon monoxide alarms, cave-in rescue, flammable liquids, etc'. This supports the question statement, which claims that the monitor is used in confined space rescue operations. The firefighting implications are that the monitor is a crucial tool for assessing atmospheric conditions in confined spaces, which is key for ensuring firefighter safety during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_33_e43f7644",
          "question": "Daily checks are not necessary for the maintenance of the portable air monitor.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Maintenance - Perform daily checks'. This contradicts the question statement, which claims that daily checks are not necessary. The correct firefighting implications are that daily checks are necessary for the maintenance of the monitor, which is important for ensuring its proper functioning and reliability during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_33_96c122df",
          "question": "Respiratory protection is not necessary when using the portable air monitor.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Use respiratory protection until atmosphere proven safe'. This contradicts the question statement, which claims that respiratory protection is not necessary. The correct firefighting implications are that respiratory protection should be used until the monitor proves the atmosphere safe, which is crucial for protecting firefighters from potentially harmful gases.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_13_b4572aa0",
          "question": "The TFT Midmatic Nozzle is suitable for 2\u201d handlines.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Appropriate for 1 \u00be\u201d handlines only.' This contradicts the question statement, indicating that the TFT Midmatic Nozzle is not suitable for 2\u201d handlines. This is important for firefighters to know as using the incorrect equipment can impact firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_13_6617219e",
          "question": "The TFT Midmatic Nozzle requires 75 PSI at the tip to operate properly.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '75 PSI required at the tip to operate properly.' This supports the question statement, indicating that the TFT Midmatic Nozzle does require 75 PSI at the tip to operate properly. This is a key operational concern for firefighters as incorrect pressure can affect the effectiveness of firefighting efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_13_87add21a",
          "question": "The TFT Midmatic Nozzle can be lubricated with WD-40.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not use WD -40.' This contradicts the question statement, indicating that the TFT Midmatic Nozzle should not be lubricated with WD-40. This is an important maintenance consideration for firefighters to ensure the longevity and proper functioning of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_13_34d804a3",
          "question": "The TFT Midmatic Nozzle can be used for hydraulic ventilation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Hydraulic Ventilation.' This supports the question statement, indicating that the TFT Midmatic Nozzle can be used for hydraulic ventilation. This is a key tactical consideration for firefighters as hydraulic ventilation can be used to control the environment within a burning structure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_13_7b4fcc2f",
          "question": "The TFT Midmatic Nozzle should be opened quickly to prevent a water surge or water hammer.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Open slowly to prevent a water surge or water hammer.' This contradicts the question statement, indicating that the TFT Midmatic Nozzle should be opened slowly, not quickly, to prevent a water surge or water hammer. This is a critical safety implication for firefighters as a water surge or water hammer can potentially cause injury or damage equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_29_2a577d7c",
          "question": "The reciprocating saw is a stationary tool and not carried on any Seattle Fire Department truck companies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The reciprocating saw is a portable saw that is carried on all Seattle Fire Department truck companies and some engine companies.' This contradicts the statement, indicating that the saw is portable and is indeed carried on SFD truck companies. The portability of the saw allows for increased mobility during firefighting operations, which can be crucial during emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_29_24011397",
          "question": "The reciprocating saw can be operated simultaneously with the hydraulic rescue tools.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It can be operated simultaneously with the hydraulic rescue tools.' This supports the statement and indicates that the saw can be used in conjunction with other tools, allowing for more efficient rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_29_55e409b8",
          "question": "The reciprocating saw is only battery operated.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The SFD carries both corded and cordless models.' This contradicts the statement, indicating that not all reciprocating saws are battery operated. This is an important consideration for firefighters as it affects the operational readiness and usage of the tool.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_29_719219b8",
          "question": "The reciprocating saw requires no maintenance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Maintenance - Keep unit clean. - Replace the blades as needed. - Store saw in ready condition.' This contradicts the statement, indicating that the saw does require maintenance. Proper maintenance of firefighting equipment is crucial for operational readiness and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_29_e66c835f",
          "question": "When using the reciprocating saw, it is not necessary to wear proper safety gear.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Safety - Wear proper safety gear (gloves, eye protection, and boots).' This contradicts the statement, indicating that proper safety gear is necessary when using the saw. This is a critical safety consideration for firefighters to prevent injuries during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_3_732d288c",
          "question": "A Reducer is a coupling that increases the size of male threads.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Reducer is a coupling that reduces the size of male threads.' This contradicts the statement in the question. In firefighting operations, understanding the function of a reducer is crucial for ensuring proper connection of hoses of different sizes.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_3_3a66dece",
          "question": "An Increaser is a coupling that increases the size of male threads.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'An Increaser is a coupling that increases the size of male threads.' This supports the statement in the question. In firefighting, using an increaser allows firefighters to connect a smaller hose to a larger one, which can be necessary in situations where more water flow is required.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_3_1897292a",
          "question": "Couplings are always identified from the male side to the female side.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Couplings are always identified from the female side to the male side.' This contradicts the statement in the question. In firefighting, correctly identifying the sides of couplings is important for ensuring the correct and secure attachment of hoses.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_3_272a91b3",
          "question": "In firefighting couplings, female refers to external threads.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Female refers to internal threads.' This contradicts the statement in the question. In firefighting, understanding the difference between female and male threads is crucial for correctly connecting hoses and other equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_3_55979cfc",
          "question": "In firefighting couplings, male refers to external threads.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Male refers to external threads.' This supports the statement in the question. Understanding this is important in firefighting as it ensures proper connection of equipment, which can impact the effectiveness of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_34_4e89f0a8",
          "question": "The Holmatro Hydraulic Power Unit (DPU 30) weighs less than 50 lbs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Weight: 58 lbs.' This contradicts the statement that the unit weighs less than 50 lbs. The weight of the unit can affect the lifting and carrying techniques used by firefighters, which is a safety consideration.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_34_cc673f81",
          "question": "The Holmatro Hydraulic Power Unit (DPU 30) is powered by a Honda GX100 3HP 4 stroke engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Honda GX100 3HP 4 stroke engine.' This supports the statement that the unit is powered by this specific engine. The type of engine can affect the operation and maintenance of the unit, which is an operational concern for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_34_a42f81d7",
          "question": "The Holmatro Hydraulic Power Unit (DPU 30) has a single stage pump.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Two Stage Pump with dual power outlets.' This contradicts the statement that the unit has a single stage pump. The type of pump can affect the performance and capabilities of the unit, which is a tactical consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_34_b29cb226",
          "question": "The Holmatro Hydraulic Power Unit (DPU 30) should be cleaned and refueled after use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Clean and refuel after use.' This supports the statement that the unit should be cleaned and refueled after use. Proper maintenance can extend the life of the unit and ensure it is ready for the next operation, which is an operational concern for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_34_5f382821",
          "question": "Spilled or mishandled hydraulic fluid from the Holmatro Hydraulic Power Unit (DPU 30) does not pose a slip hazard.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Spilled or mishandled hydraulic fluid may create a slip hazard.' This contradicts the statement that spilled or mishandled hydraulic fluid does not pose a slip hazard. This is a safety implication for firefighters as it can lead to accidents during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_8_cacc9ba5",
          "question": "A Wye is an appliance designed to connect two or more lines into one line or two lines into an engine or appliance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Wye is an appliance designed to branch a singular water source into two or more hose lines.' This contradicts the statement, as a Wye is used to branch a single water source into multiple lines, not to connect multiple lines into one. This is important for firefighters to understand as it affects how they can distribute water during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_8_8be89ae5",
          "question": "A Siamese fitting is equipped with a clapper valve to prevent the backflow of water through the unused intakes.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is equipped with a clapper valve to prevent the backflow of water through the unused intakes.' This supports the statement. Understanding this feature of the Siamese fitting is crucial for firefighters as it prevents potential water supply issues during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_8_2523624c",
          "question": "Wyes are equipped with quarter-turn-ball or gated valves to control the flow of water.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Wyes are equipped with quarter-turn-ball or gated valves to control the flow of water.' This supports the statement. This is a key operational feature that firefighters need to understand to effectively control water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_8_d4e9a9d7",
          "question": "A Siamese fitting has a male threaded inlet swivels and a female threaded outlet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It has female threaded inlet swivels and a male threaded outlet.' This contradicts the statement, as a Siamese fitting has female threaded inlet swivels, not male. It's important for firefighters to understand this to ensure correct connection of hoses and appliances.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_8_a329462d",
          "question": "A Wye has a female threaded inlet and male threaded outlets.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It has a female threaded inlet and male threaded outlets.' This supports the statement. Firefighters need to understand this to ensure correct connection of hoses when using a Wye.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_22_9cb721cd",
          "question": "The primary uses of a firefighter's axe are for forcible entry and ventilation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Although the uses of an axe are varied, it is primarily used for forcible entry and ventilation.' This indicates that while an axe can be used for various tasks, its main functions in firefighting are to force entry into a structure and to aid in ventilation. These tasks are crucial in firefighting operations as they allow firefighters to access and navigate the fire scene effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_22_eb7e1ce9",
          "question": "Fiberglass handles on axes are weaker than wood handles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'Fiberglass is 50 times stronger than wood and does not rot.' This means that fiberglass handles are significantly more durable and long-lasting than wood handles. This is an important consideration for firefighters as it affects the reliability and lifespan of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_22_da321987",
          "question": "The pickhead axe is primarily used as a striking tool.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'The pickhead axe may be used for ripping, digging, and piercing.' This means that the pickhead axe is not primarily used as a striking tool, but rather for other tasks. Understanding the specific uses of each tool is crucial for firefighters to ensure they use their equipment effectively and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_22_03d7caff",
          "question": "Service axes are typically shorter and lighter than heavy duty axes.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying, 'Heavy duty axes are 36 inches and weigh 8 pounds. Service axes are shorter (typically 28 inches) and weigh 6 pounds.' This indicates that service axes are designed to be more compact and lightweight than heavy duty axes. This is important for firefighters to know as it affects the portability and ease of use of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_22_85645024",
          "question": "It is recommended to paint axes to aid in maintenance and inspection.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'Avoid painting to aid in maintenance and inspection.' This means that painting axes is not recommended as it can hinder maintenance and inspection processes. This is an important consideration for firefighters as it affects the upkeep and safety checks of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_18_b8a84b15",
          "question": "The Pike Pole is designed with a point and a hook to penetrate and pull materials respectively.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Pike Pole has a head that is designed with a point and a hook. The point allows the pole to penetrate materials and the hook allows them to be pulled or moved.' This directly supports the question statement. This design allows firefighters to manipulate their environment during operations, such as pulling down ceilings for ventilation or overhaul tasks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_18_cc1438f6",
          "question": "The Pike Pole can only be used for pulling ceilings and overhaul.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'Uses - Pulling ceilings - Overhaul - Ventilation - Water rescue (reaching tool)'. This contradicts the question as it states that the Pike Pole can also be used for ventilation and water rescue. Understanding the multiple uses of the Pike Pole can help firefighters make effective decisions during various operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_18_59d1dee6",
          "question": "The handles of the Pike Pole should be painted to prevent rust.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Keep handles free of paint. Heads may be painted to prevent rust.' This directly contradicts the question statement. Keeping the handles free of paint can ensure a better grip and safety for firefighters during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_18_6bb7c363",
          "question": "When using the Pike Pole, firefighters should be alert to large sections of ceiling falling while being pulled.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Be alert to large sections of ceiling falling while being pulled.' This directly supports the question statement. Being alert to falling debris is crucial for firefighter safety during operations involving the Pike Pole.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_18_61371115",
          "question": "The Pike Pole comes in sizes ranging from 4 feet to 16 feet.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Sizes range from 4 feet to 16 feet.' This directly supports the question statement. Understanding the size range of the Pike Pole can help firefighters choose the appropriate tool for different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_38_48a02542",
          "question": "The water vacuum is a tool used for the removal of water during salvage operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The water vac is an indispensable tool for the removal of water during salvage operations.' This supports the statement that the water vacuum is used for water removal during salvage operations. Understanding this is important for firefighters as it relates to salvage operations and the necessary equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_38_358b89cf",
          "question": "The water vacuum can be used effectively even if the water is deeper than the head of the wand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the water is deeper than the head of the wand, a Prosser pump may be required prior to the beginning of water vac use.' This contradicts the statement that the water vacuum can be used effectively in deep water. Firefighters need to understand the limitations of their equipment to ensure effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_38_d767f9d3",
          "question": "The water vacuum requires a gas power source to operate.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'it requires an electrical power source.' This contradicts the statement that the water vacuum requires a gas power source. Understanding the correct power source for equipment is crucial for firefighters to ensure they can operate it properly.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_38_c19ea3d9",
          "question": "The water vacuum is designed to be worn on a firefighter\u2019s back.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'it is designed to be worn on a firefighter\u2019s back.' This supports the statement that the water vacuum is designed to be worn on a firefighter\u2019s back. This is important for firefighters to know for operational considerations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_38_bbeeec55",
          "question": "The water vacuum is only carried on engine companies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Water vacuums are only carried on truck companies.' This contradicts the statement that the water vacuum is only carried on engine companies. Understanding which units carry specific equipment is important for firefighters to ensure effective resource allocation during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_4_1e57b61f",
          "question": "A Double Female Coupling is used to connect two female ends.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Double Female Coupling has female threads of equal size on both ends. It is used to connect two male ends.' This directly contradicts the question statement. In firefighting operations, using the correct coupling is crucial for ensuring the effective delivery of water to the fire scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_4_23598ae2",
          "question": "A Double Male Coupling has male threads of equal size on both ends.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A Double Male Coupling has male threads of equal size on both ends.' This directly supports the question statement. In firefighting, understanding the types of couplings and their uses is important for efficient equipment setup and operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_4_2c6379f5",
          "question": "A Double Male Coupling is used to connect two male ends.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Double Male Coupling...is used to connect two female ends.' This directly contradicts the question statement. In firefighting, using the correct coupling can impact the speed and efficiency of water delivery during fire suppression efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_4_54073c76",
          "question": "The size of the threads on both ends of a Double Female Coupling are different.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Double Female Coupling has female threads of equal size on both ends.' This directly contradicts the question statement. In firefighting, understanding the specifications of equipment like couplings is crucial for ensuring compatibility and functionality during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_4_59890a17",
          "question": "The Seattle Fire Department uses Double Female and Double Male Couplings.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Seattle Fire Department Double Female Coupling' and 'Double Male Coupling', which implies that these types of couplings are used by the department. This directly supports the question statement. In firefighting, knowledge of the types of equipment used by a department can aid in coordination and cooperation during joint operations with other departments.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_14_196ffa84",
          "question": "The TFT Handline Nozzle requires 200 PSI at the tip to operate properly.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '- 100 PSI required at the tip to operate properly.' This contradicts the statement in the question, which suggests 200 PSI is required. The correct PSI is important for the nozzle to function correctly, affecting firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_14_a9d03f2e",
          "question": "The TFT Handline Nozzle can be used for hydraulic ventilation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, 'Uses - Fire attack \u2013 offensive - Hydraulic Ventilation.' This supports the statement in the question. Understanding the uses of the nozzle can help firefighters make tactical decisions during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_14_00becda0",
          "question": "The TFT Handline Nozzle should be lubricated with WD-40.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, '- Do not use WD -40.' This contradicts the statement in the question. Using the correct lubricant is important for the maintenance and longevity of the equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_14_efed2d2f",
          "question": "The TFT Handline Nozzle has a removable tip for extending the line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '- Removable tip for extending the line (1 \u00bd\u201d male threads).' This supports the statement in the question. This feature can be crucial in firefighting operations where the line needs to be extended.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_14_69c8b2b6",
          "question": "The TFT Handline Nozzle should be opened quickly to prevent a water surge or water hammer.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'Open slowly to prevent a water surge or water hammer.' This contradicts the statement in the question. Opening the nozzle slowly is a safety measure to prevent sudden pressure changes that could potentially harm firefighters or damage equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_15_3a1c76c9",
          "question": "The Distributor Nozzle, also known as a 'Bulldozer' or 'Bresnan' Distributor, is designed to throw a heavy spray of water over an area 50 feet in diameter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is designed to throw a heavy spray of water over an area 30 feet in diameter.' This contradicts the question statement which incorrectly states 50 feet. Understanding the range of the nozzle is crucial for firefighters to effectively cover the fire area.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_15_11fd3af1",
          "question": "The Distributor Nozzle can be placed in operation by lowering it through an opening in a floor, decking, or roof, to the involved space below.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is placed in operation by lowering through an opening in a floor, decking, or roof, to the involved space below.' This supports the question statement. This operational knowledge is important for firefighters to deploy the nozzle correctly in different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_15_2a8c6733",
          "question": "The Distributor Nozzle has a built-in shutoff.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The nozzle does not have a shutoff.' This contradicts the question statement. Firefighters must ensure a shutoff is placed along the supply line or a hose clamp is available to control the water flow.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_15_907e9078",
          "question": "The Distributor Nozzle has a rotating head and operates at 270 GPM at 100 PSI.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Specifications - Rotating head - 270 GPM at 100 PSI.' This supports the question statement. Understanding the nozzle's specifications is crucial for firefighters to ensure they have adequate water supply and pressure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_15_fab6ead4",
          "question": "The Distributor Nozzle is primarily used for fighting forest fires.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Uses - Ship fires - Basement fires.' This contradicts the question statement which incorrectly states the nozzle is primarily used for forest fires. Firefighters need to understand the appropriate use of equipment for different types of fires.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_5_b74feed9",
          "question": "A Cap is used to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A Cap is a way to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance.' This supports the statement that a Cap is used to control the flow of water, which is crucial in firefighting operations to manage water supply and prevent unnecessary water damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_5_5e6db69e",
          "question": "A Plug has female threads and is intended to plug a male coupling or fitting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Plug has male threads. It is intended to plug a female coupling or fitting.' This contradicts the statement that a Plug has female threads and is intended to plug a male coupling or fitting. Understanding the correct use of plugs is important in firefighting operations to ensure secure and efficient water flow.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_5_acf4b966",
          "question": "A Cap has male threads and is intended to cap a female coupling or fitting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A Cap has female threads. It is intended to cap a male coupling or fitting.' This contradicts the statement that a Cap has male threads and is intended to cap a female coupling or fitting. Knowing the correct use of caps is crucial in firefighting operations to manage water supply effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_5_4b794391",
          "question": "A Plug is used to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A Plug is a way to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance.' This supports the statement that a Plug is used to control the flow of water, which is an important aspect of firefighting operations to manage resources and prevent unnecessary water damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_5_8abc655f",
          "question": "A Cap and a Plug serve the same function but have different designs.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A Cap is a way to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance' and 'A Plug is a way to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance.' This supports the statement that a Cap and a Plug serve the same function but have different designs. Understanding the function and design of these tools is crucial in firefighting operations for effective water management.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_39_62a0fd8c",
          "question": "The Prosser pump is only effective for water removal when water depth is 2\u201d or deeper.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Prosser pump is an ideal tool for the removal of water when water depth is 2\u201d or deeper.' This means that the pump is designed to work best when the water is at least 2 inches deep. In firefighting scenarios, this could affect decisions about when and where to use this equipment for water removal.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_39_a381f1c2",
          "question": "The maximum effective lift of a single Prosser pump is 74 feet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies, 'Max. effective lift of a single pump is 37 ft (74 feet in tandem).' This means that a single pump can lift water up to 37 feet, not 74 feet. The 74 feet lift is achieved when two pumps are used in tandem. This is important for firefighters to understand when planning how to use these pumps in different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_39_c6bb2756",
          "question": "The Prosser pump comes with a 35-foot electrical cord.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '25-foot electrical cord and 35-foot handling cord.' This means that the electrical cord is 25 feet long, not 35 feet. The 35-foot cord is for handling. Firefighters need to be aware of this to ensure they have enough distance from the power source when using the pump.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_39_2ccbdda5",
          "question": "The Prosser pump should be powered off before handling.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text advises, 'Power off before handling.' This is a safety measure to protect firefighters from potential electrical hazards when handling the pump.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_39_1c443ef0",
          "question": "The Prosser pump does not require any maintenance after use.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text outlines, 'Dewatering Maintenance - Wipe down unit after use. - Inspect power cord for damage. - Ensure that rope is secured to the pump.' This indicates that the pump does require maintenance after use, including wiping down the unit, inspecting the power cord, and ensuring the rope is secured. This is important for firefighters to know to keep the equipment in good working condition.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_19_3aadefc5",
          "question": "The Spanner wrench is used for tightening/loosening couplings, appliances or hydrant port caps.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Spanner is a straight, forged or folding -type wrench device used for tightening/loosening couplings, appliances or hydrant port caps.' This indicates that the Spanner wrench is indeed used for these purposes. Understanding the functions of different tools is crucial for firefighters as it directly affects their ability to perform their duties effectively and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_19_5962c7db",
          "question": "The OCD Wrench is typically carried in the hydrant bag.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is normally carried in the hydrant bag.' This confirms that the OCD Wrench is typically carried in the hydrant bag. Knowing where tools are typically stored can help firefighters quickly locate them when needed, which can be critical in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_19_405c8fb1",
          "question": "The Spanner wrench is made from either plastic or steel.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'They are made from plastic or aluminum.' This contradicts the statement that Spanner wrenches are made from plastic or steel. The materials tools are made from can affect their durability, weight, and other properties, which can have implications for how they are used in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_19_11ff3142",
          "question": "The OCD Wrench can be used when a galvin wrench will not make a complete turn due to obstacles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It may also be used when a galvin wrench will not make a complete turn due to obstacles.' This confirms that the OCD Wrench can be used in situations where a galvin wrench cannot make a complete turn. Understanding the different uses of tools can help firefighters make effective decisions about which tools to use in different situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_19_cd3b06bc",
          "question": "All firefighters are issued a straight, forged Spanner wrench.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Straight, forged spanners are located on all engines and folding -type are issued to each Firefighter.' This contradicts the statement that all firefighters are issued a straight, forged Spanner wrench. Knowing which tools are issued to each firefighter can help ensure that all firefighters have the tools they need to perform their duties.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_23_08336605",
          "question": "The Roof Hook was originally designed for rooftop ventilation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Originally designed for overhauling dumpster fires, the Roof Hook has become a favorite rooftop ventilation tool.' This indicates that the Roof Hook was not originally designed for rooftop ventilation but has evolved to be used for this purpose. This is important for firefighters to understand as it shows the versatility of their tools and the evolution of firefighting tactics.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_23_5bd5f537",
          "question": "The Roof Hook can be used to pull back roofing materials and break ceramic roof tiles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Roof Hook can also be used to pull back roofing materials, break ceramic roof tiles, and to \u201clouver\u201d the vent cuts.' This shows that the Roof Hook is a versatile tool that can be used for various tasks during firefighting operations, including ventilation and overhaul.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_23_2f86c491",
          "question": "The Roof Hook is made entirely of steel.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Specifications - 6 feet long - Fiberglass shaft with \u201cD\u201d handle - Two-pronged steel hooks.' This shows that the Roof Hook is not made entirely of steel, but has a fiberglass shaft and steel hooks. This is crucial for firefighters to know as it affects the tool's weight, durability, and conductivity.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_23_05776932",
          "question": "When using the Roof Hook, large sections of the ceiling may fall.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Be alert - large sections may fall when pulling ceilings.' This indicates that when using the Roof Hook for pulling ceilings, there is a risk of large sections falling. This is a vital safety consideration for firefighters during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_23_502584b7",
          "question": "The Roof Hook is primarily used for pulling ceilings where small areas need to be opened.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Uses - Roof sounding and ventilation - Overhaul, pulling ceilings where large areas need to be opened.' This shows that the Roof Hook is used for pulling ceilings where large, not small, areas need to be opened. This is important for firefighters to understand as it affects their tactical decisions during overhaul and ventilation operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_9_67f1fc0a",
          "question": "The Tri-Gated Wye is an appliance used to deliver water to the incident.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Tri-Gated Wye, also known as a \u201cManifold\u201d, is an appliance used to deliver water to the incident.' This shows that the Tri-Gated Wye is indeed used to deliver water to the incident, which is crucial for firefighting operations as it helps in controlling and extinguishing the fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_9_214884bd",
          "question": "The Tri-Gated Wye is attached to the engine\u2019s small diameter hose (SDH).",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Tri-Gated Wye is attached to the engine\u2019s large diameter hose (LDH).' This contradicts the statement in the question that it is attached to the engine's small diameter hose. The use of LDH is significant in firefighting operations as it allows for a greater volume of water to be delivered to the incident.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_9_9e6292bb",
          "question": "The Tri-Gated Wye splits a singular source of water into multiple lines.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'As with other wyes, the Tri-Gated Wye splits a singular source of water into multiple lines.' This supports the statement in the question. This feature is important in firefighting as it allows for multiple attack lines to be supplied from a single water source, increasing operational flexibility.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_9_3c9ea5e0",
          "question": "The Tri-Gated Wye has female threads on both sides of the appliance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A difference from all other wyes is that on the tri-gated wye there are male threads on both sides of the appliance.' This contradicts the statement in the question that it has female threads on both sides. The presence of male threads on both sides is relevant to firefighting operations as it determines how the hose is connected to the appliance.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_9_0a876bb8",
          "question": "Each outlet of the Tri-Gated Wye has a separate gated valve.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Each outlet has a separate gated valve.' This supports the statement in the question. Having separate gated valves for each outlet is important in firefighting operations as it allows for independent control of water flow to each line, enhancing tactical flexibility.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_35_44d17b44",
          "question": "The Holmatro Rescue Tools are used for light rescue and auto extrication.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'These tools are hydraulically driven tools that are used for heavy rescue and auto extrication.' This contradicts the statement in the question that they are used for light rescue. The implication for firefighters is understanding the capability of their tools for different rescue scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_35_1922b35a",
          "question": "The Holmatro Double Power Unit (DPU30) supplies the power for the Holmatro Rescue Tools.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Holmatro Double Power Unit (DPU30) supplies the power.' This supports the statement in the question. Firefighters must understand the power source of their tools to ensure they are operational during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_35_d5ad4926",
          "question": "The Holmatro Rescue Tools are optional equipment on all Truck Companies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The DPU30 and Rescue Tools are standard equipment on all Truck Companies.' This contradicts the statement in the question that they are optional. The implication for firefighters is knowing what standard equipment is available on their trucks for various operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_35_ec7227cc",
          "question": "The jaws on the Cutter and the \u201cCombi\u201d tool should be tightened using a torque wrench set at 75 ft-lb after every use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Use torque wrench set at 75 ft-lb. to tighten the jaws on the Cutter and the \u201cCombi\u201d tool after every use.' This supports the statement in the question. Proper maintenance of tools is crucial for firefighters to ensure they are ready for use in rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_35_0065f910",
          "question": "While using the Holmatro Rescue Tools, it is not necessary to wear eye protection.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Wear proper safety gear (full protective clothing) and eye protection.' This contradicts the statement in the question that eye protection is not necessary. The implication for firefighters is the importance of personal protective equipment during operations to ensure their safety.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_20_d2903f31",
          "question": "What is the primary use of the Corey Wrench in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Corey Wrench is primarily used to remove and replace the fire hydrant caps.",
          "options": {
            "A": "To open or close the main stem of a fire hydrant",
            "B": "To remove and replace the fire hydrant caps",
            "C": "To provide leverage so that water may flow quickly",
            "D": "To open or close the 'foot valve' of a hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_20_9250be4d",
          "question": "Why might a firefighter choose to use a Galvin Wrench over a Corey Wrench when dealing with a fire hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Galvin Wrench is designed to be used to open or close the main stem of a fire hydrant. Its long handles provide leverage so that water may flow quickly.",
          "options": {
            "A": "The Galvin Wrench is shorter and easier to handle",
            "B": "The Galvin Wrench has a five-sided hole that corresponds with the cap nut",
            "C": "The Galvin Wrench provides more leverage for opening the hydrant's main stem",
            "D": "The Galvin Wrench is used to remove and replace the fire hydrant caps"
          }
        },
        {
          "id": "sfd_basic_skills_20_cfe45250",
          "question": "What is the disadvantage of using a Corey Wrench to open a hydrant\u2019s main stem?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Corey Wrench can be used to open a hydrant\u2019s main stem if there is an obstruction, but there is less available mechanical advantage with this shorter wrench.",
          "options": {
            "A": "It cannot be used to open a hydrant\u2019s main stem",
            "B": "There is less available mechanical advantage with this shorter wrench",
            "C": "The Corey Wrench does not correspond with the shape of the hydrant main stem nut",
            "D": "The Corey Wrench cannot be used in conjunction with the Galvin Wrench"
          }
        },
        {
          "id": "sfd_basic_skills_20_6f91c4dd",
          "question": "What is the function of the five-sided hole in both the Corey and Galvin Wrench?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The five-sided hole in both the Corey and Galvin Wrench corresponds with the shape of the hydrant main stem nut or the cap nut.",
          "options": {
            "A": "It is used to remove and replace the fire hydrant caps",
            "B": "It corresponds with the shape of the hydrant main stem nut",
            "C": "It provides leverage so that water may flow quickly",
            "D": "It is used to open or close the 'foot valve' of a hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_20_1aced231",
          "question": "How can the Galvin Wrench and the Corey Wrench be used together in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The box end of the Galvin Wrench may be used, in conjunction with the Corey Wrench, to open or close the 'foot valve' of a hydrant.",
          "options": {
            "A": "The Galvin Wrench can be used to remove the hydrant caps, while the Corey Wrench opens the main stem",
            "B": "The Corey Wrench can be used to provide leverage, while the Galvin Wrench opens the main stem",
            "C": "The Galvin Wrench and the Corey Wrench can be used together to open or close the 'foot valve' of a hydrant",
            "D": "The Corey Wrench can be used to remove the hydrant caps, while the Galvin Wrench opens the main stem"
          }
        },
        {
          "id": "sfd_basic_skills_36_6f2afa13",
          "question": "Which tool would be most effective for a situation requiring maximum cutting force?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Cutter has the highest maximum cutting force at 55,100 lbs.",
          "options": {
            "A": "Telescopic Mini Ram",
            "B": "Hand Operated Combination Tool",
            "C": "Cutter",
            "D": "Spreader"
          }
        },
        {
          "id": "sfd_basic_skills_36_e3c6e018",
          "question": "If weight is a critical factor in a rescue operation, which tool would be the best choice?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Hand Operated Combination Tool is the lightest, weighing only 23 lbs.",
          "options": {
            "A": "Cutter",
            "B": "Hand Operated Combination Tool",
            "C": "Telescopic Ram",
            "D": "Combination Tool"
          }
        },
        {
          "id": "sfd_basic_skills_36_8681c437",
          "question": "Which tool has the greatest maximum spreading travel?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Spreader has the greatest maximum spreading travel at 27 \u00bc\u201d.",
          "options": {
            "A": "Spreader",
            "B": "Telescopic Ram",
            "C": "Combination Tool",
            "D": "Hand Operated Combination Tool"
          }
        },
        {
          "id": "sfd_basic_skills_36_6f4bacc2",
          "question": "In a situation where maximum pulling force is needed, which tool should not be used?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Cutter does not have a maximum pulling force specification.",
          "options": {
            "A": "Spreader",
            "B": "Combination Tool",
            "C": "Hand Operated Combination Tool",
            "D": "Cutter"
          }
        },
        {
          "id": "sfd_basic_skills_36_9838cde2",
          "question": "Which tool has the highest maximum spread force in its first section?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Both the Telescopic Ram and the Telescopic Mini Ram have the same maximum spread force in the first section, but the Cutter and Combination Tool do not have this specification.",
          "options": {
            "A": "Telescopic Ram",
            "B": "Telescopic Mini Ram",
            "C": "Combination Tool",
            "D": "Cutter"
          }
        },
        {
          "id": "sfd_basic_skills_16_a4d4b41a",
          "question": "What are the recommended uses for the Seattle Fire Department Fog Applicator?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the Fog Applicator is used for fire extinguishment when a small amount of water is indicated and for small space fires such as attics and walls.",
          "options": {
            "A": "For large open space fires",
            "B": "For small space fires such as attics and walls",
            "C": "For fire extinguishment when a large amount of water is indicated",
            "D": "For fires involving flammable liquids"
          }
        },
        {
          "id": "sfd_basic_skills_16_2b242897",
          "question": "What is a crucial safety measure when using the Fog Applicator?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that a crucial safety measure when using the Fog Applicator is that it must be used with a nozzle shut off.",
          "options": {
            "A": "It must be used with a nozzle shut off",
            "B": "It must be used with a water source",
            "C": "It must be used with a fire extinguisher",
            "D": "It must be used with a fire blanket"
          }
        },
        {
          "id": "sfd_basic_skills_16_81f5d693",
          "question": "What is the size range of the Seattle Fire Department Fog Applicator?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the size of the Fog Applicator varies from 48 to 112 inches long.",
          "options": {
            "A": "10 to 36 inches long",
            "B": "48 to 112 inches long",
            "C": "24 to 60 inches long",
            "D": "36 to 72 inches long"
          }
        },
        {
          "id": "sfd_basic_skills_16_5d37c0bf",
          "question": "What type of fires is the Fog Applicator not suitable for?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Fog Applicator is designed for small space fires and fire extinguishment when a small amount of water is indicated, making it unsuitable for large open space fires.",
          "options": {
            "A": "Small space fires",
            "B": "Fires requiring a small amount of water",
            "C": "Large open space fires",
            "D": "Fires in attics"
          }
        },
        {
          "id": "sfd_basic_skills_16_fff9a872",
          "question": "Why is the Fog Applicator used when a small amount of water is indicated?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Fog Applicator is used when a small amount of water is indicated to efficiently extinguish the fire while minimizing water damage.",
          "options": {
            "A": "To prevent water damage",
            "B": "To conserve water resources",
            "C": "To increase the intensity of the fire",
            "D": "To make the fire spread faster"
          }
        },
        {
          "id": "sfd_basic_skills_6_4e74ad73",
          "question": "What is the primary function of a Sister Coupling in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Sister Coupling is used to connect two unequal male ends.",
          "options": {
            "A": "To connect two equal male ends",
            "B": "To connect two equal female ends",
            "C": "To connect two unequal male ends",
            "D": "To connect two hoses of the same size"
          }
        },
        {
          "id": "sfd_basic_skills_6_1cfc013e",
          "question": "What is the main difference between a Double Female and a Sister Coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The main difference is that a Sister Coupling connects two unequal male ends, while a Double Female connects two equal female ends.",
          "options": {
            "A": "A Sister Coupling has male threads",
            "B": "A Sister Coupling connects two unequal male ends",
            "C": "A Sister Coupling is larger in size",
            "D": "A Sister Coupling is used for water supply"
          }
        },
        {
          "id": "sfd_basic_skills_6_b55d1421",
          "question": "What is the purpose of a Brother Coupling in firefighting equipment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A Brother Coupling is used to connect two unequal female ends.",
          "options": {
            "A": "To connect two unequal female ends",
            "B": "To connect two equal male ends",
            "C": "To connect two hoses of the same size",
            "D": "To connect two equal female ends"
          }
        },
        {
          "id": "sfd_basic_skills_6_bf606622",
          "question": "How does a Brother Coupling differ from a Double Male?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The main difference is that a Brother Coupling connects two unequal female ends, while a Double Male connects two equal male ends.",
          "options": {
            "A": "A Brother Coupling has female threads",
            "B": "A Brother Coupling connects two unequal female ends",
            "C": "A Brother Coupling is smaller in size",
            "D": "A Brother Coupling is used for water supply"
          }
        },
        {
          "id": "sfd_basic_skills_6_6fa2d98f",
          "question": "What is the common feature between a Sister Coupling and a Brother Coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Both a Sister Coupling and a Brother Coupling are used to connect two unequal ends, but the former is for male ends and the latter for female ends.",
          "options": {
            "A": "They both connect two equal ends",
            "B": "They both connect two unequal ends",
            "C": "They both have the same thread size",
            "D": "They both are used for water supply"
          }
        },
        {
          "id": "sfd_basic_skills_7_80eb40bf",
          "question": "What is the primary use of a Storz Adaptor Coupling in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Storz Adaptor Coupling is primarily used to couple SFD hose to hydrants or appliances of neighboring fire departments.",
          "options": {
            "A": "To connect SFD hose to hydrants or appliances of neighboring fire departments",
            "B": "To connect two hoses of the same type",
            "C": "To connect a hose to a fire extinguisher",
            "D": "To connect a hose to a fire truck"
          }
        },
        {
          "id": "sfd_basic_skills_7_386faae6",
          "question": "What is the procedure to release a coupled hose from a Storz Adaptor Coupling?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "To release a coupled hose from a Storz Adaptor Coupling, the rocker buttons need to be depressed.",
          "options": {
            "A": "Turn the coupling clockwise",
            "B": "Turn the coupling counter-clockwise",
            "C": "Depress the rocker buttons",
            "D": "Pull the hose away from the coupling"
          }
        },
        {
          "id": "sfd_basic_skills_7_15dbe40c",
          "question": "Why is it important for firefighters to understand the use of a Storz Adaptor Coupling, even if it is not routinely used by the SFD?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding the use of a Storz Adaptor Coupling is important because it is used in several surrounding cities on mutual aid.",
          "options": {
            "A": "Because it is a mandatory part of the firefighter training curriculum",
            "B": "Because it is used in several surrounding cities on mutual aid",
            "C": "Because it is a requirement for promotion within the fire department",
            "D": "Because it is used in all firefighting operations"
          }
        },
        {
          "id": "sfd_basic_skills_7_66aa753d",
          "question": "What type of threads does a Storz Adaptor Coupling have?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Storz Adaptor Coupling has male NST threads.",
          "options": {
            "A": "Female NST threads",
            "B": "Male NST threads",
            "C": "Female BSP threads",
            "D": "Male BSP threads"
          }
        },
        {
          "id": "sfd_basic_skills_7_ade5f9f2",
          "question": "What type of coupling does a Storz Adaptor Coupling connect to?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Storz Adaptor Coupling connects to a 'sexless' coupling that uses a quick connect fitting.",
          "options": {
            "A": "A coupling with female threads",
            "B": "A coupling with male threads",
            "C": "A 'sexless' coupling",
            "D": "A coupling with both male and female threads"
          }
        },
        {
          "id": "sfd_basic_skills_17_fc027a90",
          "question": "What is the primary use of bolt cutters in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The primary use of bolt cutters in firefighting operations is for forcible entry.",
          "options": {
            "A": "Extinguishing fires",
            "B": "Rescuing trapped individuals",
            "C": "Forcible entry",
            "D": "Communication"
          }
        },
        {
          "id": "sfd_basic_skills_17_9a3cf1e0",
          "question": "What is one of the maintenance procedures for bolt cutters?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "One of the maintenance procedures for bolt cutters is to wipe them clean.",
          "options": {
            "A": "Loosening the cutter gaps",
            "B": "Wiping clean",
            "C": "Using them regularly",
            "D": "Storing in a wet environment"
          }
        },
        {
          "id": "sfd_basic_skills_17_b185d803",
          "question": "What safety gear should be used when operating bolt cutters?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When operating bolt cutters, gloves and eye protection should be used for safety.",
          "options": {
            "A": "Helmet and boots",
            "B": "Gloves and eye protection",
            "C": "Fire resistant suit",
            "D": "Breathing apparatus"
          }
        },
        {
          "id": "sfd_basic_skills_17_ff68f0a7",
          "question": "How can the cutter gaps of bolt cutters be kept tight?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The cutter gaps of bolt cutters can be kept tight by using adjustment screws.",
          "options": {
            "A": "By using them frequently",
            "B": "By using adjustment screws",
            "C": "By applying oil",
            "D": "By storing them in a cold environment"
          }
        },
        {
          "id": "sfd_basic_skills_17_7e08c8bc",
          "question": "Why is forcible entry important in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Forcible entry is important in firefighting operations to rescue trapped individuals.",
          "options": {
            "A": "To rescue trapped individuals",
            "B": "To extinguish fires",
            "C": "To communicate with team members",
            "D": "To clean the equipment"
          }
        },
        {
          "id": "sfd_basic_skills_40_6393b96e",
          "question": "What is one of the primary uses of a Thermal Imager Camera (TIC) in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The TIC is primarily used to 'see' through smoke by detecting thermal radiation from fire and trapped victims, not for photography, communication, or fire extinguishing.",
          "options": {
            "A": "To take photographs of the fire scene",
            "B": "To detect thermal radiation from fire and trapped victims",
            "C": "To communicate with other firefighters",
            "D": "To extinguish fires"
          }
        },
        {
          "id": "sfd_basic_skills_40_e5eba903",
          "question": "What maintenance is required for a Thermal Imager Camera (TIC)?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The TIC needs to be inspected and cleaned after use, and its battery rotated as directed. It doesn't need to be replaced after each use, it does require maintenance, and it likely needs to be charged more often than once a year.",
          "options": {
            "A": "It needs to be replaced after each use",
            "B": "It requires no maintenance",
            "C": "It needs to be inspected and cleaned after use, and its battery rotated as directed",
            "D": "It needs to be charged only once a year"
          }
        },
        {
          "id": "sfd_basic_skills_40_04f1a0da",
          "question": "What type of technology does a Thermal Imager Camera (TIC) use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The TIC uses thermographic technology to detect thermal radiation, not ultraviolet, radio wave, or X-ray technology.",
          "options": {
            "A": "Ultraviolet technology",
            "B": "Thermographic technology",
            "C": "Radio wave technology",
            "D": "X-ray technology"
          }
        },
        {
          "id": "sfd_basic_skills_40_594728d9",
          "question": "What materials can a Thermal Imager Camera (TIC) recognize a significant heat signature through?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The TIC can recognize a significant heat signature through sheet rock, lathe and plaster, and acoustic ceiling tile, not through wood, metal, glass, plastic, concrete, or steel.",
          "options": {
            "A": "Sheet rock, lathe and plaster, and acoustic ceiling tile",
            "B": "Wood and metal",
            "C": "Glass and plastic",
            "D": "Concrete and steel"
          }
        },
        {
          "id": "sfd_basic_skills_40_9a63e1ed",
          "question": "Where is a Thermal Imager Camera (TIC) standard equipment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The TIC is standard equipment on Truck Companies and Battalion Chiefs\u2019 vehicles and select engine companies, not in all fire stations, every firefighter's personal gear, or the fire department's administrative offices.",
          "options": {
            "A": "On Truck Companies and Battalion Chiefs\u2019 vehicles and select engine companies",
            "B": "In all fire stations",
            "C": "In every firefighter's personal gear",
            "D": "In the fire department's administrative offices"
          }
        },
        {
          "id": "sfd_basic_skills_37_8408ed9c",
          "question": "What is the importance of checking the gauge of a fire extinguisher?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Checking the gauge of a fire extinguisher is important to ensure that there is adequate pressure for use. Without the correct pressure, the extinguisher may not work effectively.",
          "options": {
            "A": "To ensure the extinguisher is not too heavy",
            "B": "To check the color of the gauge",
            "C": "To ensure there is adequate pressure for use",
            "D": "To check the size of the extinguisher"
          }
        },
        {
          "id": "sfd_basic_skills_37_a7b10ac8",
          "question": "Why is it important to choose the proper type of extinguisher for the fuel to be extinguished?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Different types of fires require different types of extinguishers. Using the wrong type of extinguisher can be ineffective or even dangerous.",
          "options": {
            "A": "To make the extinguisher lighter",
            "B": "To ensure effective extinguishing of the fire",
            "C": "To make the extinguisher look good",
            "D": "To increase the pressure of the extinguisher"
          }
        },
        {
          "id": "sfd_basic_skills_37_78a9039d",
          "question": "Which type of fire extinguisher uses water as an agent?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Pressurized Water fire extinguisher uses water as an agent to extinguish the fire.",
          "options": {
            "A": "Dry Chemical",
            "B": "CO2",
            "C": "Pressurized Water",
            "D": "Sodium Bicarb"
          }
        },
        {
          "id": "sfd_basic_skills_37_62d527cb",
          "question": "What is the propellant used in a CO2 fire extinguisher?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The CO2 fire extinguisher uses self as a propellant, meaning it uses the pressure of the CO2 gas itself to expel the extinguishing agent.",
          "options": {
            "A": "Nitrogen",
            "B": "Air",
            "C": "Water",
            "D": "Self"
          }
        },
        {
          "id": "sfd_basic_skills_37_5b686459",
          "question": "What should be done with a fire extinguisher after use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After use, a fire extinguisher should be tagged and sent to Services for maintenance and refilling.",
          "options": {
            "A": "Discard it",
            "B": "Tag and send to Services",
            "C": "Leave it as it is",
            "D": "Refill it immediately"
          }
        },
        {
          "id": "sfd_basic_skills_21_da643e3f",
          "question": "What is the primary purpose of bars in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, bars are used for forcible entry, heavy rescue, prying, breaking, ramming, clawing, pulling, moving, and lifting.",
          "options": {
            "A": "Communication",
            "B": "Forcible entry and heavy rescue",
            "C": "Fire suppression",
            "D": "Ventilation"
          }
        },
        {
          "id": "sfd_basic_skills_21_ce83b8ee",
          "question": "What is the importance of choosing the appropriate bar for the job in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text emphasizes the importance of choosing the right tool for the job to allow the mechanical advantage of the tool do the work, not brute strength.",
          "options": {
            "A": "To ensure the bar matches the firefighter's uniform",
            "B": "To allow the mechanical advantage of the tool do the work, not brute strength",
            "C": "To make the firefighter look professional",
            "D": "To ensure the bar is not too heavy for the firefighter"
          }
        },
        {
          "id": "sfd_basic_skills_21_6d1754ba",
          "question": "What safety gear is recommended when using bars in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that proper safety gear when using bars includes a helmet, gloves, eye protection, and boots.",
          "options": {
            "A": "Helmet, gloves, eye and boots",
            "B": "Helmet, gloves, and safety vest",
            "C": "Helmet, gloves, and respirator",
            "D": "Helmet, gloves, and ear protection"
          }
        },
        {
          "id": "sfd_basic_skills_21_a37f3460",
          "question": "What is the recommended maintenance for bars after use in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text suggests that after use, bars should be cleaned and inspected, and a file should be used to remove any nicks.",
          "options": {
            "A": "Clean and inspect, then use a file to remove nicks",
            "B": "Clean and inspect, then apply a heavy coat of oil",
            "C": "Clean and inspect, then repaint",
            "D": "Clean and inspect, then replace any damaged parts"
          }
        },
        {
          "id": "sfd_basic_skills_21_3f7a168f",
          "question": "What are some of the different types of bars used in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text lists several types of bars used in firefighting operations, including Heavy Duty Bar, Medium Duty Bar, Burke Bar, Light Duty Bar, Extrication Bar, Lock Breaker, Trumpet Bar, Haligan, Wrecking Bar.",
          "options": {
            "A": "Heavy Duty Bar, Medium Duty Bar, Burke Bar, Light Duty Bar, Extrication Bar, Lock Breaker, Trumpet Bar, Haligan, Wrecking Bar",
            "B": "Fire Bar, Rescue Bar, Entry Bar, Safety Bar, Duty Bar",
            "C": "Steel Bar, Iron Bar, Aluminum Bar, Copper Bar, Bronze Bar",
            "D": "Long Bar, Short Bar, Thick Bar, Thin Bar, Heavy Bar"
          }
        },
        {
          "id": "sfd_basic_skills_10_5f26a60d",
          "question": "What is the primary function of a Hydrant Gate in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Hydrant Gate is a gated valve fitting that controls the flow of water from a 2 \u00bd\u201d hose port of a fire hydrant.",
          "options": {
            "A": "To increase the pressure of water",
            "B": "To control the flow of water from a fire hydrant",
            "C": "To compress the fire hose",
            "D": "To put out the fire directly"
          }
        },
        {
          "id": "sfd_basic_skills_10_40c0628d",
          "question": "What is the correct procedure when releasing the clamp on a fire hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct procedure when releasing the clamp on a fire hose is to face the direction of the flow (destination).",
          "options": {
            "A": "Face the direction of the flow (source)",
            "B": "Stand on the side of the hose",
            "C": "Face the direction of the flow (destination)",
            "D": "Stand behind the hose"
          }
        },
        {
          "id": "sfd_basic_skills_10_cc8e3978",
          "question": "What is the purpose of a Hose Clamp in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Hose Clamp is a device used to compress fire hose in order to shut off the flow of water while in operation.",
          "options": {
            "A": "To increase the size of the hose",
            "B": "To shut off the flow of water while in operation",
            "C": "To control the direction of water flow",
            "D": "To connect two hoses together"
          }
        },
        {
          "id": "sfd_basic_skills_10_f91cfb4f",
          "question": "What is typically kept with a Hydrant Gate?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A 2 \u00bd\u201d to 4\u201d Increaser is typically kept with a Hydrant Gate.",
          "options": {
            "A": "A 2 \u00bd\u201d to 4\u201d Increaser",
            "B": "A Hose Clamp",
            "C": "An additional fire hydrant",
            "D": "A fire extinguisher"
          }
        },
        {
          "id": "sfd_basic_skills_10_80127ba4",
          "question": "When should a Hose Clamp be applied to an uncharged line?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Hose Clamp can be applied to an uncharged line to prevent flow.",
          "options": {
            "A": "When the fire is out",
            "B": "When the hose is damaged",
            "C": "To prevent flow",
            "D": "When the water source is depleted"
          }
        },
        {
          "id": "sfd_basic_skills_26_db325bf3",
          "question": "What is the primary function of the Positive Pressure Ventilation Fan?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Positive Pressure Ventilation Fan is used to remove heat, smoke and fire gases, enhancing fire operation and safety.",
          "options": {
            "A": "To cool down the fire",
            "B": "To remove heat, smoke and fire gases",
            "C": "To increase the intensity of the fire",
            "D": "To provide light in dark areas"
          }
        },
        {
          "id": "sfd_basic_skills_26_31092d91",
          "question": "What is a crucial safety consideration when operating the Positive Pressure Ventilation Fan in an enclosed area?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The exhaust fumes from the Positive Pressure Ventilation Fan contain carbon monoxide, which can reach dangerous levels when operating in an enclosed area.",
          "options": {
            "A": "Risk of electrocution",
            "B": "Risk of the fan overheating",
            "C": "Risk of carbon monoxide reaching dangerous levels",
            "D": "Risk of the fan causing a secondary fire"
          }
        },
        {
          "id": "sfd_basic_skills_26_b82f13c3",
          "question": "What type of fuel does the Positive Pressure Ventilation Fan use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Positive Pressure Ventilation Fan uses unleaded (white stripe) fuel.",
          "options": {
            "A": "Diesel",
            "B": "Unleaded (white stripe) fuel",
            "C": "Natural gas",
            "D": "Electricity"
          }
        },
        {
          "id": "sfd_basic_skills_26_9388e5fd",
          "question": "What is the recommended maintenance after each use of the Positive Pressure Ventilation Fan?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After each use, the Positive Pressure Ventilation Fan should be refueled.",
          "options": {
            "A": "Replace the blades",
            "B": "Refuel",
            "C": "Send to Services for engine work",
            "D": "Replace the engine"
          }
        },
        {
          "id": "sfd_basic_skills_26_d22cf086",
          "question": "What is the approximate CFM delivered by the Positive Pressure Ventilation Fan?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Positive Pressure Ventilation Fan delivers approximately 15000 CFM.",
          "options": {
            "A": "5000 CFM",
            "B": "10000 CFM",
            "C": "15000 CFM",
            "D": "20000 CFM"
          }
        },
        {
          "id": "sfd_basic_skills_30_02b1fd12",
          "question": "What is one of the primary uses of a circular saw in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The circular saw is primarily used for construction purposes such as boarding up buildings in firefighting operations.",
          "options": {
            "A": "Extinguishing fires",
            "B": "Rescuing victims",
            "C": "Boarding up buildings",
            "D": "Communicating with other firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_30_8667606f",
          "question": "What safety consideration should be taken into account when using a circular saw?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "It's important to remember that the blade of a circular saw continues to rotate even after the trigger is released, posing a potential safety risk.",
          "options": {
            "A": "The blade continues to rotate after the trigger is released",
            "B": "The saw can be used without safety gear",
            "C": "The saw does not require a power source",
            "D": "The saw is not portable"
          }
        },
        {
          "id": "sfd_basic_skills_30_396c25d5",
          "question": "What is a maintenance requirement for the circular saw?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The blade of the circular saw should be replaced as needed as part of its maintenance.",
          "options": {
            "A": "The saw does not require cleaning",
            "B": "The blade should be replaced as needed",
            "C": "The saw should be stored in a dirty condition",
            "D": "The saw does not require a power source"
          }
        },
        {
          "id": "sfd_basic_skills_30_213be268",
          "question": "What type of power source does a circular saw require?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The circular saw requires an electrical power source.",
          "options": {
            "A": "Solar power",
            "B": "Wind power",
            "C": "Electrical power",
            "D": "It does not require a power source"
          }
        },
        {
          "id": "sfd_basic_skills_30_0e294737",
          "question": "What type of safety gear should be worn when operating a circular saw?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When operating a circular saw, it is recommended to wear proper safety gear including gloves, eye protection, and boots.",
          "options": {
            "A": "Gloves, eye protection, and boots",
            "B": "Helmet, gloves, and boots",
            "C": "Eye protection, boots, and a life jacket",
            "D": "Gloves, boots, and a fire-resistant suit"
          }
        },
        {
          "id": "sfd_basic_skills_31_d2097798",
          "question": "What is the primary purpose of the Rope Rescue Equipment carried by the Seattle Fire Department's Truck Companies?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the Rope Rescue Equipment is designed to assist in the rescue of persons trapped in low or high angle situations.",
          "options": {
            "A": "To assist in putting out fires",
            "B": "To assist in the rescue of persons trapped in low or high angle situations",
            "C": "To assist in the rescue of persons from burning buildings",
            "D": "To assist in the rescue of persons trapped in vehicles"
          }
        },
        {
          "id": "sfd_basic_skills_31_aa232927",
          "question": "What is one of the maintenance requirements for the Rope Rescue Equipment?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the Rope Rescue Equipment must be cleaned and inspected after each use.",
          "options": {
            "A": "The equipment must be replaced after each use",
            "B": "The equipment must be cleaned and inspected after each use",
            "C": "The equipment must be tested before each use",
            "D": "The equipment must be stored in a dry place"
          }
        },
        {
          "id": "sfd_basic_skills_31_b104452f",
          "question": "When should the rescue rope be replaced?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the rescue rope must be replaced after use in an actual rescue incident.",
          "options": {
            "A": "After each use",
            "B": "After use in an actual rescue incident",
            "C": "Every six months",
            "D": "Every year"
          }
        },
        {
          "id": "sfd_basic_skills_31_f7a21a4f",
          "question": "What materials are included in the Rope Rescue Equipment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that the materials included in the Rope Rescue Equipment are nylon webbing, kernmantle rope, steel and aluminum.",
          "options": {
            "A": "Nylon webbing, kernmantle rope, steel and aluminum",
            "B": "Nylon webbing, kernmantle rope, plastic and aluminum",
            "C": "Nylon webbing, kernmantle rope, steel and copper",
            "D": "Nylon webbing, kernmantle rope, steel and iron"
          }
        },
        {
          "id": "sfd_basic_skills_31_bdaa79c5",
          "question": "What is a safety consideration when using the Rope Rescue Equipment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that one safety consideration when using the Rope Rescue Equipment is to wear appropriate safety gear.",
          "options": {
            "A": "Wear appropriate safety gear",
            "B": "Ensure the equipment is stored in a dry place",
            "C": "Ensure the equipment is used only by trained professionals",
            "D": "Ensure the equipment is replaced after each use"
          }
        },
        {
          "id": "sfd_basic_skills_27_e202806c",
          "question": "Why is the chainsaw considered the best saw for ventilation in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The chainsaw is considered the best saw for ventilation because it can 'feel' the structural members beneath the roofing materials, allowing the operator to work safely without unnecessary damage to the rafters and/or joists.",
          "options": {
            "A": "Because it is lightweight",
            "B": "Because it uses mixed fuel",
            "C": "Because it can 'feel' the structural members beneath the roofing materials",
            "D": "Because it has a 20-inch bar"
          }
        },
        {
          "id": "sfd_basic_skills_27_32282fc3",
          "question": "What is the purpose of the chainsaw's automatic and manual chain brake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The automatic and manual chain brake on the chainsaw is designed to ensure safety during operation.",
          "options": {
            "A": "To increase cutting speed",
            "B": "To ensure safety during operation",
            "C": "To adjust chain tension",
            "D": "To clean the chainsaw"
          }
        },
        {
          "id": "sfd_basic_skills_27_83000a85",
          "question": "When should the chainsaw chain be replaced?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The chainsaw chain should be replaced when 3 (or more) teeth are damaged or missing.",
          "options": {
            "A": "When it becomes dull",
            "B": "When 3 (or more) teeth are damaged or missing",
            "C": "After each use",
            "D": "When the chainsaw is sent for engine work"
          }
        },
        {
          "id": "sfd_basic_skills_27_da68011f",
          "question": "What is one of the safety considerations when using the chainsaw during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "One of the safety considerations when using the chainsaw during firefighting operations is to use only enough bar as needed. Over plunging the bar can lead to accidents.",
          "options": {
            "A": "Use only enough bar as needed",
            "B": "Use the chainsaw without safety gear",
            "C": "Over plunge the bar during use",
            "D": "Ignore other operations around you"
          }
        },
        {
          "id": "sfd_basic_skills_27_6585ce37",
          "question": "Why is the chainsaw's light weight beneficial in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The chainsaw's light weight is beneficial in firefighting operations because it makes it easy to work from ladders and in places where heavier saws would not be safe.",
          "options": {
            "A": "It allows for faster cutting speed",
            "B": "It makes it easy to work from ladders and in places where heavier saws would not be safe",
            "C": "It reduces the need for maintenance",
            "D": "It increases the chainsaw's fuel efficiency"
          }
        },
        {
          "id": "sfd_basic_skills_11_cab4e4a0",
          "question": "What is one of the primary uses of a Portable Ground Monitor in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, Portable Ground Monitors are used to deliver powerful streams of water over long distances.",
          "options": {
            "A": "To deliver powerful streams of water over short distances",
            "B": "To monitor the temperature of a fire",
            "C": "To deliver powerful streams of water over long distances",
            "D": "To monitor the air quality in the vicinity of a fire"
          }
        },
        {
          "id": "sfd_basic_skills_11_4773737c",
          "question": "What is a crucial safety consideration when using a Portable Ground Monitor?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that it is important to ensure that the Monitor is footed or anchored to counteract the strong nozzle reaction.",
          "options": {
            "A": "Ensuring the Monitor is footed or anchored to counteract the strong nozzle reaction",
            "B": "Ensuring the Monitor is placed at a high altitude",
            "C": "Ensuring the Monitor is kept away from water sources",
            "D": "Ensuring the Monitor is used only indoors"
          }
        },
        {
          "id": "sfd_basic_skills_11_13f137e7",
          "question": "What factor influences the flow rates of a Portable Ground Monitor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, the flow rates of a Portable Ground Monitor depend on the size of the nozzle.",
          "options": {
            "A": "The color of the Monitor",
            "B": "The size of the nozzle",
            "C": "The weight of the Monitor",
            "D": "The height at which the Monitor is placed"
          }
        },
        {
          "id": "sfd_basic_skills_11_31462de9",
          "question": "What is a necessary maintenance step for a Portable Ground Monitor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that it is necessary to keep the Monitor lubricated and check for loose tips.",
          "options": {
            "A": "Replacing the nozzle after every use",
            "B": "Keeping it lubricated and checking for loose tips",
            "C": "Cleaning it with a special solution after every use",
            "D": "Storing it in a cool, dry place"
          }
        },
        {
          "id": "sfd_basic_skills_11_2da23358",
          "question": "What is the implication of not properly footing or anchoring a Portable Ground Monitor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If not properly footed or anchored, the strong nozzle reaction could cause the Monitor to tip over.",
          "options": {
            "A": "It could lead to a decrease in water pressure",
            "B": "It could lead to the Monitor tipping over due to the strong nozzle reaction",
            "C": "It could lead to the Monitor overheating",
            "D": "It could lead to a decrease in the range of the water stream"
          }
        },
        {
          "id": "sfd_basic_skills_2_dbfd227c",
          "question": "Why is it important for firefighters to have a good understanding of their equipment and tools?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding equipment and tools allows firefighters to locate and place them in service without delay, which is crucial in emergency situations.",
          "options": {
            "A": "To be able to clean them properly",
            "B": "To be able to locate and place them in service without delay",
            "C": "To be able to use them for personal tasks",
            "D": "To be able to sell them if needed"
          }
        },
        {
          "id": "sfd_basic_skills_2_91ae2efe",
          "question": "What is the purpose of the equipment and tools section in the Seattle Fire Department manual?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The section is intended to help new members recognize and understand the purpose of fire service tools, not to provide detailed information or a list of suppliers.",
          "options": {
            "A": "To provide detailed information on each piece of equipment",
            "B": "To assist new members recognize and understand the purpose of fire service tools",
            "C": "To provide a list of suppliers for the equipment and tools",
            "D": "To provide a platform for selling old equipment and tools"
          }
        },
        {
          "id": "sfd_basic_skills_2_41ed64b7",
          "question": "Why is it important for equipment and tools to be maintained clean and in good working order?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Clean, well-maintained equipment and tools are crucial for effective firefighting operations.",
          "options": {
            "A": "To ensure they look nice",
            "B": "To ensure they can be sold at a high price",
            "C": "To ensure they can be used effectively in firefighting operations",
            "D": "To ensure they can be used for personal tasks"
          }
        },
        {
          "id": "sfd_basic_skills_2_5cbe5935",
          "question": "What is the role of the equipment and tools in the success of a firefighter's career?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Knowledge and proficiency of equipment and tools are essential for success in recruit school and throughout a firefighter's career.",
          "options": {
            "A": "They are essential for success in recruit school and throughout their career",
            "B": "They are only needed during recruit school",
            "C": "They are not important as long as the firefighter is physically fit",
            "D": "They are only needed for promotional exams"
          }
        },
        {
          "id": "sfd_basic_skills_2_8fa3e556",
          "question": "What is the main focus of the equipment and tools section in the Seattle Fire Department manual?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The section focuses on specifications, uses, maintenance, and safety of the tools, not their history, cost, suppliers, or personal uses.",
          "options": {
            "A": "Specifications, uses, maintenance and safety of the tools",
            "B": "The history and evolution of firefighting tools",
            "C": "The cost and suppliers of the tools",
            "D": "The personal uses of the tools"
          }
        },
        {
          "id": "sfd_basic_skills_28_30eef09b",
          "question": "What is the primary use of the metal-cutting blade on the rotary saw?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The metal-cutting blade on the rotary saw is primarily used for forcible entry or other metal cutting.",
          "options": {
            "A": "Ventilation",
            "B": "Cutting hardwood flooring",
            "C": "Forcible entry",
            "D": "Cutting stucco"
          }
        },
        {
          "id": "sfd_basic_skills_28_d2291aa4",
          "question": "What safety measures should be taken when using the rotary saw near flammable liquids?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When using the rotary saw near flammable liquids, a hose-line and dry chemical extinguisher is required for safety.",
          "options": {
            "A": "Wear full PPE",
            "B": "Have a hose-line and dry chemical extinguisher ready",
            "C": "Ensure the blade is not smaller than 9 inches",
            "D": "Ensure the saw is belt driven"
          }
        },
        {
          "id": "sfd_basic_skills_28_ed76bfd7",
          "question": "What maintenance step is required after each use of the rotary saw?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The rotary saw should be refueled after each use as part of its maintenance.",
          "options": {
            "A": "Adjust belt tension",
            "B": "Replace blade if smaller than 9 inches",
            "C": "Refuel",
            "D": "Forward to Services for engine work"
          }
        },
        {
          "id": "sfd_basic_skills_28_66cf0c34",
          "question": "What type of blade on the rotary saw is ideal for cutting stucco, brick or concrete block?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The masonry-cutting blade on the rotary saw is ideal for cutting stucco, brick or concrete block.",
          "options": {
            "A": "Wood-cutting blade",
            "B": "Metal-cutting blade",
            "C": "Masonry-cutting blade",
            "D": "None of the above"
          }
        },
        {
          "id": "sfd_basic_skills_28_ceebfc70",
          "question": "What is the weight of the rotary saw used by the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The rotary saw used by the Seattle Fire Department weighs 24 pounds.",
          "options": {
            "A": "24 pounds",
            "B": "20 pounds",
            "C": "30 pounds",
            "D": "15 pounds"
          }
        },
        {
          "id": "sfd_basic_skills_12_1a043868",
          "question": "What is the nozzle pressure at the tip for handlines according to the Seattle Fire Department's specifications?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the specifications, the nozzle pressure is 50 PSI at the tip for handlines.",
          "options": {
            "A": "50 PSI",
            "B": "80 PSI",
            "C": "100 PSI",
            "D": "120 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_12_896b549d",
          "question": "What safety consideration should be taken when using portable monitors?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that portable monitors should be properly footed for safety.",
          "options": {
            "A": "Ensure they are properly footed",
            "B": "Ensure they are properly oiled",
            "C": "Ensure they are properly charged",
            "D": "Ensure they are properly painted"
          }
        },
        {
          "id": "sfd_basic_skills_12_db58c0ff",
          "question": "What is the GPM for a 2 \u00bd\u201d handline?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the specifications, a 2 \u00bd\u201d handline has a GPM of 1650.",
          "options": {
            "A": "1000",
            "B": "1350",
            "C": "1650",
            "D": "180"
          }
        },
        {
          "id": "sfd_basic_skills_12_99236524",
          "question": "When is a fire attack with deeper penetration needed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that a fire attack with deeper penetration is needed when using a 2 \u00bd\u201d handline.",
          "options": {
            "A": "When using a 1 \u00be\u201d handline",
            "B": "When using a 2 \u00bd\u201d handline",
            "C": "When the nozzle pressure is 50 PSI",
            "D": "When the nozzle pressure is 80 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_12_62b8f52d",
          "question": "What care should be taken when operating smoothbore handlines?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text specifies that care should be taken when operating smoothbore handlines.",
          "options": {
            "A": "Ensure they are properly footed",
            "B": "Ensure they are properly oiled",
            "C": "Ensure they are properly charged",
            "D": "Use care"
          }
        },
        {
          "id": "sfd_basic_skills_32_859377fa",
          "question": "What is the primary use of the 12 mm Rescue Rope in the Seattle Fire Department's rope rescue applications?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 12 mm Rescue Rope is primarily used for main, belay, and accessory lines in rope rescue applications.",
          "options": {
            "A": "Used to create anchors for rope systems",
            "B": "Used for patient attachment in rope rescue systems",
            "C": "Used for main, belay, and accessory lines in rope rescue applications",
            "D": "Used to extend a loaded rope system under control"
          }
        },
        {
          "id": "sfd_basic_skills_32_dfd51484",
          "question": "What is the purpose of the Locking Steel Carabiner in the rope systems?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Locking Steel Carabiner is used to connect components in rope systems.",
          "options": {
            "A": "To create directional changes and mechanical advantages",
            "B": "To connect components in rope systems",
            "C": "To create positive attachment to patient in rope rescue systems",
            "D": "To build a tandem prussik belay system"
          }
        },
        {
          "id": "sfd_basic_skills_32_1dadd25a",
          "question": "What is the function of the Brake Rack in lowering systems?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Brake Rack is used as a frictioning device in lowering systems.",
          "options": {
            "A": "To create anchors for rope systems",
            "B": "To connect components in rope systems",
            "C": "To extend a loaded rope system under control",
            "D": "As a frictioning device"
          }
        },
        {
          "id": "sfd_basic_skills_32_dd4951eb",
          "question": "What is the purpose of the Load Releasing Hitch in the rope rescue systems?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Load Releasing Hitch is used to extend a loaded rope system under control.",
          "options": {
            "A": "To extend a loaded rope system under control",
            "B": "To create anchors for rope systems",
            "C": "To connect components in rope systems",
            "D": "To create directional changes and mechanical advantages"
          }
        },
        {
          "id": "sfd_basic_skills_32_0a1221ba",
          "question": "What is the function of the Long Prussik Sling in the rope rescue systems?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Long Prussik Sling is used to build a tandem prussik belay system, attach a pulley to a line, or as a progress capturing device.",
          "options": {
            "A": "To create anchors for rope systems",
            "B": "To extend a loaded rope system under control",
            "C": "To build a tandem prussik belay system, attach a pulley to a line, or as a progress capturing device",
            "D": "To connect components in rope systems"
          }
        },
        {
          "id": "sfd_basic_skills_24_b3acd9c9",
          "question": "What is the primary use of salvage and overhaul tools in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Salvage and overhaul tools are primarily used for post-fire operations, such as digging, trenching, scraping, salvage, and overhaul.",
          "options": {
            "A": "For communication during operations",
            "B": "For post-fire operations",
            "C": "For pre-fire preparations",
            "D": "For firefighting training"
          }
        },
        {
          "id": "sfd_basic_skills_24_fc1199fb",
          "question": "What is a key maintenance consideration for firefighting tools with metal heads?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To maintain firefighting tools with metal heads, it is important to paint or oil them to prevent rust.",
          "options": {
            "A": "They should be replaced after every use",
            "B": "They should be painted or oiled to prevent rust",
            "C": "They should be kept in a wet environment",
            "D": "They should be sharpened regularly"
          }
        },
        {
          "id": "sfd_basic_skills_24_324bfc91",
          "question": "What is a safety consideration when using firefighting tools?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When using firefighting tools, it is important to wear appropriate safety gear to prevent injuries.",
          "options": {
            "A": "Wear appropriate safety gear",
            "B": "Use tools without handles",
            "C": "Use tools with rusted heads",
            "D": "Use tools with loose handles"
          }
        },
        {
          "id": "sfd_basic_skills_24_f7f2adf0",
          "question": "Which company is typically equipped with a more limited supply of tools?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Engine Companies are typically equipped with a more limited supply of tools compared to Truck Companies.",
          "options": {
            "A": "Truck Companies",
            "B": "Engine Companies",
            "C": "Rescue Companies",
            "D": "Hazmat Companies"
          }
        },
        {
          "id": "sfd_basic_skills_24_511469ac",
          "question": "What type of tool is a wall scraper in the context of firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In the context of firefighting, a wall scraper is considered a specialty tool.",
          "options": {
            "A": "A common household tool",
            "B": "A specialty tool",
            "C": "A communication tool",
            "D": "A training tool"
          }
        },
        {
          "id": "sfd_basic_skills_25_5575cacd",
          "question": "What are the potential hazards of operating the portable electrical generator in an enclosed area?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that carbon monoxide contained in the exhaust fumes may reach dangerous levels when operating in an enclosed area.",
          "options": {
            "A": "Risk of fire from overheating",
            "B": "Risk of carbon monoxide poisoning",
            "C": "Risk of electrocution from wet conditions",
            "D": "Risk of equipment malfunction"
          }
        },
        {
          "id": "sfd_basic_skills_25_c3154136",
          "question": "What is the importance of using a circuit tester and GFCI when operating the portable electrical generator?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A circuit tester and GFCI (Ground Fault Circuit Interrupter) are used to protect against electrical shock or electrocution.",
          "options": {
            "A": "To ensure the generator is producing the correct voltage",
            "B": "To prevent electrical fires",
            "C": "To prevent electrical shock or electrocution",
            "D": "To ensure the generator is not overheating"
          }
        },
        {
          "id": "sfd_basic_skills_25_bda62158",
          "question": "What is the primary use of the portable electrical generator as mentioned in the text?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that the generator is used as a portable source of electricity for operating lights, power tools, submersible pumps, etc.",
          "options": {
            "A": "To power heating equipment",
            "B": "To power lights, power tools, submersible pumps, etc.",
            "C": "To power the fire truck",
            "D": "To recharge other electrical equipment"
          }
        },
        {
          "id": "sfd_basic_skills_25_acd7fc32",
          "question": "What is a critical maintenance procedure for the portable electrical generator after use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that after use, the generator should be refueled and stored in ready condition.",
          "options": {
            "A": "Send to Services for engine repair and servicing",
            "B": "Refuel after use and store in ready condition",
            "C": "Clean the generator with a wet cloth",
            "D": "Replace the generator's battery"
          }
        },
        {
          "id": "sfd_basic_skills_25_e21ff250",
          "question": "What type of fuel does the portable electrical generator use?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that the generator uses unleaded fuel.",
          "options": {
            "A": "Diesel",
            "B": "Propane",
            "C": "Unleaded fuel",
            "D": "Natural gas"
          }
        },
        {
          "id": "sfd_basic_skills_33_8e35403c",
          "question": "What atmospheric conditions does the portable air monitor continuously monitor?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The portable air monitor continuously monitors Carbon Monoxide, Oxygen, Hydrogen Sulfide, and Lower Explosive Limit of combustible gasses.",
          "options": {
            "A": "Carbon Monoxide, Oxygen, Hydrogen Sulfide, Lower Explosive Limit",
            "B": "Carbon Dioxide, Oxygen, Hydrogen, Lower Explosive Limit",
            "C": "Carbon Monoxide, Nitrogen, Hydrogen Sulfide, Upper Explosive Limit",
            "D": "Carbon Dioxide, Oxygen, Hydrogen, Upper Explosive Limit"
          }
        },
        {
          "id": "sfd_basic_skills_33_04662bfb",
          "question": "What is the importance of performing daily checks on the portable air monitor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Daily checks are crucial to ensure that the portable air monitor is functioning properly and providing accurate readings, which is critical for safety in firefighting operations.",
          "options": {
            "A": "To ensure the device is fully charged",
            "B": "To ensure the device is functioning properly and providing accurate readings",
            "C": "To ensure the device is clean",
            "D": "To ensure the device is not lost"
          }
        },
        {
          "id": "sfd_basic_skills_33_c284b596",
          "question": "What safety measure should be taken until the atmosphere is proven safe by the portable air monitor?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Respiratory protection should be used until the atmosphere is proven safe by the portable air monitor to prevent inhalation of harmful gases.",
          "options": {
            "A": "Use of gloves",
            "B": "Use of safety goggles",
            "C": "Use of respiratory protection",
            "D": "Use of ear protection"
          }
        },
        {
          "id": "sfd_basic_skills_33_c9a8cdad",
          "question": "What is the Lower Explosive Limit (LEL) in the context of the portable air monitor?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Lower Explosive Limit (LEL) is the lowest concentration of a gas that will burn in air. Monitoring this is crucial in firefighting to prevent explosions.",
          "options": {
            "A": "The lowest concentration of a gas that will burn in air",
            "B": "The highest concentration of a gas that will burn in air",
            "C": "The average concentration of a gas that will burn in air",
            "D": "The concentration of a gas that is safe to breathe"
          }
        },
        {
          "id": "sfd_basic_skills_33_76e7906d",
          "question": "What is one of the uses of the portable air monitor in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "One of the uses of the portable air monitor in firefighting operations is to monitor atmospheric conditions in confined space rescue, which is crucial for safety.",
          "options": {
            "A": "To extinguish fires",
            "B": "To rescue people from burning buildings",
            "C": "To monitor atmospheric conditions in confined space rescue",
            "D": "To provide light in dark areas"
          }
        },
        {
          "id": "sfd_basic_skills_13_7bac454a",
          "question": "What is the appropriate PSI required at the tip for the TFT Midmatic Nozzle to operate properly?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The TFT Midmatic Nozzle requires 75 PSI at the tip to operate properly.",
          "options": {
            "A": "50 PSI",
            "B": "100 PSI",
            "C": "75 PSI",
            "D": "25 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_13_adf70d36",
          "question": "What is the consequence of opening the TFT Midmatic Nozzle too quickly?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Opening the TFT Midmatic Nozzle too quickly can cause a water surge or water hammer.",
          "options": {
            "A": "It will cause a water surge or water hammer.",
            "B": "It will cause the nozzle to malfunction.",
            "C": "It will reduce the water pressure.",
            "D": "It will increase the water pressure."
          }
        },
        {
          "id": "sfd_basic_skills_13_663559fe",
          "question": "What is the recommended maintenance procedure for the moving parts of the TFT Midmatic Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The moving parts of the TFT Midmatic Nozzle should be lubricated with 'Break Free'.",
          "options": {
            "A": "Lubricate with WD-40.",
            "B": "Lubricate with 'Break Free'.",
            "C": "No lubrication is required.",
            "D": "Lubricate with oil."
          }
        },
        {
          "id": "sfd_basic_skills_13_beb40520",
          "question": "What is the GPM range of the TFT Midmatic Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The GPM range of the TFT Midmatic Nozzle is 70 - 200 GPM.",
          "options": {
            "A": "50 - 100 GPM",
            "B": "100 - 150 GPM",
            "C": "150 - 200 GPM",
            "D": "70 - 200 GPM"
          }
        },
        {
          "id": "sfd_basic_skills_13_affb0e92",
          "question": "What is the purpose of the removable tip on the TFT Midmatic Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The removable tip on the TFT Midmatic Nozzle is used for extending the line.",
          "options": {
            "A": "To increase the water pressure.",
            "B": "To decrease the water pressure.",
            "C": "To extend the line.",
            "D": "To reduce the GPM."
          }
        },
        {
          "id": "sfd_basic_skills_29_721fce4b",
          "question": "What is one of the main uses of the reciprocating saw in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The reciprocating saw is often used in auto extrication, as it can cut some portions of the auto easier and more quickly than the hydraulic cutters.",
          "options": {
            "A": "Fire extinguishing",
            "B": "Communication",
            "C": "Auto extrication",
            "D": "Water rescue"
          }
        },
        {
          "id": "sfd_basic_skills_29_3c9b5e16",
          "question": "What is one safety measure to take when using the reciprocating saw near flammable liquids?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When cutting near flammable liquids, it is important to ensure a charged handline and dry chemical extinguisher is readily available.",
          "options": {
            "A": "Ensure a charged handline and dry chemical extinguisher is readily available",
            "B": "Use the saw without gloves",
            "C": "Operate the saw without eye protection",
            "D": "Store the saw in a ready condition"
          }
        },
        {
          "id": "sfd_basic_skills_29_65e97a97",
          "question": "What is one key maintenance tip for the reciprocating saw?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Maintaining the reciprocating saw includes storing it in a ready condition.",
          "options": {
            "A": "Leave the unit dirty",
            "B": "Never replace the blades",
            "C": "Store saw in ready condition",
            "D": "Use the saw without safety gear"
          }
        },
        {
          "id": "sfd_basic_skills_29_93ff8cac",
          "question": "What is a unique feature of the reciprocating saw that affects its operation?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "One unique feature of the reciprocating saw is that the blade continues to move after the trigger is released. This has implications for safety and operation.",
          "options": {
            "A": "The blade continues to move after trigger is released",
            "B": "The saw is not portable",
            "C": "The saw cannot be used with hydraulic rescue tools",
            "D": "The saw requires a water source"
          }
        },
        {
          "id": "sfd_basic_skills_29_bb45642e",
          "question": "What types of reciprocating saws does the Seattle Fire Department carry?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Seattle Fire Department carries both corded and cordless models of the reciprocating saw.",
          "options": {
            "A": "Only cordless models",
            "B": "Only corded models",
            "C": "Both corded and cordless models",
            "D": "Neither corded nor cordless models"
          }
        },
        {
          "id": "sfd_basic_skills_3_6291dd08",
          "question": "What is the purpose of a Reducer in firefighting equipment?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Reducer is a coupling that reduces the size of male threads, so that female threads of a corresponding smaller size may be attached.",
          "options": {
            "A": "To increase the size of male threads",
            "B": "To attach female threads of a larger size",
            "C": "To reduce the size of male threads",
            "D": "To identify the female side of the coupling"
          }
        },
        {
          "id": "sfd_basic_skills_3_569256e3",
          "question": "How are couplings identified in firefighting equipment?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Couplings are always identified from the female side to the male side.",
          "options": {
            "A": "From the male side to the female side",
            "B": "By the size of the female threads",
            "C": "By the size of the male threads",
            "D": "From the female side to the male side"
          }
        },
        {
          "id": "sfd_basic_skills_3_c53b2476",
          "question": "What does 'female' refer to in the context of firefighting equipment?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In the context of firefighting equipment, 'female' refers to internal threads.",
          "options": {
            "A": "External threads",
            "B": "Internal threads",
            "C": "The size of the coupling",
            "D": "The gender of the firefighter"
          }
        },
        {
          "id": "sfd_basic_skills_3_61a09b47",
          "question": "What is the function of an Increaser in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "An Increaser is a coupling that increases the size of male threads, so that female threads of a corresponding larger size may be attached.",
          "options": {
            "A": "To reduce the size of male threads",
            "B": "To increase the size of male threads",
            "C": "To identify the male side of the coupling",
            "D": "To attach female threads of a smaller size"
          }
        },
        {
          "id": "sfd_basic_skills_3_8ab8923d",
          "question": "Why is it important to understand the function of Reducers and Increasers in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding the function of Reducers and Increasers is crucial to ensure proper coupling and decoupling during firefighting operations, which can affect the effectiveness and safety of the operation.",
          "options": {
            "A": "To ensure proper gender identification",
            "B": "To ensure proper coupling and decoupling during operations",
            "C": "To increase the size of the fire hose",
            "D": "To reduce the size of the fire hose"
          }
        },
        {
          "id": "sfd_basic_skills_34_2b01865f",
          "question": "What is a potential hazard of mishandling hydraulic fluid in the Holmatro Hydraulic Power Unit?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that spilled or mishandled hydraulic fluid may create a slip hazard.",
          "options": {
            "A": "It can cause a fire.",
            "B": "It can cause an explosion.",
            "C": "It can create a slip hazard.",
            "D": "It can cause electrical shock."
          }
        },
        {
          "id": "sfd_basic_skills_34_788c481c",
          "question": "What is one of the maintenance procedures for the Holmatro Hydraulic Power Unit after use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that hoses and couplings should be inspected after use as part of the maintenance procedures.",
          "options": {
            "A": "Replace the engine.",
            "B": "Inspect hoses and couplings.",
            "C": "Drain all hydraulic fluid.",
            "D": "Disassemble the unit."
          }
        },
        {
          "id": "sfd_basic_skills_34_7a02bc95",
          "question": "What safety gear is specifically mentioned as necessary when using the Holmatro Hydraulic Power Unit?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text mentions that appropriate safety gear, including eye protection, should be used when operating the unit.",
          "options": {
            "A": "Hearing protection.",
            "B": "Gloves.",
            "C": "Safety shoes.",
            "D": "Eye protection."
          }
        },
        {
          "id": "sfd_basic_skills_34_2c09ce67",
          "question": "What is the weight of the Holmatro Hydraulic Power Unit?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that the weight of the Holmatro Hydraulic Power Unit is 58 lbs.",
          "options": {
            "A": "58 lbs.",
            "B": "100 lbs.",
            "C": "30 lbs.",
            "D": "75 lbs."
          }
        },
        {
          "id": "sfd_basic_skills_34_e64e6272",
          "question": "What type of engine does the Holmatro Hydraulic Power Unit have?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the Holmatro Hydraulic Power Unit has a Honda GX100 3HP 4 stroke engine.",
          "options": {
            "A": "Honda GX100 2HP 2 stroke engine.",
            "B": "Honda GX100 3HP 4 stroke engine.",
            "C": "Honda GX200 3HP 4 stroke engine.",
            "D": "Honda GX100 3HP 2 stroke engine."
          }
        },
        {
          "id": "sfd_basic_skills_8_454e7686",
          "question": "What is the primary function of a Wye in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Wye is an appliance designed to branch a singular water source into two or more hose lines.",
          "options": {
            "A": "To connect two or more lines into one line",
            "B": "To branch a singular water source into two or more hose lines",
            "C": "To prevent the backflow of water through the unused intakes",
            "D": "To control the flow of water through the use of a clapper valve"
          }
        },
        {
          "id": "sfd_basic_skills_8_dc4d95bc",
          "question": "What is the main purpose of a Siamese fitting in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Siamese fitting is an appliance designed to connect two or more lines into one line or two lines into an engine or appliance.",
          "options": {
            "A": "To control the flow of water through the use of a quarter-turn-ball valve",
            "B": "To branch a singular water source into two or more hose lines",
            "C": "To connect two or more lines into one line or two lines into an engine or appliance",
            "D": "To prevent the backflow of water through the use of a clapper valve"
          }
        },
        {
          "id": "sfd_basic_skills_8_84f0f281",
          "question": "What type of valve is equipped in a Wye to control the flow of water?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Wyes are equipped with quarter-turn-ball or gated valves to control the flow of water.",
          "options": {
            "A": "Gated valve",
            "B": "Clapper valve",
            "C": "Ball valve",
            "D": "Quarter-turn-ball or gated valves"
          }
        },
        {
          "id": "sfd_basic_skills_8_2b72209a",
          "question": "What is the function of a clapper valve in a Siamese fitting?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Siamese fitting is equipped with a clapper valve to prevent the backflow of water through the unused intakes.",
          "options": {
            "A": "To control the flow of water",
            "B": "To prevent the backflow of water through the unused intakes",
            "C": "To connect two or more lines into one line",
            "D": "To branch a singular water source into two or more hose lines"
          }
        },
        {
          "id": "sfd_basic_skills_8_2810672f",
          "question": "What type of threads does a Wye have on its inlet and outlets?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Wye has a female threaded inlet and male threaded outlets.",
          "options": {
            "A": "Male threaded inlet and female threaded outlets",
            "B": "Female threaded inlet and male threaded outlets",
            "C": "Both inlet and outlets are male threaded",
            "D": "Both inlet and outlets are female threaded"
          }
        },
        {
          "id": "sfd_basic_skills_22_745bda09",
          "question": "What is the primary use of an axe in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The primary use of an axe in firefighting operations is for forcible entry and ventilation.",
          "options": {
            "A": "Cutting down trees",
            "B": "Breaking windows",
            "C": "Forcible entry and ventilation",
            "D": "Digging trenches"
          }
        },
        {
          "id": "sfd_basic_skills_22_ac80340a",
          "question": "Why is it recommended to avoid painting the axe?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Avoiding painting the axe aids in its maintenance and inspection, as paint could hide potential damage or wear.",
          "options": {
            "A": "To make it look more professional",
            "B": "To aid in maintenance and inspection",
            "C": "To prevent rust",
            "D": "To make it lighter"
          }
        },
        {
          "id": "sfd_basic_skills_22_cb44e8c0",
          "question": "What safety consideration should be taken into account when swinging an axe?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When swinging an axe, it's important to allow for the arc of the swing and avoid 'round house' swings to ensure safety.",
          "options": {
            "A": "Ensure the axe is sharp",
            "B": "Allow for the arc of the swing and avoid 'round house' swings",
            "C": "Make sure the axe is painted",
            "D": "Swing the axe with one hand"
          }
        },
        {
          "id": "sfd_basic_skills_22_4941454f",
          "question": "Why might a firefighter choose a fiberglass handle over a wooden one?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Fiberglass handles are chosen over wooden ones because they are 50 times stronger than wood and do not rot.",
          "options": {
            "A": "Fiberglass handles are cheaper",
            "B": "Fiberglass is 50 times stronger than wood and does not rot",
            "C": "Fiberglass handles are lighter",
            "D": "Fiberglass handles are more traditional"
          }
        },
        {
          "id": "sfd_basic_skills_22_f5f5c4d2",
          "question": "What is the difference between a heavy duty axe and a service axe?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Service axes are shorter and weigh less than heavy duty axes, making them more suitable for certain tasks and easier to carry.",
          "options": {
            "A": "Service axes are used for service calls only",
            "B": "Heavy duty axes are used for training only",
            "C": "Service axes are shorter and weigh less than heavy duty axes",
            "D": "Heavy duty axes are made of steel, while service axes are made of iron"
          }
        },
        {
          "id": "sfd_basic_skills_18_04dc7d68",
          "question": "What is the primary safety consideration when using a Pike Pole for pulling ceilings?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text clearly states that a primary safety consideration when using a Pike Pole for pulling ceilings is to be alert to large sections of ceiling falling while being pulled.",
          "options": {
            "A": "Ensure the pole is painted to prevent rust",
            "B": "Make sure the pole is at least 16 feet long",
            "C": "Be alert to large sections of ceiling falling while being pulled",
            "D": "Ensure the pole has a 'D' style handle"
          }
        },
        {
          "id": "sfd_basic_skills_18_fce9f851",
          "question": "What is one of the uses of a Pike Pole in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that a Pike Pole can be used for ventilation in firefighting operations.",
          "options": {
            "A": "Extinguishing fires",
            "B": "Ventilation",
            "C": "Carrying injured personnel",
            "D": "Breaking windows"
          }
        },
        {
          "id": "sfd_basic_skills_18_86078fac",
          "question": "What is the purpose of the point and hook on the head of a Pike Pole?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text explains that the point on the head of a Pike Pole is designed to penetrate materials, while the hook allows these materials to be pulled or moved.",
          "options": {
            "A": "The point is for breaking windows and the hook is for carrying the pole",
            "B": "The point allows the pole to penetrate materials and the hook allows them to be pulled or moved",
            "C": "The point is for painting the pole and the hook is for hanging it up",
            "D": "The point is for extinguishing fires and the hook is for rescue operations"
          }
        },
        {
          "id": "sfd_basic_skills_18_e12f6551",
          "question": "Why should the handles of a Pike Pole be kept free of paint?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "While the text does not explicitly state why the handles should be kept free of paint, it is reasonable to infer that this is to ensure a good grip, which is crucial for safety and effectiveness in firefighting operations.",
          "options": {
            "A": "To prevent the pole from being too heavy",
            "B": "To ensure a good grip",
            "C": "To make the pole more visible in the dark",
            "D": "To prevent rust"
          }
        },
        {
          "id": "sfd_basic_skills_18_7108a674",
          "question": "What is the importance of wearing full PPE when using a Pike Pole?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions wearing full PPE as a safety measure when using a Pike Pole. This is likely to protect against potential injuries from falling materials, especially when pulling ceilings.",
          "options": {
            "A": "To prevent rust on the pole",
            "B": "To ensure proper handling of the pole",
            "C": "To protect against potential injuries from falling materials",
            "D": "To make the firefighter more visible"
          }
        },
        {
          "id": "sfd_basic_skills_38_2bda7042",
          "question": "What is the primary use of the water vacuum in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The water vacuum is primarily used for the removal of water during salvage operations.",
          "options": {
            "A": "Extinguishing fires",
            "B": "Removing smoke",
            "C": "Salvage operations",
            "D": "Rescuing victims"
          }
        },
        {
          "id": "sfd_basic_skills_38_a49961af",
          "question": "Why might a Prosser pump be required in the use of a water vacuum?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A Prosser pump may be required if the water is deeper than the head of the wand.",
          "options": {
            "A": "If the water is deeper than the head of the wand",
            "B": "If the water is too hot",
            "C": "If the water contains chemicals",
            "D": "If the water vacuum's tank is full"
          }
        },
        {
          "id": "sfd_basic_skills_38_803ae4ca",
          "question": "What safety equipment is recommended for use with the water vacuum according to SFD Dispatch #12-08?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A circuit tester and GFCI are recommended for use with the water vacuum according to SFD Dispatch #12-08.",
          "options": {
            "A": "Fire resistant gloves",
            "B": "A circuit tester and GFCI",
            "C": "Safety goggles",
            "D": "A full face mask"
          }
        },
        {
          "id": "sfd_basic_skills_38_1de23bee",
          "question": "What is the weight of the water vacuum when full?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The weight of the water vacuum when full is 73 pounds.",
          "options": {
            "A": "50 pounds",
            "B": "73 pounds",
            "C": "100 pounds",
            "D": "125 pounds"
          }
        },
        {
          "id": "sfd_basic_skills_38_772167f2",
          "question": "What is an important maintenance step after using the water vacuum?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "An important maintenance step after using the water vacuum is wiping down the unit.",
          "options": {
            "A": "Refilling the tank",
            "B": "Wiping down the unit",
            "C": "Replacing the power cord",
            "D": "Replacing the wand"
          }
        },
        {
          "id": "sfd_basic_skills_4_fb377cbb",
          "question": "What is the primary use of a Double Female Coupling in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A Double Female Coupling has female threads of equal size on both ends and is used to connect two hoses with male ends.",
          "options": {
            "A": "To connect two hoses with male ends",
            "B": "To connect two hoses with female ends",
            "C": "To connect a hose with a fire hydrant",
            "D": "To connect a hose with a fire extinguisher"
          }
        },
        {
          "id": "sfd_basic_skills_4_28e59682",
          "question": "What is the primary use of a Double Male Coupling in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Double Male Coupling has male threads of equal size on both ends and is used to connect two hoses with female ends.",
          "options": {
            "A": "To connect two hoses with male ends",
            "B": "To connect two hoses with female ends",
            "C": "To connect a hose with a fire hydrant",
            "D": "To connect a hose with a fire extinguisher"
          }
        },
        {
          "id": "sfd_basic_skills_4_5475cfcb",
          "question": "What could be a potential safety risk when using a Double Male Coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Double Male Couplings, due to their design, can disconnect more easily than other types of couplings, which could pose a safety risk during firefighting operations.",
          "options": {
            "A": "It can cause a hose to burst",
            "B": "It can disconnect easily",
            "C": "It can cause water pressure to drop",
            "D": "It can cause a fire to spread"
          }
        },
        {
          "id": "sfd_basic_skills_4_a8562e4c",
          "question": "Why is it important to understand the difference between a Double Female Coupling and a Double Male Coupling in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding the difference between a Double Female Coupling and a Double Male Coupling is crucial for ensuring proper hose connection during firefighting operations.",
          "options": {
            "A": "To ensure proper water flow",
            "B": "To ensure proper hose connection",
            "C": "To ensure proper fire extinguishing",
            "D": "To ensure proper fire spread"
          }
        },
        {
          "id": "sfd_basic_skills_4_0e791a65",
          "question": "What is the size of the Double Female and Double Male Couplings mentioned in the text?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text mentions that the Double Female and Double Male Couplings are 2.5 inches in size.",
          "options": {
            "A": "1 inch",
            "B": "1.5 inches",
            "C": "2 inches",
            "D": "2.5 inches"
          }
        },
        {
          "id": "sfd_basic_skills_14_3c022e46",
          "question": "What is the required PSI at the tip of the TFT Handline Nozzle for proper operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The TFT Handline Nozzle requires 100 PSI at the tip to operate properly.",
          "options": {
            "A": "50 PSI",
            "B": "150 PSI",
            "C": "100 PSI",
            "D": "200 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_14_eba818ef",
          "question": "What is the purpose of the removable tip on the TFT Handline Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The removable tip on the TFT Handline Nozzle is used for extending the line.",
          "options": {
            "A": "To increase water pressure",
            "B": "For extending the line",
            "C": "To reduce water usage",
            "D": "To change the water direction"
          }
        },
        {
          "id": "sfd_basic_skills_14_be2aa4de",
          "question": "What safety precaution should be taken when opening the TFT Handline Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To prevent a water surge or water hammer, the TFT Handline Nozzle should be opened slowly.",
          "options": {
            "A": "Open quickly to prevent water surge",
            "B": "Open slowly to prevent a water surge or water hammer",
            "C": "Open with gloves on to prevent burns",
            "D": "Open only when wearing safety goggles"
          }
        },
        {
          "id": "sfd_basic_skills_14_c538a0d0",
          "question": "What substance should not be used for maintenance of the TFT Handline Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "WD-40 should not be used for the maintenance of the TFT Handline Nozzle.",
          "options": {
            "A": "Break Free",
            "B": "WD-40",
            "C": "Water",
            "D": "Oil"
          }
        },
        {
          "id": "sfd_basic_skills_14_f54585de",
          "question": "What is the GPM range of the TFT Handline Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The GPM range of the TFT Handline Nozzle is 50 - 350 GPM.",
          "options": {
            "A": "50 - 150 GPM",
            "B": "100 - 200 GPM",
            "C": "50 - 350 GPM",
            "D": "100 - 350 GPM"
          }
        },
        {
          "id": "sfd_basic_skills_15_6659e5c7",
          "question": "What is one of the primary uses of a Distributor Nozzle in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Distributor Nozzle is primarily used for fighting ship and basement fires.",
          "options": {
            "A": "Extinguishing forest fires",
            "B": "Fighting ship and basement fires",
            "C": "Rescuing trapped individuals",
            "D": "Ventilating smoke-filled rooms"
          }
        },
        {
          "id": "sfd_basic_skills_15_2bc0b865",
          "question": "What safety consideration should be taken into account when using the Distributor Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Distributor Nozzle does not have a shutoff, so one should be placed along the supply line or a hose clamp should be available.",
          "options": {
            "A": "The nozzle should be used at a safe distance from the fire",
            "B": "The nozzle does not have a shutoff, so one should be placed along the supply line or a hose clamp should be available",
            "C": "The nozzle should be used only by trained personnel",
            "D": "The nozzle should be used in conjunction with a fire extinguisher"
          }
        },
        {
          "id": "sfd_basic_skills_15_6ed5ec83",
          "question": "What is the operational tactic for placing the Distributor Nozzle in operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Distributor Nozzle is placed in operation by lowering it through an opening in a floor, decking, or roof, to the involved space below.",
          "options": {
            "A": "By attaching it to a fire truck",
            "B": "By lowering it through an opening in a floor, decking, or roof, to the involved space below",
            "C": "By throwing it into the fire",
            "D": "By using it to spray water from a distance"
          }
        },
        {
          "id": "sfd_basic_skills_15_89d272b8",
          "question": "What is the capacity of the Distributor Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Distributor Nozzle has a capacity of 270 GPM at 100 PSI.",
          "options": {
            "A": "270 GPM at 100 PSI",
            "B": "150 GPM at 80 PSI",
            "C": "300 GPM at 120 PSI",
            "D": "200 GPM at 90 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_15_cea10976",
          "question": "What maintenance is required for the Distributor Nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Distributor Nozzle requires lubrication of its moving parts for maintenance.",
          "options": {
            "A": "Replacing the nozzle head every six months",
            "B": "Lubricating moving parts",
            "C": "Checking for leaks regularly",
            "D": "Cleaning the nozzle after every use"
          }
        },
        {
          "id": "sfd_basic_skills_5_91712932",
          "question": "What is the purpose of a Cap in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Cap is used to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance.",
          "options": {
            "A": "To increase the flow of water from the apparatus",
            "B": "To temporarily or permanently prevent the flow of water from the apparatus",
            "C": "To redirect the flow of water from the apparatus",
            "D": "To measure the flow of water from the apparatus"
          }
        },
        {
          "id": "sfd_basic_skills_5_0dda1ac2",
          "question": "What is the difference between a Cap and a Plug in firefighting equipment?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Cap has female threads and is intended to cap a male coupling or fitting. A Plug has male threads and is intended to plug a female coupling or fitting.",
          "options": {
            "A": "A Cap has male threads, while a Plug has female threads",
            "B": "A Cap has female threads, while a Plug has male threads",
            "C": "A Cap and a Plug are the same",
            "D": "A Cap is used to increase water flow, while a Plug is used to decrease it"
          }
        },
        {
          "id": "sfd_basic_skills_5_00f1e2ff",
          "question": "What is the primary safety consideration when using a Cap or a Plug?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "While all these considerations are important, the most critical safety consideration is ensuring the Cap or Plug is securely fastened to prevent unintended water flow.",
          "options": {
            "A": "Ensuring the Cap or Plug is the correct size",
            "B": "Ensuring the Cap or Plug is securely fastened",
            "C": "Ensuring the Cap or Plug is not used in a high-temperature environment",
            "D": "Ensuring the Cap or Plug is brightly colored for visibility"
          }
        },
        {
          "id": "sfd_basic_skills_5_1034b31b",
          "question": "What is the implication of using a Cap or Plug in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Cap or Plug is used to temporarily or permanently prevent the flow of water from the apparatus, hose or appliance, allowing for more precise control of water flow.",
          "options": {
            "A": "It increases the risk of water damage",
            "B": "It allows for more precise control of water flow",
            "C": "It reduces the effectiveness of the firefighting operation",
            "D": "It increases the time needed to extinguish a fire"
          }
        },
        {
          "id": "sfd_basic_skills_5_1f6e7848",
          "question": "Which firefighting equipment is intended to plug a female coupling or fitting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Plug has male threads and is intended to plug a female coupling or fitting.",
          "options": {
            "A": "Cap",
            "B": "Hose",
            "C": "Plug",
            "D": "Nozzle"
          }
        },
        {
          "id": "sfd_basic_skills_39_faf17699",
          "question": "What is the maximum effective lift of a single Prosser pump according to the specifications?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the specifications, the maximum effective lift of a single Prosser pump is 37 feet.",
          "options": {
            "A": "74 feet",
            "B": "37 feet",
            "C": "120 feet",
            "D": "25 feet"
          }
        },
        {
          "id": "sfd_basic_skills_39_ef58cee1",
          "question": "What is one of the safety precautions that should be taken when using the Prosser pump?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "One of the safety precautions mentioned is to use a circuit tester and GFCI, in accordance with SFD Dispatch # 12 -08.",
          "options": {
            "A": "Use the pump while it's hot",
            "B": "Power on before handling",
            "C": "Use a circuit tester and GFCI, in accordance with SFD Dispatch # 12 -08",
            "D": "Inspect power cord after use"
          }
        },
        {
          "id": "sfd_basic_skills_39_72c485e7",
          "question": "What is the purpose of the strainer in the Prosser pump?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The strainer in the Prosser pump is used to keep debris out.",
          "options": {
            "A": "To increase water flow",
            "B": "To keep debris out",
            "C": "To cool the pump",
            "D": "To secure the pump"
          }
        },
        {
          "id": "sfd_basic_skills_39_6d3b9b59",
          "question": "What is the minimum water depth for the Prosser pump to be an ideal tool for water removal?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Prosser pump is an ideal tool for the removal of water when water depth is 2 inches or deeper.",
          "options": {
            "A": "1 inch",
            "B": "2 inches",
            "C": "3 inches",
            "D": "4 inches"
          }
        },
        {
          "id": "sfd_basic_skills_39_c7700631",
          "question": "What is one of the maintenance tasks for the Prosser pump after use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "One of the maintenance tasks mentioned is to wipe down the unit after use.",
          "options": {
            "A": "Fill it with water",
            "B": "Wipe down unit",
            "C": "Heat the pump",
            "D": "Remove the strainer"
          }
        },
        {
          "id": "sfd_basic_skills_19_63424a88",
          "question": "What is the primary use of a Spanner Wrench in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Spanner Wrench is primarily used for tightening or loosening couplings, appliances, or hydrant port caps in firefighting operations.",
          "options": {
            "A": "To open or close the main stem of a fire hydrant",
            "B": "To tighten or loosen couplings, appliances, or hydrant port caps",
            "C": "To remove and replace the hose port caps",
            "D": "To extinguish fires"
          }
        },
        {
          "id": "sfd_basic_skills_19_512c4706",
          "question": "What is a unique feature of the OCD Wrench that makes it useful in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The OCD Wrench is designed to adjust to varying nut sizes by screwing the handle in or out, making it particularly useful for worn down nuts.",
          "options": {
            "A": "It can be used by itself or in tandem",
            "B": "It is made from plastic or aluminum",
            "C": "It adjusts to varying nut sizes by screwing the handle in or out",
            "D": "It is normally carried in the hydrant bag"
          }
        },
        {
          "id": "sfd_basic_skills_19_be8d8967",
          "question": "When might a firefighter choose to use an OCD Wrench over a galvin wrench?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The OCD Wrench may be used when a galvin wrench will not make a complete turn due to obstacles.",
          "options": {
            "A": "When the galvin wrench is not available",
            "B": "When the galvin wrench will not make a complete turn due to obstacles",
            "C": "When the fire is too large",
            "D": "When the hydrant port caps are too tight"
          }
        },
        {
          "id": "sfd_basic_skills_19_5e56b1c1",
          "question": "What types of spanners are issued to each firefighter?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Each firefighter is issued a folding-type spanner.",
          "options": {
            "A": "Straight, forged spanners",
            "B": "Folding-type spanners",
            "C": "OCD Wrenches",
            "D": "Galvin Wrenches"
          }
        },
        {
          "id": "sfd_basic_skills_19_a6ae669d",
          "question": "What material are the Spanner Wrenches made from?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Spanner Wrenches are made from plastic or aluminum.",
          "options": {
            "A": "Steel",
            "B": "Wood",
            "C": "Plastic or aluminum",
            "D": "Iron"
          }
        },
        {
          "id": "sfd_basic_skills_23_81a381a2",
          "question": "What was the original purpose of the Roof Hook?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Roof Hook was originally designed for overhauling dumpster fires.",
          "options": {
            "A": "For overhauling dumpster fires",
            "B": "For breaking ceramic roof tiles",
            "C": "For pulling ceilings",
            "D": "For rooftop ventilation"
          }
        },
        {
          "id": "sfd_basic_skills_23_798a40aa",
          "question": "What safety consideration should be taken into account when using the Roof Hook?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When using the Roof Hook, firefighters should be alert as large sections may fall when pulling ceilings.",
          "options": {
            "A": "Ensure the handle is free of paint",
            "B": "Be alert as large sections may fall when pulling ceilings",
            "C": "Ensure the hook is facing up",
            "D": "Ensure the tool is 6 feet long"
          }
        },
        {
          "id": "sfd_basic_skills_23_49590b9e",
          "question": "Why is the Roof Hook now primarily used in the fire service?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Roof Hook is primarily used in the fire service for rooftop ventilation.",
          "options": {
            "A": "For overhauling dumpster fires",
            "B": "For rooftop ventilation",
            "C": "For breaking ceramic roof tiles",
            "D": "For pulling ceilings"
          }
        },
        {
          "id": "sfd_basic_skills_23_52b80681",
          "question": "What is a specific use of the Roof Hook in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "One specific use of the Roof Hook in firefighting operations is to louver the vent cuts.",
          "options": {
            "A": "To louver the vent cuts",
            "B": "To paint the heads",
            "C": "To ensure the tool is 6 feet long",
            "D": "To ensure full protective clothing is worn"
          }
        },
        {
          "id": "sfd_basic_skills_23_a4ddfd57",
          "question": "What is a maintenance consideration for the Roof Hook?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A maintenance consideration for the Roof Hook is that the heads may be painted but the handles should be kept free of paint.",
          "options": {
            "A": "The heads may be painted but keep handles free of paint",
            "B": "The hooks should be facing up",
            "C": "The tool should be 6 feet long",
            "D": "Full protective clothing should be worn"
          }
        },
        {
          "id": "sfd_basic_skills_9_1d18996f",
          "question": "What is the primary function of the Tri-Gated Wye in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Tri-Gated Wye is used to split a singular source of water into multiple lines, allowing for more efficient water delivery during firefighting operations.",
          "options": {
            "A": "To increase the water pressure",
            "B": "To split a singular source of water into multiple lines",
            "C": "To cool down the engine",
            "D": "To connect the nozzle to the hydrant directly"
          }
        },
        {
          "id": "sfd_basic_skills_9_12e41e70",
          "question": "What is a unique feature of the Tri-Gated Wye compared to other wyes?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Unlike other wyes, the Tri-Gated Wye has male threads on both sides of the appliance.",
          "options": {
            "A": "It has female threads on both sides",
            "B": "It has male threads on both sides",
            "C": "It has no threads",
            "D": "It has a singular outlet"
          }
        },
        {
          "id": "sfd_basic_skills_9_cc6419d2",
          "question": "What is the purpose of the 'Manifold Reverse' lay in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'Manifold Reverse' lay is used to easily implement the use of the Tri-Gated Wye, enhancing the efficiency of water delivery.",
          "options": {
            "A": "To reverse the flow of water",
            "B": "To easily implement the use of the Tri-Gated Wye",
            "C": "To connect the nozzle directly to the hydrant",
            "D": "To increase the water pressure"
          }
        },
        {
          "id": "sfd_basic_skills_9_be864005",
          "question": "What is the significance of the LDH hose in relation to the Tri-Gated Wye?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The LDH hose is significant as it is used for both supply hose (between the hydrant and the engine) and hose to supply attack lines (between the engine and the nozzle).",
          "options": {
            "A": "The LDH hose is used to connect the Tri-Gated Wye to the nozzle",
            "B": "The LDH hose is used for both supply hose and hose to supply attack lines",
            "C": "The LDH hose is used to increase the water pressure",
            "D": "The LDH hose is not related to the Tri-Gated Wye"
          }
        },
        {
          "id": "sfd_basic_skills_9_69518244",
          "question": "What is the size of the male inlet on the Tri-Gated Wye?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Tri-Gated Wye has a 4\u201d male inlet that branches off to three 2 \u00bd\u201d male threads.",
          "options": {
            "A": "2 \u00bd\u201d",
            "B": "3\u201d",
            "C": "4\u201d",
            "D": "5\u201d"
          }
        },
        {
          "id": "sfd_basic_skills_35_e13ba446",
          "question": "What is the primary function of the Holmatro Rescue Tools in the context of firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Holmatro Rescue Tools are hydraulically driven tools used for heavy rescue and auto extrication, as stated in the text.",
          "options": {
            "A": "To start fires for controlled burns",
            "B": "To extinguish fires",
            "C": "For heavy rescue and auto extrication",
            "D": "To communicate with other firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_35_ad9ec9ff",
          "question": "What is the significance of the DPU30 in relation to the Holmatro Rescue Tools?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The DPU30, or the Holmatro Double Power Unit, supplies power to the Holmatro Rescue Tools, making them operational.",
          "options": {
            "A": "It is the tool used to extinguish fires",
            "B": "It is the tool used to start controlled burns",
            "C": "It is the tool used to communicate with other firefighters",
            "D": "It supplies power to the Holmatro Rescue Tools"
          }
        },
        {
          "id": "sfd_basic_skills_35_634d9436",
          "question": "What is the recommended maintenance procedure for the Cutter and the 'Combi' tool?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that a torque wrench set at 75 ft-lb should be used to tighten the jaws on the Cutter and the 'Combi' tool after every use.",
          "options": {
            "A": "Use torque wrench set at 75 ft-lb. to tighten the jaws after every use",
            "B": "Clean the tools with water after every use",
            "C": "Replace the tools after every use",
            "D": "No maintenance is required"
          }
        },
        {
          "id": "sfd_basic_skills_35_fb2cf1af",
          "question": "What safety gear is recommended when using the Holmatro Rescue Tools?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that full protective clothing and eye protection should be worn when using the Holmatro Rescue Tools.",
          "options": {
            "A": "Full protective clothing and eye protection",
            "B": "A helmet and gloves only",
            "C": "No safety gear is necessary",
            "D": "Only eye protection"
          }
        },
        {
          "id": "sfd_basic_skills_35_c59cad95",
          "question": "Which units in the Seattle Fire Department are equipped with the DPU30 and Rescue Tools as standard equipment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, the DPU30 and Rescue Tools are standard equipment on all Truck Companies in the Seattle Fire Department.",
          "options": {
            "A": "All Truck Companies",
            "B": "Only the Chief's vehicle",
            "C": "Only the first responding unit",
            "D": "All Ambulances"
          }
        }
      ]
    },
    "2": {
      "chapter_id": "2",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_47_2459ebd0",
          "question": "The PASS system can be deactivated while the system is still pressurized.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If you attempt to deactivate the PASS with a pressurized system, you will hear single \u201cchirps\u201d every second for approximately 15 seconds...this DOES NOT indicate the PASS has been de-activated.' This means that the PASS system cannot be deactivated while the system is still pressurized. This is important for firefighters to understand as it affects their safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_47_53ee73b8",
          "question": "The Pak-Alert distress alarm includes a log of event data including start-up, shut-down, and PASS activation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text confirms, 'The Pak -Alert distress alarm includes on -board electronics which maintain a running log of event data including start -up, shut -down, and PASS activation.' This feature can provide valuable information for post-incident analysis and learning.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_47_a0cf3df5",
          "question": "The Remote Pressure Gauge assembly incorporates a digital display.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Remote Pressure Gauge assembly incorporates an analog display.' This means that the display is not digital. Understanding the type of display is important for firefighters as it affects how they read and interpret the gauge during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_47_5c89dd99",
          "question": "The orange light on the Pak-Alert system is a combination of the red, green, and white lights.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text confirms, 'THE ORANGE LIGHT IS A COMBINATION OF THE RED, GREEN, AND WHITE LIGHTS.' This is important for firefighters to understand as it affects how they interpret the signals from the Pak-Alert system.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_47_de078b0a",
          "question": "When the Pak-Alert system is in full alarm, it flashes green lights simultaneously.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'PASS Full Alarm Flashes RED (simultaneously).' This means that the Pak-Alert system does not flash green lights when in full alarm. Understanding the correct light signals is crucial for firefighters as it affects their response during an emergency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_51_2c5771ef",
          "question": "The air from two SCBA cylinders is used to support two users in the Emergency Breathing Support System.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The air from only one SCBA cylinder is used to support two users.' This contradicts the question statement, implying that only one SCBA cylinder is used to support two users in the Emergency Breathing Support System. This is crucial for firefighters to understand as it affects their air supply management during emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_51_57082c78",
          "question": "The donor's Vibralert should be activated during the use of the Emergency Breathing Support System.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The donor\u2019s Vibralert should not b e activated.' This contradicts the question statement, indicating that the donor's Vibralert should not be activated during the use of the Emergency Breathing Support System. This is important for firefighters to know to prevent unnecessary alarm during emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_51_3fa8d698",
          "question": "Each user\u2019s Remote Pressure Gauge will display the average pressure between the two users.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Each user\u2019s Remote Pressure Gauge will continue to display their individual cylinder pressure, not the average pressure between the two users.' This contradicts the question statement, implying that each user's Remote Pressure Gauge will display their individual cylinder pressure, not the average. This is a critical detail for firefighters to understand as it affects their awareness of their individual air supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_51_1cc2d4a1",
          "question": "The Emergency Breathing Support System hose becomes pressurized when the SCBA is pressurized.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the SCBA is pressurized, the Emergency Breathing Support System hose is also pressurized.' This supports the question statement, indicating that the Emergency Breathing Support System hose becomes pressurized when the SCBA is pressurized. This is an important operational detail for firefighters to understand to ensure proper functioning of the system.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_51_79eeb0dc",
          "question": "The male side of the Emergency Breathing Support System manifold can release air at up to 150 psig when the check valve sleeve is pulled back.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The male side of the Emergency Breathing Support System manifold can release air at up to 150 psig when the check valve sleeve is pulled back.' This supports the question statement, indicating that the male side of the system manifold can release air at up to 150 psig when the check valve sleeve is pulled back. This is a critical safety detail for firefighters to be aware of to prevent potential injury from high-pressure air release.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_50_d6ee844a",
          "question": "The Emergency Breathing Support System is a transfill system.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Emergency Breathing Support System is not a transfill system.' This means that the Emergency Breathing Support System does not move air from one cylinder to another on the high-pressure side of the PRA. This is important for firefighters to understand as it affects how they can share air in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_50_ee56e8d1",
          "question": "The Emergency Breathing Support System allows users to share air on the high-pressure side of the PRA.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Emergency Breathing Support System \u201cBuddy Breathing\u201d system allows users to share air on the low-pressure side of the PRA.' This contradicts the statement in the question. Understanding this is crucial for firefighters as it affects the operational use of the system during emergencies.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_50_f3f5b462",
          "question": "When used for emergency escape, the Emergency Breathing Support System can be used to supply breathing support air to multiple users.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When used for emergency escape, the Emergency Breathing Support System must remain connected and used to supply breathing support air to ONLY ONE other user.' This contradicts the statement in the question. This is a critical safety consideration for firefighters as it limits the number of users the system can support in an emergency escape situation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_50_aac9d195",
          "question": "Two SCBA users can connect their \u201cBuddy Breathing\u201d hoses together to share air.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Two SCBA users can connect their \u201cBuddy Breathing\u201d hoses together. The remaining air capacity of both cylinders is available to both SCBA users, so long as they stay connected.' This supports the statement in the question. This is a key operational consideration for firefighters as it allows them to share air in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_50_2a59998f",
          "question": "The remaining air capacity of both cylinders is available to both SCBA users only if they stay connected.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The remaining air capacity of both cylinders is available to both SCBA users, so long as they stay connected.' This supports the statement in the question. It is important for firefighters to understand this as it affects their air supply during emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_46_1b34d0ac",
          "question": "The Remote Pressure Gauge is located on the user\u2019s left side.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Remote Pressure Gauge is located on the user\u2019s right side.' This directly contradicts the statement in the question. The location of the gauge is important for firefighters to quickly check the pressure in high-stress situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_46_c636aad6",
          "question": "The YELLOW button on the Remote Pressure Gauge is used to reset the PASS in \u201cpre-alarm\u201d by clicking the button once.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The YELLOW button is used to reset the PASS in \u201cpre -alarm\u201d by clicking the button once.' This supports the statement in the question. Understanding the function of the YELLOW button is crucial for firefighters to manage and reset alarms during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_46_b21a0244",
          "question": "The system is activated by a pressure switch when the cylinder valve is closed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The system is activated by a pressure switch when the cylinder valve is opened.' This directly contradicts the statement in the question. Knowing how to activate the system is essential for firefighters to ensure the system is operational before entering a dangerous environment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_46_1022b9bd",
          "question": "If no motion is detected in 20 seconds, a pre-alarm consisting of ascending/descending tones is heard from the sensor module on the back frame.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If no motion is detected in 20 seconds, a pre-alarm consisting of ascending/descending tones is heard from the sensor module on the back frame.' This supports the statement in the question. This feature is important for firefighter safety as it alerts others if a firefighter becomes immobile during an operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_46_cda9b7d9",
          "question": "Batteries can be changed while the system is pressurized.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'NEVER REMOVE OR REPLACE BATTERIES WITH SYSTEM PRESSURIZED OR DAMAGE MAY OCCUR TO ELECTRONIC COMPONENTS.' This directly contradicts the statement in the question. Understanding this is crucial to prevent damage to the system and ensure its proper functioning during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_53_44aa342e",
          "question": "The Emergency Breathing Support System, Facepiece Mounted Regulator, and Remote Pressure Gauge are all located on the 'high pressure' side of the Pressure Reducing Assembly.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Emergency Breathing Support System \u201cBuddy Breathing\u201d system, Facepiece Mounted Regulator, and Remote Pressure Gauge are all located on the \u201clow pressure\u201d side of the Pressure Reducing Assembly (PRA).' This contradicts the statement in the question. The firefighting implications are that understanding the location of these components in relation to the PRA is crucial for proper operation and maintenance of the SCBA.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_53_d36fc913",
          "question": "When cylinder pressure drops to about 1833 psig, the Pressure Reducing Assembly switches air flow to a secondary pathway.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text confirms, 'When cylinder pressure drops to ~1833 psig (\u2153 capacity), the PRA switches air flow to a secondary pathway.' This supports the statement in the question. The firefighting implications are that firefighters must be aware of this pressure threshold and its impact on the operation of their SCBA, particularly during extended operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_53_475918f7",
          "question": "If both SCBA are operating at the same pressure, the cylinders will be consumed at different rates.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If both SCBA are operating at the same pressure (both above 1/3 or both in alarm), the cylinders will be consumed at more or less the same rate.' This contradicts the statement in the question. The firefighting implications are that firefighters sharing air need to monitor their air consumption rates to ensure they do not run out of air prematurely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_53_7f373b3e",
          "question": "When an SCBA that is not in alarm is connected to one that is, only the Vibralert of the SCBA in alarm will sound.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When an SCBA that is not in alarm is connected to one that is, both Vibralerts will sound.' This contradicts the statement in the question. The firefighting implications are that firefighters must understand the signals of their equipment to accurately interpret their situation, particularly in a buddy-breathing scenario.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_53_c9443719",
          "question": "At the end of use, the facepiece and regulator should be removed from the user requiring support last.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remove the facepiece and regulator from the user requiring support first.' This contradicts the statement in the question. The firefighting implications are that correct procedures must be followed when terminating the Emergency Breathing Support System function to ensure firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_45_d341d916",
          "question": "The Scott AV3000 HT facepieces are available in two sizes only.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Scott AV3000 HT facepieces are available in three sizes (small, medium, and large).' This contradicts the question statement, indicating that there are three sizes, not two. The correct sizing is crucial for firefighters to ensure a proper fit for safety and efficiency during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_45_679e95f5",
          "question": "The Voicemitters on the SCOTT AV3000 HT are designed to enhance communication between users.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "According to the text, 'The Voicemitters are a mechanical voice amplification system that increases the clarity of communication between users.' This supports the question statement. Clear communication is vital in firefighting operations for coordination and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_45_038be7ba",
          "question": "The SCOTT Epic 3 voice amplifier is a solar-powered device.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'The Epic 3 is a battery-powered voice amplification device.' This contradicts the question statement, which incorrectly claims the device is solar-powered. Understanding the power source of equipment is important for firefighters to ensure they are adequately prepared for operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_45_09eca59b",
          "question": "The Pak-Alert SE7 is mounted on the front frame of the SCOTT AV3000 HT facepiece.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, 'SCOTT\u2019s integrated PASS device, the Pak-Alert SE7, is mounted on the back frame.' This contradicts the question statement. Knowing the correct location of equipment is crucial for firefighters as it affects how they interact with their gear during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_45_671f35b6",
          "question": "The most effective technique for communicating into a portable radio is to place the remote microphone directly over either of the Voicemitters.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this by stating, 'The most effective technique for communicating into a portable radio is to place the remote microphone directly over either of the Voicemitters.' This validates the question statement. Effective communication techniques are critical in firefighting operations for safety and coordination.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_49_c0355064",
          "question": "The Scott Air-Pak X3\u00ae is not equipped with a Dual Emergency Breathing Support System \u201cBuddy Breathing\u201d accessory hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Scott Air -Pak X3\u00ae is equipped with a Dual Emergency Breathing Support System \u201cBuddy Breathing\u201d accessory hose.' This statement contradicts the question. The firefighting implications of this are significant as the 'Buddy Breathing' system allows firefighters to share air in emergency situations, enhancing safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_49_7d1f212c",
          "question": "The Dual Emergency Breathing Support System is connected to the high-pressure side of the SCBA\u2019s Pressure Reducing Assembly (PRA).",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'One end is permanently connected to the low- pressure side of the SCBA\u2019s Pressure Reducing Assembly (PRA).' This contradicts the question statement. The correct connection to the low-pressure side is crucial for the proper functioning of the 'Buddy Breathing' system, ensuring that firefighters can share air safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_49_0412f963",
          "question": "The Dual Emergency Breathing Support System is stored in a belt mounted carrying pouch when not in use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A belt mounted carrying pouch with a snap opening is used to store the Dual Emergency Breathing Support System when not in use.' This supports the question statement. Proper storage of the system ensures it is protected and readily available when needed, contributing to firefighter safety and operational readiness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_49_12157606",
          "question": "The carrying pouch for the Dual Emergency Breathing Support System is mounted on the left side of the waist pad.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The pouch is mounted on the right side of the waist pad.' This contradicts the question statement. Knowing the correct location of equipment is important for firefighters to quickly and efficiently access their gear in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_49_386c8310",
          "question": "The Dual Emergency Breathing Support System has both male and female quick disconnect couplings.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The other end is fitted with both male and female quick disconnect couplings.' This supports the question statement. The presence of both types of couplings allows for versatile connections, enhancing the system's usability in various emergency scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_48_50c9b47a",
          "question": "The Heads-Up Display provides a visual monitor of the air supply in the cylinder and valve assembly.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Heads -Up Display provides a visual monitor of the air supply in the cylinder and valve assembly.' This supports the statement that the Heads-Up Display provides a visual monitor of the air supply. This is crucial for firefighters as it helps them monitor their air supply during operations, ensuring their safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_48_8886284b",
          "question": "The Heads-Up Display consists of five rectangular LEDs to represent the cylinder pressure.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Heads -Up Display consists of four rectangular LEDs to represent the cylinder pressure at FULL, THREE -QUARTERS, ONE - HALF, and ONE -THIRD.' This contradicts the statement that the Heads-Up Display consists of five rectangular LEDs. Understanding the correct number and function of LEDs is important for firefighters to accurately monitor their air supply during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_48_58a9d470",
          "question": "If the lights on the Heads-Up Display do not operate as described, the respirator can still be used.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the lights do not operate as described, DO NOT USE THE RESPIRATOR.' This contradicts the statement that the respirator can still be used if the lights do not operate as described. This is a critical safety issue for firefighters as using a faulty respirator can lead to insufficient air supply during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_48_dbab8a3d",
          "question": "The Heads-Up Display has an automatic brightness control that adjusts the display based on the light conditions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Heads -Up Display has an automatic brightness control that dims the display in low light and returns the display to full brightness in bright light situations.' This supports the statement that the Heads-Up Display has an automatic brightness control. This feature can help firefighters read the display more easily in varying light conditions, enhancing their operational efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_48_88dd9784",
          "question": "When the LOW BATTERY indicator activates, the batteries must be changed immediately even if the cylinder still has sufficient power.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the LOW BATTERY indicator activates, there is still sufficient power to operate the Heads -Up Display for the duration of the cylinder. However, the batteries must be changed immediately upon terminating use of the SCBA before re -entry into an IDLH.' This supports the statement that the batteries must be changed immediately when the LOW BATTERY indicator activates. This is crucial for firefighters as failing to change the batteries could result in the Heads-Up Display not functioning properly, potentially compromising their safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_44_68c87000",
          "question": "The SCBA cylinders should be picked up or carried by the valve handle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not pick up or carry SCBA cylinders by the valve handle.' This contradicts the question statement. The correct way to handle the cylinders is by using the body of the valve assembly. This is important for firefighter safety and proper equipment handling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_44_aa8be6f9",
          "question": "The threaded connection on the cylinder valve assembly is used for filling and incorporates a one-way valve that allows air to escape the cylinder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'The threaded connection on the cylinder valve assembly is used for filling. It incorporates a one-way valve that allows air to enter the cylinder, but not escape.' This contradicts the question statement. The one-way valve allows air to enter the cylinder, not escape. This is crucial for maintaining the integrity of the air supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_44_0a5297d5",
          "question": "The E-Z Flo+ Facepiece Mounted Regulator keeps a positive pressure in the facepiece at all times.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text confirms, 'This is a pressure-demand regulator, which keeps a positive pressure in the facepiece at all times.' This supports the question statement. Maintaining positive pressure is critical to prevent the inhalation of smoke or toxic gases during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_44_63e86e8e",
          "question": "The design of the Facepiece Mounted Regulator mixes the inhaled and exhaled air.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The design of the Facepiece Mounted Regulator separates the air being inhaled from the exhaled air.' This contradicts the question statement. The separation of inhaled and exhaled air limits cross-contamination between users, which is important for firefighter health and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_44_fb6c8300",
          "question": "The regulator needs to be cleaned or disinfected between users due to the possibility of cross contamination.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'Because of this separated flow path design, the regulator does not need to be cleaned or disinfected between users.' This contradicts the question statement. The design of the regulator minimizes the risk of cross-contamination, reducing the need for cleaning or disinfection between users. This is a significant consideration for equipment maintenance and firefighter health.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_52_ddc60e9f",
          "question": "Damage to the hose can result in partial or complete loss of air from both cylinders when in use by two persons for emergency breathing support.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Damage to the hose may result in partial or complete loss of air. If damage occurs when connected and in use by two persons for emergency breathing support, the air loss will be from both cylinders.' This supports the statement and implies that firefighters should be cautious when using the hose for emergency breathing support, as damage to it can affect both users.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_52_4af297bb",
          "question": "The person requiring support must always hold their breath and separate the QD on the regulator hose and connect it to the female side of the manifold.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the person requiring support DOES NOT have a matching Emergency Breathing Support System connection, or that connection is not accessible, they must hold their breath and separate the QD on the regulator hose and connect it to the female side of the manifold.' This contradicts the statement because it specifies that this step is only necessary if the person requiring support does not have a matching connection or if it is not accessible. Firefighters should be aware of the different connection methods in order to provide effective support.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_52_09e906ef",
          "question": "The person giving support must have the Emergency Breathing Support System on their SCBA when operating with mutual aid companies.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When operating with mutual aid companies, remember that the person requiring support must have either a regulator hose with a male quick disconnect or a matching Emergency Breathing Support System hose. The person giving support must have the Emergency Breathing Support System on their SCBA.' This supports the statement and highlights the importance of having the right equipment when providing support in a mutual aid situation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_52_42fc6dcf",
          "question": "The Emergency Breathing Support System hose can only be joined male-to-female.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the Emergency Breathing Support System hose on the person requiring support is accessible, the two manifolds may be joined either male-to-female or female-to-male.' This contradicts the statement, indicating that the hose can be joined in either direction. This flexibility can be crucial in emergency situations where quick connection is needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_52_9028f20c",
          "question": "It is not necessary to test for positive connection by tugging on the couplings after connecting the Emergency Breathing Support System.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Test for positive connection by tugging on the couplings.' This contradicts the statement, emphasizing the importance of ensuring a secure connection to avoid potential air loss during an emergency situation. Firefighters should always verify the connection to ensure the system functions properly when needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_43_d8fe8fae",
          "question": "The Air-Pak X3's Pressure Reducing Assembly (PRA) has never experienced a complete failure since its development in 1976.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It was originally developed with NASA in 1976 with no reported complete failures.' This supports the statement that the PRA has never experienced a complete failure. This reliability is crucial for firefighters as it ensures a consistent supply of air, which is vital for their safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_43_0039cdec",
          "question": "The Vibralert alarm is activated when the primary air path of the PRA becomes blocked and the secondary air path begins supplying air.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the primary air path of the PRA becomes blocked or should fail closed, the secondary air path will automatically begin supplying air to the Facepiece Mounted Regulator and the Vibralert alarm will be actuated to warn the user of malfunction.' This supports the statement that the Vibralert alarm is activated under these circumstances. This feature is crucial for firefighter safety as it alerts them to potential equipment malfunctions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_43_cbe186f0",
          "question": "The cylinder valve is designed to freely open and close without any special mechanism.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The cylinder valve is designed to freely open. However, it has a ratcheting style closing mechanism designed to limit the possibility of accidentally closing the cylinder valve once open.' This contradicts the statement that the cylinder valve can freely open and close without any special mechanism. This design consideration is important for firefighters as it prevents accidental closure of the valve, ensuring a consistent air supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_43_a4c15cd5",
          "question": "The standard cylinder used in the SCBA has a service life of 10 years.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Our SCBA cylinders have a service life of 15 years.' This contradicts the statement that the standard cylinder has a service life of 10 years. Understanding the service life of equipment is important for firefighters to ensure they are using reliable and safe equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_43_bfe89b66",
          "question": "The Snap-Change cylinder connection should show orange around the lock rings when properly attached.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When attaching an air cylinder, the user must ensure both Snap-Change locks \u201cclick\u201d into place. No orange should show around the lock rings.' This contradicts the statement that orange should show around the lock rings when properly attached. Proper attachment of the cylinder is crucial for firefighter safety to ensure a secure and reliable air supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_42_97dc541d",
          "question": "The SCOTT Air-Pak X3 SCBA is designed to provide respiratory protection in an oxygen deficient atmosphere.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The SCOTT Air-Pak X3 SCBA is a respirator intended to provide respiratory protection to an individual when entering, working in, and exiting an objectionable, oxygen deficient, and/or unbreathable (toxic) atmosphere.' This directly supports the question statement. The firefighting implication is that firefighters must understand the importance of using SCBA in oxygen deficient environments to ensure their safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_42_88cbc3fd",
          "question": "The waist strap buckle of the SCOTT Air-Pak X3 SCBA can be connected in multiple ways.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Because the waist strap buckle can only be connected one way, care must be used when slinging the Air-Pak to avoid twists in the straps.' This directly contradicts the question statement. The correct firefighting implication is that firefighters must be aware of the correct way to connect the waist strap buckle to ensure proper fit and function of the SCBA.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_42_e40c9be3",
          "question": "The Dual Emergency Breathing Support System \u201cBuddy Breathing\u201d hose is mounted in a pouch on the user\u2019s left waist pad.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Dual Emergency Breathing Support System \u201cBuddy Breathing\u201d hose is mounted in a pouch on the user\u2019s right waist pad.' This directly contradicts the question statement. The correct firefighting implication is that firefighters must know the correct location of the 'Buddy Breathing' hose for efficient use during emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_42_8d4a86af",
          "question": "The SCOTT Air-Pak X3 SCBA is designed to withstand exposure to certain environmental conditions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This equipment is designed to withstand exposure to certain environmental conditions as defined by the applicable approvals.' This directly supports the question statement. The firefighting implication is that firefighters must understand the limitations of their equipment in order to ensure their safety in various environmental conditions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_42_fe71509d",
          "question": "The back frame of the SCOTT Air-Pak X3 SCBA consists of a Kevlar cylinder retention band and latch assembly, connected to a steel frame.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The back frame consists of a Kevlar cylinder retention band and latch assembly, connected to an aluminum frame.' This directly contradicts the question statement. The correct firefighting implication is that firefighters must be aware of the materials used in their equipment, as this can affect the equipment's weight, durability, and resistance to heat.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_47_906be159",
          "question": "What does a single 'chirp' every second for approximately 15 seconds indicate when attempting to deactivate the PASS with a pressurized system?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The single 'chirp' every second for approximately 15 seconds does not indicate that the PASS has been deactivated. It will continue to sense motion and go into pre-alarm until all air has been removed, the YELLOW button has been depressed twice and a two-tone shut off tone has been heard.",
          "options": {
            "A": "The PASS has been successfully deactivated",
            "B": "The PASS is malfunctioning",
            "C": "The PASS is still active and sensing motion",
            "D": "The PASS is in full alarm mode"
          }
        },
        {
          "id": "sfd_basic_skills_47_804f17a8",
          "question": "What does the ORANGE light indicate on the Pak-Alert Visible Indicators?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ORANGE light on the Pak-Alert Visible Indicators flashes alternately when the unit has low air (1/3 cylinder) and once every two seconds when the battery is low.",
          "options": {
            "A": "The unit is in startup mode",
            "B": "The unit has low air or low battery",
            "C": "The unit is in normal operation",
            "D": "The unit is in full alarm mode"
          }
        },
        {
          "id": "sfd_basic_skills_47_9ffda5a5",
          "question": "What is the purpose of the LED backlight on the Remote Pressure Gauge assembly?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The LED backlight on the Remote Pressure Gauge assembly is designed to assist in low light visibility.",
          "options": {
            "A": "To indicate low air pressure",
            "B": "To assist in low light visibility",
            "C": "To indicate a malfunction in the system",
            "D": "To indicate a full alarm mode"
          }
        },
        {
          "id": "sfd_basic_skills_47_bcf2df43",
          "question": "What is the purpose of the Pak-Alert distress alarm's on-board electronics?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The on-board electronics of the Pak-Alert distress alarm maintain a running log of event data including start-up, shut-down, and PASS activation.",
          "options": {
            "A": "To control the LED lights",
            "B": "To maintain a running log of event data",
            "C": "To activate the PASS system",
            "D": "To control the pressure in the air cylinder"
          }
        },
        {
          "id": "sfd_basic_skills_47_f90258fb",
          "question": "What does the flashing RED light indicate on the Pak-Alert Visible Indicators?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The flashing RED light on the Pak-Alert Visible Indicators indicates that the PASS is in pre-alarm (flashes alternately) or full alarm (flashes simultaneously) mode.",
          "options": {
            "A": "The unit is in startup mode",
            "B": "The unit has low air or low battery",
            "C": "The unit is in normal operation",
            "D": "The unit is in pre-alarm or full alarm mode"
          }
        },
        {
          "id": "sfd_basic_skills_51_92fafdc3",
          "question": "What is the first step to follow when a situation arises that requires the use of the Emergency Breathing Support System?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in such a situation is to declare a Mayday and plan an escape route.",
          "options": {
            "A": "Connect the Buddy Breathing hose",
            "B": "Ensure the receiver's facepiece and regulator are properly donned",
            "C": "Declare a Mayday and plan your escape route",
            "D": "Check the Vibralert of the donor"
          }
        },
        {
          "id": "sfd_basic_skills_51_d762b852",
          "question": "What does the Remote Pressure Gauge display when the Emergency Breathing Support System is in use?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Each user's Remote Pressure Gauge will continue to display their individual cylinder pressure, not the average pressure between the two users.",
          "options": {
            "A": "The average pressure between the two users",
            "B": "The pressure in the Emergency Breathing Support System hose",
            "C": "The individual cylinder pressure of each user",
            "D": "The pressure in the donor's cylinder"
          }
        },
        {
          "id": "sfd_basic_skills_51_8b1118f5",
          "question": "What should the donating user ensure before connecting the Emergency Breathing Support System?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The donating user must ensure the receiver's facepiece and regulator are properly donned, connected, and secure prior to connecting the Emergency Breathing Support System.",
          "options": {
            "A": "That the receiver's Vibralert is not activated",
            "B": "That the receiver's facepiece and regulator are properly donned, connected, and secure",
            "C": "That they have enough air in their cylinder to support two people",
            "D": "That the check valve sleeve is pulled back"
          }
        },
        {
          "id": "sfd_basic_skills_51_91ff9f87",
          "question": "What must users engaged in Emergency Breathing Support with an Emergency Breathing Support System do regardless of the circumstances?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Regardless of the circumstances, the users engaged in Emergency Breathing Support with an Emergency Breathing Support System must immediately exit the IDLH.",
          "options": {
            "A": "Check the Vibralert of the donor",
            "B": "Ensure the receiver's facepiece and regulator are properly donned",
            "C": "Immediately exit the IDLH",
            "D": "Pull the check valve sleeve and point the male end toward anyone"
          }
        },
        {
          "id": "sfd_basic_skills_51_aeac4857",
          "question": "What happens when the SCBA is pressurized?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the SCBA is pressurized, the Emergency Breathing Support System hose is also pressurized.",
          "options": {
            "A": "The Vibralert of the donor is activated",
            "B": "The Emergency Breathing Support System hose is also pressurized",
            "C": "The check valve sleeve is pulled back",
            "D": "The receiver's facepiece and regulator are disconnected"
          }
        },
        {
          "id": "sfd_basic_skills_50_5e0f01bd",
          "question": "What is the main difference between the Emergency Breathing Support System and a transfill system?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The main difference is that transfill systems move air from one cylinder to another on the high-pressure side of the PRA, while the Emergency Breathing Support System allows users to share air on the low-pressure side.",
          "options": {
            "A": "Transfill systems move air on the low-pressure side of the PRA",
            "B": "The Emergency Breathing Support System is used for emergency escape only",
            "C": "Transfill systems move air from one cylinder to another on the high-pressure side of the PRA",
            "D": "The Emergency Breathing Support System can support multiple users at once"
          }
        },
        {
          "id": "sfd_basic_skills_50_083f5dec",
          "question": "What is the maximum number of users that the Emergency Breathing Support System can supply air to during an emergency escape?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "During an emergency escape, the Emergency Breathing Support System must remain connected and used to supply breathing support air to ONLY ONE other user.",
          "options": {
            "A": "Two",
            "B": "Three",
            "C": "Four",
            "D": "One"
          }
        },
        {
          "id": "sfd_basic_skills_50_2360bb37",
          "question": "What happens to the remaining air capacity when two SCBA users connect their 'Buddy Breathing' hoses together?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When two SCBA users connect their 'Buddy Breathing' hoses together, the remaining air capacity of both cylinders is available to both users, so long as they stay connected.",
          "options": {
            "A": "It is halved between the two users",
            "B": "It is available to both SCBA users",
            "C": "It is depleted faster",
            "D": "It is reserved for emergency use only"
          }
        },
        {
          "id": "sfd_basic_skills_50_ca527f4a",
          "question": "What is the primary function of the 'Buddy Breathing' system?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The primary function of the 'Buddy Breathing' system is to allow users to share air on the low-pressure side of the PRA.",
          "options": {
            "A": "To provide a backup air supply",
            "B": "To allow users to share air",
            "C": "To refill air cylinders",
            "D": "To filter air"
          }
        },
        {
          "id": "sfd_basic_skills_50_48588a13",
          "question": "What is the main safety consideration when using the 'Buddy Breathing' system?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The main safety consideration when using the 'Buddy Breathing' system is that users must stay connected to share air.",
          "options": {
            "A": "Users must stay connected to share air",
            "B": "Users must disconnect after a certain time",
            "C": "Users must monitor their own air supply",
            "D": "Users must use the system only in non-emergency situations"
          }
        },
        {
          "id": "sfd_basic_skills_46_67461c35",
          "question": "What is the correct procedure to change the batteries of the Remote Pressure Gauge?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The correct procedure to change the batteries of the Remote Pressure Gauge is to ensure that the cylinder valve is off and the PASS alarm is completely inactive. This is to prevent any damage to the electronic components.",
          "options": {
            "A": "Remove the batteries while the system is pressurized",
            "B": "Replace the batteries without ensuring a watertight seal",
            "C": "Change the batteries with the PASS alarm active",
            "D": "Ensure the cylinder valve is off and the PASS alarm is inactive before changing batteries"
          }
        },
        {
          "id": "sfd_basic_skills_46_24a6845d",
          "question": "What is the function of the YELLOW button on the Remote Pressure Gauge?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The YELLOW button on the Remote Pressure Gauge is used to reset the PASS in pre-alarm by clicking the button once. If the PASS is in full alarm, pressing the YELLOW button twice will reset the system. The YELLOW button is also used to shut off the integrated PASS after doffing and bleeding all air from the system.",
          "options": {
            "A": "To activate the PASS into full alarm mode",
            "B": "To reset the PASS in pre-alarm and to shut off the integrated PASS",
            "C": "To activate the Heads-Up Display",
            "D": "To turn on the LED indicator lights"
          }
        },
        {
          "id": "sfd_basic_skills_46_ee81b8e7",
          "question": "What happens when no motion is detected in 20 seconds?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If no motion is detected in 20 seconds, a pre-alarm consisting of ascending/descending tones is heard from the sensor module on the back frame.",
          "options": {
            "A": "The system will chirp 3 times",
            "B": "The system will go into full alarm mode",
            "C": "A pre-alarm consisting of ascending/descending tones is heard from the sensor module",
            "D": "The YELLOW button will automatically reset the system"
          }
        },
        {
          "id": "sfd_basic_skills_46_647acca5",
          "question": "What is the function of the RED button on the Remote Pressure Gauge?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Pressing the RED button on the Remote Pressure Gauge will place the PASS into full alarm mode. This can be done with or without air in the system.",
          "options": {
            "A": "To reset the PASS in pre-alarm",
            "B": "To shut off the integrated PASS",
            "C": "To place the PASS into full alarm mode",
            "D": "To activate the Heads-Up Display"
          }
        },
        {
          "id": "sfd_basic_skills_46_1d330d40",
          "question": "What is the purpose of the 1/3-cylinder End of Service Time Indicator (ESOTI)?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 1/3-cylinder End of Service Time Indicator (ESOTI) is designed to provide a warning when the remaining air in the system is approximately one third of the cylinder's rated capacity.",
          "options": {
            "A": "To indicate the remaining battery life",
            "B": "To indicate the remaining air in the system",
            "C": "To indicate the activation of the PASS alarm",
            "D": "To indicate the pressure in the cylinder"
          }
        },
        {
          "id": "sfd_basic_skills_53_1b1469f2",
          "question": "What is the role of the Pressure Reducing Assembly (PRA) in the operation of the SCBA?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Under normal operation, the PRA reduces SCBA cylinder pressure to 125 psig.",
          "options": {
            "A": "It increases the SCBA cylinder pressure to 125 psig",
            "B": "It reduces the SCBA cylinder pressure to 125 psig",
            "C": "It maintains the SCBA cylinder pressure at a constant level",
            "D": "It has no effect on the SCBA cylinder pressure"
          }
        },
        {
          "id": "sfd_basic_skills_53_d9703bb1",
          "question": "What happens when the SCBA cylinder pressure drops to approximately 1833 psig?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When cylinder pressure drops to ~1833 psig (\u2153 capacity), the PRA switches air flow to a secondary pathway.",
          "options": {
            "A": "The PRA switches air flow to a secondary pathway",
            "B": "The Vibralert alarm is triggered",
            "C": "The Emergency Breathing Support System is activated",
            "D": "The SCBA is considered to be in alarm"
          }
        },
        {
          "id": "sfd_basic_skills_53_35d0a76e",
          "question": "What is the significance of the Vibralert alarm during 'Buddy Breathing' operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "An alarming Vibralert is a very important indicator during 'Buddy Breathing' operations. Air exiting the Emergency Breathing Support System connection from an SCBA in alarm does so at a higher pressure.",
          "options": {
            "A": "It indicates that the SCBA is in alarm",
            "B": "It signals that the SCBA cylinder pressure is too low",
            "C": "It shows that air is exiting the Emergency Breathing Support System at a higher pressure",
            "D": "It suggests that the SCBA is operating at a pressure above 1/3"
          }
        },
        {
          "id": "sfd_basic_skills_53_3452b671",
          "question": "What happens when two SCBA are operating at the same pressure during 'Buddy Breathing' operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When both SCBA are operating at the same pressure (both above 1/3 or both in alarm), the cylinders will be consumed at more or less the same rate.",
          "options": {
            "A": "The cylinders will be consumed at more or less the same rate",
            "B": "The 'low' member's cylinder will be consumed first",
            "C": "Both Vibralerts will sound",
            "D": "The 'full' SCBA will overcome the lower pressure from the 'low' SCBA"
          }
        },
        {
          "id": "sfd_basic_skills_53_f9c2c30d",
          "question": "What should be done first when terminating the Emergency Breathing Support System function after exiting the IDLH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When both users have exited the IDLH, Emergency Breathing Support System function can be terminated. The first step is to remove the facepiece and regulator from the user requiring support.",
          "options": {
            "A": "Separate the regulator or manifolds from each other",
            "B": "Remove the facepiece and regulator from the user requiring support",
            "C": "Replace the dust caps on the Emergency Breathing Support System manifolds",
            "D": "Coil the hose neatly and return to the carry pouch"
          }
        },
        {
          "id": "sfd_basic_skills_45_4f1a21c8",
          "question": "What is the purpose of the Voicemitters on the Scott AV3000 HT facepiece?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Voicemitters are a mechanical voice amplification system that increases the clarity of communication between users.",
          "options": {
            "A": "To provide a mounting bracket for the SCOTT Epic 3 voice amplifier",
            "B": "To increase the clarity of communication between users",
            "C": "To maintain positive pressure when exposed to high heat and flame loads",
            "D": "To provide a reduced profile to eliminate bunching and discomfort under helmets"
          }
        },
        {
          "id": "sfd_basic_skills_45_9d8a064f",
          "question": "What is the most effective technique for communicating into a portable radio with the Scott AV3000 HT facepiece?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The most effective technique for communicating into a portable radio is to place the remote microphone directly over either of the Voicemitters.",
          "options": {
            "A": "Speaking loudly into the radio",
            "B": "Using the SCOTT Epic 3 voice amplifier",
            "C": "Placing the remote microphone directly over either of the Voicemitters",
            "D": "Using sign language"
          }
        },
        {
          "id": "sfd_basic_skills_45_dc8c01ab",
          "question": "What is the function of the Pak-Alert SE7 device?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Pak-Alert SE7 is an integrated PASS device that meets NFPA 1982, 2013 edition requirements.",
          "options": {
            "A": "It is a battery-powered voice amplification device",
            "B": "It is a mechanical voice amplification system",
            "C": "It is a device for maintaining positive pressure when exposed to high heat and flame loads",
            "D": "It is an integrated PASS device that meets NFPA 1982, 2013 edition requirements"
          }
        },
        {
          "id": "sfd_basic_skills_45_81430288",
          "question": "What is the benefit of the Kevlar harness in the Scott AV3000 HT facepiece?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Kevlar harness has a reduced profile to eliminate bunching and discomfort under helmets.",
          "options": {
            "A": "It increases the clarity of communication between users",
            "B": "It eliminates bunching and discomfort under helmets",
            "C": "It provides a mounting bracket for the SCOTT Epic 3 voice amplifier",
            "D": "It is a battery-powered voice amplification device"
          }
        },
        {
          "id": "sfd_basic_skills_45_4010d6b2",
          "question": "What is the significance of the bracket on the right side of the Scott AV3000 HT facepiece?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Voicemitter cover on the right side of the facepiece incorporates a mounting bracket for the SCOTT Epic 3 voice amplifier.",
          "options": {
            "A": "It is used to mount the Voicemitters",
            "B": "It is used to mount the SCOTT Epic 3 voice amplifier",
            "C": "It is used to mount the Pak-Alert SE7 device",
            "D": "It is used to mount the Kevlar harness"
          }
        },
        {
          "id": "sfd_basic_skills_49_f8fb7610",
          "question": "What is the purpose of the Dual Emergency Breathing Support System in the Scott Air-Pak X3\u00ae?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Dual Emergency Breathing Support System, also known as 'Buddy Breathing', allows two firefighters to breathe from the same air supply.",
          "options": {
            "A": "To provide additional oxygen to the firefighter",
            "B": "To allow two firefighters to breathe from the same air supply",
            "C": "To reduce the pressure of the SCBA",
            "D": "To store extra equipment"
          }
        },
        {
          "id": "sfd_basic_skills_49_c0fdd10f",
          "question": "Where is the Dual Emergency Breathing Support System stored when not in use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Dual Emergency Breathing Support System is stored in a pouch on the right side of the waist pad when not in use.",
          "options": {
            "A": "In a pouch on the left side of the waist pad",
            "B": "In a pouch on the right side of the waist pad",
            "C": "In a pouch on the back of the SCBA",
            "D": "In a pouch on the front of the SCBA"
          }
        },
        {
          "id": "sfd_basic_skills_49_fd1ed1bc",
          "question": "To which part of the SCBA is one end of the Dual Emergency Breathing Support System permanently connected?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "One end of the Dual Emergency Breathing Support System is permanently connected to the low-pressure side of the SCBA's Pressure Reducing Assembly (PRA).",
          "options": {
            "A": "The high-pressure side of the SCBA's Pressure Reducing Assembly (PRA)",
            "B": "The medium-pressure side of the SCBA's Pressure Reducing Assembly (PRA)",
            "C": "The low-pressure side of the SCBA's Pressure Reducing Assembly (PRA)",
            "D": "The SCBA's oxygen tank"
          }
        },
        {
          "id": "sfd_basic_skills_49_6d1539b6",
          "question": "What type of couplings does the other end of the Dual Emergency Breathing Support System have?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The other end of the Dual Emergency Breathing Support System is fitted with both male and female quick disconnect couplings.",
          "options": {
            "A": "Male only quick disconnect couplings",
            "B": "Female only quick disconnect couplings",
            "C": "Both male and female quick disconnect couplings",
            "D": "No couplings"
          }
        },
        {
          "id": "sfd_basic_skills_49_4bed11b1",
          "question": "What is the potential safety implication of using the Dual Emergency Breathing Support System?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Dual Emergency Breathing Support System, or 'Buddy Breathing', can allow two firefighters to share air supply in an emergency, potentially saving lives.",
          "options": {
            "A": "It can cause the SCBA to overheat",
            "B": "It can allow two firefighters to share air supply in an emergency, potentially saving lives",
            "C": "It can cause the SCBA to malfunction",
            "D": "It can increase the weight of the SCBA"
          }
        },
        {
          "id": "sfd_basic_skills_48_587eef91",
          "question": "What does the Heads-Up Display in the Seattle Fire Department's equipment represent?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Heads-Up Display provides a visual monitor of the air supply in the cylinder and valve assembly.",
          "options": {
            "A": "The temperature inside the fire",
            "B": "The amount of water left in the hose",
            "C": "The air supply in the cylinder and valve assembly",
            "D": "The distance to the nearest fire hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_48_a2ba036a",
          "question": "What should a firefighter do if the Heads-Up Display lights do not operate as described?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the lights do not operate as described, the respirator should be removed from service and sent in for repair.",
          "options": {
            "A": "Continue using the respirator",
            "B": "Try to fix the lights themselves",
            "C": "Remove the respirator from service and send in for repair",
            "D": "Ignore the issue as it is not critical"
          }
        },
        {
          "id": "sfd_basic_skills_48_aa4a13d7",
          "question": "What does the integrated Pak-Alert alarm do to the Heads-Up Display lights?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The integrated Pak-Alert alarm will cause the Heads-Up Display lights to flash in an alternating pattern when in pre-alarm.",
          "options": {
            "A": "Turns them off",
            "B": "Causes them to flash in an alternating pattern",
            "C": "Changes their color to red",
            "D": "Makes them brighter"
          }
        },
        {
          "id": "sfd_basic_skills_48_601f3a9d",
          "question": "What does the LOW BATTERY indicator on the Heads-Up Display mean for the operation of the equipment?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the LOW BATTERY indicator activates, there is still sufficient power to operate the Heads-Up Display for the duration of the cylinder.",
          "options": {
            "A": "The equipment should be immediately turned off",
            "B": "There is still sufficient power to operate the Heads-Up Display for the duration of the cylinder",
            "C": "The equipment is completely out of power",
            "D": "The equipment is malfunctioning"
          }
        },
        {
          "id": "sfd_basic_skills_48_e1e6d14c",
          "question": "What does the Heads-Up Display do in low light situations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Heads-Up Display has an automatic brightness control that dims the display in low light situations.",
          "options": {
            "A": "Turns off completely",
            "B": "Flashes rapidly",
            "C": "Dims the display",
            "D": "Increases the brightness"
          }
        },
        {
          "id": "sfd_basic_skills_44_34c72342",
          "question": "What is the correct method to carry SCBA cylinders according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The body of the valve assembly should be used to pick up, carry, and set down the cylinders. This is to prevent damage to the valve handle.",
          "options": {
            "A": "By the valve handle",
            "B": "By the body of the valve assembly",
            "C": "By the threaded connection",
            "D": "By the hand wheel"
          }
        },
        {
          "id": "sfd_basic_skills_44_4b6dbff9",
          "question": "What is the function of the one-way valve in the cylinder valve assembly?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The one-way valve in the cylinder valve assembly allows air to enter the cylinder, but not escape. This is crucial for maintaining pressure within the cylinder.",
          "options": {
            "A": "Allows air to escape the cylinder",
            "B": "Allows air to enter and escape the cylinder",
            "C": "Allows air to enter the cylinder but not escape",
            "D": "Blocks air from entering or escaping the cylinder"
          }
        },
        {
          "id": "sfd_basic_skills_44_4103d293",
          "question": "What is the purpose of the E-Z Flo+ Facepiece Mounted Regulator's design?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The design of the E-Z Flo+ Facepiece Mounted Regulator allows for easy inhalation/exhalation, separates inhaled air from exhaled air to limit cross contamination, and allows for easy cleaning.",
          "options": {
            "A": "To allow for easy cleaning",
            "B": "To separate inhaled air from exhaled air",
            "C": "To allow for easy inhalation/exhalation",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_44_aac71e2c",
          "question": "What happens when the hand wheel is opened during filling of the SCBA cylinder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Opening the hand wheel during filling will cause air to discharge through the Snap-Change nipple. This is not a desired operation during filling.",
          "options": {
            "A": "Air enters the cylinder",
            "B": "Air discharges through the Snap-Change nipple",
            "C": "The cylinder becomes unusable",
            "D": "Nothing, it's a normal part of the process"
          }
        },
        {
          "id": "sfd_basic_skills_44_a989b2ff",
          "question": "What is the function of the spray bar in the Facepiece Mounted Regulator?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon inhalation, the air enters the facepiece through 9 small holes on top of the Facepiece Mounted Regulator, also known as the spray bar. The air flows across the facepiece lens, cooling and removing any condensation that is built up.",
          "options": {
            "A": "It allows the user to spray water",
            "B": "It directs the air across the facepiece lens, cooling and removing any condensation",
            "C": "It helps the user to breathe more easily",
            "D": "It separates the inhaled air from the exhaled air"
          }
        },
        {
          "id": "sfd_basic_skills_52_2c641460",
          "question": "What is the implication of damage to the hose when it is connected and in use by two persons for emergency breathing support?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that if damage occurs when the hose is connected and in use by two persons for emergency breathing support, the air loss will be from both cylinders.",
          "options": {
            "A": "Air loss will be from one cylinder only",
            "B": "Air loss will not affect the cylinders",
            "C": "Air loss will be from both cylinders",
            "D": "Air loss will cause the hose to disconnect"
          }
        },
        {
          "id": "sfd_basic_skills_52_7889b2fe",
          "question": "Why is it important for one user to always maintain control of the connected manifolds?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text mentions that good practice dictates that one user always maintain control of the connected manifolds, especially when performing any Fire Ground Survival techniques.",
          "options": {
            "A": "To prevent the hose from tangling",
            "B": "To ensure proper air flow",
            "C": "To avoid complete air loss",
            "D": "To ensure safety when performing any Fire Ground Survival techniques"
          }
        },
        {
          "id": "sfd_basic_skills_52_71a0b5de",
          "question": "What is the first step in the procedures for using the Emergency Breathing Support System?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, the first step in the procedures for using the Emergency Breathing Support System is to declare a Mayday and plan your escape route.",
          "options": {
            "A": "Open the snaps on the pouch and extend the hose",
            "B": "Declare a Mayday and plan your escape route",
            "C": "Determine whether there is sufficient air remaining in the donating member\u2019s cylinder",
            "D": "Remove the dust cap from the manifold"
          }
        },
        {
          "id": "sfd_basic_skills_52_f7325329",
          "question": "What is the implication of not having a matching Emergency Breathing Support System connection?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text states that if the person requiring support does not have a matching Emergency Breathing Support System connection, they must hold their breath and separate the QD on the regulator hose and connect it to the female side of the manifold.",
          "options": {
            "A": "The person requiring support can connect to the female side of the manifold",
            "B": "The person requiring support cannot be connected to the system",
            "C": "The person requiring support can connect to the male side of the manifold",
            "D": "The person requiring support must hold their breath and separate the QD on the regulator hose and connect it to the female side of the manifold"
          }
        },
        {
          "id": "sfd_basic_skills_52_7d8a5ac0",
          "question": "What is required when operating with mutual aid companies?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that when operating with mutual aid companies, the person requiring support must have either a regulator hose with a male quick disconnect or a matching Emergency Breathing Support System hose. The person giving support must have the Emergency Breathing Support System on their SCBA.",
          "options": {
            "A": "The person requiring support must have a matching Emergency Breathing Support System hose",
            "B": "The person giving support must have the Emergency Breathing Support System on their SCBA",
            "C": "Both A and B",
            "D": "Neither A nor B"
          }
        },
        {
          "id": "sfd_basic_skills_43_f39f8bbe",
          "question": "What happens when the primary air path of the Pressure Reducing Assembly (PRA) becomes blocked or fails?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, if the primary air path of the PRA becomes blocked or fails, the secondary air path will automatically begin supplying air to the Facepiece Mounted Regulator and the Vibralert alarm will be actuated to warn the user of malfunction.",
          "options": {
            "A": "The secondary air path will automatically begin supplying air and the Vibralert alarm will be actuated",
            "B": "The PRA will stop functioning completely",
            "C": "The primary air path will automatically repair itself",
            "D": "The SCBA will explode"
          }
        },
        {
          "id": "sfd_basic_skills_43_8e87e5e7",
          "question": "What is the significance of the 'Snap-Change' cylinder connection in the PRA?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'Snap-Change' cylinder connection is a proprietary feature of SCOTT that allows for quick and secure attachment of an air cylinder. The user must ensure both Snap-Change locks 'click' into place.",
          "options": {
            "A": "It allows for quick and secure attachment of an air cylinder",
            "B": "It changes the pressure in the cylinder",
            "C": "It allows the cylinder to be released while the system is pressurized",
            "D": "It triggers the Vibralert alarm"
          }
        },
        {
          "id": "sfd_basic_skills_43_ae1fbabe",
          "question": "What is the purpose of the ratcheting style closing mechanism in the cylinder valve?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ratcheting style closing mechanism in the cylinder valve is designed to limit the possibility of accidentally closing the cylinder valve once open.",
          "options": {
            "A": "To increase the pressure in the cylinder",
            "B": "To limit the possibility of accidentally closing the cylinder valve once open",
            "C": "To trigger the Vibralert alarm",
            "D": "To allow the cylinder to be released while the system is pressurized"
          }
        },
        {
          "id": "sfd_basic_skills_43_a8c3b840",
          "question": "What should be done if the Vibralert alarm is actuated due to a malfunction in the PRA?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the Vibralert alarm is actuated due to a malfunction in the PRA, the SCBA should be placed out of service and sent in for repair.",
          "options": {
            "A": "The SCBA should be immediately used for firefighting operations",
            "B": "The SCBA should be placed out of service and sent in for repair",
            "C": "The SCBA should be discarded",
            "D": "The SCBA should be used until the cylinder is empty"
          }
        },
        {
          "id": "sfd_basic_skills_43_78f0633e",
          "question": "What is the significance of the 5500 psig design in the standard cylinder used in the SCBA?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 5500 psig design in the standard cylinder used in the SCBA allows up to 11% reduction in cylinder weight and 8% reduction in cylinder diameter.",
          "options": {
            "A": "It increases the service life of the cylinder",
            "B": "It allows up to 11% reduction in cylinder weight and 8% reduction in cylinder diameter",
            "C": "It triggers the Vibralert alarm",
            "D": "It allows the cylinder to be released while the system is pressurized"
          }
        },
        {
          "id": "sfd_basic_skills_42_806dc8b8",
          "question": "What is the purpose of the SCOTT Air-Pak X3\u00ae Snap-Change Self-Contained Breathing Apparatus (SCBA)?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The SCOTT Air-Pak X3\u00ae Snap-Change Self-Contained Breathing Apparatus (SCBA) is designed to provide respiratory protection in environments that are objectionable, oxygen deficient, and/or unbreathable.",
          "options": {
            "A": "To provide respiratory protection in an objectionable, oxygen deficient, and/or unbreathable atmosphere",
            "B": "To provide vision enhancement in low visibility environments",
            "C": "To provide thermal protection in high temperature environments",
            "D": "To provide communication capabilities in noisy environments"
          }
        },
        {
          "id": "sfd_basic_skills_42_4443e3e0",
          "question": "What is the function of the waist strap buckle of the SCOTT Air-Pak X3\u00ae Snap-Change Self-Contained Breathing Apparatus (SCBA)?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The waist strap buckle is designed to secure the SCBA to the firefighter's waist. It can only be connected one way, so care must be taken to avoid twists in the straps.",
          "options": {
            "A": "To connect the SCBA to the firefighter's helmet",
            "B": "To secure the SCBA to the firefighter's waist",
            "C": "To attach additional equipment to the SCBA",
            "D": "To adjust the length of the SCBA's air hose"
          }
        },
        {
          "id": "sfd_basic_skills_42_12384b91",
          "question": "What is the function of the Dual Emergency Breathing Support System \u201cBuddy Breathing\u201d hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Dual Emergency Breathing Support System \u201cBuddy Breathing\u201d hose allows two firefighters to share a single air supply.",
          "options": {
            "A": "To allow two firefighters to share a single air supply",
            "B": "To provide a backup air supply in case the primary supply fails",
            "C": "To allow the firefighter to connect to an external air supply",
            "D": "To allow the firefighter to manually control the flow of air"
          }
        },
        {
          "id": "sfd_basic_skills_42_b2551d78",
          "question": "What is the purpose of the Kevlar cylinder retention band and latch assembly in the back frame of the SCOTT Air-Pak X3\u00ae Snap-Change Self-Contained Breathing Apparatus (SCBA)?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Kevlar cylinder retention band and latch assembly is designed to secure the air cylinder to the back frame of the SCBA.",
          "options": {
            "A": "To secure the air cylinder to the back frame",
            "B": "To provide a handle for carrying the SCBA",
            "C": "To connect the SCBA to the firefighter's helmet",
            "D": "To attach additional equipment to the SCBA"
          }
        },
        {
          "id": "sfd_basic_skills_42_6095d539",
          "question": "What is the function of the Pak-Alert SE7 (Integrated PASS Device) in the SCOTT Air-Pak X3\u00ae Snap-Change Self-Contained Breathing Apparatus (SCBA)?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Pak-Alert SE7 (Integrated PASS Device) is designed to alert others if the firefighter becomes immobile.",
          "options": {
            "A": "To provide a backup air supply in case the primary supply fails",
            "B": "To alert others if the firefighter becomes immobile",
            "C": "To allow the firefighter to connect to an external air supply",
            "D": "To provide communication capabilities in noisy environments"
          }
        }
      ]
    },
    "3": {
      "chapter_id": "3",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_103_c50a6d73",
          "question": "The last member ties the hose to the rung of the ladder above the landing using a clove hitch around the rung.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The last member ties the hose to the rung of the ladder above the landing, using a clove hitch around the rung.' This is important for securing the hose and ensuring it doesn't fall or move unexpectedly, which could cause safety issues during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_103_68d939a6",
          "question": "After the hose in the building is shoulder-loaded, the member immediately starts firefighting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'After the hose in the building is shoulder-loaded and carried to the window (or to the fire escape opening), the body loop is released from the ladder and the member climbs down the ladder.' This contradicts the statement as the member does not immediately start firefighting but first descends the ladder. This is a crucial step in ensuring safety and proper positioning for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_103_c0f57136",
          "question": "The member at the top lays the shoulder-load on the floor next to the opening and feeds one section to the member on the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member at the top then lays the shoulder-load on the floor next to the opening and feeds one section to the member on the ground.' This is important for ensuring that the hose is properly extended and ready for use in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_103_46255705",
          "question": "The last member secures a body loop to the nozzle behind the shut off or places the nozzle over the shoulder with the lead across the chest before climbing up.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The last member then secures a body loop to the nozzle behind the shut off or places the nozzle over the shoulder with the lead across the chest. He then climbs down.' This contradicts the statement as the member secures the nozzle and then climbs down, not up. This is a crucial step in ensuring safety and proper positioning for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_103_9833f0c9",
          "question": "The member breaks the hose at the first coupling on the ground after climbing down the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member then breaks the hose at the first coupling on the ground.' This is important for ensuring that the hose is ready for use and properly extended for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_98_bc64acce",
          "question": "The shoulder-loads of hose should be placed on the ground near the left beam of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Begin by placing the shoulder-loads of hose on the ground near the right beam of the ladder.' This contradicts the question statement. Correct placement of equipment is crucial for efficient firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_98_59acd47a",
          "question": "The first member should place the nozzle over the left shoulder with the hose crossing the front of the body to the right side.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The first member grasps the nozzle and, facing the ladder, places the nozzle over the left shoulder with the hose crossing the front of the body to the right side.' This supports the question statement. Proper handling of the hose is important for firefighter safety and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_98_186080ed",
          "question": "The member secures a body loop to the hose using a hose knot at about waist height.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member then secures a body loop to the hose, using a hose knot at about knee height.' This contradicts the question statement. Correct knot placement can affect the balance and control of the hose, impacting firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_98_dd99cf36",
          "question": "The member places the other end of the body loop over the right shoulder and immediately begins to climb.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member places the other end of the body loop over the right shoulder and immediately begins to climb.' This supports the question statement. Quick and correct actions are vital in firefighting operations to ensure safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_98_d184b5ca",
          "question": "The nozzle should be placed far from the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The nozzle will be next to the ladder.' This contradicts the question statement. Proper positioning of the nozzle is crucial for efficient hose deployment and firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_77_24485e34",
          "question": "A firefighter can only shoulder load a hose bundle on their right shoulder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"The firefighter shoulder-loads the nozzle bundle on their right shoulder as previously discussed, then... shoulder-loads the second section on the left shoulder.\" This statement contradicts the question as it clearly states that a firefighter can shoulder load hose bundles on both shoulders. This is important as it allows firefighters to carry more equipment, potentially reaching the fire more quickly.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_77_8f0fa91b",
          "question": "If a second firefighter is not readily available, firefighters may shoulder load a second bundle on the left shoulder or drag an additional 100' of hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"If a second firefighter is not readily available or if additional hose is required to reach the objective, firefighters may shoulder load a second bundle on the left shoulder or drag an additional 100' of hose.\" This statement supports the question. This tactic can be crucial in situations where manpower is limited or the fire is far from the engine.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_77_68a16e55",
          "question": "Firefighters should release bundle ties before they start advancing toward the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"Firefighters advance toward the objective, releasing bundle ties as the prior section plays out.\" This statement contradicts the question as it specifies that firefighters should release the bundle ties as they advance, not before. This ensures that the hose does not become entangled or unmanageable during advancement.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_77_0b55a798",
          "question": "The second bundle is completely removed from the apparatus before the firefighter steps away.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"...stepping away from apparatus with a bundle on each shoulder until the second bundle is completely removed from the apparatus.\" This statement supports the question. This procedure ensures that the hose is properly deployed and prevents potential tripping hazards near the apparatus.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_77_e38934c7",
          "question": "The firefighter should pull out the entire next bundle before shoulder-loading the second section.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"...grasps the bottom of the next bundle, pulls out approximately one third way, and shoulder-loads the second section on the left shoulder.\" This statement contradicts the question as it specifies that the firefighter should pull out approximately one third of the next bundle before shoulder-loading it. This is important for managing the weight and balance of the hose during transport.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_61_4b75555e",
          "question": "The hose should be rolled with turns and twists for storage.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The single and double rolls are to be done with the hose stretched straight, without turns or twists, and laid flat on the ground.' This contradicts the statement, indicating that the hose should be rolled straight and without twists for storage. This is important for firefighting operations as improperly stored hoses can lead to operational difficulties and safety risks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_61_1bbeee72",
          "question": "Hose rolling is usually a two-person operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hose rolling is usually a one-person operation.' This contradicts the statement, indicating that hose rolling is typically done by one person. However, it also mentions that a second person can expedite the process. Understanding this can help in efficient resource allocation during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_61_472f0841",
          "question": "The hose must be cleaned and thoroughly dried before single rolling the hose and placing into storage.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Hose must be cleaned and thoroughly dried before single rolling the hose and placing into storage.' This supports the statement, emphasizing the importance of cleaning and drying the hose before storage. This is crucial for maintaining the longevity and functionality of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_61_86916407",
          "question": "The hose is rolled from the female coupling to the male coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Facing the open end of the male coupling, grasp the coupling with both hands and roll it away from the body and tightly into the hose.' This contradicts the statement, indicating that the hose is rolled starting from the male coupling. Understanding this is important for correct hose management during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_61_e3771e48",
          "question": "The hose is rolled to facilitate water drainage.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Hose rolling is usually a one-person operation and best performed from the highest grade of land to the lowest to facilitate water drainage.' This supports the statement, indicating that one of the reasons for rolling the hose is to facilitate water drainage. This is important for maintaining the functionality of the hose and preventing water-related damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_57_d9931104",
          "question": "Aeration is a process by which air is introduced into a liquid, either by bubbling the air through it or by spraying the liquid into the air at normal pressures. This process is crucial in firefighting operations, true or false?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'AERATION - A process by which air is introduced into a liquid, either by bubbling the air through it or by spraying the liquid into the air at normal pressures.' Aeration is a key process in firefighting, as it aids in the creation of foam which is used to smother fires and prevent re-ignition.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_57_73d81d47",
          "question": "The term 'brass' in firefighting refers only to hose couplings made of a copper-zinc alloy, true or false?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'BRASS - A copper-zinc alloy. Also, a term used to describe hose couplings, whether or not they are made of brass or the lighter and stronger composite material, pyrolite.' Therefore, the term 'brass' does not only refer to hose couplings made of a copper-zinc alloy, but also those made of other materials like pyrolite.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_57_de724a52",
          "question": "A body loop is a one-inch piece of nylon sewn into a 51-inch continuous loop with all safe working loads computed at a 5:1 design failure. The vertical weight load limit is 300 pounds, choke weight load limit is 225 pounds and basket weight load limit is 600 pounds. This equipment is essential for rescue operations, true or false?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'BODY LOOP - A one-inch piece of nylon sewn into a 51-inch continuous loop with all safe working loads computed at a 5:1 design failure. The vertical weight load limit is 300 pounds, choke weight load limit is 225 pounds and basket weight load limit is 600 pounds.' This equipment is crucial for rescue operations, as it allows firefighters to safely lift and move individuals during rescue scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_57_c9286c31",
          "question": "The term 'appliance' in firefighting refers to any variety of tools or devices carried on an engine that connect hoses or stream devices together. These appliances are not vital in firefighting operations, true or false?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'APPLIANCE - Any variety of tools or devices carried on an engine that connect hoses or stream devices together.' These appliances are essential in firefighting operations as they enable the connection of hoses and stream devices, facilitating the delivery of water or other firefighting agents to the fire scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_57_c29cd532",
          "question": "A centrifugal pump is a pump with one or more impellers that utilizes centrifugal force to move the water. Most modern fire pumps are not of this type, true or false?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'CENTRIFUGAL PUMP - Pump with one or more impellers that utilizes centrifugal force to move the water. Most modern fire pumps are of this type.' Therefore, most modern fire pumps are indeed of the centrifugal type, which is crucial for efficient water delivery during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_94_d81720b4",
          "question": "A coiled hose can be easily deployed to a desired location in high-rise situations or where numerous obstacles are present.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A coil will allow the nozzle (and subsequent hose) to \u201cpay off\u201d the top of the bundle and easily be deployed to a desired location.' This supports the statement that a coiled hose can be easily deployed in complex situations, which is crucial for efficient firefighting operations in high-rise buildings or areas with many obstacles.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_94_b5a614f7",
          "question": "Stairwells and tight hallways cannot make good use of the coiling hose technique.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Stairwells and tight hallways will make good use of this technique.' This contradicts the statement, indicating that the coiling hose technique is indeed beneficial in confined spaces like stairwells and tight hallways, which are common in firefighting scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_94_3b698a98",
          "question": "A firefighter cannot carry a charged coil on their shoulder until stretching is required.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Coils will also allow the firefighter to carry a charged coil on their shoulder for a period, until stretching is required.' This contradicts the statement, showing that carrying a charged coil on the shoulder is a viable technique until hose stretching is necessary, which can enhance mobility and readiness in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_94_939808fc",
          "question": "The excess hose should be laid down on the ground in a messy bundle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Lay the excess hose down on the ground in a neat bundle.' This contradicts the statement, emphasizing the importance of keeping the hose orderly to ensure smooth deployment and prevent entanglement during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_94_e0172d9c",
          "question": "When preparing the hose, you should kneel at the bundle and untie it, if necessary, sliding the nozzle close to your knees.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Kneel at the bundle and untie it, if necessary. Slide the nozzle close to your knees.' This supports the statement, indicating that this is the correct procedure for preparing the hose, which is important for ensuring efficient and safe hose deployment in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_82_890b3902",
          "question": "The hose should be arranged in flakes near the front of the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Begin preparing the hose for loading by arranging it in flakes near the rear of the engine.' This contradicts the question statement, which suggests the hose should be arranged near the front. Proper hose placement is crucial for efficient deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_82_5367cb38",
          "question": "The first male coupling should hang 4\" past the end of the bed at the far-right side of the open end of the 2 \u00bd\u201d hose bed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the first male coupling hanging 4\" past the end of the bed at the far-right side of the open end of the 2 \u00bd\u201d hose bed.' This supports the question statement. Proper placement of couplings is crucial for effective hose deployment and connection during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_82_5da13a35",
          "question": "Coupling connections should be made while arranging the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not make any coupling connections at this time.' This contradicts the question statement, which suggests that coupling connections should be made while arranging the hose. Following the correct procedure for hose arrangement and coupling connections is important to prevent entanglements and ensure efficient hose deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_82_a74eb87d",
          "question": "The first female coupling should be left at the top of the stack flush with the bights at the open end.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Leave the first female coupling at the top of the stack flush with the bights at the open end.' This supports the question statement. Proper placement of couplings is crucial for effective hose deployment and connection during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_82_d66c798d",
          "question": "The hose should be passed, flat, toward the open end of the compartment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hold the coupling in place and pass the hose, flat, toward the closed end of the compartment.' This contradicts the question statement, which suggests that the hose should be passed toward the open end of the compartment. Proper hose management is crucial for efficient deployment and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_83_69545246",
          "question": "The male end of the hose should be placed at the bottom of the second vertical stack.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Take the next 100' of hose and place the male at the bottom.' This indicates that the male end of the hose should be positioned at the bottom of the stack, which is important for proper hose connection and operation during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_83_5f3fdefa",
          "question": "All bundles should be tied about 18\" back from the bights with the top flake left free.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'All bundles should be tied about 18\" back from the bights with the top flake left free.' This is crucial for preventing twists in the hose and ensuring efficient deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_83_6cd95760",
          "question": "The nozzle should be attached to the top of the last section of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach a nozzle to the last section of hose. Place the nozzle on the bottom of the hose bed.' This contradicts the statement that the nozzle should be attached to the top of the hose. The placement of the nozzle is important for proper hose deployment and operation during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_83_aed6a042",
          "question": "Some fire apparatus have a hose bed configuration that supports five vertical stacks of hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Some fire apparatus have a hose bed configuration that will not support five vertical stacks of hose.' This contradicts the statement that some fire apparatus can support five vertical stacks. Understanding the capacity of the hose bed configuration is crucial for effective hose management during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_83_06e0883f",
          "question": "The 'Plan B' Bulk load consists of a flat load for the bottom 200' of 2 1/2\" hose with three vertical stacks of 100'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'These apparatus will use a \"Plan B\" Bulk load consisting of a flat load for the bottom 200' of 2 1/2\" hose with three vertical stacks of 100'.' This confirms the statement and highlights the need for alternative hose loading strategies in apparatus with different hose bed configurations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_95_a002b4bc",
          "question": "When gathering the hose, every flake should be picked up.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When every other flake has been gathered, lift and separate them from the rest of the bundle.' This indicates that not every flake is gathered initially. This is important for firefighters to understand as it affects how the hose is prepared and deployed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_95_f354c2c6",
          "question": "The nozzle end of the hose should be coming off the top of the coil.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The nozzle end of the hose must be coming off the top of the coil.' This is a crucial aspect of hose management and deployment, as it ensures that the hose can be quickly and effectively used when needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_95_ff2fb496",
          "question": "The hose gathered in your arms should be placed behind the rest of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the hose gathered in your arms away and to the front of the rest of the hose to create a coil.' This contradicts the statement that the hose should be placed behind the rest of the hose. Proper placement of the hose can affect the speed and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_95_ae520029",
          "question": "After creating a coil, the line should be charged.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Charge the line.' This indicates that after the hose has been properly coiled, the line should be charged. This is a critical step in firefighting operations to ensure that water is ready to be deployed when needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_95_18c2b92d",
          "question": "The hose should be coiled before every other flake is gathered.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When every other flake has been gathered, lift and separate them from the rest of the bundle.' This is followed by, 'Place the hose gathered in your arms away and to the front of the rest of the hose to create a coil.' This shows that the gathering of every other flake precedes the coiling of the hose. Understanding the correct order of these steps is important for efficient and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_56_a3dc41ad",
          "question": "The mission of the Seattle Fire Department is to save lives and protect property.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Simply stated, the mission of our organization is to save lives and protect property.' This directly supports the statement in the question. The mission statement guides all firefighting operations and tactics, emphasizing the importance of safety and property protection.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_56_55978a69",
          "question": "The hose laying operation is not a visible part of the job at a fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts the statement by saying, 'The hose laying operation is often the most visible part of our job at a fire.' This means that the hose laying operation is a crucial and noticeable aspect of firefighting, which requires precision and coordination.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_56_7374c144",
          "question": "Every second does not count at a fire scene.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts the statement by saying, 'Every second counts at a fire scene.' This emphasizes the urgency and time sensitivity in firefighting operations, highlighting the need for efficiency and prompt response.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_56_cd2a4b73",
          "question": "The application of water on fire is a direct action that allows the Seattle Fire Department to meet its goals.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying, 'The application of water on fire is a direct action that allows us to meet our goals.' This underlines the importance of proper hose operations in achieving the department's mission of saving lives and protecting property.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_56_5894a939",
          "question": "The information and techniques for the loading and deployment of both supply and attack lines are not necessary for the Seattle Fire Department.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts the statement by saying, 'This section contains the information and techniques necessary for the loading and deployment of both supply and attack lines used in the Seattle Fire Department.' This emphasizes the importance of understanding and applying these techniques in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_60_d69d6a10",
          "question": "A reverse lay is a hose laid from the water source to the fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'REVERSE LAY - Hose laid from the fire to the water source.' This contradicts the question statement, which implies the hose is laid from the water source to the fire. In firefighting operations, understanding the direction of hose lay is critical for effective water supply and fire suppression.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_60_0bcf0b83",
          "question": "A Ross Dump Valve is used to mitigate any excess intake water pressure.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'ROSS DUMP VALVE - An adjustable valve plumbed into the intake side of the fire pump to mitigate any excess intake water pressure.' This supports the question statement. In firefighting operations, managing water pressure is crucial to ensure the safety and effectiveness of fire suppression efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_60_3fa40c07",
          "question": "Turning the shaper clockwise on a nozzle will result in a fog stream.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Turn clockwise for a straight stream and counter-clockwise for a fog stream.' This contradicts the question statement, which implies turning the shaper clockwise results in a fog stream. Understanding how to control water stream patterns is crucial in firefighting for effective fire suppression and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_60_74a474b1",
          "question": "A Siamese is an appliance that divides one hose line into two.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'SIAMESE - An appliance that makes two hose lines into one.' This contradicts the question statement, which implies that a Siamese divides one hose line into two. In firefighting operations, understanding how to combine hose lines is important for managing water supply and fire suppression tactics.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_60_83c67011",
          "question": "Water hammer refers to the force created by the rapid deceleration of water.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'WATER HAMMER - Force created by the rapid deceleration of water.' This supports the question statement. In firefighting, understanding the concept of water hammer is important as it can potentially damage firefighting equipment and disrupt fire suppression efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_99_bc922771",
          "question": "The second member secures a body loop to the hose at either a 50 or 100 foot interval depending on the staffing and the amount of hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The second member secures a body loop to the hose at either a 50 or 100 foot interval (depending on the staffing and the amount of hose).' This implies that the distance at which the body loop is secured can vary depending on the staffing and the amount of hose available. This is a crucial operational consideration during firefighting as it affects the efficiency of the team.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_99_b5afb1c6",
          "question": "The first member tests the floor for structural integrity by stomping the floor with his left foot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member tests the floor for structural integrity by stomping the floor with his foot.' However, it does not specify that the left foot is used. This is a crucial safety consideration as testing the floor for structural integrity can prevent potential accidents.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_99_d2837f8c",
          "question": "When the first member reaches the top of the ladder, the member steps over the hose and the sill with the left foot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the first member reaches the top of the ladder, the member steps over the hose and the sill with the right foot.' This contradicts the statement that the member steps over with the left foot. This is a tactical consideration as the way a firefighter climbs and descends can affect their safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_99_aa71f0be",
          "question": "The first member steps on the hose to counteract the weight of the line while removing the body loop from the line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The first member steps on the hose to counteract the weight of the line while removing the body loop from the line.' This supports the statement and is a crucial operational consideration as it helps maintain control of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_99_0449a091",
          "question": "The nozzle is moved from the back to the chest, and the foot is removed from the hose as the member faces the ladder and begins to shoulder-load the first section.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The nozzle is moved from the back to the chest, and the foot is removed from the hose as the member faces the ladder and begins to shoulder-load the first section.' This supports the statement and is a crucial operational consideration as it affects how the firefighter manages the equipment during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_76_0dc6146a",
          "question": "The first step in shoulder-loading a 2 1/2\" hose from the bulk bed is to grasp the rightmost bundle with the left hand just under the nozzle and the right hand on top of the bundle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Grasp the leftmost bundle (the first 100 feet tied together with the nozzle attached) with the right hand just under the nozzle and the left hand on top of the bundle.' This contradicts the statement in the question, which suggests grasping the rightmost bundle. The correct procedure is important for efficient and safe hose handling during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_76_a08457ed",
          "question": "When shoulder-loading a 2 1/2\" hose, the nozzle and front flakes should be at the belt line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Pivot toward the hose turning your back toward the hose bed and placing the bottom flake flat on the right shoulder; the nozzle and front flakes should be at the belt line.' This supports the statement in the question. Proper positioning of the hose is crucial for effective deployment and control during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_76_a839cebb",
          "question": "After pulling the bundle partially out of the slot, you should hold the bundle tightly behind the body with both hands.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hold the bundle tightly in front of the body with both hands.' This contradicts the statement in the question, which suggests holding the bundle behind the body. Holding the bundle in front of the body is important for maintaining control and balance during hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_76_8d058ee4",
          "question": "The hose should be broken immediately after it is removed from the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The hose should not be broken until it is determined that the amount removed is sufficient, until the stretch has been completed, or if the hose is to be connected to a water source separate from the engine.' This contradicts the statement in the question, which suggests breaking the hose immediately after removal. The timing of breaking the hose is important for efficient firefighting operations and ensuring a continuous water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_76_c0320bb3",
          "question": "Additional shoulder-loads, if necessary, are removed in a similar manner by other firefighters.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Additional shoulder-loads, if necessary, are removed in a similar manner by other firefighters.' This supports the statement in the question. This procedure ensures efficient and coordinated hose handling among the firefighting team.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_102_917bfd4d",
          "question": "The initial shoulder-load of hose should be placed to the left of the fire escape.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Begin by placing the initial shoulder-load of hose to the right of the fire escape.' This contradicts the statement, as the hose should be placed on the right, not the left. This is important as it affects the positioning and movement of firefighters during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_102_3ef26dba",
          "question": "The first member secures a body loop to the nozzle and begins to climb with both hands on the beams of the fire escape ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The first member secures a body loop to the nozzle... and immediately begins to climb with both hands on the beams of the fire escape ladder.' This supports the statement and is crucial for ensuring the safety and efficiency of the firefighter while climbing the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_102_02ea9002",
          "question": "Additional members attach their body loops to the hose at random intervals.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Additional members... attach their body loops to the hose at appropriate intervals.' This contradicts the statement as the intervals are not random, but appropriate, which will depend on the length of the lay and the available staffing. This is important for maintaining coordination and safety among the team.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_102_d494309d",
          "question": "After stepping onto the fire escape landing, the first member removes their body loop while stepping on the hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'After stepping onto the fire escape landing the first member steps on the hose while removing their body loop.' This supports the statement and is an important procedure to ensure the hose remains in place while the firefighter is preparing to shoulder-load.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_102_07ee63b7",
          "question": "The second member stands facing the landing with the hose to his/her right.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the second member... stands facing the landing with the hose to his/her left.' This contradicts the statement, as the hose should be to the left, not the right. This affects the way the hose is handled and loaded, impacting the efficiency and safety of operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_109_e9b36907",
          "question": "The hose and couplings in the Seattle Fire Department get their name based on the outer diameter of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hose and couplings get their name based on the inner diameter of the hose.' This contradicts the question statement, which suggests that the name is based on the outer diameter. The inner diameter of a hose affects the volume of water that can be delivered, which is a crucial factor in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_109_a6f61f5c",
          "question": "In the Seattle Fire Department, the 4\" hose refers to the outer diameter of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '4\" refers to the inner diameter of the hose.' This contradicts the question statement, which suggests that the 4\" refers to the outer diameter. Understanding the inner diameter is important for firefighters as it impacts the amount of water that can be delivered to combat a fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_109_286161d5",
          "question": "The Seattle Fire Department carries 4\", 2 1/2\", and 1 3/4\" hoses.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'In the Seattle Fire Department, we carry 4\", 2 1/2\", and 1 3/4\" hose.' This supports the question statement. The different hose sizes can be used in different situations, depending on the volume of water needed and the accessibility of the fire location.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_109_24bce548",
          "question": "The size of the hose does not affect firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hose and couplings get their name based on the inner diameter of the hose.' This contradicts the question statement, which suggests that the size of the hose does not affect firefighting operations. The size of the hose, specifically the inner diameter, affects the volume of water that can be delivered, which is a crucial factor in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_109_21a4f4e6",
          "question": "The Seattle Fire Department does not carry a hose with an inner diameter of 2 1/2\".",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In the Seattle Fire Department, we carry 4\", 2 1/2\", and 1 3/4\" hose.' This contradicts the question statement, which suggests that the Seattle Fire Department does not carry a 2 1/2\" hose. Having a variety of hose sizes allows the department to respond effectively to different fire scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_92_6c356a56",
          "question": "When stretching from a standpipe outlet with two members present, the line is stretched to the objective before making the connection to the standpipe.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The line is stretched to the objective and then a member returns to make the connection.' This indicates that the connection to the standpipe is made after the line is stretched to the objective, which can have implications for timing and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_92_cc85bfd1",
          "question": "When operating a single person 2 \u00bd\u201d line, the operator should remove his/her hands from the bale.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, 'While operating the attack line in this configuration, the operator must never remove his/her hands from the bale.' This is important for maintaining control of the line and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_92_8fd54394",
          "question": "When stretching from an engine, the pump operator will open the appropriate discharge valves as directed by the officer.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The pump operator will open the appropriate discharge valves at the call for water, or as directed by the officer.' This highlights the importance of communication and following directions in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_92_05ff775f",
          "question": "When three members are present at a standpipe outlet, the third member anchors the line and makes the connection to the standpipe while the other two members make the stretch.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'With three members present, the third member anchors the line and makes the connection to the standpipe while the other two members make the stretch.' This indicates the division of tasks among team members during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_92_f7947374",
          "question": "When operating a single person 2 \u00bd\u201d line, the operator should form a loop in the nozzle end of the line approximately 30 feet in diameter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Form a loop in the nozzle end of the line approximately 18 feet in diameter.' This contradicts the statement in the question and highlights the importance of proper equipment handling and operation in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_84_cd59592a",
          "question": "The male LDH coupling, with a 4\u201d to 2\u00bd\u201d reducer coupling attached, should be placed on the left side of the hose bed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Begin by placing the male LDH coupling, with a 4\u201d to 2\u00bd\u201d reducer coupling attached, on the right side of the hose bed.' This contradicts the statement, indicating that the coupling should be placed on the right, not the left side of the hose bed. The correct placement of equipment is crucial in firefighting operations for efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_84_cf783d35",
          "question": "The hose should be passed straight back into the bed, lying flat, all the way down to the closed end of the compartment.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Pass the hose straight back into the bed, lying flat, all the way down to the closed end of the compartment.' This supports the statement. Proper hose placement is important for effective firefighting operations and can impact the speed and safety of deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_84_f51ae022",
          "question": "At the closed end of the bed, a bight will be formed in the hose and lead the hose back up toward the open end.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'At the closed end of the bed a bight will be formed in the hose and lead the hose back up toward the open end.' This supports the statement. Understanding how to correctly form and manage a bight in the hose is crucial for efficient hose deployment and can impact firefighting tactics.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_84_cee17c61",
          "question": "The hose should be kept directly on top of the first flake for the entire distance to the open end.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Keep the hose directly on top of the first flake for about half the distance to the open end and then adjust it so that it runs against and parallel to the first flake for the remainder of the distance to the open end.' This contradicts the statement, indicating that the hose should only be kept directly on top of the first flake for about half the distance. Proper hose management is crucial for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_84_4f2dba84",
          "question": "The hose should be adjusted to run against and parallel to the first flake for the remainder of the distance to the open end.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'adjust it so that it runs against and parallel to the first flake for the remainder of the distance to the open end.' This supports the statement. Proper hose placement and management can impact the speed and safety of hose deployment in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_105_fbf97d99",
          "question": "The first member secures the line to the ladder using a clove hitch around the rung below the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The first member then secures the line to the ladder, using a clove hitch around the rung above the hose.' This contradicts the statement in the question. The correct placement of the clove hitch is crucial to ensure the stability and safety of the hose line during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_105_9220932b",
          "question": "The second and third members assist in the placing of the nozzle by lifting on the hose upon the command of the first member.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The members below, upon the command of the first member assist in the placing of the nozzle by lifting on the hose.' This supports the statement in the question. Effective communication and teamwork are vital in firefighting operations to ensure safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_105_11186a9c",
          "question": "The third member climbs up the ladder to hold both members safely on the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The second member then climbs up the ladder to a position one rung below the first member, reaching around the body of the first member and grasps the beams with both hands to hold both members safely on the ladder.' This contradicts the statement in the question. Understanding each member's role is crucial for safety and effectiveness during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_105_8a667c9e",
          "question": "The first member is free to manipulate the hose and nozzle after securing the line to the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This leaves the first member free to manipulate the hose and nozzle.' This supports the statement in the question. Knowing how to secure the hose line properly allows the first member to focus on manipulating the hose and nozzle, which is essential for effective firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_105_856491fe",
          "question": "The ladder tip does not need to be secured to the building during firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ensure the ladder tip is secured to the building.' This contradicts the statement in the question. Securing the ladder tip to the building is a critical safety measure during firefighting operations to prevent the ladder from slipping or falling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_71_3e280262",
          "question": "The shoulder-load method of carrying hose should be lifted using the back muscles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remember to pull and lift the shoulder-load with the arm and leg muscles, not the back muscles.' This contradicts the statement in the question. Using the arm and leg muscles instead of the back muscles can prevent injuries during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_71_e1fffcc1",
          "question": "When shoulder-loading a hose, the nozzle or coupling should be positioned slightly above the waist.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The flakes should be positioned with one-third of the length in front of the body and two-thirds in back with the nozzle or coupling at slightly above the waist.' This supports the statement in the question. The positioning of the nozzle or coupling can affect the balance and control of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_71_e3f273aa",
          "question": "When shoulder-loading a hose from the ground after use, you should start with the coupling closest to the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the hose is laid out on level ground, start with the coupling farthest from the engine.' This contradicts the statement in the question. Starting with the coupling farthest from the engine ensures proper drainage and ease of handling during hose recovery operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_71_e77ce2c5",
          "question": "When shoulder-loading a hose, each flake should be formed in a different manner and length.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Continue to form flakes in the same manner while keeping each flake flat, the same length, and on top of the previous flake.' This contradicts the statement in the question. Keeping each flake the same length and manner ensures uniformity and ease of handling during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_71_dc54b924",
          "question": "After shoulder-loading a hose, it should be laid on the ground in position for loading, parallel to the tailboard and three feet away.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Carry the shoulder-load to the engine and lay it on the ground in position for loading, parallel to the tailboard and three feet away.' This supports the statement in the question. Proper positioning of the hose after shoulder-loading facilitates efficient reloading onto the engine and readiness for the next firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_88_9846c55f",
          "question": "The final female coupling should be connected to the pre-connect discharge outlet to finish the load.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Finish the load by connecting the final female coupling to the pre - connect dis charge outlet.' This indicates that the final step in preparing the hose load involves connecting the final female coupling to the pre-connect discharge outlet. This is crucial for ensuring that the hose is ready for use during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_88_6868b091",
          "question": "The top three bights should be tied tightly to prevent slack while shoulder-loading and advancing the line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Leave the top three bights untied to allow for slack while shoulder - loading and advancing the line.' This contradicts the statement in the question. Leaving the top three bights untied allows for necessary slack, which can facilitate smoother operations when shoulder-loading and advancing the line during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_88_a8aa2398",
          "question": "The hose leading from the discharge outlet should be tucked between the hose bundle and the right side wall of the slot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tuck the hose, leading from the discharge outlet, between the hose bundle and the left side wall of the slot (driver\u2019s side of the engine ).' This contradicts the statement in the question. The correct placement of the hose is important for ensuring the efficient use and deployment of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_88_ec5df267",
          "question": "Only the top few inches of the hose should be wedged to keep the top flakes securely in position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Wedge just the top few inches to keep the top flakes securely in position.' This supports the statement in the question. Properly securing the top flakes of the hose is important to prevent them from becoming dislodged during transport or operations, which could potentially disrupt firefighting efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_88_e776b3ea",
          "question": "The 200-foot load and nozzle should be tied with a tie rope at the slot opening.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Then tie the 200 -foot load and no zzle with a tie rope at the slot opening.' This supports the statement in the question. Tying the load and nozzle at the slot opening is a necessary step in preparing the hose for use, ensuring that it remains secure and ready for deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_67_1ef879bc",
          "question": "To make the coupling, the member with the male coupling should assist by aligning the couplings.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is important that the member with the male coupling look completely away to eliminate the tendency to assist.' This contradicts the statement, indicating that the member with the male coupling should not assist in aligning the couplings. This is crucial for firefighting operations as it ensures the proper and safe coupling of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_67_db88a0f2",
          "question": "To break the coupling, the member with the female coupling turns the swivel in a clockwise direction.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To break the coupling, the member with the male coupling grasps it firmly while the other member turns the swivel counter-clockwise until the coupling is broken.' This contradicts the statement, indicating that the swivel should be turned in a counter-clockwise direction to break the coupling. Understanding this is important for firefighters as it affects the disassembly of the hose after firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_67_2d45a568",
          "question": "To make the coupling, the member with the female coupling aligns it with the male coupling and turns the swivel in a clockwise direction.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member with the female coupling then grasps the bowl with the left hand and the swivel with the right hand, aligning the female coupling with the male coupling. This member then turns the female swivel in a clockwise direction with the right hand until the couplings are seated.' This supports the statement, indicating that the swivel is turned in a clockwise direction to make the coupling. This is a key operational procedure in firefighting as it ensures a secure connection of the hose for effective water delivery.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_67_c64b49ea",
          "question": "The member with the male coupling should hold it in a vertical plane.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member with the male coupling grasps it with both hands around the bowl and holds it in a horizontal plane.' This contradicts the statement, indicating that the male coupling should be held in a horizontal plane. This is an important safety and operational consideration in firefighting, as holding the coupling in the correct plane ensures proper alignment and secure connection of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_67_cb74276f",
          "question": "To finish making the coupling, the member with the female coupling should grasp both the swivel and bowl with both hands and turn clockwise.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Finish by grasping both the swivel and bowl with both hands and turning clockwise, aligning the creases.' This supports the statement, indicating that the member with the female coupling should grasp both the swivel and bowl with both hands and turn clockwise to finish making the coupling. This is crucial for firefighting operations as it ensures the secure and proper connection of the hose, enabling effective water delivery during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_89_0770ba7d",
          "question": "The female coupling of the first bundle should be nearest to the tailboard when arranging the unconnected bundles in flakes.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The flakes should run parallel to the tailboard with the female coupling of the first bundle nearest the tailboard.' This means that the female coupling of the first bundle should indeed be nearest to the tailboard. This is important for proper hose connection and efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_89_6319d219",
          "question": "The hose should be loaded into the hose slot in a horizontal stack.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Load the hose into the hose slot in a vertical stack.' This contradicts the statement that the hose should be loaded in a horizontal stack. Loading the hose in a vertical stack is crucial for efficient hose deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_89_5bff7e8e",
          "question": "The flakes at the open end of the slot should extend 6 to 9 inches from the slot opening.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The flakes at the open end of the slot should extend 6 to 9 inches from the slot opening.' This supports the statement and is important for ensuring that the hose is properly loaded and ready for quick deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_89_9d25f660",
          "question": "The bottom and/or middle flake, of the bottom 100 feet, should be kept intentionally short to facilitate a single member reaching back to stretch the entire 200 feet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The bottom and/or middle flake, of the bottom 100 feet, may be kept intentionally long to facilitate a single member reaching back to stretch the entire 200 feet.' This contradicts the statement that the flake should be kept short. Keeping the flake long is important for enabling a single firefighter to stretch the entire 200 feet of the hose, which can be crucial in certain firefighting scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_89_5c762a8f",
          "question": "The hose should be loaded in this manner until there is 20 feet or less remaining when measured from the open end of the hose bed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Continue loading the hose in this manner until there is 10 feet or less remaining when measured from the open end of the hose bed.' This contradicts the statement that the hose should be loaded until there is 20 feet or less remaining. Loading the hose correctly is essential for efficient hose deployment and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_66_ae4a84bb",
          "question": "To make the coupling, you should turn the swivel of the female coupling in a counter-clockwise direction.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To make the coupling, grasp the swivel of the female coupling with both hands, align with the male coupling, and turn in a clockwise direction.' This directly contradicts the question statement, which suggests turning the swivel in a counter-clockwise direction. The correct procedure is important for ensuring a secure connection between the hose couplings, which is critical for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_66_759457b2",
          "question": "Stepping directly behind the bowl of the male coupling changes the angle of the coupling with relation to the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The action of stepping in this location should change the angle of the coupling with relation to the ground making the connection easier.' This supports the question statement. Changing the angle of the coupling can make it easier to connect, which can speed up firefighting operations and potentially save lives and property.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_66_30a63596",
          "question": "To break the coupling, you should turn the swivel in a clockwise direction.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To break the coupling, turn the swivel in a counter-clockwise direction.' This directly contradicts the question statement, which suggests turning the swivel in a clockwise direction. Understanding the correct procedure to disconnect the hose is important for safety and efficiency in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_66_86433c6d",
          "question": "You can use the end of a short double fold to aid in tilting the coupling upward.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the coupling on the end of a short double fold to aid in tilting it upward.' This supports the question statement. Using the end of a short double fold to tilt the coupling can make it easier to connect the hose, which can improve the efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_66_8207e6de",
          "question": "You should step on the short double fold with the right foot to rotate the coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Step on the short double fold with the left foot (or knee) and rotate the coupling with both hands.' This directly contradicts the question statement, which suggests stepping on the fold with the right foot. Understanding the correct procedure is important for maintaining balance and control while connecting the hose, which can enhance safety and efficiency in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_70_63626330",
          "question": "The member with the male coupling should attempt to align the couplings.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This member makes no attempt to align the couplings and needs to look away completely to avoid the tendency to assist.' This means that the member with the male coupling should not try to align the couplings, as it is the responsibility of the member with the nozzle. This is important for firefighting operations to ensure proper and efficient coupling of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_70_cd29fcf7",
          "question": "The member with the nozzle should turn the nozzle in a clockwise direction until seated hand tight.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Turn the nozzle in a clockwise direction until seated hand tight.' This indicates that the member with the nozzle should indeed turn the nozzle in a clockwise direction until it is seated hand tight. This is crucial for ensuring a secure connection between the hose and the nozzle during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_70_3023c437",
          "question": "If the female coupling of the nozzle has a movable swivel, you should grasp the barrel with the right hand and turn the swivel with the left hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the female coupling of the nozzle has a movable swivel, grasp the barrel with the left hand and turn the swivel with the right hand.' This contradicts the statement, as it specifies that the barrel should be grasped with the left hand and the swivel turned with the right hand. This is important for firefighters to know as it affects how they handle equipment during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_70_384d7535",
          "question": "The two members should begin by facing away from each other.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The two members begin by facing each other.' This contradicts the statement, indicating that the two members should start by facing each other. This is a crucial part of the procedure for connecting a hose to a nozzle, which is a fundamental firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_70_5af802ff",
          "question": "The member with the male coupling should hold the coupling in a vertical plane.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'holding the coupling in a horizontal plane.' This contradicts the statement, indicating that the member with the male coupling should hold the coupling in a horizontal plane, not a vertical one. This is important for firefighters to understand as it affects the correct procedure for coupling hoses.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_104_98016148",
          "question": "The first member attaches a body loop to the line with a hose knot 12 inches behind the coupling to which the nozzle is attached.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The first member attaches a body loop to the line with a hose knot 12 inches behind the coupling to which the nozzle is attached.' This is a crucial step in ensuring the hose is secured properly, which is important for firefighter safety and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_104_c7e62c5c",
          "question": "The second and third members attach their loops at 5-foot intervals behind the first member.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement, 'The second and third members attach their loops at 10-foot intervals behind the first member.' The correct interval is 10 feet, not 5 feet. This spacing is important for maintaining control of the hose and ensuring firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_104_b707ab0b",
          "question": "The members approach the ladder at a 90-degree angle and start climbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement, 'The members approach the ladder at a 45-degree angle and start climbing.' The correct angle is 45 degrees, not 90 degrees. Approaching at the correct angle is important for maintaining balance and safety while climbing.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_104_7e88d436",
          "question": "The first member stops when the head is even with the first opening above the windowsill.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The first member stops when the head is even with the first opening above the windowsill.' This is a crucial step in positioning the hose correctly for firefighting operations, and understanding this is important for effective firefighting tactics.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_104_083efb86",
          "question": "The first member then grasps the beam of the ladder with the right hand and guides the nozzle over the first rung above the sill with the left hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement, 'The first member then grasps the beam of the ladder with the left hand and guides the nozzle over the first rung above the sill with the right hand.' The correct hand usage is crucial for maintaining control of the hose and ensuring firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_112_1ab41a00",
          "question": "In most engine evolutions, water flows from the male end to the female end of the coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In most of the engine evolutions water flows from the female end to the male end.' This directly contradicts the statement in the question. Understanding the direction of water flow is critical for firefighters to ensure effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_112_1fe22382",
          "question": "A 2 \u00bd\u201d to 4\u201d coupling is referred to as an increaser because the size of the hose is increased.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This coupling is named this way because the female end is 2 \u00bd\u201d and the male end is 4\u201d. So, if water flows from the female end to the male end through this coupling, the size of the hose is increased. Therefore, we refer to this coupling as an increaser.' This supports the statement in the question. Understanding the function of different couplings is important for firefighters to ensure the correct water flow for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_112_46618ca2",
          "question": "All 50-foot sections of 4\u201d hose carried on Seattle fire engines have 4\u201d ST threads.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'All 50-foot sections of 4\u201d hose carried on Seattle fire engines have 4\u201d NST threads.' This directly contradicts the statement in the question. Knowing the type of threads on the hoses is crucial for firefighters to ensure proper connection to hydrants and other equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_112_143a9910",
          "question": "The hydrant adapter is used to connect the 4\u201d hose to a hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This coupling is used to connect the 4\u201d hose to a hydrant.' This supports the statement in the question. Understanding the function of the hydrant adapter is important for firefighters to ensure proper connection and water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_112_6ecb7796",
          "question": "The 'soft suction adapter' is never used to adapt male NST threads to female ST threads.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'There are some situations where it is necessary to adapt male NST threads to female ST threads. This is where the \u201csoft suction adapter\u201d (aka \u2018Red Dot Coupling\u2019) is used.' This directly contradicts the statement in the question. Knowing when to use specific adapters is crucial for firefighters to ensure effective water supply in different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_85_8823efc0",
          "question": "The hose should be passed back toward the closed end with the hose running against and parallel to the initial flake.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Then pass the hose back toward the closed end with the hose running against and parallel to the initial flake.' This implies that the hose should be arranged in a way that it runs parallel to the initial flake, which is crucial for efficient hose deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_85_96e3c8c3",
          "question": "When the next coupling is reached, it should be positioned within five feet of the open end.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the next coupling is reached, connect the next section of hose and position the coupling within three feet of the open end.' This contradicts the statement that the coupling should be positioned within five feet of the open end. Proper positioning of the coupling is important for efficient hose connection and deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_85_c05b8ad3",
          "question": "Upon reaching the left side of the bed, flakes should be formed in the same direction back toward the right side.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Upon reaching the left side of the bed, form flakes in the opposite direction back toward the right side.' This contradicts the statement that flakes should be formed in the same direction. The direction of flake formation is crucial for efficient hose deployment and can affect firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_85_c6fb5256",
          "question": "Additional layers should be formed in the same manner, keeping the couplings within three feet of the open end.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Form additional layers in the same manner, keeping the couplings within three feet of the open end.' This supports the statement that additional layers should be formed in the same manner, keeping the couplings within three feet of the open end. This is important for maintaining consistency in hose loading, which can affect the speed and efficiency of hose deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_85_39c91482",
          "question": "The hose should be loaded until half the complement of hose has been loaded.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Form additional layers in the same manner, keeping the couplings within three feet of the open end, until the full complement of hose has been loaded.' This contradicts the statement that the hose should be loaded until half the complement of hose has been loaded. Loading the full complement of hose is crucial for ensuring that firefighters have enough hose length for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_93_083ce2f3",
          "question": "A single firefighter can be assigned to any hose line entering a building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A minimum of two members shall be assigned to any hose line entering a building.' This contradicts the statement, implying that at least two firefighters are required for safety and operational efficiency. This is crucial in firefighting operations as it ensures that there is always backup in case of any unexpected situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_93_2f8400b1",
          "question": "Upon arrival at the objective, any remaining hose line must be arranged to be free of kinks and easily advanced.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon arrival at the objective, any remaining hose line must be arranged to be free of kinks and easily advanced - stacked into coils or flaked out.' This supports the statement and highlights the importance of preparing the hose line properly for efficient firefighting operations. This ensures that water can flow freely when the hose is charged.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_93_4bdbe3ab",
          "question": "Control of the nozzle is not important during firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Control of the nozzle must be maintained at all times.' This contradicts the statement, emphasizing the importance of maintaining control of the nozzle during firefighting operations. This is crucial for directing the water stream effectively to extinguish the fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_93_109ebd70",
          "question": "It is best practice to set down a hose bundle directly in front of the entry point.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Considering this, it is usually a best practice to avoid setting down a hose bundle directly in front of the entry point.' This contradicts the statement, indicating that it's best to avoid placing the hose bundle directly in front of the entry point to prevent obstruction. This is important for ensuring smooth entry and exit of firefighters and equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_93_8fd36537",
          "question": "The front door should be the first 'pinch' point that will create excess friction.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Pay attention to the building you are entering and orient your long flakes to ensure that the front door is not the first \u201cpinch\u201d point that will create excess friction.' This contradicts the statement, suggesting that the front door should not be the first 'pinch' point. This is crucial for maintaining the efficiency of the hose line and reducing the risk of hose damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_108_b0069a48",
          "question": "The Seattle Fire Department hose should be cleaned and changed only when it becomes soiled.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Any hose not used for thirty days shall be rotated.' This implies that even if the hose is not soiled, it should be changed if it has not been used for thirty days. This is important for maintaining the readiness and functionality of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_108_cf4601d1",
          "question": "Before flushing a hose that has been used to pump saltwater, the couplings should be left loosened with the gaskets removed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Before flushing, the couplings should be left loosened with the gaskets removed to allow for complete flushing.' This is crucial to ensure that all saltwater is removed from the hose, preventing potential damage to the equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_108_5b6feb36",
          "question": "The female hose couplings should be checked for gaskets after each use and before loading on the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The female hose couplings should be checked for gaskets after each use and before loading on the engine.' This is a critical step in ensuring the proper functioning of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_108_e42c0918",
          "question": "Nozzles should be visually inspected after each use to ensure that the molded rubber fog teeth are damaged.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Nozzles should be visually inspected after each use to be sure that the molded rubber fog teeth are undamaged.' This means that the nozzles should be inspected for damage, not to ensure that they are damaged. Ensuring the nozzles are undamaged is vital for the effective operation of the firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_108_2a3971f8",
          "question": "The screen inside the nozzle barrel should be checked and any trapped particles and debris should be removed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'On nozzles, the screen (Gasket Grabber) inside the barrel should be checked and any trapped particles and debris should be removed.' This is important to maintain the functionality of the nozzle and to prevent blockages during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_69_86ca15a8",
          "question": "To attach the nozzle using the standing method, you should grasp the nozzle by the barrel with the left hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Grasp the nozzle by the barrel with the right hand at a point where the nozzle is in balance.' This contradicts the statement, indicating that the right hand, not the left, is used to grasp the nozzle by the barrel. This is crucial for firefighters to understand as incorrect handling of equipment can lead to operational inefficiencies or safety risks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_69_ef281d4e",
          "question": "To remove the nozzle, you should rotate it in a clockwise direction.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To remove the nozzle, rotate the nozzle counter-clockwise while bracing the male coupling with the left hand.' This contradicts the statement, indicating that the nozzle should be rotated counter-clockwise, not clockwise, to remove it. Understanding the correct method of equipment operation is vital for firefighters to ensure efficient and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_69_f4cb8184",
          "question": "When attaching the nozzle using the stepping on hose method, you should fold two short double flakes ending with the male coupling on top.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'To attach the nozzle, fold two short double flakes ending with the male coupling on top.' This supports the statement. Knowing the correct method of preparing the hose for nozzle attachment is important for firefighters to ensure the equipment is ready for use when needed, enhancing firefighting efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_69_5912fe71",
          "question": "When removing the nozzle using the stepping on hose method, you should step on the hose just in front of the male coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To remove the nozzle, rotate the nozzle counter-clockwise with the left foot stepping on the hose, just behind the male coupling.' This contradicts the statement, indicating that the firefighter should step on the hose just behind, not in front of, the male coupling. This is significant for firefighters as incorrect handling can lead to equipment damage or safety risks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_69_12dc5863",
          "question": "When attaching the nozzle, you should continue to rotate it until the coupling is seated and hand tight, regardless of the method used.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Continue to rotate the nozzle until the coupling is seated and hand tight' for both the standing and stepping on hose methods. This supports the statement. Ensuring the nozzle is properly attached is critical for firefighters to prevent equipment failure during firefighting operations, which could lead to safety risks or operational inefficiencies.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_86_628ae7a5",
          "question": "The flakes of the 1 \u00be\u201d hose should be arranged perpendicular to the tailboard of the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The flakes should run parallel to the tailboard with the male coupling of the first bundle nearest the tailboard.' This contradicts the question statement. The arrangement of the hose flakes can affect the efficiency and safety of hose deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_86_cc854eb0",
          "question": "The 1 \u00be\u201d nozzle should be placed on the hose before building a flat loaded vertical stack.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the 1 \u00be\u201d nozzle on the hose and build a flat loaded vertical stack with the first section.' This supports the question statement. Proper nozzle placement is crucial for effective water delivery during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_86_7168a184",
          "question": "The last flake of the first bundle should be included in the tied bundle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tie the bundle but leave the last flake out of the tied bundle.' This contradicts the question statement. Leaving the last flake out can facilitate quicker deployment and reduce the risk of hose entanglement during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_86_270bf6e4",
          "question": "A 2 \u00bd\u201d to 1 \u00bd\u201d Bell reducer should be attached to the female on the top bundle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Attach a 2 \u00bd\u201d to 1 \u00bd\u201d Bell reducer to the female on the top bundle.' This supports the question statement. The use of a reducer can allow for greater flexibility in water delivery options during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_86_acff78a5",
          "question": "Tie ropes should be tied loosely with a quick release knot positioned at the bottom of the bundle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tie ropes should be tied tight and with a quick release knot positioned at the top of the bundle.' This contradicts the question statement. Properly tied ropes can ensure secure hose bundles while the quick release knot can facilitate rapid deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_90_78789f5d",
          "question": "The nozzle should be attached to the first bundle of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach the nozzle to the second bundle'. This contradicts the statement that the nozzle should be attached to the first bundle. The correct placement of the nozzle is crucial for the proper deployment of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_90_8d38b635",
          "question": "The hose of the second bundle is flaked in vertical stacks.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hose of the second bundle is then passed back into the hose slot and flaked in vertical stacks'. This supports the statement that the hose of the second bundle is flaked in vertical stacks. Proper stacking of the hose ensures efficient deployment and use during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_90_75db04ee",
          "question": "The male end of the first section of hose and the remaining female coupling from the second section are not connected.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The male end of the first section of hose and the remaining female coupling from the second section are connected'. This contradicts the statement that they are not connected. Proper connection of the hose sections is essential for the effective flow of water during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_90_79b986b6",
          "question": "The flakes of the hose extend 6 to 9 inches from the open end of the slot, over the pistol grip, flush with the nozzle tip.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The flakes will continue to extend 6 to 9 inches from the open end of the slot, over the pistol grip, flush with the nozzle tip'. This supports the statement in the question. The correct extension of the flakes is important for the proper handling and control of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_90_7cd4590b",
          "question": "The bundle is ready for deployment after the male end of the first section of hose and the remaining female coupling from the second section are connected.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The bundle is now correctly loaded and ready for deployment'. This supports the statement that the bundle is ready for deployment after the male end of the first section of hose and the remaining female coupling from the second section are connected. Ensuring the bundle is correctly loaded and ready for deployment is crucial for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_65_db3dce5d",
          "question": "Over-tightening of a connection by two members should be encouraged since the connection may have to be broken by one member.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Over-tightening of a connection by two members should be avoided since the connection may have to be broken by one member.' This contradicts the statement. Over-tightening can make it difficult for a single firefighter to break the connection if necessary, potentially slowing down operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_65_6d050cdf",
          "question": "Before connections are started, the female coupling should be checked to ensure the gasket is in place.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Before connections are started, the female coupling should be checked to ensure the gasket is in place.' This supports the statement. Checking the gasket before making a connection can prevent leaks and ensure the hose functions properly, which is critical during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_65_b5c0512f",
          "question": "The female swivel is turned left (counter-clockwise) to make connections, and turned right (clockwise) to break connections.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'From the perspective of \u201clooking at the male coupling\u201d, the female swivel is turned right (clockwise) to make, and turned left (counter-clockwise) to break connections.' This contradicts the statement. Understanding the correct way to make and break connections is important for efficient hose operation during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_65_4d875a3c",
          "question": "The Higbee marker identifies a point on the coupling where the first full thread starts.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Higbee marker identifies a point on the coupling where the first full thread starts.' This supports the statement. Recognizing the Higbee marker can help firefighters make connections more quickly and accurately, which can be crucial in a fire situation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_65_2894da95",
          "question": "To make the coupling, the swivel of the female coupling should be turned counter-clockwise.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To make the coupling, grasp the swivel of the female coupling with the right hand and align the two couplings in the same plane. The swivel should be turned clockwise.' This contradicts the statement. Knowing the correct direction to turn the swivel is essential for making connections quickly and effectively during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_73_145f503e",
          "question": "The hose should be pulled out of the slot entirely at once.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Grasp the entire bundle with both hands and pull it one-third of the way out of the slot.' This contradicts the statement that the hose should be pulled out entirely at once. In firefighting operations, pulling the hose out gradually can help manage the hose better and prevent potential tangling or mishandling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_73_485cae6e",
          "question": "The nozzle and front flakes of the hose should be at the belt line when carrying.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The nozzle and front flakes should be at the belt line.' This supports the statement in the question. Having the nozzle and front flakes at the belt line can help distribute the weight of the hose evenly and allow for better control during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_73_5dfb9bda",
          "question": "The hose should be held loosely in front of the body with both hands.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hold the bundle tightly in front of the body with both hands.' This contradicts the statement that the hose should be held loosely. Holding the hose tightly can ensure better control and prevent the hose from slipping during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_73_6a29d48b",
          "question": "The hose should pay out gradually from the top, one flake at a time.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hands should grip the hose flakes so as to allow the hose to pay out gradually from the top, one flake at a time.' This supports the statement in the question. Paying out the hose gradually can help manage the hose effectively and prevent potential mishaps during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_73_114dac25",
          "question": "After pulling the hose, you should move towards the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Step away from the engine in a straight line and pull the remainder of the bundle completely out of the slot.' This contradicts the statement that you should move towards the engine. Moving away from the engine can help create space for the hose to be laid out properly during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_107_db45f2b1",
          "question": "It is safe to stand in front of the hydrant when opening the main stem.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Stand behind the hydrant when opening the main stem.' This contradicts the statement in the question. The implication for firefighting operations is that standing in front of the hydrant during operation could pose a safety risk due to the high water pressure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_107_91caeba7",
          "question": "Hydrants should always be operated in a fully opened or fully closed position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Always operate the hydrant in a fully opened or fully closed position.' This supports the statement in the question. The implication for firefighting operations is that partially opening or closing the hydrant could lead to operational issues or damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_107_5a80fdb1",
          "question": "Over tightening while closing hydrants can contribute to breaking the main stem of the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Do not over tighten while closing hydrants, it may contribute to breaking the main stem of the hydrant.' This supports the statement in the question. The implication for firefighting operations is that care must be taken when closing hydrants to avoid causing damage that could impact water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_107_7d35cd6e",
          "question": "Water coming up from the base when the main stem is operated is a sign of a malfunctioning hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Don\u2019t be alarmed by water coming up from the base when the main stem is operated.' This contradicts the statement in the question. The implication for firefighting operations is that this is a normal occurrence and does not indicate a problem with the hydrant.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_107_eae4bf14",
          "question": "Fast operation of hydrants does not cause any damage.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Fast operation causes water hammer and could result in a broken water main, broken water meter, etc.' This contradicts the statement in the question. The implication for firefighting operations is that hydrants should be operated slowly to avoid causing damage that could disrupt water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_111_78e064a9",
          "question": "A coupling with the same thread, orientation, and size on both ends is referred to as a sister coupling or a brother coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If a coupling has the same thread, orientation (i.e. male or female), and size on both ends, we refer to it as a double female or a double male.' This contradicts the statement in the question. In firefighting operations, understanding the correct terminology is crucial for effective communication and equipment usage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_111_05de43d2",
          "question": "A coupling with the same thread and orientation on both ends but of unequal size is referred to as a double female or double male.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If a coupling has the same thread and orientation on both ends but they are of unequal size (i.e. 2 \u00bd\u201d female on one end and 4\u201d female on the other end) we refer to it as either a sister coupling or brother coupling.' This contradicts the statement in the question. Misunderstanding these terms could lead to incorrect equipment selection during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_111_869286ea",
          "question": "The term 'Red Dot Coupling' refers to a 4\u201d NST to 4\u201d ST coupling.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '\u2018Red Dot Coupling\u2019 (4\u201d NST to 4\u201d ST).' This supports the statement in the question. Recognizing these terms and their corresponding equipment is important for efficient and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_111_40964509",
          "question": "A 'Sister Coupling' can have a 2 \u00bd\u201d female on one end and 4\u201d female on the other end.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If a coupling has the same thread and orientation on both ends but they are of unequal size (i.e. 2 \u00bd\u201d female on one end and 4\u201d female on the other end) we refer to it as either a sister coupling or brother coupling.' This supports the statement in the question. Understanding these terms can help firefighters make quick decisions about equipment during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_111_a85cd68d",
          "question": "A 'Double Female Hydrant Adapter' refers to a 4\u201d ST to 4\u201d NST coupling.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Double Female Hydrant Adapter (4\u201d ST to 4\u201d NST).' This supports the statement in the question. Correct identification of equipment is crucial for effective firefighting tactics and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_110_4618b8a0",
          "question": "In the Seattle Fire Department, hose couplings are also referred to as adapters.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In general , we refer to them as couplings, not adapters.' This directly contradicts the statement in the question. Understanding the correct terminology is crucial for clear communication during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_110_1e9fb08c",
          "question": "The 2 \u00bd\u201d to \u00be\u201d Reducer is used for a 'Jiffy-hose'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, '2 \u00bd\u201d to \u00be\u201d Reducer (for \u2018Jiffy-hose\u2019).' This directly supports the statement in the question. Knowing the correct coupling for specific hoses is essential for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_110_2523ed18",
          "question": "There is no such thing as a 4\u201d Double Female coupling in the Seattle Fire Department.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '4\u201d Double Female.' This directly contradicts the statement in the question. Knowing the available types of couplings can affect the efficiency and safety of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_110_5407e2ef",
          "question": "The 2 \u00bd\u201d to 4\u201d coupling is referred to as an Increaser.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, '2 \u00bd\u201d to 4\u201d Increaser.' This directly supports the statement in the question. Understanding the function of different couplings can impact the effectiveness of water delivery during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_110_414b1634",
          "question": "The 4\u201d to 2 \u00bd\u201d coupling is called a Reducer because it increases the hose diameter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '4\u201d to 2 \u00bd\u201d Reducer.' This directly contradicts the statement in the question. A reducer is used to decrease, not increase, the hose diameter. Misunderstanding this could lead to operational inefficiencies or safety issues during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_106_5e4c2849",
          "question": "The bale and the shaper of the nozzle should be open while climbing a ladder for safety.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'For safety, both the bale and the shaper of the nozzle should be closed while climbing a ladder.' This contradicts the statement, indicating that for safety reasons, both the bale and the shaper should be closed, not open. This is important for firefighter safety during operations involving climbing ladders with a hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_106_0b682f84",
          "question": "When drilling, the nozzle bale should be operated at one-quarter of its open position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When drilling, only operate the nozzle bale at one-quarter of its open position.' This supports the statement. Operating the nozzle bale at one-quarter of its open position during drilling is a key operational consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_106_747f719c",
          "question": "Lowering a charged line down a ladder is accomplished differently than taking it up the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Lowering a charged line down a ladder is accomplished in the same way that the charged line was taken up the ladder, except in reverse order.' This contradicts the statement, indicating that the process of lowering a charged line down a ladder is the same as taking it up, just in reverse. This is a key operational consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_106_ee3e1352",
          "question": "The bale and the shaper of the nozzle should be closed while climbing a ladder to prevent water flow.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For safety, both the bale and the shaper of the nozzle should be closed while climbing a ladder.' This supports the statement. Keeping the bale and the shaper of the nozzle closed while climbing a ladder prevents unintended water flow, which can affect balance and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_106_8494a110",
          "question": "When drilling, the nozzle bale should be fully opened for maximum water flow.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When drilling, only operate the nozzle bale at one-quarter of its open position.' This contradicts the statement, indicating that the nozzle bale should not be fully opened during drilling. This is important for controlling water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_72_4acc2cdf",
          "question": "The front third of the hose bundle is not important to 'dress' when in a hurry to accomplish a hose lay.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the front third of the bundle is the most important part of the bundle to \u201cdress\u201d prior to attempting to shoulder -load the bundle.' This contradicts the statement in the question. In firefighting operations, ensuring the hose is properly dressed, especially the front third, can prevent entanglements and delays during deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_72_e09754e2",
          "question": "When shoulder-loading a hose, it is recommended to twist the back for a proper lift.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Then stand, taking care to use the leg muscles and to avoid twisting the back.' This contradicts the statement in the question. Twisting the back can lead to injuries, which can compromise a firefighter's ability to perform duties effectively and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_72_6fae06d6",
          "question": "All hoses, regardless of diameter, will be shoulder-loaded in the same manner.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'All hose will be shoulder-loaded in this manner, regardless of diameter.' This supports the statement in the question. Understanding this procedure is crucial for firefighters as it ensures consistency and efficiency in hose deployment, regardless of the hose size.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_72_3702b695",
          "question": "When preparing to shoulder-load a hose, you should stand alongside the hose, adjacent to the nozzle, or the male coupling, or the last flake to be extended.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Stand alongside the hose, adjacent to the nozzle, or the male coupling, or the last flake to be extended, whichever is appropriate.' This supports the statement in the question. Proper positioning is crucial in firefighting operations to ensure effective and safe handling of equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_72_bc788013",
          "question": "When lifting the hose bundle for shoulder-loading, it is not necessary to use both hands.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Using both hands, gather and squeeze the flakes together, lifting the forward bights from the ground.' This contradicts the statement in the question. Using both hands ensures a secure grip and balanced load, reducing the risk of dropping the hose or causing injury.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_64_cdd73fd5",
          "question": "The traditional method of unrolling a hose involves pulling the hose away from the coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The traditional method to unroll hose is to grasp the outside coupling and to push the rest of the roll away.' This contradicts the statement in the question that the hose is pulled away from the coupling. Understanding the correct method of unrolling a hose is important for firefighters to prevent equipment damage and ensure efficient operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_64_33883693",
          "question": "The butterfly method of unrolling a hose is beneficial when space is limited.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The following method avoids this problem and works especially well when space is limited.' This supports the statement in the question that the butterfly method is beneficial when space is limited. This knowledge can help firefighters adapt to different situations and environments, ensuring efficient hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_64_7777df9b",
          "question": "The traditional method of unrolling a hose can cause the male coupling to become 'out of round'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'However, the problem with this method is that the male coupling at the other end could become damaged as it snaps downward against the ground from the momentum of the unrolling action. When couplings are not \u201ccoupled\u201d they can become \u201cout of round\u201d when violently handled.' This supports the statement in the question that the traditional method can cause the male coupling to become 'out of round'. This understanding is crucial for firefighters to prevent equipment damage and maintain operational readiness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_64_1730e476",
          "question": "In the butterfly method, the male coupling is grasped from the center of the roll at the beginning of the unrolling process.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Finally, grasp the male coupling from the center of the roll and walk away, stretching the hose out on the ground.' This contradicts the statement in the question that the male coupling is grasped at the beginning of the unrolling process. Correct understanding of the process can help firefighters deploy the hose efficiently and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_64_a1052a11",
          "question": "In the butterfly method, successive layers of the hose are pulled to the same side.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Continue pulling successive layers to alternate sides until the roll is deployed.' This contradicts the statement in the question that successive layers are pulled to the same side. Understanding the correct method can help firefighters deploy the hose effectively and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_91_8997dd6c",
          "question": "The force exerted by a fire stream emerging under pressure from a nozzle is in the same direction as the water flow.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A fire stream emerging under pressure from a nozzle always exerts force in the opposite direction of the water flow.' This means that the force exerted by the water is in the opposite direction, not the same. This is important for firefighters to understand as it affects how they control and handle the nozzle during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_91_887243d3",
          "question": "The member on the nozzle must be prepared to control the nozzle reaction before opening the bale of any nozzle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the nozzle, along with any back-up members, must be prepared to control this nozzle reaction before opening the bale of any nozzle.' This means that firefighters must be ready to handle the force exerted by the nozzle before they open it. This is crucial for safety and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_91_aa9b76ec",
          "question": "A 2 \u00bd\u201d attack line requires a minimum of three members to operate.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A 2 \u00bd\u201d attack line requires a minimum of two members to operate.' This means that at least two firefighters are needed to operate a 2 \u00bd\u201d attack line, not three. This is important for planning and coordinating firefighting teams.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_91_14703465",
          "question": "After making a connection, you should check the valves or gates to be sure that they are either open or closed, whichever is required.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'After making a connection, check the valves or gates to be sure that they are either open or closed, whichever is required.' This means that firefighters should always check the status of valves or gates after making a connection. This is crucial for ensuring the proper flow of water during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_91_712406f3",
          "question": "The gate on the tri-gate connected to the attack line should always be left open.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The gate on the tri-gate connected to the attack line may be left either open or closed, depending on the officer\u2019s decision.' This means that the position of the gate on the tri-gate is not always open, but depends on the officer\u2019s decision. This is important to understand as it affects the flow of water and the tactics used in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_68_d9e4b056",
          "question": "Two members are required to un-couple a hose using spanner wrenches.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A single member can complete this by kneeling at the hose and alternating the spanner wrenches in the same fashion as described above.' This contradicts the statement that two members are required. In firefighting operations, understanding that a single firefighter can un-couple a hose is important for efficiency and flexibility in different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_68_280ee7f3",
          "question": "The member on the side of the male coupling applies force in a clockwise direction.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the side of the male coupling positioning a spanner wrench on the lug of the bowl, applying force in a counter-clockwise direction.' This contradicts the statement that force is applied in a clockwise direction. Correctly applying force is crucial to safely and effectively un-coupling hoses during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_68_08492443",
          "question": "The member on the female coupling side turns in a counter-clockwise direction until the connection is broken.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the female coupling side then positions a spanner wrench on the lug of the female swivel and turns in a counter-clockwise direction until the connection is broken.' This supports the statement. Understanding the correct direction to turn the wrench is essential for successful hose un-coupling in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_68_07b51c02",
          "question": "The process of un-coupling a hose using spanner wrenches involves alternating the wrenches.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A single member can complete this by kneeling at the hose and alternating the spanner wrenches in the same fashion as described above.' This supports the statement. Knowing the correct procedure for un-coupling hoses is vital for efficient firefighting operations and preventing equipment damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_68_2ae1486e",
          "question": "The spanner wrench is positioned on the lug of the bowl when un-coupling the male side of the hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the side of the male coupling positioning a spanner wrench on the lug of the bowl.' This supports the statement. Correct positioning of the wrench is crucial for effective un-coupling of hoses, which is a key aspect of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_87_4141c994",
          "question": "The two unconnected bundles should be arranged in flakes at the front of the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Begin preparing the hose for loading by arranging the two unconnected bundles in flakes at the rear of the engine.' This contradicts the statement, indicating that the bundles should be arranged at the rear, not the front of the engine. This is crucial for efficient hose deployment and management during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_87_c3cb5f0a",
          "question": "The male coupling of the first bundle should be nearest the tailboard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The flakes should run parallel to the tailboard with the male coupling of the first bundle nearest the tailboard.' This supports the statement. Proper hose connection is essential for ensuring effective water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_87_a7b32ebd",
          "question": "The nozzle should be placed in the slot and allowed to extend 6 to 9 inches out from the closed end of the slot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Start the load by placing the nozzle in the slot and allow it to extend 6 to 9 inches out from the open end of the slot.' This contradicts the statement, indicating that the nozzle should extend from the open, not the closed end of the slot. Correct nozzle placement is important for quick and efficient deployment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_87_ba411c99",
          "question": "The male coupling from the second bundle should be connected to the female coupling on top of the first bundle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Connect the male coupling from the second bundle to the female coupling on top of the first bundle.' This supports the statement. Proper hose connection is crucial for ensuring uninterrupted water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_87_80dde3a5",
          "question": "The second bundle should be flaked in a horizontal stack on top of the first bundle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Continue to flake the second bundle in a vertical stack on top of the first bundle until the full 200 feet have been loaded.' This contradicts the statement, indicating that the second bundle should be flaked in a vertical, not horizontal stack. Proper hose stacking is essential for efficient hose deployment and management during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_63_0d701a4b",
          "question": "The double roll of a fire hose should be secured with two lengths of heavy-duty twine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The double roll should be secured with three lengths of heavy-duty twine.' This contradicts the statement in the question which mentions two lengths of twine. The correct number of twine lengths ensures the stability and safety of the hose roll, which is crucial during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_63_c8510ab1",
          "question": "When securing the roll, the three lengths of twine should be evenly spaced about the circumference of the roll.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The three lengths should be evenly spaced about the circumference of the roll.' This supports the statement in the question. Proper securing of the hose roll is important for the ease of deployment and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_63_38df6ba1",
          "question": "If the hose has been damaged, it should be discarded immediately.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the hose has been damaged, a rag should be tied around the hose at the point of damage. Information should be written on the repair tag (F14) and attached to the hose.' This contradicts the statement in the question which suggests discarding the hose. Proper handling of damaged equipment can prevent further damage and ensure safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_63_0a5375e7",
          "question": "The damaged area on a hose should be indicated on the repair tag by noting the number of feet from the male coupling.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The damaged area should be indicated on the repair tag by noting the number of feet from the male coupling.' This supports the statement in the question. Accurate identification of damage location helps in effective repair and maintenance of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_63_49f0630a",
          "question": "The repair tag should be attached to the hose without any written information.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Information should be written on the repair tag (F14) and attached to the hose.' This contradicts the statement in the question which suggests no information should be written. Proper documentation of damage is crucial for effective repair and maintenance of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_75_e7f8c25f",
          "question": "The first firefighter (Heel) is responsible for shoulder-loading the bottom 100' section of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'First firefighter (Heel) should er-load the top 100' section and steps away from the tailboard. Second firefighter (Nozzle) shoulder-loads the bottom section and steps off tailboard.' This clearly contradicts the statement in the question. The Heel firefighter handles the top section of the hose, not the bottom. This is important for coordinating the team's movements and ensuring the hose is deployed effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_75_da874035",
          "question": "Both firefighters should take care not to drag the length of hose between them on the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Both firefighters proceed to the water source, taking care not to drag the length of hose between them on the ground.' This supports the statement in the question. Dragging the hose can cause damage and hinder its deployment, which could impact firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_75_266cccbb",
          "question": "The rear member should allow the last flake of the shoulder-load to drop from the shoulder without any signal.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'As the rear member notices the last flake of the shoulder-load is about to pull off, he/she shouts for the member ahead to \u201cstretch\u201d and allows the last flake to drop from the shoulder.' This contradicts the statement in the question. The rear member should signal the forward member before dropping the last flake. This communication is crucial for coordinating the team's movements and ensuring the hose is deployed effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_75_329193d0",
          "question": "Once the connection is made between the bell reducer and the water source, the team will advance together to their objective.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Once the connection is made between the bell reducer and the water source, the team will advance together to their objective.' This supports the statement in the question. Coordinated movement is important for maintaining control of the hose and ensuring it is deployed effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_75_e7ea60e7",
          "question": "Any excess working line should be left as is once the objective is reached.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Any excess working line is then arranged so as to be free of kinks and into a configuration which allows for easy advancement.' This contradicts the statement in the question. Excess line should be arranged to prevent kinks and facilitate further advancement. This is important for maintaining control of the hose and ensuring it can be extended if needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_59_74f48e85",
          "question": "The hose port is the main hose-carrying area of a fire engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'HOSE BED - The main hose -carrying area of a fire engine.' This contradicts the statement, as the hose bed, not the hose port, is the main hose-carrying area of a fire engine. The hose bed is where the hoses are stored and transported, which is crucial for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_59_78c269f4",
          "question": "The keystone can be manually or mechanically operated.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'KEYSTONE - The main intake valve located midship on both sides of a fire engine that may be manually or mechanically operated.' This supports the statement, indicating that the keystone valve can be operated both manually and mechanically. This versatility can affect firefighting tactics, as it allows for flexibility in controlling water flow.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_59_37cde230",
          "question": "A master stream device delivers a small quantity of water.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'MASTER STREAM DEVICE - An appliance that delivers a large quantity of water (at least 500 GPM) such as a deck gun, ground monitor, or ladder pipe.' This contradicts the statement, as a master stream device delivers a large, not small, quantity of water. This is important for firefighting operations, as a master stream device is used when a large volume of water is needed to control a fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_59_6719ee51",
          "question": "The pressure relief valve (PRV) is designed to release excess pressure from the fire pump.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'PRESSURE RELIEF VALVE (PRV) - A device designed to release excess pressure from the fire pump.' This supports the statement, indicating that the PRV's role is to release excess pressure. This is a critical safety feature, as it prevents damage to the pump and potential harm to firefighters due to overpressure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_59_359f42e4",
          "question": "P.S.I. is a measurement of volume used in pumping, hydraulics, pneumatics, and operating hose streams.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'P.S.I. - Pound(s) per square inch. A measurement of pressure used in pumping, hydraulics, pneumatics, and operating hose streams.' This contradicts the statement, as P.S.I. is a measurement of pressure, not volume. Understanding P.S.I. is crucial for firefighters, as it helps them to manage water flow and pressure during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_101_d7918c29",
          "question": "The hose stretch starts by turning to the right and dropping off the top flake.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members then start the stretch by turning to the left and dropping off the top flake.' This directly contradicts the question statement. Proper hose stretching is crucial for firefighting operations as it allows for correct spacing and continuous line advancement towards the objective.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_101_19055bce",
          "question": "The hose runs from right shoulder-load to right shoulder-load in a continuous line as the members face into the building.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This will allow proper spacing and will result in the hose running from right shoulder -load to right shoulder -load in a continuous line as the members face into the building.' This supports the question statement. Maintaining a continuous line is important for the safety and efficiency of firefighting operations as it ensures a smooth and unobstructed water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_101_98ae28a4",
          "question": "The first member places the nozzle over the right shoulder onto the back.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The first member places the nozzle over the left shoulder onto the back.' This directly contradicts the question statement. Correct placement of the nozzle is important for maintaining balance and control during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_101_96ef3fcd",
          "question": "The hose is carried up the ladder in the same manner as with a body loop.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hose is carried up the ladder or the straight ladder fire escape in the same manner as with a body loop.' This supports the question statement. Understanding how to correctly carry the hose up a ladder is crucial for firefighter safety and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_101_2d3483f3",
          "question": "The second, third, and any additional members place the hose on their left shoulder(s), at designated intervals.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The second, third, and any additional members place the hose on their right shoulder(s), at designated intervals.' This directly contradicts the question statement. Correct placement of the hose on the shoulder is important for maintaining balance and control during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_80_ab63e3c5",
          "question": "The large diameter hose should be uncoupled from the tri-gate before overhauling.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Uncouple the large diameter hose from the tri-gate.\" This statement directly supports the question. The uncoupling of the hose is the first step in the overhauling process, which is crucial for firefighting operations as it allows for the hose to be properly managed and deployed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_80_9ae022ba",
          "question": "It is safe to place an arm through the bight formed in front of the body.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"It is unsafe to place an arm through the bight formed in front of the body.\" This statement directly contradicts the question. Placing an arm through the bight can lead to injury or entanglement, which could hinder firefighting operations and compromise safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_80_b8ef7eb9",
          "question": "The member should look forward frequently while pulling the hose from the hose bed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"The member should look backward frequently.\" This statement directly contradicts the question. Looking backward frequently is important for safety and operational efficiency, as it allows the firefighter to monitor the hose and ensure it is being deployed correctly.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_80_8af181c1",
          "question": "A second member should grasp the hose and place it flat on their shoulder with the coupling along their back as the coupling emerges.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"As the coupling emerges, a second member, facing away from the engine, grasps the hose and places it flat on their shoulder with the coupling along their back.\" This statement directly supports the question. This procedure is important for the effective and safe handling of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_80_ce214fe0",
          "question": "With limited staffing, each member may stretch only one section of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"With limited staffing, each member may stretch two sections, with members spaced at every other coupling.\" This statement directly contradicts the question. In situations with limited staffing, firefighters may need to handle more sections of the hose, which requires careful coordination and communication to ensure safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_79_3e01f21a",
          "question": "The second member takes a position facing away from the hose bed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The second member takes a position facing the hose bed.' This contradicts the statement in the question. Understanding the correct positioning is crucial for efficient hose handling and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_79_e613f288",
          "question": "The hose coupling should be at the small of the back after the member shoulder-loads the hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The coupling should now be at the small of the back.' This supports the statement in the question. Proper positioning of the hose coupling ensures effective hose management and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_79_64f3c2a0",
          "question": "Additional members continue shoulder-loading hose until the designated amount has been acquired and the final coupling has been broken.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Additional members continue shoulder-loading hose in this manner until the designated amount has been acquired and the final coupling has been broken.' This supports the statement in the question. This process ensures that the necessary amount of hose is ready for use in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_79_957fed3a",
          "question": "The members then turn towards the hose load, allowing the top flake to drop from their shoulder-loads.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members then turn away from the hose load (a counter-clockwise pivot 180 degrees to the left), allowing the top flake to drop from their shoulder-loads.' This contradicts the statement in the question. Turning away from the hose load is a crucial part of the procedure that allows for proper deployment of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_79_8613b4ad",
          "question": "The members should be facing towards the engine with the hose running continuously between the members and flaked on the members\u2019 right shoulders.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members should then be facing away from the engine with the hose running continuously between the members and flaked on the members\u2019 right shoulders.' This contradicts the statement in the question. Facing away from the engine is a crucial part of the procedure that ensures proper hose deployment and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_96_cffda9ad",
          "question": "An uncharged line can fit through places which will not restrict or halt the flow of water when the line is charged.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'An uncharged line may fit through places which will restrict or halt the flow of water when the line is charged (i.e., under doors, between heavy furniture, etc.)'. This contradicts the statement, indicating that certain tight spaces may indeed restrict or halt the flow of water when the line is charged. Firefighters must be aware of this when positioning their lines to ensure effective water delivery.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_96_509a072c",
          "question": "When advancing charged attack lines, positioning members at difficult areas can assist with the advancement by 'shuffling' the hose past these areas.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position members at areas that make it difficult to advance the hose line. These areas include corners, stairways, and other friction points. The strategically positioned members can assist with the advancement by \u201cshuffling\u201d the hose past these areas greatly accelerating the attack.' This supports the statement, indicating that strategic positioning of team members can help overcome obstacles and speed up the attack. This is a key tactical consideration for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_96_ce1cf4aa",
          "question": "When advancing attack lines up or down stairs, it is always more effective to run the hose straight up or down the well opening.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In buildings with no wall separating the staircases, it is sometimes more effective to run the hose straight up or down the well opening.' This contradicts the statement, indicating that running the hose straight up or down the well opening is not always the most effective method, but may be in certain circumstances. Firefighters must assess the specific conditions and choose the best method for advancing the line.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_96_4486c2dc",
          "question": "When using the method of running the hose straight up or down the well opening, the line should be anchored to the railing on the appropriate landing, using a body loop.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If this method is used, be sure to anchor the line to the railing on the appropriate landing, using a body loop.' This supports the statement, indicating that when using this method, it is important to secure the line to prevent it from slipping or falling. This is a key safety consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_96_97f34ee1",
          "question": "The method of running the hose straight up or down the well opening can be used for any distance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This method can only be used for short distances (100 feet or less), because of the weight of the water and hose.' This contradicts the statement, indicating that this method is only suitable for short distances due to the weight of the water and hose. Firefighters must consider this limitation when planning their attack strategy.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_78_02ecdcef",
          "question": "The large diameter hose (LDH) should be uncoupled from the tri-gate before shoulder-loading begins.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Begin by uncoupling the large diameter hose (LDH) from the tri-gate.' This indicates that the LDH should be uncoupled before any shoulder-loading begins. This is important for firefighter safety and proper hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_78_92c9ddd3",
          "question": "The hose should be passed over the left shoulder during the shoulder-loading process.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The hose should then be passed over the right shoulder.' This contradicts the statement that the hose should be passed over the left shoulder. Correct shoulder-loading technique is crucial for effective hose deployment and firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_78_26c2a42c",
          "question": "Each flake formed should be flat, the same length, and on top of the previous flake.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Each flake should be flat, the same length, and on top of the previous flake.' This supports the statement that each flake should meet these criteria. Proper flake formation is essential for efficient hose deployment and can impact firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_78_ac0a3bcd",
          "question": "When the first section of the hose has been shoulder-loaded, the firefighter should immediately proceed to shoulder-load the next section.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the first section (50 feet) has been shoulder-loaded and is within 10 feet of the coupling, move back several steps to allow a second member to shoulder-load the next section.' This contradicts the statement that the firefighter should immediately proceed to shoulder-load the next section. This procedure is important to ensure smooth transitions between firefighters and efficient hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_78_90530374",
          "question": "The bights of the hose should be kept in front of the body above the waist during the shoulder-loading process.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Continue to form flakes, keeping the bights in front of the body above the waist.' This supports the statement that the bights should be kept in this position. Proper positioning of the bights can affect hose deployment and firefighter mobility.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_97_50aa4031",
          "question": "The hose is connected to the standpipe on the same floor as the fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The hose is connected to the standpipe on the floor below the fire then laid to the fire floor.' This contradicts the statement in the question. The firefighting implication here is that connecting the hose to the standpipe on the floor below the fire can provide a more controlled approach to the fire floor.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_97_9a5ed6cf",
          "question": "If advancing the charged line becomes impossible, the stretched and charged hose line must be extended.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If advancing the charged line becomes impossible due to obstacles or a lack of hose, the stretched and charged hose line must be extended.' This supports the statement in the question. The firefighting implication is that the ability to extend the hose line can overcome obstacles or a lack of hose, ensuring continuous firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_97_70a619b7",
          "question": "When extending the hose line, it is not necessary to tie the bale in the open position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is essential that the bale be tied in the open position if this type of hose line extension is performed.' This contradicts the statement in the question. The firefighting implication is that tying the bale in the open position is critical for maintaining water flow during hose line extension.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_97_fbf92d29",
          "question": "When hoisting or lowering a hose line using a rope, the end of the rope should be tied to the hose four feet behind the nozzle using a hose knot.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Tie the end of the roof (or utility) rope to the hose four feet behind the nozzle using a hose knot.' This supports the statement in the question. The firefighting implication is that this technique ensures the stability and control of the hose during hoisting or lowering operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_97_bec719e5",
          "question": "If the hose is being hoisted, the roof rope should be tied off outside the window.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the hose is being hoisted, tie the roof rope off inside the window (or on the roof).' This contradicts the statement in the question. The firefighting implication is that tying the rope off inside the window or on the roof provides a secure anchor point during hoisting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_81_aaddae8c",
          "question": "The Tri-Gate is picked up by one member and advanced toward the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Two members begin by picking the tri-gate up by the handles and advancing toward the objective.' This contradicts the statement as it is not one member but two members who pick up the Tri-Gate and advance towards the objective. This is important in firefighting operations as teamwork and coordination are crucial for effective hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_81_1be83686",
          "question": "The hose is placed on the right shoulder of a member facing away from the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Another member, facing away from the engine, then places the hose flat on their right shoulder with the coupling to the rear.' This supports the statement and shows the correct positioning of the hose during deployment. The correct positioning is important for safety and efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_81_d045eb5b",
          "question": "With limited staffing, each member can stretch only one section of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'With limited staffing, two sections may be stretched by each member.' This contradicts the statement as it indicates that each member can stretch two sections of the hose, not just one. This is a tactical consideration in firefighting operations, especially when resources are limited.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_81_534e6f43",
          "question": "Members are spaced at every coupling during hose deployment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'With limited staffing, two sections may be stretched by each member, with members spaced at every other coupling.' This contradicts the statement as members are spaced at every other coupling, not at every coupling. This is an operational concern in firefighting, ensuring efficient use of personnel and equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_81_77e30f35",
          "question": "The hose is removed in the same manner until the objective is reached.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Additional hose is removed in the same manner until the objective is reached.' This supports the statement, indicating that the same procedure is followed for hose deployment until the objective is reached. This consistency is important in firefighting operations for efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_58_dd1a92c0",
          "question": "The term 'charge' refers to pressurizing a fire hose or fire extinguisher.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'CHARGE - To pressurize a fire hose or fire extinguisher.' This means that the term 'charge' in firefighting refers to the process of pressurizing a fire hose or fire extinguisher. This is crucial for firefighters as it directly affects the effectiveness of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_58_2ebb6ff8",
          "question": "A 'Dutchman' is a technique used to deploy hose over distance from the engine to an objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'DUTCHMAN - A short fold or reverse bend used to allow couplings to pay out without them turning over.' This contradicts the statement as a 'Dutchman' is not a technique for deploying a hose, but a method to prevent couplings from turning over. Understanding this is important for firefighters as it affects hose deployment and management.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_58_d7323ca0",
          "question": "The 'Engine Port' is the smallest discharge opening on a fire hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'ENGINE PORT - The largest discharge opening on a fire hydrant. Same as \u201csteamer port.\u201d' This contradicts the statement as the 'Engine Port' is not the smallest, but the largest discharge opening on a fire hydrant. This is a crucial aspect for firefighters as it affects the volume of water that can be accessed during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_58_02890967",
          "question": "A 'Gated Wye' is an appliance that allows a single hose to be split into two hoses.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'GATED WYE - An appliance, equipped with manual valves, that allows a single hose to be split into two hoses.' This means that a 'Gated Wye' is indeed an appliance that allows a single hose to be split into two hoses. This is important for firefighters as it provides flexibility in water distribution during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_58_427d8587",
          "question": "The 'Higbee Cut' is a machined 90-degree angle cut into the threaded portion of couplings that allows for quick and easy threading.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'HIGBEE CUT - A machined 45-degree angle cut into the threaded portion of couplings that allows for quick and easy threading.' This contradicts the statement as the 'Higbee Cut' is not a 90-degree, but a 45-degree angle cut. Understanding this is important for firefighters as it affects the ease and speed of coupling hoses.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_100_2ac60065",
          "question": "The second member keeps the hose in a loop at the left side of the ladder while climbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The second member continues to climb, keeping the hose in a loop at the right side of the ladder.' This contradicts the question statement, which suggests the hose is kept on the left side. The correct side, as per the text, is the right side. This is important for maintaining balance and control while climbing the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_100_08d5c8b1",
          "question": "Upon reaching the top of the ladder, the second member passes the line hand over hand to the first member.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon reaching the top of the ladder, the member stops and grasps the hose leading up to the first member with the left arm between the rungs and passes the line hand over hand to the first member.' This supports the question statement. The procedure is crucial for ensuring the safe and efficient transfer of the hose between team members during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_100_917f9889",
          "question": "The last member secures the hose to the ladder with a clove hitch on the first rung below the windowsill.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The last member uses a body loop and secures the hose to the ladder with a clove hitch on the first rung above the windowsill.' This contradicts the question statement, which suggests the hose is secured below the windowsill. The correct position, as per the text, is above the windowsill. This is important for ensuring the hose is secured at a height that facilitates effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_100_687dc955",
          "question": "The third and any additional members follow the same procedures until the required amount of hose has been carried up and shoulder-loaded.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The third and any additional members follow the same procedures until the required amount of hose has been carried up and shoulder-loaded.' This supports the question statement. Following the same procedures ensures consistency and efficiency in firefighting operations, especially when multiple members are involved.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_100_fa8edec5",
          "question": "When the first bundle has been shoulder-loaded, the second member steps in off the ladder into the room and shoulder-loads the hose on the left shoulder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the first bundle has been shoulder-loaded, the second member steps in off the ladder into the room... The second member then shoulder-loads the hose on the right shoulder as it comes in the window (or onto the roof).' This contradicts the question statement, which suggests the hose is loaded on the left shoulder. The correct shoulder, as per the text, is the right shoulder. This is important for maintaining balance and control when handling the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_74_6428f013",
          "question": "The tie-rope should be removed when it is about 25 feet away from the tailboard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The tie -rope will have to be removed once about 25 feet away from the tailboard.' This indicates that the tie-rope should be removed at this distance. This is important in firefighting operations to ensure the proper handling and deployment of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_74_ba113468",
          "question": "The entire bundle consists of 200 feet of hose, 1 3/4\" nozzle, and 2 1/2\" to 1 1/2\" Bell Reducer.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Grasp the entire bundle (consisting of 200 feet of hose, 1 3/4\" nozzle, and 2 1/2\" to 1 1/2\" Bell Reducer).' This confirms the components of the bundle. Understanding the components of the bundle is crucial for firefighters as it affects the operations and tactics during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_74_060a613b",
          "question": "The hose should be pulled two-thirds of the way out of the slot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'pull it one -third of the way out of the slot.' This contradicts the statement that the hose should be pulled two-thirds of the way out. The correct procedure is to pull it one-third of the way out. This is important for firefighters to know to ensure proper handling and deployment of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_74_4056df08",
          "question": "The nozzle and front flakes should be at the chest level.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Pivot toward the hose; the nozzle and front flakes should be at the belt line.' This contradicts the statement that the nozzle and front flakes should be at the chest level. The correct position is at the belt line. This is crucial for firefighters to ensure proper handling and control of the hose during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_74_f464743f",
          "question": "One should step away from the engine in a straight line after pulling the bundles partially out of the slot.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Step away from the engine in a straight line and pull the remainder of the bundles completely out of the slot.' This confirms the procedure after pulling the bundles partially out of the slot. This is important for firefighters to ensure proper handling and deployment of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_62_c476a735",
          "question": "The male coupling should be laid on top of the hose about six feet from the female coupling when preparing for the double roll.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Beginning with the hose stretched flat, grasp the male coupling and carry it back toward the female coupling. Lay the male coupling on top of the hose about six feet from the female coupling.' This supports the statement and indicates the correct positioning of the male coupling during the double roll preparation. This is crucial for firefighters as incorrect positioning could lead to operational difficulties during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_62_4c4e6a57",
          "question": "The female coupling should be sticking out a foot or two beyond the male coupling at the base of the roll.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the roll reaches the male coupling, stop. The female coupling should be sticking out a foot or two beyond the male coupling at the base of the roll.' This supports the statement and indicates the correct positioning of the female coupling in relation to the male coupling. This is important for firefighters as it ensures the couplings are protected and ready for connection.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_62_5cdc3c98",
          "question": "The top layer of the hose will move backward as the roll progresses toward the couplings.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The top layer of hose will move forward as the roll progresses toward the couplings.' This contradicts the statement, indicating that the top layer of the hose moves forward, not backward, as the roll progresses. This is important for firefighters to understand as it affects the rolling process and the positioning of the couplings.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_62_d9575070",
          "question": "After the roll is completed, the two couplings should be left disconnected.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Next, lay the roll on its side and connect the two couplings.' This contradicts the statement, indicating that the couplings should be connected after the roll is completed. This is crucial for firefighters as it ensures the hose is secure and ready for transport or storage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_62_e5d3c328",
          "question": "A layer of hose should protect the couplings after they are connected.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A layer of hose should now protect the couplings.' This supports the statement and indicates that the couplings should be protected by a layer of hose after they are connected. This is important for firefighters as it helps to prevent damage to the couplings during transport or storage.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_103_97024433",
          "question": "What is the procedure for securing the hose to the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The hose is secured to the ladder using a clove hitch around the rung.",
          "options": {
            "A": "Using a clove hitch around the rung",
            "B": "Tying a knot around the rung",
            "C": "Using a body loop around the rung",
            "D": "Placing the nozzle over the rung"
          }
        },
        {
          "id": "sfd_basic_skills_103_87b97c57",
          "question": "What is the first action taken by the member at the bottom of the ladder after the hose is shoulder-loaded and carried to the window?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first action taken by the member at the bottom of the ladder is to break the hose at the first coupling on the ground.",
          "options": {
            "A": "He feeds one section to the member on the ground",
            "B": "He breaks the hose at the first coupling on the ground",
            "C": "He secures a body loop to the nozzle",
            "D": "He places the nozzle over the shoulder with the lead across the chest"
          }
        },
        {
          "id": "sfd_basic_skills_103_0c2fb617",
          "question": "What does the last member do with the nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The last member places the nozzle over the shoulder with the lead across the chest.",
          "options": {
            "A": "Places it over the shoulder with the lead across the chest",
            "B": "Secures a body loop to the nozzle behind the shut off",
            "C": "Ties it to the rung of the ladder",
            "D": "Feeds it to the member on the ground"
          }
        },
        {
          "id": "sfd_basic_skills_103_141980a6",
          "question": "What is the direction of pivot for all members after tying the hose to the rung of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "All members pivot to the left after tying the hose to the rung of the ladder.",
          "options": {
            "A": "To the right",
            "B": "To the left",
            "C": "Forward",
            "D": "Backward"
          }
        },
        {
          "id": "sfd_basic_skills_103_4c997760",
          "question": "What happens after the hose in the building is shoulder-loaded and carried to the window?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After the hose in the building is shoulder-loaded and carried to the window, the body loop is released from the ladder and the member climbs down the ladder.",
          "options": {
            "A": "The body loop is released from the ladder and the member climbs down the ladder",
            "B": "The member at the top lays the shoulder-load on the floor next to the opening",
            "C": "The member breaks the hose at the first coupling on the ground",
            "D": "The member feeds one section to the member on the ground"
          }
        },
        {
          "id": "sfd_basic_skills_98_6c069c65",
          "question": "Where should the shoulder-loads of hose be placed before carrying a hose line up a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The shoulder-loads of hose should be placed on the ground near the right beam of the ladder. This is to ensure easy access and efficient operation when climbing the ladder.",
          "options": {
            "A": "Next to the left beam of the ladder",
            "B": "On the ground near the right beam of the ladder",
            "C": "On the top rung of the ladder",
            "D": "In the firefighter's hands"
          }
        },
        {
          "id": "sfd_basic_skills_98_2080e7c3",
          "question": "How should the nozzle be positioned when carrying a hose line up a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The nozzle should be placed over the left shoulder with the hose crossing the front of the body to the right side. This positioning allows for better balance and control while climbing the ladder.",
          "options": {
            "A": "Over the right shoulder with the hose crossing the front of the body to the left side",
            "B": "In the firefighter's right hand",
            "C": "Over the left shoulder with the hose crossing the front of the body to the right side",
            "D": "In the firefighter's left hand"
          }
        },
        {
          "id": "sfd_basic_skills_98_b6aad719",
          "question": "What should a firefighter do immediately after securing a body loop to the hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After securing a body loop to the hose, the firefighter should immediately begin to climb the ladder. This is to ensure quick and efficient operation during firefighting activities.",
          "options": {
            "A": "Begin to climb the ladder",
            "B": "Check the nozzle for any blockages",
            "C": "Secure another body loop",
            "D": "Wait for another firefighter to climb first"
          }
        },
        {
          "id": "sfd_basic_skills_98_feddf67b",
          "question": "Where should the nozzle be in relation to the ladder when preparing to carry a hose line up a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The nozzle should be next to the ladder. This positioning allows for easy access and efficient operation when climbing the ladder.",
          "options": {
            "A": "The nozzle should be next to the ladder",
            "B": "The nozzle should be on the top rung of the ladder",
            "C": "The nozzle should be at the base of the ladder",
            "D": "The nozzle should be in the firefighter's hands"
          }
        },
        {
          "id": "sfd_basic_skills_98_e211b198",
          "question": "What knot is used to secure a body loop to the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A hose knot is used to secure a body loop to the hose. This knot is secure and easy to tie and untie, making it ideal for firefighting operations.",
          "options": {
            "A": "A square knot",
            "B": "A clove hitch",
            "C": "A hose knot",
            "D": "A bowline knot"
          }
        },
        {
          "id": "sfd_basic_skills_77_30eeb8da",
          "question": "What is the procedure if a second firefighter is not readily available or if additional hose is required to reach the objective?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The firefighter should shoulder load a second bundle on the left shoulder if a second firefighter is not readily available or if additional hose is required to reach the objective.",
          "options": {
            "A": "The firefighter should wait for a second firefighter to arrive.",
            "B": "The firefighter should shoulder load a second bundle on the right shoulder.",
            "C": "The firefighter should shoulder load a second bundle on the left shoulder.",
            "D": "The firefighter should drag an additional 100' of hose."
          }
        },
        {
          "id": "sfd_basic_skills_77_919f02d9",
          "question": "What is the next step after a firefighter shoulder-loads the nozzle bundle on their right shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After shoulder-loading the nozzle bundle on their right shoulder, the firefighter should turn back left toward the engine and grasp the bottom of the next bundle.",
          "options": {
            "A": "The firefighter should advance toward the objective.",
            "B": "The firefighter should turn back left toward the engine and grasp the bottom of the next bundle.",
            "C": "The firefighter should release bundle ties.",
            "D": "The firefighter should wait for a second firefighter to arrive."
          }
        },
        {
          "id": "sfd_basic_skills_77_997939ea",
          "question": "What should a firefighter do after shoulder-loading the second section on the left shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "After shoulder-loading the second section on the left shoulder, the firefighter should step away from apparatus with a bundle on each shoulder until the second bundle is completely removed from the apparatus.",
          "options": {
            "A": "The firefighter should wait for a second firefighter to arrive.",
            "B": "The firefighter should advance toward the objective.",
            "C": "The firefighter should release bundle ties.",
            "D": "The firefighter should step away from apparatus with a bundle on each shoulder until the second bundle is completely removed from the apparatus."
          }
        },
        {
          "id": "sfd_basic_skills_77_5dac7508",
          "question": "When should firefighters release bundle ties?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Firefighters should release bundle ties as the prior section plays out.",
          "options": {
            "A": "Before shoulder-loading the nozzle bundle on their right shoulder.",
            "B": "After shoulder-loading the second section on the left shoulder.",
            "C": "As the prior section plays out.",
            "D": "After the second bundle is completely removed from the apparatus."
          }
        },
        {
          "id": "sfd_basic_skills_77_fa23c593",
          "question": "What is the purpose of shoulder-loading a second bundle on the left shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The purpose of shoulder-loading a second bundle on the left shoulder is to reach the objective if additional hose is required.",
          "options": {
            "A": "To balance the weight of the hose.",
            "B": "To reach the objective if additional hose is required.",
            "C": "To wait for a second firefighter to arrive.",
            "D": "To release bundle ties."
          }
        },
        {
          "id": "sfd_basic_skills_61_fc3bf765",
          "question": "Why is it important to roll the hose without turns or twists according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Rolling the hose without turns or twists allows the hose to load more compactly, which is important for storage and transport.",
          "options": {
            "A": "It makes the hose look neater",
            "B": "It prevents damage to the hose",
            "C": "It allows the hose to load more compactly",
            "D": "It makes the hose easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_61_45f7b064",
          "question": "What is the purpose of rolling the hose from the highest grade of land to the lowest?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Rolling the hose from the highest grade of land to the lowest facilitates water drainage, which is important for the maintenance and longevity of the hose.",
          "options": {
            "A": "It makes the hose easier to roll",
            "B": "It facilitates water drainage",
            "C": "It prevents the hose from getting dirty",
            "D": "It makes the hose easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_61_1a34fbf2",
          "question": "Why is it important to clean and thoroughly dry the hose before single rolling it and placing it into storage?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Cleaning and thoroughly drying the hose before single rolling it and placing it into storage prevents the hose from getting moldy, which can damage the hose and affect its performance.",
          "options": {
            "A": "It prevents the hose from smelling bad",
            "B": "It prevents the hose from getting moldy",
            "C": "It makes the hose easier to roll",
            "D": "It makes the hose easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_61_6bdb2507",
          "question": "What is the purpose of a second member assisting with stretching and laying the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A second member assisting with stretching and laying the hose can expedite the operation, which is important for efficiency and time management in firefighting operations.",
          "options": {
            "A": "It makes the hose easier to roll",
            "B": "It makes the hose easier to carry",
            "C": "It expedites the operation",
            "D": "It prevents the hose from getting dirty"
          }
        },
        {
          "id": "sfd_basic_skills_61_f4ea6db8",
          "question": "What is the purpose of stamping out any protruding coils down into the roll?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Stamping out any protruding coils down into the roll prevents the hose from unrolling, which is important for storage and transport.",
          "options": {
            "A": "It makes the hose look neater",
            "B": "It prevents the hose from unrolling",
            "C": "It makes the hose easier to carry",
            "D": "It prevents damage to the hose"
          }
        },
        {
          "id": "sfd_basic_skills_57_1496fc2e",
          "question": "What is the role of attack lines in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Attack lines are hose lines or fire streams used to attack, contain, or prevent the spread of fire.",
          "options": {
            "A": "To connect hoses or stream devices together",
            "B": "To introduce air into a liquid",
            "C": "To attack, contain, or prevent the spread of fire",
            "D": "To store water"
          }
        },
        {
          "id": "sfd_basic_skills_57_c47a6851",
          "question": "What is the importance of a body loop in firefighter safety?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "A body loop is a piece of nylon sewn into a continuous loop with safe working loads computed at a 5:1 design failure. It has specific weight load limits to ensure safety.",
          "options": {
            "A": "It is used to connect hoses together",
            "B": "It is used to store water",
            "C": "It is used to introduce air into a liquid",
            "D": "It has specific weight load limits to ensure safety"
          }
        },
        {
          "id": "sfd_basic_skills_57_61929893",
          "question": "What is the function of a centrifugal pump in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A centrifugal pump is a pump with one or more impellers that utilizes centrifugal force to move the water.",
          "options": {
            "A": "It is used to attack, contain, or prevent the spread of fire",
            "B": "It utilizes centrifugal force to move the water",
            "C": "It is used to store water",
            "D": "It is used to connect hoses together"
          }
        },
        {
          "id": "sfd_basic_skills_57_6f2f3602",
          "question": "What is the role of an appliance in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "An appliance is any variety of tools or devices carried on an engine that connect hoses or stream devices together.",
          "options": {
            "A": "It is used to attack, contain, or prevent the spread of fire",
            "B": "It is used to connect hoses or stream devices together",
            "C": "It is used to store water",
            "D": "It is used to introduce air into a liquid"
          }
        },
        {
          "id": "sfd_basic_skills_57_f6ad1863",
          "question": "What is the significance of the term 'brass' in the context of firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "'Brass' is a term used to describe hose couplings, whether or not they are made of brass or the lighter and stronger composite material, pyrolite.",
          "options": {
            "A": "It refers to a type of fire engine",
            "B": "It refers to a type of protective clothing",
            "C": "It refers to a type of hose coupling",
            "D": "It refers to a type of fire attack line"
          }
        },
        {
          "id": "sfd_basic_skills_94_8eaf816f",
          "question": "In which situations would a firefighter need a neat and compact charged handline?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A neat and compact charged handline is required in high-rise buildings and areas with numerous obstacles as it allows the hose to be easily deployed to a desired location.",
          "options": {
            "A": "In open spaces with no obstacles",
            "B": "In high-rise buildings and areas with numerous obstacles",
            "C": "In areas with plenty of water supply",
            "D": "In areas with low fire intensity"
          }
        },
        {
          "id": "sfd_basic_skills_94_afa3e5aa",
          "question": "What is the benefit of coiling a hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Coiling a hose allows the nozzle and subsequent hose to pay off the top of the bundle, making it easily deployable to a desired location.",
          "options": {
            "A": "It increases the water pressure",
            "B": "It makes the hose lighter to carry",
            "C": "It allows the nozzle to pay off the top of the bundle and be easily deployed",
            "D": "It extends the length of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_94_04219f13",
          "question": "What should be done with the excess hose before untying the bundle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The excess hose should be laid down on the ground in a neat bundle. This helps in keeping the hose as orderly as possible.",
          "options": {
            "A": "It should be left hanging",
            "B": "It should be laid down on the ground in a neat bundle",
            "C": "It should be coiled around the firefighter's arm",
            "D": "It should be thrown away"
          }
        },
        {
          "id": "sfd_basic_skills_94_facd0a9f",
          "question": "What is the procedure for untying the hose bundle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hose bundle should be untied while kneeling, with the nozzle slid close to your knees. This is the most efficient way to handle the hose.",
          "options": {
            "A": "Untie it while standing",
            "B": "Untie it while kneeling, sliding the nozzle close to your knees",
            "C": "Untie it while sitting, sliding the nozzle close to your feet",
            "D": "Untie it while lying down, sliding the nozzle close to your chest"
          }
        },
        {
          "id": "sfd_basic_skills_94_322c75b5",
          "question": "What is the advantage of a firefighter carrying a charged coil on their shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Carrying a charged coil on their shoulder allows a firefighter to stretch the hose when required, providing flexibility in firefighting operations.",
          "options": {
            "A": "It increases the firefighter's mobility",
            "B": "It allows the firefighter to use the hose as a weapon",
            "C": "It allows the firefighter to carry more water",
            "D": "It allows the firefighter to stretch the hose when required"
          }
        },
        {
          "id": "sfd_basic_skills_82_bf5c9c6b",
          "question": "What is the first step in preparing the hose for loading onto the engine?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in preparing the hose for loading onto the engine is to arrange it in flakes near the rear of the engine.",
          "options": {
            "A": "Tie with a bundle tie around all but the top flake",
            "B": "Make a bight in the hose to form a flake of the desired length",
            "C": "Arrange it in flakes near the rear of the engine",
            "D": "Place the first male coupling hanging 4\" past the end of the bed"
          }
        },
        {
          "id": "sfd_basic_skills_82_bf29ad19",
          "question": "Why is it important to keep the hose free from twists and entanglements when loading onto the engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Keeping the hose free from twists and entanglements ensures it can be quickly and efficiently deployed when needed, which is crucial in firefighting operations.",
          "options": {
            "A": "To ensure the hose can be quickly and efficiently deployed when needed",
            "B": "To make the hose look neat and tidy",
            "C": "To prevent damage to the engine",
            "D": "To make the hose lighter and easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_82_41f3e1f6",
          "question": "Where should the first male coupling be placed when loading the hose onto the engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first male coupling should be placed hanging 4\" past the end of the bed at the far-right side of the open end of the hose bed.",
          "options": {
            "A": "At the far-right side of the open end of the hose bed",
            "B": "At the far-left side of the open end of the hose bed",
            "C": "In the middle of the open end of the hose bed",
            "D": "At the closed end of the hose bed"
          }
        },
        {
          "id": "sfd_basic_skills_82_68baffcc",
          "question": "What is the purpose of making a bight in the hose when loading it onto the engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Making a bight in the hose forms a flake of the desired length, which is important for efficient deployment and operation.",
          "options": {
            "A": "To form a flake of the desired length",
            "B": "To make the hose easier to carry",
            "C": "To prevent the hose from getting tangled",
            "D": "To make the hose look neat and tidy"
          }
        },
        {
          "id": "sfd_basic_skills_82_d463c879",
          "question": "Where should the first female coupling be left when building a vertical stack with bights?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first female coupling should be left at the top of the stack flush with the bights at the open end. This is important for proper hose deployment.",
          "options": {
            "A": "At the bottom of the stack",
            "B": "In the middle of the stack",
            "C": "At the top of the stack",
            "D": "The female coupling should not be included in the stack"
          }
        },
        {
          "id": "sfd_basic_skills_83_bab890fd",
          "question": "What is the purpose of placing the female end under the top flake during hose stacking?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Tucking the female end under the top flake is done to prevent twists in the hose, which could hinder firefighting operations.",
          "options": {
            "A": "To make the hose look neat",
            "B": "To prevent the hose from uncoiling",
            "C": "To prevent twists in the hose",
            "D": "To make the hose easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_83_4184e34f",
          "question": "What is the significance of ensuring the tip of the nozzle is even with the bights of prior bundles?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Ensuring the tip of the nozzle is even with the bights of prior bundles facilitates quick deployment of the hose, which is crucial in firefighting operations.",
          "options": {
            "A": "To ensure the hose is properly balanced",
            "B": "To make the hose easier to carry",
            "C": "To ensure proper water flow",
            "D": "To facilitate quick deployment of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_83_aafade9c",
          "question": "What is the 'Plan B' Bulk load used for?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'Plan B' Bulk load is used when the fire apparatus has a hose bed configuration that will not support five vertical stacks of hose. It consists of a flat load for the bottom 200' of 2 1/2\" hose with three vertical stacks of 100' instead of 5.",
          "options": {
            "A": "When the fire apparatus has a hose bed configuration that will not support five vertical stacks of hose",
            "B": "When there is a shortage of hoses",
            "C": "When the hoses are too long",
            "D": "When the hoses are too short"
          }
        },
        {
          "id": "sfd_basic_skills_83_46022064",
          "question": "Why should all bundles be tied about 18\" back from the bights?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Tying all bundles about 18\" back from the bights facilitates quick deployment of the hose, which is crucial in firefighting operations.",
          "options": {
            "A": "To prevent the hose from uncoiling",
            "B": "To make the hose easier to carry",
            "C": "To facilitate quick deployment of the hose",
            "D": "To make the hose look neat"
          }
        },
        {
          "id": "sfd_basic_skills_83_4e1efbe0",
          "question": "Where should the nozzle be placed in the last bundle in the bed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The nozzle should be placed on the bottom of the hose bed (left side) with the pistol grip up and the bale closed and down. This ensures that the nozzle is ready for immediate use during firefighting operations.",
          "options": {
            "A": "On the top of the hose bed",
            "B": "On the bottom of the hose bed with the pistol grip up and the bale closed and down",
            "C": "On the side of the hose bed",
            "D": "In the middle of the hose bed"
          }
        },
        {
          "id": "sfd_basic_skills_95_72efeda7",
          "question": "What is the importance of placing the nozzle end of the hose coming off the top of the coil?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Having the nozzle end of the hose coming off the top of the coil ensures quick deployment in firefighting operations, which is crucial in emergency situations.",
          "options": {
            "A": "It allows for easier storage",
            "B": "It makes the hose look more organized",
            "C": "It ensures quick deployment in firefighting operations",
            "D": "It prevents the hose from tangling"
          }
        },
        {
          "id": "sfd_basic_skills_95_3382f531",
          "question": "What is the next step after gathering every other flake and separating them from the rest of the bundle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After gathering every other flake and separating them from the rest of the bundle, the next step is to place the hose gathered in your arms away and to the front of the rest of the hose to create a coil.",
          "options": {
            "A": "Charge the line",
            "B": "Place the hose gathered in your arms away and to the front of the rest of the hose to create a coil",
            "C": "Roll the hose",
            "D": "Disconnect the hose"
          }
        },
        {
          "id": "sfd_basic_skills_95_b6e3ce2e",
          "question": "What is the purpose of charging the line?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Charging the line refers to filling the hose with water, preparing it for firefighting operations.",
          "options": {
            "A": "To fill the hose with water",
            "B": "To check for leaks in the hose",
            "C": "To increase the pressure in the hose",
            "D": "To prepare the hose for storage"
          }
        },
        {
          "id": "sfd_basic_skills_95_3a62d168",
          "question": "Why is it important to separate every other flake from the rest of the bundle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Separating every other flake from the rest of the bundle is a step in preparing the hose for coiling, which aids in efficient deployment.",
          "options": {
            "A": "To make the hose lighter",
            "B": "To prepare the hose for coiling",
            "C": "To check for damage",
            "D": "To make the hose longer"
          }
        },
        {
          "id": "sfd_basic_skills_95_7984b8c8",
          "question": "What could be a potential risk if the nozzle end of the hose is not coming off the top of the coil?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "If the nozzle end of the hose is not coming off the top of the coil, it could make the hose difficult to deploy quickly in firefighting operations, potentially delaying response times.",
          "options": {
            "A": "The hose could become tangled",
            "B": "The hose could be too short",
            "C": "The water pressure could be too low",
            "D": "The hose could be difficult to deploy quickly in firefighting operations"
          }
        },
        {
          "id": "sfd_basic_skills_56_8b93ef3e",
          "question": "Why is a well-organized deployment of fire hose essential in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A well-organized deployment of fire hose allows for the quick and effective application of water on fire, which directly contributes to the mission of saving lives and protecting property.",
          "options": {
            "A": "It looks professional and gives the public a positive perception of the department",
            "B": "It ensures that every firefighter has a role to play",
            "C": "It allows for the quick and effective application of water on fire, saving lives and protecting property",
            "D": "It makes the job of the firefighters easier"
          }
        },
        {
          "id": "sfd_basic_skills_56_da284930",
          "question": "What is the impact of a mistake in execution during a hose laying operation?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A mistake in execution during a hose laying operation can cause a delay, which can be detrimental as every second counts at a fire scene.",
          "options": {
            "A": "It can cause a delay, which can be detrimental as every second counts at a fire scene",
            "B": "It can lead to a negative public perception",
            "C": "It can result in the hose being damaged",
            "D": "It can make the firefighters look unprofessional"
          }
        },
        {
          "id": "sfd_basic_skills_56_f246ad91",
          "question": "Why is teamwork important in the deployment of fire hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Teamwork allows for the appropriate hose lays to be made quickly, which is essential as every second counts at a fire scene.",
          "options": {
            "A": "It ensures that the hose is laid out in a straight line",
            "B": "It allows for the appropriate hose lays to be made quickly",
            "C": "It prevents the hose from getting tangled",
            "D": "It makes the job of the firefighters easier"
          }
        },
        {
          "id": "sfd_basic_skills_56_9fc2acb9",
          "question": "What is the significance of the hose laying operation in relation to public perception?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The hose laying operation is often the most visible part of the job at a fire and effective and coordinated execution can give the public a positive perception of the department.",
          "options": {
            "A": "It is the most visible part of the job at a fire and can give the public a positive perception of the department",
            "B": "It shows the public how well the firefighters can work together",
            "C": "It demonstrates the technical skills of the firefighters",
            "D": "It shows the public how quickly the firefighters can put out a fire"
          }
        },
        {
          "id": "sfd_basic_skills_56_72a46cf4",
          "question": "Why is a diligent study of hose operations concepts important for a firefighter?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A diligent study of hose operations concepts aids in the development of the necessary confidence needed to work with a first-line team.",
          "options": {
            "A": "It helps in passing the firefighter certification exam",
            "B": "It aids in the development of the necessary confidence needed to work with a first-line team",
            "C": "It ensures that the firefighter knows how to use the hose",
            "D": "It makes the job of the firefighters easier"
          }
        },
        {
          "id": "sfd_basic_skills_60_27e16447",
          "question": "What is the function of a Ross Dump Valve in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Ross Dump Valve is plumbed into the intake side of the fire pump to mitigate any excess intake water pressure.",
          "options": {
            "A": "It is used to tighten or loosen couplings.",
            "B": "It is used to divide one larger hose line into three or more smaller hose lines.",
            "C": "It is used to mitigate any excess intake water pressure.",
            "D": "It is used to determine the shape and pattern of a water stream."
          }
        },
        {
          "id": "sfd_basic_skills_60_6dee7690",
          "question": "How does the Shaper affect firefighting tactics?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Shaper, part of a nozzle, rotates to determine the shape and pattern of a water stream. This affects firefighting tactics by controlling the water delivery.",
          "options": {
            "A": "It combines two hose lines into one.",
            "B": "It determines the shape and pattern of a water stream.",
            "C": "It mitigates excess intake water pressure.",
            "D": "It is used to carry a stack of hose flakes."
          }
        },
        {
          "id": "sfd_basic_skills_60_b5bc2811",
          "question": "What is the implication of a Water Hammer in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Water Hammer refers to the force created by the rapid deceleration of water. This can potentially damage equipment or cause injury if not properly managed.",
          "options": {
            "A": "It refers to an intake port or the intake side of an appliance.",
            "B": "It is the force created by the rapid deceleration of water.",
            "C": "It is a stack of hose flakes carried on the right shoulder.",
            "D": "It is a coupling with no distinct male or female components."
          }
        },
        {
          "id": "sfd_basic_skills_60_9f3bdff0",
          "question": "What is the purpose of a Siamese in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Siamese is an appliance that combines two hose lines into one, allowing for greater water flow or distribution.",
          "options": {
            "A": "It is used to carry a stack of hose flakes.",
            "B": "It is an appliance that makes two hose lines into one.",
            "C": "It is used to mitigate any excess intake water pressure.",
            "D": "It is used to tighten or loosen couplings."
          }
        },
        {
          "id": "sfd_basic_skills_60_18478ee3",
          "question": "What is the function of a Spanner Wrench in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A Spanner Wrench is a tool used to tighten or loosen couplings on firefighting hoses, ensuring secure connections and preventing leaks.",
          "options": {
            "A": "It is used to tighten or loosen couplings.",
            "B": "It is used to carry a stack of hose flakes.",
            "C": "It is used to mitigate any excess intake water pressure.",
            "D": "It is an appliance that makes two hose lines into one."
          }
        },
        {
          "id": "sfd_basic_skills_99_c93988e4",
          "question": "What is the purpose of securing a body loop to the hose at either a 50 or 100 foot interval?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The body loop secured to the hose provides a grip for the firefighter when climbing.",
          "options": {
            "A": "To provide a grip for climbing",
            "B": "To measure the length of the hose",
            "C": "To support the coupling while climbing",
            "D": "To mark the hose for replacement"
          }
        },
        {
          "id": "sfd_basic_skills_99_881f7232",
          "question": "What is the first action a firefighter should take upon reaching the top of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Before entering the room, the firefighter should test the floor for structural integrity to ensure it is safe.",
          "options": {
            "A": "Step into the room",
            "B": "Test the floor for structural integrity",
            "C": "Remove the body loop from the line",
            "D": "Shoulder-load the first section of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_99_00d6a772",
          "question": "Why does a firefighter step on the hose after reaching the top of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Stepping on the hose helps to counteract the weight of the line, making it easier to remove the body loop.",
          "options": {
            "A": "To prevent the hose from slipping",
            "B": "To counteract the weight of the line while removing the body loop",
            "C": "To check the pressure in the hose",
            "D": "To signal to other firefighters that it's safe to climb"
          }
        },
        {
          "id": "sfd_basic_skills_99_7a0d1634",
          "question": "Where should the nozzle be moved to when a firefighter is about to shoulder-load the first section of the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The nozzle is moved to the chest when the firefighter is about to shoulder-load the first section of the hose.",
          "options": {
            "A": "To the back",
            "B": "To the chest",
            "C": "To the right shoulder",
            "D": "To the left shoulder"
          }
        },
        {
          "id": "sfd_basic_skills_99_b33534eb",
          "question": "What should be done if there is a coupling at the designated interval for securing the body loop?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If there is a coupling at the designated interval, the body loop should be fastened just behind the coupling to support it while climbing.",
          "options": {
            "A": "The coupling should be removed",
            "B": "The body loop should be secured just behind the coupling",
            "C": "The body loop should be secured directly on the coupling",
            "D": "The coupling should be ignored"
          }
        },
        {
          "id": "sfd_basic_skills_76_d48c508d",
          "question": "What is the first step in handling a 2 1/2\" hose shoulder-load from a bulk bed according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step is to stand on the tailboard to reach the hose conveniently.",
          "options": {
            "A": "Pull the shoulder-load about one-third of the way out of the bed",
            "B": "Stand on the tailboard to reach the hose conveniently",
            "C": "Connect the hose to a water source",
            "D": "Break the hose"
          }
        },
        {
          "id": "sfd_basic_skills_76_370f47df",
          "question": "When should the hose not be broken according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The hose should not be broken until it is determined that the amount removed is sufficient, until the stretch has been completed, or if the hose is to be connected to a water source separate from the engine.",
          "options": {
            "A": "When it is determined that the amount removed is sufficient",
            "B": "When the hose is to be connected to a water source separate from the engine",
            "C": "When the stretch has been completed",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_76_3658fbc2",
          "question": "What is the correct position of the nozzle and front flakes when placing the bottom flake flat on the right shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The nozzle and front flakes should be at the belt line when placing the bottom flake flat on the right shoulder.",
          "options": {
            "A": "At the belt line",
            "B": "Above the head",
            "C": "On the left shoulder",
            "D": "On the ground"
          }
        },
        {
          "id": "sfd_basic_skills_76_3f38b536",
          "question": "How should the bundle be held after it is partially pulled out of the slot?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The bundle should be held tightly in front of the body with both hands after it is partially pulled out of the slot.",
          "options": {
            "A": "Hold the bundle tightly in front of the body with both hands",
            "B": "Hold the bundle loosely with one hand",
            "C": "Hold the bundle over the head with both hands",
            "D": "Hold the bundle behind the body with both hands"
          }
        },
        {
          "id": "sfd_basic_skills_76_59c97080",
          "question": "What should be done after pulling the remainder of the bundle completely out of the slot?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After pulling the remainder of the bundle completely out of the slot, one should step away from the engine in a straight line.",
          "options": {
            "A": "Break the hose",
            "B": "Connect the hose to a water source",
            "C": "Step away from the engine in a straight line",
            "D": "Return the bundle to the slot"
          }
        },
        {
          "id": "sfd_basic_skills_102_766f370e",
          "question": "Where should the initial shoulder-load of hose be placed in relation to the fire escape?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The initial shoulder-load of hose should be placed to the right of the fire escape, with all remaining shoulder-loads placed progressively to the right and slightly behind the first.",
          "options": {
            "A": "To the left of the fire escape",
            "B": "Directly on the fire escape",
            "C": "To the right of the fire escape",
            "D": "In the center of the fire escape"
          }
        },
        {
          "id": "sfd_basic_skills_102_4b07b553",
          "question": "What is the first action of the first member after stepping onto the fire escape landing?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After stepping onto the fire escape landing, the first member steps on the hose while removing their body loop and preparing to shoulder-load.",
          "options": {
            "A": "They immediately begin to climb with both hands on the beams of the fire escape ladder",
            "B": "They step on the hose while removing their body loop and preparing to shoulder-load",
            "C": "They secure a body loop to the nozzle, using a hose knot directly behind the nozzle shut off",
            "D": "They pass the hose hand over hand to the second member"
          }
        },
        {
          "id": "sfd_basic_skills_102_cd167f5e",
          "question": "What should the second member do after the first member has shoulder-loaded the first bundle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After the first member has shoulder-loaded the first bundle, the second member steps into the building and, if necessary, stands facing the landing with the hose to his/her left, bringing the hose across the chest from the left hip to the right shoulder, and begins shoulder-loading.",
          "options": {
            "A": "They should immediately begin to climb the ladder",
            "B": "They should step into the building and begin shoulder-loading",
            "C": "They should pass the hose hand over hand to the first member",
            "D": "They should secure a body loop 15 feet behind the first member"
          }
        },
        {
          "id": "sfd_basic_skills_102_5d366b5d",
          "question": "How should the first member secure the body loop to the nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first member secures a body loop to the nozzle, using a hose knot directly behind the nozzle shut off.",
          "options": {
            "A": "Using a hose knot directly behind the nozzle shut off",
            "B": "Using a simple knot at the nozzle",
            "C": "Using a double knot at the nozzle shut off",
            "D": "Using a hose knot directly in front of the nozzle shut off"
          }
        },
        {
          "id": "sfd_basic_skills_102_d3fa51c2",
          "question": "Where should additional members stand when attaching their body loops to the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Additional members, also standing to the left of the hose, attach their body loops to the hose at appropriate intervals.",
          "options": {
            "A": "To the right of the hose",
            "B": "Directly on the hose",
            "C": "To the left of the hose",
            "D": "In the center of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_109_48f81914",
          "question": "What does the number in the hose name represent in the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "In the Seattle Fire Department, the number in the hose name represents the inner diameter of the hose in inches.",
          "options": {
            "A": "The length of the hose in feet",
            "B": "The weight of the hose in pounds",
            "C": "The outer diameter of the hose in inches",
            "D": "The inner diameter of the hose in inches"
          }
        },
        {
          "id": "sfd_basic_skills_109_89faf93e",
          "question": "What is the largest hose size carried by the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "According to the text, the Seattle Fire Department carries hoses with inner diameters of 4 inches, 2 1/2 inches, and 1 3/4 inches. Therefore, the largest size is 4 inches.",
          "options": {
            "A": "1 3/4 inches",
            "B": "2 1/2 inches",
            "C": "3 inches",
            "D": "4 inches"
          }
        },
        {
          "id": "sfd_basic_skills_109_03014698",
          "question": "How might the inner diameter of a fire hose impact firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A larger inner diameter in a fire hose could potentially increase the water flow rate, which could be crucial in firefighting operations.",
          "options": {
            "A": "A larger diameter could increase the water flow rate",
            "B": "A smaller diameter could increase the water pressure",
            "C": "The diameter has no impact on firefighting operations",
            "D": "A larger diameter could make the hose lighter"
          }
        },
        {
          "id": "sfd_basic_skills_109_8811a096",
          "question": "Why is it important for firefighters to know the inner diameter of their hoses?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Knowing the inner diameter of a hose can help firefighters calculate the water flow rate, which is crucial for effective firefighting.",
          "options": {
            "A": "To determine the hose's color",
            "B": "To calculate the water flow rate",
            "C": "To know the manufacturer",
            "D": "To determine the hose's weight"
          }
        },
        {
          "id": "sfd_basic_skills_109_ec0c986b",
          "question": "What could be a potential safety consideration related to the inner diameter of a fire hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A larger diameter hose might be heavier and more difficult to handle, which could potentially impact firefighter safety.",
          "options": {
            "A": "A larger diameter hose might be more difficult to handle",
            "B": "A smaller diameter hose might be more prone to kinks",
            "C": "A larger diameter hose might be less visible",
            "D": "The inner diameter of a hose has no safety implications"
          }
        },
        {
          "id": "sfd_basic_skills_92_285ff054",
          "question": "What is the role of the third member when stretching from a standpipe outlet with three members present?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The third member anchors the line and makes the connection to the standpipe while the other two members make the stretch.",
          "options": {
            "A": "The third member returns to make the connection.",
            "B": "The third member drops the bell reducer and the top two flakes of the apartment bundle at the interior standpipe connection.",
            "C": "The third member anchors the line and makes the connection to the standpipe.",
            "D": "The third member operates the attack line."
          }
        },
        {
          "id": "sfd_basic_skills_92_837f1500",
          "question": "What is the first step in operating a single person 2 \u00bd\u201d line?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in operating a single person 2 \u00bd\u201d line is to form a loop in the nozzle end of the line approximately 18 feet in diameter.",
          "options": {
            "A": "Cross the nozzle under the hose allowing it to extend approximately 30 inches beyond the loop.",
            "B": "Secure the hose to itself at the crossing point with a body loop using a round turn and two half-hitches.",
            "C": "Form a loop in the nozzle end of the line approximately 18 feet in diameter.",
            "D": "Sit on the hose at the crossing point."
          }
        },
        {
          "id": "sfd_basic_skills_92_5e664913",
          "question": "What should the operator never remove his/her hands from while operating the attack line in a single person 2 \u00bd\u201d line configuration?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "While operating the attack line in a single person 2 \u00bd\u201d line configuration, the operator must never remove his/her hands from the bale.",
          "options": {
            "A": "The standpipe valve",
            "B": "The bell reducer",
            "C": "The bale",
            "D": "The pressure gauge"
          }
        },
        {
          "id": "sfd_basic_skills_92_d74dac95",
          "question": "When does the pump operator open the appropriate discharge valves when stretching from the engine?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The pump operator opens the appropriate discharge valves at the call for water, or as directed by the officer.",
          "options": {
            "A": "When the third member anchors the line and makes the connection to the standpipe.",
            "B": "At the call for water, or as directed by the officer.",
            "C": "When the operator sits on the hose at the crossing point.",
            "D": "When the nozzle is once again aimed toward the objective."
          }
        },
        {
          "id": "sfd_basic_skills_92_b066c791",
          "question": "What is the purpose of the operator sitting on the hose at the crossing point in a single person 2 \u00bd\u201d line operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The operator sits on the hose at the crossing point to hold the nozzle in place.",
          "options": {
            "A": "To prevent the hose from moving.",
            "B": "To maintain the loop in the nozzle end of the line.",
            "C": "To hold the nozzle in place.",
            "D": "To adjust the pressure of the water."
          }
        },
        {
          "id": "sfd_basic_skills_84_33b73693",
          "question": "Where should the male LDH coupling with a 4\u201d to 2\u00bd\u201d reducer coupling be placed when loading LDH?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The male LDH coupling with a 4\u201d to 2\u00bd\u201d reducer coupling should be placed on the right side of the hose bed, just past the open end.",
          "options": {
            "A": "On the left side of the hose bed",
            "B": "In the middle of the hose bed",
            "C": "On the right side of the hose bed",
            "D": "At the closed end of the hose bed"
          }
        },
        {
          "id": "sfd_basic_skills_84_3fe82120",
          "question": "What is formed at the closed end of the bed when loading LDH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "At the closed end of the bed, a bight is formed in the hose.",
          "options": {
            "A": "A knot",
            "B": "A bight",
            "C": "A loop",
            "D": "A coil"
          }
        },
        {
          "id": "sfd_basic_skills_84_6b6b5831",
          "question": "What is the correct way to position the hose after forming a bight at the closed end of the bed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After forming a bight at the closed end of the bed, the hose should be led back up toward the open end, keeping it directly on top of the first flake for about half the distance and then adjusting it so that it runs against and parallel to the first flake for the remainder of the distance.",
          "options": {
            "A": "Lead the hose back up toward the open end, keeping it directly on top of the first flake for the entire distance",
            "B": "Lead the hose back up toward the open end, keeping it directly on top of the first flake for about half the distance and then adjusting it so that it runs against and parallel to the first flake for the remainder of the distance",
            "C": "Lead the hose back up toward the open end, keeping it directly on top of the first flake for about half the distance and then adjusting it so that it runs perpendicular to the first flake for the remainder of the distance",
            "D": "Lead the hose back up toward the open end, keeping it directly on top of the first flake for about half the distance and then adjusting it so that it runs diagonally to the first flake for the remainder of the distance"
          }
        },
        {
          "id": "sfd_basic_skills_84_bff13f1b",
          "question": "What is the purpose of using a 4\u201d to 2\u00bd\u201d reducer coupling when loading LDH?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A 4\u201d to 2\u00bd\u201d reducer coupling is used to connect hoses of different diameters.",
          "options": {
            "A": "To increase the water flow",
            "B": "To reduce the water flow",
            "C": "To connect hoses of different diameters",
            "D": "To prevent hose kinks"
          }
        },
        {
          "id": "sfd_basic_skills_84_7cd2e9e3",
          "question": "What is the potential safety implication of not properly loading the LDH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Improperly loading the LDH could cause the hose to kink or become tangled, which can hinder firefighting operations.",
          "options": {
            "A": "It could lead to a slower response time",
            "B": "It could cause the hose to kink or become tangled",
            "C": "It could cause the fire truck to tip over",
            "D": "It could cause the water pressure to be too high"
          }
        },
        {
          "id": "sfd_basic_skills_105_fd7503be",
          "question": "What is the role of the first member in securing the hose to the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first member secures the line to the ladder using a clove hitch around the rung above the hose, allowing them to manipulate the hose and nozzle.",
          "options": {
            "A": "They secure the line to the ladder using a clove hitch around the rung above the hose.",
            "B": "They foot the ladder and provide stability.",
            "C": "They assist in placing the nozzle by lifting on the hose.",
            "D": "They climb down one rung and tie their body loops to the ladder."
          }
        },
        {
          "id": "sfd_basic_skills_105_8ea7bf49",
          "question": "What is the importance of adjusting the slack out of the body loop?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Adjusting the slack out of the body loop compensates for the nozzle reaction, allowing the first member to manipulate the hose and nozzle.",
          "options": {
            "A": "It allows the first member to climb down the ladder.",
            "B": "It compensates for the nozzle reaction.",
            "C": "It provides stability to the ladder.",
            "D": "It helps in tying the body loops to the ladder."
          }
        },
        {
          "id": "sfd_basic_skills_105_578bc092",
          "question": "What is the role of the second and third members after the first member secures the line to the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After the first member secures the line to the ladder, the second and third members climb down one rung and tie their body loops to the ladder, adjusting them to take a strain on the line.",
          "options": {
            "A": "They climb down one rung and tie their body loops to the ladder.",
            "B": "They secure the ladder tip to the building.",
            "C": "They assist in placing the nozzle by lifting on the hose.",
            "D": "They climb up the ladder to a position one rung below the first member."
          }
        },
        {
          "id": "sfd_basic_skills_105_393201eb",
          "question": "Why does the second member climb to a position one rung below the first member?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The second member climbs to a position one rung below the first member to reach around the body of the first member and grasp the beams with both hands, holding both members safely on the ladder.",
          "options": {
            "A": "To secure the line to the ladder.",
            "B": "To hold both members safely on the ladder.",
            "C": "To foot the ladder and provide stability.",
            "D": "To tie their body loops to the ladder."
          }
        },
        {
          "id": "sfd_basic_skills_105_7ab9c9a7",
          "question": "What is the role of the third member after the second member climbs up the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After the second member climbs up the ladder, the third member climbs down and foots the ladder, providing stability.",
          "options": {
            "A": "They secure the line to the ladder.",
            "B": "They assist in placing the nozzle by lifting on the hose.",
            "C": "They foot the ladder.",
            "D": "They climb to a position one rung below the first member."
          }
        },
        {
          "id": "sfd_basic_skills_71_136afbac",
          "question": "What is the correct method to carry a shoulder-load hose to an objective?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The correct method to carry a shoulder-load hose to an objective is to pull and lift the shoulder-load with the arm and leg muscles, not the back muscles. The flakes should be maintained in an upright position.",
          "options": {
            "A": "Pull and lift the shoulder-load with the back muscles",
            "B": "Maintain the flakes of the shoulder-load in a horizontal position",
            "C": "Position the flakes with two-thirds of the length in front of the body",
            "D": "Pull and lift the shoulder-load with the arm and leg muscles, maintaining the flakes in an upright position"
          }
        },
        {
          "id": "sfd_basic_skills_71_2e92881d",
          "question": "What should be done to prevent the hose from dragging on the ground?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Adjusting the load is necessary to prevent the hose from dragging on the ground.",
          "options": {
            "A": "Adjust the load",
            "B": "Increase the pressure",
            "C": "Decrease the pressure",
            "D": "Change the nozzle"
          }
        },
        {
          "id": "sfd_basic_skills_71_4212414a",
          "question": "What should be done after the hydrant has been shut down and all couplings have been broken?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After the hydrant has been shut down and all couplings have been broken, the hose line should be straightened and all kinks eliminated to allow drainage.",
          "options": {
            "A": "Start with the coupling closest to the engine",
            "B": "Straighten the hose line and eliminate all kinks to allow drainage",
            "C": "Increase the pressure in the hose",
            "D": "Leave the hose as it is"
          }
        },
        {
          "id": "sfd_basic_skills_71_31e3bd80",
          "question": "Where should the initial coupling be placed when shoulder-loading a hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When shoulder-loading a hose, the initial coupling should be placed against the front of the body about chest high.",
          "options": {
            "A": "Against the back of the body about waist high",
            "B": "Against the front of the body about chest high",
            "C": "Over the left shoulder",
            "D": "On the ground"
          }
        },
        {
          "id": "sfd_basic_skills_71_2e00db65",
          "question": "Where should the shoulder-load be laid once it is carried to the engine?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Once the shoulder-load is carried to the engine, it should be laid on the ground in position for loading, parallel to the tailboard and three feet away.",
          "options": {
            "A": "On top of the engine",
            "B": "In the engine",
            "C": "On the ground in position for loading, parallel to the tailboard and three feet away",
            "D": "In front of the engine"
          }
        },
        {
          "id": "sfd_basic_skills_88_757722c4",
          "question": "What is the purpose of leaving the top three bights untied when loading the hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Leaving the top three bights untied allows for slack while shoulder-loading and advancing the line, providing flexibility and ease of movement during operations.",
          "options": {
            "A": "To allow for slack while shoulder-loading and advancing the line",
            "B": "To make the hose lighter",
            "C": "To make the hose look neat",
            "D": "To make it easier to connect the hose to the outlet"
          }
        },
        {
          "id": "sfd_basic_skills_88_6fd6e419",
          "question": "Where should the hose leading from the discharge outlet be tucked?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hose leading from the discharge outlet should be tucked between the hose bundle and the left side wall of the slot. This helps to secure the hose and keep it in place.",
          "options": {
            "A": "Between the hose bundle and the right side wall of the slot",
            "B": "Between the hose bundle and the left side wall of the slot",
            "C": "On top of the hose bundle",
            "D": "Underneath the hose bundle"
          }
        },
        {
          "id": "sfd_basic_skills_88_b9a0d2ae",
          "question": "What is the final step in loading the hose according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The final step in loading the hose, as per the Seattle Fire Department, is connecting the final female coupling to the pre-connect discharge outlet. This ensures the hose is ready for use.",
          "options": {
            "A": "Tying the 200-foot load and nozzle with a tie rope",
            "B": "Tucking the hose between the hose bundle and the left side wall of the slot",
            "C": "Leaving the top three bights untied",
            "D": "Connecting the final female coupling to the pre-connect discharge outlet"
          }
        },
        {
          "id": "sfd_basic_skills_88_163a303f",
          "question": "Why is it important to wedge just the top few inches of the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Wedging just the top few inches of the hose helps to keep the top flakes securely in position. This prevents them from moving or falling out of place during operations.",
          "options": {
            "A": "To make the hose lighter",
            "B": "To keep the top flakes securely in position",
            "C": "To make the hose look neat",
            "D": "To make it easier to connect the hose to the outlet"
          }
        },
        {
          "id": "sfd_basic_skills_88_56dd1e5d",
          "question": "What is the purpose of tying the 200-foot load and nozzle with a tie rope?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Tying the 200-foot load and nozzle with a tie rope helps to secure them during operations. This prevents them from moving or becoming dislodged, which could interfere with firefighting efforts.",
          "options": {
            "A": "To make the hose look neat",
            "B": "To make the hose lighter",
            "C": "To secure the load and nozzle during operations",
            "D": "To make it easier to connect the hose to the outlet"
          }
        },
        {
          "id": "sfd_basic_skills_67_c3cdf840",
          "question": "What is the correct direction to turn the swivel when making the coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The swivel of the female coupling should be turned in a clockwise direction to make the coupling.",
          "options": {
            "A": "Counter-clockwise",
            "B": "Clockwise",
            "C": "Either direction",
            "D": "Upwards"
          }
        },
        {
          "id": "sfd_basic_skills_67_78aa2afa",
          "question": "Why is it important for the member with the male coupling to look completely away during the coupling process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member with the male coupling should look completely away to eliminate the tendency to assist, allowing the other member to align the couplings.",
          "options": {
            "A": "To avoid eye injury",
            "B": "To eliminate the tendency to assist",
            "C": "To allow the other member to take control",
            "D": "To focus on other tasks"
          }
        },
        {
          "id": "sfd_basic_skills_67_f235e21f",
          "question": "What is the correct direction to turn the swivel when breaking the coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The swivel of the female coupling should be turned in a counter-clockwise direction to break the coupling.",
          "options": {
            "A": "Clockwise",
            "B": "Counter-clockwise",
            "C": "Either direction",
            "D": "Downwards"
          }
        },
        {
          "id": "sfd_basic_skills_67_c8f62d4b",
          "question": "Where should the member with the female coupling grasp when aligning the couplings?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The member with the female coupling should grasp the bowl with the left hand and the swivel with the right hand when aligning the couplings.",
          "options": {
            "A": "The bowl with the left hand and the swivel with the right hand",
            "B": "The swivel with both hands",
            "C": "The bowl with both hands",
            "D": "The swivel with the left hand and the bowl with the right hand"
          }
        },
        {
          "id": "sfd_basic_skills_67_e5f937ec",
          "question": "What is the final step in making the coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The final step in making the coupling is to grasp both the swivel and bowl with both hands and turn clockwise, aligning the creases.",
          "options": {
            "A": "Turn the swivel counter-clockwise",
            "B": "Grasp both the swivel and bowl with both hands and turn clockwise",
            "C": "Release the male coupling",
            "D": "Align the creases"
          }
        },
        {
          "id": "sfd_basic_skills_89_1f8f7759",
          "question": "What is the purpose of keeping the bottom and/or middle flake of the bottom 100 feet intentionally long?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Keeping the bottom and/or middle flake of the bottom 100 feet intentionally long allows a single firefighter to reach back and stretch the entire 200 feet of the hose.",
          "options": {
            "A": "To make the hose look tidy",
            "B": "To add extra weight to the hose",
            "C": "To facilitate a single member reaching back to stretch the entire 200 feet",
            "D": "To make the hose easier to roll up"
          }
        },
        {
          "id": "sfd_basic_skills_89_c4b08072",
          "question": "Where should the female coupling of the first bundle be placed when arranging the hose for loading?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The female coupling of the first bundle should be nearest the tailboard when arranging the hose for loading.",
          "options": {
            "A": "At the open end of the slot",
            "B": "Nearest the tailboard",
            "C": "At the discharge port",
            "D": "On top of the previously loaded hose"
          }
        },
        {
          "id": "sfd_basic_skills_89_8eceef48",
          "question": "What should be done when there is 10 feet or less remaining of the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When there is 10 feet or less remaining of the hose, the hose and the male coupling are passed on top of the previously loaded hose and out of the closed end of the hose bed.",
          "options": {
            "A": "The hose should be disconnected from the discharge port",
            "B": "The hose and the male coupling are passed on top of the previously loaded hose and out of the closed end of the hose bed",
            "C": "The hose should be extended 6 to 9 inches from the slot opening",
            "D": "The hose should be loaded into the hose slot in a vertical stack"
          }
        },
        {
          "id": "sfd_basic_skills_89_ed70cbd4",
          "question": "How far should the flakes at the open end of the slot extend from the slot opening?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The flakes at the open end of the slot should extend 6 to 9 inches from the slot opening.",
          "options": {
            "A": "3 to 5 inches",
            "B": "6 to 9 inches",
            "C": "10 to 12 inches",
            "D": "15 to 18 inches"
          }
        },
        {
          "id": "sfd_basic_skills_89_74169a0c",
          "question": "To which part of the engine should the female end of the 2 \u00bd\u201d hose be connected?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The female end of the 2 \u00bd\u201d hose should be connected to the appropriate discharge port.",
          "options": {
            "A": "The tailboard",
            "B": "The hose slot",
            "C": "The appropriate discharge port",
            "D": "The closed end of the hose bed"
          }
        },
        {
          "id": "sfd_basic_skills_66_11a0c489",
          "question": "What is the purpose of stepping behind the bowl of the male coupling when connecting hoses?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Stepping behind the bowl of the male coupling changes the angle of the coupling with relation to the ground, making the connection easier.",
          "options": {
            "A": "To change the angle of the coupling making the connection easier",
            "B": "To prevent the hose from moving",
            "C": "To ensure the firefighter's safety",
            "D": "To test the strength of the coupling"
          }
        },
        {
          "id": "sfd_basic_skills_66_2c266823",
          "question": "In which direction should you turn the swivel of the female coupling to make the coupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To make the coupling, the swivel of the female coupling should be turned in a clockwise direction.",
          "options": {
            "A": "Counter-clockwise",
            "B": "Clockwise",
            "C": "Either direction",
            "D": "Depends on the type of hose"
          }
        },
        {
          "id": "sfd_basic_skills_66_7f33a182",
          "question": "What is the correct method to break the coupling?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "To break the coupling, the swivel should be turned in a counter-clockwise direction.",
          "options": {
            "A": "Turn the swivel in a clockwise direction",
            "B": "Pull the male and female couplings apart",
            "C": "Turn the swivel in a counter-clockwise direction",
            "D": "Apply pressure on the bowl of the male coupling"
          }
        },
        {
          "id": "sfd_basic_skills_66_ae0c29ae",
          "question": "What is the purpose of placing the coupling on the end of a short double fold?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Placing the coupling on the end of a short double fold aids in tilting it upward, making it easier to connect.",
          "options": {
            "A": "To make the hose longer",
            "B": "To aid in tilting it upward",
            "C": "To prevent the hose from kinking",
            "D": "To test the strength of the coupling"
          }
        },
        {
          "id": "sfd_basic_skills_66_00410271",
          "question": "What is the purpose of stepping on the short double fold during the alternate stepping on hose method?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Stepping on the short double fold during the alternate stepping on hose method aids in rotating the coupling, making it easier to connect.",
          "options": {
            "A": "To prevent the hose from moving",
            "B": "To change the angle of the coupling",
            "C": "To aid in rotating the coupling",
            "D": "To test the strength of the coupling"
          }
        },
        {
          "id": "sfd_basic_skills_70_e2864b95",
          "question": "When connecting a male hose coupling to a nozzle, which direction should the nozzle be turned?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The nozzle should be turned in a clockwise direction until seated hand tight.",
          "options": {
            "A": "Counterclockwise",
            "B": "Clockwise",
            "C": "Either direction",
            "D": "No specific direction"
          }
        },
        {
          "id": "sfd_basic_skills_70_db45c395",
          "question": "What is the role of the member with the male coupling during the hose connection process?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member with the male coupling grasps the bowl with both hands, holding the coupling in a horizontal plane. They make no attempt to align the couplings and need to look away completely to avoid the tendency to assist.",
          "options": {
            "A": "To align the couplings",
            "B": "To turn the nozzle",
            "C": "To hold the coupling in a horizontal plane",
            "D": "To assist the member with the nozzle"
          }
        },
        {
          "id": "sfd_basic_skills_70_325dbe14",
          "question": "What is the correct way to handle a nozzle with a movable swivel?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the female coupling of the nozzle has a movable swivel, grasp the barrel with the left hand and turn the swivel with the right hand in a clockwise direction until tightly seated.",
          "options": {
            "A": "Grasp the barrel with the right hand and turn the swivel with the left hand",
            "B": "Grasp the barrel with both hands and turn the swivel with the right hand",
            "C": "Grasp the barrel with the left hand and turn the swivel with the right hand",
            "D": "Grasp the swivel with both hands and turn the barrel with the right hand"
          }
        },
        {
          "id": "sfd_basic_skills_70_83bab3aa",
          "question": "Who is responsible for aligning the coupling of the nozzle with the coupling on the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member with the nozzle is responsible for aligning the coupling of the nozzle with the coupling on the hose.",
          "options": {
            "A": "The member with the male coupling",
            "B": "The member with the nozzle",
            "C": "Both members equally",
            "D": "Neither, it should align naturally"
          }
        },
        {
          "id": "sfd_basic_skills_70_61c30354",
          "question": "What is the potential hazard if the member with the male coupling tries to assist in aligning the couplings?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member with the male coupling needs to look away completely to avoid the tendency to assist, which could lead to misalignment of the couplings.",
          "options": {
            "A": "It may cause the hose to kink",
            "B": "It may result in a loose connection",
            "C": "It may lead to misalignment of the couplings",
            "D": "It may cause the nozzle to turn in the wrong direction"
          }
        },
        {
          "id": "sfd_basic_skills_104_1c462f0d",
          "question": "Where should the first member attach the body loop to the line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first member attaches a body loop to the line with a hose knot 12 inches behind the coupling to which the nozzle is attached.",
          "options": {
            "A": "At the nozzle",
            "B": "12 inches behind the coupling to which the nozzle is attached",
            "C": "10 feet behind the first member",
            "D": "At the end of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_104_6667d9e9",
          "question": "At what angle should the members approach the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The members approach the ladder at a 45-degree angle.",
          "options": {
            "A": "90 degrees",
            "B": "45 degrees",
            "C": "30 degrees",
            "D": "60 degrees"
          }
        },
        {
          "id": "sfd_basic_skills_104_2d95dbcf",
          "question": "Where should the second and third members keep the hose while climbing the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The second and third members keep the hose clear of the ladder and to the right side.",
          "options": {
            "A": "To the left side of the ladder",
            "B": "In front of the ladder",
            "C": "To the right side of the ladder",
            "D": "Behind the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_104_cec12625",
          "question": "When should the first member stop climbing the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first member stops when the head is even with the first opening above the windowsill.",
          "options": {
            "A": "When the head is even with the first opening above the windowsill",
            "B": "When the head is below the first opening above the windowsill",
            "C": "When the head is above the first opening above the windowsill",
            "D": "When the head is at the same level as the windowsill"
          }
        },
        {
          "id": "sfd_basic_skills_104_ced3e7db",
          "question": "What should the first member do after reaching the first opening above the windowsill?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first member then grasps the beam of the ladder with the left hand and guides the nozzle over the first rung above the sill with the right hand.",
          "options": {
            "A": "Continue climbing",
            "B": "Grasp the beam of the ladder with the left hand and guide the nozzle over the first rung above the sill with the right hand",
            "C": "Pass the hose to the second member",
            "D": "Detach the body loop"
          }
        },
        {
          "id": "sfd_basic_skills_112_45aef38a",
          "question": "What is the primary function of a coupling in the context of firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In the context of firefighting, a coupling is primarily used to connect or adapt different sizes or types of hoses or connections.",
          "options": {
            "A": "To increase the pressure of the water",
            "B": "To change the direction of the water flow",
            "C": "To connect or adapt different sizes or types of hoses",
            "D": "To control the speed of the water flow"
          }
        },
        {
          "id": "sfd_basic_skills_112_205cdea7",
          "question": "What does it mean when a coupling is described as an 'increaser'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "An 'increaser' coupling increases the size of the hose from the female end to the male end.",
          "options": {
            "A": "It increases the pressure of the water",
            "B": "It increases the size of the hose from the female end to the male end",
            "C": "It increases the speed of the water flow",
            "D": "It increases the distance the water can reach"
          }
        },
        {
          "id": "sfd_basic_skills_112_10415ee7",
          "question": "Why would a firefighter use a 'soft suction adapter' or 'Red Dot Coupling'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A 'soft suction adapter' or 'Red Dot Coupling' is used to adapt male NST threads to female ST threads.",
          "options": {
            "A": "To increase the size of the hose",
            "B": "To adapt male NST threads to female ST threads",
            "C": "To connect a hose to a hydrant",
            "D": "To reduce the size of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_112_d0417f2b",
          "question": "In most engine evolutions, in which direction does the water flow?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In most engine evolutions, water flows from the female end to the male end.",
          "options": {
            "A": "From the male end to the female end",
            "B": "From the female end to the male end",
            "C": "From the hydrant to the hose",
            "D": "From the hose to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_112_7e59b79e",
          "question": "What is the purpose of the hydrant adapter?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The hydrant adapter is used both to connect the 4\u201d hose to a hydrant and to adapt male ST threads to female NST threads.",
          "options": {
            "A": "To connect the 4\u201d hose to a hydrant",
            "B": "To increase the size of the hose",
            "C": "To adapt male ST threads to female NST threads",
            "D": "Both A and C"
          }
        },
        {
          "id": "sfd_basic_skills_85_3e9584de",
          "question": "What is the correct procedure for forming a bight in the hose according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct procedure is to form a bight in the hose and keep it even with the open end of the hose bed.",
          "options": {
            "A": "Form a bight at the closed end and keep it even with the open end of the hose bed.",
            "B": "Form a bight at the open end and keep it even with the closed end of the hose bed.",
            "C": "Form a bight in the hose and keep it even with the open end of the hose bed.",
            "D": "Form a bight in the hose and keep it even with the closed end of the hose bed."
          }
        },
        {
          "id": "sfd_basic_skills_85_b4f9dfe0",
          "question": "Where should the next coupling be positioned when loading the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The next coupling should be positioned within three feet of the open end.",
          "options": {
            "A": "Within three feet of the closed end.",
            "B": "Within three feet of the open end.",
            "C": "At the halfway point of the hose bed.",
            "D": "At the end of the hose bed."
          }
        },
        {
          "id": "sfd_basic_skills_85_a08c7f71",
          "question": "What is the correct procedure when reaching the left side of the bed while forming flakes?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon reaching the left side of the bed, flakes should be formed in the opposite direction back toward the right side.",
          "options": {
            "A": "Continue in the same direction.",
            "B": "Form flakes in the opposite direction back toward the right side.",
            "C": "Stop and start from the right side.",
            "D": "Form flakes in the same direction back toward the right side."
          }
        },
        {
          "id": "sfd_basic_skills_85_ac1f79f3",
          "question": "What is the correct procedure when the next coupling is reached while loading the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the next coupling is reached, the next section of hose should be connected and the coupling should be positioned within three feet of the open end.",
          "options": {
            "A": "Disconnect the next section of hose.",
            "B": "Connect the next section of hose and position the coupling within three feet of the closed end.",
            "C": "Connect the next section of hose and position the coupling within three feet of the open end.",
            "D": "Connect the next section of hose and position the coupling at the halfway point of the hose bed."
          }
        },
        {
          "id": "sfd_basic_skills_85_2d1045dd",
          "question": "What should be done when the full complement of hose has been loaded?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Additional layers should be formed in the same manner, keeping the couplings within three feet of the open end, until the full complement of hose has been loaded.",
          "options": {
            "A": "Form additional layers in the same manner, keeping the couplings within three feet of the closed end.",
            "B": "Form additional layers in the same manner, keeping the couplings within three feet of the open end.",
            "C": "Stop and start from the right side.",
            "D": "Form additional layers in a different manner, keeping the couplings within three feet of the open end."
          }
        },
        {
          "id": "sfd_basic_skills_93_31d7ead0",
          "question": "What is one of the rules that always apply when advancing attack lines, regardless of the line being charged or uncharged?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon arrival at the objective, any remaining hose line must be arranged to be free of kinks and easily advanced.",
          "options": {
            "A": "A minimum of three members shall be assigned to any hose line entering a building.",
            "B": "Upon arrival at the objective, any remaining hose line must be arranged to be free of kinks and easily advanced.",
            "C": "Control of the nozzle must be relinquished at times.",
            "D": "The hose line should be arranged in a disorganized manner."
          }
        },
        {
          "id": "sfd_basic_skills_93_2d5f7044",
          "question": "What should be considered when deploying the final sections of hose outside a building?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The most efficient way to deploy the final sections of hose, prior to charging the hose with water, is to create large flakes.",
          "options": {
            "A": "Create large flakes and lay down the excess hose that is intended to enter the structure.",
            "B": "Ignore any obstacles and charge the attack line inside the building.",
            "C": "Set down the hose bundle directly in front of the entry point.",
            "D": "Charge the hose less than 10 feet away from the front door."
          }
        },
        {
          "id": "sfd_basic_skills_93_cab7df35",
          "question": "What is the best practice to avoid when setting down a hose bundle?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "It is usually a best practice to avoid setting down a hose bundle directly in front of the entry point.",
          "options": {
            "A": "Setting it down directly in front of the entry point.",
            "B": "Preparing and charging your hose 10 or more feet away from the front door.",
            "C": "Creating large flakes.",
            "D": "Maintaining control of the nozzle at all times."
          }
        },
        {
          "id": "sfd_basic_skills_93_531bbd67",
          "question": "What should be done to ensure easy deployment when the hose charges?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the hose charges, it will be in an orientation that will allow easy deployment if it is stretched straight back from the intended objective.",
          "options": {
            "A": "Stretch the hose straight back from the intended objective.",
            "B": "Create small flakes.",
            "C": "Charge the hose inside the building.",
            "D": "Set down the hose bundle directly in front of the entry point."
          }
        },
        {
          "id": "sfd_basic_skills_93_a77d9f37",
          "question": "What should be paid attention to when entering a building with a hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Pay attention to the building you are entering and orient your long flakes to ensure that the front door is not the first 'pinch' point that will create excess friction.",
          "options": {
            "A": "The color of the building.",
            "B": "The building's architecture style.",
            "C": "The orientation of the long flakes to ensure that the front door is not the first 'pinch' point.",
            "D": "The number of windows in the building."
          }
        },
        {
          "id": "sfd_basic_skills_108_66231117",
          "question": "What is the recommended procedure for cleaning a fire hose that has been in contact with oils, tars, or chemicals?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests using a mild soap or detergent for cleaning hoses that have been in contact with oils, tars, or chemicals.",
          "options": {
            "A": "Wash with water only",
            "B": "Use a mild soap or detergent",
            "C": "Leave it to dry naturally",
            "D": "Use a strong industrial cleaner"
          }
        },
        {
          "id": "sfd_basic_skills_108_d48762b9",
          "question": "What is the procedure for a hose that has been used to pump saltwater?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that a hose that has been used to pump saltwater should be thoroughly washed and flushed with water before drying.",
          "options": {
            "A": "It should be dried immediately",
            "B": "It should be thoroughly washed and flushed with water before drying",
            "C": "It should be left to dry naturally",
            "D": "It should be replaced"
          }
        },
        {
          "id": "sfd_basic_skills_108_45924be4",
          "question": "What should be done with the fire hose if it has not been used for thirty days?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that any hose not used for thirty days should be rotated.",
          "options": {
            "A": "It should be discarded",
            "B": "It should be used regardless of its condition",
            "C": "It should be rotated",
            "D": "It should be cleaned and dried"
          }
        },
        {
          "id": "sfd_basic_skills_108_b543f91d",
          "question": "What should be checked on the female hose couplings after each use?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the female hose couplings should be checked for gaskets after each use.",
          "options": {
            "A": "The size of the coupling",
            "B": "The color of the coupling",
            "C": "The gaskets",
            "D": "The weight of the coupling"
          }
        },
        {
          "id": "sfd_basic_skills_108_9f153725",
          "question": "What should be done to the nozzles after each use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that nozzles should be visually inspected after each use to ensure that the molded rubber fog teeth are undamaged.",
          "options": {
            "A": "They should be replaced",
            "B": "They should be visually inspected",
            "C": "They should be cleaned with a mild detergent",
            "D": "They should be left as they are"
          }
        },
        {
          "id": "sfd_basic_skills_69_001e150b",
          "question": "What is the correct method to attach a nozzle using the one member standing method?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct method is to grasp the coupling with the left hand and rotate the nozzle clockwise.",
          "options": {
            "A": "Grasp the nozzle with the left hand and rotate counter-clockwise",
            "B": "Grasp the coupling with the right hand and rotate clockwise",
            "C": "Grasp the coupling with the left hand and rotate clockwise",
            "D": "Grasp the nozzle with the right hand and rotate counter-clockwise"
          }
        },
        {
          "id": "sfd_basic_skills_69_4e1fc99c",
          "question": "How should you remove the nozzle using the one member standing method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To remove the nozzle, you should rotate it counter-clockwise while bracing the male coupling with the left hand.",
          "options": {
            "A": "Rotate the nozzle clockwise while bracing the male coupling with the left hand",
            "B": "Rotate the nozzle counter-clockwise while bracing the male coupling with the left hand",
            "C": "Rotate the nozzle clockwise while bracing the male coupling with the right hand",
            "D": "Rotate the nozzle counter-clockwise while bracing the male coupling with the right hand"
          }
        },
        {
          "id": "sfd_basic_skills_69_206bc797",
          "question": "What is the correct method to attach a nozzle using the stepping on hose method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The correct method is to step on the folds with the left foot and rotate the nozzle clockwise.",
          "options": {
            "A": "Step on the folds with the right foot and rotate the nozzle counter-clockwise",
            "B": "Step on the folds with the left foot and rotate the nozzle clockwise",
            "C": "Step on the folds with the right foot and rotate the nozzle clockwise",
            "D": "Step on the folds with the left foot and rotate the nozzle counter-clockwise"
          }
        },
        {
          "id": "sfd_basic_skills_69_327b723f",
          "question": "How should you remove the nozzle using the stepping on hose method?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "To remove the nozzle, you should rotate it counter-clockwise with the left foot stepping on the hose.",
          "options": {
            "A": "Rotate the nozzle clockwise with the left foot stepping on the hose",
            "B": "Rotate the nozzle counter-clockwise with the right foot stepping on the hose",
            "C": "Rotate the nozzle clockwise with the right foot stepping on the hose",
            "D": "Rotate the nozzle counter-clockwise with the left foot stepping on the hose"
          }
        },
        {
          "id": "sfd_basic_skills_69_027a2736",
          "question": "Why is it important to ensure the nozzle is hand tight when attaching it?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Ensuring the nozzle is hand tight is important to prevent it from detaching during operation, to protect the hose from damage, and to maintain the water pressure.",
          "options": {
            "A": "To prevent the nozzle from detaching during operation",
            "B": "To ensure the hose is not damaged",
            "C": "To ensure the water pressure is maintained",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_86_7c5ace5f",
          "question": "Where should the male coupling of the first bundle be positioned when preparing the hose for loading?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The male coupling of the first bundle should be nearest the tailboard.",
          "options": {
            "A": "At the front of the engine",
            "B": "Nearest the tailboard",
            "C": "On the top bundle",
            "D": "In the middle of the bundle"
          }
        },
        {
          "id": "sfd_basic_skills_86_f3ae3173",
          "question": "What should be attached to the female on the top bundle?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A 2 \u00bd\u201d to 1 \u00bd\u201d Bell reducer should be attached to the female on the top bundle.",
          "options": {
            "A": "A 2 \u00bd\u201d to 1 \u00bd\u201d Bell reducer",
            "B": "A 1 \u00be\u201d nozzle",
            "C": "The male of the second bundle",
            "D": "A quick release knot"
          }
        },
        {
          "id": "sfd_basic_skills_86_3f146e3e",
          "question": "How should the tie ropes be tied?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Tie ropes should be tied tight and with a quick release knot positioned at the top of the bundle.",
          "options": {
            "A": "Loosely and with a quick release knot positioned at the bottom of the bundle",
            "B": "Tightly and with a quick release knot positioned at the top of the bundle",
            "C": "Tightly and with a quick release knot positioned at the bottom of the bundle",
            "D": "Loosely and with a quick release knot positioned at the top of the bundle"
          }
        },
        {
          "id": "sfd_basic_skills_86_d1b84831",
          "question": "What should be done with the last flake of the first section?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The last flake of the first section should be left out of the tied bundle.",
          "options": {
            "A": "It should be left out of the tied bundle",
            "B": "It should be included in the tied bundle",
            "C": "It should be attached to the male of the second bundle",
            "D": "It should be attached to the 1 \u00be\u201d nozzle"
          }
        },
        {
          "id": "sfd_basic_skills_86_0d4c08be",
          "question": "How should the 1 \u00be\u201d nozzle be placed on the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 1 \u00be\u201d nozzle should be placed on the hose with the bale down and closed and the pistol grip up.",
          "options": {
            "A": "With the bale up and open and the pistol grip down",
            "B": "With the bale down and closed and the pistol grip up",
            "C": "With the bale up and closed and the pistol grip down",
            "D": "With the bale down and open and the pistol grip up"
          }
        },
        {
          "id": "sfd_basic_skills_90_617afec7",
          "question": "What is the correct orientation of the nozzle when loading the second 100 feet of the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The nozzle bale should be down and the pistol grip should be up when loading the second 100 feet of the hose.",
          "options": {
            "A": "Nozzle bale up and pistol grip down",
            "B": "Nozzle bale down and pistol grip up",
            "C": "Nozzle bale and pistol grip both up",
            "D": "Nozzle bale and pistol grip both down"
          }
        },
        {
          "id": "sfd_basic_skills_90_54db806b",
          "question": "How far should the flakes extend from the open end of the slot when loading the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The flakes should extend 6 to 9 inches from the open end of the slot when loading the hose.",
          "options": {
            "A": "3 to 6 inches",
            "B": "6 to 9 inches",
            "C": "9 to 12 inches",
            "D": "12 to 15 inches"
          }
        },
        {
          "id": "sfd_basic_skills_90_e904d912",
          "question": "What is the correct position of the hose after the second bundle is loaded?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The hose should be flush with the nozzle tip after the second bundle is loaded.",
          "options": {
            "A": "Flush with the nozzle tip",
            "B": "Protruding beyond the nozzle tip",
            "C": "Below the nozzle tip",
            "D": "Above the nozzle tip"
          }
        },
        {
          "id": "sfd_basic_skills_90_88dd6e84",
          "question": "What is the final step in preparing the hose bundle for deployment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The final step in preparing the hose bundle for deployment is connecting the male end of the first section of hose to the remaining female coupling from the second section.",
          "options": {
            "A": "Connecting the male end of the first section of hose to the remaining female coupling from the second section",
            "B": "Placing the nozzle in the slot",
            "C": "Flaking the hose in vertical stacks",
            "D": "Attaching the nozzle to the second bundle"
          }
        },
        {
          "id": "sfd_basic_skills_90_2f448310",
          "question": "Which part of the hose should be even with the protruding folds of the first bundle when loading the second bundle?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The tip of the hose should be even with the protruding folds of the first bundle when loading the second bundle.",
          "options": {
            "A": "The nozzle bale",
            "B": "The pistol grip",
            "C": "The male end of the first section",
            "D": "The tip"
          }
        },
        {
          "id": "sfd_basic_skills_65_4523b2fb",
          "question": "What is the potential consequence of over-tightening a hose connection?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Over-tightening of a connection by two members should be avoided since the connection may have to be broken (uncoupled) by one member.",
          "options": {
            "A": "It may cause the hose to burst",
            "B": "It may be difficult for one member to uncouple",
            "C": "It may cause the hose to leak",
            "D": "It may cause the hose to kink"
          }
        },
        {
          "id": "sfd_basic_skills_65_168ae5db",
          "question": "What is the general rule for making or breaking couplings?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The general rule is that couplings are made or broken while facing the male coupling and turning the female swivel clockwise to make, and counter-clockwise to break connections.",
          "options": {
            "A": "Turn the female swivel clockwise to break and counter-clockwise to make connections",
            "B": "Turn the male coupling clockwise to make and counter-clockwise to break connections",
            "C": "Turn the female swivel clockwise to make and counter-clockwise to break connections",
            "D": "Turn the male coupling counter-clockwise to make and clockwise to break connections"
          }
        },
        {
          "id": "sfd_basic_skills_65_8ad8f275",
          "question": "What should be checked before connections are started?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Before connections are started, the female coupling should be checked to ensure the gasket is in place.",
          "options": {
            "A": "The male coupling should be checked to ensure the gasket is in place",
            "B": "The female coupling should be checked to ensure the gasket is in place",
            "C": "The hose should be checked to ensure it is not kinked",
            "D": "The pressure in the hose should be checked"
          }
        },
        {
          "id": "sfd_basic_skills_65_ffd1dd81",
          "question": "What is the Higbee marker used for?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Higbee marker identifies a point on the coupling where the first full thread starts.",
          "options": {
            "A": "To identify the point on the coupling where the first full thread starts",
            "B": "To identify the point on the coupling where the last thread ends",
            "C": "To identify the point on the coupling where the gasket is located",
            "D": "To identify the point on the coupling where the swivel starts"
          }
        },
        {
          "id": "sfd_basic_skills_65_459eddd1",
          "question": "When coupling a hose without the Higbee marker, how can you tell when the threads of both couplings are aligned?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When coupling hose without the Higbee marker, turn the female swivel counter-clockwise against the male coupling until a slight click is felt between the two couplings. At that point, the threads of both couplings are aligned.",
          "options": {
            "A": "A slight click is felt between the two couplings",
            "B": "The female swivel can no longer be turned",
            "C": "The male coupling can no longer be turned",
            "D": "A slight resistance is felt when turning the female swivel"
          }
        },
        {
          "id": "sfd_basic_skills_73_e0a3cc5f",
          "question": "What is the first step in the shoulder-loading hose procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step is to stand on the tailboard to reach the hose with good body mechanics.",
          "options": {
            "A": "Pull the entire bundle out of the slot",
            "B": "Stand on the tailboard to reach the hose",
            "C": "Place the bottom flake of the bundle on the right shoulder",
            "D": "Pull the hose one-third of the way out of the slot"
          }
        },
        {
          "id": "sfd_basic_skills_73_7fe927ac",
          "question": "What is the correct position for the nozzle and front flakes during the shoulder-loading hose procedure?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The nozzle and front flakes should be positioned at the belt line.",
          "options": {
            "A": "At the belt line",
            "B": "On the right shoulder",
            "C": "In front of the body",
            "D": "At the top of the bundle"
          }
        },
        {
          "id": "sfd_basic_skills_73_c16505d3",
          "question": "Why is it important to grip the hose flakes to allow the hose to pay out gradually from the top, one flake at a time?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Gripping the hose flakes in this way allows the firefighter to maintain control over the hose as it is being extended.",
          "options": {
            "A": "To prevent the hose from tangling",
            "B": "To ensure the hose is fully extended",
            "C": "To maintain control over the hose",
            "D": "To reduce the weight of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_73_d7d4f61d",
          "question": "What should you do after holding the bundle tightly in front of the body with both hands during the shoulder-loading hose procedure?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After holding the bundle tightly in front of the body with both hands, you should step away from the engine in a straight line and pull the remainder of the bundle completely out of the slot.",
          "options": {
            "A": "Pull the remainder of the bundle completely out of the slot",
            "B": "Turn your back towards the hose slot",
            "C": "Place the bottom flake of the bundle on the right shoulder",
            "D": "Stand on the tailboard to reach the hose"
          }
        },
        {
          "id": "sfd_basic_skills_73_9ea6aba9",
          "question": "What is the purpose of moving away from the engine in a straight line during the shoulder-loading hose procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Moving away from the engine in a straight line helps to stretch out the slack behind the shoulder-load.",
          "options": {
            "A": "To ensure the hose is fully extended",
            "B": "To stretch out the slack behind the shoulder-load",
            "C": "To prevent the hose from tangling",
            "D": "To maintain control over the hose"
          }
        },
        {
          "id": "sfd_basic_skills_107_5b38f81a",
          "question": "What is the potential consequence of operating hydrants too quickly?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Fast operation of hydrants can cause water hammer, which could result in a broken water main or meter.",
          "options": {
            "A": "It may cause a fire",
            "B": "It can result in a broken water main or meter",
            "C": "It may cause the hydrant to explode",
            "D": "It can cause the water to freeze"
          }
        },
        {
          "id": "sfd_basic_skills_107_c2ca48e6",
          "question": "Why is it important to stand clear of the hydrant caps during operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Water pressure in hydrants can be as high as 150 psi, causing the caps to potentially blow off during operation.",
          "options": {
            "A": "The caps can get extremely hot",
            "B": "The caps can blow off due to high water pressure",
            "C": "The caps can emit harmful gases",
            "D": "The caps can attract lightning"
          }
        },
        {
          "id": "sfd_basic_skills_107_8bf42fe8",
          "question": "What could happen if a hydrant is left to drain out from the base for a length of time with the drain valve running?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the hydrant is left to drain out from the base for a length of time with the drain valve running, it may damage the drip valve rubber and necessitate valve replacement.",
          "options": {
            "A": "It may cause a flood",
            "B": "It can damage the drip valve rubber and necessitate valve replacement",
            "C": "It can cause the water to become contaminated",
            "D": "It can cause the hydrant to become unstable"
          }
        },
        {
          "id": "sfd_basic_skills_107_90647e62",
          "question": "What is the recommended position for operating a hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hydrant should always be operated in a fully opened or fully closed position.",
          "options": {
            "A": "Half-opened position",
            "B": "Quarter-opened position",
            "C": "Fully opened or fully closed position",
            "D": "Three-quarters opened position"
          }
        },
        {
          "id": "sfd_basic_skills_107_cbf0b282",
          "question": "What could happen if you over tighten while closing hydrants?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Over tightening while closing hydrants may contribute to breaking the main stem of the hydrant.",
          "options": {
            "A": "It may contribute to breaking the main stem of the hydrant",
            "B": "It can cause the water to become contaminated",
            "C": "It can cause the hydrant to explode",
            "D": "It may cause a flood"
          }
        },
        {
          "id": "sfd_basic_skills_111_6834299f",
          "question": "What is the term used to describe a coupling with the same thread, orientation, and size on both ends?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A coupling with the same thread, orientation, and size on both ends is referred to as a double female or a double male.",
          "options": {
            "A": "Sister Coupling",
            "B": "Double Female or Double Male",
            "C": "Red Dot Coupling",
            "D": "Brother Coupling"
          }
        },
        {
          "id": "sfd_basic_skills_111_182e3802",
          "question": "What is the difference between a 'Brother Coupling' and a 'Sister Coupling'?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Both Brother and Sister Couplings have the same thread and orientation on both ends but they are of unequal size.",
          "options": {
            "A": "The Brother Coupling is larger in size",
            "B": "The Sister Coupling has a different thread orientation",
            "C": "There is no difference, they are the same",
            "D": "They have the same thread and orientation on both ends but are of unequal size"
          }
        },
        {
          "id": "sfd_basic_skills_111_230f752c",
          "question": "What are the safety considerations when using a double female or double male coupling in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When using a double female or double male coupling, it's important to ensure the thread orientation matches the hose and to check the size of the coupling for safety.",
          "options": {
            "A": "Ensuring the thread orientation matches the hose",
            "B": "Checking the size of the coupling",
            "C": "Both A and B",
            "D": "None of the above"
          }
        },
        {
          "id": "sfd_basic_skills_111_53b66833",
          "question": "What is the term used to describe a coupling that has the same thread and orientation on both ends but they are of unequal size?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A coupling that has the same thread and orientation on both ends but they are of unequal size is referred to as either a sister coupling or brother coupling.",
          "options": {
            "A": "Double Female or Double Male",
            "B": "Red Dot Coupling",
            "C": "Sister or Brother Coupling",
            "D": "Storz to 4\u201d (NST) Adapter"
          }
        },
        {
          "id": "sfd_basic_skills_111_6742760c",
          "question": "What is the operational implication of using a coupling with unequal size ends in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Using a coupling with unequal size ends (sister or brother coupling) allows for the connection of hoses of different sizes.",
          "options": {
            "A": "It can increase the water flow",
            "B": "It can decrease the water flow",
            "C": "It can connect hoses of different sizes",
            "D": "It can cause the hose to burst"
          }
        },
        {
          "id": "sfd_basic_skills_110_add70d0c",
          "question": "What is the correct term used to refer to hose couplings in the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, in the Seattle Fire Department, hose couplings are generally referred to as 'couplings', not adapters.",
          "options": {
            "A": "Adapters",
            "B": "Connectors",
            "C": "Couplings",
            "D": "Attachments"
          }
        },
        {
          "id": "sfd_basic_skills_110_caa58528",
          "question": "Which hose coupling would you use to decrease the size of the hose from 4\u201d to 2 \u00bd\u201d?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 4\u201d to 2 \u00bd\u201d Reducer is used to decrease the size of the hose from 4\u201d to 2 \u00bd\u201d.",
          "options": {
            "A": "4\u201d Double Male",
            "B": "4\u201d to 2 \u00bd\u201d Reducer",
            "C": "2 \u00bd\u201d to 4\u201d Increaser",
            "D": "2 \u00bd\u201d Double Female"
          }
        },
        {
          "id": "sfd_basic_skills_110_fa698261",
          "question": "In a situation where you need to connect two hoses with female ends, which coupling should you use?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 2 \u00bd\u201d Double Male coupling is used to connect two hoses with female ends.",
          "options": {
            "A": "2 \u00bd\u201d Double Male",
            "B": "4\u201d Double Female",
            "C": "2 \u00bd\u201d to 4\u201d Increaser",
            "D": "4\u201d Double Male"
          }
        },
        {
          "id": "sfd_basic_skills_110_1b8aa954",
          "question": "What type of coupling would you use for a 'Jiffy-hose'?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 2 \u00bd\u201d to \u00be\u201d Reducer is used for a 'Jiffy-hose'.",
          "options": {
            "A": "2 \u00bd\u201d to \u00be\u201d Reducer",
            "B": "2 \u00bd\u201d to 1 \u00bd\u201d Reducer",
            "C": "4\u201d to 2 \u00bd\u201d Reducer",
            "D": "2 \u00bd\u201d to 4\u201d Increaser"
          }
        },
        {
          "id": "sfd_basic_skills_110_5b6a82c1",
          "question": "What could be the potential safety implications of using the wrong hose coupling during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Using the wrong hose coupling could lead to a decrease in water pressure, cause the hose to burst, or cause the hose to disconnect, all of which could have serious safety implications during firefighting operations.",
          "options": {
            "A": "It could lead to a decrease in water pressure",
            "B": "It could cause the hose to burst",
            "C": "It could cause the hose to disconnect",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_106_70e0c253",
          "question": "What should be closed for safety while climbing a ladder during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "For safety, both the bale and the shaper of the nozzle should be closed while climbing a ladder.",
          "options": {
            "A": "The nozzle bale and shaper",
            "B": "The helmet visor and gloves",
            "C": "The oxygen tank and mask",
            "D": "The fire hose and water pump"
          }
        },
        {
          "id": "sfd_basic_skills_106_83f8019a",
          "question": "When drilling, how should the nozzle bale be operated?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When drilling, the nozzle bale should only be operated at one-quarter of its open position.",
          "options": {
            "A": "At full open position",
            "B": "At half of its open position",
            "C": "At one-quarter of its open position",
            "D": "It should not be operated"
          }
        },
        {
          "id": "sfd_basic_skills_106_7a441abf",
          "question": "What is the correct method of lowering a charged line down a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Lowering a charged line down a ladder is accomplished in the same way that the charged line was taken up the ladder, except in reverse order.",
          "options": {
            "A": "In the same way that the charged line was taken up the ladder, but in reverse order",
            "B": "In a completely different way than the charged line was taken up the ladder",
            "C": "In the same way that the charged line was taken up the ladder, but in the same order",
            "D": "The method is not specified"
          }
        },
        {
          "id": "sfd_basic_skills_106_70d02325",
          "question": "What is the implication of operating the nozzle bale at one-quarter of its open position during drilling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Operating the nozzle bale at one-quarter of its open position during drilling decreases the water pressure.",
          "options": {
            "A": "It increases the water pressure",
            "B": "It decreases the water pressure",
            "C": "It increases the risk of injury",
            "D": "It has no implication"
          }
        },
        {
          "id": "sfd_basic_skills_106_1a47548a",
          "question": "What is the safety implication of closing both the bale and the shaper of the nozzle while climbing a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Closing both the bale and the shaper of the nozzle while climbing a ladder prevents accidental discharge of water, which could cause a safety hazard.",
          "options": {
            "A": "It prevents accidental discharge of water",
            "B": "It increases the water pressure",
            "C": "It decreases the water pressure",
            "D": "It has no safety implication"
          }
        },
        {
          "id": "sfd_basic_skills_72_a44bdaee",
          "question": "What is the most important part of the bundle to 'dress' if you are in a hurry to accomplish a hose lay?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The front third of the bundle is the most important part to 'dress' when in a hurry to accomplish a hose lay.",
          "options": {
            "A": "The back third of the bundle",
            "B": "The middle third of the bundle",
            "C": "The front third of the bundle",
            "D": "All parts are equally important"
          }
        },
        {
          "id": "sfd_basic_skills_72_66a0d161",
          "question": "What is the correct way to lift the hose bundle?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hose bundle should be lifted using the leg muscles and avoiding twisting the back to prevent injury.",
          "options": {
            "A": "Using the back muscles",
            "B": "Using the arm muscles",
            "C": "Using the leg muscles and avoiding twisting the back",
            "D": "Using the shoulder muscles"
          }
        },
        {
          "id": "sfd_basic_skills_72_c36043a8",
          "question": "Where should you stand when 'dressing' the hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "You should stand alongside the hose, adjacent to the nozzle, male coupling, or the last flake to be extended.",
          "options": {
            "A": "Adjacent to the nozzle, male coupling, or the last flake to be extended",
            "B": "At the back of the hose",
            "C": "In the middle of the hose",
            "D": "At a distance from the hose"
          }
        },
        {
          "id": "sfd_basic_skills_72_a0cc513c",
          "question": "What is the correct position of the flakes when shoulder-loading the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The flakes should be stacked vertically on top of each other when shoulder-loading the hose.",
          "options": {
            "A": "The flakes should be stacked horizontally",
            "B": "The flakes should be stacked diagonally",
            "C": "The flakes should be stacked vertically",
            "D": "The position of the flakes does not matter"
          }
        },
        {
          "id": "sfd_basic_skills_72_e608d9d1",
          "question": "What is the correct procedure when lifting the forward bights from the ground?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "You should use both hands to gather and squeeze the flakes together when lifting the forward bights from the ground.",
          "options": {
            "A": "Using one hand, gather and squeeze the flakes together",
            "B": "Using both hands, gather and squeeze the flakes together",
            "C": "Using both hands, pull the flakes apart",
            "D": "Using one hand, pull the flakes apart"
          }
        },
        {
          "id": "sfd_basic_skills_64_4a0ab830",
          "question": "What is the potential problem with the traditional method of unrolling a hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The traditional method of unrolling a hose could potentially damage the male coupling as it snaps downward against the ground from the momentum of the unrolling action.",
          "options": {
            "A": "The hose can become tangled",
            "B": "The male coupling could become damaged",
            "C": "It requires too much space",
            "D": "It takes too much time"
          }
        },
        {
          "id": "sfd_basic_skills_64_dc3cca5c",
          "question": "Why might the butterfly method be a better choice for unrolling a hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The butterfly method avoids the problem of potential damage to the male coupling that can occur with the traditional method.",
          "options": {
            "A": "It is faster",
            "B": "It prevents the hose from tangling",
            "C": "It avoids potential damage to the male coupling",
            "D": "It requires less physical strength"
          }
        },
        {
          "id": "sfd_basic_skills_64_dc18e343",
          "question": "What can happen to couplings when they are violently handled?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When couplings are violently handled, they can become 'out of round'.",
          "options": {
            "A": "They can become 'out of round'",
            "B": "They can become disconnected",
            "C": "They can become tangled",
            "D": "They can become elongated"
          }
        },
        {
          "id": "sfd_basic_skills_64_de962039",
          "question": "What is the final step in the butterfly method of unrolling a hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The final step in the butterfly method of unrolling a hose is to grasp the male coupling from the center of the roll and walk away, stretching the hose out on the ground.",
          "options": {
            "A": "Grasp the male coupling from the center of the roll and walk away",
            "B": "Continue pulling successive layers to alternate sides",
            "C": "Grasp the first layer of hose on the roll",
            "D": "Stand the roll on edge"
          }
        },
        {
          "id": "sfd_basic_skills_64_9e553eef",
          "question": "Why is the butterfly method especially useful when space is limited?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The butterfly method is useful when space is limited because it requires less space to unroll the hose compared to the traditional method.",
          "options": {
            "A": "It requires less space to unroll the hose",
            "B": "It is faster than the traditional method",
            "C": "It prevents the hose from tangling",
            "D": "It requires less physical strength"
          }
        },
        {
          "id": "sfd_basic_skills_91_30874e3f",
          "question": "What factors contribute to the severity of nozzle reaction during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The severity of the nozzle reaction is determined by the pressure of the water and the size of the nozzle's tip.",
          "options": {
            "A": "The size of the fire and the distance from the fire",
            "B": "The pressure of the water and the size of the nozzle's tip",
            "C": "The number of firefighters and the type of fire",
            "D": "The type of nozzle and the temperature of the water"
          }
        },
        {
          "id": "sfd_basic_skills_91_70a82159",
          "question": "What is the minimum number of members required to operate a 2 \u00bd\u201d attack line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A 2 \u00bd\u201d attack line requires a minimum of two members to operate.",
          "options": {
            "A": "One",
            "B": "Two",
            "C": "Three",
            "D": "Four"
          }
        },
        {
          "id": "sfd_basic_skills_91_57806248",
          "question": "What should be done before opening the bale of any nozzle?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Firefighters must be prepared to control the nozzle reaction before opening the bale of any nozzle.",
          "options": {
            "A": "Check the pressure of the water",
            "B": "Ensure the fire is under control",
            "C": "Prepare to control the nozzle reaction",
            "D": "Ensure all members are at a safe distance"
          }
        },
        {
          "id": "sfd_basic_skills_91_aadbc76a",
          "question": "What should be done as soon as the line has been connected or anchored?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "As soon as the line has been connected or anchored, the valves or gates should be checked.",
          "options": {
            "A": "Release the bundle tie ropes",
            "B": "Check the valves or gates",
            "C": "Open the bale of the nozzle",
            "D": "Start spraying water"
          }
        },
        {
          "id": "sfd_basic_skills_91_85774159",
          "question": "What is the recommended number of members for increased safety and mobility when operating a 2 \u00bd\u201d attack line?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "For increased safety and mobility, three or four members are recommended to operate a 2 \u00bd\u201d attack line.",
          "options": {
            "A": "One",
            "B": "Two",
            "C": "Three or four",
            "D": "Five or six"
          }
        },
        {
          "id": "sfd_basic_skills_68_484cd95f",
          "question": "What is the correct direction to apply force when uncoupling a hose using spanner wrenches?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, force is applied in a counter-clockwise direction when uncoupling a hose using spanner wrenches.",
          "options": {
            "A": "Clockwise",
            "B": "Counter-clockwise",
            "C": "Upwards",
            "D": "Downwards"
          }
        },
        {
          "id": "sfd_basic_skills_68_20d6b407",
          "question": "How does the member on the side of the female coupling assist in uncoupling the hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the female coupling side assists by positioning a spanner wrench on the lug of the female swivel and turning it in a counter-clockwise direction until the connection is broken.",
          "options": {
            "A": "Turns the spanner wrench in a clockwise direction",
            "B": "Turns the spanner wrench in a counter-clockwise direction",
            "C": "Applies force upwards",
            "D": "Does not assist"
          }
        },
        {
          "id": "sfd_basic_skills_68_9405ca91",
          "question": "What is the role of the member on the side of the male coupling during hose uncoupling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the side of the male coupling positions a spanner wrench on the lug of the bowl and applies force in a counter-clockwise direction.",
          "options": {
            "A": "Applies force in a clockwise direction",
            "B": "Applies force in a counter-clockwise direction",
            "C": "Does not participate in the uncoupling process",
            "D": "Holds the hose steady"
          }
        },
        {
          "id": "sfd_basic_skills_68_4baad6a8",
          "question": "Can a single member complete the hose uncoupling process?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that a single member can complete the hose uncoupling process by kneeling at the hose and alternating the spanner wrenches in the same fashion as described.",
          "options": {
            "A": "Yes, by kneeling at the hose and alternating the spanner wrenches",
            "B": "No, it requires at least two members",
            "C": "Yes, but only with specialized equipment",
            "D": "No, it is too dangerous for a single member"
          }
        },
        {
          "id": "sfd_basic_skills_68_01c61f5e",
          "question": "What tool is used to uncouple the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text specifies that spanner wrenches are used to uncouple the hose.",
          "options": {
            "A": "Pliers",
            "B": "Wrench",
            "C": "Spanner wrenches",
            "D": "Screwdriver"
          }
        },
        {
          "id": "sfd_basic_skills_87_11ba40c4",
          "question": "What is the first step in preparing the hose for loading according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in preparing the hose for loading is to arrange the two unconnected bundles in flakes at the rear of the engine.",
          "options": {
            "A": "Connect the male coupling from the second bundle to the female coupling on top of the first bundle.",
            "B": "Start the load by placing the nozzle in the slot.",
            "C": "Arrange the two unconnected bundles in flakes at the rear of the engine.",
            "D": "Pass the hose toward the back of the slot and form a series of vertically stacked flakes."
          }
        },
        {
          "id": "sfd_basic_skills_87_0cd6845a",
          "question": "How should the nozzle be placed in the slot during the loading process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The nozzle should extend 6 to 9 inches out from the open end of the slot during the loading process.",
          "options": {
            "A": "It should be fully inserted into the slot.",
            "B": "It should extend 6 to 9 inches out from the open end of the slot.",
            "C": "It should be placed at the rear of the slot.",
            "D": "It should be attached to the male coupling of the first bundle."
          }
        },
        {
          "id": "sfd_basic_skills_87_faabd62b",
          "question": "What is the correct way to stack the hose in the slot?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hose should be stacked in a vertical manner in the slot.",
          "options": {
            "A": "In a horizontal stack.",
            "B": "In a diagonal stack.",
            "C": "In a vertical stack.",
            "D": "In a circular stack."
          }
        },
        {
          "id": "sfd_basic_skills_87_4a366a23",
          "question": "How should the folds at the open end be aligned?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The folds at the open end should be aligned with each other, 6 to 9 inches from the slot opening.",
          "options": {
            "A": "They should be aligned with each other, 6 to 9 inches from the slot opening.",
            "B": "They should be aligned with the nozzle.",
            "C": "They should be aligned with the tailboard.",
            "D": "They should be aligned with the rear of the engine."
          }
        },
        {
          "id": "sfd_basic_skills_87_3eea441a",
          "question": "What should be done once the first 100-foot section is loaded?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Once the first 100-foot section is loaded, the male coupling from the second bundle should be connected to the female coupling on top of the first bundle.",
          "options": {
            "A": "Connect the male coupling from the second bundle to the female coupling on top of the first bundle.",
            "B": "Attach the nozzle to the first coupling.",
            "C": "Start the load by placing the nozzle in the slot.",
            "D": "Arrange the two unconnected bundles in flakes at the rear of the engine."
          }
        },
        {
          "id": "sfd_basic_skills_63_3d9f4554",
          "question": "How many lengths of heavy-duty twine should be used to secure a double roll?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The double roll should be secured with three lengths of heavy-duty twine.",
          "options": {
            "A": "One",
            "B": "Two",
            "C": "Three",
            "D": "Four"
          }
        },
        {
          "id": "sfd_basic_skills_63_ad15782d",
          "question": "What should be done if the hose has been damaged?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the hose has been damaged, a rag should be tied around the hose at the point of damage.",
          "options": {
            "A": "Discard the hose immediately",
            "B": "Tie a rag around the hose at the point of damage",
            "C": "Continue using the hose",
            "D": "Replace the hose with a new one"
          }
        },
        {
          "id": "sfd_basic_skills_63_c377e00f",
          "question": "Where should the information about the damage be written?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Information about the damage should be written on the repair tag (F14).",
          "options": {
            "A": "On the hose itself",
            "B": "On the repair tag (F14)",
            "C": "On the twine used to secure the roll",
            "D": "On the rag tied around the point of damage"
          }
        },
        {
          "id": "sfd_basic_skills_63_ba60650d",
          "question": "How should the damaged area be indicated on the repair tag?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The damaged area should be indicated on the repair tag by noting the number of feet from the male coupling.",
          "options": {
            "A": "By noting the color of the hose",
            "B": "By noting the number of feet from the male coupling",
            "C": "By noting the type of damage",
            "D": "By noting the date of damage"
          }
        },
        {
          "id": "sfd_basic_skills_63_f3fba421",
          "question": "How should the three lengths of twine be spaced about the circumference of the roll?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The three lengths of twine should be evenly spaced about the circumference of the roll.",
          "options": {
            "A": "They should be unevenly spaced",
            "B": "They should be spaced at the top, middle, and bottom",
            "C": "They should be spaced at the two ends and the middle",
            "D": "They should be evenly spaced"
          }
        },
        {
          "id": "sfd_basic_skills_75_08f5a4b4",
          "question": "What is the first step in the Two Person Carry method as described in the text?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first step in the Two Person Carry method is to stand on the tailboard to reach the hose conveniently.",
          "options": {
            "A": "Stand on the tailboard to reach the hose conveniently",
            "B": "Grasp the top bundle and pull it 1/3 the way out the slot",
            "C": "Place the bottom flake of the top bundle on the right shoulder",
            "D": "Both firefighters proceed to the water source"
          }
        },
        {
          "id": "sfd_basic_skills_75_7956dd03",
          "question": "What is the role of the second firefighter (Nozzle) in the Two Person Carry method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The second firefighter (Nozzle) shoulder-loads the bottom section and steps off tailboard.",
          "options": {
            "A": "Shoulder-loads the top 100' section and steps away from the tailboard",
            "B": "Shoulder-loads the bottom section and steps off tailboard",
            "C": "Grips the hose flakes to allow the hose to pay out gradually from the top",
            "D": "Shouts for the member ahead to 'stretch'"
          }
        },
        {
          "id": "sfd_basic_skills_75_792d9584",
          "question": "What is the importance of not dragging the length of hose between the two firefighters on the ground?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Dragging the length of hose on the ground could potentially cause damage to the hose, trip other firefighters, and slow down the advancement to the objective.",
          "options": {
            "A": "It could cause damage to the hose",
            "B": "It could trip other firefighters",
            "C": "It could slow down the advancement to the objective",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_75_e8525f98",
          "question": "What is the purpose of the rear member shouting 'stretch' to the member ahead?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The rear member shouts 'stretch' to signal that the last flake of the shoulder-load is about to pull off.",
          "options": {
            "A": "To signal that the last flake of the shoulder-load is about to pull off",
            "B": "To signal that the connection has been made with the water source",
            "C": "To signal that the hose is free of kinks",
            "D": "To signal that the objective has been reached"
          }
        },
        {
          "id": "sfd_basic_skills_75_5d39b10d",
          "question": "What should be done with any excess working line once the objective is reached?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Any excess working line should be arranged so as to be free of kinks and into a configuration which allows for easy advancement.",
          "options": {
            "A": "It should be left as it is",
            "B": "It should be arranged so as to be free of kinks and into a configuration which allows for easy advancement",
            "C": "It should be rolled up and stored away",
            "D": "It should be stretched out straight"
          }
        },
        {
          "id": "sfd_basic_skills_59_0ebd9957",
          "question": "What is the firefighting implication of a Keystone in a fire engine?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Keystone is the main intake valve located midship on both sides of a fire engine that may be manually or mechanically operated. It is crucial for controlling the water supply.",
          "options": {
            "A": "It is used to measure the fire pump discharge pressure.",
            "B": "It is a device designed to release excess pressure from the fire pump.",
            "C": "It is the main intake valve that can be manually or mechanically operated.",
            "D": "It is used to evacuate air from a centrifugal pump housing and hard suction hose."
          }
        },
        {
          "id": "sfd_basic_skills_59_9b0452b5",
          "question": "What is the purpose of a Marker Bight in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Marker Bight extends four inches beyond the 2 \u00bd\u201d accordion hose load and serves as a reference for locating the couplings. This aids in quick and efficient hose deployment.",
          "options": {
            "A": "To measure the fire pump discharge pressure.",
            "B": "To serve as a reference for locating the couplings.",
            "C": "To release excess pressure from the fire pump.",
            "D": "To evacuate air from a centrifugal pump housing and hard suction hose."
          }
        },
        {
          "id": "sfd_basic_skills_59_306dabae",
          "question": "What is the role of a Master Stream Device in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Master Stream Device, such as a deck gun, ground monitor, or ladder pipe, delivers a large quantity of water (at least 500 GPM). This is crucial for controlling large fires.",
          "options": {
            "A": "To carry or drag supply hose to a specific location.",
            "B": "To transfer power from the engine to auxiliary equipment.",
            "C": "To deliver a large quantity of water (at least 500 GPM).",
            "D": "To evacuate air from a centrifugal pump housing and hard suction hose."
          }
        },
        {
          "id": "sfd_basic_skills_59_ff05c21c",
          "question": "What is the function of a Pressure Relief Valve (PRV) in a fire pump?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A Pressure Relief Valve (PRV) is designed to release excess pressure from the fire pump. This is a safety feature that prevents damage to the pump and hose from overpressure.",
          "options": {
            "A": "To measure the fire pump discharge pressure.",
            "B": "To release excess pressure from the fire pump.",
            "C": "To transfer power from the engine to auxiliary equipment.",
            "D": "To evacuate air from a centrifugal pump housing and hard suction hose."
          }
        },
        {
          "id": "sfd_basic_skills_59_a2843ab0",
          "question": "What does the term 'Overhaul' refer to in the context of a hose?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "In the context of a hose, 'Overhaul' refers to the process of carrying or dragging supply hose to a specific location. This is a key part of positioning and deploying hoses for firefighting operations.",
          "options": {
            "A": "The process of measuring the fire pump discharge pressure.",
            "B": "The process of releasing excess pressure from the fire pump.",
            "C": "The process of transferring power from the engine to auxiliary equipment.",
            "D": "The process of carrying or dragging supply hose to a specific location."
          }
        },
        {
          "id": "sfd_basic_skills_101_31285ec4",
          "question": "In the hose stretching process, why is it important to turn to the left and drop off the top flake?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Turning to the left and dropping off the top flake allows proper spacing and results in the hose running from right shoulder-load to right shoulder-load in a continuous line. This is crucial for the members to face into the building and advance toward the objective.",
          "options": {
            "A": "To allow the hose to run from right shoulder-load to right shoulder-load in a continuous line",
            "B": "To ensure the hose is carried up the ladder properly",
            "C": "To place the nozzle over the left shoulder onto the back",
            "D": "To ensure the hose is placed on the right shoulder at designated intervals"
          }
        },
        {
          "id": "sfd_basic_skills_101_ecc5fb8e",
          "question": "Where does the first member place the nozzle during the hose carrying process up the ladder or the straight ladder fire escape?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first member places the nozzle over the left shoulder onto the back, with the lead running across the chest from the left shoulder to the right hip. This is important for maintaining balance and control while climbing.",
          "options": {
            "A": "Over the right shoulder onto the back",
            "B": "Over the left shoulder onto the back",
            "C": "On the right hip",
            "D": "On the left hip"
          }
        },
        {
          "id": "sfd_basic_skills_101_c352eb7f",
          "question": "Where do the second, third, and any additional members place the hose during the hose carrying process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The second, third, and any additional members place the hose on their right shoulder(s), at designated intervals. This is to maintain a consistent line and ensure efficient advancement toward the objective.",
          "options": {
            "A": "On their left shoulder(s)",
            "B": "On their right shoulder(s)",
            "C": "Over their left shoulder onto the back",
            "D": "Over their right shoulder onto the back"
          }
        },
        {
          "id": "sfd_basic_skills_101_60ce9548",
          "question": "Why is it important for the hose to run from right shoulder-load to right shoulder-load in a continuous line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Having the hose run from right shoulder-load to right shoulder-load in a continuous line allows the members to face into the building and advance toward the objective. This is crucial for efficient firefighting operations.",
          "options": {
            "A": "To ensure the hose is carried up the ladder properly",
            "B": "To allow the members to face into the building and advance toward the objective",
            "C": "To place the nozzle over the left shoulder onto the back",
            "D": "To ensure the hose is placed on the right shoulder at designated intervals"
          }
        },
        {
          "id": "sfd_basic_skills_101_a0f63dfc",
          "question": "What is the purpose of the lead running across the chest from the left shoulder to the right hip?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The lead running across the chest from the left shoulder to the right hip helps the first member maintain balance and control while climbing. This is crucial for safety and efficient firefighting operations.",
          "options": {
            "A": "To ensure the hose is carried up the ladder properly",
            "B": "To allow the members to face into the building and advance toward the objective",
            "C": "To maintain balance and control while climbing",
            "D": "To ensure the hose is placed on the right shoulder at designated intervals"
          }
        },
        {
          "id": "sfd_basic_skills_80_00b58029",
          "question": "What is the safety consideration when forming a bight in the hose during overhauling of Large Diameter Hose (LDH)?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "It is mentioned in the text that it is unsafe to place an arm through the bight formed in front of the body.",
          "options": {
            "A": "The bight should be formed at the end of the hose",
            "B": "An arm should be placed through the bight formed in front of the body",
            "C": "The bight should be placed behind the body",
            "D": "It is unsafe to place an arm through the bight formed in front of the body"
          }
        },
        {
          "id": "sfd_basic_skills_80_4ebd8b77",
          "question": "What is the correct positioning of the coupling when overhauling the LDH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the coupling should be placed against the back of the body when overhauling the LDH.",
          "options": {
            "A": "The coupling should be placed against the front of the body",
            "B": "The coupling should be placed against the back of the body",
            "C": "The coupling should be held in hand while overhauling",
            "D": "The coupling should be placed on the ground"
          }
        },
        {
          "id": "sfd_basic_skills_80_a2614186",
          "question": "What should a firefighter do as the next coupling emerges from the hose bed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that the firefighter should pause slightly when the next coupling emerges from the hose bed.",
          "options": {
            "A": "The firefighter should continue pulling without pausing",
            "B": "The firefighter should pause slightly",
            "C": "The firefighter should stop pulling the hose",
            "D": "The firefighter should speed up the pulling"
          }
        },
        {
          "id": "sfd_basic_skills_80_7142173c",
          "question": "What is the correct method for a second member to grasp the hose during overhauling?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the second member should grasp the hose and place it flat on their shoulder with the coupling along their back.",
          "options": {
            "A": "The second member should grasp the hose and place it flat on their shoulder with the coupling along their front",
            "B": "The second member should grasp the hose and place it flat on their shoulder with the coupling along their back",
            "C": "The second member should grasp the hose and place it on the ground",
            "D": "The second member should not grasp the hose"
          }
        },
        {
          "id": "sfd_basic_skills_80_44f8463b",
          "question": "What is the recommended spacing for members during overhauling with limited staffing?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that with limited staffing, members should be spaced at every other coupling.",
          "options": {
            "A": "Members should be spaced at every coupling",
            "B": "Members should be spaced at every other coupling",
            "C": "All members should be at the same coupling",
            "D": "There is no specific recommended spacing for members"
          }
        },
        {
          "id": "sfd_basic_skills_79_8792c787",
          "question": "What is the correct position for the second member while shoulder-loading the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The second member takes a position facing the hose bed, the coupling in front of him/her, with the hose lead running alongside his/her left side.",
          "options": {
            "A": "Facing the hose bed with the coupling in front and the hose lead running alongside the right side",
            "B": "Facing away from the hose bed with the coupling behind and the hose lead running alongside the left side",
            "C": "Facing the hose bed with the coupling in front and the hose lead running alongside the left side",
            "D": "Facing away from the hose bed with the coupling behind and the hose lead running alongside the right side"
          }
        },
        {
          "id": "sfd_basic_skills_79_8d8571e5",
          "question": "Where should the coupling be located after the member shoulder-loads the hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After the member picks up and passes the hose coupling across the body, the coupling should now be at the small of the back.",
          "options": {
            "A": "At the small of the back",
            "B": "At the right shoulder",
            "C": "At the left shoulder",
            "D": "In front of the body at chest level"
          }
        },
        {
          "id": "sfd_basic_skills_79_46546e3b",
          "question": "What action should the members take after the designated amount of hose has been shoulder-loaded?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The members then turn away from the hose load (a counter-clockwise pivot 180 degrees to the left), allowing the top flake to drop from their shoulder-loads.",
          "options": {
            "A": "Turn towards the hose load",
            "B": "Turn away from the hose load with a clockwise pivot",
            "C": "Turn away from the hose load with a counter-clockwise pivot",
            "D": "Stay in the same position"
          }
        },
        {
          "id": "sfd_basic_skills_79_fb5b7e94",
          "question": "Where should the final coupling be held by the rear-most member?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The rear-most member should be holding the final coupling in front of the body at about chest-level.",
          "options": {
            "A": "Behind the body at about waist-level",
            "B": "In front of the body at about chest-level",
            "C": "In front of the body at about waist-level",
            "D": "Behind the body at about chest-level"
          }
        },
        {
          "id": "sfd_basic_skills_79_59aefc70",
          "question": "What should be done with the slack between the members?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The slack between the members should be kept off of the ground.",
          "options": {
            "A": "Keep it on the ground",
            "B": "Keep it off the ground",
            "C": "Wrap it around the hose",
            "D": "Tie it in a knot"
          }
        },
        {
          "id": "sfd_basic_skills_96_a45f5be5",
          "question": "Why is it important to avoid pinch points when advancing uncharged attack lines?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Pinch points, such as under doors or between heavy furniture, can restrict or halt the flow of water when the line is charged, making it crucial to avoid them when advancing uncharged attack lines.",
          "options": {
            "A": "Pinch points can cause the hose to burst.",
            "B": "Pinch points can restrict or halt the flow of water when the line is charged.",
            "C": "Pinch points can cause the firefighter to trip and fall.",
            "D": "Pinch points can cause the hose to knot and tangle."
          }
        },
        {
          "id": "sfd_basic_skills_96_b75241de",
          "question": "What is the preferred type of door for hose line access when located in close proximity?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Man doors are preferred over roll up doors for hose line access when located in close proximity.",
          "options": {
            "A": "Sliding doors",
            "B": "Revolving doors",
            "C": "Roll up doors",
            "D": "Man doors"
          }
        },
        {
          "id": "sfd_basic_skills_96_5cc23653",
          "question": "Where should members be positioned to assist with advancing a charged line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Members should be positioned at areas that make it difficult to advance the hose line, such as corners, stairways, and other friction points, to assist with the advancement.",
          "options": {
            "A": "At the beginning of the hose line",
            "B": "At areas that make it difficult to advance the hose line",
            "C": "At the end of the hose line",
            "D": "At the midpoint of the hose line"
          }
        },
        {
          "id": "sfd_basic_skills_96_9ea06f8b",
          "question": "When advancing attack lines up or down stairs, where should the line be laid?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The line should be laid against the outside wall to avoid sharp bends and pinch points on the landings.",
          "options": {
            "A": "Against the outside wall",
            "B": "In the middle of the staircase",
            "C": "Against the inside wall",
            "D": "Along the railing"
          }
        },
        {
          "id": "sfd_basic_skills_96_155ade67",
          "question": "What is the maximum distance a hose can be run straight up or down a well opening?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hose can be run straight up or down a well opening for short distances (100 feet or less), because of the weight of the water and hose.",
          "options": {
            "A": "50 feet",
            "B": "100 feet",
            "C": "150 feet",
            "D": "200 feet"
          }
        },
        {
          "id": "sfd_basic_skills_78_965eafd4",
          "question": "Where should the coupling of the large diameter hose (LDH) be placed before passing it over the shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The coupling of the LDH should be placed against the front of the body just above the waistline. This position allows for efficient movement and safety during hose handling.",
          "options": {
            "A": "Against the back just below the shoulder blades",
            "B": "Against the front of the body just above the waistline",
            "C": "Against the front of the body just below the waistline",
            "D": "Against the back just above the waistline"
          }
        },
        {
          "id": "sfd_basic_skills_78_4f7cde0e",
          "question": "What is the purpose of keeping the bights in front of the body above the waist while forming flakes?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Keeping the bights in front of the body above the waist while forming flakes helps to prevent the hose from tangling. This is important for firefighter safety and efficient hose deployment.",
          "options": {
            "A": "To make the hose look neat",
            "B": "To prevent the hose from tangling",
            "C": "To ensure the hose is evenly distributed",
            "D": "To ensure the hose is not too heavy to carry"
          }
        },
        {
          "id": "sfd_basic_skills_78_e3031fba",
          "question": "When should a firefighter move back several steps during the shoulder-load process?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A firefighter should move back several steps when the first section (50 feet) has been shoulder-loaded and is within 10 feet of the coupling. This allows a second member to shoulder-load the next section, promoting teamwork and efficiency.",
          "options": {
            "A": "When the first section (50 feet) has been shoulder-loaded and is within 10 feet of the coupling",
            "B": "When the hose starts to feel heavy",
            "C": "When the hose begins to tangle",
            "D": "When the hose is fully loaded onto the shoulder"
          }
        },
        {
          "id": "sfd_basic_skills_78_8363352a",
          "question": "What is the correct position of the hose when passed over the shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hose should be lying flat on the shoulder. This position allows for better control and safety during hose handling.",
          "options": {
            "A": "The hose should be twisted around the shoulder",
            "B": "The hose should be lying flat on the shoulder",
            "C": "The hose should be draped loosely over the shoulder",
            "D": "The hose should be coiled tightly around the shoulder"
          }
        },
        {
          "id": "sfd_basic_skills_78_e57f6d38",
          "question": "What is the importance of each flake being flat, the same length, and on top of the previous flake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Each flake being flat, the same length, and on top of the previous flake helps to prevent the hose from tangling during deployment. This is crucial for firefighter safety and efficient operations.",
          "options": {
            "A": "It makes the hose easier to carry",
            "B": "It prevents the hose from tangling during deployment",
            "C": "It makes the hose look neat and organized",
            "D": "It allows for faster hose deployment"
          }
        },
        {
          "id": "sfd_basic_skills_97_ea044afd",
          "question": "What is the purpose of coiling the excess hose remaining in the shoulder-load after reaching the fire objective?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Coiling the excess hose helps to conserve space, especially in narrow hallways.",
          "options": {
            "A": "To make it easier to carry",
            "B": "To conserve space",
            "C": "To make it easier to connect to the standpipe",
            "D": "To increase the pressure of the water"
          }
        },
        {
          "id": "sfd_basic_skills_97_082ffacb",
          "question": "Why is it essential to tie the bale in the open position when extending the hose line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Tying the bale in the open position ensures that the hose line can be extended easily.",
          "options": {
            "A": "To prevent water from flowing back into the hose",
            "B": "To ensure the hose line can be extended easily",
            "C": "To prevent the hose from kinking",
            "D": "To ensure the nozzle can be removed easily"
          }
        },
        {
          "id": "sfd_basic_skills_97_432cc0bc",
          "question": "What is the procedure for extending a 2 \u00bd\u201d hose line?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The correct procedure for extending a 2 \u00bd\u201d hose line is to clamp off the hose line, unattach the nozzle, and add a new section of hose and a nozzle to the existing attack line.",
          "options": {
            "A": "The hose line is clamped off, the nozzle unattached, and a new section of hose and a nozzle added to the existing attack line",
            "B": "The nozzle is removed, the hose line is clamped off, and a new section of hose is added",
            "C": "The hose line is clamped off, a new section of hose is added, and the nozzle is reattached",
            "D": "The nozzle is removed, a new section of hose is added, and the hose line is clamped off"
          }
        },
        {
          "id": "sfd_basic_skills_97_2e07f50f",
          "question": "What is the purpose of tying the roof rope off inside the window (or on the roof) when hoisting a hose line?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Tying the roof rope off inside the window (or on the roof) helps to prevent the hose line from falling while it is being hoisted.",
          "options": {
            "A": "To prevent the hose line from falling",
            "B": "To make it easier to hoist the hose line",
            "C": "To ensure the hose line can be extended easily",
            "D": "To conserve space"
          }
        },
        {
          "id": "sfd_basic_skills_97_02989bc7",
          "question": "What is the purpose of placing a half-hitch on both sides of the shutoff when tying the end of the roof (or utility) rope to the hose?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Placing a half-hitch on both sides of the shutoff helps to hold the attack line in place.",
          "options": {
            "A": "To make it easier to untie the rope",
            "B": "To ensure the hose line can be extended easily",
            "C": "To prevent the hose line from falling",
            "D": "To hold the attack line in place"
          }
        },
        {
          "id": "sfd_basic_skills_81_f6ef2931",
          "question": "What is the correct procedure when the coupling emerges from the hose bed during the cross lotting LDH with the Tri-Gate?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "As per the text, when the coupling emerges from the hose bed, the two members pause slightly and another member places the hose flat on their right shoulder with the coupling to the rear.",
          "options": {
            "A": "The two members continue advancing without pause",
            "B": "The two members pause slightly and another member places the hose flat on their right shoulder with the coupling to the front",
            "C": "The two members pause slightly and another member places the hose flat on their right shoulder with the coupling to the rear",
            "D": "The two members pause slightly and another member places the hose flat on their left shoulder with the coupling to the rear"
          }
        },
        {
          "id": "sfd_basic_skills_81_35b8054d",
          "question": "What is the strategy for stretching two sections with limited staffing?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "With limited staffing, two sections may be stretched by each member, with members spaced at every other coupling.",
          "options": {
            "A": "Members are spaced at every coupling",
            "B": "Members are spaced at every other coupling",
            "C": "Members are spaced at every third coupling",
            "D": "Members are not spaced at all"
          }
        },
        {
          "id": "sfd_basic_skills_81_fd998ba7",
          "question": "What is the first step in the cross lotting LDH with the Tri-Gate process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in the process is for two members to pick up the tri-gate by the handles and advance towards the objective.",
          "options": {
            "A": "Two members begin by picking the tri-gate up by the handles and retreating from the objective",
            "B": "Two members begin by picking the tri-gate up by the handles and advancing toward the objective",
            "C": "Two members begin by picking the tri-gate up by the handles and standing still",
            "D": "Two members begin by picking the tri-gate up by the handles and moving sideways"
          }
        },
        {
          "id": "sfd_basic_skills_81_e0218c49",
          "question": "Where is the hose placed during the cross lotting LDH with the Tri-Gate process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hose is placed flat on the right shoulder of a member during the cross lotting LDH with the Tri-Gate process.",
          "options": {
            "A": "On the left shoulder",
            "B": "On the right shoulder",
            "C": "On the head",
            "D": "On the back"
          }
        },
        {
          "id": "sfd_basic_skills_81_d542024a",
          "question": "What is the orientation of the coupling when the hose is placed on the shoulder during the cross lotting LDH with the Tri-Gate process?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the hose is placed on the shoulder, the coupling is oriented to the rear.",
          "options": {
            "A": "To the front",
            "B": "To the side",
            "C": "To the rear",
            "D": "There is no specific orientation"
          }
        },
        {
          "id": "sfd_basic_skills_58_666a5395",
          "question": "What is the purpose of a 'Dutchman' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A 'Dutchman' is a short fold or reverse bend used to allow couplings to pay out without them turning over.",
          "options": {
            "A": "To measure positive and negative pressures",
            "B": "To allow couplings to pay out without them turning over",
            "C": "To split a single hose into two hoses",
            "D": "To indicate the location of the Higbee cut"
          }
        },
        {
          "id": "sfd_basic_skills_58_0d57c6f0",
          "question": "What is the function of a 'Gated Wye' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A 'Gated Wye' is an appliance, equipped with manual valves, that allows a single hose to be split into two hoses.",
          "options": {
            "A": "To pressurize a fire hose",
            "B": "To measure the rate of flow",
            "C": "To allow a single hose to be split into two hoses",
            "D": "To prevent leakage in couplings and appliances"
          }
        },
        {
          "id": "sfd_basic_skills_58_4764ef55",
          "question": "What is the importance of the 'Higbee Cut' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'Higbee Cut' is a machined 45-degree angle cut into the threaded portion of couplings that allows for quick and easy threading.",
          "options": {
            "A": "To allow couplings to pay out without them turning over",
            "B": "To allow for quick and easy threading of couplings",
            "C": "To pressurize a fire hose",
            "D": "To split a single hose into two hoses"
          }
        },
        {
          "id": "sfd_basic_skills_58_49251d78",
          "question": "What is the role of a 'Gasket' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "A 'Gasket' is a thin rubber O-ring that allows couplings and appliance to seat firmly and prevent leakage.",
          "options": {
            "A": "To allow for quick and easy threading of couplings",
            "B": "To allow a single hose to be split into two hoses",
            "C": "To allow couplings to pay out without them turning over",
            "D": "To allow couplings and appliance to seat firmly and prevent leakage"
          }
        },
        {
          "id": "sfd_basic_skills_58_26152359",
          "question": "What does 'Forward Lay' mean in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "'Forward Lay' refers to the hose being laid from the water source to the fire.",
          "options": {
            "A": "Hose laid from the water source to the fire",
            "B": "Hose laid from the fire to the water source",
            "C": "Hose split into two hoses",
            "D": "Hose pressurized for firefighting"
          }
        },
        {
          "id": "sfd_basic_skills_100_1b8d8a72",
          "question": "What is the role of the second member in the hose carrying procedure up the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, the second member continues to climb, keeping the hose in a loop at the right side of the ladder. Upon reaching the top of the ladder, the member stops and passes the line hand over hand to the first member.",
          "options": {
            "A": "The second member secures the hose to the ladder with a clove hitch on the first rung above the windowsill.",
            "B": "The second member carries the hose up the ladder and passes it to the first member.",
            "C": "The second member stays at the bottom of the ladder to provide support.",
            "D": "The second member is responsible for extinguishing the fire."
          }
        },
        {
          "id": "sfd_basic_skills_100_cdb89fcc",
          "question": "What is the procedure for the last member in the hose carrying process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the last member uses a body loop and secures the hose to the ladder with a clove hitch on the first rung above the windowsill.",
          "options": {
            "A": "The last member steps in off the ladder into the room.",
            "B": "The last member uses a body loop and secures the hose to the ladder with a clove hitch on the first rung above the windowsill.",
            "C": "The last member passes the hose to the first member.",
            "D": "The last member stays at the bottom of the ladder to provide support."
          }
        },
        {
          "id": "sfd_basic_skills_100_66c299b0",
          "question": "What is the safety consideration when the second member reaches the top of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Upon reaching the top of the ladder, the member stops and grasps the hose leading up to the first member with the left arm between the rungs for safety.",
          "options": {
            "A": "The member should immediately start extinguishing the fire.",
            "B": "The member should secure the hose to the ladder with a clove hitch.",
            "C": "The member should grasp the hose leading up to the first member with the left arm between the rungs.",
            "D": "The member should jump off the ladder into the room."
          }
        },
        {
          "id": "sfd_basic_skills_100_80757536",
          "question": "What is the procedure for the second member after the first bundle has been shoulder-loaded?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After the first bundle has been shoulder-loaded, the second member steps in off the ladder into the room, crosses over the hose, turns to face the ladder, and brings the incoming hose across the chest from the left hip to the right shoulder.",
          "options": {
            "A": "The member should start extinguishing the fire.",
            "B": "The member should secure the hose to the ladder with a clove hitch.",
            "C": "The member should step in off the ladder into the room, cross over the hose, turn to face the ladder, and bring the incoming hose across the chest from the left hip to the right shoulder.",
            "D": "The member should pass the hose to the first member."
          }
        },
        {
          "id": "sfd_basic_skills_100_ec1b55df",
          "question": "What is the procedure for the third and any additional members in the hose carrying process?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the third and any additional members follow the same procedures until the required amount of hose has been carried up and shoulder-loaded.",
          "options": {
            "A": "They should follow the same procedures as the first member.",
            "B": "They should follow the same procedures as the second member.",
            "C": "They should follow the same procedures until the required amount of hose has been carried up and shoulder-loaded.",
            "D": "They should stay at the bottom of the ladder to provide support."
          }
        },
        {
          "id": "sfd_basic_skills_74_fc4dc8d2",
          "question": "What is the importance of arranging the excess working line free of kinks and into a configuration of large flakes?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Arranging the excess working line free of kinks and into a configuration of large flakes allows for easy advancement, which is crucial in firefighting operations.",
          "options": {
            "A": "It makes the hose look organized",
            "B": "It allows for easy advancement",
            "C": "It reduces the weight of the hose",
            "D": "It increases the water pressure"
          }
        },
        {
          "id": "sfd_basic_skills_74_d1484f4b",
          "question": "What components make up the entire bundle that is to be carried by one person?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The entire bundle consists of 200 feet of hose, 1 3/4\" nozzle, and 2 1/2\" to 1 1/2\" Bell Reducer. This is important for firefighters to know as it affects the weight and handling of the hose.",
          "options": {
            "A": "200 feet of hose, 1 3/4\" nozzle, and 2 1/2\" to 1 1/2\" Bell Reducer",
            "B": "100 feet of hose, 1 3/4\" nozzle, and 2 1/2\" to 1 1/2\" Bell Reducer",
            "C": "200 feet of hose, 1 1/2\" nozzle, and 2 1/2\" to 1 1/2\" Bell Reducer",
            "D": "200 feet of hose, 1 3/4\" nozzle, and 2\" to 1 1/2\" Bell Reducer"
          }
        },
        {
          "id": "sfd_basic_skills_74_6ed22101",
          "question": "At what distance from the tailboard should the tie-rope be removed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The tie-rope should be removed once about 25 feet away from the tailboard. This is a safety consideration to prevent tripping hazards during firefighting operations.",
          "options": {
            "A": "15 feet",
            "B": "25 feet",
            "C": "35 feet",
            "D": "45 feet"
          }
        },
        {
          "id": "sfd_basic_skills_74_c4a5e055",
          "question": "Where should the nozzle and front flakes be positioned during a one-person carry?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During a one-person carry, the nozzle and front flakes should be at the belt line. This positioning allows for better control and balance of the hose bundle.",
          "options": {
            "A": "At the shoulder level",
            "B": "At the chest level",
            "C": "At the belt line",
            "D": "At the knee level"
          }
        },
        {
          "id": "sfd_basic_skills_74_47e55573",
          "question": "How should the bundles be held during a one-person carry?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The bundles should be held tightly in front of the body with both hands during a one-person carry. This provides the most control and stability.",
          "options": {
            "A": "Behind the body with one hand",
            "B": "In front of the body with one hand",
            "C": "Behind the body with both hands",
            "D": "In front of the body with both hands"
          }
        },
        {
          "id": "sfd_basic_skills_62_5aac5de8",
          "question": "What is the first step in preparing a hose for transport for repairs according to the Seattle Fire Department's Double Roll method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in the Double Roll method is to grasp the male coupling and carry it back toward the female coupling.",
          "options": {
            "A": "Connect the two couplings",
            "B": "Grasp the male coupling and carry it back toward the female coupling",
            "C": "Straddle the hose at the bight, facing the couplings",
            "D": "Fold the hose over and away from the body"
          }
        },
        {
          "id": "sfd_basic_skills_62_48fde276",
          "question": "Why is it important to keep the two layers of hose in line and on top of one another during the Double Roll method?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Keeping the two layers of hose in line and on top of one another ensures that the hose rolls evenly, which is crucial for the Double Roll method.",
          "options": {
            "A": "To ensure the hose rolls evenly",
            "B": "To prevent damage to the hose",
            "C": "To make the hose lighter",
            "D": "To make the hose longer"
          }
        },
        {
          "id": "sfd_basic_skills_62_4f552ef2",
          "question": "What should be the position of the female coupling relative to the male coupling at the base of the roll in the Double Roll method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In the Double Roll method, when the roll reaches the male coupling, the female coupling should be sticking out a foot or two beyond the male coupling at the base of the roll.",
          "options": {
            "A": "The female coupling should be inside the roll",
            "B": "The female coupling should be sticking out a foot or two beyond the male coupling",
            "C": "The female coupling should be at the same level as the male coupling",
            "D": "The female coupling should be below the male coupling"
          }
        },
        {
          "id": "sfd_basic_skills_62_bd27949a",
          "question": "What is the final step in preparing a hose for transport for repairs according to the Seattle Fire Department's Double Roll method?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The final step in the Double Roll method is to lay the roll on its side and connect the two couplings.",
          "options": {
            "A": "Fold the hose over and away from the body",
            "B": "Straddle the hose at the bight, facing the couplings",
            "C": "Connect the two couplings",
            "D": "Grasp the male coupling and carry it back toward the female coupling"
          }
        },
        {
          "id": "sfd_basic_skills_62_7e017f9f",
          "question": "What is the purpose of having a layer of hose protect the couplings in the Double Roll method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Having a layer of hose protect the couplings in the Double Roll method is to prevent damage to the couplings.",
          "options": {
            "A": "To make the hose lighter",
            "B": "To prevent damage to the couplings",
            "C": "To make the hose longer",
            "D": "To ensure the hose rolls evenly"
          }
        }
      ]
    },
    "4": {
      "chapter_id": "4",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_115_787c44c4",
          "question": "Life-saving operations should always be prioritized over firefighting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Life-saving operations are placed ahead of firefighting when sufficient firefighters are not available to do both. Judgment is the key factor when confronted with this situation.' This indicates that the decision to prioritize life-saving operations over firefighting depends on the availability of firefighters and the specific situation, not always.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_115_f6b8840b",
          "question": "The best life-saving measure may sometimes be a prompt attack on the fire.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The best life-saving measure may be a prompt attack on the fire, which, if allowed to spread, would trap occupants.' This supports the statement that a prompt attack on the fire can sometimes be the best life-saving measure, as it can prevent the fire from spreading and trapping occupants.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_115_6ed5e338",
          "question": "The size of the attack line to be utilized depends solely on the location of the fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The specific evolution and the size of attack line to be utilized will depend on the following: Location of fire, Severity of fire, Type of occupancy, Type of construction.' This contradicts the statement that the size of the attack line depends solely on the location of the fire, as it also depends on the severity of the fire, type of occupancy, and type of construction.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_115_30ce9ac8",
          "question": "Immediate rescue attempts by the first arriving engine company should always be attempted, regardless of the situation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Immediate rescue attempts by the first arriving engine company without simultaneously stretching and positioning a hose line should be attempted only in extreme situations.' This contradicts the statement that immediate rescue attempts should always be attempted, as the text specifies that this should only be done in extreme situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_115_07a14230",
          "question": "For upper floor fires, the distance from the entrance door to the stairway must be considered when estimating the length of the attack line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For upper floor fires, the distance from the entrance door to the stairway must also be considered.' This supports the statement that for upper floor fires, the distance from the entrance door to the stairway must be considered when estimating the length of the attack line.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_142_d8bae1b2",
          "question": "The 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant can be removed with a corey wrench.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Remove the 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant with a corey wrench.' This supports the statement and indicates that a corey wrench is a crucial tool for firefighters to manipulate hydrant ports during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_142_a7d667e7",
          "question": "The hydrant adapter is attached to the 2\u00bd\u201d port.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach the hydrant adapter to the engine port and the LDH to the adapter.' This contradicts the statement as the hydrant adapter is attached to the engine port, not the 2\u00bd\u201d port. This is important for firefighters to understand as incorrect attachment could lead to operational issues during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_142_6522d41d",
          "question": "The hydrant gate should be in the open position when attached to the 2\u00bd\u201d port.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach the hydrant gate to the 2\u00bd\u201d port and ensure that the gate is in the closed position.' This contradicts the statement as the hydrant gate should be in the closed position when attached. This is a crucial safety measure to prevent uncontrolled water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_142_8dcd3e20",
          "question": "The hydrant is opened fully using the Galvin wrench.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Step behind the hydrant and open it fully using the Galvin wrench.' This supports the statement and indicates that a Galvin wrench is an essential tool for firefighters to operate hydrants during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_142_1c76eb98",
          "question": "The LDH is attached directly to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach the hydrant adapter to the engine port and the LDH to the adapter.' This contradicts the statement as the LDH is attached to the hydrant adapter, not directly to the hydrant. Understanding this is important for firefighters as incorrect attachment could lead to operational issues during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_154_c78da695",
          "question": "The position #4 firefighter is responsible for procuring the irons and placing them on the ground and to the fire side of the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Procure the irons and place them on the ground and to the fire side of the engine.' This indicates that the position #4 firefighter is responsible for this task. This is important as it ensures that the necessary equipment is in the correct location for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_154_9a2b6c1a",
          "question": "The position #4 firefighter should always wait for instructions from the Officer before directing the driver to proceed to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the Officer is unable to foot the tri-gate or LDH because of incident command responsibilities, the position #4 firefighter will have sole responsibility of ensuring that all required hose and equipment has been removed from the engine. After completing this task, position #4 firefighter will then direct the driver to proceed to the hydrant without instructions from the Officer.' This contradicts the statement, indicating that the position #4 firefighter may sometimes need to act without direct orders from the Officer. This highlights the importance of individual initiative and understanding of procedures in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_154_1c16fac5",
          "question": "The position #4 firefighter is responsible for connecting both 2\u00bd\u201d female couplings to the tri-gate.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When safe to do so, connect both 2\u00bd\u201d female couplings to the tri-gate.' This indicates that the position #4 firefighter is responsible for this task. This is a critical step in ensuring the proper flow of water for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_154_44e64c8c",
          "question": "The position #4 firefighter is not involved in the operation of the monitor if the Officer is not present.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Direct the operation of the monitor if the Officer is not present.' This contradicts the statement, indicating that the position #4 firefighter may need to take charge of the monitor operation in the absence of the Officer. This underlines the importance of adaptability and leadership in firefighting situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_154_cac49991",
          "question": "The position #4 firefighter assists the position #3 firefighter in securing the monitor for safe operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Once the position #3 firefighter has completely positioned the 2\u00bd\u201d hose, assist the position #3 firefighter in securing the monitor for safe operation.' This indicates that the position #4 firefighter is responsible for this task. This collaboration is key to ensuring the safe and effective operation of firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_139_32198c9b",
          "question": "The firefighter should always remove kinks in the hose line immediately, even if sufficient water is entering the intake.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If kinks are present but it appears that sufficient water is entering the intake, disregard them at this time. Such kinks will be addressed at a later point.' This contradicts the statement, indicating that not all kinks need to be immediately removed if they are not currently affecting water supply. The implication for firefighting is understanding the prioritization of tasks and efficient use of resources.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_139_889a78e6",
          "question": "Upon completion of the primary supply, the driver will act as a member of the Firefighter Stand-by Rescue Team until the Rapid Intervention Team is assigned.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon completion of the primary supply, the driver will don their SCBA in a stand-by position and act as a member of the Firefighter Stand-by Rescue Team until the Rapid Intervention Team is assigned.' This supports the statement. The implication for firefighting is understanding the roles and responsibilities of different team members during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_139_52e11fbc",
          "question": "Traffic cones are placed to protect only the personnel from approaching vehicles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles.' This contradicts the statement, indicating that traffic cones are used to protect not only personnel but also the engine and hose lines. The implication for firefighting is understanding the importance of scene safety and protection of resources.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_139_3756ab2b",
          "question": "The driver will obtain a second water supply after all remaining kinks in the supply line have been removed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'While placing the cones, remove any remaining kinks remaining in the supply line. The driver will then obtain a second water supply.' This supports the statement. The implication for firefighting is understanding the sequence of operations and the importance of ensuring an efficient water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_139_eccf894f",
          "question": "Once a second supply has been established, the engine\u2019s booster tank should not be refilled.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once a second supply has been established, refill any water already used from the engine\u2019s booster tank by opening the tank fill valve.' This contradicts the statement, indicating that the engine\u2019s booster tank should be refilled once a second supply is established. The implication for firefighting is understanding the importance of maintaining adequate water supplies during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_119_5298439d",
          "question": "The position #3 firefighter is responsible for bringing appropriate tools to the fire building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The position #4 firefighter will also be responsible to bring appropriate tools to the fire building.' This contradicts the statement in the question, indicating that it is the position #4 firefighter, not the position #3 firefighter, who is responsible for this task. This is an important consideration as it affects the division of responsibilities and tasks during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_119_f8e614a7",
          "question": "Traffic cones are positioned to protect personnel, the engine, and hose lines from approaching vehicles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles.' This supports the statement in the question, indicating that traffic cones are used as a safety measure to protect personnel and equipment from potential harm from vehicles. This is a crucial safety consideration during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_119_9bf694dc",
          "question": "The position #4 firefighter will serve as the nozzle person.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member riding in the position #3 seat will act as the nozzle person, while the position #4 firefighter will serve as the back-up person on the hose line.' This contradicts the statement in the question, indicating that it is the position #3 firefighter, not the position #4 firefighter, who serves as the nozzle person. This is a key operational detail in firefighting as it determines the roles and responsibilities of the crew members.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_119_5b117026",
          "question": "The driver is responsible for obtaining a second water supply after a first supply has been established.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The driver will then obtain a second water supply.' This supports the statement in the question, indicating that the driver has the responsibility of securing a second water supply. This is a critical task as it ensures that there is sufficient water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_119_9e7ed53f",
          "question": "After forcible entry has been accomplished, the position #3 firefighter will assist the firefighter assigned to the nozzle in advancing the line to the fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'After forcible entry has been accomplished, the position # 4 firefighter will assist the firefighter assigned to the nozzle in advancing the line to the fire.' This contradicts the statement in the question, indicating that it is the position #4 firefighter, not the position #3 firefighter, who assists in advancing the line to the fire after forcible entry. This is a key tactical consideration as it affects the execution of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_158_e4d13e8b",
          "question": "The pump and hydrant operations for two members are different from those for the driver alone.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The pump and hydrant operations for two members are the same as those for the driver (alone)'. This means that the procedures for operating the pump and hydrant do not change based on the number of members present. The implications for firefighting operations are that consistency in procedures can help reduce confusion and errors during high-pressure situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_158_2e67dde7",
          "question": "The hydrant member assists the driver after the hydrant is opened, then dons an SCBA and follows the lines to the fire operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'After the hydrant is opened, the member will assist the driver, if necessary, and then dons an SCBA and follows the lines to the fire operation'. This indicates that the hydrant member has multiple responsibilities, including assisting the driver and following the lines to the fire operation. This highlights the importance of multi-tasking and coordination in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_158_41f8f547",
          "question": "The intake valve should be opened before the hydrant connection is made.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do NOT open the intake valve until the hydrant connection is made'. This contradicts the question statement, indicating that the intake valve should only be opened after the hydrant connection is made. This is a crucial safety measure to prevent uncontrolled water flow or potential damage to equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_158_e53b62dd",
          "question": "The hydrant member should report to the Officer for further assignment after opening the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hydrant member shall then report to the Officer for further assignment'. This supports the question statement, indicating that the hydrant member's duties include reporting to the Officer after opening the hydrant. This highlights the importance of communication and chain of command in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_158_961dbfa9",
          "question": "The female coupling of the LDH should be left at the hydrant during a reverse pump hook up.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Proceed to the hydrant with female coupling. Leave the female coupling at the hydrant'. This supports the question statement, indicating that the female coupling of the LDH should indeed be left at the hydrant during a reverse pump hook up. This is an important procedure to ensure proper water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_174_c142c87b",
          "question": "In unusual situations, it is not necessary to adapt procedures if hydrants are poorly located.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Members must be alert for unusual situations where hydrants are poorly located (up a bank, in brush, etc.) and adapt these procedures accordingly.' This contradicts the statement, indicating that firefighters must be prepared to adapt their procedures in response to unusual situations, such as poorly located hydrants. This is crucial for ensuring effective firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_174_1eed3555",
          "question": "When dealing with 'dry' hose lays, it is acceptable to anchor the hose to another object near the street.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For \"dry\" hose lays, it may be necessary to remove enough hose from the engine to reach the poorly located hydrant, anchor it to another object near the street (fence, utility pole, etc.), and then proceed with the lay.' This supports the statement, indicating that anchoring the hose to another object near the street is an acceptable practice when dealing with 'dry' hose lays. This can be a critical tactic in ensuring that the hose can reach a poorly located hydrant.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_174_9f08e180",
          "question": "The utility strap can only be looped once around the anchoring object.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'More than one utility strap can be looped together if greater length is needed.' This contradicts the statement, indicating that multiple utility straps can be looped together if necessary. This is important for firefighters to understand, as it allows for greater flexibility in dealing with difficult hydrant situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_174_c9c269b6",
          "question": "If the equipment and hose cannot be overhauled quickly to the hydrant, it is still okay to proceed with the lay.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the equipment and hose cannot be overhauled quickly to the hydrant, do not proceed with the lay until it is assured that sufficient hose has been provided to reach the hydrant from the street.' This contradicts the statement, indicating that firefighters should not proceed with the lay until they are sure they have enough hose to reach the hydrant. This is a crucial safety consideration to ensure that water supply is not compromised during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_174_31846270",
          "question": "The hydrant wrenches and hydrant bag should be left with the additional hose that was removed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hydrant wrenches and hydrant bag will be left with the additional hose that was removed.' This supports the statement, indicating that these tools should be left with the additional hose. This is a key operational consideration to ensure that the necessary tools are readily available when needed for making connections and charging the line.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_123_554b94cc",
          "question": "The position #3 firefighter is responsible for shoulder-loading the 1\u00be\u201d preconnected hose load and stretching the line to the location designated by the Officer.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position #3 Firefighter - Shoulder-load the 1\u00be\u201d preconnected hose load and stretch the line to the location designated by the Officer.' This indicates that the position #3 firefighter has the responsibility of managing the hose load and its placement, which is crucial for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_123_a3348c04",
          "question": "The position #4 firefighter is responsible for bleeding the air from the charged hose line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Bleed the air from the charged hose line, assess the fire stream for an appropriate volume of water flow (GPM), and check the fire stream for the appropriate pattern.' However, this task is assigned to the position #3 firefighter, not the position #4 firefighter. The position #4 firefighter's responsibilities include procuring the irons and providing forcible entry as required. Understanding each role's responsibilities is essential for efficient teamwork and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_123_c9b7d3a1",
          "question": "The position #3 firefighter needs to call for water after coiling or flaking the hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Coil or flake the hose, as appropriate, and call for water.' This shows that it is the responsibility of the position #3 firefighter to call for water after preparing the hose. This is a key step in ensuring that the firefighting team has the necessary resources to combat the fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_123_98602a7f",
          "question": "The position #4 firefighter is responsible for advancing the attack line into a position to begin the fire attack.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When joined by the back-up member, advance the attack line into a position to begin the fire attack.' However, this task is assigned to the position #3 firefighter, not the position #4 firefighter. The position #4 firefighter's responsibilities include assisting in advancing and operating the hose line. Understanding the division of tasks is important for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_123_afb807e7",
          "question": "Both position #3 and #4 firefighters are responsible for advancing to the fire location.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position #3 and #4 firefighter advancing to the fire location.' This indicates that both position #3 and #4 firefighters have the shared responsibility of advancing to the fire location, which is crucial for initiating the fire attack and ensuring the safety of the team.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_135_1710acd4",
          "question": "When stretching a supply hose a long distance, it is recommended to place the coupling in front of the body.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'At no time should the coupling be placed in front of the body while overhauling hose to the hydrant.' This directly contradicts the question statement. Placing the coupling in front of the body could lead to injury if the hose snags on an object during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_135_ad53d261",
          "question": "It is safe to place your arm or shoulder through a loop in the hose while overhauling hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'never place your arm or shoulder through a loop in the hose while overhauling hose.' This directly contradicts the question statement. Doing so could potentially lead to injury if the hose snags on an object during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_135_18284c04",
          "question": "When stretching a supply hose a long distance, the coupling should be placed at the small of the back.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This will place the coupling at the small of the back.' This directly supports the question statement. Proper positioning of the coupling can help prevent injury and improve efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_135_7335b000",
          "question": "When stretching a supply hose a long distance, you should face away from the hose bed and create a bight in the hose approximately four feet from the coupling.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Face the hose bed and create a bight in the hose approximately four feet from the coupling.' This directly contradicts the question statement. Facing the hose bed while creating a bight in the hose is part of the correct procedure for stretching a supply hose a long distance.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_135_319e3029",
          "question": "When stretching a supply hose a long distance, you should hold the bight over the right shoulder with both hands.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the bight over the right shoulder as you turn away from the engine, holding it with both hands.' This directly supports the question statement. Holding the bight over the right shoulder with both hands is part of the correct procedure for stretching a supply hose a long distance, which can help prevent injury and improve efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_162_1b768df6",
          "question": "The tailboard of the engine should be positioned approximately 10 feet past the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position the engine so that the tailboard is approximately 10 feet past the hydrant.' This positioning allows for efficient hose deployment and connection to the hydrant, which is crucial for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_162_8cceac22",
          "question": "The hose clamp should be placed at least 20 feet from any coupling on the supply side of the hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The clamp must be placed a minimum of 20 feet from the tailboard of the engine, and not less than 3 feet from any coupling on the supply side of the hose.' The question incorrectly states the distance from the coupling, which is actually 3 feet, not 20. Correct placement of the hose clamp is important for safety and efficient water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_162_7fd4eadd",
          "question": "The driver should sound a single horn honk to signal that it is safe for the position #3 and #4 firefighters to exit the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When safe to do so, sound a single horn honk so that the position #3 and #4 firefighters know it is safe to exit the engine.' This is a crucial communication method to ensure firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_162_690cbb88",
          "question": "The driver should face away from the hydrant when applying the hose clamp.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Face the direction of the hydrant during the application of the clamp.' Facing the hydrant provides better visibility and control when applying the hose clamp, which is important for safety and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_162_e9fbaaf3",
          "question": "The driver should connect the male end of the LDH to the desired pump intake using a 4\u201d double female.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Connect the male end of the LDH to the desired pump intake using a 4\u201d double female.' This is a specific procedure that ensures proper water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_163_48860d6a",
          "question": "The hose clamp should be opened rapidly at first and then slowly to prevent water hammer.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The first one to two turns of the clamp will be made in a rapid manner. Then continue to open the clamp with slow turns to prevent water hammer.' This indicates the importance of controlling the speed of opening the hose clamp to prevent sudden pressure changes, known as water hammer, which could potentially damage the firefighting equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_163_effce3d9",
          "question": "If a kink is discovered while returning to the pump panel, it should be ignored until later.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If a significant kink is discovered while returning to the pump panel, remove it immediately.' This contradicts the statement in the question. Immediate removal of kinks ensures uninterrupted water flow which is crucial for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_163_291d5ee0",
          "question": "The driver will act as a member of the Firefighter Stand-by Rescue Team upon completion of the primary supply.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon completion of the primary supply, the driver will don the SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team.' This highlights the multi-role nature of firefighting personnel and the importance of readiness for different tasks during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_163_ffc479dd",
          "question": "Position #3 Firefighter should remain seated while the engine is making the forward lay.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Remain seated while the engine is making the forward lay.' This indicates the importance of safety precautions during firefighting operations, as movement within the vehicle while it is in motion could potentially lead to accidents.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_163_ae40cf2c",
          "question": "Position #4 Firefighter should disconnect the LDH from the tri-gate after the engine comes to a stop at the hydrant location.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Proceed to the tailboard and disconnect the LDH from the tri-gate.' This indicates the role of Position #4 Firefighter in ensuring the proper setup of firefighting equipment for efficient water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_134_1a4a5b30",
          "question": "The position #4 firefighter connects the bell reducer to the 2\u00bd\u201d hose after all of the hose is deployed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Once all of the 2\u00bd\u201d hose is deployed, the position #4 firefighter will connect the bell reducer to the 2\u00bd\u201d hose.' This indicates that the #4 firefighter's responsibility is to connect the bell reducer after the hose is fully deployed, which is crucial for ensuring proper water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_134_244a69ab",
          "question": "Large Diameter Hose (LDH) is not capable of delivering a high volume of flow with little reduction in pressure due to friction loss.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'LDH is capable of delivering a very high volume of flow with little reduction in pressure due to friction loss.' This contradicts the question statement. The ability of LDH to deliver high volume of flow with little pressure reduction is important for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_134_d7cc654b",
          "question": "A single firefighter can overhaul LDH for an unlimited distance without assistance.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A single member can only be expected to overhaul LDH approximately 150 feet without assistance.' This contradicts the question statement. Understanding the limitations of a single firefighter in overhauling LDH is important for planning and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_134_8a0f89e8",
          "question": "When a single member is overhauling hose to the hydrant, they should always keep the coupling in front of them.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Always keep the coupling behind you as you go.' This contradicts the question statement. The position of the coupling is important for the safety and efficiency of the firefighter when overhauling the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_134_80bab7ed",
          "question": "2\u00bd\u201d hose may be used when it is not possible to utilize LDH for the water supply and an additional company will be delayed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When it is not possible to utilize LDH for the water supply, and an additional company will be delayed, 2\u00bd\u201d hose may be used.' This supports the question statement. Knowing when to use different types of hoses is crucial for effective firefighting operations, especially when there are delays in additional support.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_122_a0b12d02",
          "question": "You should charge the attack line with a pressure of greater than 75 PSI before the hose is full of water.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not charge the attack line with a pressure of greater than 75 PSI until the hose is full of water.' Charging the hose with a pressure greater than 75 PSI before it is full can damage the inner lining of the hose, potentially compromising its effectiveness during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_122_f87700c5",
          "question": "To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle clockwise until the valve opens.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle counter-clockwise until the valve opens.' Turning the handle in the wrong direction could lead to improper setting of the PRV, which could affect the discharge pressure and potentially impact firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_122_5468ccb1",
          "question": "The PRV indicator light will illuminate when the valve opens.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text confirms, 'This will be known by 3 indicators: the engine RPM\u2019s will begin to drop, the indicated discharge pressure will also drop, and the PRV indicator light will illuminate.' The illumination of the PRV indicator light is a crucial signal in setting the discharge pressure relief valve, which is essential for maintaining the correct pressure during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_122_5694d9e2",
          "question": "After the hose is filled with water, you should maintain the discharge pressure at 50-75 PSI.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the hose is filled, increase the discharge pressure to the desired setting.' This implies that the discharge pressure should be increased beyond 50-75 PSI after the hose is filled. Maintaining a lower pressure could affect the effectiveness of the water stream in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_122_0b97b460",
          "question": "The procedure for setting the PRV involves turning the operating handle clockwise and counter-clockwise.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text explains, 'Once these occur, turn the operating handle the other direction (clockwise) one-half turn. Pause, and then turn the handle clockwise an additional one-half turn.' This indicates that the procedure for setting the PRV involves turning the operating handle in both directions. Understanding this procedure is important for firefighters to ensure the correct discharge pressure during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_159_4e8d0027",
          "question": "The LDH can be used in place of the Soft Suction hose when attempting to make a Reverse Pump Hook-up if the latter will not reach the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If soft suction hose will not reach the hydrant when attempting to make a Reverse Pump Hook -up, LDH should be utilized in its place.' This indicates that the LDH is a viable alternative to the Soft Suction hose in this scenario. This is important for firefighters to know as it affects their ability to effectively and efficiently set up water supply during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_159_42c8dd5a",
          "question": "The LDH should be connected to the hydrant using a Hydrant Adaptor.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Hydrant Adaptor used to connect LDH to the hydrant.' This shows that a Hydrant Adaptor is necessary to connect the LDH to the hydrant. This is a crucial operational detail for firefighters to ensure proper water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_159_3d1835a4",
          "question": "The LDH should be connected to the secondary side intake using a 4\u201d double female.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'LDH connected to the main side intake using a 4\u201d double female.' This contradicts the statement that the LDH should be connected to the secondary side intake. Understanding the correct connection point is important for firefighters to ensure efficient water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_159_efb35e2a",
          "question": "The Soft Suction hose is the preferred option for a Reverse Pump Hook-up.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Using LDH instead of the Soft Suction (Preferred option).' This suggests that the Soft Suction hose is the preferred option for a Reverse Pump Hook-up. This is important for firefighters to know as it affects their decision-making process when setting up water supply during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_159_d2a620b1",
          "question": "The LDH Supply to the Rear and the LDH Supply to the Front evolutions are not related to the Reverse Pump Hook-up.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '(See evolution instructions for the \u201cLDH Supply to the Rear\u201d and the \u201cLDH Supply to the Front\u201d evolutions.)' This contradicts the statement that these evolutions are not related to the Reverse Pump Hook-up. Understanding the relationship between these evolutions and the Reverse Pump Hook-up is important for firefighters to ensure efficient and effective water supply during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_118_a67e0eb0",
          "question": "The primary responsibility of the engine company engine driver is to provide a continuous supply of water to the operating firefighting force.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The primary responsibility of the engine company engine driver is the safe delivery of personnel to a reported fire or emergency, and to provide a continuous supply of water to the operating firefighting force.' This directly supports the question statement. The ability to provide a continuous supply of water is critical for firefighting operations as it enables the firefighting force to effectively combat the fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_118_f299740c",
          "question": "The engine driver must shift the Power Take-off (PTO) from road to pump before setting the parking brake.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '1. Set the parking brake. 4. Shift the Power Take-off (PTO) from road to pump.' This contradicts the question statement. The correct sequence of operations is critical for safety and effective firefighting operations. Setting the parking brake ensures the vehicle is stable before shifting the PTO, which engages the pump for water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_118_705e0c20",
          "question": "The 'OK to Pump' light must be illuminated before the driver exits the cab.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The \u201cOK to Pump\u201d light must also be illuminated. The engine is now in pump gear. 1. Release the seat belt and exit the cab.' This directly supports the question statement. The illumination of the 'OK to Pump' light indicates that the pump is engaged and ready for operation, which is a vital step before the driver exits the cab to ensure continuous water supply for firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_118_83f087a5",
          "question": "After completing the primary supply, the driver will act as a member of the Rapid Intervention Team.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Upon completion of the primary supply, the driver will don SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team, until a Rapid Intervention Team has been assigned.' This contradicts the question statement. The driver acts as a member of the Firefighter Stand-by Rescue Team, not the Rapid Intervention Team. This role is important for firefighter safety as it provides additional support and readiness for rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_118_9e73eca0",
          "question": "The engine driver's responsibilities include recognizing the need for and initiating supply line operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Drivers must also recognize the need for and initiate supply line operations.' This directly supports the question statement. Recognizing the need for and initiating supply line operations is a critical responsibility of the engine driver, as it ensures a continuous and adequate water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_138_83d6f1e6",
          "question": "The hydrant bag and hydrant wrenches are not necessary when returning to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Procure the hydrant bag and hydrant wrenches and return to the hydrant.' This indicates that the hydrant bag and hydrant wrenches are indeed necessary when returning to the hydrant. These tools are essential for firefighters to effectively connect the hydrant to the engine and ensure a reliable water source during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_138_e5ed0a89",
          "question": "The 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant are removed with a corey wrench.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "According to the text, 'Remove the 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant with a corey wrench.' This shows that a corey wrench is used to remove these caps. This is an important step in preparing the hydrant for connection to the engine, which is crucial for water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_138_b3e63924",
          "question": "The hydrant gate should be left in the open position when attached to the 2\u00bd\u201d port.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying, 'Attach the hydrant gate to the 2\u00bd\u201d port and ensure that the gate is in the closed position.' This means that the hydrant gate should be in the closed position when attached to the 2\u00bd\u201d port. This is a safety measure to prevent uncontrolled water flow when the hydrant is initially connected.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_138_a356effa",
          "question": "The LDH is attached directly to the engine port.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach the hydrant adapter to the engine port and the LDH to the hydrant adapter.' This indicates that the LDH is not attached directly to the engine port, but to the hydrant adapter. This step is crucial for ensuring a secure connection between the hydrant and the engine, which is necessary for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_138_006cbd68",
          "question": "The hydrant adapter is used to connect the LDH to the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying, '. Hydrant Adaptor used to connect LDH to the hydrant.' This shows that the hydrant adapter is indeed used to connect the LDH to the hydrant. This is a critical step in establishing a water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_155_638caaa6",
          "question": "The company Officer is the only one who can signal the driver to proceed to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Officer or the position #4 firefighter will give this order.' This means that either the Officer or the position #4 firefighter can give the signal, not just the Officer. This is important as it affects communication and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_155_b2958657",
          "question": "The driver should exit the cab immediately after honking the horn once.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remain seated in the engine while all other members remove the necessary hose and equipment.' This contradicts the statement, indicating that the driver should stay in the cab until all other members have exited and removed the necessary equipment. This is a safety measure to ensure that all members are clear of the vehicle before it moves.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_155_c62868e2",
          "question": "The standard length of the soft suction hose is 24 feet.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '(Standard soft suction length is 24 feet.)' This supports the statement. Knowing the standard length of the hose is important for positioning the engine and planning the hose lay.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_155_6cd4ec95",
          "question": "The intake should be positioned not less than one-third the length of the suction hose laterally from the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position the intake as follows: - Not less than one -third the length of the suction hose laterally.' This supports the statement. Proper positioning of the intake is crucial for efficient water supply and can affect firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_155_23d6099f",
          "question": "The female end of the LDH should be connected to the 4\u201d rear discharge port.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Connect the male end of the LDH to the 4\u201d rear discharge port.' This contradicts the statement, indicating that the male end of the LDH, not the female end, should be connected to the 4\u201d rear discharge port. This is important for proper connection of hoses and equipment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_143_80839a1c",
          "question": "If a significant kink is found while returning to the pump panel, it should be removed immediately.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Return to the engine\u2019s pump if a significant kink is found while returning to the pump panel remove it immediately.' This implies that significant kinks can hinder the flow of water, which is crucial in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_143_1b14cce0",
          "question": "If the PRV was properly set, it will likely require adjustment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the PRV was properly set, it will likely not require any adjustment.' This implies that a properly set PRV does not need to be adjusted, ensuring the efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_143_6696a657",
          "question": "The driver should don SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team if one is not already in place and a Rapid Intervention Team has not yet been assigned.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon completion of the primary supply, the driver will don SCBA to a stand - by position and act as a member of the Firefighter Stand-by Rescue Team if one is not already in place and a Rapid Intervention Team has not yet been assigned.' This highlights the importance of having a standby rescue team in place for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_143_afba1775",
          "question": "Traffic cones are not necessary to protect personnel, the engine, and hose lines from approaching vehicles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles.' This shows the importance of using traffic cones for safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_143_475f511a",
          "question": "Once a second water supply has been established, there is no need to refill any water already used from the engine\u2019s booster tank.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once a second supply has been established, refill any water already used from the engine\u2019s booster tank by opening the tank fill valve.' This implies that it is important to maintain a sufficient water supply for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_114_d967e29e",
          "question": "The Seattle Fire Department Basic Skills Manual is a tactics textbook.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It should be noted that the Seattle Fire Department Basic Skills Manual is not a tactics textbook.' This contradicts the statement in the question, implying that the manual is not meant to provide tactical guidance but rather to outline basic skills and procedures.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_114_b6664322",
          "question": "The first hose line is always placed between the fire and the most severe exposure.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If it is determined there is no life hazard in the building, the first line is positioned between the fire and the most severe exposure.' This indicates that the placement of the first hose line depends on whether there is a life hazard in the building, contradicting the absolute statement in the question.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_114_27cb8cb0",
          "question": "The primary function of the engine company is stretching and operating hose lines.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Stretching and operating hose lines is the primary function of the engine company.' This directly supports the statement in the question, indicating that the main responsibility of the engine company is to manage hose lines during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_114_04c8a9cc",
          "question": "The majority of structural fires are controlled and extinguished by the initial line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The majority of structural fires are controlled and extinguished by this initial line.' This directly supports the statement in the question, highlighting the importance of the initial hose line in controlling and extinguishing fires.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_114_206b17ed",
          "question": "More lives are saved at fire operations by the proper positioning and operating of hose lines than by all other life-saving techniques available to firefighting forces.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'More lives are saved at fire operations by the proper positioning and operating of hose lines than by all other life-saving techniques available to firefighting forces.' This directly supports the statement in the question, emphasizing the critical role of proper hose line management in saving lives during fire operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_148_66273dd1",
          "question": "The second section of 2\u00bd\u201d hose should be placed on the ground next to the nozzle bundle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Remove the second section of 2\u00bd\u201d hose from the bed and place it on the ground next to the nozzle bundle.' This supports the statement and indicates the importance of proper hose placement for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_148_31a31e69",
          "question": "If the Officer is unavailable, the tri-gate should be left in its original position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the Officer is unavailable, remove the tri-gate and position it between the unloaded 2 \u00bd\u201d bundles and the engine.' This contradicts the statement and highlights the importance of adapting roles and responsibilities in the absence of the Officer for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_148_ad7fcae3",
          "question": "The signal to the driver to proceed to the hydrant should be only visual.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This signal should be both audible and visual, by pointing forward while shouting \u201c Go ahead .\u201d' This contradicts the statement and emphasizes the need for clear and multi-modal communication in firefighting scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_148_0732a238",
          "question": "If the Officer is unable to foot the tri-gate, the position #4 firefighter will have the responsibility of ensuring that all required hose and equipment has been removed from the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the Officer is unable to foot the tri-gate or LDH because of incident command responsibilities, the position #4 firefighter will have sole responsibility of ensuring that all required hose and equipment has been removed from the engine.' This supports the statement and underscores the importance of understanding and executing role-specific responsibilities in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_148_f2031572",
          "question": "After completing the task of ensuring that all required hose and equipment has been removed from the engine, position #4 firefighter will wait for instructions from the Officer to direct the driver to proceed to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'After completing this task, position #4 firefighter will then direct the driver to proceed to the hydrant without instructions from the Officer.' This contradicts the statement and highlights the importance of initiative and independent action in certain firefighting situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_172_da0c06f9",
          "question": "The Officer (2nd engine) should remain seated in the engine until the driver sounds the proper horn signal.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Exit the cab after the driver sounds the proper horn signal.' This indicates that the Officer should exit the cab after the signal, not remain seated. This is important for safety and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_172_d0e4108c",
          "question": "The position #3 firefighter (2nd engine) may be directed to the hydrant with the driver to assist with the reverse pump hook-up.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'If directed to the hydrant with the driver, remain in the cab while the engine makes its first stop, then proceed to the hydrant with the driver and assist with the reverse pump hook-up.' This shows that the position #3 firefighter may be directed to assist with the reverse pump hook-up, which is crucial for ensuring a rapid water supply connection.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_172_6a7395ba",
          "question": "The position #4 firefighter (2nd engine) should exit the cab before the driver sounds the proper horn signal.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Exit the cab after the driver sounds the proper horn signal.' This indicates that the position #4 firefighter should exit the cab after the signal, not before. This is important for safety and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_172_67c0c4c7",
          "question": "The driver (2nd engine) should position the engine as directed by the Officer and sound a single horn honk to signal it is safe to exit the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Position the engine as directed by the Officer. Sound a single horn honk so that the Officer and position #4 firefighter know that it is safe to exit the engine.' This shows that the driver should follow the Officer's directions and use the horn signal for safety, which is crucial for ensuring a coordinated response.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_172_d83090f5",
          "question": "The Officer (2nd engine) should remove the Officer\u2019s SCBA and appropriate tools from the engine and place these items on the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Remove the Officer\u2019s SCBA and appropriate tools from the engine and place these items on the ground.' This shows that the Officer should remove and place these items, which is important for ensuring readiness for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_125_985da77a",
          "question": "The discharge pressure should be increased to the desired setting before the hose is full of water.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not charge the attack line with a pressure of greater than 75 PSI until the hose is full of water.' This means that the discharge pressure should not be increased to the desired setting until after the hose is filled with water to avoid damaging the inner lining of the hose. This is important for maintaining the integrity of the firefighting equipment and ensuring effective water delivery for fire suppression.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_125_37c6a4c4",
          "question": "The PRV operating handle should be turned clockwise until the valve opens.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle counter-clockwise until the valve opens.' This means that the PRV operating handle should be turned counter-clockwise, not clockwise, to open the valve. Understanding the correct operation of equipment is crucial for effective firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_125_1b545a55",
          "question": "The discharge pressure should be maintained between 50-75 PSI while the hose is being filled.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Maintain 50-75 PSI while the hose is being filled by manipulating the throttle as needed.' This means that the discharge pressure should indeed be maintained between 50-75 PSI while the hose is being filled. This is important for ensuring safe and effective water delivery during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_125_13ded9c5",
          "question": "The position #3 firefighter should shoulder-load the first length of 2 \u00bd\u201d hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position #3 Firefighter - Shoulder-load the first length of 2 \u00bd\u201d hose.' This means that the position #3 firefighter is responsible for shoulder-loading the first length of the hose. Understanding roles and responsibilities during firefighting operations is crucial for teamwork and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_125_756fc9b2",
          "question": "The attack line should be charged before assessing the fire stream for an appropriate volume of water flow (GPM).",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Bleed the air from the charged hose line, assess the fire stream for an appropriate volume of water flow (GPM), and check the fire stream for the appropriate pattern.' This means that the attack line should indeed be charged before assessing the fire stream for an appropriate volume of water flow. This is important for ensuring effective water delivery and fire suppression.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_133_8dd0c546",
          "question": "The position #4 firefighter is responsible for placing the second section of the apartment bundle neatly on the ground and untying the bundle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon reaching the end of the 2\u00bd\u201d line, the position #4 firefighter places the second section of the apartment bundle neatly on the ground and unties the bundle.' This supports the statement and highlights the importance of clear roles and responsibilities during firefighting operations for efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_133_e9159027",
          "question": "The position #3 firefighter should drop portions of the first section (shoulder-load) while the second section is being stretched out.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This firefighter should not drop any portion of the first section (shoulder-load) until all of the second section has been stretched out.' This contradicts the statement and emphasizes the importance of maintaining control of equipment during firefighting operations to ensure effective deployment of resources.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_133_f7323d64",
          "question": "After connecting the bell reducer to the 2\u00bd\u201d line, position #4 firefighter should immediately begin advancing the hose line to the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'After connecting the bell reducer to the 2\u00bd\u201d line, position #4 firefighter meets the other member at the nozzle.' This contradicts the statement and underscores the importance of teamwork and coordination in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_133_661b2a18",
          "question": "If some of the 2 \u00bd\u201d hose will be used inside of the structure, the position #3 and #4 firefighters each grab two or three bights of 2\u00bd\u201d hose while retaining their apartment bundle sections on their shoulder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon reaching the end of the 2\u00bd\u201d bundle (left bundled by the driver), the position #3 and #4 firefighters each grab two or three bights of 2\u00bd\u201d hose with the left hand while retaining their apartment bundle sections on their shoulder.' This supports the statement and highlights the need for firefighters to be adaptable and versatile in handling different equipment based on the firefighting scenario.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_133_a60d4028",
          "question": "The position #4 firefighter should instruct the position #3 firefighter to 'stretch the 2\u00bd\u201d' before dropping the last flake of 2\u00bd\u201d hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When this firefighter drops the last flake, they should instruct the position #3 firefighter to \u201cstretch the 2\u00bd\u201d.' This supports the statement and emphasizes the importance of communication and coordination among firefighters during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_164_26c5059e",
          "question": "The first due company is responsible for making the hydrant connections in the Forward Lay - Dry evolution.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A later arriving company will be directed to make the hydrant connections in the Forward Lay \u2013 Dry evolution. No hydrant connections are made by the members of the first due company.' This contradicts the question statement, indicating that it is not the first due company but a later arriving one that makes the hydrant connections. This has implications for firefighting operations and coordination between different companies.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_164_87adf0d1",
          "question": "The driver should position the engine so that the tailboard is approximately 10 feet past the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Driver - Position the engine so that the tailboard is approximately 10 feet past the hydrant.' This supports the question statement, indicating that the driver's positioning of the engine is crucial for the Forward Lay operation. This is important for firefighting tactics and safety, as it ensures the engine is correctly positioned for hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_164_d5db5bf0",
          "question": "The position #3 and #4 firefighters should exit the engine before the driver sounds a single horn honk.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When safe to do so, sound a single horn honk so that the position #3 and #4 firefighters know it is safe to exit the engine.' This contradicts the question statement, indicating that the horn honk is a signal for the firefighters to exit the engine. This is a safety measure to ensure firefighters exit the engine only when it is safe to do so.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_164_0b2873f4",
          "question": "The Officer should remain seated in the engine until the Forward Lay is completed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Remain seated in the engine until the Forward Lay is completed.' This supports the question statement, indicating that the Officer should stay in the engine during the Forward Lay operation. This is a safety measure to ensure the Officer is not exposed to potential hazards during this operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_164_ca5b5ae5",
          "question": "The Officer should don the SCBA at the fire scene before supervising and assisting the company in fire suppression and rescue activities.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'At the fire scene, don the SCBA. Supervise and assist the company in fire suppression and rescue activities as outlined in the POG.' This supports the question statement, indicating that the Officer should wear the SCBA at the fire scene before carrying out their duties. This is a crucial safety measure to protect the Officer from smoke and toxic gases.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_144_36c03a4d",
          "question": "A second supply line from a different hydrant is required only when supplying a 2\u00bd\u201d attack line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A second supply line from a different hydrant is required when any of the following apply: If supplying a 2\u00bd\u201d attack line, If pumping 300 gallons per minute or more, While pumping at any multiple alarm fire.' This means that there are other conditions under which a second supply line is required, not just when supplying a 2\u00bd\u201d attack line. This is important for firefighters to understand to ensure adequate water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_144_b2028abe",
          "question": "The intake valve for the redundant supply should be opened before the hydrant connection is made.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not open the intake valve for the redundant supply until that line has been connected to the hydrant and charged.' This contradicts the question statement. This is a critical safety measure to prevent water from abruptly backfilling the hose, which would make connection to the hydrant impossible.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_144_a4f3b999",
          "question": "The methods for obtaining the second supply will be different from the primary supply line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The methods for obtaining the second supply will be the same as for the primary supply line.' This contradicts the question statement. Understanding this helps firefighters to efficiently set up redundant supply lines during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_144_a33f64c5",
          "question": "A redundant supply is highly recommended even if the rules for its requirement do not apply.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A redundant supply is highly recommended whenever operating at a working fire or other hazardous environment even if the above rules do not apply.' This supports the question statement. This is a key safety measure to ensure a greater margin of safety with redundant supply lines.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_144_32787854",
          "question": "For a reverse lay, a large compliment of hose and equipment must be removed from the engine at the fire scene before the engine can proceed to the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For a reverse lay, a large compliment of hose and equipment must be removed from the engine at the fire scene. This task must be completed before the engine can proceed to the hydrant.' This supports the question statement. This is a critical operational consideration for firefighters when performing a reverse lay.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_152_cb97bdb7",
          "question": "After all hose and equipment has been removed from the engine, the 200 feet of 2\u00bd\u201d hose should be broken into two separate sections.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When all hose and equipment has been removed from the engine, break the 200 feet of 2\u00bd\u201d hose into two separate sections.' This supports the statement and is a crucial step in preparing the hose for deployment, which can affect the efficiency and safety of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_152_69549612",
          "question": "The female couplings should be handed off to the position #1 firefighter at the tri-gate.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Hand the female couplings off to the position #4 firefighter at the tri-gate.' This contradicts the statement. The correct assignment of roles and tasks is essential for the smooth operation and coordination of firefighting efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_152_193f0be9",
          "question": "The 2\u00bd\u201d hose lines should be stretched approximately 100 feet beyond the monitor.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'simultaneously stretch the 2\u00bd\u201d hose lines approximately 50 feet beyond the monitor.' This contradicts the statement. Correctly understanding the required distance for stretching the hose lines can affect the range and effectiveness of the water stream during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_152_bd748314",
          "question": "Both 2 \u00bd\u201d lines are stretched 50 feet beyond the monitor.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Both 2 \u00bd\u201d lines are stretched 50 feet beyond the monitor.' This supports the statement. The correct positioning of the hose lines can impact the ability to successfully control and extinguish a fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_152_7e966390",
          "question": "Lines are brought back 30 feet behind the monitor.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Lines are brought back 20 feet behind the monitor.' This contradicts the statement. The correct positioning of the hose lines after being stretched can affect the safety of firefighters and the effectiveness of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_129_fb7527a8",
          "question": "The maximum overall length of the hose lay for an 'Extended Attack' should not exceed 700 feet.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The maximum overall length of this hose lay should not exceed 700 feet.' This is important as exceeding this length could affect pump pressures and volume, potentially compromising the effectiveness of the firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_129_1e4688a1",
          "question": "If more than 400' of hose is needed, the 'Blitz line' should still be used for the 2 1/2\" hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If greater than 400' of hose is needed to reach the objective, the 2 1/2\" Bulk Bed shall be used instead of the 'Blitz line' for the 2 1/2\" hose.' This is crucial for firefighters to understand, as using the incorrect equipment could hinder the firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_129_2e416a14",
          "question": "The 'Blitz line' allows for foam use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Using the Blitz line will allow for foam use.' This is a key tactical consideration, as foam can be more effective in certain firefighting scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_129_979cafce",
          "question": "Any changes to the length of the 'Extended Attack' do not need to be communicated.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Any change to the length of the \u201cExtended Attack\u201d must be verbalized via radio.' This is a key safety and operational consideration, as changes to the plan must be communicated to ensure all team members are aware and can adjust their actions accordingly.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_129_875d9144",
          "question": "The first 100-foot section of the 2 1/2\" 'Blitz Line' should be shoulder-loaded by the driver.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Shoulder-load the first 100-foot section of the 2 1/2\" \"Blitz Line\" (this task can be accomplished by the Officer, if they are available).' This is a key operational consideration, as it affects how the hose is deployed and can impact the efficiency of the firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_168_bb74372b",
          "question": "The signal to the driver to proceed to the hydrant should be both audible and visual.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This signal should be both audible and visual, by pointing forward while shouting \u201cGo ahead.\u201d' This is important for clear communication between firefighters, especially in noisy or visually obstructed environments.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_168_7f369ec2",
          "question": "The body loop should be removed as soon as the engine starts making the lay.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The body loop must not be removed until the engine has stopped at the fire.' This is crucial for safety as premature removal could lead to uncontrolled hose movement or other hazards.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_168_3f8c0713",
          "question": "The hydrant should be opened fully before the driver has come to a stop.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once you are certain that the driver has come to a stop and a hose gate has been placed, open the hydrant fully.' This ensures that water pressure is controlled and the hose is properly secured before water is released.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_168_5d92eb00",
          "question": "If the other members of the company have not yet entered the fire building, the firefighter should assist in stretching the attack line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the other members of the company have not yet entered the fire building, procure appropriate tools and assist in stretching the attack line.' This highlights the importance of teamwork and efficient use of resources in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_168_bb80c690",
          "question": "Major kinks in the LDH should be ignored to ensure a quick return to the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'While returning to the engine, remove any major kinks in the LDH to ensure a good supply is received at the engine\u2019s intake.' This emphasizes the importance of maintaining the integrity of the hose for effective water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_169_b01fca1c",
          "question": "The Blind Alley Lay is a split lay that requires three engine companies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Blind Alley Lay is a split lay that is accomplished with two engine companies.' This contradicts the statement that three engine companies are required. Understanding the number of engine companies required for a specific operation is crucial for effective resource allocation during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_169_1bf64c43",
          "question": "The Blind Alley Lay can be utilized when a forward lay is required down an alley, private drive, or other limited access road.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This lay may be utilized when a forward lay is required down an alley, private drive, or other limited access road.' This supports the statement. Knowing when to use specific tactics like the Blind Alley Lay is important for efficient firefighting, especially in areas with limited access.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_169_bd76fe37",
          "question": "The first engine company drops the tri-gate at the end of the alley or private drive.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The first engine will drop the tri-gate at the entrance of the alley or private drive.' This contradicts the statement that the tri-gate is dropped at the end of the alley. Understanding the correct procedure for deploying equipment is crucial for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_169_f983f5ef",
          "question": "The LDH can be secured to a substantial object with a body loop so that a member is not required to foot the tri-gate.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The LDH can be secured to a substantial object (e.g. mail box, fence post) with a body loop so that a member is not required to foot the tri-gate.' This supports the statement. Knowing how to secure equipment properly can enhance firefighter safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_169_e70efd04",
          "question": "The initial engine company lays forward to the fire after the second half of the split lay.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This engine company will then perform the first half of the split lay...Initial engine company lays forward to the fire.' This contradicts the statement that the initial engine company lays forward to the fire after the second half of the split lay. Understanding the sequence of operations is important for coordinating firefighting efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_128_c8f5a6dc",
          "question": "The first section of the 2 1/2\" hose is loaded by the backup member.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Seattle Fire Department Member shoulder-loading first section of 2 1/2\"'. This contradicts the statement, as it is the main member, not the backup member, who loads the first section of the hose. This is important for firefighting operations as it determines the roles and responsibilities during hose deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_128_4f6eac86",
          "question": "The position #4 firefighter assists the position #3 firefighter with stretching the second section of the blitz line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Assist the position #3 firefighter with stretching the second section of the blitz line, as necessary.' This supports the statement. Understanding the roles and responsibilities of each position is crucial for effective teamwork and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_128_188e8812",
          "question": "The position #4 firefighter is responsible for providing forcible entry as required.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Provide forcible entry as required.' This supports the statement. Knowing who is responsible for forcible entry is important for tactical considerations and ensuring a swift and effective response.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_128_d5cab17e",
          "question": "The backup member is responsible for operating the hose line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Assist in advancing and operating the hose line.' This contradicts the statement, as it is the position #4 firefighter, not the backup member, who assists in operating the hose line. This is important for understanding the division of labor and responsibilities during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_128_01432822",
          "question": "The position #4 firefighter is responsible for covering with the SCBA.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Cover with the SCBA.' This supports the statement. Understanding who is responsible for using the SCBA is crucial for safety during firefighting operations, as it provides respiratory protection in environments with potentially harmful gases and particulates.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_153_125f7cbe",
          "question": "The 2\u00bd\u201d hose lines are connected to the monitor before being spread out into position for operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Turn again towards the monitor, while still holding each coupling, and connect each of the 2\u00bd\u201d lines to the monitor. . Connections to the monitor are made. Spread out the 2\u00bd\u201d hose lines into position for monitor operation.' This indicates that the hose lines are connected to the monitor before being spread into position for operation. This sequence is important in firefighting operations to ensure proper setup and functionality of the monitor.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_153_1a44eaba",
          "question": "The monitor\u2019s anchor chain is tied to the 2\u00bd\u201d hose lines at the point where they cross behind the monitor.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Secure the monitor\u2019s anchor chain to the 2\u00bd\u201d ho se lines at the point where they cross in front of the monitor.' This contradicts the statement as the anchor chain is secured at the point where the hose lines cross in front of the monitor, not behind. This is crucial for the stability and safety of the monitor during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_153_2d989049",
          "question": "A body loop is tied around the 2\u00bd\u201d hose lines at the point where they cross behind the monitor.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Tie a body loop around the 2\u00bd\u201d hose lines at the point where they cross behind the monitor.' This supports the statement that a body loop is tied at the point where the hose lines cross behind the monitor. This step is important for securing the hose lines and ensuring the proper operation of the monitor during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_153_99e6a92a",
          "question": "The monitor is not ready for operation after these steps are completed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The monitor is ready for operation.' This contradicts the statement as the monitor is ready for operation after these steps are completed. Understanding this sequence is important for firefighters to ensure the monitor is properly set up and ready for use in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_153_e0ceb018",
          "question": "The monitor operation is not part of Engine Evolutions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Chapter 4 \u2022 Engine Evolutions.' This contradicts the statement as the monitor operation is part of Engine Evolutions. Understanding this is crucial for firefighters as it helps in understanding the role and operation of the monitor in the context of engine evolutions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_145_2c57d7ff",
          "question": "Removing and positioning the tri-gate is always a two-member operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Removing and positioning the tri-gate is normally a one member operation, but if the tri -gate must be positioned at some distance from the engine, two members should be used to overhaul it.' This indicates that while it can be a two-member operation, it is not always required to be so. This has implications for resource allocation during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_145_b6c9377b",
          "question": "The member footing the tri-gate or LDH should be positioned on the fire side, in a location clearly visible to the driver in the rear view mirror.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member footing the tri-gate or LDH should be positioned on the fire side, in a location clearly visible to the driver in the rear view mirror.' This is important for safety and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_145_bea93a0f",
          "question": "The command 'Go ahead' is only made verbally.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When all equipment that is needed and the tri -gate or LDH is properly footed, the command \u201c Go ahead \u201d is made both verbally and visually.' This indicates the importance of clear communication in both forms during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_145_83b45074",
          "question": "Members should be between the LDH hose and/or tri-gate while the engine is moving.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Members should not be between the LDH hose and/or tri-gate while the engine is moving.' This is a safety consideration to prevent injury during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_145_1a8ad6bb",
          "question": "The valves on the tri-gate should be checked to be sure they are all closed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The valves on the tri-gate should be checked to be sure they are all closed.' This is an important step to ensure the proper functioning of the equipment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_165_0e359eb0",
          "question": "The hose clamp must be placed a minimum of 20 feet from the tailboard of the engine, and not less than 3 feet from any coupling. Is this statement true or false?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The statement is true. The text states, 'The clamp must be placed a minimum of 20 feet from the tailboard of the engine, and not less than 3 feet from any coupling.' This is important for safety reasons, to ensure the hose is properly secured and to prevent any potential damage to the hose or coupling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_165_96080d97",
          "question": "The driver should face the direction of the engine while applying the hose clamp. Is this statement true or false?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The statement is false. The text states, 'Face the direction of the hydrant during the application of the clamp.' This is crucial for safety and operational efficiency, as facing the source of the water supply can help the driver ensure the clamp is properly applied and the hose is secure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_165_3b06c323",
          "question": "The female end of the LDH should be placed under the tailboard to minimize the tripping hazard. Is this statement true or false?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The statement is true. The text states, 'Return to that coupling, break the connection, and place the female end under the tailboard to minimize the tripping hazard.' This is a vital safety measure to prevent accidents on the fire scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_165_3790ac82",
          "question": "The first one to two turns of the clamp will be made while facing the hydrant. Is this statement true or false?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The statement is false. The text states, 'Return to the hose clamp, face the engine (the direction of water flow), and open the clamp. The first one to two turns of the clamp will be made.' This is important for operational efficiency and safety, as it ensures the clamp is properly opened and the water flow is correctly directed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_165_1ffc68a7",
          "question": "The male end of the LDH is connected to the desired pump intake using a 4\u201d double female. Is this statement true or false?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The statement is true. The text states, 'Connect the male end of the LDH to the desired pump intake using a 4\u201d double female.' This is crucial for ensuring the correct connection and water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_132_13f512ae",
          "question": "The #4 firefighter is responsible for connecting the bell reducer to the 2 \u00bd\u201d hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Seattle Fire Department Position #4 connecting the bell reducer to the 2 \u00bd\u201d hose.' This shows that the #4 firefighter has the responsibility of connecting the bell reducer to the hose. This is crucial in firefighting operations as it ensures the right equipment is connected for effective firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_132_0ffce70e",
          "question": "If there are no obstacles, the #3 firefighter cannot complete the stretch themselves.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If there are no obstacles, the #3 firefighter may be able to simply grab the center bight of the bundle on the ground and complete the stretch themselves.' This contradicts the statement as it shows that the #3 firefighter can complete the stretch themselves if there are no obstacles. This is important in firefighting as it allows for quicker deployment of the hose line when there are no obstacles.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_132_518bd2c3",
          "question": "If there are obstacles, it may be necessary for the #4 firefighter to re-shoulder-load the remainder of the 1\u00be\u201d hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If there are obstacles (furniture, stairs, etc.), it may be necessary for the #4 firefighter to re-shoulder-load the remainder of the 1\u00be\u201d hose.' This supports the statement and shows that obstacles may require the #4 firefighter to re-shoulder-load the hose. This is a tactical consideration during firefighting operations to ensure the hose line is properly deployed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_132_b182c613",
          "question": "The SCBA is not necessary when advancing and operating the hose line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Assist in advancing and operating the hose line. Cover with the SCBA.' This contradicts the statement as it shows that the SCBA is necessary when advancing and operating the hose line. This is a safety implication for firefighters as the SCBA provides respiratory protection from smoke and harmful gases.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_132_855f12ff",
          "question": "Position #3 and #4 do not advance with the apartment bundle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Position #3 and #4 advancing with the apartment bundle.' This contradicts the statement as it shows that Position #3 and #4 do advance with the apartment bundle. This is an operational concern during firefighting as it involves the movement and positioning of firefighters and equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_124_34b05d83",
          "question": "The Officer is responsible for directing the driver where to position the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Officer - Direct the driver where to position the engine.' This indicates that it is the Officer's responsibility to guide the driver in positioning the engine. This is crucial in firefighting operations as the positioning of the engine can impact the effectiveness of the fire attack.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_124_a6089f83",
          "question": "If more than 200 feet of attack line is needed, additional 2\u00bd\u201d hose should be removed from the engine without the Officer's indication.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If more than 200 feet of attack line will be needed to reach the objective, members will work together to remove additional 2\u00bd\u201d hose from the engine as needed. The Officer must indicate the length of the stretch to the company members if longer than 200 feet is desired.' This contradicts the statement as it clearly mentions that the Officer must indicate if a longer stretch is required. This is important as it ensures coordination and effective communication within the team during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_124_5673a89b",
          "question": "The Driver is responsible for breaking the 2\u00bd\u201d coupling that will reach the desired discharge port.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Go to the tailboard and break the 2\u00bd\u201d coupling that will reach the desired discharge port.' This supports the statement that the Driver is responsible for breaking the 2\u00bd\u201d coupling. This is a critical task as it ensures the correct length of hose is available for the fire attack.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_124_bcc016a4",
          "question": "The Officer is responsible for connecting the 2\u00bd\u201d line to the appropriate discharge port.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Connect the 2\u00bd\u201d line to the appropriate discharge port.' This task is mentioned under the responsibilities of the Driver, not the Officer, contradicting the statement. This is a key operational task that ensures the hose is correctly connected for effective water discharge during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_124_0b548fb1",
          "question": "The Officer should sling the SCBA to the stand-by position as a member of the Firefighter Stand-by Rescue Team.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Sling the SCBA to the stand-by position as a member of the Firefighter Stand-by Rescue Team.' This supports the statement that the Officer should sling the SCBA to the stand-by position. This is a safety measure that ensures the Officer is prepared for immediate action in case of a rescue situation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_173_4bdbaacf",
          "question": "The second engine company lays reverse to the hydrant in the Seattle Fire Department's engine evolutions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The second engine company lays reverse to the hydrant.' This means that the second engine company's role in the engine evolution is to lay the hose in a direction opposite to the hydrant. This is a tactical consideration in firefighting operations to ensure efficient water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_173_2c86d898",
          "question": "The first engine pumps to the second as a relay pumping evolution.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The final result will be the second engine pumping to the first as a relay pumping evolution.' This contradicts the statement because it is the second engine that pumps to the first, not the other way around. Understanding this is crucial for firefighters as it affects the operations and efficiency of firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_173_14390557",
          "question": "Relay pumping evolution is a strategy used by the Seattle Fire Department to enhance water supply during firefighting operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The final result will be the second engine pumping to the first as a relay pumping evolution.' This supports the statement that relay pumping evolution is a strategy used to enhance water supply. This is a key operational concern in firefighting, ensuring that there is sufficient water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_173_b6d7b9cc",
          "question": "The first engine company lays reverse to the hydrant in the Seattle Fire Department's engine evolutions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The second engine company lays reverse to the hydrant.' This contradicts the statement because it is the second engine company that lays reverse to the hydrant, not the first. This is a tactical consideration that affects the efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_173_13285ed3",
          "question": "The relay pumping evolution is the initial step in the Seattle Fire Department's engine evolutions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The final result will be the second engine pumping to the first as a relay pumping evolution.' This contradicts the statement because the relay pumping evolution is the final result, not the initial step. Understanding the sequence of operations is important for firefighters to ensure effective and efficient firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_149_f373158d",
          "question": "The 2\u00bd\u201d female coupling should be connected to the tri-gated wye before all equipment and hose has been removed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Look to see that all equipment and hose has been removed. When safe to do so, connect the 2\u00bd\u201d female coupling to the tri-gated wye.' This indicates that all equipment and hose should be removed before connecting the coupling to the wye. This is important for firefighter safety and efficient operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_149_6ff0d9c2",
          "question": "The gate valve should be opened immediately after connecting the 2\u00bd\u201d female coupling to the tri-gated wye.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not open the gate valve at this time.' This contradicts the statement in the question. The timing of opening the gate valve is crucial in firefighting operations to control the water flow and pressure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_149_714bb8fd",
          "question": "The last flake of hose from your shoulder should be thrown by instructing the position #3 firefighter to 'stretch'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'As you throw the last flake of hose from your shoulder, instruct the position #3 firefighter to \u201c stretch .\u201d' This supports the statement in the question. This coordination is important for effective hose deployment and teamwork in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_149_265fd1b9",
          "question": "The nozzle section of the 2\u00bd\u201d hose should be placed furthest from the fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'All of the hose should be placed on the fire side of the engine, and in sequential order \u2013 the nozzle section being closest to the fire.' This contradicts the statement in the question. The placement of the nozzle section closest to the fire is crucial for effective firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_149_3944df26",
          "question": "More than 200 feet of attack line is required for a 2\u00bd\u201d Manifold.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '2\u00bd\u201d Manifold - More than 200 feet of attack line required.' This supports the statement in the question. Understanding the required length of attack line is important for effective firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_166_246dad38",
          "question": "The hose clamp should be opened rapidly to prevent water hammer.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Then continue to open the clamp with slow turns to prevent water hammer.' This contradicts the statement in the question, indicating that slow turns, not rapid opening, prevent water hammer. Understanding this is crucial for firefighters to prevent equipment damage and ensure a steady water supply during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_166_626d1d9b",
          "question": "If a significant kink is discovered while returning to the pump panel, it should be removed immediately.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If a significant kink is discovered while returning to the pump panel, remove it immediately.' This supports the statement in the question, emphasizing the importance of maintaining a clear water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_166_5156b906",
          "question": "After completion of the primary supply, the driver does not need to don the SCBA.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Upon completion of the primary supply, the driver will don the SCBA to a stand-by position.' This contradicts the statement in the question, highlighting the importance of personal protective equipment even when not directly engaged in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_166_e34fb214",
          "question": "Traffic cones should be positioned to protect personnel, the engine, and hose lines from approaching vehicles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles.' This supports the statement in the question, underlining the importance of safety measures to protect firefighters and equipment on the scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_166_c811bbe1",
          "question": "The incident commander should always be recommended to lay a second supply by another engine company.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If necessary, recommend to the incident commander that a second supply be laid by another engine company.' This contradicts the statement in the question, indicating that the decision to lay a second supply is situational and not always necessary. This reflects the dynamic decision-making required in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_131_f87700c5",
          "question": "To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle clockwise until the valve opens.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle counter-clockwise until the valve opens.' This contradicts the question statement, which suggests turning the handle clockwise. The correct procedure is important for maintaining control over the water pressure during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_131_5468ccb1",
          "question": "The PRV indicator light will illuminate when the valve opens.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'the PRV indicator light will illuminate.' This supports the question statement. Understanding the indicators of the PRV operation is crucial for firefighters to ensure the correct water pressure for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_131_084d0fd1",
          "question": "Position #3 firefighter is responsible for attaching the bell reducer to the 2\u00bd\u201d line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Wait as the position #4 firefighter attaches the bell reducer to the 2\u00bd\u201d line.' This contradicts the question statement, which suggests that the position #3 firefighter performs this task. Knowing the responsibilities of each position is important for effective teamwork and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_131_fec8b0ea",
          "question": "Position #4 firefighter is responsible for calling for water from the driver when the stretch is completed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Call for water from the driver when the stretch is completed.' This supports the question statement. Understanding the roles and responsibilities of each position helps ensure efficient and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_131_017edc98",
          "question": "The position #3 firefighter should allow the hose to flake from their shoulder-load as soon as they reach the end of the stretched 2\u00bd\u201d hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not allow any hose to flake from the #3 firefighter\u2019s shoulder-load until the position #4 firefighter gives the order to \u201cstretch.\u201d' This contradicts the question statement, which suggests that the position #3 firefighter should allow the hose to flake immediately upon reaching the end of the stretched hose. Following the correct procedure is important for maintaining control over the hose and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_127_ed14a586",
          "question": "The driver should increase the engine speed to 800-1000 RPMs before opening the tank-to-pump valve.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Open the tank-to-pump valve, and increase engine speed to 800-1000 RPMs.' This indicates that the tank-to-pump valve should be opened before increasing the engine speed. This sequence is important to ensure proper water flow and pressure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_127_d1704b83",
          "question": "The attack line should not be charged with a pressure of greater than 75 PSI until the hose is full of water.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'NOTE: Do not charge the attack line with a pressure of greater than 75 PSI until the hose is full of water.' This is to avoid damaging the inner lining of the hose, which could compromise its effectiveness in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_127_4bb47f4b",
          "question": "The discharge pressure relief valve (PRV) is set by turning the PRV operating handle clockwise until the valve opens.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle counter-clockwise until the valve opens.' This contradicts the statement in the question. Correctly setting the PRV is crucial for maintaining the desired discharge pressure during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_127_228a0279",
          "question": "The Firefighter should drop the first section of the hose once the second section has been stretched out.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not drop any portion of the first section (shoulder-load) until all of the second section has been stretched out.' This contradicts the statement in the question. Proper handling of the hose is important to ensure efficient water delivery and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_127_21ac9aaf",
          "question": "After calling for water, the Firefighter should bleed the air from the charged hose line and assess the fire stream for an appropriate volume of water flow.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Bleed the air from the charged hose line, assess the fire stream for an appropriate volume of water flow (GPM).' This supports the statement in the question. Bleeding air from the hose line and assessing the fire stream are important steps to ensure effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_170_1325f9dd",
          "question": "The driver must place a hose clamp on the LDH immediately after setting the wheel blocks.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The driver must place a hose clamp on the LDH immediately after setting the wheel blocks.' This is a crucial step in ensuring that the hose is secure and ready for use in firefighting operations. Failing to do so could result in a lack of water supply during a critical moment in the firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_170_89ba84e4",
          "question": "The second engine to arrive will perform a Forward Lay evolution from the location of the tri-gate initially dropped by the first engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The second engine to arrive will basically perform a Reverse Lay evolution from the location of the tri-gate initially dropped by the first engine.' This indicates that the second engine's role is to reinforce and extend the first engine's operations, not to initiate a new Forward Lay.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_170_22027942",
          "question": "The driver should exit the engine immediately after stopping it as directed by the Officer.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Stop the engine as directed by the Officer. Sound a single horn honk so that the position #4 firefighter knows it is safe to exit the engine. Remain in the cab and wait for the position #4 firefighter to return to the engine.' This indicates that the driver should remain in the cab until the position #4 firefighter has safely exited and returned to the engine. This is important for maintaining safety and order during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_170_8a41a299",
          "question": "The hose clamp must be placed a minimum of 20 feet from the tailboard of the engine, and not less than 3 feet from any coupling.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The clamp must be placed a minimum of 20 feet from the tailboard of the engine, and not less than 3 feet from any coupling.' This is important to ensure that the hose is properly secured and that there is enough distance from the engine and any couplings to prevent any potential issues during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_170_9947874c",
          "question": "The Officer should immediately join the #3 and #4 firefighters in the fire attack after giving verbal directions for a 'Blind Alley Lay - Dry'.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remain seated in the engine until the Blind Alley Lay is completed. At the fire scene, indicate to the #3 and #4 firefighters the fire attack to perform.' This indicates that the Officer should remain in the engine until the Blind Alley Lay is completed before joining the #3 and #4 firefighters. This ensures that all procedures are followed correctly and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_150_33f0ee5a",
          "question": "The Monitor Manifold evolution begins with 200 feet of 2\u00bd\u201d hose and 200 feet of 1\u00be\u201d hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Monitor Manifold evolution will begin with 200 feet of 2\u00bd\u201d hose, 200 feet of 1\u00be\u201d hose...'. This supports the statement that the Monitor Manifold evolution begins with these specific lengths and diameters of hose. This is important in firefighting as the correct length and diameter of hose can affect the water supply and pressure, which can impact firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_150_b82926af",
          "question": "The officer's SCBA and appropriate tools are left on the engine during the Monitor Manifold evolution.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remove the Officer\u2019s SCBA and appropriate tools from the engine and place these items on the ground.' This contradicts the statement that these items are left on the engine. The officer's SCBA and tools are critical for personal safety and operational effectiveness during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_150_74f009c1",
          "question": "The monitor and the monitor base are kept in a compartment on top of the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Receive the monitor and the monitor base from the position #3 firefighter if these items are kept in a compartment on top of the engine.' This supports the statement that the monitor and monitor base are kept in a compartment on top of the engine. Knowing where equipment is stored on the engine is crucial for efficient operations at a fire scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_150_676e87f5",
          "question": "The tri-gated wye is positioned between the unloaded hose and the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remove the tri-gated wye, with LDH attached, and position it between the unloaded hose and the engine.' This contradicts the statement that the tri-gated wye is positioned between the unloaded hose and the hydrant. The correct positioning of equipment can affect the efficiency and effectiveness of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_150_9601e29a",
          "question": "The officer directs the driver where to position the engine and gives verbal directions to the crew designating the evolution to be performed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Officer - Direct the driver where to position the engine. Give verbal directions to the crew designating the evolution to be performed...'. This supports the statement that the officer directs the driver and gives verbal directions to the crew. Clear communication and direction from the officer are crucial for effective and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_146_0337273c",
          "question": "The 2\u00bd\u201d Manifold evolution requires removing 200 feet of 2\u00bd\u201d attack line from the engine at the fire location.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The 2\u00bd\u201d Manifold evolution will result in members removing 200 feet of 2\u00bd\u201d attack line, the tri-gate with LDH attached, and appropriate tools from the engine at the fire location.' This supports the statement and shows the importance of understanding the equipment requirements for different firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_146_92c46ef0",
          "question": "The officer is responsible for attaching the 2\u00bd\u201d hose to the tri-gate.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When safe to do so, attach the 2\u00bd\u201d hose to the tri-gate.' However, it does not specify that this task is the responsibility of the officer. This contradicts the statement and emphasizes the need for clear role assignments during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_146_7d2dc4f0",
          "question": "The tri-gate should be footed until the engine is at least 150 feet away.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Foot the tri-gate until the engine is at least 150 feet away.' This supports the statement and highlights the importance of safety measures during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_146_35e6b2cf",
          "question": "The officer is responsible for opening the gate at the call for water.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Officer opens the gate at the call for water.' This supports the statement and shows the officer's role in controlling water flow during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_146_7212d309",
          "question": "The officer's SCBA and appropriate tools should be left on the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Remove the Officer\u2019s SCBA and appropriate tools from the engine and place these items on the ground.' This contradicts the statement and shows the importance of having necessary equipment readily accessible during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_147_6a6326a3",
          "question": "The first section of 2\u00bd\u201d hose from the bulk bed should be placed on the ground and to the fire side of the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Remove the first section of 2\u00bd\u201d hose from the bulk bed. Place the bundle on the ground and to the fire side of the engine.' This indicates the correct positioning of the hose, which is important for efficient firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_147_37ebd0a9",
          "question": "Any firefighter can give the order to 'stretch'.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'allow any hose to flake from the shoulder-load until position #4 gives the order to \u201c stretch .\u201d' This indicates that only the firefighter in position #4 can give the order to stretch, which is crucial for coordinated firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_147_5404afe6",
          "question": "A single member can stretch 200 feet of 2 \u00bd\u201d hose.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Single member stretching 200 feet of 2 \u00bd\u201d hose.' This shows that a single firefighter can perform this task, which is important for understanding individual capabilities in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_147_f4a049fb",
          "question": "The Reverse Pump Hook-up is performed by the firefighter in position #3.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text does not provide any information about who performs the Reverse Pump Hook-up. This question is false because it makes an assumption not supported by the text, highlighting the importance of not making assumptions in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_147_934a449c",
          "question": "The firefighter in position #3 assists other members in removing the appropriate hose and equipment.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Firefighter - Remove the first section of 2\u00bd\u201d hose from the bulk bed... Assist the other members in removing the appropriate hose and equipment as necessary.' This indicates that the firefighter in position #3 has a role in assisting others, which is crucial for teamwork in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_151_27b0d182",
          "question": "The tri-gate should be footed until the engine is at least 200 feet away.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Foot the tri-gate until the engine is at least 150 feet away.' This contradicts the question statement which suggests the distance should be 200 feet. The distance is important to ensure safety and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_151_f7fd187a",
          "question": "The position #4 firefighter may be assigned to remove the tri-gate and its footing if the Officer has command duties to attend to.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The removal of the tri-gate and it\u2019s footing may be assigned to the position #4 firefighter if the Officer has command duties to attend to.' This supports the question statement. Understanding roles and responsibilities is crucial for effective teamwork and safety in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_151_16c440fb",
          "question": "The driver should honk the engine\u2019s horn twice to signal to the members that it is safe to exit the cab.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Honk the engine\u2019s horn once to signal to the members that it is safe to exit the cab.' This contradicts the question statement which suggests the horn should be honked twice. Clear and accurate signals are important for safety and coordination in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_151_2869ed2d",
          "question": "The nozzle section of the apartment bundle should be nearest to the fire.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The nozzle section should be nearest to the fire.' This supports the question statement. Proper positioning of equipment can affect the effectiveness and safety of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_151_8d31df1b",
          "question": "Position #3 Firefighter is responsible for initiating the reverse lay upon receiving direction from the Officer or position #4 firefighter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Prepare to initiate the reverse lay upon receiving direction from the Officer or position #4 firefighter.' This contradicts the question statement which suggests that the position #3 firefighter is responsible for initiating the reverse lay. Understanding roles and responsibilities is crucial for effective teamwork and safety in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_171_1178a77b",
          "question": "The hose clamp should be opened rapidly at all times to prevent water hammer.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The first one to two turns of the clamp will be made in a rapid manner. Then continue to open the clamp with slow turns to prevent water hammer.' This indicates that only the first one to two turns should be rapid, and subsequent turns should be slow to prevent water hammer, which can damage the hose and disrupt water flow.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_171_cbe17483",
          "question": "If a significant kink is discovered while returning to the pump panel, it should be disregarded.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'If a significant kink is discovered while returning to the pump panel, remove it immediately.' This implies that significant kinks can disrupt water flow and should be addressed immediately for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_171_4e434cbf",
          "question": "Upon completion of the primary supply, the driver will act as a member of the Firefighter Stand-by Rescue Team.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Upon completion of the primary supply, the driver will don the SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team.' This shows that the driver has a dual role in firefighting operations, contributing to both water supply and rescue efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_171_1a144539",
          "question": "The LDH should be secured to a substantial object with a body loop when the engine stops at the hydrant location.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text says, 'If possible, secure the LDH to a substantial object (e.g. mail box, fence post) with a body loop.' This indicates that securing the LDH can prevent it from moving or being damaged, which is crucial for maintaining a stable water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_171_917bc9ae",
          "question": "Position #3 Firefighter should exit the engine as soon as it reaches the fire location.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Position #3 Firefighter (1st engine) - Remain on the engine until it reaches the fire location.' This implies that the firefighter in this position should stay on the engine, likely to be ready for immediate action upon arrival at the fire scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_126_3088a1e7",
          "question": "The #3 firefighter should start stretching their hose before the #4 firefighter has stretched theirs completely off their shoulder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Be sure the #3 firefighter does not stretch their hose until the #4 firefighter has stretched theirs completely off their shoulder first.' This implies that the #4 firefighter must stretch their hose first for efficient operation and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_126_8bbdff9e",
          "question": "The 2\u00bd\u201d Blitz Line evolution results in the deployment of a 200 foot 2\u00bd\u201d hose bundle that is already connected to the engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The 2\u00bd\u201d Blitz Line evolution will result in the deployment of a 200 foot 2\u00bd\u201d hose bundle that is already connected to the engine.' This indicates that the Blitz Line evolution is designed for quick deployment and connection to the engine.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_126_7bf152be",
          "question": "The #4 firefighter is responsible for providing forcible entry as required.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Provide forcible entry as required.' This is part of the #4 firefighter's responsibilities, which include stretching the hose line and assisting in its operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_126_349e7d94",
          "question": "The first length of 2 \u00bd\u201d hose is shouldered by the #4 firefighter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Seattle Fire Department Position #3 member shouldering the first length of 2 \u00bd\u201d hose.' This contradicts the statement, indicating that it is the #3 firefighter who shoulders the first length of the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_126_90514ce1",
          "question": "The #4 firefighter should drop some additional hose (1 or 2 flakes) near the tailboard so the desired discharge can be reached.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Once the shoulder-load is in place, drop some additional hose (1 or 2 flakes) near the tailboard so the desired discharge can be reached.' This is part of the #4 firefighter's responsibilities to ensure that the desired discharge can be reached.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_130_e2ca57b5",
          "question": "The nozzle must be removed from the 2 \u00bd\u201d hose and be replaced by the 2 \u00bd\u201d to 1 \u00bd\u201d bell reducer for an extended lay.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For this extended lay, recognize that a nozzle must be removed from the 2 \u00bd\u201d hose and be replaced by the 2 \u00bd\u201d to 1 \u00bd\u201d bell reducer.' This is important for firefighting operations as it ensures the correct pressure and flow of water for the situation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_130_62023c0f",
          "question": "The attack line should be charged with a pressure of greater than 75 PSI before the hose is full of water.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not charge the attack line with a pressure of greater than 75 PSI until the hose is full of water.' This is crucial to prevent damage to the inner lining of the hose, which could affect firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_130_489e1550",
          "question": "The engine speed should be increased to 800-1000 RPMs after opening the tank-to-pump valve.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Open the tank-to-pump valve, and increase engine speed to 800-1000 RPMs.' This is a crucial step in the process of priming the pump and ensuring a full stream of water for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_130_cdeba102",
          "question": "Water should be sent to the firefighting team as soon as the nozzle is replaced by the bell reducer.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If water is sent to the firefighting team before they are ready, a dangerous condition will result.' This highlights the importance of communication and timing in firefighting operations to ensure safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_130_aa66d3ca",
          "question": "The discharge pressure should be increased to the desired setting only after the hose is filled.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the hose is filled, increase the discharge pressure to the desired setting.' This is crucial to ensure the correct pressure for firefighting operations and to prevent damage to the hose.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_167_c35d3d4a",
          "question": "The firefighter should remain seated while the engine is making the forward lay.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Remain seated while the engine is making the forward lay.' This is important for the safety of the firefighter during the movement of the engine. Unexpected movements could cause injury if not properly seated.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_167_25c06ba9",
          "question": "The firefighter should place a part of their body between the LDH and the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Be certain that no part of the body is placed between the LDH and the hydrant. If the hose snags during the forward lay, an injury may occur.' This highlights the importance of safety precautions when handling equipment to prevent injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_167_90dcb6d1",
          "question": "The hose should be disconnected from the tri-gate at the tailboard when the engine comes to a stop at the hydrant location.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Proceed to the tailboard and disconnect the LDH from the tri-gate.' This is a crucial step in the process of setting up the hose for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_167_d14fb595",
          "question": "The firefighter should step on the LDH at the point where the hose crosses itself.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Step on the LDH at the point where the hose crosses itself.' This is a technique used to secure the hose and prevent it from moving unexpectedly, which could lead to safety issues.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_167_91fc705f",
          "question": "The firefighter should bring the female coupling back towards the engine to form a six foot bight even with the barrel of the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Bring the female coupling back towards the engine to form a six foot bight even with the barrel of the hydrant.' This is a specific procedure that ensures the hose is properly positioned and ready for use in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_156_1b782f2a",
          "question": "The LDH should be connected to the 4\u201d rear discharge port of the Seattle Fire Department's engine.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Connecting the LDH to the 4\u201d rear discharge port.' This supports the statement that the LDH should be connected to the 4\u201d rear discharge port. This is a crucial step in firefighting operations as it ensures the correct flow of water from the hydrant to the fire scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_156_5b2e1486",
          "question": "The rear discharge valve should be closed during firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Go to the pump panel and open the rear discharge port.' This contradicts the statement that the rear discharge valve should be closed. Keeping the rear discharge valve open is important for the flow of water during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_156_2e29e0a2",
          "question": "The soft suction hose should be connected to the side intake.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Deploy the soft suction hose and connect to the side intake.' This supports the statement that the soft suction hose should be connected to the side intake. This is a critical step in ensuring that water is properly drawn from the hydrant.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_156_c4a7bdde",
          "question": "The hydrant bag, the hydrant wrenches and the hydrant coupling of the soft suction hose are not necessary when proceeding to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Proceed to the hydrant with the hydrant bag, the hydrant wrenches and the hydrant coupling of the soft suction hose.' This contradicts the statement that these items are not necessary. These tools are essential in connecting the hose to the hydrant and ensuring a secure and efficient water supply for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_156_644705dc",
          "question": "The intake valve should be partially opened during firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Open the intake valve fully.' This contradicts the statement that the intake valve should be partially opened. A fully opened intake valve ensures maximum water flow, which is crucial for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_140_369843cd",
          "question": "If the nearest hydrant is in front of the engine and within 100 feet, you should grab the 15-foot LDH bundle tied with a body loop and the bight of the 50-foot section of LDH next to it.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the nearest hydrant is in front of the engine and within 100 feet, grab the 15 -foot LDH bundle tied with a body loop and the bight of the 50 -foot section of LDH next to it.' This supports the question statement and indicates the initial steps to take when the hydrant is in front of the engine and within 100 feet. This is important for efficient firefighting operations and ensuring a quick water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_140_2642004c",
          "question": "The driver should pull down three 50-foot sections of LDH.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Driver pulls down two 50-foot sections of LDH.' This contradicts the question statement, which suggests three sections should be pulled down. The correct procedure is to pull down two 50-foot sections. This is crucial for maintaining proper hose management during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_140_6f9cfebc",
          "question": "The 15-foot LDH bundle should be left at the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Leave the 15-foot LDH bundle at the hydrant and return to the engine.' This contradicts the question statement, which suggests the LDH bundle should be left at the engine. The correct procedure is to leave the LDH bundle at the hydrant. This is important for ensuring the correct positioning of equipment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_140_2e4aa5e2",
          "question": "The female end of the unused hose should be placed under the tailboard to minimize the tripping hazard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Break the coupling on the ground and place the female end of the unused hose under the tailboard to minimize the tripping hazard.' This supports the question statement and indicates the safety measures to take to prevent tripping hazards. This is crucial for firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_140_d3bf3f56",
          "question": "The driver should proceed to the hydrant holding a bight of each 50-foot section in each hand.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Proceed to the hydrant holding a bight of each 50 -foot section in each hand.' This supports the question statement and indicates the correct procedure for the driver when moving towards the hydrant. This is important for efficient firefighting operations and ensuring a quick water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_117_41990d32",
          "question": "The hydrant to engine connection should always be within 100 feet.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Every effort must be made to have the hydrant to engine connection to be within 100 feet.' This suggests that maintaining this distance is crucial for efficient firefighting operations, as it ensures adequate water supply to the engine for firefighting purposes.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_117_4c9f3e90",
          "question": "The final positioning of the engine company should impede the incoming ladder companies from the fire building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, 'The final positioning of the engine company must not impede the incoming ladder companies from the fire building.' This indicates that the engine company's positioning should facilitate, not hinder, the ladder companies' access to the fire building, which is critical for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_117_fe84423c",
          "question": "Orders given during firefighting operations can be vague and open-ended.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'Orders must be given clearly and concisely so that all members are aware of the evolution to be performed.' This contradicts the statement, emphasizing the importance of clear and concise communication in firefighting operations for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_117_a738775e",
          "question": "The length of the attack line must be specified only if it is standard for a particular evolution.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The length of the attack line must be specified if longer than what is standard for a particular evolution.' This contradicts the statement, highlighting the need to specify the length of the attack line when it exceeds the standard length, to ensure proper equipment setup and operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_117_466d7883",
          "question": "The engine Officer must consider the placement of the ladder company for optimum use of the aerial ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, 'The engine Officer must also allow for the placement of the ladder company for optimum use of the aerial ladder.' This supports the statement and indicates the importance of strategic placement of resources in firefighting operations for effective use of equipment and personnel.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_160_efce3a33",
          "question": "The LDH supply line is first connected to the hydrant before stretching it from the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Begin by stretching the LDH supply line from the engine to the hydrant.' This contradicts the statement that the LDH supply line is first connected to the hydrant. Understanding the correct order of operations is crucial in firefighting to ensure efficient and effective water supply setup.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_160_3aa1ba0a",
          "question": "The soft suction is extended using a soft suction adapter marked with a red dot.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'connect it directly to the soft suction after opening the keystone, using a soft suction adapter (\"red dot.\")' This supports the statement that a soft suction adapter marked with a red dot is used to extend the soft suction. The correct identification and use of equipment is vital in firefighting operations for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_160_2b7580b4",
          "question": "The hydrant adapter is used to connect the engine to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Using the hydrant adapter, connect the LDH supply line to the engine port on the hydrant.' This contradicts the statement that the hydrant adapter is used to connect the engine to the hydrant. It is important to understand the correct use of adapters in firefighting operations to ensure proper water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_160_aac04bc4",
          "question": "The hydrant is opened before connecting the LDH supply line to the engine port on the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'connect the LDH supply line to the engine port on the hydrant and open the hydrant.' This contradicts the statement that the hydrant is opened before connecting the LDH supply line. Understanding the correct sequence of operations is vital in firefighting to prevent water hammer and other potential issues.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_160_87421c0b",
          "question": "The LDH is broken from the bed and connected directly to the soft suction.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Break the LDH from the bed and connect it directly to the soft suction.' This supports the statement that the LDH is broken from the bed and connected directly to the soft suction. Understanding how to properly set up and use equipment is crucial in firefighting operations for safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_137_77cd63a0",
          "question": "The LDH should be run out at a sharp angle from the hose bed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Turn and run out the hose at a slight angle until a coupling...drops to the ground.' This contradicts the statement that the LDH should be run out at a sharp angle. Running the hose at a slight angle can help prevent kinks and facilitate smoother operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_137_344feda8",
          "question": "The unused end of the LDH should be placed under the tailboard to minimize the tripping hazard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the female end of the unused hose under the tailboard to minimize the tripping hazard.' This supports the statement and highlights the importance of maintaining a safe working environment to prevent accidents during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_137_09bdfa48",
          "question": "The male end of the LDH should be attached to the desired pump intake using a 4\u201d double female.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Attach the male end of the LDH to the desired pump intake using a 4\u201d double female.' This supports the statement and emphasizes the correct procedure for connecting the LDH to the pump intake, which is crucial for effective water supply during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_137_e4a3032b",
          "question": "If the soft suction hose is connected to the intake, it should remain in place when making the connection with the LDH.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the soft suction hose is connected to the intake, remove it to allow for this connection to be made.' This contradicts the statement that the soft suction hose should remain in place. Removing the soft suction hose when connecting the LDH ensures a secure and effective connection for water supply.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_137_755bf704",
          "question": "The connection of LDH that will reach the side intake should not be broken.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Return to that coupling, break the connection, and place the female end of the unused hose under the tailboard.' This contradicts the statement that the connection of LDH should not be broken. Breaking the connection at the right place is important to ensure the correct length of hose is used, which can impact the efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_121_f493824c",
          "question": "The 1\u00be\u201d Pre-connect evolution deploys a 200 foot 1\u00be\u201d hose bundle that is already connected to the engine to use tank water to initiate the fire attack as quickly as possible.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The 1\u00be\u201d Pre-connect evolution will result in the deployment of a 200 foot 1\u00be\u201d hose bundle that is already connected to the engine. The intention of this lay is to use tank water to initiate the fire attack as quickly as possible.' This supports the statement as it directly describes the purpose and process of the 1\u00be\u201d Pre-connect evolution. This is crucial for firefighting operations as it allows for a quick initiation of the fire attack.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_121_9f48d321",
          "question": "The Pre-connect Officer is responsible for positioning the engine.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Driver - Position the engine as directed by the company Officer.' This contradicts the statement as it is the Driver, not the Pre-connect Officer, who is responsible for positioning the engine. This is an important distinction in firefighting operations as it clarifies roles and responsibilities.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_121_f0bf206a",
          "question": "The wheel blocks should be placed after the engine is put into pump.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Perform the in-cab procedures to place the engine into pump. Exit the cab and place the wheel blocks.' This supports the statement as it outlines the sequence of actions. This is important for firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_121_f1e4dbbb",
          "question": "The discharge pressure should be increased to between 100-125 PSI.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Increase the throttle to bring the discharge pressure between 50-75 PSI.' This contradicts the statement as it specifies a lower range for the discharge pressure. Understanding the correct pressure range is crucial for effective firefighting and equipment operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_121_30bab8e4",
          "question": "The hose is filled by manipulating the throttle as needed while maintaining 50-75 PSI.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Maintain 50-75 PSI while the hose is being filled by manipulating the throttle as needed.' This supports the statement as it describes the process of filling the hose. This is an important operational consideration for firefighters to ensure effective water delivery during fire suppression.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_120_3149c000",
          "question": "The position #3 firefighter should exit the crew cab with SCBA in the stand-by position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'PHOTO 4.4 Seattle Fire Department Positions #3 and #4 will exit the crew cab with SCBA in the stand-by position.' This statement contradicts the question because it implies that both position #3 and #4 firefighters, not just position #3, should exit the crew cab with SCBA in the stand-by position. This is important for firefighter safety and readiness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_120_1455ad8b",
          "question": "The position #3 firefighter maintains control of the nozzle until the fire is declared 'tapped.'",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'the position #3 firefighter will maintain control of the nozzle... until the fire is declared \u201ctapped.\u201d' This supports the question statement. Maintaining control of the nozzle is crucial for firefighter safety as it provides protection to all other members operating on or above the fire floor.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_120_3490efcb",
          "question": "If the company Officer is not present inside the fire building, the position #4 firefighter will serve as the 'team A' leader.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'If the company Officer is not present inside the fire building, the position #4 firefighter will serve as the \u201cteam B\u201d leader.' This contradicts the question as it clearly states that the position #4 firefighter will serve as the 'team B' leader, not 'team A'. This is important for understanding roles and responsibilities during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_120_fbc6180d",
          "question": "Establishing a ventilation opening as soon as possible is not a priority.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Establishing a ventilation opening as soon as possible is a priority.' This contradicts the question statement. Ventilation is a crucial part of firefighting operations as it helps to reduce heat and improve visibility, aiding in the search and rescue process.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_120_51b59ee0",
          "question": "All members will maintain contact with all others assigned to the team via sight, sound (voice), or touch while operating in a hazardous atmosphere.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'All members will maintain contact with all others assigned to the team via sight, sound (voice), or touch while operating in a hazardous atmosphere.' This supports the question statement. Maintaining contact with team members is crucial for safety and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_136_f86cd813",
          "question": "The hydrant bag carried by each Engine Company contains a 2 \u00bd\u201d double female.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'As a minimum, the hydrant bag will contain the following: \u2022 Hydrant ada pter (1) \u2022 2 \u00bd\u201d double female (1)'. This confirms that the hydrant bag does indeed contain a 2 \u00bd\u201d double female. This is important for firefighters to know as it affects their ability to make connections to a hydrant.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_136_0f4c2913",
          "question": "If the nearest hydrant is to the rear of the engine, you should proceed approximately 6 feet past the hydrant to allow enough hose for an easy connection.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the nearest hydrant is to the rear of the engine, shoulder -load the 15-foot section tied with a body loop and overhaul the hose directly t o the hydrant. Proceed approximately 6 feet past the hydrant to allow enough hose for an easy connection.' This confirms that firefighters should proceed approximately 6 feet past the hydrant to allow enough hose for an easy connection. This is a critical operational consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_136_2b2aa8ec",
          "question": "The hydrant bag carried by each Engine Company does not contain a hydrant gate.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'As a minimum, the hydrant bag will contain the following: \u2022 Hydrant ada pter (1) \u2022 2 \u00bd\u201d double female (1) \u2022 Body loop (1) \u2022 OCD wrench (1) \u2022 Spanner wrench (2) \u2022 Hydrant gate (1)'. This contradicts the statement that the hydrant bag does not contain a hydrant gate. Knowing the contents of the hydrant bag is crucial for firefighters as it affects their ability to make connections to a hydrant.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_136_a29ebcf5",
          "question": "The 2\u00bd\u201d to 4\u201d Increaser is typically kept attached to the hydrant ada pter.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '2\u00bd\u201d to 4\u201d Increaser (1) \u2013 (typically kept attached to the hydrant gate)'. This contradicts the statement that the 2\u00bd\u201d to 4\u201d Increaser is typically kept attached to the hydrant ada pter. It is actually typically kept attached to the hydrant gate. This is an important detail for firefighters to remember as it affects their ability to make connections to a hydrant.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_136_b113f5e0",
          "question": "When pulling hose straight back, you should stop pulling once you have enough hose to reach the side intake.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Pulling until enoug h hose to reach the side intake is removed.' This confirms that when pulling hose straight back, you should stop pulling once you have enough hose to reach the side intake. This is a key operational consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_161_03cd4021",
          "question": "In a forward lay, the engine always stops at the water source to drop off a supply line before advancing to the fire location.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Forward Lay refers to the engine stopping at the water source to drop off a supply line and then advancing to the location of the fire.' This indicates that stopping at the water source to drop off a supply line is a fundamental part of a forward lay, which is a key firefighting tactic.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_161_7e6fa02f",
          "question": "In a 'wet' forward lay, all members secure the hose to the hydrant and then get back onto the engine to proceed to the fire location.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When performed \"wet,\" the hydrant person stays at the hydran t, makes up the hydrant connection, charges the line, and then proceeds, on foot, to the fire.' This contradicts the statement, as in a 'wet' forward lay, the hydrant person stays at the hydrant, not all members. This is important for firefighters to understand as it affects their roles and responsibilities during a 'wet' forward lay.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_161_704a86e0",
          "question": "A forward lay should not be performed 'wet' if the engine will be more than 100 feet of the hydrant due to friction loss and/or elevation gain.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A forward lay is not advised to p roceed \u201cwet\u201d if the engine will be more than 100 feet of the hydrant. Fricti on loss and/or elevation gain will significantly reduce the incoming pump pressure at the pumping engine.' This supports the statement and highlights the importance of understanding the impact of distance and elevation on firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_161_97799ef2",
          "question": "In a 'dry' forward lay with LDH, the position #4 firefighter stays at the hydrant to make connections while the engine performs the forward lay.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The order \u201c Forward Lay with LDH \u2013Dry\u201d will indicate that the position #4 firefighter will not remain at the hydrant to make connections while the engine performs the forward lay.' This contradicts the statement, indicating that in a 'dry' forward lay with LDH, the position #4 firefighter does not stay at the hydrant. This is a crucial operational detail for firefighters to understand.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_161_a27d63c3",
          "question": "In a forward lay, the desired location to stop the engine is with the tailboard 10 feet past the hydrant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The desired loc ation is to stop with the tailboard 10 feet past the hydrant.' This supports the statement and emphasizes the importance of proper positioning of the engine in a forward lay for efficient firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_116_bf2e0bfe",
          "question": "The firefighter assigned to the nozzle position can enter the immediate fire area without water if it's a small building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The firefighter assigned to the nozzle position should never enter the immediate fire area without water.' This means that regardless of the size of the building, a firefighter should not enter the fire area without water due to safety concerns.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_116_26226047",
          "question": "In large buildings, the line should be charged in the stairwell on the floor below the fire.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'In large buildings, the line should be charged in the stairwell on the floor below the fire.' This is to ensure that the line is charged in a safe, smoke-free location that is protected from the fire area by fire doors.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_116_796b72cc",
          "question": "Hose lines can be operated in opposition to each other under certain circumstances.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'No matter which evolution the engine Officer chooses to perform, hose lines will not be operated in opposition to each other.' This is to prevent the risk of injury to firefighters and to ensure effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_116_e5f99f65",
          "question": "The engine company Officer's decision-making skills regarding incident strategy and tactics have a significant impact on the outcome of a fire operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When arriving first, the engine company Officer may well have more influence on the outcome of a fire operation than any other member on scene. Sound decision-making skills regarding incident strategy and tactics are extremely important.' This highlights the critical role of the Officer's decision-making skills in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_116_c4eef41d",
          "question": "The engine should be positioned before the fire location has been determined.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Officer will decide where to position the engine once the fire location has been determined.' This means that the engine's position is determined based on the fire location and other factors, ensuring effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_141_d254409e",
          "question": "The male coupling is connected to the desired pump intake using a 2\u201d double female.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The male coupling is connected to the desired pump intake using a 4\u201d double female.' This indicates that a 4\u201d double female is used, not a 2\u201d. This is crucial for firefighters to know as using the incorrect size could affect the efficiency and safety of the firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_141_74e6f0ad",
          "question": "If the soft suction is connected to the intake valve, it should be removed to allow for the connection to be made.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the soft suction is connected to the intake valve, remove it to allow for this connection to be made.' This shows that the soft suction must be removed to make way for the connection. This is important for firefighters to understand as it impacts the setup of the equipment and ultimately the effectiveness of the firefighting operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_141_d1c431e1",
          "question": "The intake valve should be opened immediately after connecting the LDH to the main side intake.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not open the intake valve at this time.' This contradicts the statement that the intake valve should be opened immediately after connecting the LDH. This is a crucial point for firefighters to remember as prematurely opening the valve could disrupt the operation and potentially pose safety risks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_141_d15a6c28",
          "question": "The hydrant bag and the hydrant wrenches are not necessary when returning to the hydrant.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Procure the hydrant bag and the hydrant wrenches and return to hydrant.' This contradicts the statement that the hydrant bag and wrenches are not necessary. This is important for firefighters to understand as these tools are essential for operating the hydrant, which is a key part of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_141_985a9ddd",
          "question": "The LDH should be connected to the main side intake.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Connect the LDH to the main side intake.' This supports the statement that the LDH should be connected to the main side intake. This is a key operational detail for firefighters as it ensures the correct setup of the equipment, which is crucial for effective firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_157_570bcad8",
          "question": "The hydrant gate should be in the open position when attaching the soft suction hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Attach the soft suction hose and a hydrant gate. Ensure that the gate is in the closed position.' This contradicts the statement in the question. It is important to ensure the gate is closed to prevent uncontrolled water flow during the setup process.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_157_811e3a4d",
          "question": "Kinks in the hose should be addressed immediately, regardless of the water flow.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'While returning to the panel remove any significant kinks immediately. If kinks are present but it remains evident that sufficient water is entering the intake and being discharged to the tri-gate, disregard them at this time.' This contradicts the statement in the question. It implies that not all kinks need immediate attention, especially if they do not significantly impact water flow. This allows firefighters to prioritize other tasks during a fire operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_157_bb7d50d9",
          "question": "To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle counter-clockwise until the valve opens.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'To set your discharge pressure relief valve (PRV), you must turn the PRV operating handle counter-clockwise until the valve opens.' This supports the statement in the question. Understanding how to properly set the PRV is crucial for maintaining safe and effective water pressure during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_157_e8f6fd1c",
          "question": "Traffic cones should be positioned to protect the engine and hose lines from approaching vehicles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles.' This supports the statement in the question. Positioning traffic cones is a safety measure to protect firefighters, their equipment, and their operations from potential disruptions or damage from other vehicles.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_157_d652f547",
          "question": "Once a second water supply has been established, there is no need to monitor the pump panel and the radio.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once a second supply has been established, ensure remaining equipment and hose loads are ready for use. Monitor the pump panel and the radio for further instructions.' This contradicts the statement in the question. Continuous monitoring of the pump panel and radio is necessary to stay updated on the situation and receive further instructions, ensuring effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_115_87e253e1",
          "question": "What is the key factor when deciding between life-saving operations and firefighting upon arrival?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text states that judgment is the key factor when confronted with the situation of choosing between life-saving operations and firefighting when sufficient firefighters are not available to do both.",
          "options": {
            "A": "The type of construction",
            "B": "The severity of the fire",
            "C": "The type of occupancy",
            "D": "Judgment"
          }
        },
        {
          "id": "sfd_basic_skills_115_b1e984fb",
          "question": "What factors should be considered when estimating the length of the attack line?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text mentions all of these factors as important when estimating the length of the attack line.",
          "options": {
            "A": "The distance from the engine to the entrance door",
            "B": "The distance from the entrance door to the stairway",
            "C": "The amount of hose required to advance up the stairs",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_115_073402e3",
          "question": "When should immediate rescue attempts by the first arriving engine company without simultaneously stretching and positioning a hose line be attempted?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that such rescue attempts should only be made in extreme situations.",
          "options": {
            "A": "In all situations",
            "B": "Only in extreme situations",
            "C": "When there are sufficient firefighters",
            "D": "When the fire is not severe"
          }
        },
        {
          "id": "sfd_basic_skills_115_356366be",
          "question": "What is the minimum length of hose that should be allocated to the fire floor?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that a minimum of one length of hose should be allocated to the fire floor.",
          "options": {
            "A": "One length",
            "B": "Two lengths",
            "C": "Three lengths",
            "D": "Four lengths"
          }
        },
        {
          "id": "sfd_basic_skills_115_7a3acb47",
          "question": "What is the best life-saving measure when the fire, if allowed to spread, would trap occupants?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that the best life-saving measure in such a situation may be a prompt attack on the fire.",
          "options": {
            "A": "Immediate rescue attempts",
            "B": "A prompt attack on the fire",
            "C": "Waiting for more firefighters",
            "D": "Evacuating the building"
          }
        },
        {
          "id": "sfd_basic_skills_142_fe141e90",
          "question": "What tool is used to remove the 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Corey wrench is used to remove the 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant.",
          "options": {
            "A": "Hydrant adapter",
            "B": "Galvin wrench",
            "C": "Corey wrench",
            "D": "LDH"
          }
        },
        {
          "id": "sfd_basic_skills_142_7e59b79e",
          "question": "What is the purpose of the hydrant adapter?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hydrant adapter is used to connect LDH to the hydrant.",
          "options": {
            "A": "To remove the port cap",
            "B": "To connect LDH to the hydrant",
            "C": "To open the hydrant",
            "D": "To close the hydrant gate"
          }
        },
        {
          "id": "sfd_basic_skills_142_590d8d7a",
          "question": "What is the correct position of the hydrant gate when attaching it to the 2\u00bd\u201d port?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hydrant gate should be in the closed position when attaching it to the 2\u00bd\u201d port.",
          "options": {
            "A": "Open",
            "B": "Half-open",
            "C": "Closed",
            "D": "Half-closed"
          }
        },
        {
          "id": "sfd_basic_skills_142_6f54e5df",
          "question": "What tool is used to fully open the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Galvin wrench is used to fully open the hydrant.",
          "options": {
            "A": "Corey wrench",
            "B": "Hydrant adapter",
            "C": "LDH",
            "D": "Galvin wrench"
          }
        },
        {
          "id": "sfd_basic_skills_142_b0c847be",
          "question": "What is the first step in connecting LDH to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in connecting LDH to the hydrant is to remove the 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant with a corey wrench.",
          "options": {
            "A": "Attach the hydrant gate to the 2\u00bd\u201d port",
            "B": "Open the hydrant fully using the Galvin wrench",
            "C": "Remove the 4\u201d engine port cap and a 2\u00bd\u201d port cap of the hydrant with a corey wrench",
            "D": "Attach the hydrant adapter to the engine port"
          }
        },
        {
          "id": "sfd_basic_skills_154_f05b5c75",
          "question": "Who is responsible for ensuring that all required hose and equipment has been removed from the engine if the Officer is unable to due to incident command responsibilities?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that if the Officer is unable to foot the tri-gate or LDH because of incident command responsibilities, the position #4 firefighter will have sole responsibility of ensuring that all required hose and equipment has been removed from the engine.",
          "options": {
            "A": "Position #3 Firefighter",
            "B": "The Driver",
            "C": "Position #4 Firefighter",
            "D": "The Hydrant Operator"
          }
        },
        {
          "id": "sfd_basic_skills_154_753a6396",
          "question": "What should the signal to the driver to proceed to the hydrant include?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text specifies that the signal to the driver to proceed to the hydrant should be both audible and visual, by pointing forward while shouting 'Go ahead.'",
          "options": {
            "A": "A visual signal only",
            "B": "An audible signal only",
            "C": "Both an audible and visual signal",
            "D": "A written signal"
          }
        },
        {
          "id": "sfd_basic_skills_154_7b3eaa69",
          "question": "What is the role of the position #4 firefighter after ensuring all required hose and equipment has been removed from the engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After ensuring that all required hose and equipment has been removed from the engine, the position #4 firefighter is responsible for directing the driver to proceed to the hydrant without instructions from the Officer.",
          "options": {
            "A": "To direct the driver to proceed to the hydrant without instructions from the Officer",
            "B": "To foot the tri-gate",
            "C": "To secure the monitor for safe operation",
            "D": "To select the proper tip size"
          }
        },
        {
          "id": "sfd_basic_skills_154_55aa3da3",
          "question": "Who assists the position #3 firefighter in securing the monitor for safe operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that once the position #3 firefighter has completely positioned the 2\u00bd\u201d hose, the position #4 firefighter assists in securing the monitor for safe operation.",
          "options": {
            "A": "The Officer",
            "B": "The Driver",
            "C": "Position #4 Firefighter",
            "D": "The Hydrant Operator"
          }
        },
        {
          "id": "sfd_basic_skills_154_6075e06d",
          "question": "Who directs the operation of the monitor if the Officer is not present?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the position #4 firefighter directs the operation of the monitor if the Officer is not present.",
          "options": {
            "A": "Position #3 Firefighter",
            "B": "The Driver",
            "C": "Position #4 Firefighter",
            "D": "The Hydrant Operator"
          }
        },
        {
          "id": "sfd_basic_skills_139_efb2fddf",
          "question": "Why is it important to stand behind the hydrant when opening it?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Standing behind the hydrant when opening it can protect the firefighter from potential injury caused by sudden water pressure.",
          "options": {
            "A": "To avoid getting wet",
            "B": "To avoid being seen by the public",
            "C": "To avoid potential injury from sudden water pressure",
            "D": "To have a better view of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_139_19b66b34",
          "question": "What is the role of the driver after completion of the primary supply?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon completion of the primary supply, the driver will don their SCBA in a stand-by position and act as a member of the Firefighter Stand-by Rescue Team until the Rapid Intervention Team is assigned.",
          "options": {
            "A": "To act as a member of the Rapid Intervention Team",
            "B": "To act as a member of the Firefighter Stand-by Rescue Team",
            "C": "To immediately start fighting the fire",
            "D": "To leave the scene"
          }
        },
        {
          "id": "sfd_basic_skills_139_53df6af7",
          "question": "Why is it necessary to position traffic cones around the scene?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Positioning traffic cones around the scene is important to protect personnel, the engine, and hose lines from approaching vehicles.",
          "options": {
            "A": "To mark the area for the public",
            "B": "To protect personnel, the engine, and hose lines from approaching vehicles",
            "C": "To indicate where the fire is",
            "D": "To create a path for the fire to follow"
          }
        },
        {
          "id": "sfd_basic_skills_139_a0f30277",
          "question": "What should be done once a second water supply has been established?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once a second water supply has been established, any water already used from the engine\u2019s booster tank should be refilled.",
          "options": {
            "A": "Start fighting the fire",
            "B": "Refill any water already used from the engine\u2019s booster tank",
            "C": "Close the tank-to-pump valve",
            "D": "Leave the scene"
          }
        },
        {
          "id": "sfd_basic_skills_139_c677e728",
          "question": "What should be done if kinks are present but it appears that sufficient water is entering the intake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If kinks are present but it appears that sufficient water is entering the intake, they can be disregarded at this time. Such kinks will be addressed at a later point.",
          "options": {
            "A": "Immediately remove all kinks",
            "B": "Disregard them at this time",
            "C": "Close the tank-to-pump valve",
            "D": "Call for additional help"
          }
        },
        {
          "id": "sfd_basic_skills_119_e42a4ae0",
          "question": "What is the primary responsibility of the position #3 firefighter during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The position #3 firefighter is primarily responsible for acting as the nozzle person, as mentioned in the text.",
          "options": {
            "A": "To act as the backup person on the hose line",
            "B": "To bring appropriate tools to the fire building",
            "C": "To act as the nozzle person",
            "D": "To position traffic cones"
          }
        },
        {
          "id": "sfd_basic_skills_119_8a4cb797",
          "question": "What is the significance of positioning traffic cones during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that traffic cones are positioned to protect personnel, the engine, and hose lines from approaching vehicles.",
          "options": {
            "A": "To mark the boundary of the fire",
            "B": "To protect personnel, the engine, and hose lines from approaching vehicles",
            "C": "To guide the direction of the fire",
            "D": "To signal the end of firefighting operations"
          }
        },
        {
          "id": "sfd_basic_skills_119_7b3755e8",
          "question": "What is the role of the position #4 firefighter after forcible entry has been accomplished?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After forcible entry has been accomplished, the position #4 firefighter assists the firefighter assigned to the nozzle in advancing the line to the fire.",
          "options": {
            "A": "To refill the engine\u2019s booster tank",
            "B": "To assist the firefighter assigned to the nozzle in advancing the line to the fire",
            "C": "To position traffic cones",
            "D": "To act as the nozzle person"
          }
        },
        {
          "id": "sfd_basic_skills_119_d9ee493e",
          "question": "What is the standard tool assignment for the position #4 firefighter?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that the position #4 firefighter's tool assignment will most often be a Halligan married to a HD Flathead axe, referred to as 'the irons.'",
          "options": {
            "A": "A Halligan married to a HD Flathead axe",
            "B": "A water hose",
            "C": "A fire extinguisher",
            "D": "Traffic cones"
          }
        },
        {
          "id": "sfd_basic_skills_119_940e189a",
          "question": "What should all members do while advancing into the fire building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "While advancing, all members must watch carefully for changing conditions and for any victims as they advance into the fire building.",
          "options": {
            "A": "Refill the engine\u2019s booster tank",
            "B": "Watch carefully for changing conditions and for any victims",
            "C": "Position traffic cones",
            "D": "Act as the nozzle person"
          }
        },
        {
          "id": "sfd_basic_skills_158_04ca0c5a",
          "question": "What is the role of the hydrant member in a two-member pump and hydrant operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The hydrant member is responsible for removing the hydrant wrenches and making the soft suction connection to the hydrant, assisting the driver if necessary, and then reporting to the Officer for further assignment.",
          "options": {
            "A": "Perform the necessary pump panel procedures",
            "B": "Remove the hydrant wrenches and make the soft suction connection to the hydrant",
            "C": "Report to the Officer for further assignment",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_158_d3628b57",
          "question": "What is the first step in obtaining a second supply for a reverse pump hook up?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first step in obtaining a second supply for a reverse pump hook up is to move to the rear of the engine and remove the female coupling of the LDH from under the tailboard.",
          "options": {
            "A": "Move to the rear of the engine and remove the female coupling of the LDH from under the tailboard",
            "B": "Break the LDH coupling, and place the female end under the tailboard",
            "C": "Connect the male end of the LDH to the unused side pump intake using a 4\u201d double female",
            "D": "Open the gate fully"
          }
        },
        {
          "id": "sfd_basic_skills_158_24c87f72",
          "question": "What should you NOT do before the hydrant connection is made?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "You should not open the intake valve until the hydrant connection is made.",
          "options": {
            "A": "Open the intake valve",
            "B": "Break the LDH coupling",
            "C": "Attach the female end of the LDH to the hydrant gate",
            "D": "Remove all kinks in the hose"
          }
        },
        {
          "id": "sfd_basic_skills_158_6f37a006",
          "question": "What is the final step in setting up a second supply for a reverse pump hook up?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The final step in setting up a second supply for a reverse pump hook up is to open the intake valve fully.",
          "options": {
            "A": "Attach the female end of the LDH to the hydrant gate",
            "B": "Open the intake valve fully",
            "C": "Move back to the pump panel, removing all kinks in the hose as you proceed",
            "D": "Connect the male end of the LDH to the unused side pump intake using a 4\u201d double female"
          }
        },
        {
          "id": "sfd_basic_skills_158_d20f1272",
          "question": "Why is it important to place the female end of the LDH under the tailboard?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Placing the female end of the LDH under the tailboard minimizes the tripping hazard.",
          "options": {
            "A": "To ensure the LDH is fully extended",
            "B": "To minimize the tripping hazard",
            "C": "To make it easier to connect to the hydrant",
            "D": "To prevent water from leaking out"
          }
        },
        {
          "id": "sfd_basic_skills_174_2a71096c",
          "question": "What should be done when hydrants are poorly located?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that firefighters must adapt their procedures to reach poorly located hydrants.",
          "options": {
            "A": "Ignore the hydrant and find another one",
            "B": "Report the issue and wait for it to be fixed",
            "C": "Adapt procedures to reach the hydrant",
            "D": "Use a longer hose"
          }
        },
        {
          "id": "sfd_basic_skills_174_0027654e",
          "question": "What is the purpose of overhauling the female end of the large diameter hose, hydrant wrenches and hydrant bag to the hydrant before the lay is made?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Overhauling these items to the hydrant before the lay is made assists the directed company or member in making connections and charging the line.",
          "options": {
            "A": "To make the hose lighter",
            "B": "To assist the directed company or member in making connections and charging the line",
            "C": "To make the hose longer",
            "D": "To prevent the hose from tangling"
          }
        },
        {
          "id": "sfd_basic_skills_174_3a54c666",
          "question": "What should be done if the utility strap cannot be slipped over the top of the anchoring object?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that if the utility strap cannot be slipped over the top of the anchoring object, the free end of the utility strap should be tied to the object using a round turn and two half hitches.",
          "options": {
            "A": "Find another object to anchor the hose",
            "B": "Tie the free end of the utility strap to the object using a round turn and two half hitches",
            "C": "Use a longer utility strap",
            "D": "Ignore the utility strap and proceed with the lay"
          }
        },
        {
          "id": "sfd_basic_skills_174_8e1c2017",
          "question": "What should be done if the equipment and hose cannot be overhauled quickly to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that if the equipment and hose cannot be overhauled quickly to the hydrant, the lay should not proceed until it is assured that sufficient hose has been provided to reach the hydrant from the street.",
          "options": {
            "A": "Proceed with the lay",
            "B": "Find another hydrant",
            "C": "Do not proceed with the lay until it is assured that sufficient hose has been provided to reach the hydrant from the street",
            "D": "Use a longer hose"
          }
        },
        {
          "id": "sfd_basic_skills_174_bc349f80",
          "question": "What should be done with the hydrant wrenches and hydrant bag if additional hose has been removed?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that the hydrant wrenches and hydrant bag should be left with the additional hose that was removed.",
          "options": {
            "A": "They should be left with the additional hose",
            "B": "They should be taken back to the engine",
            "C": "They should be attached to the end of the hose",
            "D": "They should be given to the directed company or member"
          }
        },
        {
          "id": "sfd_basic_skills_123_976149f2",
          "question": "What is the role of Position #3 firefighter during a fire operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The role of Position #3 firefighter is to shoulder-load the 1\u00be\u201d preconnected hose load and stretch the line to the location designated by the Officer.",
          "options": {
            "A": "Procure the irons and meet the position #3 firefighter at the nozzle.",
            "B": "Provide forcible entry as required.",
            "C": "Shoulder-load the 1\u00be\u201d preconnected hose load and stretch the line to the location designated by the Officer.",
            "D": "Assist in advancing and operating the hose line."
          }
        },
        {
          "id": "sfd_basic_skills_123_891166cc",
          "question": "What is the role of Position #4 firefighter during a fire operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The role of Position #4 firefighter is to procure the irons and meet the position #3 firefighter at the nozzle.",
          "options": {
            "A": "Shoulder-load the 1\u00be\u201d preconnected hose load and stretch the line to the location designated by the Officer.",
            "B": "Procure the irons and meet the position #3 firefighter at the nozzle.",
            "C": "Assess the fire stream for an appropriate volume of water flow (GPM).",
            "D": "Bleed the air from the charged hose line."
          }
        },
        {
          "id": "sfd_basic_skills_123_2c133cbb",
          "question": "What is the importance of bleeding the air from the charged hose line?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Bleeding the air from the charged hose line is important to prevent air bubbles from disrupting the water stream.",
          "options": {
            "A": "To increase the water pressure.",
            "B": "To reduce the weight of the hose.",
            "C": "To prevent air bubbles from disrupting the water stream.",
            "D": "To make the hose more flexible."
          }
        },
        {
          "id": "sfd_basic_skills_123_1161f072",
          "question": "What should a firefighter do after shoulder-loading the 1\u00be\u201d preconnected hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After shoulder-loading the 1\u00be\u201d preconnected hose, the firefighter should stretch the line to the location designated by the Officer.",
          "options": {
            "A": "Immediately start the fire attack.",
            "B": "Stretch the line to the location designated by the Officer.",
            "C": "Procure the irons and meet the position #3 firefighter at the nozzle.",
            "D": "Assist in advancing and operating the hose line."
          }
        },
        {
          "id": "sfd_basic_skills_123_2f21d380",
          "question": "What is the purpose of checking the fire stream for the appropriate pattern?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Checking the fire stream for the appropriate pattern is done to ensure an effective and efficient fire attack.",
          "options": {
            "A": "To ensure the hose is not damaged.",
            "B": "To ensure the water is reaching the fire.",
            "C": "To ensure the water pressure is sufficient.",
            "D": "To ensure an effective and efficient fire attack."
          }
        },
        {
          "id": "sfd_basic_skills_135_4f8750de",
          "question": "Where should the coupling be placed while overhauling hose to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The coupling should be placed at the small of the back while overhauling hose to the hydrant. This is to prevent injury if the hose snags on an object.",
          "options": {
            "A": "In front of the body",
            "B": "At the small of the back",
            "C": "Through a loop in the hose",
            "D": "On the right shoulder"
          }
        },
        {
          "id": "sfd_basic_skills_135_033145d1",
          "question": "What should you avoid doing with your arm or shoulder while overhauling hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "You should never place your arm or shoulder through a loop in the hose while overhauling hose. If the hose snags on an object, you may become injured.",
          "options": {
            "A": "Placing it through a loop in the hose",
            "B": "Holding the hose with both hands",
            "C": "Leaning forward",
            "D": "Running towards the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_135_d90cec55",
          "question": "What is the correct method for stretching supply hose a long distance?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct method for stretching supply hose a long distance is to place the bight over the right shoulder, hold it with both hands, place the coupling at the small of the back, and run towards the hydrant.",
          "options": {
            "A": "Place the coupling in front of the body and run towards the hydrant",
            "B": "Place the coupling at the small of the back and walk towards the hydrant",
            "C": "Place the bight over the right shoulder, hold it with both hands, place the coupling at the small of the back, and run towards the hydrant",
            "D": "Place the bight over the left shoulder, hold it with one hand, place the coupling at the small of the back, and walk towards the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_135_4ba59f36",
          "question": "What is the potential risk of placing your arm or shoulder through a loop in the hose while overhauling hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Placing your arm or shoulder through a loop in the hose while overhauling hose may cause injury if the hose snags on an object.",
          "options": {
            "A": "It may cause the hose to snag on an object",
            "B": "It may cause injury if the hose snags on an object",
            "C": "It may cause the hose to become unmanageable",
            "D": "It may cause the hose to lose pressure"
          }
        },
        {
          "id": "sfd_basic_skills_135_1f15d405",
          "question": "Where should the bight in the hose be placed when stretching the supply hose a long distance?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When stretching the supply hose a long distance, the bight in the hose should be placed over the right shoulder.",
          "options": {
            "A": "Over the left shoulder",
            "B": "Over the right shoulder",
            "C": "At the small of the back",
            "D": "In front of the body"
          }
        },
        {
          "id": "sfd_basic_skills_162_bff4f2d0",
          "question": "What is the minimum distance the hose clamp must be placed from the tailboard of the engine?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The clamp must be placed a minimum of 20 feet from the tailboard of the engine.",
          "options": {
            "A": "10 feet",
            "B": "20 feet",
            "C": "3 feet",
            "D": "30 feet"
          }
        },
        {
          "id": "sfd_basic_skills_162_fe502442",
          "question": "What is the signal for the position #3 and #4 firefighters to know it is safe to exit the engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A single horn honk signals that it is safe for the position #3 and #4 firefighters to exit the engine.",
          "options": {
            "A": "A single horn honk",
            "B": "Two horn honks",
            "C": "A flashing light",
            "D": "A verbal command"
          }
        },
        {
          "id": "sfd_basic_skills_162_4898b009",
          "question": "What is the minimum distance the hose clamp must be placed from any coupling on the supply side of the hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The clamp must be placed not less than 3 feet from any coupling on the supply side of the hose.",
          "options": {
            "A": "1 foot",
            "B": "2 feet",
            "C": "3 feet",
            "D": "4 feet"
          }
        },
        {
          "id": "sfd_basic_skills_162_8e0e6cce",
          "question": "What should be done to minimize the tripping hazard when connecting the LDH to the desired pump intake?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "To minimize the tripping hazard, the female end of the LDH should be placed under the tailboard.",
          "options": {
            "A": "Place the female end under the tailboard",
            "B": "Place the male end under the tailboard",
            "C": "Use a 4\u201d double female",
            "D": "Open the intake valve"
          }
        },
        {
          "id": "sfd_basic_skills_162_e96ea8fb",
          "question": "What should the driver do after positioning the engine at the fire scene?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After positioning the engine at the fire scene, the driver should perform the in-cab procedures to place the engine into pump, then exit the cab and place the wheel blocks.",
          "options": {
            "A": "Exit the cab and place the wheel blocks",
            "B": "Sound a single horn honk",
            "C": "Return to the cab and begin the Forward Lay",
            "D": "Begin the procedures necessary to charge the appropriate attack line"
          }
        },
        {
          "id": "sfd_basic_skills_163_eea23323",
          "question": "What is the primary reason for opening the hose clamp with slow turns after the initial rapid turns?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Opening the hose clamp with slow turns after the initial rapid turns is done to prevent water hammer, which can cause damage to the hose and potentially lead to a dangerous situation.",
          "options": {
            "A": "To allow the firefighter to rest",
            "B": "To ensure the clamp is fully open",
            "C": "To prevent water hammer",
            "D": "To test the strength of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_163_1072c50c",
          "question": "What should a firefighter do if a significant kink is discovered while returning to the pump panel?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If a significant kink is discovered while returning to the pump panel, it should be removed immediately. Kinks can restrict water flow and impact firefighting operations.",
          "options": {
            "A": "Ignore the kink and continue to the pump panel",
            "B": "Remove the kink immediately",
            "C": "Report the kink to the incident commander",
            "D": "Wait for another firefighter to remove the kink"
          }
        },
        {
          "id": "sfd_basic_skills_163_0e026864",
          "question": "What is the role of the driver upon completion of the primary supply?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon completion of the primary supply, the driver will don the SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team, if one is not already in place.",
          "options": {
            "A": "The driver should return to the fire station",
            "B": "The driver should act as a member of the Firefighter Stand-by Rescue Team",
            "C": "The driver should refill the engine\u2019s booster tank",
            "D": "The driver should monitor the radio for further instructions"
          }
        },
        {
          "id": "sfd_basic_skills_163_1996f7ca",
          "question": "What is the purpose of positioning traffic cones around the engine and hose lines?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Traffic cones are positioned to protect personnel, the engine, and hose lines from approaching vehicles. This helps ensure the safety of firefighters and the integrity of firefighting operations.",
          "options": {
            "A": "To mark the location of the fire",
            "B": "To protect personnel, the engine, and hose lines from approaching vehicles",
            "C": "To signal to other firefighters where the engine is located",
            "D": "To provide a visual guide for aiming the hose"
          }
        },
        {
          "id": "sfd_basic_skills_163_4a935b17",
          "question": "What should Position #4 Firefighter do when the engine comes to a stop at the hydrant location?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the engine comes to a stop at the hydrant location, Position #4 Firefighter should exit the engine, proceed to the tailboard and disconnect the LDH from the tri-gate. This is part of the procedure for establishing a water supply.",
          "options": {
            "A": "Remain in the engine",
            "B": "Proceed to the tailboard and disconnect the LDH from the tri-gate",
            "C": "Carry out the instructions of the company Officer",
            "D": "Refill the engine\u2019s booster tank"
          }
        },
        {
          "id": "sfd_basic_skills_134_40b497dc",
          "question": "Why is Large Diameter Hose (LDH) often the best option when supplying an engine from a hydrant source?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "LDH is preferred because it can deliver a high volume of flow with little reduction in pressure due to friction loss.",
          "options": {
            "A": "It is lighter and easier to handle",
            "B": "It is capable of delivering a very high volume of flow with little reduction in pressure due to friction loss",
            "C": "It is cheaper and more readily available",
            "D": "It is more durable and less likely to get damaged"
          }
        },
        {
          "id": "sfd_basic_skills_134_eada0cb2",
          "question": "What is the maximum distance a single firefighter can be expected to overhaul LDH without assistance?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A single firefighter can be expected to overhaul LDH approximately 150 feet without assistance.",
          "options": {
            "A": "50 feet",
            "B": "100 feet",
            "C": "150 feet",
            "D": "200 feet"
          }
        },
        {
          "id": "sfd_basic_skills_134_cfc2e5f4",
          "question": "When might it be impractical to use LDH for water supply?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "It might be impractical to use LDH when an additional company will be delayed and a single member is overhauling hose to the hydrant.",
          "options": {
            "A": "When the fire is small and doesn't require much water",
            "B": "When an additional company will be delayed and a single member is overhauling hose to the hydrant",
            "C": "When the hydrant source is too far away",
            "D": "When the LDH is damaged or faulty"
          }
        },
        {
          "id": "sfd_basic_skills_134_3c44909e",
          "question": "What should a firefighter do when stretching supply hose a short distance?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When stretching supply hose a short distance, a firefighter should grasp the hose just behind the coupling and run toward the hydrant, always keeping the coupling behind.",
          "options": {
            "A": "Grasp hose just behind the coupling and run toward the hydrant, keeping the coupling ahead",
            "B": "Grasp hose just behind the coupling and run toward the hydrant, keeping the coupling behind",
            "C": "Grasp hose just ahead of the coupling and run toward the hydrant, keeping the coupling ahead",
            "D": "Grasp hose just ahead of the coupling and run toward the hydrant, keeping the coupling behind"
          }
        },
        {
          "id": "sfd_basic_skills_134_010f224a",
          "question": "What alternative to LDH may be used when it is not possible to utilize LDH for the water supply, and an additional company will be delayed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When it is not possible to utilize LDH for the water supply, and an additional company will be delayed, 2\u00bd\u201d hose may be used.",
          "options": {
            "A": "1\u00bd\u201d hose",
            "B": "2\u00bd\u201d hose",
            "C": "3\u00bd\u201d hose",
            "D": "4\u00bd\u201d hose"
          }
        },
        {
          "id": "sfd_basic_skills_122_11c85777",
          "question": "What is the recommended pressure to maintain as the hose fills with water?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text recommends maintaining 50-75 PSI as the hose fills with water.",
          "options": {
            "A": "25-50 PSI",
            "B": "50-75 PSI",
            "C": "75-100 PSI",
            "D": "100-125 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_122_3c6043c7",
          "question": "What are the three indicators that the PRV operating handle has been turned enough counter-clockwise?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the three indicators are the engine RPM\u2019s will begin to drop, the indicated discharge pressure will also drop, and the PRV indicator light will illuminate.",
          "options": {
            "A": "Engine RPM\u2019s drop, discharge pressure increases, PRV indicator light illuminates",
            "B": "Engine RPM\u2019s increase, discharge pressure drops, PRV indicator light turns off",
            "C": "Engine RPM\u2019s drop, discharge pressure drops, PRV indicator light illuminates",
            "D": "Engine RPM\u2019s increase, discharge pressure increases, PRV indicator light turns off"
          }
        },
        {
          "id": "sfd_basic_skills_122_73240623",
          "question": "Why should you not charge the attack line with a pressure of greater than 75 PSI until the hose is full of water?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that charging the attack line with a pressure of greater than 75 PSI before the hose is full of water can damage the inner lining of the hose.",
          "options": {
            "A": "To prevent damaging the inner lining of the hose",
            "B": "To prevent the hose from becoming too heavy",
            "C": "To ensure the water supply lasts longer",
            "D": "To ensure the hose doesn't become too long"
          }
        },
        {
          "id": "sfd_basic_skills_122_cbca0034",
          "question": "What should you do once the PRV indicator light turns off?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text suggests that once the PRV indicator light turns off, the procedure of turning the handle has been completed and the discharge pressure has returned to the desired setting.",
          "options": {
            "A": "Turn the operating handle counter-clockwise one-half turn",
            "B": "Turn the operating handle clockwise one-half turn",
            "C": "Continue to turn the operating handle clockwise until the discharge pressure returns to the desired setting",
            "D": "Stop turning the operating handle"
          }
        },
        {
          "id": "sfd_basic_skills_122_20534034",
          "question": "What is the consequence of not setting the discharge pressure to the desired setting?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Setting the discharge pressure to the desired setting ensures that the hose has enough pressure for effective firefighting. The other options are not mentioned in the text.",
          "options": {
            "A": "The hose will not fill with water",
            "B": "The PRV indicator light will not turn off",
            "C": "The engine RPM\u2019s will not drop",
            "D": "The hose may not have enough pressure for effective firefighting"
          }
        },
        {
          "id": "sfd_basic_skills_159_3935435f",
          "question": "What should be used if a soft suction hose will not reach the hydrant when attempting to make a Reverse Pump Hook-up?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that LDH should be utilized in place of a soft suction hose if it will not reach the hydrant when attempting to make a Reverse Pump Hook-up.",
          "options": {
            "A": "A 4\" double female",
            "B": "LDH",
            "C": "Hydrant Adaptor",
            "D": "Soft Suction"
          }
        },
        {
          "id": "sfd_basic_skills_159_a53e11a7",
          "question": "What is the preferred option for a Reverse Pump Hook-up using LDH instead of the Soft Suction?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Both LDH connected to the main side intake using a 4\" double female and Hydrant Adaptor used to connect LDH to the hydrant are mentioned as parts of the preferred option for a Reverse Pump Hook-up using LDH.",
          "options": {
            "A": "LDH connected to the main side intake using a 4\" double female",
            "B": "Hydrant Adaptor used to connect LDH to the hydrant",
            "C": "Both A and B",
            "D": "None of the above"
          }
        },
        {
          "id": "sfd_basic_skills_159_770afede",
          "question": "What is the implication of using LDH for a Reverse Pump Hook-up?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text suggests that LDH is used when the soft suction hose will not reach the hydrant, implying that LDH allows for a longer reach.",
          "options": {
            "A": "It increases the risk of fire spread",
            "B": "It decreases the efficiency of water supply",
            "C": "It allows for a longer reach to the hydrant",
            "D": "It requires more manpower to operate"
          }
        },
        {
          "id": "sfd_basic_skills_159_e15fbc9a",
          "question": "What is the role of a 4\" double female in a Reverse Pump Hook-up using LDH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that a 4\" double female is used to connect the LDH to the main side intake.",
          "options": {
            "A": "It connects the LDH to the hydrant",
            "B": "It connects the LDH to the main side intake",
            "C": "It connects the soft suction hose to the hydrant",
            "D": "It connects the soft suction hose to the main side intake"
          }
        },
        {
          "id": "sfd_basic_skills_159_7713fc28",
          "question": "What is the role of a Hydrant Adaptor in a Reverse Pump Hook-up using LDH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that a Hydrant Adaptor is used to connect the LDH to the hydrant.",
          "options": {
            "A": "It connects the LDH to the main side intake",
            "B": "It connects the LDH to the hydrant",
            "C": "It connects the soft suction hose to the hydrant",
            "D": "It connects the soft suction hose to the main side intake"
          }
        },
        {
          "id": "sfd_basic_skills_118_e042c6f8",
          "question": "What is the primary responsibility of the engine company engine driver?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The primary responsibility of the engine company engine driver is the safe delivery of personnel to a reported fire or emergency.",
          "options": {
            "A": "To provide a continuous supply of water to the operating firefighting force",
            "B": "To act as a member of the Firefighter Stand-by Rescue Team",
            "C": "To safe delivery of personnel to a reported fire or emergency",
            "D": "To initiate supply line operations"
          }
        },
        {
          "id": "sfd_basic_skills_118_dfd698f9",
          "question": "What is the first step in the driver\u2019s 'In-Cab Procedure'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in the driver\u2019s 'In-Cab Procedure' is to set the parking brake.",
          "options": {
            "A": "Shift the transmission into 'neutral'",
            "B": "Set the parking brake",
            "C": "Honk horn once",
            "D": "Shift the Power Take-off (PTO) from road to pump"
          }
        },
        {
          "id": "sfd_basic_skills_118_8db07064",
          "question": "What does a change in the speedometer reading indicate during the 'In-Cab Procedure'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A change in the speedometer reading indicates that the pump is engaged.",
          "options": {
            "A": "The engine is completely stopped",
            "B": "The pump is engaged",
            "C": "The engine is in drive",
            "D": "The engine is in neutral"
          }
        },
        {
          "id": "sfd_basic_skills_118_381a1eff",
          "question": "What is the driver\u2019s role after completion of the primary supply?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon completion of the primary supply, the driver will act as a member of the Firefighter Stand-by Rescue Team.",
          "options": {
            "A": "To act as a member of the Rapid Intervention Team",
            "B": "To act as a member of the Firefighter Stand-by Rescue Team",
            "C": "To provide water to attack lines",
            "D": "To initiate supply line operations"
          }
        },
        {
          "id": "sfd_basic_skills_118_d6c321c4",
          "question": "What is the purpose of honking the horn once during the 'In-Cab Procedure'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Honking the horn once during the 'In-Cab Procedure' signals to the crewmembers that the engine is completely stopped.",
          "options": {
            "A": "To signal that the engine is in pump gear",
            "B": "To signal that the engine is completely stopped",
            "C": "To signal that the engine is in drive",
            "D": "To signal that the engine is in neutral"
          }
        },
        {
          "id": "sfd_basic_skills_138_d7fe436e",
          "question": "What is the purpose of the hydrant adapter in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hydrant adapter is used to connect the Large Diameter Hose (LDH) to the hydrant.",
          "options": {
            "A": "To connect the fire engine to the hydrant",
            "B": "To connect the LDH to the hydrant",
            "C": "To connect the hydrant bag to the hydrant",
            "D": "To connect the wrenches to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_138_6e6470ca",
          "question": "What is the first step in preparing a hydrant for use in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in preparing a hydrant for use is to procure the hydrant bag and hydrant wrenches and return to the hydrant.",
          "options": {
            "A": "Attach the hydrant adapter to the engine port",
            "B": "Attach the LDH to the hydrant adapter",
            "C": "Procure the hydrant bag and hydrant wrenches and return to the hydrant",
            "D": "Attach the hydrant gate to the 2\u00bd\u201d port"
          }
        },
        {
          "id": "sfd_basic_skills_138_849c11f9",
          "question": "What is the significance of ensuring the hydrant gate is in the closed position?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Ensuring the hydrant gate is in the closed position is important to prevent water from prematurely flowing out of the hydrant.",
          "options": {
            "A": "To prevent water from flowing out of the hydrant",
            "B": "To allow the fire engine to connect to the hydrant",
            "C": "To allow the LDH to connect to the hydrant",
            "D": "To prevent the hydrant from overheating"
          }
        },
        {
          "id": "sfd_basic_skills_138_f9cad353",
          "question": "What tool is used to remove the engine port cap and the 2\u00bd\u201d port cap of the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A corey wrench is used to remove the engine port cap and the 2\u00bd\u201d port cap of the hydrant.",
          "options": {
            "A": "Hydrant adapter",
            "B": "Hydrant gate",
            "C": "Corey wrench",
            "D": "Hydrant bag"
          }
        },
        {
          "id": "sfd_basic_skills_138_ef22a28a",
          "question": "What is the purpose of the 4\u201d engine port cap on a hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 4\u201d engine port cap on a hydrant is used to prevent water from prematurely flowing out of the hydrant.",
          "options": {
            "A": "To connect the LDH to the hydrant",
            "B": "To prevent water from flowing out of the hydrant",
            "C": "To connect the hydrant adapter to the engine port",
            "D": "To connect the hydrant bag to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_155_7015b4fe",
          "question": "Who gives the order to proceed to the hydrant in a reverse lay supply line operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the order to proceed to the hydrant is given by the company Officer or the position #4 firefighter.",
          "options": {
            "A": "The engine driver",
            "B": "The company Officer or the position #4 firefighter",
            "C": "Any member of the team",
            "D": "The hydrant operator"
          }
        },
        {
          "id": "sfd_basic_skills_155_6a38412c",
          "question": "What is the standard length of a soft suction hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the standard length of a soft suction hose is 24 feet.",
          "options": {
            "A": "12 feet",
            "B": "24 feet",
            "C": "36 feet",
            "D": "48 feet"
          }
        },
        {
          "id": "sfd_basic_skills_155_b2d65b38",
          "question": "What should be considered when positioning the engine at the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text specifies that when positioning the engine at the hydrant, the driver should consider which soft suction intake will be utilized and the length of the soft suction hose.",
          "options": {
            "A": "The color of the hydrant",
            "B": "The number of bystanders",
            "C": "Which soft suction intake will be utilized and the length of the soft suction hose",
            "D": "The weather conditions"
          }
        },
        {
          "id": "sfd_basic_skills_155_ea0f3b50",
          "question": "What is the signal that it is safe for the members to exit the cab?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that a single honk of the horn indicates that it is safe for the members to exit the cab.",
          "options": {
            "A": "A single honk of the horn",
            "B": "A double honk of the horn",
            "C": "A flashing light",
            "D": "A verbal command"
          }
        },
        {
          "id": "sfd_basic_skills_155_5fe7ab4c",
          "question": "What should be done with the female end of the LDH after breaking the connection?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that after breaking the connection, the female end of the LDH should be placed under the tailboard for safety.",
          "options": {
            "A": "Connect it to the hydrant",
            "B": "Place it under the tailboard for safety",
            "C": "Leave it on the ground",
            "D": "Hand it to another firefighter"
          }
        },
        {
          "id": "sfd_basic_skills_143_0d991714",
          "question": "What should be done if a significant kink is found while returning to the pump panel?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Significant kinks in the hose can disrupt the water supply and should be removed immediately.",
          "options": {
            "A": "Ignore it and continue",
            "B": "Remove it immediately",
            "C": "Report it to the team leader",
            "D": "Wait for the Rapid Intervention Team to handle it"
          }
        },
        {
          "id": "sfd_basic_skills_143_0fa31289",
          "question": "What is the next step after returning to the pump panel?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Once at the pump panel, the intake valve should be opened to ensure water supply.",
          "options": {
            "A": "Close the intake valve",
            "B": "Open the tank-to-pump valve",
            "C": "Open the intake valve",
            "D": "Adjust the throttle"
          }
        },
        {
          "id": "sfd_basic_skills_143_f474c9b0",
          "question": "What role does the driver take upon completion of the primary supply?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Upon completion of the primary supply, the driver dons SCBA to a stand-by position and acts as a member of the Firefighter Stand-by Rescue Team.",
          "options": {
            "A": "Joins the Firefighter Stand-by Rescue Team",
            "B": "Becomes a member of the Rapid Intervention Team",
            "C": "Takes a break",
            "D": "Starts refilling the engine\u2019s booster tank"
          }
        },
        {
          "id": "sfd_basic_skills_143_c3d0ab7d",
          "question": "What is the purpose of placing traffic cones around the engine and hose lines?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Traffic cones are placed to protect personnel, the engine, and hose lines from approaching vehicles.",
          "options": {
            "A": "To mark the area for the Rapid Intervention Team",
            "B": "To protect personnel, the engine, and hose lines from approaching vehicles",
            "C": "To signal to other firefighters where the water supply is",
            "D": "To show the public where the fire is"
          }
        },
        {
          "id": "sfd_basic_skills_143_a0f30277",
          "question": "What should be done once a second water supply has been established?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once a second supply has been established, any water already used from the engine\u2019s booster tank should be refilled.",
          "options": {
            "A": "Start the engine",
            "B": "Refill any water already used from the engine\u2019s booster tank",
            "C": "Remove any remaining kinks in the supply line",
            "D": "Close the tank-to-pump valve"
          }
        },
        {
          "id": "sfd_basic_skills_114_35424ee4",
          "question": "What is the primary function of the engine company according to the Seattle Fire Department Basic Skills Manual?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, stretching and operating hose lines is the primary function of the engine company.",
          "options": {
            "A": "To evacuate occupants",
            "B": "To search for persons endangered by the fire",
            "C": "Stretching and operating hose lines",
            "D": "To extinguish the fire"
          }
        },
        {
          "id": "sfd_basic_skills_114_33fc9124",
          "question": "What is the purpose of the first hose line in a structural fire?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The first hose line is placed to allow occupants to evacuate, allow members to proceed to the floors above the fire for search, and to confine and extinguish the fire.",
          "options": {
            "A": "To allow members to proceed to the floors above the fire for search",
            "B": "To confine and extinguish the fire",
            "C": "To allow occupants to evacuate",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_114_38a00e9b",
          "question": "If there is no life hazard in the building, where is the first line positioned?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If there is no life hazard in the building, the first line is positioned between the fire and the most severe exposure.",
          "options": {
            "A": "Between the fire and the most severe exposure",
            "B": "At the main entrance or stairway",
            "C": "At the floors above the fire",
            "D": "At the location of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_114_6122ee69",
          "question": "Who maintains the ability to alter the standard methods of fire ground operations when necessary?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The company Officer maintains the ability to alter the standard methods when necessary.",
          "options": {
            "A": "The engine company",
            "B": "The company Officer",
            "C": "The Operations Division members",
            "D": "The Recruit Firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_114_d35ee522",
          "question": "What is the most likely internal exposure in the case of an offensive fire attack?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In the case of an offensive fire attack, the most likely internal exposure will be the location of the fire.",
          "options": {
            "A": "The main entrance or stairway",
            "B": "The floors above the fire",
            "C": "The location of the fire",
            "D": "An adjacent building"
          }
        },
        {
          "id": "sfd_basic_skills_148_1e1f7f6d",
          "question": "What is the role of the position #4 firefighter when the Officer is unable to foot the tri-gate or LDH due to incident command responsibilities?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The position #4 firefighter will have sole responsibility of ensuring that all required hose and equipment has been removed from the engine. After completing this task, the firefighter will then direct the driver to proceed to the hydrant without instructions from the Officer.",
          "options": {
            "A": "The firefighter will wait for further instructions from the Officer.",
            "B": "The firefighter will direct the driver to proceed to the hydrant without instructions from the Officer.",
            "C": "The firefighter will take over the Officer's command responsibilities.",
            "D": "The firefighter will replace the Officer at the nozzle bundle."
          }
        },
        {
          "id": "sfd_basic_skills_148_f75445c0",
          "question": "Where should the nozzle bundle be positioned in relation to the fire?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The nozzle bundle should be positioned nearest to the fire.",
          "options": {
            "A": "Farthest from the fire",
            "B": "At a safe distance from the fire",
            "C": "Nearest to the fire",
            "D": "At a random distance from the fire"
          }
        },
        {
          "id": "sfd_basic_skills_148_a1af22f2",
          "question": "What should be done with the second section of 2\u00bd\u201d hose from the bed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The second section of 2\u00bd\u201d hose from the bed should be placed on the ground next to the nozzle bundle.",
          "options": {
            "A": "It should be left on the bed",
            "B": "It should be placed on the ground next to the nozzle bundle",
            "C": "It should be attached to the tri-gate",
            "D": "It should be used to replace the first section of hose"
          }
        },
        {
          "id": "sfd_basic_skills_148_e937f16a",
          "question": "What is the signal for the driver to proceed to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The signal for the driver to proceed to the hydrant should be both audible and visual, by pointing forward while shouting 'Go ahead.'",
          "options": {
            "A": "A visual signal only",
            "B": "An audible signal only",
            "C": "Both audible and visual, by pointing forward while shouting 'Go ahead.'",
            "D": "A written signal"
          }
        },
        {
          "id": "sfd_basic_skills_148_4acb1c4d",
          "question": "What should be done if the Officer is unavailable?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the Officer is unavailable, the tri-gate should be removed and positioned between the unloaded 2 \u00bd\u201d bundles and the engine.",
          "options": {
            "A": "Wait for the Officer to return",
            "B": "Remove the tri-gate and position it between the unloaded 2 \u00bd\u201d bundles and the engine",
            "C": "Leave the scene",
            "D": "Take over the Officer's command responsibilities"
          }
        },
        {
          "id": "sfd_basic_skills_172_171dc355",
          "question": "What should the Officer (2nd engine) do once at the fire location?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Once at the fire location, the Officer (2nd engine) should carry out the instructions of the company Officer.",
          "options": {
            "A": "Direct the driver to the nearest hydrant",
            "B": "Exit the cab immediately",
            "C": "Carry out the instructions of the company Officer",
            "D": "Sound a single horn honk"
          }
        },
        {
          "id": "sfd_basic_skills_172_250b6f7d",
          "question": "What is the role of the Driver (2nd engine) after positioning the engine as directed by the Officer?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After positioning the engine as directed by the Officer, the Driver (2nd engine) should sound a single horn honk so that the Officer and position #4 firefighter know that it is safe to exit the engine.",
          "options": {
            "A": "Exit the cab and place the wheel blocks",
            "B": "Sound a single horn honk so that the Officer and position #4 firefighter know that it is safe to exit the engine",
            "C": "Direct the position #4 firefighter to send the engine to the hydrant",
            "D": "Remove the Officer\u2019s SCBA and appropriate tools from the engine"
          }
        },
        {
          "id": "sfd_basic_skills_172_7212bee7",
          "question": "What is the role of Position #3 Firefighter (2nd engine) in this scenario?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Position #3 Firefighter (2nd engine) should follow the directions of the Officer. If directed to the hydrant with the driver, they should remain in the cab while the engine makes its first stop, then proceed to the hydrant with the driver and assist with the reverse pump hook-up.",
          "options": {
            "A": "Connect the hose together using a 4\u201d double male",
            "B": "Follow directions of the Officer and assist with the reverse pump hook-up if directed to the hydrant with the driver",
            "C": "Direct the driver to a location near the dropped tri-gate of the initial engine",
            "D": "Signal the driver to proceed to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_172_85099401",
          "question": "What is the role of Position #4 Firefighter (2nd engine) after the driver sounds the proper horn signal?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Position #4 Firefighter (2nd engine) should exit the cab after the driver sounds the proper horn signal, procure a 4\u201d double male and the tri-gate, with LDH attached, from their compartments.",
          "options": {
            "A": "Exit the cab and place the wheel blocks",
            "B": "Carry out the instructions of the company Officer",
            "C": "Exit the cab, procure a 4\u201d double male and the tri-gate, with LDH attached, from their compartments",
            "D": "Sound a single horn honk so that the Officer and position #3 firefighter know that it is safe to exit the engine"
          }
        },
        {
          "id": "sfd_basic_skills_172_2b16c09f",
          "question": "What should the Officer (2nd engine) ensure about the amount of LDH hose removed from the 2nd engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Officer (2nd engine) should ensure that the amount of LDH hose removed from the 2nd engine is enough to make the connection to the initial engine\u2019s LDH hose lay.",
          "options": {
            "A": "It is enough to make the connection to the initial engine\u2019s LDH hose lay",
            "B": "It is less than the amount of LDH hose in the initial engine",
            "C": "It is more than the amount of LDH hose in the initial engine",
            "D": "It is equal to the amount of LDH hose in the initial engine"
          }
        },
        {
          "id": "sfd_basic_skills_125_966a1ef4",
          "question": "What is the recommended engine speed when opening the tank-to-pump valve during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The recommended engine speed when opening the tank-to-pump valve is 800-1000 RPMs.",
          "options": {
            "A": "500-700 RPMs",
            "B": "800-1000 RPMs",
            "C": "1000-1200 RPMs",
            "D": "1200-1400 RPMs"
          }
        },
        {
          "id": "sfd_basic_skills_125_27266f4f",
          "question": "What is the maximum pressure that should be used to charge the attack line before the hose is full of water?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The attack line should not be charged with a pressure greater than 75 PSI until the hose is full of water to avoid damaging the inner lining of the hose.",
          "options": {
            "A": "25 PSI",
            "B": "50 PSI",
            "C": "75 PSI",
            "D": "100 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_125_fc2d5599",
          "question": "What are the indicators that the discharge pressure relief valve (PRV) has opened?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The PRV has opened when the engine RPM\u2019s begin to drop, the indicated discharge pressure also drops, and the PRV indicator light illuminates.",
          "options": {
            "A": "The engine RPM\u2019s will increase, the indicated discharge pressure will rise, and the PRV indicator light will illuminate.",
            "B": "The engine RPM\u2019s will begin to drop, the indicated discharge pressure will also drop, and the PRV indicator light will illuminate.",
            "C": "The engine RPM\u2019s will remain constant, the indicated discharge pressure will rise, and the PRV indicator light will turn off.",
            "D": "The engine RPM\u2019s will increase, the indicated discharge pressure will also increase, and the PRV indicator light will turn off."
          }
        },
        {
          "id": "sfd_basic_skills_125_d796390a",
          "question": "What should be done once the hose is filled with water during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Once the hose is filled with water, the discharge pressure should be increased to the desired setting.",
          "options": {
            "A": "Decrease the discharge pressure to the desired setting.",
            "B": "Maintain the discharge pressure between 50-75 PSI.",
            "C": "Increase the discharge pressure to the desired setting.",
            "D": "Keep the discharge pressure at a constant 75 PSI."
          }
        },
        {
          "id": "sfd_basic_skills_125_8d40ee4d",
          "question": "What should be done to assess the fire stream during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The fire stream should be assessed for an appropriate volume of water flow (GPM) and the appropriate pattern.",
          "options": {
            "A": "Check the fire stream for the appropriate pattern and volume of water flow (GPM).",
            "B": "Increase the volume of water flow (GPM) to the maximum.",
            "C": "Decrease the volume of water flow (GPM) to the minimum.",
            "D": "Keep the volume of water flow (GPM) at a constant rate."
          }
        },
        {
          "id": "sfd_basic_skills_133_48e9f3f5",
          "question": "What is the role of the position #3 firefighter when all 1\u00be\u201d hose is to be used outside?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The position #3 firefighter grasps the center bight of the second section (on the ground) with the left hand while keeping the first section shoulder-loaded. This firefighter then proceeds to stretch all 200 feet of 1\u00be\u201d hose.",
          "options": {
            "A": "Connects the bell reducer to the 2\u00bd\u201d hose",
            "B": "Grasps the center bight of the second section",
            "C": "Meets the other member at the nozzle",
            "D": "Drops flakes of 2\u00bd\u201d hose first"
          }
        },
        {
          "id": "sfd_basic_skills_133_288d13e2",
          "question": "What should the position #4 firefighter do after connecting the bell reducer to the 2\u00bd\u201d line?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After connecting the bell reducer to the 2\u00bd\u201d line, position #4 firefighter meets the other member at the nozzle.",
          "options": {
            "A": "Grasp the center bight of the second section",
            "B": "Stretch all 200 feet of 1\u00be\u201d hose",
            "C": "Meet the other member at the nozzle",
            "D": "Drop flakes of 2\u00bd\u201d hose first"
          }
        },
        {
          "id": "sfd_basic_skills_133_b71a589c",
          "question": "What is the role of the position #3 firefighter when some of the 2 \u00bd\u201d hose will be used inside of the structure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The position #3 firefighter should grasp the bights most near to the 2\u00bd\u201d male coupling (as well as the coupling itself).",
          "options": {
            "A": "Connects the bell reducer to the 2\u00bd\u201d hose",
            "B": "Grasps the bights most near to the 2\u00bd\u201d male coupling",
            "C": "Meets the other member at the nozzle",
            "D": "Drops flakes of 2\u00bd\u201d hose first"
          }
        },
        {
          "id": "sfd_basic_skills_133_1611f8fa",
          "question": "What should the position #4 firefighter do when some of the 2 \u00bd\u201d hose will be used inside of the structure?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "As both members begin advancing the hose line to the objective, the position #4 firefighter will drop off flakes of 2\u00bd\u201d hose first.",
          "options": {
            "A": "Grasp the bights most near to the 2\u00bd\u201d male coupling",
            "B": "Stretch all 200 feet of 1\u00be\u201d hose",
            "C": "Meet the other member at the nozzle",
            "D": "Drop off flakes of 2\u00bd\u201d hose first"
          }
        },
        {
          "id": "sfd_basic_skills_133_40b40e58",
          "question": "What should the position #3 firefighter do after the position #4 firefighter drops the last flake of 2\u00bd\u201d hose?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the position #4 firefighter drops the last flake, they should instruct the position #3 firefighter to \u201cstretch the 2\u00bd\u201d.",
          "options": {
            "A": "Connects the bell reducer to the 2\u00bd\u201d hose",
            "B": "Grasps the bights most near to the 2\u00bd\u201d male coupling",
            "C": "Stretch the 2\u00bd\u201d",
            "D": "Meet the other member at the nozzle"
          }
        },
        {
          "id": "sfd_basic_skills_164_32259466",
          "question": "What is the role of a later arriving company in the 'Forward Lay \u2013 Dry' evolution?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that a later arriving company will be directed to make the hydrant connections in the 'Forward Lay \u2013 Dry' evolution.",
          "options": {
            "A": "To make the hydrant connections",
            "B": "To sound a single horn honk",
            "C": "To supervise and assist the company in fire suppression",
            "D": "To position the engine near the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_164_31fc5319",
          "question": "What is the role of the driver in the 'Forward Lay - Wet' evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the driver should position the engine so that the tailboard is approximately 10 feet past the hydrant in the 'Forward Lay - Wet' evolution.",
          "options": {
            "A": "To make the hydrant connections",
            "B": "To position the engine so that the tailboard is approximately 10 feet past the hydrant",
            "C": "To carry out the instructions of the company Officer",
            "D": "To supervise and assist the company in fire suppression"
          }
        },
        {
          "id": "sfd_basic_skills_164_603a8194",
          "question": "What is the signal for position #3 and #4 firefighters to know it is safe to exit the engine?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that the driver should sound a single horn honk so that the position #3 and #4 firefighters know it is safe to exit the engine.",
          "options": {
            "A": "A single horn honk",
            "B": "A double horn honk",
            "C": "A verbal command from the officer",
            "D": "A visual signal from the driver"
          }
        },
        {
          "id": "sfd_basic_skills_164_0b897e32",
          "question": "What should the Officer do at the fire scene in a 'Forward Lay - Wet' evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that at the fire scene, the Officer should don the SCBA and supervise and assist the company in fire suppression and rescue activities.",
          "options": {
            "A": "Make the hydrant connections",
            "B": "Sound a single horn honk",
            "C": "Don the SCBA and supervise and assist the company in fire suppression and rescue activities",
            "D": "Position the engine near the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_164_1d4617ea",
          "question": "Who is responsible for beginning the Forward Lay in a 'Forward Lay - Wet' evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the driver should begin the Forward Lay once the position #3 firefighter has returned to the cab and is seated and the position #4 firefighter has given the signal to proceed.",
          "options": {
            "A": "The Officer",
            "B": "The Driver",
            "C": "Position #3 Firefighter",
            "D": "Position #4 Firefighter"
          }
        },
        {
          "id": "sfd_basic_skills_113_a6607364",
          "question": "What is the main focus of Chapter 4 in the Seattle Fire Department manual?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The content specifies that Chapter 4 of the Seattle Fire Department manual is focused on Engine Evolutions.",
          "options": {
            "A": "Firefighter recruitment",
            "B": "Fire safety regulations",
            "C": "Engine evolutions",
            "D": "Fire department history"
          }
        },
        {
          "id": "sfd_basic_skills_113_10b31a2f",
          "question": "What might 'Engine Evolutions' refer to in the context of firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "'Engine Evolutions' in a firefighting context likely refers to the procedures and tactics involving the use of fire engines.",
          "options": {
            "A": "The history of fire engine development",
            "B": "The process of maintaining and repairing fire engines",
            "C": "The procedures and tactics involving the use of fire engines",
            "D": "The biological adaptation of firefighters to engine smoke"
          }
        },
        {
          "id": "sfd_basic_skills_113_28df6eab",
          "question": "How could understanding 'Engine Evolutions' impact firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Understanding 'Engine Evolutions' could improve the efficiency and effectiveness of fire engine use in firefighting operations.",
          "options": {
            "A": "It could improve the efficiency and effectiveness of fire engine use",
            "B": "It could help in designing new fire engines",
            "C": "It could reduce the need for fire engines",
            "D": "It could make fire engines obsolete"
          }
        },
        {
          "id": "sfd_basic_skills_113_6289bbe0",
          "question": "What safety considerations might be associated with 'Engine Evolutions'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Safety considerations associated with 'Engine Evolutions' would likely include understanding and following procedures for safe fire engine operation.",
          "options": {
            "A": "Ensuring fire engines are not used",
            "B": "Understanding and following procedures for safe fire engine operation",
            "C": "Avoiding the use of fire engines whenever possible",
            "D": "Replacing fire engines with more modern equipment"
          }
        },
        {
          "id": "sfd_basic_skills_113_769a9148",
          "question": "What operational tactics might be discussed in a chapter on 'Engine Evolutions'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A chapter on 'Engine Evolutions' would likely discuss tactics for using fire engines in various firefighting scenarios.",
          "options": {
            "A": "Tactics for fighting fires without the use of engines",
            "B": "Tactics for using fire engines in various firefighting scenarios",
            "C": "Tactics for convincing the public to support the fire department",
            "D": "Tactics for negotiating better contracts for firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_144_90943c2e",
          "question": "When is a second supply line from a different hydrant required according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, a second supply line from a different hydrant is required if supplying a 2\u00bd\u201d attack line.",
          "options": {
            "A": "If supplying a 1\u00bd\u201d attack line",
            "B": "If pumping 200 gallons per minute or more",
            "C": "If supplying a 2\u00bd\u201d attack line",
            "D": "While pumping at any single alarm fire"
          }
        },
        {
          "id": "sfd_basic_skills_144_691eb0af",
          "question": "What should not be done until the redundant supply line has been connected to the hydrant and charged?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that the intake valve for the redundant supply should not be opened until that line has been connected to the hydrant and charged.",
          "options": {
            "A": "Open the intake valve for the redundant supply",
            "B": "Remove the 2 \u00bd\u201d to 4\u201d increaser from the hydrant gate",
            "C": "Remove all kinks in the second supply line",
            "D": "Start the engine"
          }
        },
        {
          "id": "sfd_basic_skills_144_55bc59a6",
          "question": "What is the consequence of opening the intake valve for the redundant supply before the hydrant connection is made?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that if the intake is opened before the hydrant connection is made, water will abruptly backfill the hose making your connection to the hydrant impossible.",
          "options": {
            "A": "Water will abruptly backfill the hose making your connection to the hydrant impossible",
            "B": "The hose will burst",
            "C": "The hydrant will run out of water",
            "D": "The engine will overheat"
          }
        },
        {
          "id": "sfd_basic_skills_144_2ed689b3",
          "question": "What is the preferred hose for a second supply according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text states that LDH (Large Diameter Hose) is always preferred for a second supply.",
          "options": {
            "A": "1\u00bd\u201d hose",
            "B": "2\u00bd\u201d hose",
            "C": "3\u00bd\u201d hose",
            "D": "LDH (Large Diameter Hose)"
          }
        },
        {
          "id": "sfd_basic_skills_144_68dcc814",
          "question": "What should be done as quickly and as efficiently as possible during a reverse lay?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "During a reverse lay, a large compliment of hose and equipment must be removed from the engine at the fire scene. This task must be completed as quickly and as efficiently as possible.",
          "options": {
            "A": "The removal of hose and equipment from the engine",
            "B": "The connection of the hose to the hydrant",
            "C": "The charging of the hose",
            "D": "The opening of the intake valve"
          }
        },
        {
          "id": "sfd_basic_skills_152_20be8318",
          "question": "What is the first step to take when all hose and equipment has been removed from the engine?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step after all hose and equipment has been removed from the engine is to break the 200 feet of 2\u00bd\u201d hose into two separate sections.",
          "options": {
            "A": "Stretch the 2\u00bd\u201d hose lines 50 feet beyond the monitor",
            "B": "Break the 200 feet of 2\u00bd\u201d hose into two separate sections",
            "C": "Hand the female couplings off to the position #4 firefighter",
            "D": "Proceed back to a point approximately 20 feet behind the monitor"
          }
        },
        {
          "id": "sfd_basic_skills_152_206dd0c5",
          "question": "Who should the female couplings be handed off to?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The female couplings should be handed off to the position #4 firefighter.",
          "options": {
            "A": "The position #1 firefighter",
            "B": "The position #2 firefighter",
            "C": "The position #3 firefighter",
            "D": "The position #4 firefighter"
          }
        },
        {
          "id": "sfd_basic_skills_152_0d4d57f7",
          "question": "How far should the 2\u00bd\u201d hose lines be stretched beyond the monitor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 2\u00bd\u201d hose lines should be stretched approximately 50 feet beyond the monitor.",
          "options": {
            "A": "20 feet",
            "B": "50 feet",
            "C": "100 feet",
            "D": "200 feet"
          }
        },
        {
          "id": "sfd_basic_skills_152_addf84e1",
          "question": "After stretching the hose lines, what is the next step?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After stretching the hose lines, the next step is to turn to face the monitor and proceed back to a point approximately 20 feet behind it.",
          "options": {
            "A": "Hand the female couplings off to the position #4 firefighter",
            "B": "Break the 200 feet of 2\u00bd\u201d hose into two separate sections",
            "C": "Turn to face the monitor and proceed back to a point approximately 20 feet behind it",
            "D": "Remove all hose and equipment from the engine"
          }
        },
        {
          "id": "sfd_basic_skills_152_2db7bdf8",
          "question": "What is the importance of breaking the 200 feet of 2\u00bd\u201d hose into two separate sections?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Breaking the 200 feet of 2\u00bd\u201d hose into two separate sections allows for simultaneous use on both sides of the appliance.",
          "options": {
            "A": "To make it easier to handle",
            "B": "To increase the water pressure",
            "C": "To allow for simultaneous use on both sides of the appliance",
            "D": "There is no specific reason"
          }
        },
        {
          "id": "sfd_basic_skills_129_68231a62",
          "question": "What is the definition of an 'Extended Attack' in the context of the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text defines an 'Extended Attack' as 200' of 1 \u00be\u201d hose extended from 200' of 2 \u00bd\u201d hose.",
          "options": {
            "A": "200' of 1 \u00be\u201d hose extended from 200' of 2 \u00bd\u201d hose",
            "B": "400' of 1 \u00be\u201d hose extended from 200' of 2 \u00bd\u201d hose",
            "C": "200' of 1 \u00be\u201d hose extended from 400' of 2 \u00bd\u201d hose",
            "D": "400' of 1 \u00be\u201d hose extended from 400' of 2 \u00bd\u201d hose"
          }
        },
        {
          "id": "sfd_basic_skills_129_07ab35e1",
          "question": "What is the maximum overall length of the hose lay in an 'Extended Attack'?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the maximum overall length of the hose lay in an 'Extended Attack' should not exceed 700 feet.",
          "options": {
            "A": "500 feet",
            "B": "600 feet",
            "C": "700 feet",
            "D": "800 feet"
          }
        },
        {
          "id": "sfd_basic_skills_129_b64dcc3d",
          "question": "What is the 'Best Practice' for an 'Extended Attack' according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'Best Practice' for an 'Extended Attack' is to use the 2 \u00bd\u201d pre-connected 'Blitz line' and the 'Apartment bundle'.",
          "options": {
            "A": "Using the 2 \u00bd\u201d pre-connected 'Blitz line' and the 'Apartment bundle'",
            "B": "Using the 2 \u00bd\u201d pre-connected 'Blitz line' only",
            "C": "Using the 'Apartment bundle' only",
            "D": "Using the 2 \u00bd\u201d 'Bulk Bed' and the 'Apartment bundle'"
          }
        },
        {
          "id": "sfd_basic_skills_129_102600e9",
          "question": "What should be done if greater than 400' of hose is needed to reach the objective in an 'Extended Attack'?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that if greater than 400' of hose is needed to reach the objective, the 2 1/2\" Bulk Bed should be used instead of the 'Blitz line' for the 2 1/2\" hose.",
          "options": {
            "A": "Use the 2 1/2\" Bulk Bed instead of the 'Blitz line' for the 2 1/2\" hose",
            "B": "Use the 'Blitz line' instead of the 2 1/2\" Bulk Bed for the 2 1/2\" hose",
            "C": "Use the 'Apartment bundle' instead of the 'Blitz line' for the 2 1/2\" hose",
            "D": "Use the 'Blitz line' and the 'Apartment bundle' together for the 2 1/2\" hose"
          }
        },
        {
          "id": "sfd_basic_skills_129_e93c3b72",
          "question": "What should be done if a change is made to the length of the 'Extended Attack'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that any change to the length of the 'Extended Attack' must be verbalized via radio.",
          "options": {
            "A": "It should be written down",
            "B": "It should be verbalized via radio",
            "C": "It should be communicated through hand signals",
            "D": "It should be ignored"
          }
        },
        {
          "id": "sfd_basic_skills_168_97f029d1",
          "question": "What is the correct positioning for securing the hose using the alternative method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The correct positioning for securing the hose using the alternative method is to stand behind the hydrant, establish positive visual contact with the driver and signal the driver to proceed to the hydrant.",
          "options": {
            "A": "Stand in front of the hydrant, establish positive visual contact with the driver and signal the driver to proceed to the hydrant.",
            "B": "Stand behind the hydrant, establish positive visual contact with the driver and signal the driver to proceed to the hydrant.",
            "C": "Stand beside the hydrant, establish positive visual contact with the driver and signal the driver to proceed to the hydrant.",
            "D": "Stand on top of the hydrant, establish positive visual contact with the driver and signal the driver to proceed to the hydrant."
          }
        },
        {
          "id": "sfd_basic_skills_168_1ab7bf45",
          "question": "When should the body loop be removed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The body loop must not be removed until the engine has stopped at the fire.",
          "options": {
            "A": "Before the engine has stopped at the fire.",
            "B": "After the engine has stopped at the fire.",
            "C": "While the engine is making the lay.",
            "D": "The body loop should not be removed."
          }
        },
        {
          "id": "sfd_basic_skills_168_622d321f",
          "question": "What should be done if the position #4 firefighter\u2019s vision is obstructed?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the position #4 firefighter\u2019s vision is obstructed, use the radio to confirm the hose has been clamped.",
          "options": {
            "A": "Use the radio to confirm the hose has been clamped.",
            "B": "Move to a position where vision is not obstructed.",
            "C": "Ask another firefighter to confirm the hose has been clamped.",
            "D": "Continue with the operation without confirming the hose has been clamped."
          }
        },
        {
          "id": "sfd_basic_skills_168_9a3f73fe",
          "question": "What should be done to avoid a severe kink as the hose is filled?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "To avoid a severe kink as the hose is filled, ensure that the body loop is removed from the hydrant before the line is charged.",
          "options": {
            "A": "Ensure that the body loop is removed from the hydrant before the line is charged.",
            "B": "Ensure that the body loop is attached to the hydrant before the line is charged.",
            "C": "Ensure that the body loop is tightened on the hydrant before the line is charged.",
            "D": "Ensure that the body loop is loosened on the hydrant before the line is charged."
          }
        },
        {
          "id": "sfd_basic_skills_168_1f5840cf",
          "question": "What should be done if the other members of the company have not yet entered the fire building?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the other members of the company have not yet entered the fire building, procure appropriate tools and assist in stretching the attack line.",
          "options": {
            "A": "Procure appropriate tools and assist in stretching the attack line.",
            "B": "Wait for the other members to enter the building before procuring appropriate tools.",
            "C": "Enter the building without procuring appropriate tools.",
            "D": "Report to the incident command for other instructions."
          }
        },
        {
          "id": "sfd_basic_skills_169_8cd5a31c",
          "question": "What is the primary purpose of the Blind Alley Lay in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Blind Alley Lay is a split lay that is used when a forward lay is required down an alley, private drive, or other limited access road. It facilitates water supply in such areas.",
          "options": {
            "A": "To provide a path for firefighters to escape",
            "B": "To facilitate water supply in areas with limited access",
            "C": "To create a barrier between the fire and surrounding structures",
            "D": "To create a diversion for the fire"
          }
        },
        {
          "id": "sfd_basic_skills_169_34c3f8c8",
          "question": "What is the role of the first engine in a Blind Alley Lay operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first engine's role in a Blind Alley Lay operation is to drop the tri-gate at the entrance of the alley or private drive and perform the first half of the split lay.",
          "options": {
            "A": "To extinguish the fire",
            "B": "To evacuate the residents",
            "C": "To perform the first half of the split lay",
            "D": "To create a barrier between the fire and the second engine"
          }
        },
        {
          "id": "sfd_basic_skills_169_fa7ee2d8",
          "question": "What is the purpose of securing the LDH to a substantial object during a Blind Alley Lay operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The LDH is secured to a substantial object with a body loop so that a member is not required to foot the tri-gate.",
          "options": {
            "A": "To prevent the LDH from catching fire",
            "B": "To ensure the LDH does not obstruct the path of firefighters",
            "C": "To eliminate the need for a member to foot the tri-gate",
            "D": "To use it as a guide for the second engine"
          }
        },
        {
          "id": "sfd_basic_skills_169_e78c6ecf",
          "question": "What type of areas is the Blind Alley Lay typically used?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Blind Alley Lay is typically used in areas with limited access such as alleys, private drives, or other limited access roads.",
          "options": {
            "A": "In wide, open areas",
            "B": "In areas with multiple fire hydrants",
            "C": "In areas with limited access such as alleys or private drives",
            "D": "In areas with a large number of structures"
          }
        },
        {
          "id": "sfd_basic_skills_169_3a4a1430",
          "question": "What is the first action taken by the first engine in a Blind Alley Lay operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first action taken by the first engine in a Blind Alley Lay operation is to drop the tri-gate at the entrance of the alley or private drive.",
          "options": {
            "A": "Securing the LDH to a substantial object",
            "B": "Dropping the tri-gate at the entrance of the alley or private drive",
            "C": "Extinguishing the fire",
            "D": "Evacuating the residents"
          }
        },
        {
          "id": "sfd_basic_skills_128_8896d6d9",
          "question": "What is the role of position #4 firefighter during a fire attack according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, the position #4 firefighter assists in advancing and operating the hose line, among other tasks.",
          "options": {
            "A": "To lead the fire attack",
            "B": "To operate the fire engine",
            "C": "To assist in advancing and operating the hose line",
            "D": "To coordinate with other fire departments"
          }
        },
        {
          "id": "sfd_basic_skills_128_4829a245",
          "question": "What is the purpose of the back-up member joining the first member?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that when the back-up member joins the first member, they advance the attack line into a position to begin the fire attack.",
          "options": {
            "A": "To assist in stretching the second section of the blitz line",
            "B": "To advance the attack line into a position to begin the fire attack",
            "C": "To provide first aid",
            "D": "To coordinate with the fire department"
          }
        },
        {
          "id": "sfd_basic_skills_128_85639fc7",
          "question": "What is the role of the SCBA during a fire attack?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "According to the text, the SCBA is used to cover the firefighter.",
          "options": {
            "A": "To provide oxygen to the firefighters",
            "B": "To assist in advancing and operating the hose line",
            "C": "To provide forcible entry as required",
            "D": "To cover the firefighter"
          }
        },
        {
          "id": "sfd_basic_skills_128_fc1357bd",
          "question": "What is the purpose of shoulder-loading the first section of the 2 1/2\" hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text implies that shoulder-loading the first section of the hose is part of the process of advancing the attack line into a position to begin the fire attack.",
          "options": {
            "A": "To prepare for forcible entry",
            "B": "To advance the attack line into a position to begin the fire attack",
            "C": "To provide a backup line for the fire attack",
            "D": "To assist in stretching the second section of the blitz line"
          }
        },
        {
          "id": "sfd_basic_skills_128_8ec3fc21",
          "question": "What does the 'irons' refer to in the context of firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In the context of firefighting, 'irons' typically refers to tools used for forcible entry.",
          "options": {
            "A": "A type of fire extinguisher",
            "B": "Tools used for forcible entry",
            "C": "A type of fire-resistant material",
            "D": "A type of fire engine"
          }
        },
        {
          "id": "sfd_basic_skills_153_c637f36a",
          "question": "What is the first step in setting up the monitor for operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The first step mentioned in the text for setting up the monitor for operation is to connect each of the 2\u00bd\u201d lines to the monitor.",
          "options": {
            "A": "Tie a body loop around the 2\u00bd\u201d hose lines",
            "B": "Secure the monitor\u2019s anchor chain to the 2\u00bd\u201d hose lines",
            "C": "Spread out the 2\u00bd\u201d hose lines into position for monitor operation",
            "D": "Connect each of the 2\u00bd\u201d lines to the monitor"
          }
        },
        {
          "id": "sfd_basic_skills_153_60743c1c",
          "question": "Why is it important to secure the monitor\u2019s anchor chain to the 2\u00bd\u201d hose lines?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Securing the monitor\u2019s anchor chain to the 2\u00bd\u201d hose lines helps to stabilize the monitor and prevent it from moving during operation.",
          "options": {
            "A": "To ensure the monitor does not move during operation",
            "B": "To prevent the hose lines from tangling",
            "C": "To increase the water pressure",
            "D": "To extend the reach of the hose lines"
          }
        },
        {
          "id": "sfd_basic_skills_153_96672671",
          "question": "What is the purpose of tying a body loop around the 2\u00bd\u201d hose lines at the point where they cross behind the monitor?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Tying a body loop around the 2\u00bd\u201d hose lines at the point where they cross behind the monitor provides additional stability to the monitor during operation.",
          "options": {
            "A": "To increase water flow",
            "B": "To prevent the hoses from uncoupling",
            "C": "To provide additional stability to the monitor",
            "D": "To extend the reach of the hose lines"
          }
        },
        {
          "id": "sfd_basic_skills_153_7a9b74f1",
          "question": "What should be done after the connections to the monitor are made?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After the connections to the monitor are made, the next step is to spread out the 2\u00bd\u201d hose lines into position for monitor operation.",
          "options": {
            "A": "Start the monitor operation",
            "B": "Spread out the 2\u00bd\u201d hose lines into position for monitor operation",
            "C": "Disconnect the 2\u00bd\u201d lines from the monitor",
            "D": "Tie a body loop around the 2\u00bd\u201d hose lines"
          }
        },
        {
          "id": "sfd_basic_skills_153_c5e35b38",
          "question": "What is the final step in preparing the monitor for operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The final step in preparing the monitor for operation is to tie a body loop around the 2\u00bd\u201d hose lines at the point where they cross behind the monitor.",
          "options": {
            "A": "Secure the monitor\u2019s anchor chain to the 2\u00bd\u201d hose lines",
            "B": "Connect each of the 2\u00bd\u201d lines to the monitor",
            "C": "Spread out the 2\u00bd\u201d hose lines into position for monitor operation",
            "D": "Tie a body loop around the 2\u00bd\u201d hose lines at the point where they cross behind the monitor"
          }
        },
        {
          "id": "sfd_basic_skills_145_119467e5",
          "question": "What is the recommended procedure if the tri-gate must be positioned at some distance from the engine?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the tri-gate must be positioned at some distance from the engine, two members should be used to overhaul it and stretch sufficient LDH hose.",
          "options": {
            "A": "One member should be used to overhaul it and stretch sufficient LDH hose",
            "B": "Two members should be used to overhaul it and stretch sufficient LDH hose",
            "C": "Three members should be used to overhaul it and stretch sufficient LDH hose",
            "D": "Four members should be used to overhaul it and stretch sufficient LDH hose"
          }
        },
        {
          "id": "sfd_basic_skills_145_373f152d",
          "question": "Where should the member footing the tri-gate or LDH be positioned?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The member footing the tri-gate or LDH should be positioned on the fire side, in a location clearly visible to the driver in the rear view mirror.",
          "options": {
            "A": "On the fire side, in a location clearly visible to the driver in the rear view mirror",
            "B": "On the water side, in a location clearly visible to the driver in the rear view mirror",
            "C": "On the fire side, in a location not visible to the driver in the rear view mirror",
            "D": "On the water side, in a location not visible to the driver in the rear view mirror"
          }
        },
        {
          "id": "sfd_basic_skills_145_842ccdc1",
          "question": "What should be done before sending the engine to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Before sending the engine to the hydrant, the designated person, usually the Officer, should kneel behind the tri-gate, hang onto the straps or gate valve handles, and brace one foot against the tri-gate.",
          "options": {
            "A": "Release the straps",
            "B": "Remove your hands from the handles",
            "C": "Kneel behind the tri-gate, hang onto the straps or gate valve handles, and brace one foot against the tri-gate",
            "D": "Stand behind the tri-gate, hang onto the straps or gate valve handles, and brace one foot against the tri-gate"
          }
        },
        {
          "id": "sfd_basic_skills_145_e25647d5",
          "question": "When should the straps be released or hands be removed from the handles?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The straps should not be released, or hands removed from the handles, until the engine is at least 150 feet from the tri-gate.",
          "options": {
            "A": "When the engine is at least 50 feet from the tri-gate",
            "B": "When the engine is at least 100 feet from the tri-gate",
            "C": "When the engine is at least 150 feet from the tri-gate",
            "D": "When the engine is at least 200 feet from the tri-gate"
          }
        },
        {
          "id": "sfd_basic_skills_145_1b8d77e3",
          "question": "What should be done to ensure the safety of members during the LDH lay?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "For safety, members should not be between the LDH hose and/or tri-gate while the engine is moving.",
          "options": {
            "A": "Members should be between the LDH hose and/or tri-gate while the engine is moving",
            "B": "Members should not be between the LDH hose and/or tri-gate while the engine is moving",
            "C": "Members should be on top of the LDH hose and/or tri-gate while the engine is moving",
            "D": "Members should be under the LDH hose and/or tri-gate while the engine is moving"
          }
        },
        {
          "id": "sfd_basic_skills_165_87a1280d",
          "question": "What is the correct direction to face when applying the hose clamp at a fire scene?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, it is important to face the source of the supply when applying the hose clamp, which is the hydrant in this context.",
          "options": {
            "A": "Face the direction of the fire",
            "B": "Face the direction of the engine",
            "C": "Face the direction of the hydrant",
            "D": "Face the direction of the wind"
          }
        },
        {
          "id": "sfd_basic_skills_165_f3c15ab0",
          "question": "What is the minimum distance the clamp must be placed from the tailboard of the engine?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the clamp must be placed a minimum of 20 feet from the tailboard of the engine.",
          "options": {
            "A": "3 feet",
            "B": "20 feet",
            "C": "10 feet",
            "D": "30 feet"
          }
        },
        {
          "id": "sfd_basic_skills_165_61e84f1c",
          "question": "What is the recommended procedure to minimize the tripping hazard when connecting the LDH to the desired pump intake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests placing the female end under the tailboard to minimize the tripping hazard when connecting the LDH to the desired pump intake.",
          "options": {
            "A": "Place the male end under the tailboard",
            "B": "Place the female end under the tailboard",
            "C": "Place the hose clamp under the tailboard",
            "D": "Place the wheel blocks under the tailboard"
          }
        },
        {
          "id": "sfd_basic_skills_165_96c123b0",
          "question": "What is the first step to take after positioning the engine at the fire scene as directed by the company Officer?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step after positioning the engine at the fire scene is to perform the in-cab procedures to place the engine into pump.",
          "options": {
            "A": "Exit the cab and place the wheel blocks",
            "B": "Perform the in-cab procedures to place the engine into pump",
            "C": "Procure a hose clamp and immediately place it on the LDH",
            "D": "Return to the engine and begin the procedures necessary to charge the appropriate attack line"
          }
        },
        {
          "id": "sfd_basic_skills_165_5ba0c945",
          "question": "What is the correct procedure to follow after connecting the LDH to the desired pump intake?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After connecting the LDH to the desired pump intake, the correct procedure is to open the intake valve, return to the hose clamp, face the engine (the direction of water flow), and open the clamp.",
          "options": {
            "A": "Return to the hose clamp, face the engine, and open the clamp",
            "B": "Return to the engine and begin the procedures necessary to charge the appropriate attack line",
            "C": "Open the intake valve and return to the engine",
            "D": "Return to the engine and place the wheel blocks"
          }
        },
        {
          "id": "sfd_basic_skills_132_4f2d9abf",
          "question": "What is the role of the #3 firefighter in the absence of obstacles?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The #3 firefighter's role in the absence of obstacles is to grab the center bight of the bundle on the ground and complete the stretch themselves.",
          "options": {
            "A": "To re-shoulder-load the remainder of the 1\u00be\u201d hose",
            "B": "To assist in advancing and operating the hose line",
            "C": "To grab the center bight of the bundle on the ground and complete the stretch",
            "D": "To connect the bell reducer to the 2 \u00bd\u201d hose"
          }
        },
        {
          "id": "sfd_basic_skills_132_78e223e0",
          "question": "What should the #4 firefighter do if there are obstacles such as furniture or stairs?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If there are obstacles, it may be necessary for the #4 firefighter to re-shoulder-load the remainder of the 1\u00be\u201d hose.",
          "options": {
            "A": "Grab the center bight of the bundle on the ground and complete the stretch",
            "B": "Re-shoulder-load the remainder of the 1\u00be\u201d hose",
            "C": "Connect the bell reducer to the 2 \u00bd\u201d hose",
            "D": "Assist in advancing and operating the hose line"
          }
        },
        {
          "id": "sfd_basic_skills_132_5a90c56b",
          "question": "What is the primary safety equipment mentioned that should be used during hose line advancement?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The SCBA (Self Contained Breathing Apparatus) is mentioned as the primary safety equipment to be used during hose line advancement.",
          "options": {
            "A": "Firefighter helmet",
            "B": "Firefighter boots",
            "C": "SCBA",
            "D": "Firefighter gloves"
          }
        },
        {
          "id": "sfd_basic_skills_132_19c21908",
          "question": "What is the role of the #4 firefighter in the hose line operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The #4 firefighter's role is to connect the bell reducer to the 2 \u00bd\u201d hose.",
          "options": {
            "A": "To grab the center bight of the bundle on the ground and complete the stretch",
            "B": "To assist in advancing and operating the hose line",
            "C": "To re-shoulder-load the remainder of the 1\u00be\u201d hose",
            "D": "To connect the bell reducer to the 2 \u00bd\u201d hose"
          }
        },
        {
          "id": "sfd_basic_skills_132_e09c6336",
          "question": "What is the single member stretch of the apartment bundle?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The single member stretch of the apartment bundle refers to when the #3 firefighter grabs the center bight of the bundle on the ground and completes the stretch themselves.",
          "options": {
            "A": "When the #3 firefighter grabs the center bight of the bundle on the ground and completes the stretch",
            "B": "When the #4 firefighter connects the bell reducer to the 2 \u00bd\u201d hose",
            "C": "When the #4 firefighter re-shoulder-loads the remainder of the 1\u00be\u201d hose",
            "D": "When the #3 and #4 firefighters advance with the apartment bundle"
          }
        },
        {
          "id": "sfd_basic_skills_124_81f143a6",
          "question": "What is the role of the Officer during the 2\u00bd\u201d Attack Line evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Officer's role is to direct the driver where to position the engine and give verbal directions to the crew.",
          "options": {
            "A": "To position the engine",
            "B": "To break the 2\u00bd\u201d coupling that will reach the desired discharge port",
            "C": "To direct the driver where to position the engine and give verbal directions to the crew",
            "D": "To perform the in-cab procedures to place the engine into pump"
          }
        },
        {
          "id": "sfd_basic_skills_124_b7e3bf66",
          "question": "What should the Officer do if more than 200 feet of attack line will be needed to reach the objective?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If more than 200 feet of attack line will be needed, the Officer should indicate the length of the stretch to the company members.",
          "options": {
            "A": "Direct the driver to position the engine closer to the objective",
            "B": "Indicate the length of the stretch to the company members",
            "C": "Perform the in-cab procedures to place the engine into pump",
            "D": "Break the 2\u00bd\u201d coupling that will reach the desired discharge port"
          }
        },
        {
          "id": "sfd_basic_skills_124_0608905a",
          "question": "What is the role of the Driver during the 2\u00bd\u201d Attack Line evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Driver's role is to position the engine as directed by the company Officer and connect the 2\u00bd\u201d line to the appropriate discharge port.",
          "options": {
            "A": "To give verbal directions to the crew",
            "B": "To position the engine as directed by the company Officer and connect the 2\u00bd\u201d line to the appropriate discharge port",
            "C": "To sling the SCBA to the stand-by position",
            "D": "To supervise and assist the company in fire suppression and rescue activities"
          }
        },
        {
          "id": "sfd_basic_skills_124_6c716121",
          "question": "What should be done if the 2\u00bd\u201d hose needs to be extended beyond 200 feet?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If more than 200 feet of attack line will be needed, members should work together to remove additional 2\u00bd\u201d hose from the engine.",
          "options": {
            "A": "The driver should position the engine closer to the objective",
            "B": "The Officer should break the 2\u00bd\u201d coupling that will reach the desired discharge port",
            "C": "Members should work together to remove additional 2\u00bd\u201d hose from the engine",
            "D": "The SCBA should be slung to the stand-by position"
          }
        },
        {
          "id": "sfd_basic_skills_124_6a3a8d29",
          "question": "What is the first action the Driver should take after exiting the cab during the 2\u00bd\u201d Attack Line evolution?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "After exiting the cab, the Driver's first action should be to place the wheel blocks.",
          "options": {
            "A": "Go to the tailboard and break the 2\u00bd\u201d coupling",
            "B": "Connect the 2\u00bd\u201d line to the appropriate discharge port",
            "C": "Give verbal directions to the crew",
            "D": "Place the wheel blocks"
          }
        },
        {
          "id": "sfd_basic_skills_173_db22ae45",
          "question": "What is the role of the second engine company in the described firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, the second engine company's role is to lay reverse to the hydrant.",
          "options": {
            "A": "The second engine company extinguishes the fire",
            "B": "The second engine company rescues trapped individuals",
            "C": "The second engine company lays reverse to the hydrant",
            "D": "The second engine company supervises the operation"
          }
        },
        {
          "id": "sfd_basic_skills_173_2b224fda",
          "question": "What is the final result of the described operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the final result will be the second engine pumping to the first as a relay pumping evolution.",
          "options": {
            "A": "The first engine pumps to the second as a relay pumping evolution",
            "B": "The second engine pumps to the first as a relay pumping evolution",
            "C": "The first and second engines pump simultaneously",
            "D": "The second engine pumps to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_173_403bb83a",
          "question": "What is the purpose of a relay pumping evolution in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A relay pumping evolution is used in firefighting operations to increase the water supply.",
          "options": {
            "A": "To increase the water supply",
            "B": "To decrease the water supply",
            "C": "To extinguish the fire more quickly",
            "D": "To rescue trapped individuals"
          }
        },
        {
          "id": "sfd_basic_skills_173_e97ad0cf",
          "question": "What is the implication of the second engine laying reverse to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Laying reverse to the hydrant allows for a longer reach of the hose, which can be crucial in firefighting operations.",
          "options": {
            "A": "It allows for a quicker response time",
            "B": "It allows for a more efficient use of water",
            "C": "It allows for a longer reach of the hose",
            "D": "It allows for a more efficient evacuation of the building"
          }
        },
        {
          "id": "sfd_basic_skills_173_a8ba3488",
          "question": "What is the primary safety consideration in a relay pumping evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In a relay pumping evolution, the primary safety consideration is ensuring the water supply is sufficient to effectively combat the fire.",
          "options": {
            "A": "Ensuring the second engine is closer to the fire",
            "B": "Ensuring the first engine is closer to the fire",
            "C": "Ensuring the water supply is sufficient",
            "D": "Ensuring the hydrant is functioning properly"
          }
        },
        {
          "id": "sfd_basic_skills_149_1e0dc08d",
          "question": "What is the first step to take before connecting the 2\u00bd\u201d female coupling to the tri-gated wye?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Before connecting the 2\u00bd\u201d female coupling to the tri-gated wye, it is important to ensure that all equipment and hose has been removed.",
          "options": {
            "A": "Ensure all equipment and hose has been removed",
            "B": "Open the gate valve",
            "C": "Position #4 connecting the 2 \u00bd\u201d hose to the tri-gate",
            "D": "Shoulder-load the second section of the 2\u00bd\u201d hose"
          }
        },
        {
          "id": "sfd_basic_skills_149_551d1ffa",
          "question": "What is the role of the position #3 firefighter during the hose stretching process?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The position #3 firefighter's role is to stretch the hose when instructed by the other firefighter.",
          "options": {
            "A": "To connect the 2\u00bd\u201d female coupling to the tri-gated wye",
            "B": "To shoulder-load the second section of the 2\u00bd\u201d hose",
            "C": "To stretch the hose when instructed",
            "D": "To remove the 2\u00bd\u201d hose from the bulk bed"
          }
        },
        {
          "id": "sfd_basic_skills_149_71fff42e",
          "question": "What should be done before removing the final section of 2\u00bd\u201d hose from the bed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Before removing the final section of 2\u00bd\u201d hose from the bed, the appropriate coupling should be broken.",
          "options": {
            "A": "Ensure all equipment and hose has been removed",
            "B": "Break the appropriate coupling",
            "C": "Open the gate valve",
            "D": "Shoulder-load the second section of the 2\u00bd\u201d hose"
          }
        },
        {
          "id": "sfd_basic_skills_149_48f5e796",
          "question": "Where should all of the hose be placed after being removed from the bed?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After being removed from the bed, all of the hose should be placed on the fire side of the engine, in sequential order.",
          "options": {
            "A": "On the fire side of the engine, in sequential order",
            "B": "On the opposite side of the engine, in random order",
            "C": "In the bulk bed, in sequential order",
            "D": "In the hydrant, in random order"
          }
        },
        {
          "id": "sfd_basic_skills_149_905f1c29",
          "question": "What is the purpose of shoulder-loading the second section of the 2\u00bd\u201d hose?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The purpose of shoulder-loading the second section of the 2\u00bd\u201d hose is to begin stretching the hose to the location indicated by the Officer.",
          "options": {
            "A": "To connect the 2\u00bd\u201d female coupling to the tri-gated wye",
            "B": "To stretch the hose to the location indicated by the Officer",
            "C": "To remove the 2\u00bd\u201d hose from the bulk bed",
            "D": "To break the appropriate coupling"
          }
        },
        {
          "id": "sfd_basic_skills_166_0803bec2",
          "question": "What is the correct procedure when a significant kink is discovered while returning to the pump panel?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that if a significant kink is discovered while returning to the pump panel, it should be removed immediately.",
          "options": {
            "A": "Ignore it until later",
            "B": "Immediately remove it",
            "C": "Report it to the incident commander",
            "D": "Use a hose clamp to straighten it"
          }
        },
        {
          "id": "sfd_basic_skills_166_0e026864",
          "question": "What is the role of the driver upon completion of the primary supply?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon completion of the primary supply, the driver will don the SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team.",
          "options": {
            "A": "Monitor the pump panel and the radio for further instructions",
            "B": "Act as a member of the Firefighter Stand-by Rescue Team",
            "C": "Refill any water already used from the engine\u2019s booster tank",
            "D": "Position traffic cones to protect personnel, the engine, and hose lines"
          }
        },
        {
          "id": "sfd_basic_skills_166_1ad06637",
          "question": "What should be done if it's necessary to lay a second supply?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If necessary, recommend to the incident commander that a second supply be laid by another engine company.",
          "options": {
            "A": "The driver should do it",
            "B": "The incident commander should do it",
            "C": "Recommend to the incident commander that another engine company do it",
            "D": "The Firefighter Stand-by Rescue Team should do it"
          }
        },
        {
          "id": "sfd_basic_skills_166_2ee1450f",
          "question": "What should be done to prevent water hammer when opening the hose clamp?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To prevent water hammer, the clamp should be opened with slow turns.",
          "options": {
            "A": "Open the clamp with rapid turns",
            "B": "Open the clamp with slow turns",
            "C": "Use a special tool to open the clamp",
            "D": "Ask another firefighter to hold the hose steady"
          }
        },
        {
          "id": "sfd_basic_skills_166_fc60ff80",
          "question": "What should be done after positioning traffic cones?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After positioning traffic cones, any remaining kinks in the supply line should be removed.",
          "options": {
            "A": "Return to the engine\u2019s pump panel",
            "B": "Remove any remaining kinks in the supply line",
            "C": "Don the SCBA to a stand-by position",
            "D": "Open the tank-to-pump valve"
          }
        },
        {
          "id": "sfd_basic_skills_131_0bf93eb9",
          "question": "What is the correct procedure to set your discharge pressure relief valve (PRV)?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct procedure to set your discharge pressure relief valve (PRV) is to turn the PRV operating handle counter-clockwise until the valve opens, then turn it clockwise until the desired pressure is reached.",
          "options": {
            "A": "Turn the PRV operating handle clockwise until the valve opens.",
            "B": "Turn the PRV operating handle counter-clockwise until the valve closes.",
            "C": "Turn the PRV operating handle counter-clockwise until the valve opens, then turn it clockwise until the desired pressure is reached.",
            "D": "Turn the PRV operating handle clockwise until the valve closes, then turn it counter-clockwise until the desired pressure is reached."
          }
        },
        {
          "id": "sfd_basic_skills_131_d009634a",
          "question": "What is the role of the position #3 firefighter during hose deployment?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The role of the position #3 firefighter during hose deployment is to shoulder-load the first section of the 1\u00be\u201d apartment bundle and wait for instructions from the position #4 firefighter.",
          "options": {
            "A": "Shoulder-load the first section of the 1\u00be\u201d apartment bundle and wait for instructions from the position #4 firefighter.",
            "B": "Attach the bell reducer to the 2\u00bd\u201d line.",
            "C": "Procure the irons and place them next to the tailboard.",
            "D": "Call for water from the driver when the stretch is completed."
          }
        },
        {
          "id": "sfd_basic_skills_131_5e9f51d7",
          "question": "What is the role of the position #4 firefighter during hose deployment?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The role of the position #4 firefighter during hose deployment is to attach the bell reducer to the 2\u00bd\u201d line and begin the stretch of the dry 1 \u00be\u201d hose to the desired location.",
          "options": {
            "A": "Shoulder-load the first section of the 1\u00be\u201d apartment bundle and wait for instructions from the position #3 firefighter.",
            "B": "Attach the bell reducer to the 2\u00bd\u201d line and begin the stretch of the dry 1 \u00be\u201d hose to the desired location.",
            "C": "Procure the irons and place them next to the tailboard.",
            "D": "Call for water from the driver when the stretch is not completed."
          }
        },
        {
          "id": "sfd_basic_skills_131_c62c86c2",
          "question": "What should be done before advancing the attack line into a position to begin fire attack?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Before advancing the attack line into a position to begin fire attack, you should bleed the air from the charged hose line, assess the fire stream for an appropriate volume of water flow and check the fire stream for the appropriate pattern.",
          "options": {
            "A": "Bleed the air from the charged hose line, assess the fire stream for an appropriate volume of water flow and check the fire stream for the appropriate pattern.",
            "B": "Call for water from the driver when the stretch is completed.",
            "C": "Procure the irons and place them next to the tailboard.",
            "D": "Shoulder-load the first section of the 1\u00be\u201d apartment bundle and wait for instructions from the position #4 firefighter."
          }
        },
        {
          "id": "sfd_basic_skills_131_5d88626d",
          "question": "What should the position #4 firefighter do once the stretch of the dry 1 \u00be\u201d hose to the desired location is completed?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Once the stretch of the dry 1 \u00be\u201d hose to the desired location is completed, the position #4 firefighter should call for water from the driver.",
          "options": {
            "A": "Call for water from the driver.",
            "B": "Attach the bell reducer to the 2\u00bd\u201d line.",
            "C": "Shoulder-load the first section of the 1\u00be\u201d apartment bundle.",
            "D": "Bleed the air from the charged hose line."
          }
        },
        {
          "id": "sfd_basic_skills_127_081ea51b",
          "question": "What is the correct procedure for setting the discharge pressure relief valve (PRV)?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct procedure for setting the discharge pressure relief valve (PRV) is to turn the PRV operating handle counter-clockwise until the valve opens, then turn it clockwise until the desired pressure is achieved.",
          "options": {
            "A": "Turn the PRV operating handle clockwise until the valve opens.",
            "B": "Turn the PRV operating handle counter-clockwise until the valve closes.",
            "C": "Turn the PRV operating handle counter-clockwise until the valve opens, then turn it clockwise until the desired pressure is achieved.",
            "D": "Turn the PRV operating handle clockwise until the valve closes, then turn it counter-clockwise until the desired pressure is achieved."
          }
        },
        {
          "id": "sfd_basic_skills_127_371ebf96",
          "question": "What is the maximum pressure to charge the attack line with before the hose is full of water?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The maximum pressure to charge the attack line with before the hose is full of water is 75 PSI. Charging with a pressure greater than this can damage the inner lining of the hose.",
          "options": {
            "A": "50 PSI",
            "B": "75 PSI",
            "C": "100 PSI",
            "D": "125 PSI"
          }
        },
        {
          "id": "sfd_basic_skills_127_aa26aa14",
          "question": "What should the firefighter do after the hose line is fully charged?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Once the hose line is fully charged, the firefighter should increase the discharge pressure to the desired setting.",
          "options": {
            "A": "Increase the discharge pressure to the desired setting.",
            "B": "Decrease the discharge pressure to the desired setting.",
            "C": "Maintain the current discharge pressure.",
            "D": "Turn off the discharge pressure."
          }
        },
        {
          "id": "sfd_basic_skills_127_af5d0937",
          "question": "What is the role of the Officer in the firefighting operations as outlined in the POG?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The role of the Officer in the firefighting operations as outlined in the POG is to direct the driver where to position the engine and give verbal directions to the crew.",
          "options": {
            "A": "To perform the in-cab procedures to place the engine into pump.",
            "B": "To direct the driver where to position the engine and give verbal directions to the crew.",
            "C": "To shoulder-load the first 100-foot section of the 2\u00bd\u201d pre-connect line.",
            "D": "To open the tank-to-pump valve, and increase engine speed to 800-1000 RPMs."
          }
        },
        {
          "id": "sfd_basic_skills_127_2d8d9eb3",
          "question": "What should Position #3 Firefighter do with the first section of the hose until all of the second section has been stretched out?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Position #3 Firefighter should not drop any portion of the first section of the hose until all of the second section has been stretched out.",
          "options": {
            "A": "Drop it",
            "B": "Coil or flake it",
            "C": "Do not drop any portion of it",
            "D": "Stretch it to the location designated by the Officer"
          }
        },
        {
          "id": "sfd_basic_skills_170_37dc2099",
          "question": "What is the first action the driver of the 1st engine should take upon arriving at the fire location?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon arriving at the fire location, the driver of the 1st engine should first sound a single horn honk to signal to the position #4 firefighter that it is safe to exit the engine.",
          "options": {
            "A": "Exit the cab and place the wheel blocks",
            "B": "Sound a single horn honk",
            "C": "Begin the procedures necessary to charge the appropriate attack line",
            "D": "Don the SCBA"
          }
        },
        {
          "id": "sfd_basic_skills_170_b3867f43",
          "question": "Where should the hose clamp be placed on the LDH?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hose clamp should be placed a minimum of 20 feet from the tailboard of the engine, and not less than 3 feet from any coupling.",
          "options": {
            "A": "At the tailboard of the engine",
            "B": "At least 20 feet from the tailboard of the engine and not less than 3 feet from any coupling",
            "C": "At the source of the supply",
            "D": "At the pump intake"
          }
        },
        {
          "id": "sfd_basic_skills_170_d2bfe154",
          "question": "What is the role of the Officer of the 1st engine at the fire scene?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "At the fire scene, the Officer of the 1st engine is responsible for indicating to the #3 and #4 firefighters the fire attack to perform.",
          "options": {
            "A": "To perform the in-cab procedures to place the engine into pump",
            "B": "To indicate to the #3 and #4 firefighters the fire attack to perform",
            "C": "To return to the engine and begin the procedures necessary to charge the appropriate attack line",
            "D": "To sound a single horn honk"
          }
        },
        {
          "id": "sfd_basic_skills_170_8dfbfc87",
          "question": "What is the second engine's primary responsibility upon arrival at the fire location?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The second engine to arrive will basically perform a Reverse Lay evolution from the location of the tri-gate initially dropped by the first engine.",
          "options": {
            "A": "To perform a Reverse Lay evolution",
            "B": "To charge the appropriate attack line",
            "C": "To place a hose clamp on the LDH",
            "D": "To sound a single horn honk"
          }
        },
        {
          "id": "sfd_basic_skills_170_e086d9d7",
          "question": "What is the direction given to the crew when a fire is in a location away from the main roadway and a narrow alley or access road must be used?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the fire is in a location away from the main roadway and a narrow alley or access road must be used, the crew is directed to perform a 'Blind Alley Lay - Dry'.",
          "options": {
            "A": "Blind Alley Lay - Dry",
            "B": "Reverse Lay evolution",
            "C": "Forward Lay evolution",
            "D": "Blind Alley Lay - Wet"
          }
        },
        {
          "id": "sfd_basic_skills_150_6c470e4b",
          "question": "What is the first step in the Monitor Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in the Monitor Manifold evolution is to remove the necessary equipment from the engine.",
          "options": {
            "A": "Perform a Reverse Lay to the hydrant",
            "B": "Remove 200 feet of 2\u00bd\u201d hose, 200 feet of 1\u00be\u201d hose, the tri-gate with LDH attached, a portable monitor appliance with base, and appropriate tools from the engine",
            "C": "Attach the monitor to the base and position it at the desired place of operation",
            "D": "Remove the Officer\u2019s SCBA and appropriate tools from the engine"
          }
        },
        {
          "id": "sfd_basic_skills_150_95a22cbc",
          "question": "What should the officer do if the monitor will be put into operation in a location away from where the engine was able to stop?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the monitor will be put into operation in a location away from where the engine was able to stop, the officer should ensure sufficient LDH is removed from the engine prior to the reverse lay begins.",
          "options": {
            "A": "Ensure sufficient LDH is removed from the engine prior to the reverse lay begins",
            "B": "Direct the driver where to position the engine",
            "C": "Attach the monitor to the base and position it at the desired place of operation",
            "D": "Perform a Reverse Lay to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_150_80d9f8d7",
          "question": "What is the role of the officer in the Monitor Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The officer's role is to direct the driver where to position the engine and give verbal directions to the crew.",
          "options": {
            "A": "To perform a Reverse Lay to the hydrant",
            "B": "To attach the monitor to the base and position it at the desired place of operation",
            "C": "To direct the driver where to position the engine and give verbal directions to the crew",
            "D": "To remove the tri-gated wye, with LDH attached, and position it between the unloaded hose and the engine"
          }
        },
        {
          "id": "sfd_basic_skills_150_b5b8d4ba",
          "question": "What should be done with the monitor and the monitor base during the Monitor Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The monitor and the monitor base should be attached and positioned at the desired place of operation.",
          "options": {
            "A": "They should be left on the engine",
            "B": "They should be attached and positioned at the desired place of operation",
            "C": "They should be removed from the engine and placed on the ground",
            "D": "They should be attached to the tri-gated wye"
          }
        },
        {
          "id": "sfd_basic_skills_150_636b3fc9",
          "question": "What is the purpose of the Reverse Lay in the Monitor Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The purpose of the Reverse Lay is to connect the engine to the hydrant.",
          "options": {
            "A": "To ensure sufficient LDH is removed from the engine",
            "B": "To connect the engine to the hydrant",
            "C": "To position the engine at the desired place of operation",
            "D": "To remove the Officer\u2019s SCBA and appropriate tools from the engine"
          }
        },
        {
          "id": "sfd_basic_skills_146_ee0cf318",
          "question": "What is the role of the officer during the 2\u00bd\u201d Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The officer has multiple roles including giving verbal directions, removing the tri-gated wye, and supervising fire suppression activities.",
          "options": {
            "A": "The officer only directs the driver where to position the engine",
            "B": "The officer only removes the tri-gated wye with LDH attached",
            "C": "The officer gives verbal directions, removes the tri-gated wye, and supervises fire suppression activities",
            "D": "The officer only supervises fire suppression activities"
          }
        },
        {
          "id": "sfd_basic_skills_146_5be6011b",
          "question": "What is the purpose of the tri-gate in the 2\u00bd\u201d Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The tri-gate is used to control the flow of water during the firefighting operation.",
          "options": {
            "A": "To connect the hose to the engine",
            "B": "To connect the hose to the hydrant",
            "C": "To control the flow of water",
            "D": "To connect the hose to the SCBA"
          }
        },
        {
          "id": "sfd_basic_skills_146_3aa56b6a",
          "question": "What is the role of the Firefighter Stand-by Rescue Team during the 2\u00bd\u201d Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Firefighter Stand-by Rescue Team is responsible for slinging the SCBA to the stand-by position.",
          "options": {
            "A": "To attach the 2\u00bd\u201d hose to the tri-gate",
            "B": "To foot the tri-gate until the engine is at least 150 feet away",
            "C": "To sling the SCBA to the stand-by position",
            "D": "To open the appropriate valve of the tri-gate at the call for water"
          }
        },
        {
          "id": "sfd_basic_skills_146_44eced5a",
          "question": "When is it safe to attach the 2\u00bd\u201d hose to the tri-gate during the 2\u00bd\u201d Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 2\u00bd\u201d hose can be attached to the tri-gate when the engine is at least 150 feet away.",
          "options": {
            "A": "When the engine is at least 150 feet away",
            "B": "When the officer gives the signal",
            "C": "When the tri-gate is footed",
            "D": "When the officer opens the gate at the call for water"
          }
        },
        {
          "id": "sfd_basic_skills_146_8aa40845",
          "question": "Who may be assigned the removal and footing of the tri-gate during the 2\u00bd\u201d Manifold evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The removal and footing of the tri-gate may be assigned to the position #4 firefighter if the Officer has command duties to attend to.",
          "options": {
            "A": "The driver",
            "B": "The officer",
            "C": "The position #4 firefighter",
            "D": "The Firefighter Stand-by Rescue Team"
          }
        },
        {
          "id": "sfd_basic_skills_147_a41afaf8",
          "question": "What is the role of Position #3 firefighter in the Reverse Pump Hook-up?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, the Position #3 firefighter is responsible for removing the first section of 2\u00bd\u201d hose from the bulk bed and assisting other members in removing the appropriate hose and equipment.",
          "options": {
            "A": "To give the order to stretch",
            "B": "To assist other members in removing the appropriate hose and equipment",
            "C": "To drive the fire engine",
            "D": "To flake the hose from the shoulder-load"
          }
        },
        {
          "id": "sfd_basic_skills_147_da2cb9fe",
          "question": "When is the hose allowed to flake from the shoulder-load?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the hose should not flake from the shoulder-load until the Position #4 firefighter gives the order to stretch.",
          "options": {
            "A": "When the Position #3 firefighter gives the order",
            "B": "When the hose is fully stretched",
            "C": "When the Position #4 firefighter gives the order to stretch",
            "D": "There is no specific order to flake the hose"
          }
        },
        {
          "id": "sfd_basic_skills_147_90d7beaa",
          "question": "What is the length of the hose that a single member is stretching?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions a single member stretching 200 feet of 2 \u00bd\u201d hose.",
          "options": {
            "A": "100 feet",
            "B": "150 feet",
            "C": "200 feet",
            "D": "250 feet"
          }
        },
        {
          "id": "sfd_basic_skills_147_a1c01d1e",
          "question": "Where should the first section of 2\u00bd\u201d hose from the bulk bed be placed?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, the first section of 2\u00bd\u201d hose from the bulk bed should be placed on the ground and to the fire side of the engine.",
          "options": {
            "A": "On the fire side of the engine",
            "B": "On the water side of the engine",
            "C": "Inside the engine",
            "D": "On the roof of the engine"
          }
        },
        {
          "id": "sfd_basic_skills_147_1325ef1f",
          "question": "Who is responsible for the Reverse Pump Hook-up?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions the Seattle Fire Department Driver in relation to the instructions for the Reverse Pump Hook-up.",
          "options": {
            "A": "Seattle Fire Department Driver",
            "B": "Position #3 Firefighter",
            "C": "Position #4 Firefighter",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_151_90226ab7",
          "question": "What is the role of the officer in the operation of the tri-gate?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, the officer's role includes ensuring that all needed equipment and hose has been removed and possibly removing the tri-gate and its footing if they have command duties to attend to.",
          "options": {
            "A": "The officer is responsible for driving the engine to the hydrant.",
            "B": "The officer is responsible for removing the tri-gate and its footing.",
            "C": "The officer is responsible for ensuring all needed equipment and hose has been removed.",
            "D": "The officer is responsible for honking the engine\u2019s horn."
          }
        },
        {
          "id": "sfd_basic_skills_151_91ab3672",
          "question": "What should the driver do after positioning the engine where the Officer instructs?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The driver should honk the engine\u2019s horn once to signal to the members that it is safe to exit the cab, set the parking brake, then exit the engine and set the wheel blocks.",
          "options": {
            "A": "Exit the engine and set the wheel blocks.",
            "B": "Honk the engine\u2019s horn twice.",
            "C": "Remove the tri-gate and its footing.",
            "D": "Ensure all three tri-gate valves are closed."
          }
        },
        {
          "id": "sfd_basic_skills_151_d4b33217",
          "question": "What should be communicated to the driver regarding the monitor operation?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The driver needs to know which monitor tip is in use so they can correctly account for friction loss in the hose lay.",
          "options": {
            "A": "Which monitor tip is in use.",
            "B": "The location of the fire.",
            "C": "The number of firefighters on duty.",
            "D": "The type of fire extinguisher to use."
          }
        },
        {
          "id": "sfd_basic_skills_151_71403dc6",
          "question": "What is the role of Position #3 Firefighter in the operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Position #3 Firefighter's role is to procure the monitor and its base from the engine, and assist the #4 firefighter in removing 2\u00bd\u201d hose from the bulk bed or removing the apartment bundle, as needed.",
          "options": {
            "A": "To drive the engine to the hydrant.",
            "B": "To ensure all three tri-gate valves are closed.",
            "C": "To procure the monitor and its base from the engine.",
            "D": "To honk the engine\u2019s horn."
          }
        },
        {
          "id": "sfd_basic_skills_151_9e73d481",
          "question": "What is the significance of the driver knowing which monitor tip is in use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Knowing which monitor tip is in use allows the driver to correctly account for friction loss in the hose lay, which is crucial for effective firefighting operations.",
          "options": {
            "A": "To determine the type of fire extinguisher to use.",
            "B": "To correctly account for friction loss in the hose lay.",
            "C": "To decide the position of the engine.",
            "D": "To determine the number of firefighters needed."
          }
        },
        {
          "id": "sfd_basic_skills_171_34c04cc1",
          "question": "What is the correct procedure for opening a hose clamp according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct procedure is to make the first one to two turns in a rapid manner, then continue to open the clamp with slow turns to prevent water hammer.",
          "options": {
            "A": "Open the clamp with rapid turns to prevent water hammer.",
            "B": "Open the clamp with slow turns from the start.",
            "C": "Make the first one to two turns in a rapid manner, then continue to open the clamp with slow turns.",
            "D": "Open the clamp with slow turns, then finish with rapid turns."
          }
        },
        {
          "id": "sfd_basic_skills_171_ddcc0c98",
          "question": "What should be done if a significant kink is discovered while returning to the pump panel?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If a significant kink is discovered while returning to the pump panel, it should be removed immediately.",
          "options": {
            "A": "Ignore it and continue to the pump panel.",
            "B": "Remove it immediately.",
            "C": "Report it to the incident commander.",
            "D": "Wait for it to be addressed at a later point."
          }
        },
        {
          "id": "sfd_basic_skills_171_0e026864",
          "question": "What is the role of the driver upon completion of the primary supply?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Upon completion of the primary supply, the driver will don the SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team.",
          "options": {
            "A": "The driver should refill any water already used from the engine\u2019s booster tank.",
            "B": "The driver should don the SCBA to a stand-by position and act as a member of the Firefighter Stand-by Rescue Team.",
            "C": "The driver should position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles.",
            "D": "The driver should monitor the pump panel and the radio for further instructions."
          }
        },
        {
          "id": "sfd_basic_skills_171_5fe7ab4c",
          "question": "What should be done with the female end of the LDH after breaking the connection?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After breaking the connection, the female end of the LDH should be placed under the tailboard to minimize the tripping hazard.",
          "options": {
            "A": "Connect it to the desired pump intake.",
            "B": "Place it under the tailboard to minimize the tripping hazard.",
            "C": "Return it to the engine.",
            "D": "Secure it to a substantial object with a body loop."
          }
        },
        {
          "id": "sfd_basic_skills_171_21955a5c",
          "question": "What should be done if kinks are present but it remains evident that water is entering the intake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If kinks are present but it remains evident that water is entering the intake, they should be disregarded at this time. Such kinks will be addressed at a later point.",
          "options": {
            "A": "Remove them immediately.",
            "B": "Disregard them at this time.",
            "C": "Report them to the incident commander.",
            "D": "Secure them to a substantial object with a body loop."
          }
        },
        {
          "id": "sfd_basic_skills_126_1a173520",
          "question": "What is the role of the Position #3 firefighter in the hose deployment procedure?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Position #3 firefighter is responsible for shouldering the first length of 2 \u00bd\u201d hose and waiting for Position #4 to shoulder-load their section of the hose.",
          "options": {
            "A": "Shoulder-load the first 100-foot section of hose and wait for Position #4 to load theirs",
            "B": "Provide forcible entry as required",
            "C": "Assist in advancing and operating the hose line",
            "D": "Procure the irons and place them next to the tailboard"
          }
        },
        {
          "id": "sfd_basic_skills_126_2010fa5c",
          "question": "What is the importance of Position #4 firefighter stretching their hose completely off their shoulder before Position #3 does the same?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The sequence is important to maintain coordination and efficiency during hose deployment.",
          "options": {
            "A": "To ensure that the hose is properly connected to the engine",
            "B": "To prevent tangling of the hoses",
            "C": "To ensure the desired discharge can be reached",
            "D": "To maintain proper sequence and coordination during hose deployment"
          }
        },
        {
          "id": "sfd_basic_skills_126_ec532285",
          "question": "What is the purpose of dropping additional hose (1 or 2 flakes) near the tailboard?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Dropping additional hose near the tailboard ensures that the desired discharge can be reached.",
          "options": {
            "A": "To provide extra hose for forcible entry",
            "B": "To ensure the desired discharge can be reached",
            "C": "To allow for easier shoulder-loading of the hose",
            "D": "To create a backup supply of hose"
          }
        },
        {
          "id": "sfd_basic_skills_126_1e176174",
          "question": "What is the result of the 2\u00bd\u201d Blitz Line evolution?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 2\u00bd\u201d Blitz Line evolution results in the deployment of a 200 foot 2\u00bd\u201d hose bundle that is already connected to the engine.",
          "options": {
            "A": "Deployment of a 200 foot 2\u00bd\u201d hose bundle already connected to the engine",
            "B": "Deployment of a 100 foot 2\u00bd\u201d hose bundle already connected to the engine",
            "C": "Deployment of a 200 foot 2\u00bd\u201d hose bundle that needs to be connected to the engine",
            "D": "Deployment of a 100 foot 2\u00bd\u201d hose bundle that needs to be connected to the engine"
          }
        },
        {
          "id": "sfd_basic_skills_126_20fb64e0",
          "question": "What is the role of the Position #4 firefighter after shoulder-loading the second 100-foot section of hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After shoulder-loading the second section of the hose, the Position #4 firefighter picks up the irons and begins to stretch the line to the desired location. They also provide forcible entry as required.",
          "options": {
            "A": "Provide forcible entry as required",
            "B": "Assist in advancing and operating the hose line",
            "C": "Wait for Position #3 to shoulder-load their section of the hose",
            "D": "Disconnect the hose from the engine"
          }
        },
        {
          "id": "sfd_basic_skills_130_8879771e",
          "question": "What is the correct procedure for preparing the pump for water discharge?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The correct procedure is to increase engine speed to 800-1000 RPMs, open the tank-to-pump valve, prime the pump, and then increase the throttle to bring the discharge pressure between 50-75 PSI.",
          "options": {
            "A": "Increase engine speed to 800-1000 RPMs, open the tank-to-pump valve, prime the pump, increase the throttle to bring the discharge pressure between 50-75 PSI.",
            "B": "Open the tank-to-pump valve, increase engine speed to 800-1000 RPMs, prime the pump, increase the throttle to bring the discharge pressure between 50-75 PSI.",
            "C": "Prime the pump, increase engine speed to 800-1000 RPMs, open the tank-to-pump valve, increase the throttle to bring the discharge pressure between 50-75 PSI.",
            "D": "Increase engine speed to 800-1000 RPMs, prime the pump, open the tank-to-pump valve, increase the throttle to bring the discharge pressure between 50-75 PSI."
          }
        },
        {
          "id": "sfd_basic_skills_130_9fc02ef6",
          "question": "What could be a dangerous condition during the extended lay operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Sending water to the firefighting team before they are ready can create a dangerous condition.",
          "options": {
            "A": "If the discharge pressure is below 50 PSI.",
            "B": "If water is sent to the firefighting team before they are ready.",
            "C": "If the nozzle is not removed from the 2 \u00bd\u201d hose.",
            "D": "If the engine speed is above 1000 RPMs."
          }
        },
        {
          "id": "sfd_basic_skills_130_1a04bf2a",
          "question": "What should be avoided to prevent damaging the inner lining of the hose?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Charging the attack line with a pressure of greater than 75 PSI before the hose is full of water can damage the inner lining of the hose.",
          "options": {
            "A": "Charging the attack line with a pressure of greater than 75 PSI before the hose is full of water.",
            "B": "Increasing the engine speed to 800-1000 RPMs.",
            "C": "Removing the nozzle from the 2 \u00bd\u201d hose.",
            "D": "Maintaining 50-75 PSI while the hose is being filled."
          }
        },
        {
          "id": "sfd_basic_skills_130_b672ac5f",
          "question": "What should be replaced by the 2 \u00bd\u201d to 1 \u00bd\u201d bell reducer during an extended lay operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During an extended lay operation, the nozzle of the 2 \u00bd\u201d hose should be replaced by the 2 \u00bd\u201d to 1 \u00bd\u201d bell reducer.",
          "options": {
            "A": "The discharge valve",
            "B": "The nozzle of the 2 \u00bd\u201d hose",
            "C": "The tank-to-pump valve",
            "D": "The pressure gauge"
          }
        },
        {
          "id": "sfd_basic_skills_130_f7673016",
          "question": "What should be done when the firefighters on the attack line call for water?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the firefighters on the attack line call for water, the appropriate discharge valve should be slowly opened.",
          "options": {
            "A": "Increase the throttle to bring the discharge pressure between 50-75 PSI.",
            "B": "Slowly open the appropriate discharge valve.",
            "C": "Increase the engine speed to 800-1000 RPMs.",
            "D": "Prime the pump until the pressure gauge rises."
          }
        },
        {
          "id": "sfd_basic_skills_167_41236809",
          "question": "What is the first step Position #4 Firefighter should take when the engine stops at the hydrant location?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first step Position #4 Firefighter should take when the engine stops at the hydrant location is to disconnect the LDH from the tri-gate.",
          "options": {
            "A": "Disconnect the LDH from the tri-gate",
            "B": "Carry out the instructions of the company Officer",
            "C": "Procure the hydrant bag and hydrant wrenches",
            "D": "Remain seated while the engine is making the forward lay"
          }
        },
        {
          "id": "sfd_basic_skills_167_48c4dc2a",
          "question": "What safety precaution should be taken when securing the LDH at the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To ensure safety, no part of the body should be placed between the LDH and the hydrant to prevent injury if the hose snags during the forward lay.",
          "options": {
            "A": "Ensure the hose is wrapped tightly around the hydrant",
            "B": "Ensure no part of the body is placed between the LDH and the hydrant",
            "C": "Ensure the hose knot is at the bight in the hose",
            "D": "Ensure the hose is six feet beyond the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_167_64ffe77b",
          "question": "What should be done with the female coupling during the hose overhaul?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During the hose overhaul, the female coupling should be brought back towards the engine to form a six foot bight even with the barrel of the hydrant.",
          "options": {
            "A": "It should be disconnected from the LDH",
            "B": "It should be placed over the barrel of the hydrant",
            "C": "It should be brought back towards the engine to form a six foot bight",
            "D": "It should be placed in the hydrant bag"
          }
        },
        {
          "id": "sfd_basic_skills_167_784809cd",
          "question": "What should be done with the body loop during the hose overhaul?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The body loop should be used to form a hose knot at the bight in the hose and placed over the barrel of the hydrant to its base.",
          "options": {
            "A": "It should be placed over the barrel of the hydrant to its base",
            "B": "It should be used to form a hose knot at the bight in the hose",
            "C": "Both A and B",
            "D": "None of the above"
          }
        },
        {
          "id": "sfd_basic_skills_167_1f7f05fd",
          "question": "What should be done if the hose snags during the forward lay?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the hose snags during the forward lay, the engine should be stopped and the snag should be removed to prevent injury.",
          "options": {
            "A": "Continue with the forward lay",
            "B": "Disconnect the LDH from the tri-gate",
            "C": "Stop the engine and remove the snag",
            "D": "None of the above"
          }
        },
        {
          "id": "sfd_basic_skills_156_ba261142",
          "question": "What is the first step in connecting the LDH to the 4\u201d rear discharge port?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step mentioned in the text is to go to the pump panel and open the rear discharge port.",
          "options": {
            "A": "Open the intake valve fully",
            "B": "Go to the pump panel and open the rear discharge port",
            "C": "Deploy the soft suction hose",
            "D": "Proceed to the hydrant with the hydrant bag"
          }
        },
        {
          "id": "sfd_basic_skills_156_aa1aebc4",
          "question": "What should be done if the soft suction hose is not already connected?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the soft suction hose is not already connected, it should be deployed and connected to the side intake.",
          "options": {
            "A": "Open the rear discharge valve",
            "B": "Proceed to the hydrant with the hydrant bag",
            "C": "Deploy the soft suction hose and connect to the side intake",
            "D": "Open the intake valve fully"
          }
        },
        {
          "id": "sfd_basic_skills_156_92acf3e2",
          "question": "What should be done after opening the rear discharge port?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "After opening the rear discharge port, the next step is to open the rear discharge valve.",
          "options": {
            "A": "Proceed to the hydrant with the hydrant bag",
            "B": "Open the intake valve fully",
            "C": "Deploy the soft suction hose and connect to the side intake",
            "D": "Open the rear discharge valve"
          }
        },
        {
          "id": "sfd_basic_skills_156_530d980c",
          "question": "What should be done after deploying the soft suction hose and connecting it to the side intake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After deploying the soft suction hose and connecting it to the side intake, the next step is to open the intake valve fully.",
          "options": {
            "A": "Open the rear discharge valve",
            "B": "Open the intake valve fully",
            "C": "Go to the pump panel and open the rear discharge port",
            "D": "Proceed to the hydrant with the hydrant bag"
          }
        },
        {
          "id": "sfd_basic_skills_156_e2712086",
          "question": "What should be taken to the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hydrant bag, the hydrant wrenches and the hydrant coupling of the soft suction hose should be taken to the hydrant.",
          "options": {
            "A": "The soft suction hose",
            "B": "The hydrant bag, the hydrant wrenches and the hydrant coupling of the soft suction hose",
            "C": "The pump panel",
            "D": "The LDH"
          }
        },
        {
          "id": "sfd_basic_skills_140_9b2f83af",
          "question": "What should be done with the female end of the unused hose to ensure safety?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The female end of the unused hose should be placed under the tailboard to minimize the tripping hazard.",
          "options": {
            "A": "Leave it on the ground",
            "B": "Place it under the tailboard",
            "C": "Tie it to the hydrant",
            "D": "Hold it in hand"
          }
        },
        {
          "id": "sfd_basic_skills_140_769b9f98",
          "question": "What should be done if the nearest hydrant is in front of the engine and within 100 feet?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the nearest hydrant is in front of the engine and within 100 feet, grab the 15-foot LDH bundle tied with a body loop and the bight of the 50-foot section of LDH next to it.",
          "options": {
            "A": "Grab the 15-foot LDH bundle and the bight of the 50-foot section",
            "B": "Grab only the 15-foot LDH bundle",
            "C": "Grab only the bight of the 50-foot section",
            "D": "Do not grab any LDH bundle"
          }
        },
        {
          "id": "sfd_basic_skills_140_942cbcd7",
          "question": "What should be done with the bight of LDH in the left hand towards the front of the Apparatus?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Towards the front of the Apparatus, drop the bight of LDH in left hand and continue to the hydrant holding the 15-foot LDH bundle.",
          "options": {
            "A": "Hold it in the left hand",
            "B": "Drop it",
            "C": "Tie it to the hydrant",
            "D": "Pass it to the right hand"
          }
        },
        {
          "id": "sfd_basic_skills_140_cc363e80",
          "question": "What should be done after leaving the 15-foot LDH bundle at the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After leaving the 15-foot LDH bundle at the hydrant, return to the engine.",
          "options": {
            "A": "Return to the engine",
            "B": "Proceed to the hydrant",
            "C": "Drop the bight of LDH in left hand",
            "D": "Hold the 15-foot LDH bundle"
          }
        },
        {
          "id": "sfd_basic_skills_140_76faeb79",
          "question": "What should be done with the sections of LDH when the hydrant is on the side of the apparatus?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The sections of LDH should be angled to the side of the apparatus that the hydrant is on.",
          "options": {
            "A": "Angle them to the opposite side of the apparatus",
            "B": "Angle them to the side of the apparatus that the hydrant is on",
            "C": "Keep them straight",
            "D": "Fold them"
          }
        },
        {
          "id": "sfd_basic_skills_117_bc9be39f",
          "question": "According to the text, what is the maximum recommended distance for the hydrant to engine connection?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that every effort must be made to have the hydrant to engine connection within 100 feet.",
          "options": {
            "A": "500 feet",
            "B": "300 feet",
            "C": "100 feet",
            "D": "200 feet"
          }
        },
        {
          "id": "sfd_basic_skills_117_2700d9c9",
          "question": "What should the engine officer consider when positioning the engine company?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the engine officer must allow for the placement of the ladder company for optimum use of the aerial ladder.",
          "options": {
            "A": "The proximity to the nearest coffee shop",
            "B": "The placement of the ladder company for optimum use of the aerial ladder",
            "C": "The color of the fire hydrant",
            "D": "The weather conditions"
          }
        },
        {
          "id": "sfd_basic_skills_117_c7a786d9",
          "question": "What is the importance of the manner in which orders are given during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, the manner in which orders are given and assignments made will set the tone for the entire operation.",
          "options": {
            "A": "It sets the tone for the entire operation",
            "B": "It determines the color of the fire",
            "C": "It decides who gets to use the fire hose first",
            "D": "It determines the size of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_117_fffc5bbe",
          "question": "What should be specified if the attack line is longer than what is standard for a particular evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that the length of the attack line must be specified if it is longer than what is standard for a particular evolution.",
          "options": {
            "A": "The color of the hose",
            "B": "The weight of the hose",
            "C": "The length of the attack line",
            "D": "The brand of the hose"
          }
        },
        {
          "id": "sfd_basic_skills_117_52364214",
          "question": "What should the final positioning of the engine company not impede?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text states that the final positioning of the engine company must not impede the incoming ladder companies from the fire building.",
          "options": {
            "A": "The incoming ladder companies from the fire building",
            "B": "The view of the spectators",
            "C": "The traffic on the road",
            "D": "The water supply from the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_160_f1a91d0b",
          "question": "What is the first step in extending the soft suction using LDH according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step is to stretch the LDH supply line from the engine to the hydrant.",
          "options": {
            "A": "Open the hydrant",
            "B": "Connect the LDH supply line to the engine port on the hydrant",
            "C": "Stretch the LDH supply line from the engine to the hydrant",
            "D": "Break the LDH from the bed and connect it directly to the soft suction"
          }
        },
        {
          "id": "sfd_basic_skills_160_7ff6b242",
          "question": "What is the purpose of the soft suction adapter in the process of extending the soft suction using LDH?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The soft suction adapter is used to connect the LDH directly to the soft suction after opening the keystone.",
          "options": {
            "A": "To connect the LDH to the hydrant",
            "B": "To connect the LDH supply line to the engine port on the hydrant",
            "C": "To break the LDH from the bed",
            "D": "To connect the LDH directly to the soft suction after opening the keystone"
          }
        },
        {
          "id": "sfd_basic_skills_160_274694cd",
          "question": "What is the role of the hydrant adapter in the process of extending the soft suction using LDH?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The hydrant adapter is used to connect the LDH supply line to the engine port on the hydrant.",
          "options": {
            "A": "To connect the LDH supply line to the engine port on the hydrant",
            "B": "To open the keystone",
            "C": "To connect the LDH directly to the soft suction",
            "D": "To break the LDH from the bed"
          }
        },
        {
          "id": "sfd_basic_skills_160_13c4e02c",
          "question": "What should be done after connecting the LDH supply line to the engine port on the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After connecting the LDH supply line to the engine port on the hydrant, the hydrant should be opened.",
          "options": {
            "A": "Break the LDH from the bed",
            "B": "Open the hydrant",
            "C": "Connect the LDH directly to the soft suction",
            "D": "Stretch the LDH supply line from the engine to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_160_f7076807",
          "question": "What should be done after breaking the LDH from the bed?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After breaking the LDH from the bed, it should be connected directly to the soft suction after opening the keystone.",
          "options": {
            "A": "Open the hydrant",
            "B": "Connect the LDH supply line to the engine port on the hydrant",
            "C": "Connect it directly to the soft suction after opening the keystone",
            "D": "Stretch the LDH supply line from the engine to the hydrant"
          }
        },
        {
          "id": "sfd_basic_skills_137_8884c2c1",
          "question": "What is the purpose of placing the unused end of the LDH under the tailboard?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Placing the unused end of the LDH under the tailboard minimizes the tripping hazard, ensuring firefighter safety.",
          "options": {
            "A": "To minimize the tripping hazard",
            "B": "To increase the pressure in the hose",
            "C": "To prevent water leakage",
            "D": "To make it easier to connect to the pump intake"
          }
        },
        {
          "id": "sfd_basic_skills_137_3c5ac29c",
          "question": "What is the purpose of breaking the connection of LDH that will reach the side intake?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Breaking the connection of LDH that will reach the side intake allows for the connection to be made to the desired pump intake, facilitating efficient firefighting operations.",
          "options": {
            "A": "To allow for the connection to be made to the desired pump intake",
            "B": "To decrease the pressure in the hose",
            "C": "To prevent water leakage",
            "D": "To make it easier to roll up the hose"
          }
        },
        {
          "id": "sfd_basic_skills_137_a541e2d1",
          "question": "What type of coupling is used to connect the LDH to the desired pump intake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A 4\u201d double female coupling is used to connect the LDH to the desired pump intake, ensuring a secure and efficient connection.",
          "options": {
            "A": "2\u201d single male coupling",
            "B": "4\u201d double female coupling",
            "C": "3\u201d double male coupling",
            "D": "5\u201d single female coupling"
          }
        },
        {
          "id": "sfd_basic_skills_137_d53c8b1e",
          "question": "What should be done if the soft suction hose is connected to the intake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the soft suction hose is connected to the intake, it should be removed to allow for the LDH connection to be made, ensuring the most effective firefighting operations.",
          "options": {
            "A": "Leave it connected and connect the LDH to another intake",
            "B": "Remove it to allow for the LDH connection to be made",
            "C": "Connect the LDH to the soft suction hose",
            "D": "Use a double male coupling to connect the LDH to the soft suction hose"
          }
        },
        {
          "id": "sfd_basic_skills_137_e912b8af",
          "question": "What is the safety implication of running out the hose at a slight angle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Running out the hose at a slight angle minimizes the tripping hazard, ensuring firefighter safety during operations.",
          "options": {
            "A": "It reduces the risk of the hose tangling",
            "B": "It minimizes the tripping hazard",
            "C": "It increases the reach of the hose",
            "D": "It prevents the hose from kinking"
          }
        },
        {
          "id": "sfd_basic_skills_121_635cd80f",
          "question": "What is the primary purpose of the 1\u00be\u201d Pre-connect evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The primary purpose of the 1\u00be\u201d Pre-connect evolution is to use tank water to initiate the fire attack as quickly as possible.",
          "options": {
            "A": "To deploy a 200 foot 1\u00be\u201d hose bundle for water rescue",
            "B": "To use tank water to initiate the fire attack as quickly as possible",
            "C": "To test the engine's pump pressure",
            "D": "To train new firefighters on hose deployment"
          }
        },
        {
          "id": "sfd_basic_skills_121_db0de5f7",
          "question": "What is the role of the Pre-connect Officer in the 1\u00be\u201d Pre-connect evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Pre-connect Officer directs the driver where to position the engine and gives verbal directions to the crew.",
          "options": {
            "A": "To increase the engine speed to between 800 - 1000 RPMs",
            "B": "To direct the driver where to position the engine and give verbal directions to the crew",
            "C": "To open the tank-to-pump valve",
            "D": "To maintain 50-75 PSI while the hose is being filled"
          }
        },
        {
          "id": "sfd_basic_skills_121_a1345681",
          "question": "What should the driver do after positioning the engine as directed by the company Officer?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After positioning the engine as directed by the company Officer, the driver should perform the in-cab procedures to place the engine into pump, exit the cab and place the wheel blocks.",
          "options": {
            "A": "Exit the cab and place the wheel blocks",
            "B": "Call for water",
            "C": "Sling the SCBA to the stand-by position",
            "D": "Direct the crew to the destination of the hose line"
          }
        },
        {
          "id": "sfd_basic_skills_121_c224b0f0",
          "question": "What should the discharge pressure be when members on the attack line call for water?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When members on the attack line call for water, the discharge pressure should be between 50-75 PSI.",
          "options": {
            "A": "Between 800 - 1000 RPMs",
            "B": "Between 50-75 PSI",
            "C": "At least 100 PSI",
            "D": "No specific pressure, it depends on the situation"
          }
        },
        {
          "id": "sfd_basic_skills_121_7861c4d1",
          "question": "What is the driver supposed to do when members on the attack line call for water?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When members on the attack line call for water, the driver is supposed to slowly open the pre-connect discharge valve.",
          "options": {
            "A": "Increase the engine speed to between 800 - 1000 RPMs",
            "B": "Slowly open the pre-connect discharge valve",
            "C": "Direct the crew to the destination of the hose line",
            "D": "Exit the cab and place the wheel blocks"
          }
        },
        {
          "id": "sfd_basic_skills_120_e42a4ae0",
          "question": "What is the primary responsibility of the position #3 firefighter during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The position #3 firefighter's main duty is to maintain control of the nozzle, providing protection to all other members operating on or above the fire floor.",
          "options": {
            "A": "To establish ventilation openings",
            "B": "To conduct a primary search of the fire room",
            "C": "To maintain control of the nozzle",
            "D": "To serve as the 'team B' leader"
          }
        },
        {
          "id": "sfd_basic_skills_120_86897342",
          "question": "When should a firefighter begin a primary search of the fire room?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once the fire is under control, firefighters should begin a primary search of the fire room.",
          "options": {
            "A": "Before the fire is under control",
            "B": "After the fire is under control",
            "C": "During the fire",
            "D": "After the overhaul is complete"
          }
        },
        {
          "id": "sfd_basic_skills_120_5d0b3978",
          "question": "What is the role of the position #4 firefighter if the company Officer is not present inside the fire building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the company Officer is not present inside the fire building, the position #4 firefighter will serve as the 'team B' leader.",
          "options": {
            "A": "To maintain control of the nozzle",
            "B": "To serve as the 'team B' leader",
            "C": "To establish ventilation openings",
            "D": "To conduct a primary search of the fire room"
          }
        },
        {
          "id": "sfd_basic_skills_120_521d3b7b",
          "question": "What is the importance of establishing a ventilation opening as soon as possible?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Establishing a ventilation opening as soon as possible is a priority to allow smoke to escape, improving visibility and conditions for firefighters.",
          "options": {
            "A": "To allow the fire to spread",
            "B": "To allow smoke to escape and improve visibility",
            "C": "To allow water to enter the building",
            "D": "To allow firefighters to enter the building"
          }
        },
        {
          "id": "sfd_basic_skills_120_d037b864",
          "question": "What should the nozzle firefighter do if a large body of hidden fire is discovered or a flare up occurs?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Should a large body of hidden fire be discovered, or a flare up occurs, the nozzle firefighter must be in a position to operate the nozzle immediately.",
          "options": {
            "A": "Leave the building immediately",
            "B": "Call for backup",
            "C": "Operate the nozzle immediately",
            "D": "Begin overhaul"
          }
        },
        {
          "id": "sfd_basic_skills_136_9ed9dff0",
          "question": "What is the purpose of carrying a dedicated hydrant bag in each engine company?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hydrant bag is carried in each engine company to make connections to a hydrant. It contains specific equipment for this purpose.",
          "options": {
            "A": "To store personal belongings of the firefighters",
            "B": "To carry food and water supplies",
            "C": "To make connections to a hydrant",
            "D": "To carry medical supplies"
          }
        },
        {
          "id": "sfd_basic_skills_136_fdfe98ef",
          "question": "What should be done if the nearest hydrant is to the rear of the engine?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the nearest hydrant is to the rear of the engine, the firefighter should shoulder-load the 15-foot section tied with a body loop and overhaul the hose directly to the hydrant.",
          "options": {
            "A": "Leave the engine and find another hydrant",
            "B": "Shoulder-load the 15-foot section tied with a body loop and overhaul the hose directly to the hydrant",
            "C": "Call for backup",
            "D": "Use a bucket to transport water from the hydrant to the engine"
          }
        },
        {
          "id": "sfd_basic_skills_136_3bd17369",
          "question": "What is the purpose of the 2\u00bd\u201d to 4\u201d Increaser in the hydrant bag?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 2\u00bd\u201d to 4\u201d Increaser is used to connect two hoses of different diameters, allowing for flexibility in firefighting operations.",
          "options": {
            "A": "To increase the water pressure",
            "B": "To increase the hose diameter",
            "C": "To connect two hoses of different diameters",
            "D": "To repair damaged hoses"
          }
        },
        {
          "id": "sfd_basic_skills_136_edb9dde7",
          "question": "What is the correct distance to proceed past the hydrant for an easy connection?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The firefighter should proceed approximately 6 feet past the hydrant to allow enough hose for an easy connection.",
          "options": {
            "A": "Approximately 6 feet",
            "B": "Approximately 10 feet",
            "C": "Approximately 15 feet",
            "D": "Approximately 20 feet"
          }
        },
        {
          "id": "sfd_basic_skills_136_f2188f6c",
          "question": "What is the purpose of the OCD wrench in the hydrant bag?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The OCD wrench in the hydrant bag is used to tighten hose connections, ensuring a secure and leak-free connection to the hydrant.",
          "options": {
            "A": "To open the hydrant",
            "B": "To tighten hose connections",
            "C": "To break windows in a burning building",
            "D": "To cut through obstacles"
          }
        },
        {
          "id": "sfd_basic_skills_161_fbc79b32",
          "question": "What is the main difference between a 'wet' and a 'dry' forward lay in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In a 'wet' forward lay, the hydrant person stays at the hydrant, makes up the hydrant connection, charges the line, and then proceeds to the fire. In a 'dry' lay, all members secure the hose to the hydrant and then proceed to the fire location as a crew.",
          "options": {
            "A": "In a 'wet' lay, the hose is filled with water before being laid, while in a 'dry' lay, the hose is laid without water.",
            "B": "In a 'wet' lay, all members stay at the hydrant, while in a 'dry' lay, all members proceed to the fire location.",
            "C": "In a 'wet' lay, the hydrant person stays at the hydrant and charges the line, while in a 'dry' lay, all members proceed to the fire location after securing the hose to the hydrant.",
            "D": "In a 'wet' lay, the hose is laid from the fire location to the hydrant, while in a 'dry' lay, the hose is laid from the hydrant to the fire location."
          }
        },
        {
          "id": "sfd_basic_skills_161_69d86713",
          "question": "Why is a forward lay not advised to proceed 'wet' if the engine will be more than 100 feet of the hydrant?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Friction loss and/or elevation gain will significantly reduce the incoming pump pressure at the pumping engine if the engine is more than 100 feet away from the hydrant.",
          "options": {
            "A": "Because the water will freeze in the hose.",
            "B": "Because friction loss and/or elevation gain will significantly reduce the incoming pump pressure at the pumping engine.",
            "C": "Because the hose will not be long enough to reach the fire.",
            "D": "Because it will take too long to fill the hose with water."
          }
        },
        {
          "id": "sfd_basic_skills_161_0b71300d",
          "question": "What is the role of the officer during a 'Forward Lay with LDH\u2013Dry'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During a 'Forward Lay with LDH\u2013Dry', the officer directs the driver to position the engine near the hydrant and gives verbal directions to the crew.",
          "options": {
            "A": "The officer stays at the hydrant to make connections.",
            "B": "The officer directs the driver to position the engine near the hydrant and gives verbal directions to the crew.",
            "C": "The officer lays the hose from the hydrant to the fire location.",
            "D": "The officer charges the line and then proceeds to the fire."
          }
        },
        {
          "id": "sfd_basic_skills_161_8ffc675a",
          "question": "What is the desired location to stop the engine during a forward lay?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The desired location is to stop with the tailboard 10 feet past the hydrant.",
          "options": {
            "A": "10 feet past the hydrant.",
            "B": "Right next to the hydrant.",
            "C": "50 feet past the hydrant.",
            "D": "100 feet past the hydrant."
          }
        },
        {
          "id": "sfd_basic_skills_161_906ddb8d",
          "question": "What is the role of a second engine in most circumstances during a 'dry' forward lay?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In most circumstances, a second engine should connect to the hydrant, using a soft suction reverse pump hook-up, and pump into the LDH line laid forward to increase the pressure received by the engine that is pumping at the fire.",
          "options": {
            "A": "To assist in laying the hose.",
            "B": "To connect to the hydrant and pump into the LDH line laid forward to increase the pressure received by the engine that is pumping at the fire.",
            "C": "To stay at the hydrant and charge the line.",
            "D": "To proceed to the fire location as a crew of four."
          }
        },
        {
          "id": "sfd_basic_skills_116_03b43717",
          "question": "What considerations should be made to minimize the number of lengths of hose required and provide rapid hose line positioning?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "All the options mentioned are valid considerations for minimizing the number of lengths of hose required and providing rapid hose line positioning.",
          "options": {
            "A": "Stretching hose up the open well of a stairway",
            "B": "Utilization of standpipe systems",
            "C": "Hoisting a hose line with utility rope or drop bag line via the exterior of the building",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_116_98ff5ef2",
          "question": "Where should the line be charged in large buildings?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In large buildings, the line should be charged in the stairwell on the floor below the fire, or in a remote smoke-free location protected from the fire area by fire doors.",
          "options": {
            "A": "In the immediate fire area",
            "B": "In the stairwell on the floor below the fire, or in a remote smoke-free location protected from the fire area by fire doors",
            "C": "Outside of the building",
            "D": "In the room adjacent to the fire"
          }
        },
        {
          "id": "sfd_basic_skills_116_dd056c4d",
          "question": "What is the likely consequence of operating hose lines in opposition to each other or combining offensive and defensive attack methods?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that injury to firefighters is likely to occur if hose lines are operated in opposition to each other or if offensive and defensive attack methods are combined.",
          "options": {
            "A": "It will result in a faster extinguishing of the fire",
            "B": "It will likely lead to injury to firefighters",
            "C": "It will make the fire spread more rapidly",
            "D": "It will cause the fire to rekindle"
          }
        },
        {
          "id": "sfd_basic_skills_116_f0fa83b5",
          "question": "What is the role of the engine company Officer when arriving first at the scene of a fire?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The engine company Officer has several responsibilities when arriving first at the scene of a fire, including supervising the operation, deciding where to position the engine, and making decisions regarding incident strategy and tactics.",
          "options": {
            "A": "To supervise the operation and ensure the evolution and individual assignments are completed safely and efficiently",
            "B": "To decide where to position the engine once the fire location has been determined",
            "C": "To make sound decisions regarding incident strategy and tactics",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_116_802065f4",
          "question": "What factors should influence the Officer's decision on where to position the engine once the fire location has been determined?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Officer's decision on where to position the engine should be based on overall objectives, water source, fire conditions, and the type of engine.",
          "options": {
            "A": "Overall objectives, water source, fire conditions, and the type of engine",
            "B": "The size of the fire, the number of firefighters, and the type of engine",
            "C": "The time of day, the weather conditions, and the type of engine",
            "D": "The distance to the nearest fire station, the number of firefighters, and the type of engine"
          }
        },
        {
          "id": "sfd_basic_skills_141_e157c032",
          "question": "What is the first step in connecting the male coupling to the desired pump intake?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step is to use a 4\u201d double female to connect the male coupling to the desired pump intake.",
          "options": {
            "A": "Open the intake valve",
            "B": "Connect the LDH to the main side intake",
            "C": "Use a 4\u201d double female",
            "D": "Return to the hydrant with the hydrant bag and wrenches"
          }
        },
        {
          "id": "sfd_basic_skills_141_f8d37889",
          "question": "What should you do if the soft suction is connected to the intake valve?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "If the soft suction is connected to the intake valve, it should be removed to allow for the connection to be made.",
          "options": {
            "A": "Leave it connected",
            "B": "Connect the LDH to it",
            "C": "Open the intake valve",
            "D": "Remove it"
          }
        },
        {
          "id": "sfd_basic_skills_141_5d46ff0c",
          "question": "What should not be done immediately after connecting the LDH to the main side intake?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The intake valve should not be opened immediately after connecting the LDH to the main side intake.",
          "options": {
            "A": "Open the intake valve",
            "B": "Return to the hydrant with the hydrant bag and wrenches",
            "C": "Connect the male coupling to the desired pump intake",
            "D": "Remove the soft suction from the intake valve"
          }
        },
        {
          "id": "sfd_basic_skills_141_367a2b62",
          "question": "What should be done after connecting the LDH to the main side intake and before opening the intake valve?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After connecting the LDH to the main side intake and before opening the intake valve, the hydrant bag and the hydrant wrenches should be procured and returned to the hydrant.",
          "options": {
            "A": "Connect the male coupling to the desired pump intake",
            "B": "Remove the soft suction from the intake valve",
            "C": "Procure the hydrant bag and the hydrant wrenches and return to hydrant",
            "D": "Open the intake valve"
          }
        },
        {
          "id": "sfd_basic_skills_141_47a466d4",
          "question": "What is the purpose of returning to the hydrant with the hydrant bag and wrenches?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text does not specify the purpose of returning to the hydrant with the hydrant bag and wrenches.",
          "options": {
            "A": "To open the intake valve",
            "B": "To connect the LDH to the main side intake",
            "C": "To remove the soft suction from the intake valve",
            "D": "The text does not specify"
          }
        },
        {
          "id": "sfd_basic_skills_157_05045de7",
          "question": "What is the first step in opening a hydrant according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in opening a hydrant, as mentioned in the text, is to remove the engine port and a 2\u00bd\u201d port using the Corey wrench.",
          "options": {
            "A": "Attach the soft suction hose and a hydrant gate",
            "B": "Step behind the hydrant and open it fully using the Galvin wrench",
            "C": "Remove engine port and a 2\u00bd\u201d port using the Corey wrench",
            "D": "Ensure that the gate is in the closed position"
          }
        },
        {
          "id": "sfd_basic_skills_157_1787b5fc",
          "question": "What should be done if kinks are present but sufficient water is entering the intake and being discharged to the tri-gate?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that if kinks are present but it remains evident that sufficient water is entering the intake and being discharged to the tri-gate, they should be disregarded at this time.",
          "options": {
            "A": "Immediately remove all kinks",
            "B": "Disregard them at this time",
            "C": "Close the hydrant and start over",
            "D": "Increase the discharge pressure"
          }
        },
        {
          "id": "sfd_basic_skills_157_9a868341",
          "question": "How can you know that the discharge pressure relief valve (PRV) has opened?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text mentions three indicators that the PRV has opened: the engine RPM\u2019s will begin to drop, the indicated discharge pressure will also drop, and the PRV indicator light will illuminate.",
          "options": {
            "A": "The engine RPM\u2019s will begin to drop",
            "B": "The indicated discharge pressure will drop",
            "C": "The PRV indicator light will illuminate",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_157_0632974f",
          "question": "What should be done after setting the discharge pressure and before obtaining a second water supply?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, after setting the discharge pressure and before obtaining a second water supply, traffic cones should be positioned to protect personnel, the engine, and hose lines from approaching vehicles.",
          "options": {
            "A": "Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles",
            "B": "Monitor the pump panel and the radio for further instructions",
            "C": "Increase the discharge pressure until the desired operating pressure is reached",
            "D": "Return to the engine\u2019s pump panel"
          }
        },
        {
          "id": "sfd_basic_skills_157_a0f30277",
          "question": "What should be done once a second water supply has been established?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once a second water supply has been established, the text states that remaining equipment and hose loads should be ensured to be ready for use.",
          "options": {
            "A": "Monitor the pump panel and the radio for further instructions",
            "B": "Ensure remaining equipment and hose loads are ready for use",
            "C": "Increase the discharge pressure until the desired operating pressure is reached",
            "D": "Position traffic cones to protect personnel, the engine, and hose lines from approaching vehicles"
          }
        }
      ]
    },
    "5": {
      "chapter_id": "5",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_251_75fe153e",
          "question": "The member on the fly side is responsible for footing the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'The ladder is footed and ready for extension or pivoting... The member on the fly side will heel the ladder.' This indicates that the member on the fly side is responsible for heeling the ladder, not footing it. Misunderstanding roles during ladder operations can lead to safety risks and inefficiencies in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_251_f3f5dea0",
          "question": "The member on the bed side walks backward while grasping the center of the rungs during the flat lower operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'The member on the bed side will slowly walk backward while grasping the center of the rungs with a hand-over-hand motion to the end of the ladder and lower it to the ground.' This confirms that the member on the bed side walks backward while grasping the center of the rungs during the flat lower operation. Misunderstanding this could lead to improper ladder handling and potential safety risks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_251_844227e2",
          "question": "During the cradle lower operation, both members move to the beams and move toward the tip with a hand-over-hand motion down the beams.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Both members will move to the beams and with a hand-over-hand motion down the beams move toward the tip.' This confirms that during the cradle lower operation, both members move to the beams and move toward the tip with a hand-over-hand motion down the beams. Incorrect execution of this procedure could lead to instability of the ladder and potential injury.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_251_71e19e25",
          "question": "During the cradle lower operation, members turn to face each other at the tip of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'At the mid-section or balance point of the ladder they will turn to face each other and assume the cradle carry.' This contradicts the statement that members turn to face each other at the tip of the ladder. Misunderstanding this could lead to instability of the ladder during the cradle lower operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_251_bbed8e94",
          "question": "The positions, commands and executions change throughout the ladder operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'The positions, commands and executions do not change.' This contradicts the statement that the positions, commands and executions change throughout the ladder operation. Misunderstanding this could lead to confusion and potential safety risks during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_197_271c87a1",
          "question": "In the Beam Carry for a 26' or less ground extension ladder, the member in charge is positioned at the top of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge will be at the butt.' This contradicts the statement in the question, indicating that the member in charge is positioned at the base, not the top of the ladder. This is important for coordinating the movement and placement of the ladder, ensuring safety and efficiency in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_197_0fe3db37",
          "question": "When removing the ladder from the apparatus in the Beam Carry method, the members' inside hand should be placed between the 2nd and 3rd rungs from the ends.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Facing the butt, with their outside hand on the upper beam and the inside hand between the 2nd and 3rd rungs from the ends, the members remove the ladder from the side of the apparatus.' This supports the statement in the question, indicating the correct hand placement for removing the ladder. This is crucial for maintaining control of the ladder and ensuring safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_197_c7192b7c",
          "question": "In the Cradle Carry method for a 35' or less ground extension ladder, one member is positioned at the butt of the ladder while the other member is positioned at the top.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'One member is positioned on each side of the ladder.' This contradicts the statement in the question, indicating that both members are positioned on the sides of the ladder, not at the butt or top. This is important for evenly distributing the weight of the ladder and ensuring stability during transport.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_197_7c985099",
          "question": "In the Cradle Carry method, the members begin to pull the ladder out of the rack after releasing the ladder locks.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'They release the ladder locks and begin to pull the ladder out of the rack.' This supports the statement in the question, indicating the correct sequence of actions when using the Cradle Carry method. Understanding this sequence is crucial for safely and efficiently removing the ladder from the rack.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_197_e362d199",
          "question": "In both the Beam Carry and Cradle Carry methods, the ladder is carried to the objective after it is removed from the apparatus or rack.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the ladder is clear, they place their inside hand through the rungs and carry the ladder to the objective.' and 'The ladder is then carried to the objective.' This supports the statement in the question, indicating that in both methods, the ladder is carried to the objective after removal. This is important for understanding the goal of these methods, which is to safely transport the ladder to the desired location for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_178_3015a9ad",
          "question": "The pulley is a grooved metal wheel used when extending or retracting the flies of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'PULLEY - The grooved metal wheel over which the halyard or cable is drawn when extending or retracting the flies.' This supports the statement as it directly describes the function of the pulley in the operation of the ladder. Understanding the function of the pulley is important for firefighters as it is a key component in the operation of ladders during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_178_e40c1d81",
          "question": "The rungs on fire service ladders are usually square and spaced 10 inches apart.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Rungs on fire service ladders are usually round and spaced 14 inches apart.' This contradicts the statement as it specifies that the rungs are round, not square, and they are spaced 14 inches apart, not 10. Understanding the standard spacing and shape of rungs is important for firefighters as it impacts climbing safety and efficiency during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_178_45caf64e",
          "question": "The tormentor poles are used to assist in raising, lowering, pivoting, and stabilizing of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'TORMENTOR POLES - The poles attached to the upper bed section of a 40' or larger extension ladder. They are used to assist in raising, lowering, pivoting, and stabilizing of the ladder.' This supports the statement as it directly describes the function of tormentor poles in the operation of the ladder. Understanding the function of tormentor poles is crucial for firefighters as it affects the safe and effective operation of large extension ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_178_21609df3",
          "question": "The tip of the ladder is the lowermost end opposite the butt.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'TIP - The uppermost end of the ladder (opposite the butt).' This contradicts the statement as it specifies that the tip is the uppermost end of the ladder, not the lowermost. Understanding the correct terminology is important for firefighters as it ensures clear communication during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_178_22b61120",
          "question": "Spurs at the butt of a ladder are used to prevent slipping when the ladder is in the raised position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'SPURS - Protrusions at the butt of a ladder to prevent slipping when in the raised position, and to protect the end of the beams.' This supports the statement as it directly describes the function of spurs in preventing the ladder from slipping. Understanding the function of spurs is important for firefighters as it contributes to the stability and safety of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_206_3b9b0f19",
          "question": "The main purpose of footing the ladder is to prevent it from rocking left and right.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The main purpose being that it prevents the ladder from rocking left and right.' This means that footing the ladder provides stability and prevents loss of control, which is crucial for firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_206_0822ac00",
          "question": "A ladder should be footed only when it is unsteady in the vertical position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A ladder will be footed any time it is shifted, pivoted, or brought to the vertical as well as any other time it is unsteady while in the vertical position.' This contradicts the statement because it implies that the ladder should be footed not only when it is unsteady, but also when it is shifted, pivoted, or brought to the vertical. This is important for maintaining control and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_206_d4e674f0",
          "question": "Early footing of the ladder can prevent the member\u2019s loss of control if the ladder is starting to tip left or right.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If ever the ladder is starting to tip left or right, early footing will prevent the member\u2019s loss of control.' This supports the statement and highlights the importance of early footing in preventing accidents and maintaining control during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_206_d94a01a9",
          "question": "Only one member is needed to foot the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'One member on the bed side \u201cfooting\u201d the ladder Two members on the bed side \u201cfooting\u201d the ladder in unison.' This contradicts the statement because it implies that both one member and two members can foot the ladder depending on the situation. This is important for teamwork and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_206_312bc6ce",
          "question": "Footing the ladder is not necessary during a beam lower.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text does not provide any information that contradicts this statement. Therefore, it can be inferred that footing the ladder may not be necessary during a beam lower. However, firefighters should always assess the situation and use their judgment to ensure safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_210_f19964e0",
          "question": "The term 'IN' means the ladder will be pivoted on the designated beam toward the bed side of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The term \"IN\" means the ladder will be pivoted on the designated beam toward the fly side of the ladder.' This contradicts the statement in the question. Understanding these terms is crucial for firefighters to correctly position ladders during operations, which can affect safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_210_05461620",
          "question": "Every pivot command assumes a 1/4 turn unless directed otherwise in the command.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Every pivot command assumes a 1/4 turn unless directed otherwise in the command.' This supports the statement in the question. Knowing this standard assumption can help firefighters execute commands more efficiently, which is critical in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_210_9e64ec5a",
          "question": "The members on the fly section of the ladder will foot the ladder after each pivot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members on the bed section of the ladder will foot the ladder after each pivot.' This contradicts the statement in the question. Correctly footing the ladder is essential for maintaining stability and safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_210_5a254932",
          "question": "When the command is 'ON THE LEFT BEAM, PIVOT IN', the ladder is tipped slightly onto the left beam then rotated one quarter turn toward the fly side.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command - \"ON THE LEFT BEAM, PIVOT IN\" The ladder is tipped slightly onto the left beam then rotated one quarter turn toward the fly side.' This supports the statement in the question. Understanding these commands is crucial for firefighters to correctly execute ladder maneuvers, which can affect rescue operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_210_cd11a56e",
          "question": "A pivot command requires at least two members in the ready position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'One member in the ready position for a pivot command.' This contradicts the statement in the question. Knowing the correct personnel requirements for each command can help ensure efficient and safe ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_247_923adcf4",
          "question": "The second member of the Seattle Fire Department takes hold of the halyard with their outside hand just below the other member's hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Seattle Fire Department second member will take hold of the halyard with their inside hand just below the other member's hand.' This contradicts the statement in the question, which incorrectly states that the second member uses their outside hand. This is important for ensuring smooth operation and safety during ladder extension.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_247_5c941399",
          "question": "The member in charge checks that all the dogs are locked and states 'ALL FOUR DOGS ARE LOCKED.'",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge (#1) will check that the dogs are locked and state \"ALL FOUR DOGS ARE LOCKED.\"' This supports the statement in the question. Ensuring that all the dogs are locked is crucial for the stability of the ladder and the safety of the firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_247_a479e464",
          "question": "The members on the bed side will heel the ladder with their outside foot on the bottom rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members on the bed side will heel the ladder with their inside foot on the bottom rung.' This contradicts the statement in the question, which incorrectly states that they use their outside foot. Proper footing is essential for stability when handling the ladder, which is a key safety concern.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_247_35b10c69",
          "question": "The member on the right beam is responsible for securing the halyard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the right beam will secure the halyard.' This supports the statement in the question. Securing the halyard is important to prevent unintentional ladder movement, which could lead to accidents.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_247_f614762c",
          "question": "The members on the poles will raise the ladder into the objective using the poles to guide the tip to the proper placement.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members on the poles will lower the ladder into the objective using the poles to guide the tip to the proper placement.' This contradicts the statement in the question, which incorrectly states that they raise the ladder. Proper ladder placement is critical for effective firefighting operations and firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_181_a6aca36d",
          "question": "The Seattle Fire Department Folding Ladder can be extended beyond its usual 10 feet length.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is usually 10 feet in length and cannot be extended.' This means that the Seattle Fire Department Folding Ladder has a fixed length and cannot be extended, which is important for firefighters to know when considering which ladder to use based on the height they need to reach.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_181_68e8eb92",
          "question": "Extension ladders are always equipped with a halyard, regardless of their size.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The only exception to this is a baby ladder, which does not have a halyard due to its height.' This indicates that not all extension ladders have a halyard, specifically the baby ladder due to its smaller size. This information is crucial for firefighters as it affects how the ladder is operated and extended.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_181_3dc3cfc5",
          "question": "Ladders that are 40 feet or longer are equipped with poles to assist in handling and placement.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Ladders 4 0 feet or longer are equipped with poles to assist in handling and placement. These poles are called \u201ctormentor\u201d poles.' This is important for firefighters to know as it affects how these longer ladders are handled and positioned during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_181_b1cb4aa4",
          "question": "The weight of an extension ladder increases with its length.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text provides a table of weight comparison showing that longer extension ladders weigh more than shorter ones. For example, a 24\u2019 Extension Ladder weighs 72 lbs while a 45\u2019 Extension Ladder weighs 240 lbs. This is crucial for firefighters to understand as it affects the manpower needed to carry and position the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_181_f5f30492",
          "question": "The Seattle Fire Department Folding Ladder is also known as a 'roof' ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is also commonly called an \u201cattic\u201d ladder.' This indicates that the Seattle Fire Department Folding Ladder is also known as an 'attic' ladder, not a 'roof' ladder. This is important for firefighters to know as it can affect their communication and understanding of which equipment to use in different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_230_2d4906f6",
          "question": "The ladder should be pivoted 1/4 turn so that the fly is closest to the building when it's almost to the vertical.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Raise the ladder up on its lower beam, when it\u2019s almost to the vertical, pivot the ladder 1/4 turn so that the fly is closest to the building.' This is important for ensuring the ladder is properly positioned for climbing and reaching the building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_230_b460a252",
          "question": "The ladder should be footed only after it has been extended to the desired height.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the ladder has come to a vertical position it shall be footed.' This contradicts the statement as the ladder should be footed when it reaches a vertical position, not after it has been extended. Footing the ladder ensures stability and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_230_ddc8a0bb",
          "question": "The ladder should be lowered by placing the right foot on the bottom rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Lower into the building by placing the left foot on the bottom rung.' This contradicts the statement as the left foot, not the right foot, should be placed on the bottom rung. This is a specific technique to ensure control while lowering the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_230_7e5196e9",
          "question": "Before lowering the ladder, you should ensure that there are no obstacles in your path, including the overhead.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Turn your head and look in the direction to which the ladder will be lowered to ensure that there are no obstacles in your path, including the overhead.' This is crucial for safety to prevent accidents or damage while lowering the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_230_8bead8df",
          "question": "You should shout 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN' before raising the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'State in a loud clear voice \"OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.\" This will alert personnel in the area that a ladder is about to be lowered.' This contradicts the statement as the warning should be given before lowering the ladder, not raising it. This is to ensure the safety of personnel in the vicinity.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_267_a492e327",
          "question": "Falling glass is not a significant hazard during ventilation process.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'NOTE: Falling glass is an extreme hazard.' This directly contradicts the statement in the question. Falling glass can pose a serious risk to firefighters during ventilation operations, potentially causing injury.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_267_b44ec5c4",
          "question": "Ventilating with the tip of the ladder using the 'fly-in' method is often difficult.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, 'often times ventilating with the tip of the ladder is difficult using the \u201cfly -in\u201d method.' This supports the statement in the question. Firefighters need to be aware of the challenges associated with different ventilation techniques to ensure effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_267_bc68bd5e",
          "question": "Aiming for the center of the window is the most effective method for breaking the glass.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, 'Aiming for the center of the window is the least effective method.' This contradicts the statement in the question. Firefighters should aim as close to the corners as possible when trying to break the glass, as these are the weakest points.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_267_cf2b4798",
          "question": "Newer energy efficient windows (EEW) may have multiple panes, making them difficult to vent from an exterior position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Newer energy efficient windows (EEW) may have multiple panes (sometimes up to 3). These windows can be very difficult to vent from an exterior position.' This supports the statement in the question. Firefighters need to be aware of the construction and characteristics of different types of windows to effectively perform ventilation operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_267_5be4b5ff",
          "question": "The corners of glass are the strongest points.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, 'The corners of glass are the weakest points.' This directly contradicts the statement in the question. Understanding the weak points of glass can help firefighters to break it more effectively during ventilation operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_226_3ef5f126",
          "question": "The ladder tip always needs to be secured with a ladder anchor during extended operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For example in extended operations, operating fire streams or working from a ladder while locked in, all require the tip to be secured.' This supports the statement that the ladder tip needs to be secured during extended operations, which is crucial for firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_226_c2d7eb8d",
          "question": "The ladder anchor should be brought to the tip or fly section being secured by any means possible.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder anchor should be brought to the tip or fly section being secured by the safest means possible.' This contradicts the statement that the ladder anchor should be brought by any means possible. Safety is paramount in firefighting operations to prevent unnecessary risks.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_226_9af6b33c",
          "question": "When securing the ladder anchor, it is recommended to make a loop starting with going over the 2nd rung below the sill/edge.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Make a loop starting with going over the 1st rung below the sill/edge.' This contradicts the statement that the loop should start over the 2nd rung. The correct procedure ensures the stability of the ladder and the safety of the firefighter.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_226_9b58ab84",
          "question": "When working on the ladder, maintaining three points of contact is necessary.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Maintain three points of contact with the ladder using your feet and at least one hand or one arm when working on the ladder.' This supports the statement that maintaining three points of contact is necessary, which is a standard safety protocol to prevent falls and injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_226_8bf7044a",
          "question": "The hook is placed over the parapet or sill and a loop is made with the rope, starting over the top of the 2nd rung below the sill/top of wall or roof line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The hook is placed over the parapet or sill and a loop is made with the rope, start over the top of the 1st rung below the sill/top of wall or roof line.' This contradicts the statement that the loop should start over the top of the 2nd rung. Following the correct procedure is crucial for securing the ladder effectively and ensuring firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_227_1b252f08",
          "question": "When performing work on a ladder, it is not necessary to lock-in.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Members performing work while on a ladder should be locked -in so that both hands are free for use.' This contradicts the statement, indicating that locking-in is necessary when performing work on a ladder to ensure safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_227_75c5b0b2",
          "question": "All members should lock-in at the same height on the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is necessary to adjust this operation as all members are not the same height.' This contradicts the statement, indicating that the height at which members lock-in on the ladder should be adjusted based on their individual heights for safety and comfort.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_227_b88cb3c2",
          "question": "Members should not lock-in on any ladder that is not secured at the tip.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Members shall not lock in (leg-lock) on any ladder that is not secured at the tip.' This supports the statement, emphasizing the importance of ladder stability and safety when locking-in.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_227_80df4c39",
          "question": "The overall goal of locking-in is to establish a secure position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The overall goal is to establish a secure position.' This supports the statement, highlighting the purpose of locking-in on a ladder is to ensure a secure and stable position for the firefighter.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_227_def713fd",
          "question": "Members can lock-in on any type of aerial ladder device.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Members shall not lock in (leg-lock) on any ladder that is not secured at the tip or any type of aerial ladder device.' This contradicts the statement, indicating that members should not lock-in on aerial ladder devices due to safety concerns.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_266_e4b19403",
          "question": "The ladder should be positioned directly in front of the window to be ventilated.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Procure a ladder that will reach the objective from the ground, and position it to the left or right of the window to be ventilated.' This contradicts the statement, as the ladder should not be directly in front of the window but to its side initially. This is important to ensure the safety of the firefighters and to allow for effective ventilation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_266_c241a2eb",
          "question": "The member on the fly side of the ladder should move to a safe place away from the base of the ladder before the command 'VENTILATE' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the fly side of the ladder now leaves their position and moves to a safe place away from the base of the ladder to avoid falling glass.' This supports the statement, indicating that the member on the fly side should indeed move to a safe place before ventilation begins. This is crucial for the safety of the firefighter, as falling glass can cause serious injury.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_266_45cce5ba",
          "question": "If two members are on the bed side of the ladder, they should place their outside foot on the bottom rung to push the ladder into the window.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If two members are on the bed side of the ladder they will place their inside foot on the bottom rung and push the ladder into the window.' This contradicts the statement, as the inside foot should be used, not the outside. This technique is important for maintaining balance and control while applying force to the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_266_147453d7",
          "question": "After the window is ventilated, the ladder should be immediately removed from the building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ensure that no additional glass will fall before a member is positioned under the ladder on the bed side to bring the ladder out from the building.' This contradicts the statement, as the ladder should not be immediately removed. Instead, precautions should be taken to ensure no additional glass will fall. This is important for maintaining the safety of the firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_266_3e5db74e",
          "question": "When the ladder hits the window, the butt of the ladder may slide out.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the ladder hits the window, whether the glass breaks or not, the butt of the ladder may slide out.' This supports the statement, indicating that the impact of the ladder may cause it to slide. This is a key consideration for firefighters to ensure they maintain control of the ladder and stay safe during the ventilation process.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_231_15b388f5",
          "question": "The beam raise method is only used when the ladder is beam carried to the objective.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This method is most commonly used for raising the ladder when it is beam carried to the objective.' This indicates that the beam raise method is specifically used when the ladder is beam carried to the objective, which is a crucial consideration for firefighters when deciding on the best method to raise a ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_231_32367434",
          "question": "The member at the butt of the ladder is not responsible for checking the overhead area for obstructions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge (the member at the butt) will check the overhead area for obstructions and state \"OVERHEAD CLEAR.\"' This contradicts the statement, indicating that the member at the butt of the ladder is indeed responsible for checking the overhead area for obstructions. This is a crucial safety consideration for firefighters to prevent accidents during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_231_a4678914",
          "question": "After grounding the butt, the next command is 'PREPARE TO RAISE'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command - \"GROUND THE BUTT\"... Command \" PREPARE TO RAISE \".' This supports the statement that the next command after grounding the butt is 'PREPARE TO RAISE'. This sequence of commands is important for firefighters to ensure smooth and safe ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_231_6cb459ac",
          "question": "If a beam raise parallel to the objective is necessary, the member at the tip cannot quickly roll the ladder over their head.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If a beam raise parallel to the objective is necessary and the butt has been grounded with the bed toward the objective, the member at the tip can quickly roll the ladder over their head.' This contradicts the statement, indicating that the member at the tip can quickly roll the ladder over their head if a beam raise parallel to the objective is necessary. This is a tactical consideration for firefighters to ensure the ladder is properly positioned.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_231_570150c8",
          "question": "It is not the responsibility of all personnel to survey the area where a ladder is to be raised.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is the responsibility of all personnel to survey the area where a ladder is to be raised.' This contradicts the statement, indicating that it is indeed the responsibility of all personnel to survey the area where a ladder is to be raised. This is a crucial safety consideration for firefighters to ensure the area is safe for ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_180_053b7ebe",
          "question": "The baby ladder is primarily used for gaining access to higher elevations on the exterior of buildings.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Baby ladders are primarily used in gaining access to lower elevations on the exterior of buildings.' This contradicts the statement in the question. In firefighting operations, understanding the correct use of equipment is crucial for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_180_dece9b69",
          "question": "The roof ladder's hooks provide a means of anchoring the ladder over the roof ridge or some other roof part.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hooks provide a means of anchoring the ladder over the roof ridge or some other roof part.' This supports the statement in the question. In firefighting, the ability to secure a ladder on a pitched roof is critical for safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_180_dc03285d",
          "question": "A roof ladder can allow easier access to the top of a fire escape by using the hooks over the rungs and the spurs on the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'a roof ladder can allow easier access to the bottom of a fire escape by using the hooks over the rungs and the spurs on the ground.' This contradicts the statement in the question. Understanding the proper use of a roof ladder can impact a firefighter's ability to access a fire escape safely and efficiently.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_180_7593af33",
          "question": "Roof ladders vary in length from ten to twenty feet, with twelve to fourteen being the most common size carried.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Roof ladders vary in length from ten to twenty feet. Twelve to fourteen being the most common size carried.' This supports the statement in the question. Knowing the common lengths of roof ladders can influence decision-making in firefighting operations, particularly in relation to accessing different parts of a building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_180_9fdefb0b",
          "question": "Baby ladders are only carried on ladder trucks.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The baby ladder is a small extension ladder carried on both ladder trucks and engine companies.' This contradicts the statement in the question. Understanding where equipment is stored can impact the speed and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_246_6f4c5e0b",
          "question": "The member on the right pole will have the pole crossing the front of their body with their left hand extended to the pole at shoulder height.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the right pole will have the pole crossing the front of their body with their right hand extended to the pole at shoulder height.' This contradicts the statement in the question. Correct positioning is crucial for safe and effective ladder operations in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_246_54820c8c",
          "question": "The spike of the pole should never point into your body.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Never allow the spike of the pole to point into your body.' This supports the statement in the question. Adhering to this safety guideline can prevent injuries during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_246_44230ccb",
          "question": "Both members on the poles will be standing directly under the beams.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Both members on the poles will be standing at an angle outside the beams by approximately four feet.' This contradicts the statement in the question. Proper positioning is essential for stability during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_246_20d73760",
          "question": "The taller member or the member on the right beam takes the higher hand position on the halyard until the fly is extended to the proper height.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The taller member (or member on the right beam, if the members are the same height) calls \"HIGH\" and takes the higher hand position on the halyard until the fly is extended to the proper height.' This supports the statement in the question. Understanding this procedure is important for efficient ladder extension during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_246_61d545df",
          "question": "The fly member takes control of the right pole.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '\"FLY SIDE AROUND\u201d fly member takes control of the left pole.' This contradicts the statement in the question. Correct understanding of roles and responsibilities is key to effective teamwork in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_211_af76ef65",
          "question": "When pivoting the ladder, both members on the bed side and fly side should place their hands on the respective side beams and push the ladder onto the designated beam.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the order is given to pivot, place hands on both bed side beams and push the ladder onto the designated beam and pivot the ladder in or out to the appropriate place.' and 'When the order is given to pivot, place your hands on both fly side beams, push the ladder onto the designated beam and pivot the ladder in or out to the appropriate place.' This indicates that both members on the bed side and fly side should be involved in pivoting the ladder, which is crucial for maintaining balance and control of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_211_fa15f02e",
          "question": "When the ladder is stabilized in the raised position, both members on the poles should move at the same time.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Only one member on the poles moves at a time.' This contradicts the statement that both members on the poles should move at the same time. This rule is important to ensure the stability of the ladder during repositioning, which is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_211_bc599da2",
          "question": "In the right pole position, the member has the right hand extended up the pole as far as possible and their left hand near their left hip on the spike.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Right pole position: With the right pole crossing the front of the body the member has the right hand extended up the pole as far as possible and their left hand near their left hip on the spike.' This confirms the statement. Correct hand positioning is crucial for maintaining control of the ladder, which has direct implications for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_211_1c2528a1",
          "question": "When moving on command, the member should not pay attention to their hand position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To move correctly on command, the member pays attention to their hand position.' This contradicts the statement that the member should not pay attention to their hand position. Paying attention to hand position is important for maintaining control and stability of the ladder, which is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_211_0860ef8f",
          "question": "It is acceptable to walk backwards while in the pole positions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Never walk backwards.' This contradicts the statement that it is acceptable to walk backwards. This rule is important to prevent falls or other accidents while handling the ladder, which is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_207_331e3198",
          "question": "When a ladder is being pivoted or shifted to vertical, only one member is needed to stabilize it.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'One member: As a ladder comes to vertical and is pivoted or shifted, the member will grasp the bed section beams, step up on the first rung with their left foot, and heel the ladder with their weight until it is steady.' This shows that one member can stabilize the ladder, which is crucial for safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_207_57d6a340",
          "question": "The member on the fly side should allow the ladder to lean out away from the objective for better extension.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once the member has obtained the desired foot position, the member should then allow the ladder to lean in slightly toward the objective, to assist in the extension of the ladder.' This contradicts the statement in the question, and it's important because it affects the ladder's reach and stability during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_207_b69b4bb3",
          "question": "When the command 'INTO THE BUILDING' is given, the member on the bed side should place their right foot on the center of the bottom rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the command \"INTO THE BUILDING\" is given, the member on the bed side will place their left foot on the center of the bottom rung.' This contradicts the statement in the question, and it's important because it affects the stability and control of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_207_ad22ab37",
          "question": "In a two-member operation, both members step up on the rung with their inside foot to stabilize the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'With two members footing the ladder on the bed side, both members step up on the rung with their inside foot applying their full weight to stabilize the ladder.' This supports the statement in the question, and it's important because it affects the stability and control of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_207_e8613888",
          "question": "The member on the fly side assists the movement of lowering the ladder into the objective with their feet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the fly side will assist this movement with their hands on the beams.' This contradicts the statement in the question, and it's important because it affects the control and safety of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_196_a0527aca",
          "question": "The members should kneel down with their outside knee up when preparing to lift the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members then face the butt, kneel down with their inside knee up.' This contradicts the statement, as it is the inside knee that should be up. This is important for maintaining balance and control while lifting the ladder, which can be crucial in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_196_723128b2",
          "question": "The members place their inside arm between the 1st and 2nd rung from the ends of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the inside arm between the 2nd and 3rd rung from the ends.' This contradicts the statement, as the inside arm should be placed between the 2nd and 3rd rung, not the 1st and 2nd. Proper positioning of the arm is crucial for lifting and carrying the ladder safely and effectively during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_196_18254f42",
          "question": "The members stand up, lifting the ladder to the shoulder with their inside hand.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The members stand up, lifting the ladder to the shoulder with inside hand.' This supports the statement. This technique is important for lifting the ladder safely and efficiently, which can be crucial in firefighting operations where time is of the essence.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_196_bd279c67",
          "question": "The members take proper position at the beamed ladder before assuming the 'PREPARE TO LIFT' position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The members take proper position at the beamed ladder. Members assume the \u201cPREPARE TO LIFT\u201d position.' This supports the statement. Proper positioning is crucial for safety and effectiveness in lifting and carrying the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_196_97ff2c81",
          "question": "The members carry the ladder to the objective after they stand up and lift the ladder to their shoulder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members then beam carry the ladder to the objective.' This contradicts the statement, as the members carry the ladder to the objective after they assume the 'PREPARE TO LIFT' position, not immediately after they stand up and lift the ladder to their shoulder. Understanding the correct sequence of actions is important for safety and efficiency in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_179_20df41b3",
          "question": "Trussed beam ladders are weaker than solid beam ladders.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Trussed ladder s are designed to increase strength in relation to weight.' This contradicts the statement that trussed beam ladders are weaker. In firefighting, understanding the strength of equipment is crucial for safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_179_5ce72976",
          "question": "The weight of a trussed beam ladder is more than that of a solid beam ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'When using longer ladders, trussed beam ladders are often used rather than solid beam because the weight of the trussed beam ladder will be less.' This contradicts the statement that trussed beam ladders are heavier. Knowing the weight of equipment can affect tactical decisions, such as which ladder to use in different situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_179_a3db8d72",
          "question": "Seattle Fire Department uses trussed beamed ladders for all operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'Although trussed beamed ladders are used in the fire service, Seattle uses them for certain roof ladders and those too, will soon be phased out.' This contradicts the statement that Seattle uses trussed beamed ladders for all operations. Understanding local equipment use is important for effective teamwork and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_179_998fc2f8",
          "question": "The measured length of the ladder when the fly(s) are retracted is often written on the inside of each beam near the butt.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is good practice to write the measured length (of the ladder when the fly(s) are retr acted) on the inside of each beam near the butt.' This supports the statement. Knowing the length of the ladder can help firefighters judge the distance they need to extend the ladder to reach a target height, which can be crucial in rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_179_6718c219",
          "question": "Solid beam ladders are not used in fire service work due to their weight.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'The solid beam is a solid piece of material of the shape and size to provide the maximum strength for fire service work.' This contradicts the statement that solid beam ladders are not used in fire service work. Understanding the types of ladders used in fire service work can help firefighters make informed decisions about equipment use in different scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_250_84895deb",
          "question": "Both members should put weight on the butt end of the ladder to force it to the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Both members put weight on the butt end of the ladder forcing it to the ground.' This is a crucial step in ensuring the ladder is secure and stable before it is raised, which is critical for firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_250_b894ca57",
          "question": "The member on the right beam (#1) moves to the fly side of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this by stating, 'The member on the right beam (#1) will move to the bed side of the ladder.' Understanding correct positioning is important for maintaining balance and control of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_250_b925c621",
          "question": "The ladder should be held in a vertical position, tilted slightly away from the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this by stating, 'hold the ladder in a vertical position, tilted slightly into the objective.' This is important to ensure the ladder is correctly positioned for firefighters to climb safely and effectively reach their objective.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_250_24105b77",
          "question": "The command 'GROUND THE BUTT' signifies that members should ground the butt and begin raising the ladder to the vertical.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this by stating, '\u201cGROUND THE BUTT\u201d All in one motion, members ground the butt and begin raising the ladder to the vertical.' Understanding this command is crucial for coordinated and safe ladder operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_250_4bb3f4e2",
          "question": "The member on the left beam (#2) moves counterclockwise to the fly side just before vertical position is reached.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this by stating, 'Member on left beam moves clockwise to the fly side just before vertical position is reached.' This is important to ensure correct movement and positioning, which are key for maintaining balance and control of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_236_2c4656ea",
          "question": "The member in charge steps back in after the ladder comes to the vertical position and foots the ladder with the other member.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge steps back in (on the right beam) after the ladder comes to the vertical position and foots the ladder with the other member.' This indicates that the member in charge plays a crucial role in ensuring the ladder's stability, which is essential for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_236_e59def5d",
          "question": "The command 'EXTEND THE FLY' is given by the member on the right beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text does not specify who gives the command 'EXTEND THE FLY'. It only mentions that the two members on the bed side reach for the halyard upon this command. The question is incorrect, as it assumes that the member on the right beam gives this command. Proper communication and command structure are vital in firefighting operations to ensure safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_236_b0b46e30",
          "question": "The member on the fly side assists in bringing the ladder into the building with hands on the beams.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the fly side will assist bringing the ladder into the building with hands on the beams.' This highlights the teamwork required in firefighting operations, and the importance of each member's role in ensuring the ladder is safely and effectively used.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_236_fbaff5c5",
          "question": "When the ladder has reached the desired height, the command 'HIGH' is given by the member in charge.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the ladder has reached the desired height, the member in charge will call out 'HIGH'.' However, it does not specify that the member in charge gives this command. The question is incorrect as it assumes this. Understanding who gives commands during operations is crucial for maintaining order and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_236_74db80d1",
          "question": "Both members on the bed side will have their outside toe in front and against the bed side spurs.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Both members on the bed side will have their outside toe in front and against the bed side spurs.' This indicates the correct positioning of the firefighters when operating the ladder, which is crucial for maintaining balance and safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_261_255963e9",
          "question": "The halyard should be secured after making sure the dogs are locked.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Secure the halyard (Fig. 5.114). Make sure the dogs are locked,' which indicates that the halyard should be secured before ensuring the dogs are locked. This is important for firefighter safety, as a secured halyard can prevent accidental ladder movement.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_261_8908613e",
          "question": "You should tie the rungs of the fly and bed section together in one place.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'tie the rungs of the fly and bed section together in two places.' This contradicts the statement that they should be tied in one place. Tying in two places provides additional stability and safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_261_ea9c9369",
          "question": "The same knot used for securing the fly for climbing is used when there is insufficient halyard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Use the same knot that is used for securing the fly for climbing when there is insufficient halyard.' This supports the statement and indicates the importance of knot-tying skills in different firefighting scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_261_118a1f03",
          "question": "The ladder should be laid on its side before extending the fly.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text says, 'Lay the ladder on its beam, extend the fly to the length of rope to the knot.' This supports the statement and emphasizes the importance of proper ladder positioning for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_261_a6905c49",
          "question": "The first fly section should be tied to the second fly section only if applicable.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If applicable, tie the first fly section to the second fly section in the same way.' This supports the statement and indicates that not all firefighting scenarios will require this step, highlighting the need for adaptability in different situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_220_8d032bf1",
          "question": "The command 'EXTEND THE FLY' is given when the ladder is extended to the desired height.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the ladder is extended to the desired height the command \"HIGH\" is given.' This contradicts the statement in the question. The command 'EXTEND THE FLY' is given to start the extension process, not when the ladder has reached the desired height. This is important for firefighters to understand to ensure proper communication and operation during ladder extensions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_220_d6454bf4",
          "question": "The member on the fly side should use their body weight to manipulate the ladder in or out.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The fly-side member should be using body weight to manipulate the ladder in or out.' This supports the statement in the question. Understanding this technique is crucial for firefighters as it allows for efficient and safe manipulation of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_220_32f74ad3",
          "question": "The two members on the bed side reach for the halyard with their outside hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The two members on the bed side both reach for the halyard with their inside hand.' This contradicts the statement in the question. Proper hand placement is important for firefighters to ensure a smooth and safe extension of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_220_62f542e0",
          "question": "The member on the fly side places both hands on the beams of the bed section at shoulder height to maintain the balance of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the fly side will place both hands on the beams of the bed section, at shoulder height and maintain the balance of the ladder.' This supports the statement in the question. Understanding this technique is crucial for firefighters as it ensures the stability of the ladder during extension, enhancing safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_220_12c9344f",
          "question": "The feet of the members on the bed side should be placed shoulder width apart, one foot ahead of the other.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The feet are placed shoulder width apart, one foot ahead of the other' in reference to the member on the fly side, not the bed side. This contradicts the statement in the question. Proper stance is important for firefighters to maintain balance and control during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_257_1f04e0da",
          "question": "The first member to climb the ladder should pass their right arm between the 1st and 2nd rungs from the tip of the 26' ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the other climbs the extended ground extension ladder and passes the right arm between the 2nd and 3rd rungs from the tip.' This contradicts the statement in the question. The correct procedure is important to ensure stability and safety while climbing.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_257_fd3b000e",
          "question": "The member at the tip will lock-in above the roof, parapet or sill and withdraw the arm from between the rungs or body loop while setting the tip of the 26' ladder onto the edge of objective.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member at the tip will lock-in above the roof, parapet or sill and withdraw the arm from between the rungs or body loop while setting the tip of the 26' ladder onto the edge of objective.' This supports the statement in the question. This procedure is crucial for ensuring the ladder is secured in place, which is a key safety consideration.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_257_4d8a465f",
          "question": "The member on the bottom will then continue to climb until the 26' ladder reaches the balance point on the objective.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the bottom will then continue to climb until the 26' ladder reaches the balance point on the objective.' This supports the statement in the question. Proper positioning of the ladder is important for stability and safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_257_69dbb7f9",
          "question": "The member on the bottom will withdraw the arm from between the rungs or body loop so that the member on top can tip the ladder into the room or onto the roof.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the bottom will withdraw the arm from between the rungs or body loop so that the member on top can tip the ladder into the room or onto the roof.' This supports the statement in the question. This procedure is crucial for ensuring the ladder is properly positioned for entry or exit, which is a key tactical consideration.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_257_7c118234",
          "question": "The member that is locked in will assist by pushing the ladder off its beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member that is locked in will assist by keeping the ladder balanced on its beam.' This contradicts the statement in the question. The correct procedure is important to maintain the ladder's stability, which is a key safety consideration.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_191_915819a2",
          "question": "The command 'LIFT' is used to indicate the ladder coming horizontally off the ground into the member\u2019s hands or to the shoulders.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This shouldn\u2019t be confused with the command \u201cLIFT\u201d, which is the command for the ladder coming horizontally off the ground into the member\u2019s hands or to the shoulders.' This means that the command 'LIFT' is used to indicate the movement of the ladder from the ground to the firefighter's hands or shoulders. This is important for firefighters to understand as it ensures smooth and safe operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_191_a61ecd79",
          "question": "'RELEASE THE HALYARD' command is given when the member on the left beam unties the halyard.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '\u201cRELEASE THE HALYARD\u201d - The halyard is untied by the member on the right beam.' This contradicts the statement as it is the member on the right beam, not the left, who unties the halyard. Understanding this is crucial for firefighters as it helps ensure the correct execution of commands and safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_191_0fdeeef3",
          "question": "'SECURE THE TIP' command is given when the tip of the ladder is secured to the building with a ladder anchor.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '\u201cSECURE THE TIP\u201d - The tip of the ladder (fly section) will be secured to the building with a ladder anchor.' This supports the statement that the 'SECURE THE TIP' command is given when the tip of the ladder is secured to the building. This is a critical command for firefighters to understand as it ensures the stability of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_191_a20d67d3",
          "question": "'SET' command is given when the ladder is in the proper position for climbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '\u201cSET\u201d - The command given when the member moving with a tormentor pole has reached their ready position and is prepared for the next action.' This contradicts the statement as the 'SET' command is given when the member is ready for the next action, not when the ladder is in the proper position for climbing. Understanding this command correctly is vital for firefighters as it ensures proper coordination and safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_191_ededc0da",
          "question": "'STOW THE LADDER' command is given when the ladder is returned to the apparatus or storage area, tip first.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, '\u201cSTOW THE LADDER\u201d - Return the ladder to the apparatus or storage area, tip first.' This supports the statement that the 'STOW THE LADDER' command is given when the ladder is returned to the apparatus or storage area. Understanding this command correctly is important for firefighters as it ensures proper handling and storage of equipment, thereby preventing damage and ensuring readiness for future operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_200_cbfa38ce",
          "question": "Two members are positioned on each side of the ladder rack at the rear of the apparatus during a Flat Carry operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Two members are positioned on each side of the ladder rack at the rear of the apparatus.\" This statement directly supports the question. The positioning of the members is critical for the safe and efficient removal of the ladder from the rack, which is a key aspect of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_200_f0c1d1a2",
          "question": "The ladder should be pulled completely out of the rack during the Flat Carry operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"Use caution so that the ladder is not pulled completely out of the rack and falls to the ground.\" This statement directly contradicts the question. Pulling the ladder completely out of the rack could result in it falling, which could cause injury or damage to equipment. This is a key safety consideration in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_200_aa7197ef",
          "question": "The member at the right butt position gives the command 'To the shoulder' when the ladder is free of the ladder rack.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"When the ladder is free of the ladder rack and the member at the right butt position gives the command 'To the shoulder,'\" This statement directly supports the question. The command is important for coordinating the team's actions and ensuring the ladder is safely and efficiently moved to its destination, which is a key aspect of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_200_95acf4cf",
          "question": "When five members are available, the ladder is carried by all five during the Flat Carry operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"When five members are available, the ladder is carried with four, allowing the member in charge to stand out and spot the ladder.\" This statement directly contradicts the question. The fifth member has a different role, which is to spot the ladder. This is a key tactical consideration in firefighting operations, as it ensures the ladder is positioned correctly and safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_200_3394092d",
          "question": "The ladder is grasped between the second and third rungs from the tip just before it is free of the ladder rack.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"The two remaining members, positioned on each side of the beams, grasp the ladder between the second and third rungs from the tip just before it is free of the ladder rack.\" This statement directly supports the question. The specific point at which the ladder is grasped is important for maintaining control of the ladder during the operation, which is a key safety consideration in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_216_251e6910",
          "question": "When shifting right, the member will move to the right beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Seattle Fire Department shift right,' the member will move to the left beam. This indicates that when shifting right, the member moves to the left beam, not the right. This is crucial for firefighters to understand as it affects their positioning and movement when handling ladders during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_216_6e6e1230",
          "question": "When lifting the ladder, the member should use their back muscles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the member will lift the ladder off the ground using the leg muscles (not the back)'. This contradicts the question statement. It's important for firefighters to use their leg muscles to prevent back injuries, which could hinder their performance and safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_216_bca69fba",
          "question": "Before lifting the ladder, the path that the ladder will take is checked to assure that there are no overhead obstructions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The next action is to state \"OVERHEAD CLEAR\"; the path that the ladder will take is checked to assure that there are no overhead obstructions.' This supports the question statement. Checking for overhead obstructions is a crucial safety measure to prevent accidents during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_216_8b167b35",
          "question": "After the 'HALT - LOWER' command, the member will immediately set the ladder to the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the member will take one additional step forward then bring the feet together and come to a stop, set the ladder to the ground, and then foot the ladder.' This contradicts the question statement. The member does not immediately set the ladder to the ground after the 'HALT - LOWER' command, they first take an additional step forward. This is important for maintaining balance and control over the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_216_92b0907c",
          "question": "When shifting left, your left hand will be lifting the ladder on the bed section.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If you are shifting left, your left hand will be lifting the ladder on the bed section.' This supports the question statement. Understanding the correct hand positioning when shifting the ladder is important for maintaining control over the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_241_21b90244",
          "question": "The ladder should be placed on the ground, fly side down before raising.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the ladder on the ground, fly side up.' This contradicts the statement that the ladder should be placed fly side down. The positioning of the ladder is crucial for the safety and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_241_462d83d3",
          "question": "Before raising the ladder, it is necessary to check overhead for wires and obstructions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Response: Check overhead for wires & obstructions then \" OVERHEAD CLEAR \"'. This supports the statement that it is necessary to check overhead before raising the ladder. This step is essential to ensure the safety of firefighters and the effectiveness of the operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_241_8ef78a74",
          "question": "Only one bed-side member is needed to lift the tip off the ground and walk up the beams.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, '\u201cRAISE\u201d the two bed-side members will lift the tip off the ground and walk up the beams hand - over -hand'. This contradicts the statement that only one bed-side member is needed. Having two members ensures the stability of the ladder during the operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_241_1133e0e8",
          "question": "Each member slides their inside foot down the beam to the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Each member slides their outside foot down the beam to the ground'. This contradicts the statement that each member slides their inside foot down the beam. Correct footwork is important for maintaining balance and control while handling the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_241_2affb559",
          "question": "The tip of the boot should remain in contact with the beam after stepping back.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'step back with the inside leaving the tip of the boot in contact with the beam'. This supports the statement that the tip of the boot should remain in contact with the beam. This technique helps to maintain control of the ladder during the operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_187_9ade9e13",
          "question": "The maximum number of people permitted on a ground ladder less than 30 feet is 3.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Length or Type of Ladder Maximum Load Less than 30 feet 2'. This contradicts the statement that 3 people are permitted on a ladder less than 30 feet. Overloading a ladder can lead to instability or failure, posing a serious safety risk to firefighters and anyone they may be rescuing.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_187_1e27ac8f",
          "question": "The loads exerted on ladders for drill purposes or normal fire ground operations should not exceed 750lbs.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Loads exerted on these ladders for drill purposes or normal fire ground operations should not exceed 750lbs.' This supports the statement. Exceeding the recommended load can compromise the structural integrity of the ladder, potentially leading to a collapse and endangering firefighters and victims.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_187_40bc86d0",
          "question": "The member in charge should be positioned on the left beam of the ladder during the removal and carrying of ladders.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'The officer, or member in charge, should be positioned on the right beam of the ladder during the removal and carrying of ladders.' This contradicts the statement that the member in charge should be on the left. Proper positioning is crucial for effective communication and coordination during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_187_93675c2b",
          "question": "Ladder commands must be spoken clearly and loud enough to be heard by all members of the ladder team.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Ladder commands must be spoken clearly and loud enough to be heard by all members of the ladder team.' This supports the statement. Clear communication is essential for safe and effective ladder operations, especially in noisy fire ground environments.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_187_947b82d0",
          "question": "When the ladder is in position, the member on the left beam will give the commands to complete the raise and placement of the ladder into the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'When the ladder is in position, the member on the right beam (or right pole when applicable) will give the commands to complete the raise and placement of the ladder into the objective.' This contradicts the statement that the member on the left beam gives the commands. Miscommunication or misunderstanding of commands can lead to operational errors or safety hazards.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_186_a8616f43",
          "question": "Ladders have their greatest strength when in a horizontal position. True or False?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ladders have their greatest strength when in a vertical position and their least strength in a horizontal position.' This directly contradicts the question statement. Understanding this concept is crucial for firefighters as it affects the safety and stability of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_186_ffebc75b",
          "question": "The proper angle for setting a ladder is generally accepted as about 70 degrees from horizontal. True or False?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This is considered to be about 70 degrees (from horizontal).' This directly supports the question statement. This knowledge is important for firefighters as setting the ladder at the correct angle ensures safety and ease of climbing during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_186_94b86a8b",
          "question": "All extension ladders are raised with the fly section(s) away from the building. True or False?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'All extension ladders are raised with the fly section(s) toward the building.' This directly contradicts the question statement. This is a key operational consideration for firefighters when using extension ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_186_f6e0338c",
          "question": "The butt of the ladder should be a fixed distance out from the surface supporting the top of the ladder, generally accepted as one quarter of the height from the ground to the point where the ladder rests against the objective. True or False?",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'To achieve this angle, the butt of the ladder should be a fixed distance out from the surface supporting the top of the ladder. This is generally accepted as one quarter of the height from the ground to the point where the ladder rests against the objective.' This directly supports the question statement. This is a critical safety consideration for firefighters when setting up ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_186_5ca05005",
          "question": "A simple way to determine if a ladder is set at the proper angle for climbing is to take a standing position with your toes against the ladder spurs, extend your arms straight out, and your fingers should fall on the rung at about waist level. True or False?",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A simple and effective way to determine if a ladder is set at the proper angle for climbing is to take a standing position with your toes against the ladder spurs, extend your arms straight out, and your fingers should fall on the rung at about shoulder level.' This directly contradicts the question statement. Understanding this technique is important for firefighters to ensure the ladder is set at a safe and climbable angle.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_240_17ff5966",
          "question": "The member in charge is solely responsible for checking the overhead area for obstructions before raising the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"The member in charge, the member on the right beam or right butt will check the overhead area for obstructions and state 'OVERHEAD CLEAR.' It is the responsibility of all personnel survey of the area where a ladder is to be raised.\" This statement contradicts the question because it indicates that checking for overhead obstructions is a shared responsibility among all personnel, not just the member in charge. This is important for firefighting operations as it ensures the safety of all personnel involved in the operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_240_b8416de7",
          "question": "The left foot should be placed on the bottom rung when footing the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"The member will foot the ladde r with the left foot on the bottom rung while holding onto the fourth rung up from the spur with both hands.\" This statement supports the question by specifying that the left foot should be placed on the bottom rung when footing the ladder. This is a key operational detail for firefighters to ensure stability and safety when using ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_240_1b8adfd1",
          "question": "The halyard should be left loose during the ladder operation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"Secure the halyard.\" This statement contradicts the question by indicating that the halyard should be secured, not left loose, during ladder operations. This is critical for firefighting safety as a loose halyard can lead to instability of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_240_eb3343ae",
          "question": "To lower the ladder, the process of raising it should be reversed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"To lower the ladde r \u2022 Reverse the process.\" This statement supports the question by indicating that the process of lowering the ladder is simply the reverse of raising it. Understanding this process is crucial for firefighters to ensure safe and efficient operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_240_f524a6a9",
          "question": "The command 'READY HALT' is given before the ladder is raised.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Command ' READY HALT ' \u2022 Command ' LOWER THE LADDER '\" This statement supports the question by indicating that the command 'READY HALT' is given before the ladder is raised. This command is crucial for coordinating the actions of the firefighting team and ensuring safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_217_48379da2",
          "question": "The member on the bed side of the ladder slaps the left beam when the command 'PREPARE TO SHIFT -RIGHT' is given.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the bed side of the ladder will slap the right beam when the command is given.' This contradicts the statement in the question, as the member on the bed side slaps the right beam, not the left. This is crucial for coordinated ladder movement during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_217_b0b8209b",
          "question": "The next action after stating 'OVERHEAD CLEAR' is to lift the ladder off the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The next action is to state \"OVERHEAD CLEAR\"; the path that the ladder will take is checked to assure that there are no overhead obstructions. The next command will be \"LIFT \u201d, the members will lift the ladder off the ground.' This supports the statement in the question. It is important to ensure there are no overhead obstructions before lifting the ladder for safety reasons.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_217_7b2763a7",
          "question": "The ladder is lifted using the back muscles, not the leg muscles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the members will lift the ladder off the ground in unison using the leg muscles (not the back).' This contradicts the statement in the question, as the ladder is lifted using the leg muscles, not the back. This is important for firefighter safety to prevent back injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_217_f244f3a4",
          "question": "The bed side member watches the tip for obstructions during ladder movement.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The bed side member watches the ground and the fly side member watches the tip for obstructions.' This contradicts the statement in the question, as it is the fly side member who watches the tip for obstructions. This is crucial for safe ladder operation and movement.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_217_b176511f",
          "question": "After the command 'HALT - LOWER', the members set the ladder to the ground and then foot the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The next command is \" HALT - LOWER \", the members will take one additional step forward then bring the feet together and come to a stop, set the ladder to the ground, and then foot the ladder.' This supports the statement in the question. Properly footing the ladder after it is set down is important for stability and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_201_9aff9f50",
          "question": "When positioning a ladder for raising, it is always best to approach the building parallel to the building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When positioning a ladder for raising, approach the building at a 90 degree angle whenever possible. For safety purposes, approach parallel to the building only if space does not allow a perpendicular access.' This implies that the preferred approach is at a 90 degree angle, and a parallel approach is only used when space is limited. This is important for firefighter safety and effective ladder positioning.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_201_1c6e282c",
          "question": "Ladders are normally positioned into the right side of the window or opening when ready for climbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ladders are normally positioned into the left side of the window or opening when ready for climbing so that the ladder can be exited on the member's right.' This contradicts the statement in the question. Proper ladder positioning is crucial for firefighter safety and efficiency during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_201_2dae5c1a",
          "question": "The ultimate factor governing the final position of the ladder will be dependent on fire conditions, anticipated future conditions and wind.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The ultimate factor governing the final position of the ladder will be dependent on fire conditions, anticipated future conditions and wind.' This supports the statement in the question. Understanding this helps firefighters make informed decisions about ladder positioning in different fire scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_201_2e31faae",
          "question": "For rescue operations, the tip of the ladder should be placed immediately above the lower edge or sill of the opening.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'RESCUE Place the tip of the ladder immediately below the lower edge or sill of the opening and remove people over the sill and down the ladder.' This contradicts the statement in the question. Correct positioning of the ladder is crucial for successful rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_201_46c632a7",
          "question": "If the window or opening is too small to accommodate the width of the ladder, the ladder tip should be placed below the opening.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'ACCESS If the window or opening is too small to accommodate the width of the ladder and allow people to climb on or off, place the ladder tip below the opening as one would for rescue.' This supports the statement in the question. Understanding this can help firefighters make appropriate decisions about ladder placement in challenging scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_190_40bd9663",
          "question": "The command 'ON THE (RIGHT OR LEFT) BEAM, PIVOT IN' is used to pivot the ladder toward the flies on the designated beam.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The ladder is pivoted toward the flies on the designated beam.' This command is crucial for positioning the ladder accurately during operations, affecting both safety and effectiveness of firefighting efforts.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_190_54908c35",
          "question": "The command 'ONCE AROUND' is used in real firefighting operations to rotate positions among the team members.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This command is generally used only for training purposes to ensure that all members get an equal chance to practice in each position.' Therefore, it is not typically used in real operations, but for training to ensure all members are proficient in all positions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_190_82025226",
          "question": "The command 'OUT FROM THE BUILDING' is given to move the ladder to a horizontal position away from the building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The tip of the ladder is pulled away from the building to a vertical position.' This command is used to position the ladder vertically, not horizontally, which is crucial for safe and effective ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_190_1e4a70fb",
          "question": "The command 'OVERHEAD CLEAR' is issued to indicate that the area above the ladder is free of obstructions before raising or passing the poles on a tormentor ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The statement issued prior to raising, or prior to passing the poles on a tormentor ladder, to indicate that the area above the ladder is clear of wires or obstructions.' This command is important for safety, to ensure there are no obstructions that could interfere with ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_190_8b1f7282",
          "question": "The command 'PREPARE TO RAISE' is a preparatory command which precedes the command 'LOWER.'",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The preparatory command which precedes the next command, \u201cRAISE.\u201d' This command is used to prepare the team to raise the ladder, not lower it, which is important for coordinating team efforts during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_256_af26462e",
          "question": "The hooks of the roof ladder should face towards the ground ladder when descending the ground ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The hooks of the roof ladder are now facing out from the ground ladder.' This indicates that the hooks of the roof ladder should be facing towards the ground ladder when descending. This is important for ensuring the correct positioning and securement of the ladder, which is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_256_3f302b7a",
          "question": "The beams of the roof ladder should not straddle the chosen beam of the ground extension ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ensure the beams of the roof ladder are straddling the chosen beam of the ground extension ladder.' This contradicts the statement in the question. The correct positioning of the ladder beams is critical for stability and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_256_f8fddb2c",
          "question": "The 26' ladder should be laid on the ground at the base of the ground ladder with the right spur of the 26' ladder next to the left beam of the extended ground extension ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The 26' ladder is laid on the ground at the base of the ground ladder with the left spur of the 26' ladder next to the right beam of the extended ground extension ladder.' This contradicts the statement in the question. Correct positioning and alignment of ladders is crucial for safety and efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_256_dd97cc91",
          "question": "If the members use body loops to carry the 26' ladder up the ground extension ladder, they would use a hose knot.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the members use body loops to carry the 26' ladder up the ground extension ladder, they would use a hose knot.' This supports the statement in the question. Understanding the correct techniques for carrying and securing ladders is essential for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_256_2a5ba118",
          "question": "The 26' ladder is raised to the vertical position and pivoted out on the right beam so that it can be laid onto the rungs next to the left beam of the extended ground ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The 26' ladder is raised to the vertical position and pivoted out on the left beam so that it can be laid onto the rungs next to the right beam of the extended ground ladder.' This contradicts the statement in the question. Correct positioning and alignment of ladders is crucial for safety and efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_221_a602a579",
          "question": "Only the member on the right beam manipulates the halyard when lowering the flies on any ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When lowering the flies on any ladder only the member on the right beam manipulates the halyard.' This supports the statement. The member on the right beam has the responsibility to manipulate the halyard, which is crucial for maintaining control and safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_221_b9fa17c9",
          "question": "It is recommended to let the halyard slide through your hands while lowering the flies of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not let the halyard slide through your hands.' This contradicts the statement. Letting the halyard slide through the hands can lead to loss of control over the ladder, posing safety risks to firefighters and potentially compromising operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_221_99c3849d",
          "question": "After the fly is extended, the dogs are locked, and the ladder is into the building, the fly section must be secured.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'After the fly is extended, the dogs are locked, and the ladder is into the building, the fly section must be secured.' This supports the statement. Securing the fly section is a critical step in ensuring the stability and safety of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_221_dd0ffe6e",
          "question": "When sufficient halyard is available, the excess is pushed from the bed side of the ladder between rungs 2 and 3, then pulled back toward the member between 3 and 2.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When sufficient halyard is available, the excess is pushed from the bed side of the ladder between rungs 3 and 4, then pulled back toward the member between 3 and 2.' This contradicts the statement. Misunderstanding the correct procedure for handling excess halyard could lead to improper ladder setup, potentially compromising firefighter safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_221_0e067f19",
          "question": "A round turn is made around rung 3 and two half- hitches are placed above the rung around the halyard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A round turn is made around rung 3 and two half- hitches are placed above the rung around the halyard.' This supports the statement. Correctly tying the halyard is crucial for securing the ladder, which is a key aspect of ensuring firefighter safety and operational effectiveness during building entry.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_260_a714c19c",
          "question": "The member on the ground does not assist in guiding the ladder while it is being hoisted.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the ground steadies the ladder and assists in guiding it while being hoisted.' This contradicts the question statement. The ground member plays a crucial role in ensuring the ladder is hoisted correctly and safely, which is critical for firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_260_d12d4fc0",
          "question": "The ladder is hoisted with the bed side facing away from the building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Pivot the ladder so that the bed side is toward the building before hoisting.' This contradicts the question statement. The orientation of the ladder is important for the safety of firefighters and the efficiency of their operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_260_9a624755",
          "question": "When lowering the ladder, the knot should be on the outside of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The ladder is lowered bed side out with the knot on the outside of the ladder.' This supports the question statement. The placement of the knot is important for the safe and effective lowering of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_260_a26a6bb3",
          "question": "When measuring the distance for a Ground Extension Ladder from an Overpass or a Parapet Wall, you should add six feet to the measured length.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Drop a rope or line to measure the distance from the bottom of the pit or well to the edge, rail or wall at your elevation and add six feet to that length.' This supports the question statement. The additional six feet ensures that the ladder extends over the wall once it is in its final climbing position, which is crucial for firefighter safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_260_cb488be5",
          "question": "The flies of the ladder should be extended to less than the length of the measured rope.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Utilizing the halyard, extend the flies of the ladder out to equal the length of the measured rope.' This contradicts the question statement. The extension of the flies to the exact length of the measured rope ensures that the ladder reaches the necessary height for the operation, which is critical for firefighter safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_237_0f559465",
          "question": "The member on the right beam, bed side, is responsible for securing the halyard.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" SECURE THE HALYARD \" The member on the right beam, bed side, will secure the halyard.' This indicates that the member on the right beam, bed side, is indeed responsible for securing the halyard. This is a critical task as the halyard is used to raise and lower the ladder, affecting the safety and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_237_ab58ab97",
          "question": "The member on the fly side is responsible for releasing the ladder anchor from the tip.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" RELEASE THE TIP\u201d The member on the fly side as it was lowered into the building will release the ladder anchor from the tip.' This shows that the member on the fly side is responsible for releasing the ladder anchor from the tip. This is a crucial step in the process of lowering the ladder, impacting the safety and efficiency of the operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_237_cdfc8fae",
          "question": "The member on the left beam is responsible for lowering the flys hand-over-hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Command \" LOWER THE FLY \" The member on the bed side right beam will lower the flys hand-over-hand.' This contradicts the statement, as it is the member on the right beam, not the left, who is responsible for lowering the flys hand-over-hand. This task is important for maintaining control of the ladder during lowering operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_237_b9d6a3fa",
          "question": "The member in charge on the right beam will check for obstructions and personnel before stating 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.'",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'At this time, the member in charge on the right beam (#1) will step out to a position to observe the direction in which the ladder will be lowered and check for obstructions and personnel before stating \"OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.\"' This confirms the statement and highlights the importance of safety checks in preventing accidents during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_237_4b4a3f93",
          "question": "The members on the bed side will foot the ladder with their outside foot on the bottom rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members on the bed side will foot the ladder with their inside foot on the bottom rung while holding onto the fourth rung up from the spur with the inside hand on the rung and the outside hand on the beam.' This contradicts the statement, as it is the inside foot, not the outside, that is used to foot the ladder. This is a key safety measure to ensure stability during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_189_50f2ebc5",
          "question": "The 'GROUND THE BUTT' command is given to lower the butt end of the ladder prior to raising it to the vertical during cradle and beam carries.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'GROUND THE BUTT - A command given to lower the butt end of the ladder prior to raising it to the vertical. (Used in cradle and beam carries).' This supports the statement and indicates the importance of clear communication during ladder operations for firefighter safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_189_507254ff",
          "question": "The 'HIGH' command is issued when the ladder is at the desired height and it is locked at the next lowest rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'HIGH - The command issued when the fly is at the desired height. The fly is then locked at the next highest rung.' This contradicts the statement. The correct procedure is to lock the fly at the next highest rung, not the lowest. This is crucial for maintaining the stability and safety of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_189_68c662d8",
          "question": "The 'INTO THE BUILDING' command is given when the ladder is being lowered into the building, and the members on the bed side of the ladder must ensure that their inside foot is placed on the bottom rung.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'INTO THE BUILDING - The member(s) on the bed side of the ladder, with the member on the fly side assisting them, lower the ladder into the building... the members on the bed side of the ladder (during a 3 person evolution) must ensure that their inside foot is placed on the bottom rung.' This supports the statement and highlights the importance of proper positioning and teamwork in safely maneuvering the ladder into a building during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_189_23dcf5dc",
          "question": "The 'LIFT' command is given when the member lifts the ladder and moves in the opposite direction indicated.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'LIFT (pause) SHIFT - The member lifts the ladder and moves in the direction indicated.' This contradicts the statement. The correct procedure is for the member to move in the direction indicated, not the opposite. This is important for coordinated movement and safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_189_6b687da2",
          "question": "The 'LOWER THE FLY' command is always given to the member on the right beam to lower the fly sections.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'LOWER THE FLY - The member on the right beam lowers the fly section(s)... If a ladder were ever to have the halyard come from the left side of the pulley on a 3 person evolution the member on the left would lower the fly.' This contradicts the statement. The command is typically given to the member on the right, but in certain situations, the member on the left may lower the fly. This shows the need for flexibility and understanding of equipment in different scenarios for effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_218_440b9572",
          "question": "While extending the ladder, the right shin should be used to push against the right beam to keep the ladder balanced.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'While extending the fly section keep the ladder balanced by using your right shin to \u201cpush\u201d against the right beam.' This supports the statement and indicates that using the right shin to push against the beam is a technique for maintaining ladder balance, which is crucial for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_218_2e4dfd0c",
          "question": "If the ladder begins to lean away too far, the halyard should be pushed until control is regained.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the ladder begins to lean away from you too far, pull back on the halyard until you regain control.' This contradicts the statement, indicating that the halyard should be pulled, not pushed, to regain control of the ladder. This is important for maintaining control and safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_218_2944f76e",
          "question": "When the command 'HIGH' is given, the fly is locked at the next highest rung.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the command \"HIGH\" is given the fly is locked at the next highest rung.' This supports the statement and shows the importance of understanding and following commands during ladder operations, which can impact firefighter safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_218_e4d4ee8a",
          "question": "It is safe to reach through a rung space or touch a rung with the hands or feet while extending the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'At no time shall any member reach through a rung space or touch a rung with the hands or feet until all dogs are locked.' This contradicts the statement, indicating that it is unsafe to reach through a rung space or touch a rung during ladder extension. This is a critical safety consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_218_37642207",
          "question": "The toe of the right foot should be positioned in a place where the fly section could drop.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Be sure the toe is not in a position where the fly section could drop.' This contradicts the statement, indicating that the toe should not be positioned where the fly section could drop. This is important for firefighter safety to avoid potential injuries during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_259_c134daa5",
          "question": "The rope is run down the bed side from the destination above in the Seattle Fire Department's ladder operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The rope runs down the bed side from the destination above.' This is a key step in the ladder operation process, ensuring that the ladder can be controlled and moved accurately. Understanding this is crucial for firefighters as it affects their ability to safely and effectively use ladders during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_259_388674a1",
          "question": "A bowline with a bight is tied where the bight crosses the rope that leads to the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A bowline with a bight is tied where the bight crosses the rope that leads to the destination.' This indicates that the bowline with a bight is tied where the bight crosses the rope leading to the destination, not the ground. This is important for firefighters to understand as it affects the stability and control of the ladder during hoisting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_259_4a2abbb8",
          "question": "The ladder is pivoted 90 degrees as it begins to leave the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder is pivoted 180 degrees as the ladder begins to leave the ground.' This means that the ladder is turned completely around, not just 90 degrees. This is a critical detail for firefighters to understand as it affects the positioning of the ladder during hoisting, which in turn can impact safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_259_08faea62",
          "question": "The tip of the ladder is kept away from the building to prevent it from getting caught on objects as it goes up.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This will keep the tip of the ladder out from the building and the butt against the building, helping to prevent the tip from getting caught on objects as it goes up.' This is a crucial safety measure during ladder operations to prevent accidents and ensure smooth operation. Firefighters must understand and follow this guideline to ensure their safety and the success of their operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_259_65e4a6e3",
          "question": "A half hitch can be tied to one spur to help control the ladder from the ground if there is not enough rope available.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'At this time a half hitch can be tied to one spur to help control the ladder from the ground if enough rope is available.' This means that the half hitch is tied only when there is enough rope, not when there is a lack of it. This is an important detail for firefighters to understand as it affects the control of the ladder from the ground, which can impact safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_222_5b8f2388",
          "question": "When sufficient halyard is available, the excess is pulled from the fly side of the ladder between rungs 2 and 3.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When sufficient halyard is available, the excess is pulled from the fly side of the ladder between rungs 2 and 3.' This indicates that the excess halyard is indeed pulled from the fly side of the ladder when there is sufficient halyard available. This is important for firefighters to understand as it affects how they would secure the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_222_b0b2c535",
          "question": "If an insufficient length of halyard is available due to minimum extension of the ladder, the fly must be secured by using a utility strap.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If an insufficient length of halyard is available due to minimum extension of the ladder, the fly must be secured by using a utility strap.' This indicates that a utility strap is used to secure the fly when there is insufficient halyard length. This is a crucial safety measure for firefighters to understand and implement.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_222_5ec56c0c",
          "question": "The member securing the fly should have the right foot on the bottom rung of the ladder to keep the butt from sliding out when pulling on the halyard.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member securing the fly shall have the left foot on the bottom rung of the ladder to keep the butt from sliding out when pulling on the halyard.' This contradicts the statement that the right foot should be on the bottom rung. This is a critical safety measure for firefighters to prevent the ladder from sliding while securing the fly.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_222_a6525562",
          "question": "Any excess halyard that is left after tying will be pushed through to the fly side of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Any excess halyard that is left after tying will be pushed through to the fly side of the ladder.' This indicates that any remaining halyard after tying is indeed pushed to the fly side of the ladder. This is important for firefighters to know to ensure proper ladder setup and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_222_5aea74a5",
          "question": "A round turn is made around rung 2 when sufficient halyard is available.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A round turn is made around rung 3 and two half-hitches are placed above the rung around the halyard.' This contradicts the statement that a round turn is made around rung 2. Understanding the correct rung to make a round turn on is crucial for firefighters to ensure the stability and safety of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_263_d6b77bb6",
          "question": "The ladder should be placed with the bed side up and the spurs hanging over the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Place the ladder bed side down with the spurs hanging over the objective'. This means the ladder should be placed with the bed side down, not up. The correct positioning of the ladder is crucial for stability and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_263_3d3580eb",
          "question": "The rope should be laid straight under the ladder toward the tip.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'the rope laying straight under the ladder toward the tip'. This indicates that the rope should be laid in this manner, which is important for controlling the ladder during positioning and raising.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_263_f181396d",
          "question": "Only two members are needed to carry the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Four members carry the ladder'. This contradicts the statement that only two members are needed. The number of firefighters required to carry a ladder depends on its size and weight, and having the correct number of people is important for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_263_45e61a5e",
          "question": "Members should position themselves along the ladder, one on the right beam and one on the left beam at the center of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states 'Three to four members will position themselves along the ladder, one on the right beam and one on the left beam at the center of the ladder'. This supports the statement and is important for maintaining balance and control of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_263_0adc297c",
          "question": "Depending on the size of the ladder, three or four members will work the rope.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'Depending on the size of the ladder, one or two members will work the rope'. This contradicts the statement that three or four members will work the rope. The number of firefighters working the rope should be appropriate for the size of the ladder, to ensure safe and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_234_4b35d5a8",
          "question": "The member on the bed side is responsible for lowering the fly hand-over-hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Command \"LOWER THE FLY\" The member on the bed side will lower the fly hand-over-hand.' This statement is false because it is the member on the bed side who lowers the fly. This is important for firefighters to understand as it affects the division of responsibilities during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_234_4d6212fc",
          "question": "Before lowering the ladder, the member footing the ladder on the bed side checks for obstructions and personnel.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member footing the ladder on the bed side will check the direction in which the ladder will be lowered for obstructions and personnel and state \"OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.\"' This statement is true and highlights the safety precautions taken during ladder operations to prevent accidents.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_234_39d6ed45",
          "question": "The member on the fly side of the ladder is responsible for lifting the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Command \" LIFT \" The ladder is lifted.' However, it does not specify that the member on the fly side is responsible for lifting the ladder. This statement is false and emphasizes the importance of understanding each member's role during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_234_4cb9a639",
          "question": "The ladder is returned tip first to the apparatus when the command 'STOW THE LADDER' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" STOW THE LADDER \" The members will return the ladder tip first to the apparatus.' This statement is true and highlights the correct procedure for returning the ladder to the apparatus, which is important for maintaining the equipment's condition and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_234_db6efea4",
          "question": "The Beam Raise Three Members is accomplished differently than a two member beam raise.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Beam Raise Three Members 35' or Less Ground Extension Ladders This raise is accomplished the same as a two member beam raise with the exception that after spotting the ladder to the correct location, and after it has come to the vertical position, the member in charge (#1) will step in at the right beam.' This statement is true and highlights the difference in procedures between a two member and three member beam raise, which affects coordination and teamwork during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_185_d21e6e2e",
          "question": "The member in charge of ladder operations should always be the one carrying the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"NOTE : If a sufficient number of members are available to carry the ladder, the officer may opt to stand out and give commands.\" This statement contradicts the question. The member in charge, often an officer, does not always have to carry the ladder. They may choose to stand out and give commands if there are enough members to handle the ladder. This allows the officer to have a better view of the situation and direct operations more effectively, enhancing safety and efficiency on the fireground.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_185_04b5db43",
          "question": "The member in charge of ladder operations must be able to issue all commands and directions necessary for ladder movements.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Members will be able to take charge o f a ladder and issue all the commands and directions necessary to accomplish needed movements of a ladder.\" This statement supports the question. The member in charge must be able to direct all aspects of ladder operations. This is crucial for maintaining coordination and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_185_1397be96",
          "question": "When using tormentor poles, the member in charge should be on the left pole.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"When using to rmentor poles, the member in charge will be on the right pole.\" This statement contradicts the question. The member in charge should be on the right pole when using tormentor poles. This is a specific operational procedure that ensures consistency and coordination during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_185_79c352f1",
          "question": "For a 3 member flat carry, the member in charge should be on the right beam, at the center or butt.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"On the right beam, at the center or butt, for a 3 member flat ca rry.\" This statement supports the question. The member in charge should be in a specific position for different types of carries to ensure effective command and control over ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_185_e814cfb2",
          "question": "Commands given by the member in charge during ladder operations can be in a soft, unclear voice as long as they are prompt and exact.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"Commands shall be given by the member in charge in a loud, clear, a nd concise voice: prompt and exact re sponse is require d.\" This statement contradicts the question. Commands must be loud and clear to ensure they are heard and understood by all members, which is vital for safety and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_243_f1812f83",
          "question": "The member in charge is the one on the left beam at the butt of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge (the member on the right beam at the butt) will check the overhead area for obstructions and state \"OVERHEAD CLEAR.\"' This contradicts the statement that the member in charge is on the left beam. The member in charge has the responsibility of checking for overhead obstructions, which is crucial for ensuring the safety of the team when raising the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_243_0dd573cd",
          "question": "It is the responsibility of the member in charge alone to survey the area where a ladder is to be raised.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is the responsibility of all personnel to survey the area where a ladder is to be raised.' This contradicts the statement that it is the responsibility of the member in charge alone. This is important for firefighting operations as it ensures that all team members are aware of potential hazards in the area.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_243_3246a8c0",
          "question": "The command 'LIFT' is given before the ladder is placed on the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The command \u201cLIFT\u201d has been given and executed \u2022 Command \" READY HALT \" \u2022 Command \" LOWER THE LADDER \" Place the ladder on the ground, fly side up.' This supports the statement that the command 'LIFT' is given before the ladder is placed on the ground. Understanding the sequence of commands is crucial for effective and safe ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_243_21f82db8",
          "question": "The member on the left beam at the butt will move to the tip of the ladder to help pass the poles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the left beam at the butt (#4) will move to the butt of the ladder between the spurs and prepare to pass the poles.' This contradicts the statement that the member on the left beam at the butt will move to the tip of the ladder. Understanding each member's role and position is important for efficient ladder operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_243_c3f035f3",
          "question": "The two members at the tip stay in their positions to help pass the poles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The two members at the tip will stay in their positions to help pass the poles.' This supports the statement that the two members at the tip stay in their positions to help pass the poles. This highlights the importance of teamwork and coordination in firefighting operations, especially when handling equipment such as ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_214_5aeb1a77",
          "question": "If the command is IN, you should pull IN on the ladder with the pole so the beam furthest away from you comes off the ground slightly.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If the command is IN, push IN on the ladder with the pole so the beam closest to you comes off the ground slightly.' This contradicts the statement in the question. Understanding these commands is crucial for firefighters as it directly affects their ability to position the ladder correctly during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_214_12a0d15c",
          "question": "The member in charge gives the command for the ladder movement.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge gives the command \u201cON THE LEFT BEAM, PIVOT OUT\u201d'. This supports the statement in the question. The member in charge plays a crucial role in coordinating the team's actions, which is vital for safety and efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_214_a0b930d9",
          "question": "The member on the left pole moves to a position just past parallel with the left beam, then slightly pushes the ladder on to its left beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the left pole moves to a position just past parallel with the left beam, then slightly pulls the ladder on to its left beam.' This contradicts the statement in the question. Misunderstanding these instructions could lead to incorrect ladder positioning, potentially compromising firefighter safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_214_a476bfc4",
          "question": "After pivoting the ladder out on the left beam, the members at the butt foot the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The members at the butt pivot the ladder out on the left beam, then foot the ladder.' This supports the statement in the question. Correctly footing the ladder is a critical step in ensuring ladder stability, which is essential for firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_214_5b1cad45",
          "question": "The member in charge moves into original position after giving the command.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge moves into original position.' This supports the statement in the question. The positioning of the member in charge is important as it allows them to oversee and coordinate the operation effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_202_d5597b66",
          "question": "It is safe to place ladders in front of windows and doorways which may become involved in fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When spotting a ladder, avoid setting it in front of windows and doorways which may become involved in fire.' This contradicts the statement, indicating that it is not safe to place ladders in these locations due to the risk of the fire spreading to the ladder. This is a critical safety consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_202_391a2961",
          "question": "When extending the fly of a two section ladder, each click of the dogs results in 28 inches of extension.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When extending the fly of a two section ladder, each click of the dogs results in 14 inches of extension.' This contradicts the statement, indicating that each click of the dogs results in a 14-inch extension, not 28 inches. Understanding this is important for firefighters to ensure correct ladder extension and placement.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_202_b6e3674e",
          "question": "When extending a ladder to a roof, it is advisable to place at least 5 rungs of the ladder above the parapet or gutter line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When extending a ladder to a roof, when possible, place at least 5 rungs of the ladder above the parapet or gutter line.' This supports the statement, indicating that placing at least 5 rungs above the parapet or gutter line allows for an easier and safer transition from the ladder to the roof and back again. This is a crucial safety consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_202_2bcc3fa4",
          "question": "Fire streams that are to be operated from a ground ladder should have the ladder tip placed just below the top of the opening (header).",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Fire streams that are to be operated from a ground ladder should have the ladder tip placed just above the top of the opening (header).' This contradicts the statement, indicating that the ladder tip should be placed above, not below, the top of the opening. This is important for firefighters to ensure the best vantage point for defensive operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_202_79538330",
          "question": "When a window or opening is tall and wide enough for the ladder tip to be placed inside the opening, it is not necessary to ensure that 2 to 3 rungs are placed above the sill line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When a window or opening is tall and wide enough for the ladder tip to be placed inside the opening, ensure that 2 to 3 rungs are placed above the sill line.' This contradicts the statement, indicating that it is necessary to ensure that 2 to 3 rungs are placed above the sill line. This is a key consideration for firefighters to ensure safe and effective ladder use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_193_8f1b26d9",
          "question": "In the High Shoulder Beam Carry method, the firefighter should position themselves at the bottom 1/3 of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Position yourself at the top 1/3 of the ladder and face it.' This contradicts the question statement. Positioning at the top 1/3 of the ladder allows the firefighter to lift and balance the ladder effectively, which is crucial for safe and efficient operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_193_cf23960b",
          "question": "The inside arm should be placed between the rungs at the balance point of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the inside arm between the rungs, by or at the center (balance point).' This supports the question statement. Placing the arm at the balance point allows for better control and stability of the ladder, which is essential for firefighter safety and effective ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_193_4ed4801d",
          "question": "In both carrying methods, the outside hand is used for stabilization and balance.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The outside hand takes hold of the most comfortable rung in front of the chest for stabilization and balance' and 'The outside hand grasps the upper beam for the best stabilization and balance.' This supports the question statement. The outside hand plays a crucial role in maintaining balance and stability of the ladder, which is critical for safe ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_193_b6d714b8",
          "question": "The butt end of the ladder should be tilted slightly upward to allow for clear forward vision.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The butt end of the ladder should be tilted slightly downward to allow for clear forward vision.' This contradicts the question statement. Tilting the butt end of the ladder slightly downward helps maintain clear forward vision, which is important for firefighter safety and navigation during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_193_c57a9c48",
          "question": "In the High Shoulder Beam Carry method, the inside hand should take hold of the bottom beam to secure the ladder to the shoulder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The inside hand takes hold of the bottom beam to secure the ladder to the shoulder.' This supports the question statement. Securing the ladder to the shoulder with the inside hand allows for better control and stability of the ladder, which is crucial for safe and efficient ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_255_de8b58fd",
          "question": "When climbing the ground ladder with the roof ladder, it is recommended to keep the hand and arm that is carrying the roof ladder low to prevent the roof ladder from sliding off the shoulder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Keep the hand and arm that is carrying the roof ladder high when climbing to help prevent the roof ladder from sliding off the shoulder.' This contradicts the statement in the question. Keeping the arm high provides better control and stability, reducing the risk of the roof ladder sliding off, which could lead to potential injuries or operational delays.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_255_61005926",
          "question": "If the ground ladder is not anchored, the firefighter can take a position with their body halfway above the roof gutter, sill, or parapet.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If the ground ladder is not anchored the member can take a position with their body half way above the roof gutter, sill, or parapet.' This supports the statement in the question. This position allows the firefighter to maintain balance and control while manipulating the roof ladder, which is crucial for safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_255_e3b07061",
          "question": "When properly placed, the roof ladder beam will be directly in line with the inside of the extension ladder beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When properly placed, the roof ladder beam will be directly in line with the outside of the extension ladder beam.' This contradicts the statement in the question. Proper alignment of the ladders ensures stability and safety during operations on the roof.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_255_db97cd85",
          "question": "After the roof ladder has been lifted to its midpoint, the ladder should be positioned so its hooks are facing up.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'After the roof ladder has been lifted to its mid-point, position the ladder so its hooks are facing down.' This contradicts the statement in the question. Positioning the hooks downward allows them to engage with the peak of the roof, providing stability and safety for firefighters operating on the roof.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_255_5b175cc6",
          "question": "To ensure the roof ladder is secure, you should test the hooks by pulling downward on the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Test the hooks by pulling downward on the ladder to ensure the hooks are set properly.' This supports the statement in the question. Testing the hooks is a critical safety measure to ensure the ladder is secure before a firefighter begins operations on the roof.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_238_31b6b396",
          "question": "The member on the bed side of the ladder is responsible for heeling the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the bed side will heel the ladder.' This means that the member on the bed side of the ladder is responsible for stabilizing the ladder at the base, which is crucial for safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_238_e87337af",
          "question": "The member on the fly side of the ladder should grasp the beam with one hand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the fly side of the ladder (#3), will step to the designated beam and grasp the beam with both hands.' This contradicts the statement in the question. Grasping the beam with both hands is important for maintaining control of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_238_fc77cfbd",
          "question": "After the command 'LIFT', the ladder is lowered.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Command \" LIFT \" The ladder is lifted.' This contradicts the statement in the question. The command 'LIFT' is used to indicate that the ladder should be raised, not lowered. Understanding and following commands correctly is crucial for effective and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_238_07eaf61d",
          "question": "When carrying a ladder into the desired location, you should check the overhead area for obstructions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Carry the ladder into the desired location. Check the overhead area for obstructions.' This supports the statement in the question. Checking for overhead obstructions is important to prevent accidents and damage to the ladder or surrounding structures.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_238_75e6c47d",
          "question": "When lifting a ladder, you should lift with your back, not your legs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Crouch down, grasp the tip of the ladder and lift, keeping the back straight and lifting with the legs.' This contradicts the statement in the question. Lifting with the legs, not the back, is a basic safety principle to prevent back injuries during physical tasks like lifting a ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_239_84c37549",
          "question": "The ladder should be walked hand-over-hand using the sides of the rungs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'walk the ladder hand-over-hand using the center of the rungs or slide your hands along the beams'. This contradicts the statement that the sides of the rungs should be used. Using the center of the rungs or the beams provides better balance and control, which is crucial for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_239_cbbace2b",
          "question": "The ladder should be in a vertical position and flat against the building before any adjustments are made.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'until the ladder is in the vertical position and flat against the building'. This supports the statement that the ladder should be in a vertical position and flat against the building before any adjustments are made. Proper positioning of the ladder is critical for firefighter safety and effective climbing or extension of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_239_c61369ae",
          "question": "The member should rotate the ladder above the head while walking up the rungs.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Member reaching the wall and rotates the ladder above the head walking up the rungs'. This supports the statement that the member should rotate the ladder above the head while walking up the rungs. This technique is important for achieving the correct ladder positioning and ensuring firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_239_98fe6ab5",
          "question": "The ladder should be adjusted for climbing or to prepare for extension before it is walked to the vertical.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Member has walked ladder to the vertical, against the objective Member adjusts the butt for climbing or to prepare for extension'. This contradicts the statement that the ladder should be adjusted before it is walked to the vertical. Adjusting the ladder before it is in the correct position could lead to instability and safety risks for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_239_d7110926",
          "question": "The member should slide their hands along the beams when the ladder reaches shoulder height.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the ladder reaches shoulder height, step under the ladder and walk the ladder hand-over-hand using the center of the rungs or slide your hands along the beams'. This supports the statement that the member should slide their hands along the beams when the ladder reaches shoulder height. This technique can help maintain control and balance of the ladder, which is important for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_254_73dc452d",
          "question": "The roof ladder should be raised to the vertical position facing the tip of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Facing the tip of the roof ladder, raise the ladder to the vertical position.' This implies that the orientation of the ladder is important in the process of raising it, which could affect the safety and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_254_42c4319a",
          "question": "The hooks of the roof ladder should be facing towards the ground ladder when laying it on the rungs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'Turn the roof ladder so that the hooks are to the outside, facing away from the extension ladder.' This contradicts the statement in the question. The correct positioning of the hooks is crucial for the stability of the ladder and the safety of the firefighter.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_254_57d67fff",
          "question": "The firefighter should climb the ground ladder with the arm opposite to the beam of the roof ladder over it to balance the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies, 'Climb the ground ladder with the chosen arm over the beam of the roof ladder to balance it.' This contradicts the statement in the question. Proper balance while climbing the ladder is essential for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_254_75861821",
          "question": "The firefighter should reach between rungs 2 and 3 or 3 and 4 from the tip of the roof ladder to pull it onto their shoulder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Climb the ladder to a position to reach between rungs 2 and 3 or 3 and 4 from the tip of the roof ladder.' This supports the statement in the question. The correct positioning of the firefighter on the ladder can affect their ability to safely and efficiently carry out operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_254_750899bf",
          "question": "The roof ladder should be placed onto the roof when the firefighter's waist level is just below the roof line.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'Member reaches a point where their waist level is just above the roof line and places the roof ladder onto the roof.' This contradicts the statement in the question. The correct positioning of the firefighter relative to the roof line is crucial for safely placing the ladder and carrying out operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_192_c0da7ce5",
          "question": "Ladders are always carried tip end first when removing them from the apparatus.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ladders are usually carried butt end first when removing ladders from the apparatus and tip end first when returning them to the apparatus.' This contradicts the statement that ladders are always carried tip end first when removing them from the apparatus. Understanding the correct way to carry ladders is crucial for efficient and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_192_5de9d2d6",
          "question": "Walking backward while carrying ladders is a recommended practice.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Members shall avoid walking backward while carrying ladders.' This contradicts the statement that walking backward while carrying ladders is a recommended practice. This is important to avoid accidents during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_192_56b03786",
          "question": "More accidents occur while climbing ladders than while handling them.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'More accidents occur while handling ladders than while climbing them.' This contradicts the statement that more accidents occur while climbing ladders than handling them. This highlights the importance of proper ladder handling for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_192_a6c19bbf",
          "question": "Unused ladders must be removed from the apparatus and placed in a safe position if it is not possible for them to be left on the apparatus in a locked position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Unused ladders must be removed from the apparatus and placed in a safe position if it is not possible for them to be left on the apparatus in a locked position.' This supports the statement in the question. This is important to ensure safety and efficiency during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_192_a6b73241",
          "question": "The nesting process may sometimes make it necessary to remove more than one ladder for an operation.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The nesting process may sometimes make it necessary to remove more than one ladder for an operation.' This supports the statement in the question. Understanding this can help firefighters prepare for different scenarios during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_203_107863f9",
          "question": "The purpose of heeling a ladder is to keep the butt under control and prevent it from shifting or moving.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The purpose of heeling a ladder is to keep the butt under control and prevent it from shifting or moving.' This directly supports the question statement. The technique of heeling a ladder has significant safety implications for firefighters, as it ensures stability during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_203_56326ec0",
          "question": "When heeling a ladder, the member at the butt should grasp the halyard bundle with both hands.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member at the butt of the ladder steps up onto the bottom rung, grasps the halyard bundle with either hand and allows their weight to hang back. The other hand is rested on the beam to maintain balance.' This contradicts the question statement. Correctly grasping the halyard bundle is crucial for maintaining balance and control of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_203_26a5143f",
          "question": "The member footing should step off the rung just after the ladder comes to the vertical position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member footing will step off the rung just prior to the ladder coming to the vertical position.' This contradicts the question statement. Timing when to step off the rung is important to ensure the ladder is properly positioned and stable, which is critical for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_203_40000961",
          "question": "Just before the ladder has come to the vertical, the member should grasp the outside of each beam of the bed section with both hands at shoulder level.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Just before the ladder has come to the vertical, step down, grasp the outside of each beam of the bed section with both hands at shoulder level.' This directly supports the question statement. This technique is important to maintain control and stability of the ladder, which is crucial for firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_203_be2ab54c",
          "question": "On most ladders, the halyard is grasped between the 1st and 2nd rungs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'With most ladders, the halyard is grasped between the 2nd and 3rd rungs; however, on some ladders it may be necessary to grasp the halyard between the 1st and 2nd rungs.' This contradicts the question statement. Knowing where to grasp the halyard on different ladders is important for maintaining control and balance during ladder operations, which is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_215_c29bba2b",
          "question": "The member on the bed side of the ladder designates the beam that the ladder will be pivoted on by slapping it twice.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"When the command is given to pivot the ladder, the member on the bed side, on the respective beam, will first designate the beam that the ladder will be pivoted on by slapping it twice.\" This statement supports the question by explaining the initial action taken by the member on the bed side of the ladder during a pivot operation. This is crucial for ensuring the correct beam is used for the pivot, which can affect the stability and safety of the ladder operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_215_09a24c72",
          "question": "The member on the pole that has not moved is responsible for setting and footing the ladder after it is pivoted to the desired position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"When the ladder is pivoted to the desired position it is set and footed, each and every time.\" This statement contradicts the question as it does not specify that the member on the pole that has not moved is responsible for setting and footing the ladder. This is important for firefighting operations as it ensures the ladder is secure and stable before any further actions are taken.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_215_14b02d17",
          "question": "Any member of the team may request that a pole member \u201cPushes\u201d or \u201cPulls\u201d if the safety of the team or stability of the ladder is in question.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Any member of the team may request that a pole member \u201cPushes\u201d or \u201cPulls\u201d if the safety of the team or stability of the ladder is in question.\" This statement supports the question by highlighting the importance of team communication and the role each member plays in ensuring the safety and stability of the ladder during operations. This is crucial in firefighting as it can prevent accidents and ensure the successful execution of operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_215_671c6d9b",
          "question": "The command to shift a ladder is given without any preparatory command.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"If the member is given the command to shift, they will be first given a preparatory command of \"prepare to shift\" and then the direction in which the ladder is to be shifted.\" This statement contradicts the question by explaining that a preparatory command is given before the actual command to shift the ladder. This is important for firefighting operations as it ensures that the member is ready and prepared to execute the command, thereby enhancing safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_215_99bcfe17",
          "question": "The member will be on the bed side of the ladder when the command to shift is given and move to the opposite beam called for.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"The member will be on the bed side of the ladder when the command is given and move to the opposite beam called for.\" This statement supports the question by explaining the position of the member when the command to shift is given and the action they are required to take. This is crucial for firefighting operations as it ensures the correct execution of the shift command, which can affect the positioning and stability of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_242_a5fb921d",
          "question": "In the Seattle Fire Department, when there is one member on the right beam and two members on the left, the personnel will rotate counterclockwise.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The personnel will rotate clockwise.' This is important for firefighting operations as it ensures a systematic and coordinated movement of personnel during ladder operations, enhancing safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_242_6ce4b56d",
          "question": "The member in charge (#1) will always move up the right beam toward the tip and stop between rungs 2 and 3.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge (#1) will move up the right beam toward the tip and stop between rungs 2 and 3.' This is a critical position as the member in charge has a clear view of the operation and can coordinate the team effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_242_39379037",
          "question": "When the ladder is raised to the vertical position, the members on the beams use a foot-over-foot motion.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder is raised to the vertical position by the two members on the beams. Using a hand-over-hand motion with both hands on the beam.' This technique ensures a controlled and stable movement of the ladder, reducing the risk of accidents.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_242_651a2040",
          "question": "When the ladder comes to a vertical position, the member on the butt will step back off the ladder and place both hands on the beams and their feet are placed shoulder width apart, one foot ahead of the other to maintain the balance of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the ladder comes to a vertical position the member on the butt will step back off the ladder and place both hands on the beams and their feet are placed shoulder width apart, one foot ahead of the other to maintain the balance of the ladder.' This positioning is crucial for maintaining the stability of the ladder, ensuring the safety of the team and the success of the operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_242_fb22ae05",
          "question": "The ladder will be slightly tilted away from the objective.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder will be slightly tilted towards the objective.' This is important for tactical considerations as it allows for a more direct and efficient access to the objective, whether it be a window, roof, or other point of entry.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_184_b697c7d1",
          "question": "The Seattle Fire Department uses wooden ladders.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Not applicable for Seattle Fire Department. This deals with wooden ladders.' This indicates that the Seattle Fire Department does not use wooden ladders. The type of ladder used can impact firefighting operations, as different materials have different strengths and weaknesses in a fire scenario.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_184_5d727197",
          "question": "Lifting ladders should be done with the back, not the legs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Lifting should be done with the knees bent in a squatting position, with the back straight. This places the load on the heavy muscles in the thighs and not on the back.' This contradicts the statement that lifting should be done with the back. Proper lifting techniques are crucial for firefighter safety to prevent injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_184_956ce066",
          "question": "Any defects noted in a ladder's visual inspection must be corrected before testing.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Any defect noted in the above visual inspection shall be corrected prior to testing.' This supports the statement that defects must be corrected before testing. Ensuring equipment is in good working order is a critical safety consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_184_85fe3e2c",
          "question": "When two or more members lift together, their actions do not need to be in unison.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When two or more members lift together, their actions should be in unison.' This contradicts the statement that their actions do not need to be in unison. Coordinated actions can prevent injuries and ensure efficient operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_184_5dcde5f6",
          "question": "Keeping the toes pointed slightly inward when lifting a ladder lessens the chance of abdominal injury.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Keeping the toes pointed slightly inward rather than spread out lessens the chance of abdominal injury.' This supports the statement that this posture can help prevent abdominal injury. Proper body mechanics can help prevent injuries, which is crucial for maintaining the health and safety of firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_235_5797b196",
          "question": "The member in charge is always the one who checks the overhead area for obstructions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge (the member standing out) will check the overhead area for obstructions and state \"OVERHEAD CLEAR.\"' This indicates that it is the responsibility of the member in charge to ensure that the area above is clear of any obstructions before raising the ladder. This is crucial for firefighter safety as it prevents potential accidents caused by hitting overhead obstructions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_235_9e1eff08",
          "question": "The member at the tip (#3) is responsible for grounding the butt of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'The member on the butt (# 2) at this time, will lower the butt of the ladder so that the spur of the lower beam will be grounded at the desired point.' This contradicts the statement as it is member #2, not #3, who is responsible for grounding the butt of the ladder. Understanding each member's role is important for efficient and safe ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_235_7f2a0dda",
          "question": "If a beam raise parallel to the objective is necessary, the member at the tip can roll the ladder over their head.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If a beam raise parallel to the objective is necessary and the butt has been grounded with the bed toward the objective, the member at the tip can quickly roll the ladder over their head.' This supports the statement and highlights the flexibility and adaptability required in firefighting operations, particularly when dealing with ladder positioning.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_235_3a8dad5b",
          "question": "When the ladder reaches the vertical position, member #3 will foot the ladder from the bed side.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'When the ladder reaches the vertical position, member #2 will foot the ladder from the bed side, member #3 will assist in stabilizing the ladder on the fly side.' This contradicts the statement as it is member #2, not #3, who will foot the ladder from the bed side. Understanding these roles is crucial for maintaining stability and safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_235_8d91711d",
          "question": "Once the ladder is secure, member #1 steps in at the right beam, bed side.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When it is secure, #2 moves to the left beam, bed side, and #1 steps in at the right beam, bed side.' This supports the statement and emphasizes the importance of teamwork and coordination in firefighting operations, particularly when handling equipment such as ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_262_e8736457",
          "question": "The ladder should be laid down on its bed side before tying the hoisting knot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Lay the ladder down on its fly side.' This contradicts the statement that the ladder should be laid on its bed side. This is important as the position of the ladder affects the safety and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_262_0d5eaf27",
          "question": "The hoisting knot should be tied one rung space below the center point of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Tie the hoisting knot one rung space below the center point.' This supports the statement that the hoisting knot should be tied one rung space below the center point. The placement of the knot is critical for the balance and control of the ladder during hoisting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_262_cab9061d",
          "question": "The rope should be placed under the bed section of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the rope on top of the bed section.' This contradicts the statement that the rope should be placed under the bed section. The placement of the rope is crucial for the stability and control of the ladder during hoisting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_262_b0ada3f5",
          "question": "The tail end of the rope should start at the tip of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Starting with the tail end of the rope at the butt.' This contradicts the statement that the tail end of the rope should start at the tip of the ladder. The starting point of the rope is important for the proper tying of the hoisting knot and the control of the ladder during hoisting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_262_44449603",
          "question": "The rope should be headed toward the butt of the ladder after tying the hoisting knot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ensure that the rope is headed toward the tip.' This contradicts the statement that the rope should be headed toward the butt of the ladder. The direction of the rope after tying the hoisting knot is important for the control and maneuverability of the ladder during hoisting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_223_66622649",
          "question": "The 'push 4-3 and pull 3-2' method is used with a 2 section ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Push halyard from bed side through rungs 3 and 4, then back through 2 and 3. This is known as \u201cpush 4-3 and pull 3 -2\u201d'. This shows that the 'push 4-3 and pull 3-2' method is indeed used with a 2 section ladder. This technique is important for firefighters to understand as it impacts how they can safely and effectively use ladders during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_223_2be45883",
          "question": "The round-turn is tied around rung two of a 3 section ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tie a round -turn around rung three (3 section ladder)'. This contradicts the statement that the round-turn is tied around rung two. Understanding the correct rung to tie a round-turn around is crucial for firefighters as it affects the stability and safety of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_223_06c847d1",
          "question": "The halyard slack on the fly side is grabbed between rungs 2 and 3.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Reaching between rungs 2 and 3, grab the halyard slack on the fly side'. This confirms the statement that the halyard slack on the fly side is grabbed between rungs 2 and 3. This is a key step in the ladder operation process and hence important for firefighters to understand.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_223_c1add4f7",
          "question": "The recently grabbed slack is pulled toward you between rungs 3 and 4.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Pull the recently grabbed slack toward you between rungs 2 and 3'. This contradicts the statement that the slack is pulled between rungs 3 and 4. Misunderstanding this could lead to improper ladder setup, affecting firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_223_de5aa029",
          "question": "A half-hitch is tied around the halyard above rung 2.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tie a half -hitch around the halyard above rung 3'. This contradicts the statement that a half-hitch is tied around the halyard above rung 2. Correctly tying the half-hitch is vital for the stability of the ladder and safety of the firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_258_d3cbc28f",
          "question": "The member at the top of the ladder is responsible for steadying it on its beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the member at the top unlocks, steps over the 26' ladder onto the objective and pulls the ladder in while the other member steadies it on its beam.' This shows that it is the other member, not the one at the top, who steadies the ladder. This is important for safety and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_258_b293f751",
          "question": "The ladder is placed at the proper climbing angle, unextended, with the fly toward the building, directly below the spot where it is to be hoisted.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The ladder is placed at the proper climbing angle, unextended, with the fly toward the building, directly below the spot where it is to be hoisted.' This supports the statement and is crucial for ensuring the ladder is positioned correctly for hoisting, which is a key operational concern in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_258_5ea2820c",
          "question": "The end of a roof rope is secured to a fixed object at the lower location and dropped to the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The end of a roof rope is secured to a fixed object at the desired upper location and dropped to the ground.' This contradicts the statement and is important for understanding the correct procedure for securing the roof rope, which is a key safety concern in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_258_42b543a1",
          "question": "The operation of climbing the ladder and stepping onto the roof or into the building is reversed to bring the ladder down.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This operation is reversed to bring the ladder down.' This supports the statement and is important for understanding the correct procedure for bringing the ladder down, which is a key operational concern in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_258_125bb7dc",
          "question": "The member on the ground takes a bight of the line at the spur of the ladder and passes it from the bed side to the fly side through the first full rung space above the center of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A member on the ground grasps the rope and takes a bight of the line at the spur of the ladder. The member climbs the ladder and passes the bight from the bed side to the fly side through the first full rung space above the center of the ladder.' This supports the statement and is crucial for understanding the correct procedure for handling the rope, which is a key operational concern in firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_219_c1f0ee67",
          "question": "The member on the bed side of the ladder should place their left toe against the right spur of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the bed side will place their right toe against the right spur of the ladder.' This contradicts the question statement which suggests the left toe should be placed against the right spur. This is crucial for maintaining balance and control while extending the ladder, which directly impacts firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_219_22df3538",
          "question": "The member on the fly side should place both hands on the beams of the bed section to maintain the balance of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the fly side will place both hands on the beams of the bed section and maintain the balance of the ladder.' This supports the question statement. Maintaining balance is crucial for the safety of firefighters and the successful extension of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_219_f3866a08",
          "question": "When the command 'HIGH' is given, the fly(s) is/are locked at the next lowest rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the command 'HIGH' is given the fly(s) is/are locked at the next highest rung.' This contradicts the question statement which suggests the fly(s) is/are locked at the next lowest rung. Understanding commands and their implications is key for effective firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_219_4996894e",
          "question": "It is safe to put hands or feet in position where they can be injured by the movement of the fly section(s).",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not put hands or feet in position where they can be injured by the movement of the fly section(s).' This contradicts the question statement which suggests it is safe to do so. Safety is a primary concern in firefighting operations, and understanding how to properly use equipment is essential to prevent injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_219_89770754",
          "question": "At no time shall any member reach through a rung space or touch a rung with the hands or feet until all dogs are locked.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'At no time shall any member reach through a rung space or touch a rung with the hands or feet until all dogs are locked.' This supports the question statement. Adhering to this rule is crucial for the safety of firefighters during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_188_7e491a92",
          "question": "The command 'ADJUST THE BUTT' is given to adjust the butt of the ladder to the proper climbing angle or squaring it to the building.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'ADJUST THE BUTT - The command given to adjust the butt of the ladder (to the right, left, in or out) to the proper climbing angle or squaring it to the building.' This supports the statement. Correct ladder positioning is crucial for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_188_fc1417b9",
          "question": "'ALL DOGS ARE LOCKED' is a statement made by members after checking to ensure that the ladder is extended to the desired height.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'ALL DOGS ARE LOCKED - Statement made by members after checking to ensure that the dogs are secured properly to the desired rung after extending the flies.' This contradicts the statement. The term refers to securing the ladder, not extending it. Proper securing of the ladder is important for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_188_2a58d86d",
          "question": "'EXTEND THE FLY' is a command given to extend the fly section of the ladder to the desired height.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'EXTEND THE FLY - The fly section of the ladder is extended to the desired height by pulling down on the halyard.' This supports the statement. Correct extension of the ladder is critical for reaching the desired height for operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_188_97639e4b",
          "question": "'FLY SIDE AROUND' is a command given by the member on the tormentor poles to the member on the fly side of the ladder to come and take the left tormentor pole once the ladder has come to the vertical and is stabilized.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'FLY SIDE AROUND - A command given by the member on the tormentor poles to the member on the fly side of the ladder to come and take the left tormentor pole once the ladder has come to the vertical and is stabilized.' This supports the statement. This command is important for ensuring the stability of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_188_1776c06d",
          "question": "The command 'ADJUST THE BUTT' is given to ensure that the dogs are secured properly to the desired rung after extending the flies.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'ADJUST THE BUTT - The command given to adjust the butt of the ladder (to the right, left, in or out) to the proper climbing angle or squaring it to the building.' This contradicts the statement. The command 'ADJUST THE BUTT' is about adjusting the ladder's position, not securing the dogs. Correct ladder positioning is crucial for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_183_1e68ad22",
          "question": "Ladder locks or pawls on extension ladders are not required to be secured to the beams.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ladder locks or pawls on extension ladders shall be so fastened or secured to the beams that vibration and use will not cause loosening of bolts and nuts.' This contradicts the statement, implying that ladder locks or pawls must be secured to the beams to prevent loosening due to vibration and use, which is crucial for firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_183_1a370835",
          "question": "Staypoles or tormentors are not necessary on extension ladders over forty feet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Staypoles or tormentors shall be furnished on all extension ladders over forty feet.' This contradicts the statement, indicating that staypoles or tormentors are required for extension ladders over forty feet. This is important for maintaining ladder stability during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_183_8ae77939",
          "question": "All ladders should be stored in a manner that prevents easy access for inspection.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'All ladders shall be stored in a manner to provide ease of access for inspection, and to prevent danger of accident when withdrawing them for use.' This contradicts the statement, implying that ladders should be stored in a way that allows easy access for inspection and safe withdrawal for use, which is crucial for firefighter safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_183_a16d8f23",
          "question": "Members are always required to climb and descend ground ladders with the fly out.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Even when ladders are routinely used in the fly out configuration, in adverse conditions members shall be permitted to climb and descend ground ladders with the fly in to assure secure footing.' This contradicts the statement, indicating that in adverse conditions, members are allowed to climb and descend ladders with the fly in for safety purposes. This highlights the importance of adapting firefighting tactics based on conditions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_183_4ed554ca",
          "question": "All ladders should be inspected thoroughly after each use and records of the inspections and repairs should be kept.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'All ladders regardless of type shall be inspected thoroughly after each use. Records shall be kept of the inspections and repairs.' This supports the statement, emphasizing the importance of regular inspection and maintenance of firefighting equipment for safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_245_6fcf9b2c",
          "question": "The member in charge of the poles should push the ladder to the vertical position as soon as it lifts off the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The poles must be kept low to the ground during the initial stages of the raise and the member on the poles must not push too soon, wait until the ladder is over the head of the members on the beam.' This contradicts the question statement. Pushing the ladder too soon can lead to instability and potential accidents during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_245_2fc108c0",
          "question": "The member at the butt of the ladder should step back off the ladder and place both hands on the beams at shoulder height when the ladder comes to a vertical position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the ladder comes to a vertical position the member on the butt will step back off the ladder and place both hands on the beams at shoulder height.' This supports the question statement. Proper positioning and handling of the ladder is crucial for maintaining balance and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_245_fd2457fe",
          "question": "The member on the beams raises the ladder to the vertical position using a hand-over-hand motion with one hand on their respective beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder is raised to the vertical position by the two members on the beams, using a hand-over-hand motion with both hands on their respective beam.' This contradicts the question statement. Using both hands ensures better control and stability of the ladder during raising, which is important for safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_245_650ba59b",
          "question": "The member on the poles gives the command 'FLY SIDE AROUND' once they are certain that the ladder is stable in the vertical position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the pole member is certain that the ladder is stable in the vertical position, that member will give the command: \"FLY SIDE AROUND.\"' This supports the question statement. Clear and timely communication is vital in firefighting operations to ensure safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_245_fc7d5a77",
          "question": "The foot closest to the ladder should be about three to four feet away from the butt of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The foot closest to the ladder will be about one to one and a half feet away from the butt of the ladder.' This contradicts the question statement. Proper positioning of the feet is important to maintain balance and control of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_212_296c1a66",
          "question": "In the left pole position, your right hand is on the spike and your arms are spread out.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Facing the other pole member, your right hand is on the spike and your arms are spread out.' This indicates that in the left pole position, the firefighter's right hand is on the spike and their arms are spread out. This is important for maintaining balance and control while handling the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_212_269414d1",
          "question": "In the left pole position, your left hand is closest to your body.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Your right hand is IN closest to your body, and your left hand is OUT away from your body.' This contradicts the statement that the left hand is closest to the body in the left pole position. Correct positioning is crucial for maintaining control over the ladder and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_212_51a183e6",
          "question": "The left pole denotes the Command Position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Left Pole Denotes: 1 Command Position.' This indicates that the left pole is associated with the Command Position. Understanding this is important for effective communication and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_212_a2efb7a4",
          "question": "The right beam is associated with the movement to position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text does not provide any information associating the right beam with the movement to position. Misunderstanding or miscommunication about equipment and operational concerns can lead to inefficiencies or potential safety risks during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_212_fcac9dd3",
          "question": "Pivoting of the ladder ends in the left pole position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Pivoting of Ladder end in this position' but does not specify that 'this position' refers to the left pole position. Misunderstanding this could lead to incorrect ladder handling, which could have safety implications for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_204_3b270970",
          "question": "When heeling the ladder, the member at the butt should step on the bottom rung with one foot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'As the ladder leaves the vertical position, the member will step on the bottom rung with both feet.' This indicates that both feet should be used for stability and control when lowering the ladder, not just one. This is crucial for maintaining balance and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_204_501781d4",
          "question": "The member at the butt should grasp all the ropes of the halyard in either hand while heeling the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "According to the text, 'the member will...grasp all the ropes of the halyard in either hand.' This is important for controlling the descent of the ladder and ensuring it can be safely lowered to the ground. Mismanaging the halyard could lead to uncontrolled ladder movement, posing a risk to firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_204_ff55cf30",
          "question": "The member at the butt should use their body weight to push forward when heeling the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies that the member should 'allow the body weight to hang back.' This contradicts the statement that the body weight should be used to push forward. Leaning back helps control the ladder's descent by using gravity, which is a key aspect of safe and effective ladder operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_204_3412438e",
          "question": "The member at the butt should use their other hand to maintain balance when heeling the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Use the other hand to maintain balance.' This supports the statement and highlights the importance of maintaining balance during ladder operations. A loss of balance could lead to a fall or uncontrolled ladder movement, posing a risk to firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_204_8744d555",
          "question": "The member at the butt should be on the fly side in the 'PREPARE TO LOWER' position when heeling the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Member at the butt, on the fly side in the \u201cPREPARE TO LOWER\u201d position.' This confirms the statement and emphasizes the importance of positioning during ladder operations. Proper positioning is crucial for controlling the ladder's descent and ensuring firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_195_d57a0cea",
          "question": "The center of the ladder should be identified before removing it from the apparatus.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Identify the center of the ladder. Remove the ladder from the apparatus'. This implies that the center of the ladder should be identified before removing it from the apparatus. This is important for firefighters to ensure proper handling and balance of the ladder during removal.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_195_2a635249",
          "question": "When carrying a ladder to the objective, the member in charge should be at the tip of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge will be at the butt.' This contradicts the statement that the member in charge should be at the tip of the ladder. This is crucial for firefighters as the member in charge at the butt of the ladder can guide its movement and ensure safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_195_18b7b27d",
          "question": "The High Shoulder Beam Carry method involves the lower beam resting on the shoulder and the inside hand holding the upper beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The inside hand takes hold of the lower beam to secure the ladder to the shoulder. The outside hand grasps the upper beam for the best stabilization and balance.' This contradicts the statement that the inside hand holds the upper beam. Understanding the correct method is important for firefighters to ensure safe and effective ladder handling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_195_c46e7404",
          "question": "When carrying a ladder with two members, they should position themselves between the 1st and 2nd rungs from the tip and the butt of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members approach the ladder and position themselves between the 2nd and 3rd rungs from the tip and the butt of the ladder.' This contradicts the statement that they should position themselves between the 1st and 2nd rungs. This is important for firefighters to ensure proper positioning for safe and balanced ladder handling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_195_803fc73b",
          "question": "Unlocking the two ladder locks ensures that the halyard and cable do not get hung up on the lock handles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Unlock the two ladder locks ensuring that the halyard and cable do not get hung up on the lock handles.' This supports the statement that unlocking the ladder locks prevents the halyard and cable from getting hung up. This is crucial for firefighters as it prevents potential hazards during ladder deployment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_253_a2228338",
          "question": "Commands are necessary to perform the operation of carrying the roof ladder from the apparatus to the base of the ground extension ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'No commands are needed to perform this operation.' This means that firefighters are expected to carry out this task without needing specific instructions, which implies a level of autonomy and understanding of the procedure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_253_905bc535",
          "question": "The roof ladder should be placed on the ground with the beams straddling a different beam of the ground extension ladder that you expect to work off of.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the roof ladder on the ground with the beams straddling the same beam (of the ground extension ladder) that you expect to work off of.' This is important for stability and safety when working off the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_253_63814f1d",
          "question": "The extension ladder must be properly placed and footed for climbing and perpendicular to the objective.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The extension ladder must be properly placed and footed for climbing and perpendicular to the objective.' This is crucial for ensuring the safety and stability of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_253_499fd46a",
          "question": "The hooks on the roof ladder should face down.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Open the hooks on the roof ladder so they face up (ensure locking).' This is important to secure the ladder properly, ensuring firefighter safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_253_8a2d2c41",
          "question": "The butt of the roof ladder may lift off the ground when the ladder is raised to the vertical position if the extension ladder is not properly placed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This will keep the butt of the roof ladder from lifting off the ground when the ladder is raised to the vertical position.' This implies that improper placement of the extension ladder could cause instability, posing a safety risk to firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_228_bf28e584",
          "question": "Wedging is a technique used to stabilize the top of a ladder when the terrain at the spurs is uneven.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Wedging is a technique used to stabilize the butt of a ladder when the terrain at the spurs is uneven.' This contradicts the question statement which incorrectly mentions the top of the ladder. The correct firefighting implication is that wedging is used to stabilize the base or 'butt' of the ladder, not the top, when dealing with uneven terrain.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_228_b050eeaf",
          "question": "All ladder companies carry wooden wedges.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'All ladder companies carry wooden wedges.' This directly supports the question statement. The firefighting implication is that wooden wedges are a standard piece of equipment for all ladder companies, likely due to their utility in stabilizing ladders on uneven terrain.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_228_a8e719bc",
          "question": "Only one wedge can be used at a time to stabilize the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A member can use these wedges one at a time or two wedges opposing each other.' This contradicts the question statement which incorrectly suggests that only one wedge can be used at a time. The correct firefighting implication is that multiple wedges can be used simultaneously to stabilize a ladder if necessary.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_228_06a87854",
          "question": "Other materials available at the scene, such as tarps, cannot be used to even up the base of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Other materials that are available at the scene may also be used to even up the base of the ladder, such as tarps.' This contradicts the question statement which incorrectly suggests that only wedges can be used. The correct firefighting implication is that firefighters can use other available materials to stabilize a ladder, providing flexibility in diverse situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_228_8d8d7681",
          "question": "If a spur is not touching the ground after the ladder is placed into the climbing position, it is steadied by placing the wedge or tarp between the spur and the ground making positive contact with both.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If a spur is not touching the ground after the ladder is placed into the climbing position, it is steadied by placing the wedge or tarp between the spur and the ground making positive contact with both.' This directly supports the question statement. The firefighting implication is that proper ladder placement and stabilization is crucial for safety during operations, especially on uneven terrain.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_249_3846f61a",
          "question": "The member on the fly side is responsible for stepping up onto the bottom rung and grasping the halyard tightly with the hands.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the fly side will step up onto the bottom rung and grasp the halyard tightly with the hands.' This indicates that it is indeed the responsibility of the member on the fly side to perform this action, which is crucial for maintaining control of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_249_cad42818",
          "question": "The member in charge passes only one pole to the members on the beams.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge passes both poles to the members on the beams.' This contradicts the statement that only one pole is passed. Passing both poles is important for ensuring balanced control of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_249_9df66a46",
          "question": "The ladder is lifted to the shoulder in unison after the command 'PREPARE TO LIFT'.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Command \" LIFT \" The ladder is lifted to the shoulder in unison.' This contradicts the statement that the ladder is lifted after the command 'PREPARE TO LIFT'. The correct command for lifting the ladder is 'LIFT', which is crucial for coordinated team effort in lifting the ladder safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_249_bd1da45a",
          "question": "It is the responsibility of all personnel to be observant of the area where the poles are to be passed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is the responsibility of all personnel to be observant of the area where the poles are to be passed.' This supports the statement that all personnel are responsible for observing the area. This is important for ensuring safety during ladder operations, as unawareness of the surroundings could lead to accidents.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_249_736e5360",
          "question": "The members return the ladder tip first to the apparatus after the command 'STOW THE LADDER'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" STOW THE LADDER \" The members will return the ladder tip first to the apparatus.' This supports the statement that the ladder is returned tip first after the command 'STOW THE LADDER'. This is important for ensuring the ladder is stored properly and safely after use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_208_82958b94",
          "question": "When lowering the ladder to the objective, the base of the ladder is prevented from sliding out by the weight of the firefighters' bodies.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'they use the weight of their bodies to prevent the base of the ladder from sliding out as they lower the ladder to the objective.' This is a key safety measure to ensure stability of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_208_5fac9169",
          "question": "When the command 'INTO THE BUILDING' is given, the member on the fly side of the ladder should have one hand on the outside of each beam of the bed section.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'the member on the fly side of the ladder will have both hands grasping the outside of each beam of the bed section.' This is important for maintaining balance and control of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_208_227be09f",
          "question": "The feet of the member on the fly side of the ladder should be placed side by side for good balance and stability.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The feet should be placed approximately one to two feet back from each other, and about shoulder width apart.' This staggered foot position allows for better balance and stability during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_208_5a9f459a",
          "question": "When the command 'OUT FROM THE BUILDING' is given, the member on the bed side places their right foot on the center of the bottom rung.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the member on the bed side places their left foot on the center of the bottom rung.' This is a specific technique to ensure control and stability when moving the ladder away from the building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_208_041f35a3",
          "question": "The member on the bed side uses the weight of their body to prevent the base of the ladder from sliding when pulling the ladder out from the objective.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'using the weight of their body to prevent the base of the ladder from sliding, slowly pulls the ladder out from the objective.' This is another key safety measure to ensure stability of the ladder during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_176_eb1a4696",
          "question": "Fire service ladders are primarily used for rescue work.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'RESCUE - The principle use of fire service ladders is for rescue work.' This supports the statement that the primary use of fire service ladders is for rescue work. In a firefighting scenario, this could involve rescuing individuals from upper floors of a burning building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_176_21599751",
          "question": "Fire service ladders can be used to vent windows from the exterior.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'VENTILATION \u2013 Windows may be vented from the exterior using ground ladders.' This supports the statement that fire service ladders can be used to vent windows from the exterior. In a firefighting scenario, this could be a vital tactic to release heat and smoke from a structure, improving conditions for both trapped occupants and firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_176_80d113e7",
          "question": "Fire service ladders are not necessary if stairways are accessible.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Stairways are ordinarily accessible, but sometimes they may be involved in fire or other hazards. Members must therefore need to provide their own means of ascent or descent to upper floors.' This contradicts the statement that fire service ladders are not necessary if stairways are accessible. In a firefighting scenario, stairways may be blocked or unsafe due to fire conditions, necessitating the use of ladders.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_176_2e36202a",
          "question": "Fire service ladders can be used to support fire streams.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'FIRE STREAMS - Ladders provide a means of access for hose lines from the ground level. Fire streams can be operated directly off of properly supported ladders.' This supports the statement that fire service ladders can be used to support fire streams. In a firefighting scenario, this could allow for more effective application of water to a fire from an elevated position.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_176_014a73bb",
          "question": "Fire service ladders do not require teamwork for proper use.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Fire service ladders demand close and coordinated teamwork.' This contradicts the statement that fire service ladders do not require teamwork for proper use. In a firefighting scenario, effective use of ladders requires coordination among team members to ensure safe and efficient operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_199_4c57c508",
          "question": "The ladder is always removed from the rack by three members.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states 'When the ladder is sufficiently removed from the rack, the single member will grasp the beam in the center of the ladder, while the other two members, on the opposite side of the ladder, will grasp the beam between the 2nd and 3rd rungs from the ends.' This implies that there are scenarios where the ladder is already removed from the apparatus, and on the ground. The understanding of this procedure is crucial for efficient and safe operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_199_44fe25a6",
          "question": "The member in charge is always on the right beam of the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text clearly states 'The member in charge is on the right beam.' This is important for maintaining order and coordination during firefighting operations, ensuring that the ladder is handled safely and effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_199_2e033de6",
          "question": "All members lift the ladder to their right shoulder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text contradicts this statement by saying 'All members stand and lift to the left shoulder as they turn 180 degrees to face the other direction which will be the butt end.' Understanding this procedure is crucial for the safe and coordinated handling of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_199_f1812ccc",
          "question": "The team kneels facing the tip of the ladder before lifting it.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying 'The team gets into position and kneels facing the tip with their inside knee down.' This is an important procedure to ensure the safe and efficient lifting and handling of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_199_4cedaf94",
          "question": "The ladder is always carried to the objective immediately after being lifted from the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text supports this statement by saying 'The ladder can then be carried to the objective.' This indicates the importance of prompt action in firefighting operations, ensuring that the ladder is quickly and efficiently transported to where it is needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_224_a1cb4a33",
          "question": "The operation of adjusting the butt of a ladder is performed while the ladder is in the horizontal position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This operation is performed while the ladder is in the vertical position and against the objective with the halyard secured.' This contradicts the statement in the question, which suggests the ladder is in a horizontal position. The correct positioning of the ladder is crucial for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_224_d9a72998",
          "question": "When adjusting the butt of the ladder, one member should reach down and grasp the 1st or 2nd rung from the spur with either hand.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Reach down with either hand and grasp the 1st or 2nd rung from the spur.' This supports the statement in the question. Correctly grasping the ladder rungs is important for maintaining control of the ladder and ensuring firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_224_05f0499e",
          "question": "When two members are adjusting the butt of the ladder, the member on the right beam should reach down with the right hand and grasp the 1st or 2nd rung from the spur.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the right beam will reach down with the left hand and grasp the 1st or 2nd rung from the spur.' This contradicts the statement in the question, which suggests the member on the right beam should use the right hand. Correct hand usage is essential for maintaining balance and control during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_224_864b2751",
          "question": "When adjusting the butt of the ladder, the member should use good lifting technique to avoid injuring the back.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Use good lifting technique to avoid injuring the back.' This supports the statement in the question. Proper lifting technique is crucial to prevent injuries during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_224_f1cfca6d",
          "question": "When two members are adjusting the butt of the ladder, they should lift the top of the ladder off the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Together both members will lift the butt of the ladder up off the ground.' This contradicts the statement in the question, which suggests they should lift the top of the ladder. Lifting the correct part of the ladder is important for maintaining control and stability during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_265_b45b5941",
          "question": "When lowering a ladder into a pit or well, the length of the ladder should be equal to the distance from the bottom of the pit or well to the edge, rail or wall at your elevation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Drop a rope or line to measure the distance from the bottom of the pit or well to the edge, rail or wall at your elevation and add six feet to that length.' This means that the length of the ladder should be six feet more than the distance from the bottom of the pit or well to the edge, rail or wall at your elevation. This extra length is crucial to ensure the ladder extends over the wall once it is in its final climbing position, enhancing safety and accessibility for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_265_b9517883",
          "question": "The ladder should be placed bed side up when lowering it into a pit or well.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the ladder bed side down with the spurs hanging over the objective.' This contradicts the statement that the ladder should be placed bed side up. Placing the ladder bed side down ensures that the ladder can be flipped to the correct position once it has reached the bottom of the pit or well, which is important for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_265_dbb946f1",
          "question": "The ladder should only be allowed to slide into the pit or well after it has been raised sufficiently.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The one or two members on the rope will allow the ladder to slide into the pit or well only after it has been raised sufficiently to slide down into the pit or well opening.' This supports the statement that the ladder should only be allowed to slide into the pit or well after it has been raised sufficiently. This is crucial to ensure the ladder is positioned correctly and safely for climbing.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_265_135177c4",
          "question": "The ladder is adjusted to the proper climbing angle before it is lowered into the pit or well.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once the ladder has reached the bottom it is adjusted to the proper climbing angle.' This contradicts the statement that the ladder is adjusted to the proper climbing angle before it is lowered into the pit or well. Adjusting the ladder's angle once it has reached the bottom ensures that it is properly positioned for climbing, which is important for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_265_670807b3",
          "question": "One member should support the tip of the ladder while it is being climbed.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'One member will support the tip of the ladder while it is being climbed.' This supports the statement that one member should support the tip of the ladder while it is being climbed. This is a crucial safety measure to prevent the ladder from moving or tipping while a firefighter is climbing it.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_232_e093c8bb",
          "question": "The member at the butt (#1) is responsible for footing the ladder during the beam raise.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member at the butt (#1) will heel the ladder on the bed side for a beam raise' and 'When the ladder reaches the vertical position, member (#1) will foot the ladder from the bed side.' This implies that member #1 has the responsibility of footing the ladder during the beam raise, which is crucial for maintaining stability and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_232_7bc8b34b",
          "question": "The member at the tip (#2) raises the ladder by pulling it towards the butt.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member at the tip (#2) will raise the ladder by moving toward the butt with a hand-over-hand motion on the beam.' This indicates that member #2 is responsible for raising the ladder, which is an important aspect of ladder operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_232_c93bd16f",
          "question": "The member on the fly side (#2) is responsible for maintaining the balance of the ladder in a horizontal position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the fly side (#2) maintains the balance of the ladder in a vertical position by placing both hands on beams.' This contradicts the statement that member #2 maintains the ladder in a horizontal position. Maintaining the ladder in a vertical position is crucial for safe and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_232_30d35213",
          "question": "The bed-side member completes the raise by pulling the ladder to counteract the bed side weight.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The bed-side member completes the raise by footing the ladder while the fly side member temporarily pulls slightly to counteract the bed side weight.' This contradicts the statement that the bed-side member completes the raise by pulling the ladder. Understanding the roles and responsibilities during a ladder raise is critical for teamwork and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_232_402be1b3",
          "question": "The right shoulder carry is performed with the objective on the bed side of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Right shoulder carry with objective on fly side of ladder.' This contradicts the statement that the right shoulder carry is performed with the objective on the bed side of the ladder. Correctly performing ladder carries is important for firefighter safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_233_40518abb",
          "question": "During the 'EXTEND THE FLY' command, the member on the bed side is responsible for maintaining the balance of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the fly side will place both hands on the beams and maintain the balance of the ladder.' This contradicts the statement in the question, indicating that it is the member on the fly side, not the bed side, who maintains the ladder's balance. This is crucial for ensuring the ladder's stability during extension.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_233_4f35d86a",
          "question": "The 'HIGH' command involves checking that the dogs are locked after extending the fly to the next rung.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The fly is extended to the next rung and checked to see that the dogs are locked.' This supports the statement in the question. Checking that the dogs are locked is a safety measure to ensure the ladder remains secure at its extended height.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_233_0198d2a9",
          "question": "During the 'INTO THE BUILDING' command, the member on the fly side is responsible for securing the halyard.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the bed side will secure the halyard.' This contradicts the statement in the question, indicating that it is the member on the bed side, not the fly side, who secures the halyard. This is important for ensuring the ladder remains stable when being lowered into the building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_233_0a67f017",
          "question": "The 'SECURE THE TIP' command involves the member on the fly side securing the tip with a ladder anchor.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member that was on the fly side as it was lowered into the building will secure the tip with a ladder anchor.' This supports the statement in the question. Securing the tip is a crucial step in ensuring the ladder is safely anchored and stable for use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_233_3ddc4ac2",
          "question": "During the 'OUT FROM THE BUILDING' command, the member on the bed side assists in bringing the tip out from the building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the fly side will assist bringing the tip out from the building with hands on the beams.' This contradicts the statement in the question, indicating that it is the member on the fly side, not the bed side, who assists in bringing the tip out from the building. This is important for safely removing the ladder from the building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_264_410b0841",
          "question": "The ladder is held in the vertical position as it is raised.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder is held in the vertical position as it is lowered.' This contradicts the statement in the question that the ladder is held vertically as it is raised. Understanding the correct procedure for ladder positioning is crucial for firefighter safety and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_264_e0278d79",
          "question": "One or two members on the rope allow the ladder to slide down while keeping tension on the rope.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The one or two members on the rope will allow the ladder to slide down while keeping tension on the rope.' This supports the statement in the question. Maintaining tension on the rope while the ladder is being lowered is a key safety measure to prevent uncontrolled movements of the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_264_8eb93dc3",
          "question": "Once the ladder has reached the bottom, it is immediately ready for climbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Once the ladder has reached the bottom it is adjusted to the proper climbing angle and flipped over so that the bed is out and the fly in.' This contradicts the statement in the question that the ladder is immediately ready for climbing once it reaches the bottom. Preparing the ladder properly for climbing is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_264_cf92a670",
          "question": "The ladder should be rotated so that the fly sections are 'in' before climbing.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Rotate the ladder so that the fly sections are \u201cin\u201d and adjust for climbing.' This supports the statement in the question. Proper positioning of the ladder's sections is important for stability during climbing and operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_264_535ad84d",
          "question": "One member should support the base of the ladder while it is being climbed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'One member will support the tip of the ladder while it is being climbed.' This contradicts the statement in the question that a member should support the base of the ladder. Proper support of the ladder during climbing can prevent accidents and ensure the safety of the firefighter climbing.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_225_ca0c17dd",
          "question": "It is acceptable to climb a ladder without ensuring that the ladder locks are secured on all flies and the bed section.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ladder locks are secured on all flies and the bed section.' This contradicts the question statement, indicating that it is not safe to climb a ladder without ensuring that the ladder locks are secured. This is important for firefighter safety as it prevents the ladder from collapsing or moving unexpectedly during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_225_13b26c25",
          "question": "When climbing a ladder, it is recommended to keep your back near perpendicular with the ground and your arms almost fully extended.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'While climbing, the back should be near perpendicular with the ground and the climber's arms almost fully extended.' This supports the question statement, indicating that this is the recommended posture for climbing a ladder. This posture provides stability and balance, reducing the risk of falls during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_225_d306d703",
          "question": "When on a straight ladder fire escape, it is recommended to climb with your hands on the rungs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When on a straight ladder fire escape, always climb with your hands on the beams, not on the rungs.' This contradicts the question statement, indicating that it is not recommended to climb with your hands on the rungs when on a straight ladder fire escape. This is important for firefighter safety as holding the beams provides a more secure grip, reducing the risk of falls.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_225_be1b041d",
          "question": "The proper climbing angle for a ladder is approximately 70 degrees.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Verify proper climbing angle (approximately 70 degrees).' This supports the question statement, indicating that the proper climbing angle for a ladder is approximately 70 degrees. This angle provides stability and reduces the risk of the ladder sliding or falling during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_225_88ee395e",
          "question": "It is not necessary to secure the tip of the ladder with a ladder anchor or foot it at the butt before climbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The tip is properly secured with a ladder anchor or the ladder is footed at the butt.' This contradicts the question statement, indicating that it is necessary to secure the tip of the ladder before climbing. This is important for firefighter safety as it prevents the ladder from moving or slipping during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_177_ecf2d9aa",
          "question": "The 'Baby Ladder' is a small extension ladder that is only carried on ladder trucks.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'BABY LADDER \u2013 A small extension ladder that is carried on all ladder trucks and engine companies.' This contradicts the statement that baby ladders are only carried on ladder trucks. In firefighting operations, knowing the equipment available on different vehicles can affect decision-making and tactics.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_177_d73f9c2c",
          "question": "The 'Butt' is the top end of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'BUTT - The bottom end of the ladder opposite the tip.' This contradicts the statement that the butt is the top end of the ladder. In firefighting, understanding ladder terminology is crucial for effective communication and operation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_177_f3929457",
          "question": "The 'Dogs' mechanism prevents the fly(s) from retracting once they are properly set on the desired rung.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'DOGS - The mechanism that keeps the fly(s) from retractin g once they are properly set on the desired rung.' This supports the statement in the question. In firefighting, understanding the function of each part of the ladder is important for safety and effective use of the equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_177_9fdda505",
          "question": "The 'Halyard' is a rope used to extend or retract the fly.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'HALYARD - The rope used to extend or retract the fly.' This supports the statement in the question. In firefighting, knowing how to operate the ladder, including extending and retracting the fly, is crucial for successful operations and firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_177_613239b1",
          "question": "In Seattle, extension ladders vary in length from 20 to 50 feet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In Seattle, they vary in length from 10 to 45 feet.' This contradicts the statement that extension ladders in Seattle vary in length from 20 to 50 feet. Understanding the length of ladders available can impact firefighting tactics, such as reaching victims in high-rise buildings.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_198_a678affe",
          "question": "In a flat carry, the member in charge is positioned at the center on the right beam.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge will be in the center on the right beam.' This indicates that the leader's position is crucial for coordinating the team's actions and ensuring safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_198_bc891706",
          "question": "When removing the ladder from the apparatus, only one member is needed to grasp the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When removing the ladder from the apparatus, two of the members grasp the ladder.' This implies that removing a ladder is a task that requires teamwork and coordination, emphasizing the importance of communication and cooperation in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_198_20e38ec6",
          "question": "The member on the side of the ladder with two members will continue out with the top of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the side of the ladder with two members will continue out with the butt of the ladder.' This contradicts the statement, and highlights the need for clear roles and responsibilities during ladder operations to ensure safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_198_5bd2b272",
          "question": "A flat carry operation for a ground extension ladder requires three members if the ladder is 35' or less.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Flat Carry (LADDER TRUCK) Three Members \u2013 35' or Less Ground Extension Ladder.' This indicates that the number of firefighters involved in a flat carry operation depends on the length of the ladder, which is a crucial consideration for effective and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_198_b46ba79a",
          "question": "The member in charge will be at the left butt position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge will be in the center on the right beam or at the right butt position.' This contradicts the statement and emphasizes the importance of the leader's position in coordinating the team's actions and ensuring safety during ladder operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_209_647f4a19",
          "question": "The member on the fly side assists the movement of the ladder with their hands on the beams.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the fly side will assist this movement with their hands on the beams.' This indicates that the member on the fly side plays a crucial role in controlling the ladder's movement, which is important for maintaining balance and safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_209_3b597aa5",
          "question": "When the command 'OUT FROM THE BUILDING' is given, the members on the bed side place their outside foot on the bottom rung of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'When the command \"OUT FROM THE BUILDING\" is given, the members on the bed side place their inside foot on the bottom rung of the ladder.' This contradicts the statement in the question. The correct foot placement is crucial for maintaining balance and control over the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_209_fe25be95",
          "question": "Pivoting is defined as the turning of the ladder in the appropriate direction on a designated spur while it is in the horizontal position.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Pivoting is defined as the turning of the ladder in the appropriate direction on a designated spur while it is in the vertical position.' This contradicts the statement in the question. Understanding the correct position of the ladder during pivoting is important for safe and effective firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_209_70a4ea64",
          "question": "The member on the fly side of the ladder should have both hands grasping the inside of each beam of the bed section.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the member on the fly side of the ladder will have both hands grasping the outside of each beam of the bed section.' This contradicts the statement in the question. Proper hand placement is crucial for maintaining control over the ladder and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_209_72706301",
          "question": "When pivoting the ladder, the member giving the commands will first designate the beam on which the pivot will be made.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member giving the commands will first designate the beam on which the pivot will be made.' This supports the statement in the question. Clear and accurate communication is vital in firefighting operations to ensure safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_248_b4b7938b",
          "question": "The member at the left butt secures the tip with a ladder anchor when the command 'SECURE THE TIP' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" SECURE THE TIP \" The member at the left butt when lowering in will secure the tip with a ladder anchor.' This confirms that the member at the left butt is responsible for securing the tip with a ladder anchor when the command 'SECURE THE TIP' is given. This is crucial for the stability of the ladder and the safety of the firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_248_fb79b1f3",
          "question": "The member on the right beam bed side is responsible for releasing the halyard when the command 'RELEASE THE HALYARD' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" RELEASE THE H ALYARD \" The member on the right beam bed side will release the halyard.' This confirms that the member on the right beam bed side is responsible for releasing the halyard when the command 'RELEASE THE HALYARD' is given. This is an important step in the process of lowering the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_248_108f07ef",
          "question": "The member on the left pole (#4) will give it to the right pole member (#1) and move to the fly side of the ladder and prepare to foot it when the command 'PREPARE TO LOWER, LEFT POLE AROUND' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" PREPARE TO LOWER, LEFT POLE AROUND \" The member on the left pole (#4) will give it to the right pole member (#1) and move to the fly side of the ladder and prepare to foot it.' This confirms that the member on the left pole (#4) will give it to the right pole member (#1) and move to the fly side of the ladder and prepare to foot it when the command 'PREPARE TO LOWER, LEFT POLE AROUND' is given. This is a key step in the process of lowering the ladder safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_248_63489dbf",
          "question": "The member on the right beam bed side will lower the fly hand-over-hand when the command 'LOWER THE FLY' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" LOW ER THE FLY \" The member on the right beam bed side will lower the fly han d-over-hand.' This confirms that the member on the right beam bed side will lower the fly hand-over-hand when the command 'LOWER THE FLY' is given. This is a critical step in the process of lowering the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_248_af7ea14b",
          "question": "The member in charge (#1) on the poles will check the direction in which the ladder will be lowered for obstructions and state 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN' when the command 'LOWER' is given.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Command \" LOWER \" 246 Chapter 5 \u00b7 Basic Ladders...The member in charge (#1) on the poles will check the di rection in which the ladder will be lowered for obstructions and state \"OVERHEAD CLEAR, CLEAR BEHIND, LADDE R COMING DOWN.\"' This confirms that the member in charge (#1) on the poles will check the direction in which the ladder will be lowered for obstructions and state 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN' when the command 'LOWER' is given. This is a crucial safety measure to ensure the area is clear before lowering the ladder.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_229_7f72c6cf",
          "question": "The Seattle Fire Department uses only two types of ladder raises.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Seattle Fire Department uses three different ladder raises: Cradle raise, Beam raise, Flat raise.' This contradicts the statement that only two types of ladder raises are used. Understanding the different types of ladder raises is crucial for firefighters as it affects how they approach different fire scenarios and building structures.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_229_7a0020d7",
          "question": "The ladder should be raised perpendicular to the building if possible.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Raise the ladder perpendicular to the building if possible.' This supports the statement. Raising the ladder perpendicular to the building is a safety measure to ensure stability and reduce the risk of the ladder tipping over during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_229_ae2b180b",
          "question": "During a flat raise, the fly side of the ladder should be away from the building.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'On flat raises, ladders are placed so that when raised to a vertical position, the fly side of the ladder is toward the building.' This contradicts the statement. The positioning of the ladder's fly side is important as it affects the stability and safety of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_229_a334b313",
          "question": "Firefighters should not pay attention to the tip of the ladder when raising, lowering, extending or retracting the fly.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Members should watch the tip of the ladder when raising, lowering, extending or retracting the fly, and when pivoting or shifting a ladder.' This contradicts the statement. Watching the tip of the ladder is a safety measure to prevent accidents and ensure proper ladder operation during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_229_0cdaff7d",
          "question": "When raising the ladder, the member places the bottom spur of the ladder to the ground.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member places the bottom spur of the ladder to the ground.' This supports the statement. Placing the bottom spur of the ladder to the ground is a crucial step in ensuring the stability of the ladder during raising, which is important for the safety of firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_252_aad48f02",
          "question": "The member in charge of moving the ladder is the one on the left beam.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge (the member on the right beam #1) will check the overhead area for obstructions and state \"OVERHEAD CLEAR.\"' This contradicts the statement in the question. The member in charge is on the right beam, not the left. This is important for coordinating ladder movement and ensuring safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_252_97d16d8c",
          "question": "It is the responsibility of all personnel to survey the area where a ladder is to be raised.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is the responsibility of all personnel to survey the area where a ladder is to be raised.' This supports the statement in the question. This is a critical safety consideration in firefighting operations to prevent accidents and ensure the ladder can be raised safely.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_252_84a98a5e",
          "question": "The ladder is raised to the vertical position by the member at the butt of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ladder is raised to the vertical position by #1 with a hand-over-hand motion on the center of the rungs.' This contradicts the statement in the question. The member at the butt of the ladder does not raise the ladder to the vertical position. Understanding this is crucial for proper ladder operation during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_252_85038d73",
          "question": "The member at the butt of the ladder steps up on the bottom rung with both feet as the ladder is raised.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member at the butt will grasp the halyards tightly, and step up on the bottom rung with both feet as the ladder is raised.' This supports the statement in the question. This is a key operational detail that ensures stability and safety when raising a ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_252_41530e30",
          "question": "The ladder should be placed on the ground with the fly side down.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Place the ladder on the ground, fly side up.' This contradicts the statement in the question. The ladder should be placed on the ground with the fly side up, not down. This is important for the correct setup and operation of the ladder during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_194_223eb6c4",
          "question": "The high shoulder beam carry and low shoulder beam carry are used for ladders of the same length.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies that the high shoulder beam carry is used for a 28' or less extension ladder, while the low shoulder beam carry is used for a 26' or less ground extension ladder. This difference in ladder length may affect the choice of carry method, which in turn could impact the speed and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_194_ba038152",
          "question": "When performing a low shoulder beam carry, the firefighter should face the butt of the ladder while standing at the center.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Face the butt while standing at the center of the ladder.' This positioning is crucial for maintaining control and balance of the ladder during the carry, which can directly impact firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_194_d970e15f",
          "question": "When performing a high shoulder beam carry, the bed section of the ladder should be away from you.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'With your inside hand grasp the closest beam and rotate it up so the bed section is toward you.' This indicates that whether performing a high or low shoulder beam carry, the bed section of the ladder should be towards the firefighter. This positioning can affect the balance and control of the ladder during carry, impacting firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_194_409152ca",
          "question": "The low shoulder beam carry is performed the same way for both engine and ladder truck operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies different ladder lengths for the engine (26' or less ground extension ladder) and ladder truck (28' or less extension ladder) operations. This suggests that while the basic carry method may be the same, the specifics could vary based on the type of operation and ladder length, affecting the tactics and strategies used in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_194_1d243a7e",
          "question": "Unlocking the ladders is the first step in both high and low shoulder beam carry methods.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Unlock ladders.' as the first step in the described carry methods. This is an important safety measure to prevent accidental deployment or movement of the ladder during carry, which could pose risks to firefighter safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_205_9171a19e",
          "question": "When heeling the ladder, the member should always use their right foot for footing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'when raising on the right beam, the right foot is used for footing. When raising on the left beam, the left foot is used'. This means that the foot used for footing depends on the beam being raised, not always the right foot. This is important for maintaining balance and control while raising the ladder, which can impact firefighter safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_205_251fa510",
          "question": "The member heeling the ladder should check for obstructions and personnel before stating 'Overhead Clear.'",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'the member heeling the ladder stands facing the tip at the butt on the bed side, and checks the direction in which the ladder will be raised for obstructions and personnel, then states, \"Overhead Clear.\"' This indicates the importance of ensuring the area is clear before raising the ladder, which can prevent accidents and injuries during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_205_caf458e5",
          "question": "When lowering the ladder, the member's feet should be together.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The other foot will be placed one foot out away from the ladder, both feet will be approximately shoulder width apart.' This contradicts the statement that the feet should be together. Maintaining a wide stance can provide stability and control when lowering the ladder, which is crucial for firefighter safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_205_6caaff77",
          "question": "The hand on the beam of the fly section should be placed above the other hand when lowering the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The hand on the beam of the fly section will be placed below the other.' This contradicts the statement that the hand on the fly section beam should be placed above the other hand. Correct hand placement is important for maintaining control of the ladder during lowering, which can prevent accidents and injuries.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_205_9fd62678",
          "question": "To prevent injury, the groin, rear leg, or knee should be in line with the spur of the ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'To prevent injury, at no time should the groin, rear leg, or knee be In line with the spur of the ladder.' This contradicts the statement that these body parts should be in line with the spur. This safety measure is important to prevent injuries during ladder operations, which can affect a firefighter's ability to perform their duties.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_213_9639d773",
          "question": "The member on the right pole will move on the command 'On the right beam, pivot out' because their right hand is out.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member on the right pole will move on the command, \"On the right beam, pivot out\" because their right hand is out.' This indicates that the position of the member's hand determines their response to the command. This understanding is crucial for coordinated movement during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_213_36394a7d",
          "question": "When the pivot command is given, the member on the designated pole will move to the other side of the pole around the end so that it can be moved without walking backward.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the pivot command is given, the member on the designated pole will move to the other side of the pole around the end so that it can be moved without walking backward.' This highlights the importance of efficient movement during firefighting operations to ensure safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_213_fe8b07e9",
          "question": "After the pole is 2 feet past being in line with both beams, the member will let go of the pole.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member will then walk forward until the pole is 2 feet past being in line with both beams. The member will again move to the other side of the pole while still holding onto it.' This contradicts the statement that the member will let go of the pole. Maintaining hold of the pole is important for stability and control during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_213_9f77fe8b",
          "question": "The member on the left pole will not move on the command 'On the right beam, pivot in'.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the left pole will move on the command \"On the right beam, pivot in\" because their right hand is in.' This contradicts the statement that the member on the left pole will not move on this command. Understanding and responding to commands correctly is vital for safety and coordination in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_213_0ad8a8e4",
          "question": "After the pivot command, both pole members will be facing away from each other.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member will again move to the other side of the pole while still holding onto it so that both pole members are again facing each other.' This contradicts the statement that the members will be facing away from each other. This understanding is important for maintaining visual contact and coordination during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_244_3d21c8f5",
          "question": "The member in charge (#1) is responsible for checking the overhead area for obstructions before raising the poles.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The member in charge will again check the overhead area for obstructions and state \"OVERHEAD CLEAR.\"' This supports the statement and highlights the importance of ensuring a safe environment before proceeding with operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_244_870586e9",
          "question": "The member on the butt (#4) is responsible for receiving the spikes of the poles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member in charge (#1), has moved to a position facing the tip of the ladder and prepares to receive the spikes of the poles.' This contradicts the statement and emphasizes the importance of understanding roles and responsibilities during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_244_3f469980",
          "question": "The member on the poles (#1) should grasp the poles with arms on the inside of the poles.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member on the poles (#1) grasps a pole in each hand with arms on the outside of the poles while standing between the poles.' This contradicts the statement and emphasizes the importance of proper handling techniques for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_244_a27c15d6",
          "question": "The poles can be held with the spikes between the middle and ring fingers with palms up.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The poles also may be held with the spikes between the middle and ring fingers with palms up and both arms on the outside of the poles while standing between the poles.' This supports the statement and highlights the flexibility in handling techniques to accommodate individual comfort and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_244_30d1add9",
          "question": "It is the responsibility of the member in charge (#1) alone to survey the area where the poles are to be passed.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is the responsibility of all personnel to survey the area where the poles are to be passed.' This contradicts the statement and underscores the importance of collective responsibility for safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_182_e180aeb2",
          "question": "It is safe to adjust the butt of an extended ladder before the tip is against the building and the fly is properly secured.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not adjust the butt of an extended ladder until the tip is against the building and the fly is properly secured with the halyard or body loop.' This means that adjusting the butt of the ladder before these conditions are met can be dangerous. The implications for firefighting operations are that improper ladder placement can lead to instability, potentially causing injury or failure to access the necessary areas of a burning building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_182_c19cec8d",
          "question": "Firefighters should avoid walking backward while carrying ladders.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Avoid walking backward while carrying ladders.' This indicates that walking backward while carrying ladders can be dangerous, possibly leading to trips, falls, or other accidents. In a firefighting context, this could delay response times or cause injury to firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_182_49aa7a2d",
          "question": "It is acceptable to lock in on an aerial ladder.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Never lock in on an aerial ladder.' This means that locking in on an aerial ladder is not safe. The implication for firefighting is that doing so could lead to a dangerous situation where a firefighter is unable to quickly descend the ladder if necessary.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_182_2d45e907",
          "question": "Firefighters should always watch the tip of the ladder when it is in the vertical position.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Always watch the tip of the ladder whenever it is in the vertical position.' This implies that keeping an eye on the ladder tip can prevent accidents. In a firefighting scenario, this could help ensure that the ladder does not accidentally come into contact with overhead obstructions or other hazards.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_182_dcb35fe2",
          "question": "It is safe to step over ladders lying on the ground.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not step over ladders lying on the ground, walk around instead.' This indicates that stepping over ladders on the ground can be dangerous. In a firefighting context, this could lead to trips or falls, potentially causing injury and delaying response times.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_251_063a1272",
          "question": "In the ladder evolution, who is responsible for heeling the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, the member on the fly side is responsible for heeling the ladder.",
          "options": {
            "A": "The member on the fly side",
            "B": "The member on the bed side",
            "C": "Both members",
            "D": "The member at the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_251_1e8885b4",
          "question": "What is the role of the member on the bed side during the flat lower evolution?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the bed side slowly walks backward while grasping the center of the rungs during the flat lower evolution.",
          "options": {
            "A": "Heels the ladder",
            "B": "Slowly walks backward while grasping the center of the rungs",
            "C": "Moves to the beams and uses a hand-over-hand motion down the beams",
            "D": "Assumes the cradle carry"
          }
        },
        {
          "id": "sfd_basic_skills_251_1f03dcd1",
          "question": "During the cradle lower evolution, when do the members turn to face each other?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During the cradle lower evolution, the members turn to face each other at the mid-section or balance point of the ladder.",
          "options": {
            "A": "At the beginning of the evolution",
            "B": "At the end of the evolution",
            "C": "At the mid-section or balance point of the ladder",
            "D": "When they reach the tip of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_251_75a0c7d3",
          "question": "What motion is used by the members when moving down the beams during the cradle lower evolution?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A hand-over-hand motion is used by the members when moving down the beams during the cradle lower evolution.",
          "options": {
            "A": "A hand-over-hand motion",
            "B": "A step-by-step motion",
            "C": "A slide-down motion",
            "D": "A jump-down motion"
          }
        },
        {
          "id": "sfd_basic_skills_251_2ac04156",
          "question": "What is the final position assumed by the members during the cradle lower evolution?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The final position assumed by the members during the cradle lower evolution is the cradle carry.",
          "options": {
            "A": "The fly side",
            "B": "The bed side",
            "C": "The cradle carry",
            "D": "The top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_197_bf1da878",
          "question": "Where should the member in charge be positioned during a beam carry of a 26' or less ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member in charge should be at the butt of the ladder during a beam carry. This is to ensure proper control and safety during the operation.",
          "options": {
            "A": "At the top of the ladder",
            "B": "In the middle of the ladder",
            "C": "At the butt of the ladder",
            "D": "At a distance, supervising the operation"
          }
        },
        {
          "id": "sfd_basic_skills_197_4b322109",
          "question": "What is the first step in removing the ladder from the apparatus during a beam carry?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in removing the ladder from the apparatus during a beam carry is to unlock the ladders. This ensures the ladder can be safely and effectively removed from the apparatus.",
          "options": {
            "A": "Carry the ladder to the objective",
            "B": "Place the inside hand through the rungs",
            "C": "Unlock the ladders",
            "D": "Position one member on each side of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_197_632ea431",
          "question": "How should the ladder be carried during a cradle carry of a 35' or less ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During a cradle carry of a 35' or less ground extension ladder, one member is positioned on each side of the ladder. This ensures the weight of the ladder is evenly distributed and can be safely carried to the objective.",
          "options": {
            "A": "One member carries the ladder alone",
            "B": "The ladder is dragged to the objective",
            "C": "One member is positioned on each side of the ladder",
            "D": "The ladder is carried on the shoulders of two members"
          }
        },
        {
          "id": "sfd_basic_skills_197_8f48cd7b",
          "question": "When is the ladder considered free of the ladder rack during a cradle carry?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The ladder is considered free of the ladder rack when it is completely out of the rack. This is the point at which the members can begin to carry the ladder to the objective.",
          "options": {
            "A": "When the ladder locks are released",
            "B": "When the ladder is half way out of the rack",
            "C": "When the ladder is completely out of the rack",
            "D": "When the ladder is carried to the objective"
          }
        },
        {
          "id": "sfd_basic_skills_197_ffc1a590",
          "question": "Where should the inside hand be placed when removing the ladder from the side of the apparatus during a beam carry?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When removing the ladder from the side of the apparatus during a beam carry, the inside hand should be placed between the 2nd and 3rd rungs from the ends. This provides better control and stability during the operation.",
          "options": {
            "A": "On the upper beam",
            "B": "On the lower beam",
            "C": "Between the 2nd and 3rd rungs from the ends",
            "D": "On the butt of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_178_e473c19e",
          "question": "What is the purpose of the spikes on a fire service ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Spikes are protrusions at the butt of a ladder to prevent slipping when in the raised position, and to protect the end of the beams.",
          "options": {
            "A": "To assist in climbing the ladder",
            "B": "To extend the length of the ladder",
            "C": "To prevent the ladder from slipping when raised",
            "D": "To attach the tormentor pole to the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_178_e8cc1c84",
          "question": "What is the function of the tormentor poles on a 40' or larger extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Tormentor poles are attached to the upper bed section of a 40' or larger extension ladder and are used to assist in raising, lowering, pivoting, and stabilizing of the ladder.",
          "options": {
            "A": "To increase the height of the ladder",
            "B": "To assist in raising, lowering, pivoting, and stabilizing of the ladder",
            "C": "To provide a secure footing when operating on a pitched roof",
            "D": "To prevent the extension of a fly section out of the top of the bed"
          }
        },
        {
          "id": "sfd_basic_skills_178_84406146",
          "question": "What is the primary use of a roof ladder in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A roof ladder is a straight ladder with folding hooks at the tip end used for maintaining secure footing when operating on a pitched roof.",
          "options": {
            "A": "To break through windows",
            "B": "To climb over walls",
            "C": "To maintain secure footing when operating on a pitched roof",
            "D": "To extend the reach of the fire hose"
          }
        },
        {
          "id": "sfd_basic_skills_178_9817c1be",
          "question": "What is the purpose of the rung plates on a fire service ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Rung plates are the metal plates where the rungs are set in the beam.",
          "options": {
            "A": "To provide a grip for climbing",
            "B": "To attach the ladder to the fire truck",
            "C": "To set the rungs in the beam",
            "D": "To extend the length of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_178_302ca98d",
          "question": "What is the function of the pulley in the operation of a fire service ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The pulley is the grooved metal wheel over which the halyard or cable is drawn when extending or retracting the flies.",
          "options": {
            "A": "To assist in climbing the ladder",
            "B": "To extend or retract the flies",
            "C": "To provide a secure footing when operating on a pitched roof",
            "D": "To prevent the ladder from slipping when raised"
          }
        },
        {
          "id": "sfd_basic_skills_206_0fa7714a",
          "question": "What is the main purpose of footing a ladder during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The main purpose of footing a ladder is to prevent it from rocking left and right, which can lead to loss of control.",
          "options": {
            "A": "To increase the height of the ladder",
            "B": "To make the ladder more visible",
            "C": "To prevent the ladder from rocking left and right",
            "D": "To make the ladder easier to climb"
          }
        },
        {
          "id": "sfd_basic_skills_206_42597f55",
          "question": "When should a ladder be footed during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A ladder should be footed any time it is shifted, pivoted, or brought to the vertical as well as any other time it is unsteady while in the vertical position.",
          "options": {
            "A": "Only when the ladder is in the vertical position",
            "B": "Any time it is shifted, pivoted, or brought to the vertical",
            "C": "Only when the ladder is being used to rescue victims",
            "D": "Only when the ladder is being used to access a burning building"
          }
        },
        {
          "id": "sfd_basic_skills_206_a0e6dd71",
          "question": "What can early footing prevent during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Early footing can prevent the member's loss of control of the ladder, especially if the ladder is starting to tip left or right.",
          "options": {
            "A": "The ladder from catching fire",
            "B": "The ladder from being seen by the public",
            "C": "The member's loss of control of the ladder",
            "D": "The ladder from being used by other firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_206_0eae9010",
          "question": "How many members can foot the ladder in unison during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that one member can foot the ladder, but also that two members can foot the ladder in unison.",
          "options": {
            "A": "One",
            "B": "Two",
            "C": "Three",
            "D": "Four"
          }
        },
        {
          "id": "sfd_basic_skills_206_e4b03fac",
          "question": "What is the potential risk if a ladder is not properly footed during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If a ladder is not properly footed, it may rock left and right, which can lead to loss of control.",
          "options": {
            "A": "The ladder may collapse",
            "B": "The ladder may rock left and right",
            "C": "The ladder may catch fire",
            "D": "The ladder may become invisible"
          }
        },
        {
          "id": "sfd_basic_skills_210_17361490",
          "question": "What does the command 'ON THE LEFT BEAM, PIVOT OUT' instruct firefighters to do?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'ON THE LEFT BEAM, PIVOT OUT' instructs to rotate the ladder one quarter turn toward the bed side.",
          "options": {
            "A": "Rotate the ladder one quarter turn toward the fly side",
            "B": "Rotate the ladder one quarter turn toward the bed side",
            "C": "Rotate the ladder one half turn toward the bed side",
            "D": "Rotate the ladder one half turn toward the fly side"
          }
        },
        {
          "id": "sfd_basic_skills_210_04bc3773",
          "question": "What does the term 'IN' refer to in the context of ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The term 'IN' refers to pivoting the ladder on the designated beam toward the fly side.",
          "options": {
            "A": "Pivoting the ladder on the designated beam toward the bed side",
            "B": "Pivoting the ladder on the designated beam toward the fly side",
            "C": "Lifting the ladder onto the designated beam",
            "D": "Lowering the ladder onto the designated beam"
          }
        },
        {
          "id": "sfd_basic_skills_210_6963d77d",
          "question": "What is the assumed pivot turn unless directed otherwise in the command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Every pivot command assumes a 1/4 turn unless directed otherwise in the command.",
          "options": {
            "A": "1/8 turn",
            "B": "1/4 turn",
            "C": "1/2 turn",
            "D": "Full turn"
          }
        },
        {
          "id": "sfd_basic_skills_210_32115cb7",
          "question": "What is the role of the members on the bed section of the ladder after each pivot?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The members on the bed section of the ladder foot the ladder after each pivot.",
          "options": {
            "A": "They rotate the ladder",
            "B": "They foot the ladder",
            "C": "They lift the ladder",
            "D": "They lower the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_210_429a4a13",
          "question": "What does the term 'OUT' refer to in the context of ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The term 'OUT' refers to pivoting the ladder on the designated beam toward the bed side.",
          "options": {
            "A": "Pivoting the ladder on the designated beam toward the bed side",
            "B": "Pivoting the ladder on the designated beam toward the fly side",
            "C": "Lifting the ladder onto the designated beam",
            "D": "Lowering the ladder onto the designated beam"
          }
        },
        {
          "id": "sfd_basic_skills_247_d6169a94",
          "question": "Who is responsible for ensuring that all the dogs are locked during a ladder extension operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text states that it is the responsibility of all personnel to be aware that all the dogs are locked.",
          "options": {
            "A": "The member in charge (#1)",
            "B": "The members on the bed side",
            "C": "The member on the right beam",
            "D": "All personnel"
          }
        },
        {
          "id": "sfd_basic_skills_247_3904304c",
          "question": "What is the role of the members on the poles during the 'INTO THE BUILDING' command?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During the 'INTO THE BUILDING' command, the members on the poles lower the ladder into the objective using the poles to guide the tip to the proper placement.",
          "options": {
            "A": "They secure the halyard",
            "B": "They adjust the butt of the ladder",
            "C": "They lower the ladder into the objective using the poles to guide the tip to the proper placement",
            "D": "They lock the dogs at the next highest rung"
          }
        },
        {
          "id": "sfd_basic_skills_247_8b6f617e",
          "question": "What is the role of the member on the right beam after the 'INTO THE BUILDING' command?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After the 'INTO THE BUILDING' command, the member on the right beam secures the halyard.",
          "options": {
            "A": "They secure the halyard",
            "B": "They adjust the butt of the ladder",
            "C": "They lock the dogs at the next highest rung",
            "D": "They heel the ladder with their inside foot on the bottom rung"
          }
        },
        {
          "id": "sfd_basic_skills_247_1c2c4f8c",
          "question": "What is the importance of the 'EXTEND THE FLY' command during a ladder extension operation?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'EXTEND THE FLY' command signals the start of the ladder extension.",
          "options": {
            "A": "It signals the start of the ladder extension",
            "B": "It signals that all the dogs are locked",
            "C": "It signals the members on the bed side to heel the ladder",
            "D": "It signals the member on the right beam to secure the halyard"
          }
        },
        {
          "id": "sfd_basic_skills_247_f850d182",
          "question": "What is the primary safety consideration when placing the outside toes during a ladder extension operation?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "For safety and stability, the outside toes should be placed in front and against the bed side spur during a ladder extension operation.",
          "options": {
            "A": "They should be placed in front and against the bed side spur",
            "B": "They should be placed on the bottom rung",
            "C": "They should be placed on the fourth rung up from the spur",
            "D": "They should be placed on the halyard"
          }
        },
        {
          "id": "sfd_basic_skills_181_aba09cfd",
          "question": "Why is the folding ladder, also known as the 'attic' ladder, particularly useful in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The folding ladder is useful because it can be easily maneuvered around corners, in hallways, and in stairwells, which is often necessary during firefighting operations.",
          "options": {
            "A": "It can be extended to any length",
            "B": "It is lighter than other ladders",
            "C": "It can be easily maneuvered around corners, in hallways, and in stairwells",
            "D": "It is equipped with 'tormentor' poles for easy handling"
          }
        },
        {
          "id": "sfd_basic_skills_181_03310e17",
          "question": "What is the purpose of the 'tormentor' poles on ladders that are 40 feet or longer?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'tormentor' poles on ladders that are 40 feet or longer are designed to assist in handling and placement of the ladder during firefighting operations.",
          "options": {
            "A": "To extend the ladder's length",
            "B": "To assist in handling and placement of the ladder",
            "C": "To make the ladder heavier",
            "D": "To fold the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_181_16d35867",
          "question": "What is the difference between a folding ladder and an extension ladder in terms of their construction?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The main difference in construction is that extension ladders have two or more sections and can be extended with a halyard, whereas folding ladders cannot be extended.",
          "options": {
            "A": "Folding ladders are always longer than extension ladders",
            "B": "Extension ladders have two or more sections and can be extended with a halyard",
            "C": "Folding ladders can be extended to any length",
            "D": "Extension ladders cannot be maneuvered around corners"
          }
        },
        {
          "id": "sfd_basic_skills_181_3a23d6c0",
          "question": "What is the approximate weight of a 35\u2019 Extension Ladder according to the Duo-Safety ladder company?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the Duo-Safety ladder company, a 35\u2019 Extension Ladder weighs approximately 129 lbs.",
          "options": {
            "A": "72 lbs",
            "B": "92 lbs",
            "C": "129 lbs",
            "D": "215 lbs"
          }
        },
        {
          "id": "sfd_basic_skills_181_cfdfb5f0",
          "question": "What is the exception to the rule that extension ladders are extended with a halyard?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The exception to the rule that extension ladders are extended with a halyard is the 'baby' ladder due to its height.",
          "options": {
            "A": "The 'attic' ladder",
            "B": "The 'baby' ladder due to its height",
            "C": "Ladders that are 40 feet or longer",
            "D": "The 'bangor' ladder"
          }
        },
        {
          "id": "sfd_basic_skills_230_ff030ceb",
          "question": "What is the purpose of pivoting the ladder 1/4 turn when it's almost to the vertical?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The ladder is pivoted 1/4 turn when it's almost to the vertical to position the fly closest to the building. This is important for the safety and efficiency of firefighting operations.",
          "options": {
            "A": "To ensure the ladder locks are set",
            "B": "To make the ladder easier to carry",
            "C": "To position the fly closest to the building",
            "D": "To alert personnel that the ladder is about to be lowered"
          }
        },
        {
          "id": "sfd_basic_skills_230_e567d4fc",
          "question": "What is the correct procedure to lower the ladder from the building?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The correct procedure to lower the ladder from the building involves releasing the halyard, placing the left foot on the bottom rung, pulling the ladder tip out from the building, lowering the fly, and preparing to lower the ladder to the ground.",
          "options": {
            "A": "Release the halyard, place left foot on the bottom rung, pull the ladder tip out from the building, lower the fly, and prepare to lower the ladder to the ground.",
            "B": "Extend the fly to the desired height, verify that the dogs are locked, and then lower the ladder.",
            "C": "Raise the ladder up on its lower beam, pivot the ladder 1/4 turn, and then lower the ladder.",
            "D": "Secure the halyard, adjust the butt if necessary, and then lower the ladder."
          }
        },
        {
          "id": "sfd_basic_skills_230_e69faa9e",
          "question": "What is the importance of stating 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN' when lowering the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Stating 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN' is important to alert personnel in the area that a ladder is about to be lowered. This is a crucial safety measure in firefighting operations.",
          "options": {
            "A": "To ensure the ladder locks are set",
            "B": "To alert personnel in the area that a ladder is about to be lowered",
            "C": "To verify that the dogs are locked",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_230_a231da69",
          "question": "What is the correct hand position when lowering the ladder to the ground?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When lowering the ladder to the ground, the correct hand position is to have the hands on the beams, using a sliding hand on the beams or hand-over-hand technique on the rungs.",
          "options": {
            "A": "Hands on the beams, using a sliding hand on the beams",
            "B": "Hands on the fourth rung up from the butt",
            "C": "One hand on the halyard, the other on the bottom rung",
            "D": "Both hands on the halyard"
          }
        },
        {
          "id": "sfd_basic_skills_230_cfa43697",
          "question": "What is the first step in lowering the ladder from the building?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in lowering the ladder from the building is to release the halyard. This allows the ladder to be moved away from the building.",
          "options": {
            "A": "Place left foot on the bottom rung",
            "B": "Pull the ladder tip out from the building",
            "C": "Release the halyard",
            "D": "Lower the fly"
          }
        },
        {
          "id": "sfd_basic_skills_267_eb29ef38",
          "question": "What is the main hazard associated with ventilating windows during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that falling glass is an extreme hazard during ventilation process.",
          "options": {
            "A": "The ladder might break",
            "B": "Falling glass",
            "C": "The window might not break",
            "D": "The fire might spread"
          }
        },
        {
          "id": "sfd_basic_skills_267_5da38e1c",
          "question": "What is the least effective method when trying to ventilate a window?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, aiming for the center of the window is the least effective method for ventilation.",
          "options": {
            "A": "Aiming for the center of the window",
            "B": "Aiming for the corners of the window",
            "C": "Using the ladder in a beam configuration",
            "D": "Using the 'fly-in' method"
          }
        },
        {
          "id": "sfd_basic_skills_267_1d69564e",
          "question": "What is the 'fly-in' method in firefighting ventilation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'fly-in' method refers to lowering the ladder into the window with both beam sections striking the panes simultaneously.",
          "options": {
            "A": "Breaking the window with a fire axe",
            "B": "Lowering the ladder into the window with both beam sections striking the panes simultaneously",
            "C": "Throwing a heavy object into the window",
            "D": "Using a special tool to cut a hole in the window"
          }
        },
        {
          "id": "sfd_basic_skills_267_59827cbd",
          "question": "Why might newer energy efficient windows (EEW) be difficult to ventilate from an exterior position?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that newer energy efficient windows (EEW) may have multiple panes, making them difficult to ventilate from an exterior position.",
          "options": {
            "A": "They are often made of stronger material",
            "B": "They may have multiple panes",
            "C": "They are usually installed at a higher level",
            "D": "They are usually smaller in size"
          }
        },
        {
          "id": "sfd_basic_skills_267_3c412233",
          "question": "What is the best strategy to break a window for ventilation during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that aiming as close to the corners as possible is the most effective method for breaking a window for ventilation.",
          "options": {
            "A": "Aim for the center of the window",
            "B": "Aim for the corners of the window",
            "C": "Use the 'fly-in' method",
            "D": "Use a special tool to cut a hole in the window"
          }
        },
        {
          "id": "sfd_basic_skills_226_790a5a2a",
          "question": "In which situations does the Seattle Fire Department recommend securing the ladder tip?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text mentions that ladder tips need to be secured during extended operations, when operating fire streams, or when working from a ladder while locked in.",
          "options": {
            "A": "During extended operations",
            "B": "When working from a ladder while locked in",
            "C": "When operating fire streams",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_226_4c8e97ee",
          "question": "What is the recommended method for bringing the ladder anchor to the tip or fly section?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that the ladder anchor should be brought to the tip or fly section by holding it in a hand while sliding that hand along a beam or placing it in a pocket while climbing.",
          "options": {
            "A": "Throwing it",
            "B": "Holding it in a hand while sliding that hand along a beam or placing it in a pocket while climbing",
            "C": "Using a pulley system",
            "D": "Using a drone"
          }
        },
        {
          "id": "sfd_basic_skills_226_bcf82637",
          "question": "What is the first step in securing the ladder anchor once you reach the window sill, balcony, railing, or parapet edge?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step mentioned in the text is to secure the hook over the object.",
          "options": {
            "A": "Make a loop starting with going over the 1st rung below the sill/edge",
            "B": "Tie two half hitches to the rope that extends from the 1st to 2nd rung",
            "C": "Secure the hook over the object",
            "D": "Start over the top of the 1st rung below the sill/top of wall or roof line"
          }
        },
        {
          "id": "sfd_basic_skills_226_bef85a2f",
          "question": "What is the recommended method for maintaining contact with the ladder while working?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text recommends maintaining three points of contact with the ladder using your feet and at least one hand or one arm.",
          "options": {
            "A": "Maintain three points of contact with the ladder using your feet and at least one hand or one arm",
            "B": "Maintain two points of contact with the ladder using your feet",
            "C": "Maintain four points of contact with the ladder using your feet and both hands",
            "D": "Maintain one point of contact with the ladder using one foot"
          }
        },
        {
          "id": "sfd_basic_skills_226_57c3f39c",
          "question": "What is the purpose of sinking the hook into the drywall?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that the hook should be sunk into the drywall to hook the actual sill or structural member of a parapet wall.",
          "options": {
            "A": "To hook the actual sill or structural member of a parapet wall",
            "B": "To ensure the ladder does not slip",
            "C": "To create a loop with the rope",
            "D": "To test the strength of the drywall"
          }
        },
        {
          "id": "sfd_basic_skills_175_463319ec",
          "question": "What is the primary safety consideration when using basic ladders during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "While all considerations are important, safety is paramount. Checking the ladder for any defects or damage before use can prevent accidents and ensure the safety of the firefighters.",
          "options": {
            "A": "Ensuring the ladder is the right color",
            "B": "Making sure the ladder is long enough to reach the top of the building",
            "C": "Checking the ladder for any defects or damage before use",
            "D": "Making sure the ladder matches the rest of the firefighting equipment"
          }
        },
        {
          "id": "sfd_basic_skills_175_730edd65",
          "question": "How does understanding the basics of ladders affect firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding the basics of ladders helps firefighters choose the right ladder for the job, which can greatly affect the success of the operation.",
          "options": {
            "A": "It doesn't affect operations at all",
            "B": "It helps in choosing the right ladder for the job",
            "C": "It makes the firefighters look more professional",
            "D": "It increases the budget for firefighting equipment"
          }
        },
        {
          "id": "sfd_basic_skills_175_ee666246",
          "question": "What is a key operational tactic when using basic ladders in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The primary operational tactic when using basic ladders in firefighting is to reach higher floors quickly and safely.",
          "options": {
            "A": "Using the ladder to break windows",
            "B": "Using the ladder as a shield against fire",
            "C": "Using the ladder to reach higher floors quickly and safely",
            "D": "Using the ladder to carry heavy equipment"
          }
        },
        {
          "id": "sfd_basic_skills_175_65d61e58",
          "question": "What is the most important factor to consider when selecting a ladder for a firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The most important factor to consider when selecting a ladder for a firefighting operation is the height the ladder can reach. This ensures that firefighters can safely and effectively reach the areas they need to.",
          "options": {
            "A": "The weight of the ladder",
            "B": "The cost of the ladder",
            "C": "The height the ladder can reach",
            "D": "The color of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_175_9597fc4a",
          "question": "Why is it important for a firefighter to understand the basics of ladders?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding the basics of ladders helps a firefighter make informed decisions during operations, which can greatly affect the success of the operation and the safety of all involved.",
          "options": {
            "A": "It helps in passing the firefighter exam",
            "B": "It helps in making informed decisions during operations",
            "C": "It helps in negotiating for a higher salary",
            "D": "It helps in impressing the public"
          }
        },
        {
          "id": "sfd_basic_skills_227_e888fabe",
          "question": "What is the main purpose of the leg-locking procedure while working on a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The leg-locking procedure is used to secure a firefighter's position on the ladder, allowing both hands to be free for work.",
          "options": {
            "A": "To allow for faster climbing",
            "B": "To show off one's agility",
            "C": "To free both hands for work",
            "D": "To test the ladder's strength"
          }
        },
        {
          "id": "sfd_basic_skills_227_9b10aaea",
          "question": "What should a firefighter adjust during the leg-locking procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Firefighters are advised to adjust the position of the leg-lock based on their individual height for maximum comfort and safety.",
          "options": {
            "A": "The height of the ladder",
            "B": "The position of the leg-lock based on individual height",
            "C": "The number of rungs on the ladder",
            "D": "The weight distribution on the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_227_beb14821",
          "question": "When should a firefighter not use the leg-lock technique?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that members should not use the leg-lock technique on any ladder that is not secured at the tip or any type of aerial ladder device.",
          "options": {
            "A": "When the ladder is secured at the tip",
            "B": "When working on an aerial ladder device",
            "C": "When the ladder has more than 10 rungs",
            "D": "When the ladder is made of wood"
          }
        },
        {
          "id": "sfd_basic_skills_227_2176aa2f",
          "question": "What is the first step in the procedure for locking-in on a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in the procedure for locking-in on a ladder is to climb one rung above the height at which you desire to work.",
          "options": {
            "A": "Tie two half-hitches above rung 2",
            "B": "Climb one rung above the height at which you desire to work",
            "C": "Step down one rung",
            "D": "Lock the toe under the next rung down"
          }
        },
        {
          "id": "sfd_basic_skills_227_6bf32cc9",
          "question": "What is the overall goal of the leg-locking procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The overall goal of the leg-locking procedure is to establish a secure position on the ladder.",
          "options": {
            "A": "To increase the speed of climbing",
            "B": "To establish a secure position",
            "C": "To test the strength of the ladder",
            "D": "To reduce the weight on the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_266_1746b4fe",
          "question": "What is the purpose of the command 'SECURE THE HALYARD' during the exterior venting of windows with a ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'SECURE THE HALYARD' is given to ensure that the ladder is stable and secure before shifting the butt of the ladder over to the center of the window to be ventilated.",
          "options": {
            "A": "To ensure that the ladder is extended to its full length",
            "B": "To ensure that the ladder is positioned correctly to the left or right of the window",
            "C": "To ensure that the ladder is stable and secure before moving it to the center of the window",
            "D": "To ensure that the ladder is brought out from the building to the vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_266_9ff5c9b3",
          "question": "Why is it important for members to step back to a safe place after pushing the ladder into the window during ventilation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Members are advised to step back to a safe place after pushing the ladder into the window to avoid being hit by falling glass during ventilation.",
          "options": {
            "A": "To avoid being hit by the ladder when it slides out",
            "B": "To avoid being hit by falling glass",
            "C": "To avoid blocking the view of the window",
            "D": "To avoid obstructing the path of other firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_266_c2163d66",
          "question": "What is the next step after the command 'PREPARE TO VENTILATE' is given during the exterior venting of windows with a ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After the command 'PREPARE TO VENTILATE' is given, the member on the fly side of the ladder moves to a safe place away from the base of the ladder to avoid falling glass.",
          "options": {
            "A": "The member on the fly side of the ladder moves to a safe place away from the base of the ladder",
            "B": "The member on the bed side of the ladder pushes the ladder into the window",
            "C": "The ladder is brought out from the building to the vertical position",
            "D": "The ladder is lowered into the building next to the window to be ventilated"
          }
        },
        {
          "id": "sfd_basic_skills_266_9f50e28c",
          "question": "What should be done if the butt of the ladder slides out after the ladder hits the window during ventilation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the butt of the ladder slides out after the ladder hits the window, the ladder should be brought out from the building to the vertical position.",
          "options": {
            "A": "The ladder should be immediately repositioned",
            "B": "The ladder should be extended further",
            "C": "The ladder should be brought out from the building to the vertical position",
            "D": "The ladder should be left in its position until all the glass has fallen"
          }
        },
        {
          "id": "sfd_basic_skills_266_f1ff9aa5",
          "question": "What is the final step in the exterior venting of windows with a ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The final step in the exterior venting of windows with a ground ladder is to lower the ladder into the building on the opposite side of the vented window.",
          "options": {
            "A": "The ladder is brought out from the building to the vertical position",
            "B": "The ladder is lowered into the building on the opposite side of the vented window",
            "C": "The ladder is pivoted to the center of the window to be ventilated",
            "D": "The ladder is shifted to the center of the window to be ventilated"
          }
        },
        {
          "id": "sfd_basic_skills_231_74e3d0e6",
          "question": "Who is responsible for checking the overhead area for obstructions before raising the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the butt is in charge and will check the overhead area for obstructions before raising the ladder.",
          "options": {
            "A": "The member at the tip",
            "B": "The member at the butt",
            "C": "All personnel",
            "D": "The member in the middle"
          }
        },
        {
          "id": "sfd_basic_skills_231_af971ae7",
          "question": "What is the command given to lower the butt of the ladder so that the spur of the lower beam will be grounded at the desired point?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The command 'Ground the butt' is given to lower the butt of the ladder so that the spur of the lower beam will be grounded at the desired point.",
          "options": {
            "A": "Prepare to raise",
            "B": "Overhead clear",
            "C": "Beam carry",
            "D": "Ground the butt"
          }
        },
        {
          "id": "sfd_basic_skills_231_5f8a1a9b",
          "question": "What should the member at the tip do if a beam raise parallel to the objective is necessary and the butt has been grounded with the bed toward the objective?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the tip should quickly roll the ladder over their head. This will properly place the fly toward the objective, avoiding the necessity to pivot the ladder 180 degrees when vertical.",
          "options": {
            "A": "The member at the tip should pivot the ladder 180 degrees when vertical",
            "B": "The member at the tip should quickly roll the ladder over their head",
            "C": "The member at the tip should move to the butt position",
            "D": "The member at the tip should ground the butt"
          }
        },
        {
          "id": "sfd_basic_skills_231_095f4c96",
          "question": "What is the response to the command 'Prepare to raise'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The response to the command 'Prepare to raise' is 'Overhead clear'. This indicates that the area above the ladder is free of obstructions.",
          "options": {
            "A": "Ground the butt",
            "B": "Overhead clear",
            "C": "Beam carry",
            "D": "Prepare to raise"
          }
        },
        {
          "id": "sfd_basic_skills_231_664a8ce1",
          "question": "What is the most common method used for raising the ladder when it is beam carried to the objective?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The most common method used for raising the ladder when it is beam carried to the objective is the beam raise.",
          "options": {
            "A": "Ground extension",
            "B": "Straight ladder",
            "C": "Beam raise",
            "D": "Overhead clear"
          }
        },
        {
          "id": "sfd_basic_skills_180_354a53ad",
          "question": "What is the primary use of a baby ladder in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The baby ladder is primarily used in gaining access to lower elevations on the exterior of buildings, salvage work, and gaining access to scuttles inside buildings.",
          "options": {
            "A": "To establish secure footing on a pitched roof",
            "B": "To gain access to lower elevations on the exterior of buildings",
            "C": "To allow easier access to the bottom of a fire escape",
            "D": "To be used as a support while removing shingles"
          }
        },
        {
          "id": "sfd_basic_skills_180_8644a963",
          "question": "What is the main purpose of the hooks on a roof ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hooks on a roof ladder provide a means of anchoring the ladder over the roof ridge or some other roof part.",
          "options": {
            "A": "To extend the length of the ladder",
            "B": "To provide a means of anchoring the ladder over the roof ridge or some other roof part",
            "C": "To be used as a handle for carrying the ladder",
            "D": "To hook onto a fire escape for easier access"
          }
        },
        {
          "id": "sfd_basic_skills_180_d4f1732b",
          "question": "How does a roof ladder contribute to firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A roof ladder provides support while removing shingles, cutting holes, and performing other ventilation and fire fighting operations.",
          "options": {
            "A": "It is used to rescue people from burning buildings",
            "B": "It is used to spray water onto the fire from a height",
            "C": "It provides support while removing shingles, cutting holes, and performing other ventilation and fire fighting operations",
            "D": "It is used to gain access to lower elevations on the exterior of buildings"
          }
        },
        {
          "id": "sfd_basic_skills_180_94279d6d",
          "question": "What is the most common size of a roof ladder carried in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Roof ladders vary in length from ten to twenty feet, with twelve to fourteen being the most common size carried.",
          "options": {
            "A": "Ten to twenty feet",
            "B": "Twelve to fourteen feet",
            "C": "Fourteen to sixteen feet",
            "D": "Sixteen to eighteen feet"
          }
        },
        {
          "id": "sfd_basic_skills_180_2dc06a37",
          "question": "How can a roof ladder be used to access a fire escape?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A roof ladder can allow easier access to the bottom of a fire escape by using the hooks over the rungs and the spurs on the ground.",
          "options": {
            "A": "By extending the ladder to reach the fire escape",
            "B": "By using the hooks over the rungs and the spurs on the ground",
            "C": "By using the ladder as a bridge to the fire escape",
            "D": "By using the ladder to climb over the fire escape"
          }
        },
        {
          "id": "sfd_basic_skills_246_42082029",
          "question": "What is the correct position for the member on the right pole?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the right pole will have the pole crossing the front of their body with their right hand extended to the pole at shoulder height.",
          "options": {
            "A": "The pole crosses the front of their body with their left hand extended to the pole at shoulder height",
            "B": "The pole crosses the front of their body with their right hand extended to the pole at shoulder height",
            "C": "The pole crosses the back of their body with their right hand extended to the pole at shoulder height",
            "D": "The pole crosses the front of their body with their right hand extended to the pole at hip height"
          }
        },
        {
          "id": "sfd_basic_skills_246_3fa62685",
          "question": "What is the safety consideration regarding the spike of the pole?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "For safety reasons, never allow the spike of the pole to point into your body.",
          "options": {
            "A": "Always allow the spike of the pole to point into your body",
            "B": "Never allow the spike of the pole to point into your body",
            "C": "The spike of the pole should always be pointed upwards",
            "D": "The spike of the pole should always be pointed downwards"
          }
        },
        {
          "id": "sfd_basic_skills_246_be891a09",
          "question": "Who takes control of the left pole during the 'FLY SIDE AROUND' command?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "During the 'FLY SIDE AROUND' command, the fly member takes control of the left pole.",
          "options": {
            "A": "The member on the right pole",
            "B": "The member on the left pole",
            "C": "The taller member",
            "D": "The fly member"
          }
        },
        {
          "id": "sfd_basic_skills_246_72e0a56d",
          "question": "Who calls 'HIGH' and takes the higher hand position on the halyard?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The taller member (or member on the right beam, if the members are the same height) calls 'HIGH' and takes the higher hand position on the halyard.",
          "options": {
            "A": "The shorter member",
            "B": "The member on the left beam",
            "C": "The taller member or member on the right beam",
            "D": "The fly member"
          }
        },
        {
          "id": "sfd_basic_skills_246_c661c183",
          "question": "How far should members on the poles be standing outside the beams?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Both members on the poles should be standing at an angle outside the beams by approximately four feet.",
          "options": {
            "A": "Approximately two feet",
            "B": "Approximately four feet",
            "C": "Approximately six feet",
            "D": "Approximately eight feet"
          }
        },
        {
          "id": "sfd_basic_skills_211_3a672832",
          "question": "What is the primary role of the member on the fly side during the ladder pivoting process?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the fly side is primarily responsible for steadying the ladder during the pivoting process.",
          "options": {
            "A": "To foot the ladder",
            "B": "To push the ladder onto the designated beam",
            "C": "To steady the ladder",
            "D": "To move the poles to a new position"
          }
        },
        {
          "id": "sfd_basic_skills_211_3c17582d",
          "question": "What is one of the rules for the pole positions when pivoting a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "One of the rules for the pole positions is to ensure the stability of the ladder prior to moving the poles to a new position.",
          "options": {
            "A": "Always walk backwards",
            "B": "Both members on the poles should move at the same time",
            "C": "Ensure the stability of the ladder prior to moving the poles to a new position",
            "D": "Ignore the tip of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_211_5332ee12",
          "question": "What should a member do when the order is given to pivot the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the order is given to pivot, a member should place their hands on both side beams and push the ladder onto the designated beam.",
          "options": {
            "A": "Place hands on both side beams and push the ladder onto the designated beam",
            "B": "Foot the ladder",
            "C": "Move the poles to a new position",
            "D": "Walk backwards"
          }
        },
        {
          "id": "sfd_basic_skills_211_f306ebd4",
          "question": "What is the correct hand position for the right pole position?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "For the right pole position, the right hand should be extended up the pole as far as possible and the left hand should be near the left hip on the spike.",
          "options": {
            "A": "Right hand near the right hip on the spike, left hand up the pole",
            "B": "Right hand up the pole, left hand near the left hip on the spike",
            "C": "Both hands on the spike",
            "D": "Both hands up the pole"
          }
        },
        {
          "id": "sfd_basic_skills_211_795558fd",
          "question": "What is the correct hand position for the left pole position?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "For the left pole position, the left hand should be as far up the pole as possible and the right hand should be near the right hip on the spike.",
          "options": {
            "A": "Left hand near the left hip on the spike, right hand up the pole",
            "B": "Left hand up the pole, right hand near the right hip on the spike",
            "C": "Both hands on the spike",
            "D": "Both hands up the pole"
          }
        },
        {
          "id": "sfd_basic_skills_207_a3e6a6cb",
          "question": "What is the first step a single member should take when a ladder comes to vertical and is pivoted or shifted?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step a single member should take when a ladder comes to vertical and is pivoted or shifted is to grasp the bed section beams.",
          "options": {
            "A": "Step up on the first rung with their right foot",
            "B": "Grasp the bed section beams",
            "C": "Heel the ladder with their weight until it is steady",
            "D": "Step down with the right foot following the beam"
          }
        },
        {
          "id": "sfd_basic_skills_207_f7d90fad",
          "question": "What should the member on the fly side do after the ladder has come to the vertical?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After the ladder has come to the vertical, the member on the fly side should step back from the spurs with both hands grasping the outside of each bed section beam.",
          "options": {
            "A": "Step up on the rung with their inside foot",
            "B": "Step back from the spurs with both hands grasping the outside of each bed section beam",
            "C": "Place their left foot on the center of the bottom rung",
            "D": "Grasp the 4th rung from the spur"
          }
        },
        {
          "id": "sfd_basic_skills_207_51812f64",
          "question": "What is the correct foot position for a member on the fly side for good balance and stability?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "For good balance and stability, the feet should be placed approximately one to two feet back from each other, and about shoulder width apart.",
          "options": {
            "A": "Feet should be placed approximately two to three feet back from each other",
            "B": "Feet should be placed approximately one to two feet back from each other, and about shoulder width apart",
            "C": "Feet should be placed side by side",
            "D": "Feet should be placed one in front of the other"
          }
        },
        {
          "id": "sfd_basic_skills_207_12538ddf",
          "question": "What is the procedure when the command 'INTO THE BUILDING' is given for a single member on the bed side?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the command 'INTO THE BUILDING' is given, the member on the bed side should place their left foot on the center of the bottom rung and grasp the 4th rung from the spur.",
          "options": {
            "A": "Place their left foot on the center of the bottom rung and grasp the 4th rung from the spur",
            "B": "Place their inside foot on the bottom rung of the ladder",
            "C": "Step back from the spurs with both hands grasping the outside of each bed section beam",
            "D": "Step up on the first rung with their left foot"
          }
        },
        {
          "id": "sfd_basic_skills_207_42bb2935",
          "question": "When two members are footing the ladder on the bed side, what is the procedure to stabilize the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "With two members footing the ladder on the bed side, both members step up on the rung with their inside foot applying their full weight to stabilize the ladder.",
          "options": {
            "A": "Both members step up on the rung with their inside foot applying their full weight",
            "B": "Both members step up on the rung with their outside foot applying their full weight",
            "C": "Both members step up on the rung with their left foot applying their full weight",
            "D": "Both members step up on the rung with their right foot applying their full weight"
          }
        },
        {
          "id": "sfd_basic_skills_196_201e1d13",
          "question": "What is the first step in lifting the ladder according to the Seattle Fire Department's procedure?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in lifting the ladder is to face the butt, kneel down with their inside knee up, and lift the ladder up onto their inside leg.",
          "options": {
            "A": "Grasp the nearest rung on the fly side with the inside hand",
            "B": "Stand up, lifting the ladder to the shoulder with inside hand",
            "C": "Face the butt, kneel down with their inside knee up, and lift the ladder up onto their inside leg",
            "D": "Take proper position at the beamed ladder"
          }
        },
        {
          "id": "sfd_basic_skills_196_c12984ff",
          "question": "Where should the inside arm be placed when lifting the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The inside arm should be placed between the 2nd and 3rd rung from the ends.",
          "options": {
            "A": "Between the 1st and 2nd rung from the ends",
            "B": "Between the 2nd and 3rd rung from the ends",
            "C": "On the most comfortable rung on the bed side",
            "D": "On the nearest rung on the fly side"
          }
        },
        {
          "id": "sfd_basic_skills_196_a5c9a6a9",
          "question": "What is the 'PREPARE TO LIFT' position in the context of ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'PREPARE TO LIFT' position refers to when members take proper position at the beamed ladder.",
          "options": {
            "A": "Members stand up, lifting the ladder to the shoulder with inside hand",
            "B": "Members face the butt, kneel down with their inside knee up, and lift the ladder up onto their inside leg",
            "C": "Members take proper position at the beamed ladder",
            "D": "Members grasp the nearest rung on the fly side with the inside hand"
          }
        },
        {
          "id": "sfd_basic_skills_196_57ecda2b",
          "question": "What is the final step in the ladder lifting procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The final step in the ladder lifting procedure is for members to beam carry the ladder to the objective.",
          "options": {
            "A": "Members stand up, lifting the ladder to the shoulder with inside hand",
            "B": "Members beam carry the ladder to the objective",
            "C": "Members grasp the nearest rung on the fly side with the inside hand",
            "D": "Members take proper position at the beamed ladder"
          }
        },
        {
          "id": "sfd_basic_skills_196_183b14e6",
          "question": "Where should the outside hand be placed when lifting the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The outside hand should be placed on the most comfortable rung on the bed side when lifting the ladder.",
          "options": {
            "A": "On the most comfortable rung on the bed side",
            "B": "On the nearest rung on the fly side",
            "C": "Between the 2nd and 3rd rung from the ends",
            "D": "Between the 1st and 2nd rung from the ends"
          }
        },
        {
          "id": "sfd_basic_skills_179_1e0142a8",
          "question": "Why are trussed beam ladders often used instead of solid beam ladders for longer lengths?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Trussed beam ladders are often used for longer lengths because they are lighter but just as strong as solid beam ladders, making them more efficient for fire service work.",
          "options": {
            "A": "They are cheaper to produce",
            "B": "They are easier to climb",
            "C": "They are lighter but just as strong",
            "D": "They are more visually appealing"
          }
        },
        {
          "id": "sfd_basic_skills_179_17248e5e",
          "question": "What is the purpose of writing the measured length of the ladder on the inside of each beam near the butt?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The measured length of the ladder is written on the inside of each beam near the butt to help members better judge the distance they must extend the fly(s) to the desired target height.",
          "options": {
            "A": "To keep track of the ladder's age",
            "B": "To help members better judge the distance they must extend the fly(s) to the desired target height",
            "C": "To identify the manufacturer of the ladder",
            "D": "To indicate the maximum weight the ladder can hold"
          }
        },
        {
          "id": "sfd_basic_skills_179_9020e1d3",
          "question": "What is the main advantage of a solid beam ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The main advantage of a solid beam ladder is that it provides the maximum strength for fire service work.",
          "options": {
            "A": "It is lighter than a trussed beam ladder",
            "B": "It provides the maximum strength for fire service work",
            "C": "It is easier to extend to the desired height",
            "D": "It is more durable and lasts longer"
          }
        },
        {
          "id": "sfd_basic_skills_179_1e03d693",
          "question": "Why is the Seattle Fire Department phasing out the use of trussed beamed ladders?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text does not provide a specific reason why the Seattle Fire Department is phasing out the use of trussed beamed ladders.",
          "options": {
            "A": "They are too heavy for practical use",
            "B": "The text does not provide a specific reason",
            "C": "They are not as strong as solid beam ladders",
            "D": "They are too expensive to maintain"
          }
        },
        {
          "id": "sfd_basic_skills_179_ed62e3e2",
          "question": "What is the primary purpose of the design of trussed ladders?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Trussed ladders are designed to increase strength in relation to weight, making them efficient for fire service work.",
          "options": {
            "A": "To increase strength in relation to weight",
            "B": "To make them easier to carry",
            "C": "To make them more visually appealing",
            "D": "To make them cheaper to produce"
          }
        },
        {
          "id": "sfd_basic_skills_250_bdc5b79e",
          "question": "What is the role of the member on the right beam during the 'GROUND THE BUTT' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the right beam (#1) will move to the bed side of the ladder and foot the ladder.",
          "options": {
            "A": "Move to the fly side of the ladder",
            "B": "Move to the bed side of the ladder and foot the ladder",
            "C": "Stay in place and continue to hold the ladder",
            "D": "Move to the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_250_7601e471",
          "question": "What is the purpose of grounding the butt of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Grounding the butt of the ladder helps to stabilize it and prevent it from slipping.",
          "options": {
            "A": "To prevent the ladder from slipping",
            "B": "To make the ladder easier to climb",
            "C": "To make the ladder lighter",
            "D": "To make the ladder longer"
          }
        },
        {
          "id": "sfd_basic_skills_250_d973d78a",
          "question": "What is the role of the member on the left beam during the 'GROUND THE BUTT' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the left beam (#2) will move to the fly side of the ladder to hold the ladder in a vertical position.",
          "options": {
            "A": "Move to the bed side of the ladder",
            "B": "Move to the fly side of the ladder and hold it in a vertical position",
            "C": "Stay in place and continue to hold the ladder",
            "D": "Move to the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_250_cf817917",
          "question": "In what direction should the ladder be tilted when in the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ladder should be tilted slightly into the objective when in the vertical position.",
          "options": {
            "A": "Away from the objective",
            "B": "Towards the objective",
            "C": "To the left",
            "D": "To the right"
          }
        },
        {
          "id": "sfd_basic_skills_250_dccce41b",
          "question": "When does the member on the left beam move to the fly side of the ladder during the 'GROUND THE BUTT' command?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The member on the left beam moves to the fly side just before the vertical position is reached.",
          "options": {
            "A": "Just before the vertical position is reached",
            "B": "After the vertical position is reached",
            "C": "Before the ladder is raised",
            "D": "After the ladder is grounded"
          }
        },
        {
          "id": "sfd_basic_skills_236_159b0272",
          "question": "Who is responsible for taking the higher hand position on the halyard when extending the fly?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The taller member or the member on the right beam, if the members are the same height, is responsible for taking the higher hand position on the halyard when extending the fly.",
          "options": {
            "A": "The shorter member",
            "B": "The member on the left beam",
            "C": "The taller member or member on the right beam",
            "D": "The member in charge"
          }
        },
        {
          "id": "sfd_basic_skills_236_cbf13e42",
          "question": "What is the role of the member on the fly side when lowering the ladder into the building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the fly side assists in bringing the ladder into the building.",
          "options": {
            "A": "They foot the ladder",
            "B": "They assist in bringing the ladder into the building",
            "C": "They extend the fly section of the ladder",
            "D": "They command 'INTO THE BUILDING'"
          }
        },
        {
          "id": "sfd_basic_skills_236_f1c7bcfa",
          "question": "What is the significance of the command 'HIGH' during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command 'HIGH' is used to indicate that the ladder has reached the desired height.",
          "options": {
            "A": "It indicates that the ladder has reached the desired height",
            "B": "It signals the members to start extending the fly",
            "C": "It is a command to foot the ladder",
            "D": "It signals the members to lower the ladder into the building"
          }
        },
        {
          "id": "sfd_basic_skills_236_22b638ac",
          "question": "What is the position of the members on the bed side when they are extending the fly section of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When extending the fly section of the ladder, the members on the bed side have their outside toe in front and against the bed side spurs.",
          "options": {
            "A": "Their inside toe is in front and against the bed side spurs",
            "B": "Their inside foot is on the bottom rung",
            "C": "They are holding onto the fourth rung up from the spur with the inside hand",
            "D": "Their hands are on the beams"
          }
        },
        {
          "id": "sfd_basic_skills_236_4c7d2140",
          "question": "What is the role of the members on the bed side when lowering the ladder into the building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When lowering the ladder into the building, the members on the bed side foot the ladder with their inside foot on the bottom rung.",
          "options": {
            "A": "They assist in bringing the ladder into the building",
            "B": "They foot the ladder with their inside foot on the bottom rung",
            "C": "They extend the fly section of the ladder",
            "D": "They command 'INTO THE BUILDING'"
          }
        },
        {
          "id": "sfd_basic_skills_261_dc7a8012",
          "question": "What is the importance of securing the halyard in ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Securing the halyard is crucial to prevent the ladder sections from separating, which could lead to instability and potential accidents.",
          "options": {
            "A": "To keep the ladder from falling",
            "B": "To ensure the ladder is extended to its full length",
            "C": "To prevent the ladder sections from separating",
            "D": "To provide a decorative element to the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_261_34ebdfc1",
          "question": "Why is it important to lock the dogs during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Locking the dogs is important to prevent the ladder from collapsing, which could lead to serious accidents.",
          "options": {
            "A": "To prevent the ladder from sliding sideways",
            "B": "To prevent the ladder from collapsing",
            "C": "To provide a decorative element to the ladder",
            "D": "To ensure the ladder is extended to its full length"
          }
        },
        {
          "id": "sfd_basic_skills_261_1432fcb7",
          "question": "What is the purpose of tying the rungs of the fly and bed section together?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Tying the rungs of the fly and bed section together is done to make the ladder more stable, which is crucial for safe ladder operations.",
          "options": {
            "A": "To make the ladder longer",
            "B": "To make the ladder more stable",
            "C": "To provide a decorative element to the ladder",
            "D": "To ensure the ladder is extended to its full length"
          }
        },
        {
          "id": "sfd_basic_skills_261_2ff6262b",
          "question": "What should you do if there is insufficient halyard for climbing?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If there is insufficient halyard for climbing, the same knot that is used for securing the fly should be used. This ensures the ladder remains secure even with limited halyard.",
          "options": {
            "A": "Use a different ladder",
            "B": "Extend the ladder to its full length",
            "C": "Use the same knot that is used for securing the fly",
            "D": "Leave the ladder as it is"
          }
        },
        {
          "id": "sfd_basic_skills_261_a66eb35b",
          "question": "Why is it important to lay the ladder on its beam?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Laying the ladder on its beam is important to extend the fly to the length of rope to the knot. This ensures the ladder is properly extended and secure.",
          "options": {
            "A": "To make the ladder longer",
            "B": "To make the ladder more stable",
            "C": "To provide a decorative element to the ladder",
            "D": "To extend the fly to the length of rope to the knot"
          }
        },
        {
          "id": "sfd_basic_skills_220_5231d797",
          "question": "What is the role of the two members on the bed side during the 'EXTEND THE FLY' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The two members on the bed side reach for the halyard with their inside hand and extend the fly to the proper height.",
          "options": {
            "A": "They maintain the balance of the ladder",
            "B": "They reach for the halyard with their inside hand and extend the fly",
            "C": "They lock the dogs on the next highest rung",
            "D": "They manipulate the ladder in or out using body weight"
          }
        },
        {
          "id": "sfd_basic_skills_220_6aebe9d1",
          "question": "What is the signal to lock the dogs on the next highest rung?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'HIGH' is given when the ladder is extended to the desired height. This is the signal to lock the dogs on the next highest rung.",
          "options": {
            "A": "EXTEND THE FLY",
            "B": "HIGH",
            "C": "LOW",
            "D": "LOCK THE DOGS"
          }
        },
        {
          "id": "sfd_basic_skills_220_39199b3c",
          "question": "What is the role of the member on the fly side during the 'EXTEND THE FLY' command?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the fly side places both hands on the beams of the bed section and maintains the balance of the ladder. They also manipulate the ladder in or out using body weight.",
          "options": {
            "A": "They reach for the halyard with their inside hand and extend the fly",
            "B": "They lock the dogs on the next highest rung",
            "C": "They maintain the balance of the ladder and manipulate it in or out using body weight",
            "D": "They give the command 'HIGH'"
          }
        },
        {
          "id": "sfd_basic_skills_220_9a165de2",
          "question": "What is the importance of maintaining the proper hand placement for both members on the bed side?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Maintaining the proper hand placement for both members on the bed side is important to establish a smooth rhythm while extending the fly.",
          "options": {
            "A": "To ensure the ladder is extended to the correct height",
            "B": "To establish a smooth rhythm while extending the fly",
            "C": "To lock the dogs on the next highest rung",
            "D": "To manipulate the ladder in or out using body weight"
          }
        },
        {
          "id": "sfd_basic_skills_220_e2897971",
          "question": "What is the correct stance for the fly-side member when manipulating the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The fly-side member should have their feet placed shoulder width apart, one foot ahead of the other, and hands at shoulder level when manipulating the ladder.",
          "options": {
            "A": "Feet shoulder width apart, one foot ahead of the other, and hands at shoulder level",
            "B": "Feet together, one foot ahead of the other, and hands at waist level",
            "C": "Feet shoulder width apart, one foot behind the other, and hands at shoulder level",
            "D": "Feet together, one foot behind the other, and hands at waist level"
          }
        },
        {
          "id": "sfd_basic_skills_257_ebc9b186",
          "question": "Who is responsible for coordinating the climbing of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member at the bottom coordinates the climbing by saying 'STEP' when each rung is to be climbed.",
          "options": {
            "A": "The member at the top",
            "B": "The member in the middle",
            "C": "The member at the bottom",
            "D": "All members simultaneously"
          }
        },
        {
          "id": "sfd_basic_skills_257_e067edc4",
          "question": "What is the role of the member at the tip of the 26' ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the tip locks in above the roof, parapet or sill and sets the tip of the ladder onto the edge of objective.",
          "options": {
            "A": "To climb the ladder first",
            "B": "To lock-in above the roof, parapet or sill and set the tip of the ladder onto the edge of objective",
            "C": "To coordinate the climbing of the ladder",
            "D": "To carry the ladder up the ground extension ladder"
          }
        },
        {
          "id": "sfd_basic_skills_257_2383a134",
          "question": "What is the final action taken by the member at the bottom of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The member at the bottom continues to climb until the 26' ladder reaches the balance point, assists by keeping the ladder balanced, and finally withdraws their arm from between the rungs or body loop.",
          "options": {
            "A": "They climb until the 26' ladder reaches the balance point on the objective",
            "B": "They withdraw their arm from between the rungs or body loop",
            "C": "They assist by keeping the ladder balanced on its beam",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_257_10e99184",
          "question": "What is the purpose of the 'body loop' mentioned in the ladder climbing procedure?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The body loop is used to secure the firefighter's arm during the climb, providing stability and safety.",
          "options": {
            "A": "To secure the ladder to the ground",
            "B": "To provide a grip for the firefighters while climbing",
            "C": "To secure the firefighter's arm during the climb",
            "D": "To hang equipment"
          }
        },
        {
          "id": "sfd_basic_skills_257_a0d5de1e",
          "question": "What does the member at the top do once the 26' ladder reaches the balance point on the objective?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once the 26' ladder reaches the balance point on the objective, the member at the top tips the ladder into the room or onto the roof.",
          "options": {
            "A": "They descend the ladder",
            "B": "They tip the ladder into the room or onto the roof",
            "C": "They lock-in above the roof, parapet or sill",
            "D": "They coordinate the climbing of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_191_d4bf4178",
          "question": "What does the command 'RELEASE THE HALYARD' refer to in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'RELEASE THE HALYARD' refers to the action where the halyard is untied by the member on the right beam.",
          "options": {
            "A": "The ladder is lifted off the ground into the member's hands",
            "B": "The ladder anchor is removed from the fly or tip",
            "C": "The halyard is untied by the member on the right beam",
            "D": "The ladder is returned to the apparatus or storage area"
          }
        },
        {
          "id": "sfd_basic_skills_191_a8b97e7c",
          "question": "What is the purpose of the command 'SECURE THE HALYARD' during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The command 'SECURE THE HALYARD' is used to pull the slack rope through the rung space, wrap the excess slack around the rung, and tie a knot to secure the ladder.",
          "options": {
            "A": "To ensure the ladder is ready to be lifted",
            "B": "To secure the tip of the ladder to the building",
            "C": "To move the ladder in the indicated direction",
            "D": "To pull the slack rope through the rung space, wrap the excess slack around the rung, and tie a knot"
          }
        },
        {
          "id": "sfd_basic_skills_191_ce3b55d1",
          "question": "What is the next step after a member has reached their ready position with a tormentor pole?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Once a member has reached their ready position with a tormentor pole, the command 'SET' is given to prepare for the next action.",
          "options": {
            "A": "The command 'SET' is given",
            "B": "The command 'SHIFT' is given",
            "C": "The command 'STOW THE LADDER' is given",
            "D": "The command 'TO THE SHOULDER' is given"
          }
        },
        {
          "id": "sfd_basic_skills_191_1fa61fe6",
          "question": "What does the command 'STOW THE LADDER' imply in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'STOW THE LADDER' implies that the ladder is returned to the apparatus or storage area, tip first.",
          "options": {
            "A": "The ladder is lifted off the ground into the member's hands",
            "B": "The ladder is returned to the apparatus or storage area, tip first",
            "C": "The halyard is untied by the member on the right beam",
            "D": "The ladder is moved in the indicated direction while it is in the raised position"
          }
        },
        {
          "id": "sfd_basic_skills_191_eb481aaf",
          "question": "What is the purpose of the command 'SECURE THE TIP' during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'SECURE THE TIP' is used to secure the tip of the ladder to the building with a ladder anchor.",
          "options": {
            "A": "To ensure the ladder is ready to be lifted",
            "B": "To secure the tip of the ladder to the building with a ladder anchor",
            "C": "To move the ladder in the indicated direction",
            "D": "To pull the slack rope through the rung space, wrap the excess slack around the rung, and tie a knot"
          }
        },
        {
          "id": "sfd_basic_skills_200_89f1184e",
          "question": "Where should the two members be positioned when pulling the ladder out of the rack?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The two members should position themselves between the second and third rungs when pulling the ladder out of the rack.",
          "options": {
            "A": "Between the first and second rungs",
            "B": "Between the second and third rungs",
            "C": "Between the third and fourth rungs",
            "D": "At the top and bottom of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_200_65bc78a0",
          "question": "What should be done when the ladder is almost free of the ladder rack?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The ladder should be pulled until it is almost free of the rack, but not completely to avoid it falling to the ground.",
          "options": {
            "A": "The ladder should be pulled completely out of the rack",
            "B": "The ladder should be left in the rack",
            "C": "The ladder should be pulled until it is almost free of the rack, but not completely",
            "D": "The ladder should be pushed back into the rack"
          }
        },
        {
          "id": "sfd_basic_skills_200_e0f17824",
          "question": "What is the command given when the ladder is free of the ladder rack?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command given when the ladder is free of the ladder rack is 'To the shoulder'.",
          "options": {
            "A": "To the ground",
            "B": "To the shoulder",
            "C": "To the rack",
            "D": "To the top"
          }
        },
        {
          "id": "sfd_basic_skills_200_191be7d4",
          "question": "What is the role of the fifth member when five members are available?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When five members are available, the fifth member's role is to stand out and spot the ladder, then step in to receive the poles.",
          "options": {
            "A": "To pull the ladder out of the rack",
            "B": "To stand out and spot the ladder, then step in to receive the poles",
            "C": "To give the command 'To the shoulder'",
            "D": "To carry the ladder to the objective"
          }
        },
        {
          "id": "sfd_basic_skills_200_e3048896",
          "question": "What should be done with caution when pulling the ladder out of the rack?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Caution should be used to avoid pulling the ladder completely out of the rack, which could cause it to fall to the ground.",
          "options": {
            "A": "Avoid pulling the ladder completely out of the rack",
            "B": "Avoid standing between the second and third rungs",
            "C": "Avoid giving the command 'To the shoulder'",
            "D": "Avoid carrying the ladder to the objective"
          }
        },
        {
          "id": "sfd_basic_skills_216_a986e866",
          "question": "What is the correct procedure when shifting the ladder to the right?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "When shifting to the right, the member will move to the right beam and grasp the 2nd rung of the bed section with the right hand.",
          "options": {
            "A": "Move to the right beam and grasp the 2nd rung of the bed section with the left hand",
            "B": "Move to the left beam and grasp the 2nd rung of the bed section with the right hand",
            "C": "Move to the left beam and grasp the 2nd rung of the bed section with the left hand",
            "D": "Move to the right beam and grasp the 2nd rung of the bed section with the right hand"
          }
        },
        {
          "id": "sfd_basic_skills_216_879e216b",
          "question": "What is the purpose of the 'OVERHEAD CLEAR' command?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'OVERHEAD CLEAR' command is used to check that the path the ladder will take is free from overhead obstructions.",
          "options": {
            "A": "To ensure there are no overhead obstructions",
            "B": "To signal that the ladder is ready to be lifted",
            "C": "To indicate that the ladder has been successfully lifted",
            "D": "To check the stability of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_216_23668a0c",
          "question": "What is the correct body part to use when lifting the ladder off the ground?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The ladder should be lifted off the ground using the leg muscles, not the back, to prevent injury.",
          "options": {
            "A": "The back",
            "B": "The arms",
            "C": "The leg muscles",
            "D": "The shoulders"
          }
        },
        {
          "id": "sfd_basic_skills_216_0b45ae11",
          "question": "What should you monitor while moving forward in the direction of travel?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "While moving forward in the direction of travel, it is important to monitor the position of the ladder being carried and watch for overhead obstructions.",
          "options": {
            "A": "The position of the ladder being carried and overhead obstructions",
            "B": "The position of the ladder being carried and the ground conditions",
            "C": "The ground conditions and overhead obstructions",
            "D": "The position of the ladder being carried and the position of other firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_216_f3b6887b",
          "question": "What is the correct procedure after the 'HALT - LOWER' command?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After the 'HALT - LOWER' command, the member should take one additional step forward, bring the feet together, come to a stop, set the ladder to the ground, and then foot the ladder.",
          "options": {
            "A": "Take one additional step forward, bring the feet together, stop, set the ladder to the ground, and foot the ladder",
            "B": "Take one additional step backward, bring the feet together, stop, set the ladder to the ground, and foot the ladder",
            "C": "Take one additional step forward, bring the feet apart, stop, set the ladder to the ground, and foot the ladder",
            "D": "Take one additional step backward, bring the feet apart, stop, set the ladder to the ground, and foot the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_241_b6b701a9",
          "question": "What is the first step in preparing to raise a ladder according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in preparing to raise a ladder according to the Seattle Fire Department is to place the ladder on the ground, fly side up.",
          "options": {
            "A": "Command 'PREPARE TO RAISE'",
            "B": "Place the ladder on the ground, fly side up",
            "C": "Check overhead for wires & obstructions",
            "D": "Lift the tip off the ground"
          }
        },
        {
          "id": "sfd_basic_skills_241_8b002175",
          "question": "What is the response to the command 'PREPARE TO RAISE'?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The response to the command 'PREPARE TO RAISE' is to check overhead for wires & obstructions and respond 'OVERHEAD CLEAR'.",
          "options": {
            "A": "Lift the tip off the ground",
            "B": "Foot the ladder in unison",
            "C": "Check overhead for wires & obstructions and respond 'OVERHEAD CLEAR'",
            "D": "Slide the outside foot down the beam to the ground"
          }
        },
        {
          "id": "sfd_basic_skills_241_a7b615cf",
          "question": "What is the importance of checking overhead for wires and obstructions before raising the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Checking overhead for wires and obstructions before raising the ladder is important to avoid potential electrical hazards and obstructions that could interfere with the ladder raising process.",
          "options": {
            "A": "To ensure the ladder doesn't get stuck",
            "B": "To avoid potential electrical hazards and obstructions that could interfere with the ladder raising process",
            "C": "To ensure the ladder is long enough",
            "D": "To check the weather conditions"
          }
        },
        {
          "id": "sfd_basic_skills_241_865df7f9",
          "question": "What is the purpose of the bed-side members footing the ladder in unison?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The bed-side members foot the ladder in unison to ensure the ladder is balanced, make it easier to carry, and prevent it from sliding.",
          "options": {
            "A": "To ensure the ladder is balanced",
            "B": "To make the ladder easier to carry",
            "C": "To prevent the ladder from sliding",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_241_3c794f4d",
          "question": "Why is it important for each member to slide their outside foot down the beam to the ground and step back with the inside leaving the tip of the boot in contact with the beam?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Each member slides their outside foot down the beam to the ground and steps back with the inside leaving the tip of the boot in contact with the beam to ensure proper footing and stability of the ladder.",
          "options": {
            "A": "To ensure proper footing and stability of the ladder",
            "B": "To make the ladder easier to climb",
            "C": "To prevent the ladder from falling over",
            "D": "To make the ladder easier to lower"
          }
        },
        {
          "id": "sfd_basic_skills_187_7315ab4b",
          "question": "What is the maximum load limit for ground ladders used in drills or normal fire ground operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that loads exerted on these ladders for drill purposes or normal fire ground operations should not exceed 750lbs.",
          "options": {
            "A": "500 lbs",
            "B": "750 lbs",
            "C": "1000 lbs",
            "D": "No limit"
          }
        },
        {
          "id": "sfd_basic_skills_187_5dd84b31",
          "question": "What is the required safety factor designed into the working load limits of all fire service ground extension and roof ladders according to NFPA?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that NFPA requires that ALL fire service ground extension and roof ladders have a 4:1 safety factor designed into the working load limits.",
          "options": {
            "A": "2:1",
            "B": "3:1",
            "C": "4:1",
            "D": "5:1"
          }
        },
        {
          "id": "sfd_basic_skills_187_ab5095ab",
          "question": "Where should the officer or member in charge be positioned during the removal and carrying of ladders?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the officer, or member in charge, should be positioned on the right beam of the ladder during the removal and carrying of ladders.",
          "options": {
            "A": "On the left beam of the ladder",
            "B": "On the right beam of the ladder",
            "C": "At the center of the ladder",
            "D": "At the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_187_12ab0fe8",
          "question": "What is the maximum number of people permitted on a ground ladder that is 30 feet or longer?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the maximum number of people permitted on a ground ladder that is 30 feet or longer is 3.",
          "options": {
            "A": "1",
            "B": "2",
            "C": "3",
            "D": "4"
          }
        },
        {
          "id": "sfd_basic_skills_187_65669119",
          "question": "What is the purpose of using the halyard or a body loop when a member is working on a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that when a member is working on a ladder, the fly section(s) shall be properly secured using the halyard or a body loop, so that the fly(s) cannot retract.",
          "options": {
            "A": "To provide extra support",
            "B": "To prevent the fly(s) from retracting",
            "C": "To increase the ladder's height",
            "D": "To secure the member's tools"
          }
        },
        {
          "id": "sfd_basic_skills_186_e7f2a2e9",
          "question": "What is the primary consideration when deciding the type and size of ladder to use in a firefighting situation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The use for the ladder and the specific situation are the primary considerations when deciding the type and size of ladder to use.",
          "options": {
            "A": "The color of the ladder",
            "B": "The weight of the ladder",
            "C": "The manufacturer of the ladder",
            "D": "The use for the ladder and the situation"
          }
        },
        {
          "id": "sfd_basic_skills_186_1fba6b2d",
          "question": "At what angle do ladders have their greatest strength?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Ladders have their greatest strength when in a vertical position, which is 90 degrees from horizontal.",
          "options": {
            "A": "70 degrees from horizontal",
            "B": "90 degrees from horizontal",
            "C": "45 degrees from horizontal",
            "D": "Horizontal position"
          }
        },
        {
          "id": "sfd_basic_skills_186_6f18585f",
          "question": "How can a firefighter determine if a ladder is set at the proper angle for climbing?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A simple and effective way to determine if a ladder is set at the proper angle for climbing is to take a standing position with your toes against the ladder spurs, extend your arms straight out, and your fingers should fall on the rung at about shoulder level.",
          "options": {
            "A": "By measuring the angle with a protractor",
            "B": "By standing with toes against the ladder spurs and extending arms straight out",
            "C": "By checking the ladder's manufacturer instructions",
            "D": "By asking a colleague for their opinion"
          }
        },
        {
          "id": "sfd_basic_skills_186_3df83737",
          "question": "What is the general rule for the distance the butt of the ladder should be from the surface supporting the top of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The general rule is that the butt of the ladder should be a fixed distance out from the surface supporting the top of the ladder, which is generally accepted as one quarter of the height from the ground to the point where the ladder rests against the objective.",
          "options": {
            "A": "One quarter of the height from the ground to the point where the ladder rests against the objective",
            "B": "Half the height from the ground to the point where the ladder rests against the objective",
            "C": "The same height as the ladder",
            "D": "Twice the height from the ground to the point where the ladder rests against the objective"
          }
        },
        {
          "id": "sfd_basic_skills_186_d6ec8cf4",
          "question": "In what direction should all extension ladders be raised?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "All extension ladders should be raised with the fly section(s) toward the building.",
          "options": {
            "A": "With the fly section(s) toward the building",
            "B": "With the fly section(s) away from the building",
            "C": "With the fly section(s) facing upward",
            "D": "With the fly section(s) facing downward"
          }
        },
        {
          "id": "sfd_basic_skills_240_48a3228a",
          "question": "What is the correct procedure to pull the butt out from the building?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, the correct procedure to pull the butt out from the building is to grasp the first and fourth or the second and fifth rungs and adjust the butt.",
          "options": {
            "A": "Grasp the first and fourth or the second and fifth rungs and adjust the butt",
            "B": "Grasp the third and sixth rungs and adjust the butt",
            "C": "Grasp the first and third rungs and adjust the butt",
            "D": "Grasp the second and fourth rungs and adjust the butt"
          }
        },
        {
          "id": "sfd_basic_skills_240_6b474cc2",
          "question": "Who is responsible for checking the overhead area for obstructions?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that the member in charge, the member on the right beam or right butt is responsible for checking the overhead area for obstructions.",
          "options": {
            "A": "The member on the left beam",
            "B": "The member in charge or the member on the right beam or right butt",
            "C": "The member on the right beam",
            "D": "The member on the left butt"
          }
        },
        {
          "id": "sfd_basic_skills_240_be62495f",
          "question": "What is the command to begin lowering the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, the command to begin lowering the ladder is 'LOWER THE LADDER'.",
          "options": {
            "A": "READY HALT",
            "B": "OVERHEAD CLEAR",
            "C": "LOWER THE LADDER",
            "D": "SECURE THE HALYARD"
          }
        },
        {
          "id": "sfd_basic_skills_240_04fc4b77",
          "question": "What is the correct procedure to foot the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that to foot the ladder, the member will place the left foot on the bottom rung while holding onto the fourth rung up from the spur with both hands.",
          "options": {
            "A": "Place the right foot on the bottom rung while holding onto the fourth rung up from the spur with both hands",
            "B": "Place the left foot on the bottom rung while holding onto the fourth rung up from the spur with one hand",
            "C": "Place the left foot on the bottom rung while holding onto the fourth rung up from the spur with both hands",
            "D": "Place the right foot on the bottom rung while holding onto the fourth rung up from the spur with one hand"
          }
        },
        {
          "id": "sfd_basic_skills_240_360bb094",
          "question": "Who is responsible for surveying the area where a ladder is to be raised?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "According to the text, it is the responsibility of all personnel to survey the area where a ladder is to be raised.",
          "options": {
            "A": "The member in charge",
            "B": "The member on the right beam",
            "C": "The member on the right butt",
            "D": "All personnel"
          }
        },
        {
          "id": "sfd_basic_skills_217_97ce4402",
          "question": "What is the correct response when the command 'PREPARE TO SHIFT -RIGHT' is given during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, when the command 'PREPARE TO SHIFT -RIGHT' is given, the member on the bed side of the ladder slaps the right beam.",
          "options": {
            "A": "The member on the bed side of the ladder slaps the left beam",
            "B": "Both members lift the ladder off the ground",
            "C": "The member on the bed side of the ladder slaps the right beam",
            "D": "The member on the fly side faces the left beam"
          }
        },
        {
          "id": "sfd_basic_skills_217_139cf8f7",
          "question": "What is the purpose of the 'OVERHEAD CLEAR' command during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'OVERHEAD CLEAR' command is used to check that the path the ladder will take is free from any overhead obstructions.",
          "options": {
            "A": "To instruct the members to lift the ladder overhead",
            "B": "To check for any overhead obstructions in the path of the ladder",
            "C": "To instruct the members to shift the ladder to the right",
            "D": "To instruct the members to set the ladder to the ground"
          }
        },
        {
          "id": "sfd_basic_skills_217_6f1451a0",
          "question": "What is the correct lifting technique during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text specifies that members should lift the ladder off the ground using the leg muscles, not the back, to prevent injury.",
          "options": {
            "A": "Lift with the back muscles",
            "B": "Lift with the arm muscles",
            "C": "Lift with the leg muscles",
            "D": "Lift with the shoulder muscles"
          }
        },
        {
          "id": "sfd_basic_skills_217_ed9254c7",
          "question": "What is the responsibility of the member on the fly side during ladder movement?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During ladder movement, the member on the fly side is responsible for watching the tip of the ladder for obstructions.",
          "options": {
            "A": "Watch the ground for obstructions",
            "B": "Watch the tip of the ladder for obstructions",
            "C": "Slap the right beam of the ladder",
            "D": "Lift the ladder off the ground"
          }
        },
        {
          "id": "sfd_basic_skills_217_f6c48a96",
          "question": "What is the next action after the 'HALT - LOWER' command during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After the 'HALT - LOWER' command, the members take one additional step forward, bring the feet together and come to a stop, set the ladder to the ground, and then foot the ladder.",
          "options": {
            "A": "The members lift the ladder off the ground",
            "B": "The members set the ladder to the ground and then foot the ladder",
            "C": "The members slap the right beam of the ladder",
            "D": "The members check for overhead obstructions"
          }
        },
        {
          "id": "sfd_basic_skills_201_28a68228",
          "question": "What is the preferred angle to approach a building when positioning a ladder for raising, according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that when positioning a ladder for raising, one should approach the building at a 90 degree angle whenever possible.",
          "options": {
            "A": "45 degrees",
            "B": "90 degrees",
            "C": "60 degrees",
            "D": "30 degrees"
          }
        },
        {
          "id": "sfd_basic_skills_201_63a6e5aa",
          "question": "When should a firefighter approach parallel to the building when positioning a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that for safety purposes, one should approach parallel to the building only if space does not allow a perpendicular access.",
          "options": {
            "A": "When the building is on fire",
            "B": "When the building is too tall",
            "C": "When space does not allow a perpendicular access",
            "D": "When the ladder is too short"
          }
        },
        {
          "id": "sfd_basic_skills_201_7dcb6fe0",
          "question": "Where should ladders be positioned relative to the window or opening when ready for climbing?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that ladders are normally positioned into the left side of the window or opening when ready for climbing.",
          "options": {
            "A": "Right side of the window",
            "B": "Center of the window",
            "C": "Left side of the window",
            "D": "Above the window"
          }
        },
        {
          "id": "sfd_basic_skills_201_7eb110f7",
          "question": "What is the ultimate factor governing the final position of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text states that the ultimate factor governing the final position of the ladder will be dependent on fire conditions, anticipated future conditions and wind.",
          "options": {
            "A": "The height of the building",
            "B": "The weight of the ladder",
            "C": "Fire conditions, anticipated future conditions and wind",
            "D": "The number of firefighters available"
          }
        },
        {
          "id": "sfd_basic_skills_201_5e06d4b0",
          "question": "What should be done if the window or opening is too small to accommodate the width of the ladder and allow people to climb on or off?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that if the window or opening is too small to accommodate the width of the ladder and allow people to climb on or off, place the ladder tip below the opening.",
          "options": {
            "A": "Place the ladder tip above the opening",
            "B": "Place the ladder tip below the opening",
            "C": "Use a smaller ladder",
            "D": "Break the window to make it larger"
          }
        },
        {
          "id": "sfd_basic_skills_190_0fd44848",
          "question": "What is the purpose of the command 'ON THE (RIGHT OR LEFT) BEAM, PIVOT IN'?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'ON THE (RIGHT OR LEFT) BEAM, PIVOT IN' is used to pivot the ladder towards the flies on the designated beam.",
          "options": {
            "A": "To move the ladder away from the building",
            "B": "To rotate the ladder towards the bed on the designated beam",
            "C": "To rotate the ladder towards the flies on the designated beam",
            "D": "To move the ladder closer to the building"
          }
        },
        {
          "id": "sfd_basic_skills_190_addab68c",
          "question": "When is the command 'ONCE AROUND' typically used?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'ONCE AROUND' is generally used for training purposes to ensure that all members get an equal chance to practice in each position.",
          "options": {
            "A": "During actual firefighting operations",
            "B": "When the ladder is stuck",
            "C": "During training exercises",
            "D": "When the ladder needs to be moved to a different location"
          }
        },
        {
          "id": "sfd_basic_skills_190_8b51d40e",
          "question": "What does the command 'OUT FROM THE BUILDING' indicate?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'OUT FROM THE BUILDING' indicates that the tip of the ladder should be pulled away from the building to a vertical position.",
          "options": {
            "A": "To move the ladder closer to the building",
            "B": "To move the ladder away from the building to a vertical position",
            "C": "To rotate the ladder towards the bed on the designated beam",
            "D": "To rotate the ladder towards the flies on the designated beam"
          }
        },
        {
          "id": "sfd_basic_skills_190_f9a8e92e",
          "question": "What is the purpose of the 'OVERHEAD CLEAR' statement?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'OVERHEAD CLEAR' statement is issued prior to raising the ladder, or prior to passing the poles on a tormentor ladder, to indicate that the area above the ladder is clear of wires or obstructions.",
          "options": {
            "A": "To indicate that the ladder is ready to be raised",
            "B": "To indicate that the area above the ladder is clear of wires or obstructions",
            "C": "To indicate that the ladder has been successfully raised",
            "D": "To indicate that the ladder is in the correct position"
          }
        },
        {
          "id": "sfd_basic_skills_190_d6b3d4c5",
          "question": "What does the command 'PREPARE TO RAISE' precede?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'PREPARE TO RAISE' is a preparatory command which precedes the next command, 'RAISE.'",
          "options": {
            "A": "The command 'ONCE AROUND'",
            "B": "The command 'OUT FROM THE BUILDING'",
            "C": "The command 'RAISE'",
            "D": "The command 'OVERHEAD CLEAR'"
          }
        },
        {
          "id": "sfd_basic_skills_256_aaea4869",
          "question": "Why is it important to ensure the beams of the roof ladder are straddling the chosen beam of the ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Ensuring the beams of the roof ladder are straddling the chosen beam of the ground extension ladder helps to keep the butt of the roof ladder from lifting off the ground when the ladder is being lowered. This is crucial for maintaining stability and safety during ladder operations.",
          "options": {
            "A": "To make the ladder look neat",
            "B": "To make the ladder easier to climb",
            "C": "To keep the butt of the roof ladder from lifting off the ground when the ladder is being lowered",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_256_59aeb8d0",
          "question": "Why should a ladder be extended far enough beyond the roof, sill or parapet?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ladder should be extended far enough beyond the roof, sill or parapet to allow the member to lock in above it. This is important for the safety of the firefighter and for effective operations.",
          "options": {
            "A": "To make the ladder look longer",
            "B": "To allow the member to lock in above it",
            "C": "To make the ladder easier to carry",
            "D": "To make the ladder easier to climb"
          }
        },
        {
          "id": "sfd_basic_skills_256_53394619",
          "question": "What is the purpose of placing body loops around the right beam of the 26' ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Body loops are used to carry the 26' ladder up the ground extension ladder. They provide a secure and convenient way to transport the ladder.",
          "options": {
            "A": "To make the ladder easier to climb",
            "B": "To make the ladder look neat",
            "C": "To make the ladder easier to carry",
            "D": "To secure the ladder to the ground"
          }
        },
        {
          "id": "sfd_basic_skills_256_84c9b6f7",
          "question": "What is the purpose of laying the beam of the roof ladder on the rungs and against the same beam of the ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Laying the beam of the roof ladder on the rungs and against the same beam of the ground extension ladder ensures the hooks of the roof ladder are facing out from the ground ladder. This is important for proper positioning and safety during ladder operations.",
          "options": {
            "A": "To make the ladder look neat",
            "B": "To make the ladder easier to climb",
            "C": "To ensure the hooks of the roof ladder are facing out from the ground ladder",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_256_246a5b57",
          "question": "Why is the 26' ladder raised to the vertical position and pivoted out on the left beam?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 26' ladder is raised to the vertical position and pivoted out on the left beam so that it can be laid onto the rungs next to the right beam of the extended ground ladder. This is a necessary step in the process of setting up the ladder for use.",
          "options": {
            "A": "To make the ladder look neat",
            "B": "To make the ladder easier to climb",
            "C": "So that it can be laid onto the rungs next to the right beam of the extended ground ladder",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_221_fc8edc06",
          "question": "Who is responsible for manipulating the halyard when lowering the flies on any ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the right beam is responsible for manipulating the halyard when lowering the flies on any ladder.",
          "options": {
            "A": "The member on the left beam",
            "B": "The member on the right beam",
            "C": "Any member who is available",
            "D": "The member at the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_221_78e96784",
          "question": "What is the recommended method for lowering the flies of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The recommended method for lowering the flies of the ladder is using a hand-over-hand method.",
          "options": {
            "A": "Letting the halyard slide through your hands",
            "B": "Using a hand-over-hand method",
            "C": "Using a foot-over-foot method",
            "D": "Using a hand-under-hand method"
          }
        },
        {
          "id": "sfd_basic_skills_221_edddb716",
          "question": "What is the primary method to secure the fly section after it is extended?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The primary method to secure the fly section after it is extended is by tying the halyard.",
          "options": {
            "A": "Locking the dogs",
            "B": "Tying the halyard",
            "C": "Using a safety pin",
            "D": "Using a locking mechanism"
          }
        },
        {
          "id": "sfd_basic_skills_221_d01d5b0c",
          "question": "What is the correct sequence for securing the halyard?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The correct sequence for securing the halyard is 'Push 4/3, Pull 3/2'.",
          "options": {
            "A": "Push 4/3, Pull 3/2",
            "B": "Push 3/2, Pull 4/3",
            "C": "Push 2/3, Pull 4/2",
            "D": "Push 3/4, Pull 2/3"
          }
        },
        {
          "id": "sfd_basic_skills_221_37e08acc",
          "question": "What should be done if the member on the right beam is having difficulty getting the fly(s) in motion?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the member on the right beam is having difficulty getting the fly(s) in motion, the other member may assist in that process then turn the halyard over to the member at the right beam.",
          "options": {
            "A": "The other member should take over the task",
            "B": "The member on the right beam should continue trying",
            "C": "The other member may assist then turn the halyard over to the member at the right beam",
            "D": "The task should be abandoned"
          }
        },
        {
          "id": "sfd_basic_skills_260_7dd44bac",
          "question": "What is the role of the member on the ground during the hoisting of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the ground steadies the ladder and assists in guiding it while being hoisted.",
          "options": {
            "A": "To pull the rope in a hand-over-hand manner",
            "B": "To steady the ladder and assist in guiding it",
            "C": "To turn the ladder on its beam",
            "D": "To extend the flies of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_260_59f32ec9",
          "question": "Why is it important to pivot the ladder so that the bed side is toward the building before hoisting?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Pivoting the ladder with the bed side toward the building ensures it is in the correct position for climbing once hoisted.",
          "options": {
            "A": "To ensure the ladder is in the correct position for climbing",
            "B": "To prevent damage to the building",
            "C": "To make the ladder easier to hoist",
            "D": "To ensure the ladder's stability"
          }
        },
        {
          "id": "sfd_basic_skills_260_29658f28",
          "question": "What is the purpose of the marker knot when lowering a Ground Extension Ladder from an overpass or a parapet wall?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The marker knot is tied at the desired length to mark the distance from the bottom of the pit or well to the edge, rail or wall at your elevation.",
          "options": {
            "A": "To indicate the length of the rope",
            "B": "To mark the desired length of the ladder",
            "C": "To mark the distance from the bottom of the pit or well to the edge",
            "D": "To provide a grip for the person lowering the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_260_6e65c85e",
          "question": "How is the ladder positioned when it is being lowered?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ladder is lowered bed side out with the knot on the outside of the ladder. This places the butt of the ladder out from the building and the tip of the ladder against the building.",
          "options": {
            "A": "The ladder is lowered bed side in with the knot on the inside of the ladder",
            "B": "The ladder is lowered bed side out with the knot on the outside of the ladder",
            "C": "The ladder is lowered bed side in with the knot on the outside of the ladder",
            "D": "The ladder is lowered bed side out with the knot on the inside of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_260_82490a16",
          "question": "What is the purpose of adding six feet to the measured distance when lowering a Ground Extension Ladder from an overpass or a parapet wall?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The six feet added to the measured distance will allow enough to extend over the wall once the ladder is in its final climbing position.",
          "options": {
            "A": "To ensure the ladder extends over the wall",
            "B": "To compensate for any measurement errors",
            "C": "To provide extra length for safety",
            "D": "To allow for the height of the person climbing the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_237_33aa4165",
          "question": "Who is responsible for securing the halyard during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the content, the member on the right beam, bed side, is responsible for securing the halyard.",
          "options": {
            "A": "The member on the left beam",
            "B": "The member on the fly side",
            "C": "The member on the right beam, bed side",
            "D": "The member on the bed side left beam"
          }
        },
        {
          "id": "sfd_basic_skills_237_3e588b50",
          "question": "What is the purpose of the 'ADJUST THE BUTT' command?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'ADJUST THE BUTT' command is given to adjust the angle of the ladder if needed.",
          "options": {
            "A": "To adjust the ladder's position against the building",
            "B": "To ensure the ladder is footed properly",
            "C": "To adjust the angle of the ladder",
            "D": "To secure the ladder's position"
          }
        },
        {
          "id": "sfd_basic_skills_237_05f4e21e",
          "question": "What does the 'SECURE THE TIP' command entail?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'SECURE THE TIP' command involves the member on the fly side securing the tip of the ladder with a ladder anchor.",
          "options": {
            "A": "The member on the fly side secures the tip with a ladder anchor",
            "B": "The member on the bed side secures the tip with a ladder anchor",
            "C": "The member on the right beam secures the tip with a ladder anchor",
            "D": "The member on the left beam secures the tip with a ladder anchor"
          }
        },
        {
          "id": "sfd_basic_skills_237_45ff429a",
          "question": "What is the role of the member on the fly side during the 'OUT FROM THE BUILDING' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During the 'OUT FROM THE BUILDING' command, the member on the fly side assists in bringing the tip of the ladder out from the building.",
          "options": {
            "A": "To foot the ladder",
            "B": "To assist in bringing the tip out from the building",
            "C": "To secure the halyard",
            "D": "To adjust the butt of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_237_62255ac9",
          "question": "What is the purpose of the 'PREPARE TO LOWER ON THE (RIGHT or LEFT) BEAM' command?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'PREPARE TO LOWER ON THE (RIGHT or LEFT) BEAM' command is given to prepare for lowering the ladder while checking for obstructions and personnel.",
          "options": {
            "A": "To prepare for securing the halyard",
            "B": "To prepare for adjusting the butt of the ladder",
            "C": "To prepare for lowering the ladder while checking for obstructions and personnel",
            "D": "To prepare for securing the tip of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_189_66ecf4fa",
          "question": "What is the command 'GROUND THE BUTT' used for in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command 'GROUND THE BUTT' is used to order the members to place the butt on the ground and raise the ladder all in one motion.",
          "options": {
            "A": "To order the members to place the butt on the ground and raise the ladder all in one motion",
            "B": "To order the members to lower the ladder to the ground",
            "C": "To order the members to move the ladder to the right",
            "D": "To order the members to lock the fly at the next highest rung"
          }
        },
        {
          "id": "sfd_basic_skills_189_1f3d943e",
          "question": "Why is it necessary for the member on the right beam to lower the fly?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "It is necessary for the member on the right beam to lower the fly, due to the fact that the halyard, as it goes through the upper pulley, is angled to the right side.",
          "options": {
            "A": "Because the halyard, as it goes through the upper pulley, is angled to the right side",
            "B": "Because the right beam member is always stronger",
            "C": "Because the right beam member has a better view of the building",
            "D": "Because the right beam member is always closer to the building"
          }
        },
        {
          "id": "sfd_basic_skills_189_28ce7dcc",
          "question": "What is the purpose of the command 'INTO THE BUILDING'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'INTO THE BUILDING' is used to order the members to lower the ladder into the building.",
          "options": {
            "A": "To order the members to move the ladder to the right",
            "B": "To order the members to lower the ladder into the building",
            "C": "To order the members to raise the ladder to the building",
            "D": "To order the members to lock the fly at the next highest rung"
          }
        },
        {
          "id": "sfd_basic_skills_189_ea103ba7",
          "question": "What is the command 'LADDER COMING THROUGH' used for?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command 'LADDER COMING THROUGH' is used to warn others that a ladder is being carried through their area.",
          "options": {
            "A": "To warn others that a ladder is being carried through their area",
            "B": "To order the members to lower the ladder to the ground",
            "C": "To order the members to raise the ladder to the building",
            "D": "To order the members to move the ladder to the right"
          }
        },
        {
          "id": "sfd_basic_skills_189_79b5b3b9",
          "question": "What is the purpose of the command 'LEFT POLE AROUND'?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command 'LEFT POLE AROUND' is used to order the left pole member to give their pole to the right pole member and move to the fly side of the ladder.",
          "options": {
            "A": "To order the left pole member to give their pole to the right pole member and move to the fly side of the ladder",
            "B": "To order the left pole member to lower the ladder to the ground",
            "C": "To order the left pole member to raise the ladder to the building",
            "D": "To order the left pole member to move the ladder to the right"
          }
        },
        {
          "id": "sfd_basic_skills_218_1636f469",
          "question": "What is the purpose of using your right shin to 'push' against the right beam while extending the fly section of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The right shin is used to push against the right beam to keep the ladder balanced and away from the firefighter. This helps maintain control over the ladder during extension.",
          "options": {
            "A": "To keep the ladder balanced and away from you",
            "B": "To ensure the ladder is properly aligned",
            "C": "To add additional height to the ladder",
            "D": "To lock the ladder in place"
          }
        },
        {
          "id": "sfd_basic_skills_218_71247733",
          "question": "What should you do if the ladder begins to lean away from you too far?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the ladder begins to lean away too far, the firefighter should pull back on the halyard until control is regained. This helps prevent the ladder from falling or becoming unmanageable.",
          "options": {
            "A": "Push harder with your right shin",
            "B": "Pull back on the halyard until you regain control",
            "C": "Reach through a rung space to stabilize the ladder",
            "D": "Lock the dogs immediately"
          }
        },
        {
          "id": "sfd_basic_skills_218_16035568",
          "question": "When is the fly section of the ladder locked?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The fly section of the ladder is locked when the command 'HIGH' is given. This ensures that the ladder is secure and safe to use.",
          "options": {
            "A": "When the ladder is fully extended",
            "B": "When the command 'HIGH' is given",
            "C": "When the ladder begins to lean",
            "D": "When the firefighter feels comfortable"
          }
        },
        {
          "id": "sfd_basic_skills_218_8432e95a",
          "question": "What should you avoid doing until all dogs are locked?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Until all dogs are locked, you should avoid reaching through a rung space or touching a rung with hands or feet. This is to prevent injury from the movement of the fly sections.",
          "options": {
            "A": "Using the halyard to pull the ladder back",
            "B": "Reaching through a rung space or touching a rung with hands or feet",
            "C": "Using your right shin to push the ladder away",
            "D": "Giving the command 'HIGH'"
          }
        },
        {
          "id": "sfd_basic_skills_218_04a666ef",
          "question": "What should you ensure before putting hands or feet in a position where they can be injured by the movement of the fly section(s)?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Before putting hands or feet in a position where they can be injured by the movement of the fly section(s), you should ensure that the dogs are locked. This prevents the ladder from moving unexpectedly and causing injury.",
          "options": {
            "A": "That the ladder is fully extended",
            "B": "That the ladder is leaning away from you",
            "C": "That the dogs are locked",
            "D": "That the command 'HIGH' has been given"
          }
        },
        {
          "id": "sfd_basic_skills_259_ef9f440d",
          "question": "What is the purpose of pivoting the ladder 180 degrees as it begins to leave the ground?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Pivoting the ladder 180 degrees as it begins to leave the ground keeps the tip of the ladder out from the building and the butt against the building, helping to prevent the tip from getting caught on objects as it goes up.",
          "options": {
            "A": "To allow the firefighter to climb faster",
            "B": "To make the ladder more visible",
            "C": "To prevent the tip of the ladder from getting caught on objects",
            "D": "To make the ladder lighter"
          }
        },
        {
          "id": "sfd_basic_skills_259_f10ac8fa",
          "question": "What is the function of a bowline with a bight in the context of ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A bowline with a bight is tied where the bight crosses the rope that leads to the destination, securing the rope.",
          "options": {
            "A": "It is used to tie the firefighter to the ladder",
            "B": "It is used to secure the ladder to the building",
            "C": "It is used to secure the rope that leads to the destination",
            "D": "It is used to hoist the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_259_c23c7b7b",
          "question": "Why is a half hitch tied to one spur if enough rope is available?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A half hitch can be tied to one spur to help control the ladder from the ground if enough rope is available.",
          "options": {
            "A": "To secure the firefighter to the ladder",
            "B": "To control the ladder from the ground",
            "C": "To secure the ladder to the building",
            "D": "To make the ladder lighter"
          }
        },
        {
          "id": "sfd_basic_skills_259_31e2d1b8",
          "question": "What is the role of the member on the ladder during the hoisting operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the ladder will climb to the ground and direct the members hoisting it to take a strain (load the rope).",
          "options": {
            "A": "To tie the bowline with a bight",
            "B": "To pivot the ladder 180 degrees",
            "C": "To climb to the ground and direct the members hoisting it",
            "D": "To secure the ladder to the building"
          }
        },
        {
          "id": "sfd_basic_skills_259_9b740f55",
          "question": "What is the purpose of 'taking a strain' during the ladder hoisting operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "'Taking a strain' refers to loading the rope during the ladder hoisting operation.",
          "options": {
            "A": "To make the ladder lighter",
            "B": "To secure the ladder to the building",
            "C": "To load the rope",
            "D": "To tie the bowline with a bight"
          }
        },
        {
          "id": "sfd_basic_skills_222_64c3d940",
          "question": "What should be done when there is insufficient halyard length due to minimum extension of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When there is insufficient halyard length, the fly must be secured by using a utility strap as described in the content.",
          "options": {
            "A": "The fly must be secured by using a utility strap",
            "B": "The ladder should be extended further",
            "C": "The halyard should be cut to fit",
            "D": "The ladder should be replaced"
          }
        },
        {
          "id": "sfd_basic_skills_222_91d9d36f",
          "question": "What is the purpose of the firefighter's left foot on the bottom rung of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The firefighter's left foot on the bottom rung of the ladder is to keep the butt from sliding out when pulling on the halyard.",
          "options": {
            "A": "To balance the ladder",
            "B": "To keep the butt from sliding out when pulling on the halyard",
            "C": "To provide a step for climbing",
            "D": "To kick the ladder into position"
          }
        },
        {
          "id": "sfd_basic_skills_222_666d3355",
          "question": "What should be done with any excess halyard after tying?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Any excess halyard that is left after tying should be pushed through to the fly side of the ladder.",
          "options": {
            "A": "It should be cut off",
            "B": "It should be left hanging",
            "C": "It should be pushed through to the fly side of the ladder",
            "D": "It should be tied around the rung"
          }
        },
        {
          "id": "sfd_basic_skills_222_595782e2",
          "question": "Where should two half hitches be placed when sufficient halyard is available?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When sufficient halyard is available, two half hitches are placed above the rung around the halyard.",
          "options": {
            "A": "Below rung 2",
            "B": "Above rung 3",
            "C": "Between rungs 2 and 3",
            "D": "On the vertical part of the utility strap"
          }
        },
        {
          "id": "sfd_basic_skills_222_c7003b32",
          "question": "What is the purpose of tying a hose knot around the lowest set of double rungs?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "A hose knot is formed around the lowest set of double rungs to secure the fly when there is insufficient halyard length.",
          "options": {
            "A": "To secure the ladder",
            "B": "To extend the halyard",
            "C": "To prevent the ladder from sliding",
            "D": "To secure the fly when there is insufficient halyard length"
          }
        },
        {
          "id": "sfd_basic_skills_263_051cad6f",
          "question": "How should the ladder be placed according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the Seattle Fire Department, the ladder should be placed bed side down with the spurs hanging over the objective.",
          "options": {
            "A": "Bed side up with the spurs hanging over the objective",
            "B": "Bed side down with the spurs hanging over the objective",
            "C": "Bed side down with the spurs under the objective",
            "D": "Bed side up with the spurs under the objective"
          }
        },
        {
          "id": "sfd_basic_skills_263_9b26e385",
          "question": "Where should the rope lay according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The rope should lay straight under the ladder toward the tip.",
          "options": {
            "A": "Straight under the ladder toward the tip",
            "B": "Straight over the ladder toward the tip",
            "C": "Curled under the ladder toward the base",
            "D": "Curled over the ladder toward the base"
          }
        },
        {
          "id": "sfd_basic_skills_263_10e31c76",
          "question": "How many members should carry the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Four members should carry the ladder.",
          "options": {
            "A": "Two",
            "B": "Three",
            "C": "Four",
            "D": "Five"
          }
        },
        {
          "id": "sfd_basic_skills_263_9b9f6146",
          "question": "Where should the members position themselves on the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Members should position themselves one on the right beam and one on the left beam at the center of the ladder.",
          "options": {
            "A": "One on the right beam and one on the left beam at the center of the ladder",
            "B": "One on the right beam and one on the left beam at the tip of the ladder",
            "C": "One on the right beam and one on the left beam at the base of the ladder",
            "D": "All members should be at the base of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_263_80d72277",
          "question": "How many members should work the rope depending on the size of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Depending on the size of the ladder, one or two members should work the rope.",
          "options": {
            "A": "One",
            "B": "Two",
            "C": "Three",
            "D": "Four"
          }
        },
        {
          "id": "sfd_basic_skills_234_235a07b3",
          "question": "What is the role of the member on the bed side during the 'PREPARE TO LOWER ON THE (RIGHT or LEFT) BEAM' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During the 'PREPARE TO LOWER ON THE (RIGHT or LEFT) BEAM' command, the member on the bed side foots the ladder and checks for obstructions and personnel.",
          "options": {
            "A": "They walk backward while lowering the ladder",
            "B": "They foot the ladder and check for obstructions",
            "C": "They grasp the beam with both hands",
            "D": "They return the ladder tip first to the apparatus"
          }
        },
        {
          "id": "sfd_basic_skills_234_326f5beb",
          "question": "What is the correct action during the 'LOWER THE FLY' command?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "During the 'LOWER THE FLY' command, the member on the bed side lowers the fly hand-over-hand.",
          "options": {
            "A": "The member on the bed side lowers the fly hand-over-hand",
            "B": "The member on the fly side steps to the designated beam",
            "C": "The ladder is lifted",
            "D": "The ladder is returned tip first to the apparatus"
          }
        },
        {
          "id": "sfd_basic_skills_234_93b854a9",
          "question": "What is the role of the member on the fly side during the 'LOWER' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During the 'LOWER' command, the member on the fly side slowly walks backward while grasping the beam of the ladder and lowers it to the ground.",
          "options": {
            "A": "They foot the ladder",
            "B": "They slowly walk backward while grasping the beam of the ladder and lower it to the ground",
            "C": "They return the ladder tip first to the apparatus",
            "D": "They check for obstructions and personnel"
          }
        },
        {
          "id": "sfd_basic_skills_234_028aee02",
          "question": "What is the difference between a two member beam raise and a three member beam raise?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The difference between a two member beam raise and a three member beam raise is that in a three member beam raise, after the ladder has come to the vertical position, the member in charge will step in at the right beam.",
          "options": {
            "A": "In a three member beam raise, the member in charge steps in at the right beam",
            "B": "In a three member beam raise, the member on the bed side lowers the fly hand-over-hand",
            "C": "In a three member beam raise, the member on the fly side steps to the designated beam",
            "D": "There is no difference between a two member beam raise and a three member beam raise"
          }
        },
        {
          "id": "sfd_basic_skills_234_b4cebca5",
          "question": "What is the final command in the sequence of handling the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The final command in the sequence of handling the ladder is 'STOW THE LADDER', where the members return the ladder tip first to the apparatus.",
          "options": {
            "A": "LOWER",
            "B": "LIFT",
            "C": "PREPARE TO LIFT",
            "D": "STOW THE LADDER"
          }
        },
        {
          "id": "sfd_basic_skills_185_e25e2cd1",
          "question": "Who is responsible for giving commands during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member in charge is responsible for giving commands during ladder operations. This ensures a smooth, coordinated movement in lifting, carrying, spotting, raising, pivoting, extending, retracting and lowering a ladder.",
          "options": {
            "A": "The member at the top of the ladder",
            "B": "The member at the bottom of the ladder",
            "C": "The member in charge",
            "D": "All members simultaneously"
          }
        },
        {
          "id": "sfd_basic_skills_185_e2108480",
          "question": "In what manner should commands be given during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Commands should be given in a loud, clear, and concise voice. This ensures that all members can hear and understand the instructions, which is crucial for their safety and the success of the operation.",
          "options": {
            "A": "In a whisper",
            "B": "In a loud, clear, and concise voice",
            "C": "In a written format",
            "D": "In a coded language"
          }
        },
        {
          "id": "sfd_basic_skills_185_d127b820",
          "question": "Where should the member in charge be positioned when two or more members are carrying a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When two or more members are carrying a ladder, the member in charge should be on the right beam, at the center or butt. This position allows for correct spotting of the ladder.",
          "options": {
            "A": "On the left beam, at the center",
            "B": "On the right beam, at the center or butt",
            "C": "At the top of the ladder",
            "D": "At the foot of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_185_511bc97d",
          "question": "What is the position of the member in charge when using tormentor poles?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When using tormentor poles, the member in charge will be on the right pole. This position allows for effective control and coordination of the ladder operation.",
          "options": {
            "A": "On the left pole",
            "B": "At the center pole",
            "C": "On the right pole",
            "D": "At the butt of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_185_2ce04afd",
          "question": "What is the position of the member in charge for all beam carries?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "For all beam carries, the member in charge should be at the butt of the ladder. This position allows for effective control and coordination of the ladder operation.",
          "options": {
            "A": "On the right beam, at the center",
            "B": "On the right beam, at the center or butt",
            "C": "At the right butt on a 4 or 5 member flat carry",
            "D": "At the butt for all beam carries"
          }
        },
        {
          "id": "sfd_basic_skills_243_74e3d0e6",
          "question": "Who is responsible for checking the overhead area for obstructions before raising the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member in charge (the member on the right beam at the butt) is responsible for checking the overhead area for obstructions.",
          "options": {
            "A": "The member on the left beam at the butt",
            "B": "The member in charge",
            "C": "The two members at the tip",
            "D": "All members"
          }
        },
        {
          "id": "sfd_basic_skills_243_d7008013",
          "question": "What is the position of the member in charge during the 'PREPARE TO RAISE - PASS THE POLES' command?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During the 'PREPARE TO RAISE - PASS THE POLES' command, the member in charge (#1) will begin to move to a position to receive the poles.",
          "options": {
            "A": "At the tip of the ladder",
            "B": "At the butt of the ladder",
            "C": "Moving to a position to receive the poles",
            "D": "Checking for overhead obstructions"
          }
        },
        {
          "id": "sfd_basic_skills_243_935b0411",
          "question": "What is the responsibility of all personnel in the area where a ladder is to be raised?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "It is the responsibility of all personnel to survey the area where a ladder is to be raised.",
          "options": {
            "A": "To check for overhead obstructions",
            "B": "To survey the area",
            "C": "To pass the poles",
            "D": "To execute the 'LIFT' command"
          }
        },
        {
          "id": "sfd_basic_skills_243_282da505",
          "question": "What is the position of the ladder when the 'LOWER THE LADDER' command is given?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the 'LOWER THE LADDER' command is given, the ladder is placed on the ground, fly side up.",
          "options": {
            "A": "On the ground, fly side up",
            "B": "On the ground, fly side down",
            "C": "In the air, fly side up",
            "D": "In the air, fly side down"
          }
        },
        {
          "id": "sfd_basic_skills_243_749ac2cb",
          "question": "What is the role of the member on the left beam at the butt during the 'PREPARE TO RAISE - PASS THE POLES' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During the 'PREPARE TO RAISE - PASS THE POLES' command, the member on the left beam at the butt (#4) will move to the butt of the ladder between the spurs and prepare to pass the poles.",
          "options": {
            "A": "To check for overhead obstructions",
            "B": "To move to the butt of the ladder between the spurs and prepare to pass the poles",
            "C": "To stay at their position and help pass the poles",
            "D": "To move to a position to receive the poles"
          }
        },
        {
          "id": "sfd_basic_skills_214_974d3bd9",
          "question": "What is the correct action to take when the command is 'IN' while handling a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the command is 'IN', you should push IN on the ladder with the pole so the beam closest to you comes off the ground slightly and the ladder is able to be pivoted on the designated beam.",
          "options": {
            "A": "Pull OUT from the ladder with the pole",
            "B": "Push IN on the ladder with the pole",
            "C": "Move to a position just past parallel with the left beam",
            "D": "Foot the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_214_8a85d8f7",
          "question": "What is the correct action to take when the command is 'OUT' while handling a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the command is 'OUT', you should pull OUT from the ladder with the pole so the beam furthest away from you comes off the ground slightly and the ladder is able to be pivoted on the designated beam.",
          "options": {
            "A": "Push IN on the ladder with the pole",
            "B": "Pull OUT from the ladder with the pole",
            "C": "Move to a position just past parallel with the left beam",
            "D": "Foot the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_214_da3cb960",
          "question": "What is the role of the member on the left pole when the command 'ON THE LEFT BEAM, PIVOT OUT' is given?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the left pole moves to a position just past parallel with the left beam, then slightly pulls the ladder onto its left beam when the command 'ON THE LEFT BEAM, PIVOT OUT' is given.",
          "options": {
            "A": "Push IN on the ladder with the pole",
            "B": "Pull OUT from the ladder with the pole",
            "C": "Move to a position just past parallel with the left beam, then slightly pull the ladder onto its left beam",
            "D": "Foot the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_214_cc69a47e",
          "question": "What is the role of the members at the butt when the command 'ON THE LEFT BEAM, PIVOT OUT' is given?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The members at the butt pivot the ladder out on the left beam, then foot the ladder when the command 'ON THE LEFT BEAM, PIVOT OUT' is given.",
          "options": {
            "A": "Push IN on the ladder with the pole",
            "B": "Pull OUT from the ladder with the pole",
            "C": "Move to a position just past parallel with the left beam, then slightly pull the ladder onto its left beam",
            "D": "Pivot the ladder out on the left beam, then foot the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_214_1cd8fe41",
          "question": "What is the role of the member in charge after giving the command 'ON THE LEFT BEAM, PIVOT OUT'?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member in charge moves into original position after giving the command 'ON THE LEFT BEAM, PIVOT OUT'.",
          "options": {
            "A": "Move to a position just past parallel with the left beam, then slightly pull the ladder onto its left beam",
            "B": "Pivot the ladder out on the left beam, then foot the ladder",
            "C": "Move into original position",
            "D": "Push IN on the ladder with the pole"
          }
        },
        {
          "id": "sfd_basic_skills_202_3da0d4fc",
          "question": "Why is it important to extend the fly to the proper distance and lock the dogs before the ladder is placed into the building during a rescue?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that victims can or will jump or grab at the ladder tip before it is set against the objective. Therefore, it's important to extend the fly to the proper distance and lock the dogs before the ladder is placed into the building.",
          "options": {
            "A": "To prevent the ladder from collapsing",
            "B": "To ensure the ladder is at the correct height",
            "C": "To prevent victims from jumping or grabbing at the ladder tip before it is set",
            "D": "To ensure the ladder is visible from a distance"
          }
        },
        {
          "id": "sfd_basic_skills_202_11dad7bb",
          "question": "Where should the ladder tip be placed when operating fire streams from a ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that the ladder tip should be placed just above the top of the opening. This allows the hose line to be placed away from the window opening while still giving the hose team members the best vantage point for defensive operations.",
          "options": {
            "A": "Just below the top of the opening",
            "B": "Just above the top of the opening",
            "C": "At the middle of the opening",
            "D": "At the bottom of the opening"
          }
        },
        {
          "id": "sfd_basic_skills_202_8ec2e5d7",
          "question": "What should be avoided when spotting a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text advises to avoid setting a ladder in front of windows and doorways which may become involved in fire when spotting a ladder.",
          "options": {
            "A": "Setting it in front of windows and doorways which may become involved in fire",
            "B": "Placing it at the corners of the structure",
            "C": "Determining the correct amount of extension prior to lowering the ladder into the building",
            "D": "Extending a ladder to a roof"
          }
        },
        {
          "id": "sfd_basic_skills_202_109eae6e",
          "question": "When extending a ladder to a roof, how many rungs of the ladder should be placed above the parapet or gutter line?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text suggests that when extending a ladder to a roof, at least 5 rungs of the ladder should be placed above the parapet or gutter line. This allows for an easier and safer transition from the ladder to the roof and back again.",
          "options": {
            "A": "At least 2 rungs",
            "B": "At least 3 rungs",
            "C": "At least 4 rungs",
            "D": "At least 5 rungs"
          }
        },
        {
          "id": "sfd_basic_skills_202_28d2be19",
          "question": "When a window or opening is tall and wide enough for the ladder tip to be placed inside the opening, how many rungs should be placed above the sill line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that when a window or opening is tall and wide enough for the ladder tip to be placed inside the opening, 2 to 3 rungs should be placed above the sill line. This ensures that hands can be used to grip.",
          "options": {
            "A": "1 to 2 rungs",
            "B": "2 to 3 rungs",
            "C": "3 to 4 rungs",
            "D": "4 to 5 rungs"
          }
        },
        {
          "id": "sfd_basic_skills_193_5c817045",
          "question": "What is the purpose of placing the inside arm between the rungs of the ladder during a low shoulder beam carry?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The inside arm is placed between the rungs and grasps the upper beam of the ladder to keep the ladder from twisting, providing stability during carry.",
          "options": {
            "A": "To ensure the firefighter can see clearly",
            "B": "To prevent the ladder from twisting",
            "C": "To lift the ladder higher",
            "D": "To make the ladder lighter"
          }
        },
        {
          "id": "sfd_basic_skills_193_c1167004",
          "question": "Why should the butt end of the ladder be tilted slightly downward during a low shoulder beam carry?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Tilting the butt end of the ladder slightly downward allows the firefighter to have clear forward vision, which is crucial for safety and efficient operation.",
          "options": {
            "A": "To make the ladder lighter",
            "B": "To prevent the ladder from twisting",
            "C": "To allow for clear forward vision",
            "D": "To lift the ladder higher"
          }
        },
        {
          "id": "sfd_basic_skills_193_c8b48701",
          "question": "In the high shoulder beam carry, where should the firefighter position themselves on the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In the high shoulder beam carry, the firefighter should position themselves at the top 1/3 of the ladder to properly balance and carry the ladder.",
          "options": {
            "A": "At the bottom 1/3 of the ladder",
            "B": "At the top 1/3 of the ladder",
            "C": "At the center of the ladder",
            "D": "At the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_193_61079ec5",
          "question": "What is the role of the outside hand during a high shoulder beam carry?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The outside hand grasps the upper beam of the ladder during a high shoulder beam carry to provide the best stabilization and balance.",
          "options": {
            "A": "To lift the ladder higher",
            "B": "To make the ladder lighter",
            "C": "To secure the ladder to the shoulder",
            "D": "To grasp the upper beam for stabilization and balance"
          }
        },
        {
          "id": "sfd_basic_skills_193_1d6f8710",
          "question": "In both the low shoulder and high shoulder beam carry, what is the common purpose of the outside hand?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In both carrying techniques, the outside hand is used to grasp a rung or beam in front of the chest for stabilization and balance.",
          "options": {
            "A": "To lift the ladder higher",
            "B": "To secure the ladder to the shoulder",
            "C": "To grasp a rung or beam for stabilization and balance",
            "D": "To make the ladder lighter"
          }
        },
        {
          "id": "sfd_basic_skills_255_767c485f",
          "question": "What is the correct position of the roof ladder beam when properly placed?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When properly placed, the roof ladder beam will be directly in line with the outside of the extension ladder beam, and be perpendicular to the roof eaves.",
          "options": {
            "A": "Parallel to the roof eaves",
            "B": "In line with the inside of the extension ladder beam",
            "C": "In line with the outside of the extension ladder beam",
            "D": "Perpendicular to the extension ladder beam"
          }
        },
        {
          "id": "sfd_basic_skills_255_2247a553",
          "question": "What is the recommended method to ensure the roof ladder hooks are set properly?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To test the hooks, you should pull downward on the ladder to ensure the hooks are set properly.",
          "options": {
            "A": "Push the ladder upward",
            "B": "Pull downward on the ladder",
            "C": "Shake the ladder side to side",
            "D": "Jump on the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_255_4001935f",
          "question": "What should you do if the ground ladder is not anchored?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the ground ladder is not anchored the member can take a position with their body half way above the roof gutter, sill, or parapet.",
          "options": {
            "A": "Lock in on the ground ladder below the roof gutter",
            "B": "Take a position with your body half way above the roof gutter",
            "C": "Climb the ladder without any precautions",
            "D": "Avoid climbing the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_255_a33deda5",
          "question": "What is the correct way to carry the roof ladder while climbing the ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Keep the hand and arm that is carrying the roof ladder high when climbing to help prevent the roof ladder from sliding off the shoulder.",
          "options": {
            "A": "Keep the hand and arm that is carrying the roof ladder low",
            "B": "Carry the roof ladder with both hands",
            "C": "Keep the hand and arm that is carrying the roof ladder high",
            "D": "Carry the roof ladder on your head"
          }
        },
        {
          "id": "sfd_basic_skills_255_6ee0cd8b",
          "question": "What is the correct position to remove the roof ladder if the ground ladder has a ladder anchor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the ground ladder has a ladder anchor, the member can lock in on the ground ladder below the roof gutter, sill, or parapet, which will free up both hands to lower the roof ladder.",
          "options": {
            "A": "Lock in on the ground ladder above the roof gutter",
            "B": "Lock in on the ground ladder below the roof gutter",
            "C": "Stand on the roof gutter",
            "D": "Stand on the roof peak"
          }
        },
        {
          "id": "sfd_basic_skills_238_ff87dc52",
          "question": "What is the correct command to give when the ladder is ready to be lifted?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The correct command to give when the ladder is ready to be lifted is 'LIFT'.",
          "options": {
            "A": "Command 'STOW THE LADDER'",
            "B": "Command 'LOWER'",
            "C": "Command 'PREPARE TO LIFT'",
            "D": "Command 'LIFT'"
          }
        },
        {
          "id": "sfd_basic_skills_238_b7d38ce2",
          "question": "What is the correct position to be in when preparing to lift the ladder from the ground?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The correct position to be in when preparing to lift the ladder from the ground is crouching down at the tip of the ladder.",
          "options": {
            "A": "Standing at the butt of the ladder looking towards the tip",
            "B": "Standing at the tip of the ladder looking towards the butt",
            "C": "Crouching down at the butt of the ladder",
            "D": "Crouching down at the tip of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_238_18b174fc",
          "question": "Which side of the ladder should be facing up when placing the butt of the ladder against the building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The fly side of the ladder should be facing up when placing the butt of the ladder against the building.",
          "options": {
            "A": "The bed side",
            "B": "The fly side",
            "C": "Either side",
            "D": "Neither side"
          }
        },
        {
          "id": "sfd_basic_skills_238_884cfeb9",
          "question": "What is the correct command to give when the ladder is ready to be returned to the apparatus?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The correct command to give when the ladder is ready to be returned to the apparatus is 'STOW THE LADDER'.",
          "options": {
            "A": "Command 'STOW THE LADDER'",
            "B": "Command 'LOWER'",
            "C": "Command 'PREPARE TO LIFT'",
            "D": "Command 'LIFT'"
          }
        },
        {
          "id": "sfd_basic_skills_238_86fb4afa",
          "question": "What is the correct method to lower the ladder to the ground?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct method to lower the ladder to the ground is by walking backward while grasping the beam of the ladder with a hand-over-hand motion.",
          "options": {
            "A": "By pushing the ladder down",
            "B": "By pulling the ladder down",
            "C": "By walking backward while grasping the beam of the ladder with a hand-over-hand motion",
            "D": "By walking forward while grasping the beam of the ladder with a hand-over-hand motion"
          }
        },
        {
          "id": "sfd_basic_skills_239_e771b0be",
          "question": "What is the correct procedure when the ladder reaches shoulder height?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the ladder reaches shoulder height, you should step under the ladder and walk the ladder hand-over-hand using the center of the rungs or slide your hands along the beams until the ladder is in the vertical position.",
          "options": {
            "A": "Jump over the ladder",
            "B": "Slide your hands along the beams until the ladder is in the vertical position",
            "C": "Walk the ladder hand-over-hand using the center of the rungs",
            "D": "Leave the ladder and find another one"
          }
        },
        {
          "id": "sfd_basic_skills_239_597a5b67",
          "question": "What should a firefighter do after walking the ladder to the vertical position against the objective?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After walking the ladder to the vertical position against the objective, the firefighter should adjust the butt for climbing or to prepare for extension.",
          "options": {
            "A": "Climb the ladder immediately",
            "B": "Leave the ladder and find another one",
            "C": "Adjust the butt for climbing or to prepare for extension",
            "D": "Rotate the ladder above the head"
          }
        },
        {
          "id": "sfd_basic_skills_239_e7c01677",
          "question": "What is the importance of using the center of the rungs or sliding your hands along the beams when the ladder is at shoulder height?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Using the center of the rungs or sliding your hands along the beams when the ladder is at shoulder height ensures that the ladder is in the vertical position and flat against the building.",
          "options": {
            "A": "To ensure the ladder is in the vertical position",
            "B": "To ensure the ladder is flat against the building",
            "C": "To ensure the ladder is at shoulder height",
            "D": "Both A and B"
          }
        },
        {
          "id": "sfd_basic_skills_239_78cc6509",
          "question": "What should a firefighter do when the ladder is in the vertical position and flat against the building?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the ladder is in the vertical position and flat against the building, the firefighter should adjust the butt for climbing or to prepare for extension.",
          "options": {
            "A": "Rotate the ladder above the head",
            "B": "Walk the ladder hand-over-hand using the center of the rungs",
            "C": "Adjust the butt for climbing or to prepare for extension",
            "D": "Jump over the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_239_d2ac0430",
          "question": "What is the next step after a member reaches the wall and rotates the ladder above the head?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After a member reaches the wall and rotates the ladder above the head, the next step is to walk up the rungs or slide the hands up the beams.",
          "options": {
            "A": "Jump over the ladder",
            "B": "Walk the ladder hand-over-hand using the center of the rungs",
            "C": "Walk up the rungs or slide the hands up the beams",
            "D": "Leave the ladder and find another one"
          }
        },
        {
          "id": "sfd_basic_skills_254_5932a381",
          "question": "What is the correct position of the hooks of the roof ladder when laying it on the ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hooks of the roof ladder should be facing away from the ground extension ladder when laying it on the rungs.",
          "options": {
            "A": "Facing towards the extension ladder",
            "B": "Facing towards the ground",
            "C": "Facing away from the extension ladder",
            "D": "Facing towards the sky"
          }
        },
        {
          "id": "sfd_basic_skills_254_a24c6a6f",
          "question": "What is the correct position to reach between rungs when climbing the ladder with the roof ladder on the shoulder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The correct position to reach between rungs when climbing the ladder with the roof ladder on the shoulder is between rungs 2 and 3 or 3 and 4.",
          "options": {
            "A": "Between rungs 1 and 2",
            "B": "Between rungs 2 and 3 or 3 and 4",
            "C": "Between rungs 3 and 4 or 4 and 5",
            "D": "Between rungs 4 and 5 or 5 and 6"
          }
        },
        {
          "id": "sfd_basic_skills_254_60b39fc5",
          "question": "What should be the position of the firefighter when placing the roof ladder onto the roof?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The firefighter should reach a point where their waist level is just above the roof line before placing the roof ladder onto the roof.",
          "options": {
            "A": "Their waist level is just above the roof line",
            "B": "Their waist level is just below the roof line",
            "C": "Their waist level is at the same level as the roof line",
            "D": "Their waist level is two feet above the roof line"
          }
        },
        {
          "id": "sfd_basic_skills_254_1071d26b",
          "question": "What is the correct position of the hooks of the roofer when raising it to the ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When raising the roofer to the ground ladder, the hooks should be pointing away from the ground ladder.",
          "options": {
            "A": "Pointing towards the ground ladder",
            "B": "Pointing away from the ground ladder",
            "C": "Pointing towards the sky",
            "D": "Pointing towards the ground"
          }
        },
        {
          "id": "sfd_basic_skills_254_b5fdb8f3",
          "question": "What is the correct way to balance the roof ladder when climbing the ground ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The roof ladder is balanced by climbing the ground ladder with the chosen arm over the beam of the roof ladder.",
          "options": {
            "A": "With the chosen arm under the beam of the roof ladder",
            "B": "With the chosen arm over the beam of the roof ladder",
            "C": "With both arms over the beam of the roof ladder",
            "D": "With both arms under the beam of the roof ladder"
          }
        },
        {
          "id": "sfd_basic_skills_192_32660a7b",
          "question": "Why is it important for members of the fire department to know the exact location of each ladder on the apparatus?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Knowing the exact location of each ladder allows for swift and efficient operation, reducing delays in emergency situations.",
          "options": {
            "A": "To ensure that any ladder can be located and placed into operation without delay",
            "B": "To ensure that the ladders are used in the correct order",
            "C": "To ensure that the ladders are not damaged during transport",
            "D": "To ensure that the ladders are not lost"
          }
        },
        {
          "id": "sfd_basic_skills_192_c6ffed31",
          "question": "What safety consideration is important when carrying ladders?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that members should avoid walking backward while carrying ladders to prevent accidents.",
          "options": {
            "A": "Avoid walking backwards",
            "B": "Always carry the ladder with two people",
            "C": "Always carry the ladder tip end first",
            "D": "Always carry the ladder butt end first"
          }
        },
        {
          "id": "sfd_basic_skills_192_5293c660",
          "question": "What should be done with unused ladders during an operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Unused ladders must be removed from the apparatus and placed in a safe position if it is not possible for them to be left on the apparatus in a locked position.",
          "options": {
            "A": "They should be left on the apparatus",
            "B": "They should be removed from the apparatus and placed in a safe position",
            "C": "They should be used as backup ladders",
            "D": "They should be returned to the fire station"
          }
        },
        {
          "id": "sfd_basic_skills_192_30822572",
          "question": "When is the risk of accidents while handling ladders increased?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that more accidents occur while handling ladders than while climbing them, especially at night when there is inadequate light, or if there is smoke in the air or uneven terrain.",
          "options": {
            "A": "During the day",
            "B": "When there is smoke in the air or uneven terrain",
            "C": "When the ladders are new",
            "D": "When the ladders are old"
          }
        },
        {
          "id": "sfd_basic_skills_192_080689f4",
          "question": "What is the correct method to carry a ladder from the ground?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text describes the Low Shoulder Beam Carry as the correct method to lift a ladder from the ground.",
          "options": {
            "A": "High Shoulder Beam Carry",
            "B": "Low Shoulder Beam Carry",
            "C": "Tip End First Carry",
            "D": "Butt End First Carry"
          }
        },
        {
          "id": "sfd_basic_skills_203_2d04e3b4",
          "question": "What is the purpose of heeling a ladder during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Heeling a ladder is done to keep the butt under control and prevent it from shifting or moving. This is accomplished by applying body weight to the ladder through placement of feet on the bottom rung or spurs.",
          "options": {
            "A": "To extend the ladder's reach",
            "B": "To increase the ladder's height",
            "C": "To keep the ladder's butt under control and prevent it from shifting or moving",
            "D": "To make the ladder more visible in smoke"
          }
        },
        {
          "id": "sfd_basic_skills_203_706b868a",
          "question": "When heeling a ladder, where should the member at the butt of the ladder grasp the halyard bundle?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "With most ladders, the halyard is grasped between the 2nd and 3rd rungs; however, on some ladders it may be necessary to grasp the halyard between the 1st and 2nd rungs.",
          "options": {
            "A": "Between the 1st and 2nd rungs",
            "B": "Between the 2nd and 3rd rungs",
            "C": "Between the 3rd and 4th rungs",
            "D": "Between the 4th and 5th rungs"
          }
        },
        {
          "id": "sfd_basic_skills_203_945d0ca6",
          "question": "What should the member at the butt of the ladder do just before the ladder comes to the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Just before the ladder has come to the vertical, the member at the butt should step down, grasp the outside of each beam of the bed section with both hands at shoulder level keeping the back leg locked.",
          "options": {
            "A": "Step up onto the next rung",
            "B": "Release the halyard bundle",
            "C": "Step down and grasp the outside of each beam of the bed section with both hands at shoulder level",
            "D": "Climb up the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_203_9f2a2df2",
          "question": "What is the role of the member footing during the heeling process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member footing will step off the rung just prior to the ladder coming to the vertical position.",
          "options": {
            "A": "To climb up the ladder",
            "B": "To step off the rung just prior to the ladder coming to the vertical position",
            "C": "To hold the halyard bundle",
            "D": "To push the ladder into a vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_203_f5f0760e",
          "question": "When heeling a ladder, where does the member at the butt place their other hand to maintain balance?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the butt of the ladder places their other hand on the beam to maintain balance while heeling the ladder.",
          "options": {
            "A": "On the halyard bundle",
            "B": "On the beam",
            "C": "On the top rung",
            "D": "On the ground"
          }
        },
        {
          "id": "sfd_basic_skills_215_300b89b7",
          "question": "What is the first action to be taken when the command is given to pivot the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first action when the command is given to pivot the ladder is for the member on the bed side to designate the beam that the ladder will be pivoted on by slapping it twice.",
          "options": {
            "A": "The member on the bed side moves back to the appropriate position",
            "B": "The member on the bed side designates the beam that the ladder will be pivoted on by slapping it twice",
            "C": "The member on the pole that has not moved executes further movement",
            "D": "The ladder is set and footed"
          }
        },
        {
          "id": "sfd_basic_skills_215_b6fa47b4",
          "question": "What is the importance of team communication during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Strong and clear team communication is critical to ensure the safety of the team and stability of the ladder.",
          "options": {
            "A": "To ensure proper distance and placement between the two pole members",
            "B": "To ensure the ladder is pivoted to the desired position",
            "C": "To ensure the safety of the team and stability of the ladder",
            "D": "To ensure the ladder is set and footed"
          }
        },
        {
          "id": "sfd_basic_skills_215_94782974",
          "question": "What command would the member on the right pole give if the ladder was leaning toward the member on the left pole after a pivot?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the ladder was leaning toward the member on the left pole after a pivot, the member on the right pole would loudly state 'Push.'",
          "options": {
            "A": "Pull",
            "B": "Push",
            "C": "Shift",
            "D": "Pivot"
          }
        },
        {
          "id": "sfd_basic_skills_215_14ecd6ee",
          "question": "What is the purpose of the 'prepare to shift' command?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'prepare to shift' command is given so that a ladder can be moved parallel to a building or object while in the vertical position.",
          "options": {
            "A": "To move the ladder parallel to a building or object while in the vertical position",
            "B": "To pivot the ladder to the desired position",
            "C": "To ensure proper distance and placement between the two pole members",
            "D": "To set and foot the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_215_d27f5aff",
          "question": "Who can request a pole member to 'Push' or 'Pull'?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Any member of the team may request that a pole member 'Pushes' or 'Pulls' if the safety of the team or stability of the ladder is in question.",
          "options": {
            "A": "Only the member on the bed side",
            "B": "Only the member on the pole that has not moved",
            "C": "Only the member on the right pole",
            "D": "Any member of the team"
          }
        },
        {
          "id": "sfd_basic_skills_242_0a5a5594",
          "question": "What is the role of the member in charge (#1) in the ladder rotation procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member in charge (#1) moves up the right beam toward the tip and stops between rungs 2 and 3.",
          "options": {
            "A": "They move to the butt of the ladder and heel it",
            "B": "They move up the right beam toward the tip and stop between rungs 2 and 3",
            "C": "They stay at the bottom rung and grasp the halyard ropes",
            "D": "They move to the left beam tip"
          }
        },
        {
          "id": "sfd_basic_skills_242_4ea9252b",
          "question": "What is the correct position for the member at the butt of the ladder when the ladder comes to a vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the ladder comes to a vertical position the member on the butt will step back off the ladder and place both hands on the beams and their feet are placed shoulder width apart, one foot ahead of the other to maintain the balance of the ladder.",
          "options": {
            "A": "They step up onto the bottom rung, and grasp the halyard ropes in both hands",
            "B": "They place both hands on the beams and their feet are placed shoulder width apart, one foot ahead of the other",
            "C": "They move to the tip of the ladder",
            "D": "They stay at the bottom rung and do not move"
          }
        },
        {
          "id": "sfd_basic_skills_242_fd957461",
          "question": "How is the ladder raised to the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The ladder is raised to the vertical position by the two members on the beams using a hand-over-hand motion.",
          "options": {
            "A": "By the two members on the beams using a hand-over-hand motion",
            "B": "By the member at the butt of the ladder",
            "C": "By the member in charge",
            "D": "By the member on the left beam tip"
          }
        },
        {
          "id": "sfd_basic_skills_242_75ac0acc",
          "question": "What is the role of the member on the left beam butt (#3) in the ladder rotation procedure?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the left beam butt (#3) will rotate to the butt of the ladder and heel it.",
          "options": {
            "A": "They move to the tip of the ladder",
            "B": "They move up the right beam toward the tip and stop between rungs 2 and 3",
            "C": "They rotate to the butt of the ladder and heel it",
            "D": "They stay at the bottom rung and do not move"
          }
        },
        {
          "id": "sfd_basic_skills_242_908a210d",
          "question": "How is the balance of the ladder maintained when it comes to a vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The balance of the ladder is maintained when it comes to a vertical position by the member at the butt placing both hands on the beams and their feet shoulder width apart, one foot ahead of the other.",
          "options": {
            "A": "By the member at the butt stepping up onto the bottom rung",
            "B": "By the two members on the beams using a hand-over-hand motion",
            "C": "By the member at the butt placing both hands on the beams and their feet shoulder width apart, one foot ahead of the other",
            "D": "By the member in charge moving up the right beam toward the tip"
          }
        },
        {
          "id": "sfd_basic_skills_184_7247da68",
          "question": "What is the correct method for lifting ladders according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct method for lifting ladders is with the knees bent and back straight. This places the load on the heavy muscles in the thighs and not on the back.",
          "options": {
            "A": "Lifting with the back while the legs are straight",
            "B": "Lifting with the arms while the back is bent",
            "C": "Lifting with the knees bent and back straight",
            "D": "Lifting with the legs while the back is bent"
          }
        },
        {
          "id": "sfd_basic_skills_184_5cf9232b",
          "question": "What is the purpose of the heat sensor label on a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The heat sensor label, when provided, changes to indicate heat exposure.",
          "options": {
            "A": "To indicate the temperature of the fire",
            "B": "To change indicating heat exposure",
            "C": "To show the ladder's maximum heat resistance",
            "D": "To indicate the ladder's age"
          }
        },
        {
          "id": "sfd_basic_skills_184_853128e1",
          "question": "What is the importance of the method of fastening ladder halyards?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The method of fastening ladder halyards, either of wire or fibrous material, should be in a manner that the connection is stronger than the halyard.",
          "options": {
            "A": "To ensure the ladder is aesthetically pleasing",
            "B": "To ensure the connection is stronger than the halyard",
            "C": "To make the ladder lighter",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_184_92831cd4",
          "question": "What is the correct foot positioning when lifting a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Keeping the toes pointed slightly inward rather than spread out lessens the chance of abdominal injury.",
          "options": {
            "A": "Toes pointed outward",
            "B": "Toes pointed inward",
            "C": "Feet flat on the ground",
            "D": "One foot in front of the other"
          }
        },
        {
          "id": "sfd_basic_skills_184_16b35d98",
          "question": "What is the importance of preparatory commands when lifting a ladder with multiple members?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The use of preparatory commands, such as 'Prepare to lift, ---Lift,' will ensure that all members are lifting in unison.",
          "options": {
            "A": "To ensure all members are lifting in unison",
            "B": "To ensure all members are aware of their roles",
            "C": "To ensure all members are physically ready",
            "D": "To ensure all members are mentally prepared"
          }
        },
        {
          "id": "sfd_basic_skills_235_74e3d0e6",
          "question": "Who is responsible for checking the overhead area for obstructions before raising the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member in charge is responsible for checking the overhead area for obstructions and stating 'OVERHEAD CLEAR.'",
          "options": {
            "A": "The member at the tip (#3)",
            "B": "The member in charge",
            "C": "All personnel",
            "D": "The member on the butt (#2)"
          }
        },
        {
          "id": "sfd_basic_skills_235_3f4c7dcc",
          "question": "What is the command given when the ladder is to be grounded at the desired point?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'GROUND THE BUTT' is given when the ladder is to be grounded at the desired point.",
          "options": {
            "A": "PREPARE TO RAISE",
            "B": "OVERHEAD CLEAR",
            "C": "GROUND THE BUTT",
            "D": "RAISE"
          }
        },
        {
          "id": "sfd_basic_skills_235_34e8431a",
          "question": "What should the member at the tip (#3) do if a beam raise parallel to the objective is necessary?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If a beam raise parallel to the objective is necessary, the member at the tip (#3) should roll the ladder over their head.",
          "options": {
            "A": "Check overhead for wires & obstructions",
            "B": "Roll the ladder over their head",
            "C": "Foot the ladder from the bed side",
            "D": "Move to the left beam, bed side"
          }
        },
        {
          "id": "sfd_basic_skills_235_8b96abdd",
          "question": "What is the role of member #2 when the ladder reaches the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the ladder reaches the vertical position, member #2 will foot the ladder from the bed side.",
          "options": {
            "A": "Check overhead for wires & obstructions",
            "B": "Move to the left beam, bed side",
            "C": "Foot the ladder from the bed side",
            "D": "Roll the ladder over their head"
          }
        },
        {
          "id": "sfd_basic_skills_235_6076f514",
          "question": "What is the purpose of the command 'OVERHEAD CLEAR'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'OVERHEAD CLEAR' is used to confirm that the overhead area is free of obstructions.",
          "options": {
            "A": "To indicate that the ladder is ready to be raised",
            "B": "To confirm that the overhead area is free of obstructions",
            "C": "To signal that the ladder has been grounded at the desired point",
            "D": "To instruct the member at the tip (#3) to roll the ladder over their head"
          }
        },
        {
          "id": "sfd_basic_skills_262_6e9e3b7c",
          "question": "Where should the tail end of the rope be positioned when tying a bowline with a bight on a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The tail end of the rope should be positioned at the butt of the ladder when tying a bowline with a bight.",
          "options": {
            "A": "At the tip of the ladder",
            "B": "At the butt of the ladder",
            "C": "One rung space below the center point",
            "D": "On top of the bed section"
          }
        },
        {
          "id": "sfd_basic_skills_262_34bd0625",
          "question": "Where should the hoisting knot be tied on the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hoisting knot should be tied one rung space below the center point of the ladder.",
          "options": {
            "A": "At the butt of the ladder",
            "B": "At the tip of the ladder",
            "C": "One rung space below the center point",
            "D": "On top of the bed section"
          }
        },
        {
          "id": "sfd_basic_skills_262_a55b9d9d",
          "question": "Which side of the ladder should be laid down before tying the rope?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The ladder should be laid down on its fly side before tying the rope.",
          "options": {
            "A": "The fly side",
            "B": "The bed side",
            "C": "The butt side",
            "D": "The tip side"
          }
        },
        {
          "id": "sfd_basic_skills_262_c527e52e",
          "question": "Where should the rope be placed before tying a bowline with a bight?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The rope should be placed on top of the bed section before tying a bowline with a bight.",
          "options": {
            "A": "At the butt of the ladder",
            "B": "At the tip of the ladder",
            "C": "One rung space below the center point",
            "D": "On top of the bed section"
          }
        },
        {
          "id": "sfd_basic_skills_262_359413c0",
          "question": "In which direction should the rope be headed after tying the hoisting knot?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After tying the hoisting knot, the rope should be headed toward the tip of the ladder.",
          "options": {
            "A": "Toward the butt of the ladder",
            "B": "Toward the tip of the ladder",
            "C": "Toward the center of the ladder",
            "D": "Toward the fly side of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_223_474ba99a",
          "question": "What is the correct sequence of steps for the 'push 4-3 and pull 3-2' technique?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'push 4-3 and pull 3-2' technique involves pushing the halyard through rungs 3 and 4, then pulling it back through rungs 2 and 3.",
          "options": {
            "A": "Push halyard through rungs 4 and 3, then back through 3 and 2",
            "B": "Push halyard through rungs 2 and 3, then back through 4 and 3",
            "C": "Push halyard through rungs 3 and 4, then back through 2 and 3",
            "D": "Push halyard through rungs 2 and 3, then back through 3 and 2"
          }
        },
        {
          "id": "sfd_basic_skills_223_47c9b234",
          "question": "What is the importance of the 'push 4-3 and pull 3-2' technique in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'push 4-3 and pull 3-2' technique is used to secure the ladder for safe climbing during firefighting operations.",
          "options": {
            "A": "It helps in rescuing victims from burning buildings",
            "B": "It is used to secure the ladder for safe climbing",
            "C": "It is used to extinguish fires in tall buildings",
            "D": "It is a technique for tying knots in the halyard"
          }
        },
        {
          "id": "sfd_basic_skills_223_5d8c5353",
          "question": "Where should a firefighter tie a round-turn when using a 3 section ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A round-turn should be tied around rung three when using a 3 section ladder.",
          "options": {
            "A": "Rung 2",
            "B": "Rung 3",
            "C": "Rung 4",
            "D": "Rung 5"
          }
        },
        {
          "id": "sfd_basic_skills_223_1d29f5b5",
          "question": "What is the next step after grabbing the halyard slack on the fly side?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After grabbing the halyard slack on the fly side, the next step is to pull the slack toward you between rungs 2 and 3.",
          "options": {
            "A": "Push the slack through rungs 2 and 3",
            "B": "Pull the slack toward you between rungs 2 and 3",
            "C": "Tie a half-hitch around the halyard above rung 3",
            "D": "Tie a round-turn around rung 3"
          }
        },
        {
          "id": "sfd_basic_skills_223_6e465f83",
          "question": "What is the final step in securing the ladder using the halyard?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The final step in securing the ladder using the halyard is to tie a half-hitch around the halyard above rung 3.",
          "options": {
            "A": "Tie a half-hitch around the halyard above rung 3",
            "B": "Tie a round-turn around rung 3",
            "C": "Push the halyard through rungs 3 and 4",
            "D": "Pull the halyard slack toward you between rungs 2 and 3"
          }
        },
        {
          "id": "sfd_basic_skills_258_58a21171",
          "question": "What is the first step in hoisting a ladder with a rope according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first step in hoisting a ladder with a rope is placing the ladder at the proper climbing angle, unextended, with the fly toward the building.",
          "options": {
            "A": "The ladder is placed at the proper climbing angle, unextended, with the fly toward the building.",
            "B": "The end of a roof rope is secured to a fixed object at the desired upper location and dropped to the ground.",
            "C": "A member on the ground grasps the rope and takes a bight of the line at the spur of the ladder.",
            "D": "The member climbs the ladder and passes the bight from the bed side to the fly side."
          }
        },
        {
          "id": "sfd_basic_skills_258_3fa7b85e",
          "question": "What is the role of the member at the top when unlocking and stepping over the 26' ladder onto the objective?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the top unlocks, steps over the 26' ladder onto the objective and pulls the ladder onto the deck.",
          "options": {
            "A": "The member steadies the ladder on its beam.",
            "B": "The member pulls the ladder onto the deck.",
            "C": "The member releases his shoulder and holds the ladder in place.",
            "D": "The member climbs the ladder and steps onto the roof or into the building."
          }
        },
        {
          "id": "sfd_basic_skills_258_08ab95bb",
          "question": "What is the role of the butt member at the fulcrum point?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "At the fulcrum point, the butt member releases his shoulder and holds the ladder in place.",
          "options": {
            "A": "The butt member unlocks and steps over the ladder.",
            "B": "The butt member steadies the ladder on its beam.",
            "C": "The butt member releases his shoulder and holds the ladder in place.",
            "D": "The butt member climbs the ladder and steps onto the roof or into the building."
          }
        },
        {
          "id": "sfd_basic_skills_258_07f983ca",
          "question": "What is the correct method to secure the bight of the line when hoisting a ladder with a rope?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The bight passes behind the left beam, then around to the front side of the bed section.",
          "options": {
            "A": "The bight passes behind the left beam, then around to the front side of the bed section.",
            "B": "The bight passes behind the right beam, then around to the front side of the bed section.",
            "C": "The bight passes behind the left beam, then around to the back side of the bed section.",
            "D": "The bight passes behind the right beam, then around to the back side of the bed section."
          }
        },
        {
          "id": "sfd_basic_skills_258_98c4bd17",
          "question": "What is the final step in hoisting a ladder with a rope?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The final step in hoisting a ladder with a rope is adjusting the knot to the lateral center of the ladder.",
          "options": {
            "A": "The member climbs the ladder and steps onto the roof or into the building.",
            "B": "The member on the ground grasps the rope and takes a bight of the line at the spur of the ladder.",
            "C": "The knot is adjusted to the lateral center of the ladder.",
            "D": "The ladder is placed at the proper climbing angle, unextended, with the fly toward the building."
          }
        },
        {
          "id": "sfd_basic_skills_219_5c69da1f",
          "question": "What is the purpose of placing the right toe against the right spur of the ladder during a two-member fly extension?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the bed side places their right toe against the right spur of the ladder to extend the flies to the desired height.",
          "options": {
            "A": "To ensure the ladder is at the right angle",
            "B": "To extend the flies to the desired height",
            "C": "To maintain the balance of the ladder",
            "D": "To lock the dogs"
          }
        },
        {
          "id": "sfd_basic_skills_219_5029d12f",
          "question": "What should a firefighter avoid doing until all dogs are locked?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Firefighters should avoid reaching through a rung space or touching a rung with the hands or feet until all dogs are locked to prevent injuries.",
          "options": {
            "A": "Reaching through a rung space or touching a rung with the hands or feet",
            "B": "Placing both hands on the beams of the bed section",
            "C": "Keeping the ladder balanced by pulling straight down and inline with the center of the ladder",
            "D": "Maintaining the balance of the ladder with the ladder slightly tilted toward the objective"
          }
        },
        {
          "id": "sfd_basic_skills_219_f3666153",
          "question": "How is the balance of the ladder maintained while extending the fly section?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The balance of the ladder is maintained while extending the fly section by pulling straight down and inline with the center of the ladder.",
          "options": {
            "A": "By placing both hands on the beams of the bed section",
            "B": "By pulling straight down and inline with the center of the ladder",
            "C": "By placing the right toe against the right spur of the ladder",
            "D": "By tilting the ladder toward the objective"
          }
        },
        {
          "id": "sfd_basic_skills_219_d3bbdbc6",
          "question": "What should the member on the fly side do to maintain the balance of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the fly side should place both hands on the beams of the bed section to maintain the balance of the ladder.",
          "options": {
            "A": "Place the right toe against the right spur of the ladder",
            "B": "Pull straight down and inline with the center of the ladder",
            "C": "Place both hands on the beams of the bed section",
            "D": "Lock the dogs"
          }
        },
        {
          "id": "sfd_basic_skills_219_e78db542",
          "question": "What is the command given when the fly(s) is/are to be locked at the next highest rung?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'HIGH' is given when the fly(s) is/are to be locked at the next highest rung.",
          "options": {
            "A": "LOCK",
            "B": "HIGH",
            "C": "STOP",
            "D": "HOLD"
          }
        },
        {
          "id": "sfd_basic_skills_188_faf33491",
          "question": "What does the command 'ADJUST THE BUTT' refer to in the context of ladder commands?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'ADJUST THE BUTT' is given to adjust the butt of the ladder to the proper climbing angle or squaring it to the building.",
          "options": {
            "A": "Securing the dogs to the desired rung",
            "B": "Extending the fly section of the ladder",
            "C": "Adjusting the butt of the ladder to the proper climbing angle or squaring it to the building",
            "D": "Commanding the member on the tormentor poles to take the left tormentor pole"
          }
        },
        {
          "id": "sfd_basic_skills_188_a21cb256",
          "question": "What is the importance of the statement 'ALL DOGS ARE LOCKED'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The statement 'ALL DOGS ARE LOCKED' is made by members after checking to ensure that the dogs are secured properly to the desired rung after extending the flies.",
          "options": {
            "A": "It indicates that the ladder has reached its maximum height",
            "B": "It signifies that the dogs are secured properly to the desired rung after extending the flies",
            "C": "It means that the ladder is squared to the building",
            "D": "It signals that the fly section of the ladder is extended"
          }
        },
        {
          "id": "sfd_basic_skills_188_63f7e4cd",
          "question": "What does the command 'EXTEND THE FLY' imply?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The command 'EXTEND THE FLY' means that the fly section of the ladder is extended to the desired height.",
          "options": {
            "A": "Securing the dogs to the desired rung",
            "B": "Adjusting the butt of the ladder to the proper climbing angle",
            "C": "Commanding the member on the tormentor poles to take the left tormentor pole",
            "D": "Extending the fly section of the ladder to the desired height"
          }
        },
        {
          "id": "sfd_basic_skills_188_6b50362f",
          "question": "What is the purpose of the command 'FLY SIDE AROUND'?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command 'FLY SIDE AROUND' is given by the member on the tormentor poles to the member on the fly side of the ladder to come and take the left tormentor pole once the ladder has come to the vertical and is stabilized.",
          "options": {
            "A": "It is given by the member on the tormentor poles to the member on the fly side of the ladder to come and take the left tormentor pole",
            "B": "It is used to adjust the butt of the ladder to the proper climbing angle",
            "C": "It is used to ensure that the dogs are secured properly to the desired rung",
            "D": "It is used to extend the fly section of the ladder to the desired height"
          }
        },
        {
          "id": "sfd_basic_skills_188_ad9bc832",
          "question": "What is the potential risk if the dogs are not locked properly?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If the dogs are not locked properly, the ladder may collapse or become unstable during use, posing a risk to firefighter safety.",
          "options": {
            "A": "The ladder may not reach the desired height",
            "B": "The ladder may not be squared to the building",
            "C": "The ladder may collapse or become unstable during use",
            "D": "The ladder may not be able to be extended"
          }
        },
        {
          "id": "sfd_basic_skills_183_97a2b03d",
          "question": "What is the purpose of ladder locks or pawls on extension ladders according to the Seattle Fire Department Ground Ladder Safety Standards?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The ladder locks or pawls are designed to prevent the hook from cutting into the rungs when engaged, ensuring the ladder's stability and safety during use.",
          "options": {
            "A": "To provide a decorative element to the ladder",
            "B": "To increase the weight of the ladder",
            "C": "To prevent the hook from cutting into rungs when engaged",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_183_ec1394b1",
          "question": "Why should staypoles or tormentors be furnished on all extension ladders over forty feet?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Staypoles or tormentors are used to stabilize extension ladders over forty feet, preventing them from tipping over during use.",
          "options": {
            "A": "To increase the height of the ladder",
            "B": "To add additional weight to the ladder",
            "C": "To prevent the ladder from tipping over",
            "D": "To make the ladder look more intimidating"
          }
        },
        {
          "id": "sfd_basic_skills_183_5e929da4",
          "question": "What is the recommended way to climb and descend ground ladders for safety purposes, unless it conflicts with the manufacturer's recommendations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Seattle Fire Department Ground Ladder Safety Standards recommend climbing and descending ground ladders with the fly out for safety purposes, unless it conflicts with the manufacturer's recommendations.",
          "options": {
            "A": "With the fly in",
            "B": "With the fly out",
            "C": "With one hand on the rungs",
            "D": "Without using the rungs"
          }
        },
        {
          "id": "sfd_basic_skills_183_ec15e5c9",
          "question": "What is the importance of storing all ladders in a manner that provides ease of access for inspection?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Storing ladders in a manner that provides ease of access for inspection helps to prevent accidents when withdrawing them for use.",
          "options": {
            "A": "To make the ladder easier to find",
            "B": "To prevent accidents when withdrawing them for use",
            "C": "To make the ladder look more organized",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_183_cd5af624",
          "question": "What components of a metal ladder should be checked according to the Seattle Fire Department Ground Ladder Safety Standards?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Seattle Fire Department Ground Ladder Safety Standards require the checking of rungs for welds, damage or weakness, beams for welds, rivets and bolts, and bolts and rivets for tightness.",
          "options": {
            "A": "Rungs, beams, and bolts",
            "B": "Rungs, beams, and paint",
            "C": "Rungs, paint, and bolts",
            "D": "Paint, beams, and bolts"
          }
        },
        {
          "id": "sfd_basic_skills_245_204bd3c7",
          "question": "What is the role of the member in charge of the poles during the initial stages of raising the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member in charge of the poles must hold the poles outward from the body when the ladder first lifts off the ground.",
          "options": {
            "A": "To push the ladder to the vertical position",
            "B": "To hold the poles outward from the body when the ladder first lifts off the ground",
            "C": "To foot the ladder and place their outside toe in front and against the bed side spurs",
            "D": "To step back off the ladder and place both hands on the beams at shoulder height"
          }
        },
        {
          "id": "sfd_basic_skills_245_f6de15aa",
          "question": "What is the correct position of the member on the butt when the ladder comes to a vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the ladder comes to a vertical position the member on the butt will step back off the ladder and place both hands on the beams at shoulder height and their feet are placed shoulder width apart.",
          "options": {
            "A": "Hands on the beams at shoulder height and feet are placed shoulder width apart",
            "B": "Step up onto the bottom rung, and grasp the halyard ropes in both hands",
            "C": "Foot the ladder, then place their outside toe in front and against the bed side spurs",
            "D": "Hold the poles outward from the body"
          }
        },
        {
          "id": "sfd_basic_skills_245_45d6eaab",
          "question": "When is the command 'FLY SIDE AROUND' given?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The command 'FLY SIDE AROUND' is given when the ladder is stable in the vertical position.",
          "options": {
            "A": "When the ladder first lifts off the ground",
            "B": "When the ladder is over the head of the members on the beam",
            "C": "When the ladder comes to a vertical position",
            "D": "When the ladder is stable in the vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_245_cb2155a9",
          "question": "What is the role of the member on the beams during the raising of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The members on the beams raise the ladder to the vertical position using a hand-over-hand motion with both hands on their respective beam.",
          "options": {
            "A": "To hold the poles outward from the body when the ladder first lifts off the ground",
            "B": "To foot the ladder, then place their outside toe in front and against the bed side spurs",
            "C": "To raise the ladder to the vertical position using a hand-over-hand motion",
            "D": "To step back off the ladder and place both hands on the beams at shoulder height"
          }
        },
        {
          "id": "sfd_basic_skills_245_8a42375d",
          "question": "What is the role of the member on the fly side of the ladder (#4)?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the fly side of the ladder (#4) will move to receive the left tormentor pole from the member in charge and will turn, walk out laterally to the pole position.",
          "options": {
            "A": "To hold the poles outward from the body when the ladder first lifts off the ground",
            "B": "To receive the left tormentor pole from the member in charge and move to the pole position",
            "C": "To raise the ladder to the vertical position using a hand-over-hand motion",
            "D": "To foot the ladder, then place their outside toe in front and against the bed side spurs"
          }
        },
        {
          "id": "sfd_basic_skills_212_810b565d",
          "question": "In the Seattle Fire Department's pole position, which hand is closest to your body?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the content, in the pole position, your right hand is IN closest to your body.",
          "options": {
            "A": "Left hand",
            "B": "Right hand",
            "C": "Both hands are equally close",
            "D": "Neither hand is close to your body"
          }
        },
        {
          "id": "sfd_basic_skills_212_b2dd402d",
          "question": "What does the left pole denote in the diagram?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The left pole denotes the Command Position according to Diagram #1.",
          "options": {
            "A": "Movement to Position",
            "B": "Pivoting of Ladder",
            "C": "Command Position",
            "D": "Spurs of Ladder"
          }
        },
        {
          "id": "sfd_basic_skills_212_c70b3b48",
          "question": "What is the significance of the right beam in the diagram?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The right beam is not mentioned in the content provided.",
          "options": {
            "A": "It indicates the direction of movement",
            "B": "It represents the command position",
            "C": "It signifies the pivoting of the ladder",
            "D": "The right beam is not mentioned in the content"
          }
        },
        {
          "id": "sfd_basic_skills_212_6f93ed16",
          "question": "What is the position of your arms in the Seattle Fire Department's pole position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the content, in the pole position, your arms are spread out.",
          "options": {
            "A": "Arms are crossed",
            "B": "Arms are behind your back",
            "C": "Arms are spread out",
            "D": "Arms are at your sides"
          }
        },
        {
          "id": "sfd_basic_skills_212_ffa5d27a",
          "question": "What is the significance of the 'spurs of ladder' in the diagram?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The 'spurs of ladder' is not mentioned in the content provided.",
          "options": {
            "A": "They indicate the direction of movement",
            "B": "They represent the command position",
            "C": "They signify the pivoting of the ladder",
            "D": "The 'spurs of ladder' is not mentioned in the content"
          }
        },
        {
          "id": "sfd_basic_skills_204_a2a07ec2",
          "question": "What is the correct position for a firefighter to take when lowering a ladder to the ground?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, the firefighter should stand on the bottom rung with both feet as the ladder leaves the vertical position.",
          "options": {
            "A": "Standing on the top rung of the ladder",
            "B": "Standing on the bottom rung with one foot",
            "C": "Standing on the bottom rung with both feet",
            "D": "Standing on the ground next to the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_204_482b49ec",
          "question": "How should a firefighter handle the halyard when lowering a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The firefighter should grasp all the ropes of the halyard in either hand when lowering the ladder.",
          "options": {
            "A": "Grasp all the ropes of the halyard in one hand",
            "B": "Grasp all the ropes of the halyard in both hands",
            "C": "Grasp one rope of the halyard in one hand",
            "D": "Do not touch the halyard"
          }
        },
        {
          "id": "sfd_basic_skills_204_ccfec61e",
          "question": "What should a firefighter use to maintain balance when lowering a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The firefighter should use the other hand to maintain balance when lowering the ladder.",
          "options": {
            "A": "The halyard",
            "B": "The other hand",
            "C": "The ladder",
            "D": "A nearby wall"
          }
        },
        {
          "id": "sfd_basic_skills_204_7cc35208",
          "question": "What is the role of body weight in the process of lowering a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The firefighter should allow the body weight to hang back when lowering the ladder.",
          "options": {
            "A": "It should be used to push the ladder down",
            "B": "It should be used to pull the ladder up",
            "C": "It should be allowed to hang back",
            "D": "It has no role in the process"
          }
        },
        {
          "id": "sfd_basic_skills_204_304ed5db",
          "question": "Where should the member be positioned when preparing to lower the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member should be at the butt, on the fly side when preparing to lower the ladder.",
          "options": {
            "A": "At the top of the ladder",
            "B": "At the butt, on the fly side",
            "C": "At the middle of the ladder",
            "D": "Away from the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_195_1e649401",
          "question": "What is the first step in removing the ladder from the apparatus?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in removing the ladder from the apparatus is to remove the locking devices which secure the ladder.",
          "options": {
            "A": "Identify the center of the ladder",
            "B": "Place the butt of the ladder on the ground",
            "C": "Remove the locking devices which secure the ladder",
            "D": "Grasp the upper beam of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_195_9fcfb4e7",
          "question": "In the High Shoulder Beam Carry method, where should the inside hand be placed for better stabilization and balance?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In the High Shoulder Beam Carry method, the inside hand should take hold of the lower beam to secure the ladder to the shoulder for better stabilization and balance.",
          "options": {
            "A": "On the upper beam",
            "B": "On the lower beam",
            "C": "On the rungs",
            "D": "On the halyard and cable"
          }
        },
        {
          "id": "sfd_basic_skills_195_33308bbd",
          "question": "When two members are carrying a ladder from the ground, where should they position themselves?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When two members are carrying a ladder from the ground, they should position themselves between the 2nd and 3rd rungs from the tip and the butt of the ladder.",
          "options": {
            "A": "At the tip and the butt of the ladder",
            "B": "Between the 2nd and 3rd rungs from the tip and the butt of the ladder",
            "C": "At the center of the ladder",
            "D": "On the upper and lower beams of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_195_a1336e10",
          "question": "What is the purpose of placing the inside arm through the rungs near the center of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Placing the inside arm through the rungs near the center of the ladder and grasping the upper beam of the ladder in front of the rung will rest against the arm to keep the ladder from twisting.",
          "options": {
            "A": "To lift the ladder",
            "B": "To secure the ladder to the shoulder",
            "C": "To keep the ladder from twisting",
            "D": "To balance the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_195_1ef3ddd0",
          "question": "When unlocking the ladder, what should you ensure about the halyard and cable?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When unlocking the ladder, you should ensure that the halyard and cable do not get hung up on the lock handles.",
          "options": {
            "A": "They are tightly secured",
            "B": "They do not get hung up on the lock handles",
            "C": "They are removed with the ladder",
            "D": "They are placed on the ground"
          }
        },
        {
          "id": "sfd_basic_skills_253_bcb4c22b",
          "question": "What is the correct position for the roof ladder when preparing to raise it?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The roof ladder should be placed on the ground with the beams straddling the same beam of the ground extension ladder that you expect to work off of. This ensures stability and safety during the operation.",
          "options": {
            "A": "On the ground with the beams straddling the same beam of the ground extension ladder",
            "B": "Leaning against the ground extension ladder",
            "C": "On the ground parallel to the ground extension ladder",
            "D": "On the ground perpendicular to the ground extension ladder"
          }
        },
        {
          "id": "sfd_basic_skills_253_9852e7f5",
          "question": "What should be done to ensure the roof ladder doesn't lift off the ground when raised to the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ground extension ladder must be properly placed and footed for climbing and perpendicular to the objective. This keeps the butt of the roof ladder from lifting off the ground when the ladder is raised to the vertical position.",
          "options": {
            "A": "The roof ladder should be tied to the ground extension ladder",
            "B": "The ground extension ladder must be properly placed and footed for climbing and perpendicular to the objective",
            "C": "The hooks of the roof ladder should be opened to the upward positions",
            "D": "The roof ladder should be placed at an angle to the ground extension ladder"
          }
        },
        {
          "id": "sfd_basic_skills_253_ed86bfbd",
          "question": "What is the correct position for the hooks on the roof ladder during operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The hooks on the roof ladder should be opened to the upward positions. This ensures that they are in the locked position, providing a secure grip on the roof.",
          "options": {
            "A": "Downward",
            "B": "Sideways",
            "C": "Upward",
            "D": "Closed"
          }
        },
        {
          "id": "sfd_basic_skills_253_0223c2ee",
          "question": "What is the first step in preparing a roof ladder for use?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in preparing a roof ladder for use is to carry it from the apparatus to the location at the base of the ground extension ladder. This is the starting point for the operation.",
          "options": {
            "A": "Open the hooks on the roof ladder",
            "B": "Carry the roof ladder from the apparatus to the base of the ground extension ladder",
            "C": "Raise the roof ladder to the vertical position",
            "D": "Place the roof ladder on the ground extension ladder"
          }
        },
        {
          "id": "sfd_basic_skills_253_cd845086",
          "question": "What is the purpose of opening the hooks on the roof ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The hooks on the roof ladder are opened to the upward positions to secure the ladder to the roof. This ensures a stable and safe platform for firefighters to work from.",
          "options": {
            "A": "To provide a grip on the ground",
            "B": "To secure the ladder to the roof",
            "C": "To connect the roof ladder to the ground extension ladder",
            "D": "To make the ladder easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_228_9eb84b85",
          "question": "What is the purpose of using wedging in ladder placement during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Wedging is a technique used to stabilize the butt of a ladder when the terrain at the spurs is uneven.",
          "options": {
            "A": "To increase the height of the ladder",
            "B": "To stabilize the butt of a ladder on uneven terrain",
            "C": "To make the ladder more visible in smoke",
            "D": "To prevent the ladder from catching fire"
          }
        },
        {
          "id": "sfd_basic_skills_228_4451997a",
          "question": "What can be used to even up the base of the ladder if the terrain is uneven?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Tarps, along with wooden wedges, can be used to even up the base of the ladder on uneven terrain.",
          "options": {
            "A": "Water",
            "B": "Tarps",
            "C": "Fire extinguisher",
            "D": "Hose"
          }
        },
        {
          "id": "sfd_basic_skills_228_8dd438b5",
          "question": "What should be done if a spur is not touching the ground after the ladder is placed into the climbing position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "If a spur is not touching the ground after the ladder is placed into the climbing position, it is steadied by placing the wedge or tarp between the spur and the ground making positive contact with both.",
          "options": {
            "A": "Remove the ladder and find a new location",
            "B": "Climb the ladder anyway",
            "C": "Place a wedge or tarp between the spur and the ground",
            "D": "Call for additional help"
          }
        },
        {
          "id": "sfd_basic_skills_228_9bc2372f",
          "question": "What is the primary material carried by all ladder companies to help stabilize ladders on uneven terrain?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "All ladder companies carry wooden wedges to help stabilize ladders on uneven terrain.",
          "options": {
            "A": "Metal plates",
            "B": "Rubber mats",
            "C": "Wooden wedges",
            "D": "Plastic blocks"
          }
        },
        {
          "id": "sfd_basic_skills_228_81063d55",
          "question": "How can a firefighter use the wooden wedges to stabilize the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A firefighter can use these wedges one at a time or two wedges opposing each other to stabilize the ladder.",
          "options": {
            "A": "One at a time or two wedges opposing each other",
            "B": "Only in pairs",
            "C": "Only one at a time",
            "D": "Three at a time"
          }
        },
        {
          "id": "sfd_basic_skills_249_8c54770c",
          "question": "Who is responsible for checking the overhead area for obstructions during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member in charge is responsible for checking the overhead area for obstructions during ladder operations.",
          "options": {
            "A": "The member at the butt of the ladder",
            "B": "The member on the fly side",
            "C": "The member in charge",
            "D": "All members"
          }
        },
        {
          "id": "sfd_basic_skills_249_53e13809",
          "question": "What is the role of the members on the bed side during the lowering of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The members on the bed side slowly walk backward while grasping the beam with a hand-over-hand motion until they are just short of the pole swivels during the lowering of the ladder.",
          "options": {
            "A": "They pass the poles to the member at the butt of the ladder",
            "B": "They walk backward while grasping the beam until they are just short of the pole swivels",
            "C": "They prepare to lift the ladder with a flat carry",
            "D": "They return the ladder tip first to the apparatus"
          }
        },
        {
          "id": "sfd_basic_skills_249_d6ef4d53",
          "question": "What is the next step after the command 'PASS THE POLES' is given?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "After the command 'PASS THE POLES' is given, the members on the beams swing the poles overhead and pass them to the member at the butt of the ladder.",
          "options": {
            "A": "The members prepare to lift the ladder with a flat carry",
            "B": "The members on the beams swing the poles overhead and pass them to the member at the butt of the ladder",
            "C": "The member in charge checks the overhead area for obstructions",
            "D": "The ladder is lifted to the shoulder in unison"
          }
        },
        {
          "id": "sfd_basic_skills_249_994c7955",
          "question": "What is the responsibility of all personnel during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "It is the responsibility of all personnel to be observant of the area where the poles are to be passed during ladder operations.",
          "options": {
            "A": "To check the overhead area for obstructions",
            "B": "To be observant of the area where the poles are to be passed",
            "C": "To pass the poles to the member at the butt of the ladder",
            "D": "To prepare to lift the ladder with a flat carry"
          }
        },
        {
          "id": "sfd_basic_skills_249_36702e87",
          "question": "What is the command given when the ladder is ready to be lifted?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The command 'LIFT' is given when the ladder is ready to be lifted.",
          "options": {
            "A": "PASS THE POLES",
            "B": "PREPARE TO LIFT",
            "C": "LIFT",
            "D": "STOW THE LADDER"
          }
        },
        {
          "id": "sfd_basic_skills_208_42f33697",
          "question": "What is the purpose of the firefighter's body weight during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The firefighter's body weight is used to prevent the base of the ladder from sliding out as they lower or pull the ladder.",
          "options": {
            "A": "To add extra weight to the ladder",
            "B": "To prevent the firefighter from falling",
            "C": "To prevent the base of the ladder from sliding",
            "D": "To help the firefighter climb the ladder faster"
          }
        },
        {
          "id": "sfd_basic_skills_208_bc765bbf",
          "question": "What is the correct foot position for a firefighter on the fly side of the ladder when the command 'INTO THE BUILDING' is given?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The firefighter should step back into a comfortable staggered foot position, allowing for good balance and stability. The feet should be placed approximately one to two feet back from each other, and about shoulder width apart.",
          "options": {
            "A": "Feet together and parallel",
            "B": "One foot forward, one foot back and shoulder width apart",
            "C": "Feet crossed and shoulder width apart",
            "D": "Both feet on the same rung of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_208_5d45565d",
          "question": "When the command 'OUT FROM THE BUILDING' is given, where should the firefighter on the bed side place their left foot?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the command 'OUT FROM THE BUILDING' is given, the member on the bed side places their left foot on the center of the bottom rung.",
          "options": {
            "A": "On the ground",
            "B": "On the center of the bottom rung",
            "C": "On the 4th rung from the spur",
            "D": "On the top rung of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_208_bb60418e",
          "question": "What should the firefighter on the fly side do when the command 'INTO THE BUILDING' is given?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When the command 'INTO THE BUILDING' is given, the firefighter on the fly side should bring the ladder into the objective in unison with the member(s) on the bed side.",
          "options": {
            "A": "Climb up the ladder",
            "B": "Bring the ladder into the objective in unison with the member(s) on the bed side",
            "C": "Pull the ladder out from the objective",
            "D": "Release the ladder and move away"
          }
        },
        {
          "id": "sfd_basic_skills_208_44906ca4",
          "question": "What should the firefighter on the bed side do to prevent the ladder from sliding when pulling it out from the objective?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The firefighter on the bed side should use the weight of their body to prevent the base of the ladder from sliding when pulling it out from the objective.",
          "options": {
            "A": "Push the ladder against the building",
            "B": "Tie the ladder to a secure object",
            "C": "Use the weight of their body",
            "D": "Ask another firefighter to hold the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_176_7d269afa",
          "question": "What is the primary use of fire service ladders according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The text states that the principal use of fire service ladders is for rescue work.",
          "options": {
            "A": "Ventilation",
            "B": "Access",
            "C": "Fire streams",
            "D": "Rescue"
          }
        },
        {
          "id": "sfd_basic_skills_176_02685114",
          "question": "Why is it crucial for firefighters to be able to ascend and descend ladders quickly and efficiently?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text emphasizes that the safety of citizens and members depends on the firefighter's ability to perform all operations quickly, using established and proper techniques.",
          "options": {
            "A": "To impress their colleagues",
            "B": "To ensure the safety of citizens and fellow members",
            "C": "To win firefighting competitions",
            "D": "To avoid getting tired"
          }
        },
        {
          "id": "sfd_basic_skills_176_c109fffe",
          "question": "In what situation might fire service ladders be used for bracing or shoring?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that ladders can be used as braces and as shoring in many applications, implying a variety of situations where additional support might be needed.",
          "options": {
            "A": "When the fire truck needs to be stabilized",
            "B": "When there are no other ladders available",
            "C": "In many applications where additional support is needed",
            "D": "When the ladder is not needed for rescue or access"
          }
        },
        {
          "id": "sfd_basic_skills_176_b7ee0028",
          "question": "How can ladders be used in salvage operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text states that ladders can be used to effect efficient salvage operations; forming catch-all basins, providing a means of attaching tarps, etc.",
          "options": {
            "A": "To break down doors",
            "B": "To form catch-all basins and provide a means of attaching tarps",
            "C": "To carry heavy equipment",
            "D": "To extinguish fires"
          }
        },
        {
          "id": "sfd_basic_skills_176_1a014c51",
          "question": "Why might firefighters need to provide their own means of ascent or descent to upper floors?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that stairways are ordinarily accessible, but sometimes they may be involved in fire or other hazards. In such cases, firefighters must provide their own means of ascent or descent.",
          "options": {
            "A": "Because the elevator is too slow",
            "B": "Because stairways may be involved in fire or other hazards",
            "C": "Because it's a standard firefighting procedure",
            "D": "Because the building's structure does not allow for other means of ascent"
          }
        },
        {
          "id": "sfd_basic_skills_199_8e811501",
          "question": "Where should the single member grasp the ladder when removing it from the rack?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The single member should grasp the beam in the center of the ladder when removing it from the rack.",
          "options": {
            "A": "At the top rung",
            "B": "At the bottom rung",
            "C": "In the center of the beam",
            "D": "Between the 2nd and 3rd rungs"
          }
        },
        {
          "id": "sfd_basic_skills_199_3e028206",
          "question": "What is the command given to raise the ladder from the rack?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command given to raise the ladder from the rack is 'TO THE SHOULDER'.",
          "options": {
            "A": "LIFT",
            "B": "TO THE SHOULDER",
            "C": "PREPARE TO LIFT",
            "D": "RAISE"
          }
        },
        {
          "id": "sfd_basic_skills_199_dbdde08c",
          "question": "Where does the member in charge position themselves when the ladder is on the ground?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member in charge positions themselves on the right beam when the ladder is on the ground.",
          "options": {
            "A": "On the left beam",
            "B": "On the right beam",
            "C": "At the top rung",
            "D": "At the bottom rung"
          }
        },
        {
          "id": "sfd_basic_skills_199_35783cdb",
          "question": "What is the command given to lift the ladder from the ground?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command given to lift the ladder from the ground is 'LIFT'.",
          "options": {
            "A": "LIFT",
            "B": "TO THE SHOULDER",
            "C": "PREPARE TO LIFT",
            "D": "RAISE"
          }
        },
        {
          "id": "sfd_basic_skills_199_80c5e397",
          "question": "What is the position of the team when preparing to lift the ladder from the ground?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The team gets into position and kneels facing the tip with their inside knee down when preparing to lift the ladder from the ground.",
          "options": {
            "A": "Standing facing the tip",
            "B": "Kneeling facing the tip with their inside knee down",
            "C": "Standing facing the butt end",
            "D": "Kneeling facing the butt end"
          }
        },
        {
          "id": "sfd_basic_skills_224_90115776",
          "question": "What is the recommended technique to avoid back injuries while adjusting the butt of a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text emphasizes the importance of using good lifting techniques to avoid back injuries while adjusting the ladder.",
          "options": {
            "A": "Using only one hand to lift",
            "B": "Lifting with the back, not the legs",
            "C": "Using good lifting technique",
            "D": "Lifting the ladder while it is not in a vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_224_98db38dd",
          "question": "When adjusting the butt of the ladder, where should one member grasp the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that one member should grasp the 1st or 2nd rung from the spur with one hand, and with the other hand grasp the 4th or 5th rung.",
          "options": {
            "A": "On the 3rd or 4th rung",
            "B": "On the 1st or 2nd rung and the 4th or 5th rung",
            "C": "On the topmost rung",
            "D": "On the spur"
          }
        },
        {
          "id": "sfd_basic_skills_224_07763281",
          "question": "What is the purpose of adjusting the butt of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Adjusting the butt of the ladder is done for climbing or lowering, as per the text.",
          "options": {
            "A": "To make the ladder shorter",
            "B": "To make the ladder longer",
            "C": "For climbing or lowering",
            "D": "To make the ladder lighter"
          }
        },
        {
          "id": "sfd_basic_skills_224_e4c4ca4a",
          "question": "When two members are adjusting the butt of the ladder, how should they coordinate their actions?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that when two members are adjusting the ladder, they should lift the butt of the ladder up off the ground together.",
          "options": {
            "A": "One member should lift while the other adjusts",
            "B": "Both members should lift at the same time",
            "C": "One member should adjust while the other supervises",
            "D": "Both members should adjust at the same time"
          }
        },
        {
          "id": "sfd_basic_skills_224_36284a04",
          "question": "What is the position of the ladder when adjusting the butt?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The operation of adjusting the butt of the ladder is performed while the ladder is in the vertical position.",
          "options": {
            "A": "Horizontal",
            "B": "Diagonal",
            "C": "Vertical",
            "D": "Inclined"
          }
        },
        {
          "id": "sfd_basic_skills_265_fa6a3055",
          "question": "Why is it important to add an extra six feet when measuring the distance from the bottom of the pit or well to your elevation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The extra six feet is added to ensure that the ladder extends over the wall once it is in its final climbing position.",
          "options": {
            "A": "To account for the height of the firefighter",
            "B": "To ensure the ladder extends over the wall once in its final climbing position",
            "C": "To allow for any inaccuracies in measurement",
            "D": "To ensure the ladder reaches the bottom of the pit or well"
          }
        },
        {
          "id": "sfd_basic_skills_265_2d17f1ba",
          "question": "What is the purpose of tying the rungs of the fly and bed section together in two places?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The rungs of the fly and bed section are tied together to secure the ladder for climbing when there is insufficient halyard.",
          "options": {
            "A": "To make the ladder longer",
            "B": "To secure the ladder for climbing when there is insufficient halyard",
            "C": "To prevent the ladder from sliding into the pit or well",
            "D": "To make the ladder more stable"
          }
        },
        {
          "id": "sfd_basic_skills_265_c1e87c2f",
          "question": "What is the role of the members positioned at the tip of the ladder during the operation?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The members positioned at the tip of the ladder are responsible for raising it to a vertical position.",
          "options": {
            "A": "To raise the ladder to a vertical position",
            "B": "To slide the ladder into the pit or well",
            "C": "To support the tip of the ladder while it is being climbed",
            "D": "To adjust the ladder to the proper climbing angle"
          }
        },
        {
          "id": "sfd_basic_skills_265_bde9c819",
          "question": "What is the purpose of the 'hoisting knot' at the butt of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'hoisting knot' at the butt of the ladder is used to allow the ladder to slide into the pit or well.",
          "options": {
            "A": "To secure the ladder for climbing",
            "B": "To allow the ladder to slide into the pit or well",
            "C": "To raise the ladder to a vertical position",
            "D": "To extend the length of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_265_b30f0ee3",
          "question": "After the ladder has reached the bottom of the pit or well, what is the next step?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once the ladder has reached the bottom, it is adjusted to the proper climbing angle and flipped so that the bed section is out and the fly in.",
          "options": {
            "A": "To raise the ladder to a vertical position",
            "B": "To adjust the ladder to the proper climbing angle and flip it so that the bed section is out and the fly in",
            "C": "To tie the rungs of the fly and bed section together",
            "D": "To extend the flies of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_232_a219ff3e",
          "question": "Who is responsible for heeling the ladder on the bed side for a beam raise?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, the member at the butt (#1) is responsible for heeling the ladder on the bed side for a beam raise.",
          "options": {
            "A": "The member at the tip (#2)",
            "B": "The member at the butt (#1)",
            "C": "The member on the fly side (#2)",
            "D": "The command officer"
          }
        },
        {
          "id": "sfd_basic_skills_232_600ef1f8",
          "question": "What is the role of the member on the fly side (#2) when the ladder reaches the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member on the fly side (#2) maintains the balance of the ladder in a vertical position by placing both hands on beams.",
          "options": {
            "A": "Pulls slightly to counteract the bed side weight",
            "B": "Raises the ladder by moving toward the butt",
            "C": "Maintains the balance of the ladder in a vertical position",
            "D": "Commands the raise"
          }
        },
        {
          "id": "sfd_basic_skills_232_18e4b8e4",
          "question": "How does the member at the tip (#2) raise the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the tip (#2) raises the ladder by moving toward the butt with a hand-over-hand motion on the beam.",
          "options": {
            "A": "By pulling slightly to counteract the bed side weight",
            "B": "By moving toward the butt with a hand-over-hand motion on the beam",
            "C": "By footing the ladder from the bed side",
            "D": "By commanding the raise"
          }
        },
        {
          "id": "sfd_basic_skills_232_cc852f43",
          "question": "What is the role of the bed-side member after the command 'RAISE'?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The bed-side member completes the raise by footing the ladder while the fly side member temporarily pulls slightly to counteract the bed side weight.",
          "options": {
            "A": "Heels the ladder on the bed side",
            "B": "Raises the ladder by moving toward the butt",
            "C": "Completes the raise by footing the ladder",
            "D": "Maintains the balance of the ladder in a vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_232_2b94d7b6",
          "question": "What is the objective of the right shoulder carry?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The objective of the right shoulder carry is to position the objective on the fly side of the ladder.",
          "options": {
            "A": "To counteract the bed side weight",
            "B": "To maintain the balance of the ladder in a vertical position",
            "C": "To move the ladder toward the butt",
            "D": "To position the objective on the fly side of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_233_318e9031",
          "question": "What is the purpose of the 'EXTEND THE FLY' command during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'EXTEND THE FLY' command is used to extend the ladder to the desired height.",
          "options": {
            "A": "To secure the tip of the ladder with a ladder anchor",
            "B": "To bring the ladder out from the building",
            "C": "To extend the ladder to the desired height",
            "D": "To check that the dogs are locked"
          }
        },
        {
          "id": "sfd_basic_skills_233_0f758b62",
          "question": "What is the role of the member on the fly side during the 'INTO THE BUILDING' command?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During the 'INTO THE BUILDING' command, the member on the fly side assists in lowering the ladder into the building.",
          "options": {
            "A": "To foot the ladder by placing a foot on the bottom rung",
            "B": "To assist in lowering the ladder into the building",
            "C": "To secure the halyard",
            "D": "To release the tip of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_233_da9f4fd7",
          "question": "What is the purpose of the 'SECURE THE TIP' command during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'SECURE THE TIP' command is used to secure the tip of the ladder with a ladder anchor.",
          "options": {
            "A": "To extend the ladder to the desired height",
            "B": "To secure the tip of the ladder with a ladder anchor",
            "C": "To check that the dogs are locked",
            "D": "To bring the ladder out from the building"
          }
        },
        {
          "id": "sfd_basic_skills_233_1aa4f651",
          "question": "What is the role of the member on the bed side during the 'OUT FROM THE BUILDING' command?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During the 'OUT FROM THE BUILDING' command, the member on the bed side is responsible for footing the ladder by placing a foot on the bottom rung.",
          "options": {
            "A": "To release the halyard",
            "B": "To assist in bringing the tip out from the building",
            "C": "To foot the ladder by placing a foot on the bottom rung",
            "D": "To extend the ladder to the desired height"
          }
        },
        {
          "id": "sfd_basic_skills_233_f08e935b",
          "question": "What is the purpose of the 'RELEASE THE TIP' command during ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'RELEASE THE TIP' command is used to release the tip of the ladder.",
          "options": {
            "A": "To secure the tip of the ladder with a ladder anchor",
            "B": "To release the tip of the ladder",
            "C": "To extend the ladder to the desired height",
            "D": "To check that the dogs are locked"
          }
        },
        {
          "id": "sfd_basic_skills_264_20cbe3de",
          "question": "What is the role of the members at the center of the beams during ladder deployment?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The members at the center of the beams begin to push the ladder over the edge of the rail or parapet during ladder deployment.",
          "options": {
            "A": "They ensure the ladder is at the proper climbing angle",
            "B": "They begin to push the ladder over the edge of the rail or parapet",
            "C": "They support the tip of the ladder while it is being climbed",
            "D": "They adjust the ladder so that the fly sections are 'in'"
          }
        },
        {
          "id": "sfd_basic_skills_264_9c01f876",
          "question": "What is the purpose of keeping tension on the rope while the ladder slides down?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Keeping tension on the rope while the ladder slides down helps to prevent the ladder from slamming into the wall/building.",
          "options": {
            "A": "To ensure the ladder reaches the bottom quickly",
            "B": "To prevent the ladder from slamming into the wall/building",
            "C": "To adjust the ladder to the proper climbing angle",
            "D": "To flip the ladder over so that the bed is out and the fly in"
          }
        },
        {
          "id": "sfd_basic_skills_264_77d4f525",
          "question": "What should be done once the ladder has reached the bottom?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once the ladder has reached the bottom, it should be adjusted to the proper climbing angle and flipped over so that the bed is out and the fly in.",
          "options": {
            "A": "The ladder should be pushed over the edge of the rail or parapet",
            "B": "The ladder should be adjusted to the proper climbing angle and flipped over so that the bed is out and the fly in",
            "C": "Tension should be kept on the rope",
            "D": "The ladder should be held in the vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_264_20057bc1",
          "question": "What is the role of the member who supports the tip of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member who supports the tip of the ladder does so to support the ladder while it is being climbed.",
          "options": {
            "A": "To push the ladder over the edge of the rail or parapet",
            "B": "To prevent the ladder from slamming into the wall/building",
            "C": "To support the ladder while it is being climbed",
            "D": "To adjust the ladder to the proper climbing angle"
          }
        },
        {
          "id": "sfd_basic_skills_264_622f3c54",
          "question": "What should be done with the fly sections of the ladder during adjustment for climbing?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "During adjustment for climbing, the fly sections of the ladder should be 'in'.",
          "options": {
            "A": "They should be flipped over",
            "B": "They should be pushed over the edge of the rail or parapet",
            "C": "They should be 'in'",
            "D": "They should be held in the vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_225_6c7dabbf",
          "question": "What is the recommended method for climbing a ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text indicates that when climbing a ground extension ladder, you should place your hands on the beams and slide them up.",
          "options": {
            "A": "Place your hands on the beams and slide them up",
            "B": "Use the trussed hand rail",
            "C": "Climb with your hands on the rungs",
            "D": "Climb with your hands on the beams, not on the rungs"
          }
        },
        {
          "id": "sfd_basic_skills_225_3d007d04",
          "question": "What is the importance of ensuring that ladder spurs are secure before climbing?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Securing ladder spurs is important to prevent the ladder from slipping, ensuring climber's safety.",
          "options": {
            "A": "To prevent the ladder from slipping",
            "B": "To ensure the ladder is at the correct angle",
            "C": "To ensure the ladder is parallel to the building",
            "D": "To ensure the ladder is resting firmly on the objective"
          }
        },
        {
          "id": "sfd_basic_skills_225_3ee79d9a",
          "question": "What is the recommended body posture while climbing a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text suggests that while climbing, the back should be near perpendicular with the ground and the climber's arms almost fully extended for optimal safety and efficiency.",
          "options": {
            "A": "The back should be near perpendicular with the ground and the climber's arms almost fully extended",
            "B": "The climber should lean forward with arms bent at the elbows",
            "C": "The climber should lean back with arms fully extended",
            "D": "The climber should be parallel to the ladder with arms bent at the elbows"
          }
        },
        {
          "id": "sfd_basic_skills_225_ff7b9538",
          "question": "How should the poles be set if the ladder is equipped with tormentor poles?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text indicates that if the ladder is equipped with tormentor poles, they should be set parallel to the building whenever possible.",
          "options": {
            "A": "They should be perpendicular to the building",
            "B": "They should be parallel to the building",
            "C": "They should be at a 45-degree angle to the building",
            "D": "They should be at a 70-degree angle to the building"
          }
        },
        {
          "id": "sfd_basic_skills_225_6554a247",
          "question": "What is the importance of securing the tip of the ladder with a ladder anchor or footing it at the butt?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Securing the tip of the ladder with a ladder anchor or footing it at the butt is important to prevent the ladder from slipping, ensuring climber's safety.",
          "options": {
            "A": "To ensure the ladder is at the correct angle",
            "B": "To prevent the ladder from bouncing and swaying",
            "C": "To ensure the ladder is parallel to the building",
            "D": "To prevent the ladder from slipping"
          }
        },
        {
          "id": "sfd_basic_skills_177_22d25a77",
          "question": "What is the primary purpose of the 'dogs' in the context of a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The 'dogs' are mechanisms that keep the fly(s) from retracting once they are properly set on the desired rung.",
          "options": {
            "A": "To extend the fly sections",
            "B": "To anchor the end of the cable to the fly section",
            "C": "To secure the tip of a ladder to its objective",
            "D": "To prevent the fly sections from retracting once they are properly set"
          }
        },
        {
          "id": "sfd_basic_skills_177_7f9fb9c7",
          "question": "What is the function of the 'beam' in a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'beam' is the principle structural member of the ladder where the rungs are secured.",
          "options": {
            "A": "It is used to extend or retract the fly",
            "B": "It is the principle structural member where the rungs are secured",
            "C": "It is used to anchor the halyard line to the fly section",
            "D": "It is the bottom end of the ladder opposite the tip"
          }
        },
        {
          "id": "sfd_basic_skills_177_df4a1c4a",
          "question": "What is the role of the 'halyard' in the context of a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'halyard' is the rope used to extend or retract the fly.",
          "options": {
            "A": "It is used to anchor the end of the cable to the fly section",
            "B": "It is the rope used to extend or retract the fly",
            "C": "It is the mechanism that keeps the fly(s) from retracting once they are properly set",
            "D": "It is the bottom end of the ladder opposite the tip"
          }
        },
        {
          "id": "sfd_basic_skills_177_b1fce63d",
          "question": "What is the function of the 'cable' in a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'cable' is used in multiple-fly extension ladders to extend fly sections.",
          "options": {
            "A": "It is used in multiple-fly extension ladders to extend fly sections",
            "B": "It is the principle structural member where the rungs are secured",
            "C": "It is the rope used to extend or retract the fly",
            "D": "It is the bottom end of the ladder opposite the tip"
          }
        },
        {
          "id": "sfd_basic_skills_177_1f2c8c04",
          "question": "What is the purpose of the 'ladder anchor'?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'ladder anchor' is a metal hook and rope device used to secure the tip of a ladder to its objective to prevent tipping.",
          "options": {
            "A": "To secure the tip of a ladder to its objective to prevent tipping",
            "B": "To extend the fly sections",
            "C": "To anchor the end of the cable to the fly section",
            "D": "To prevent the fly sections from retracting once they are properly set"
          }
        },
        {
          "id": "sfd_basic_skills_198_7e736dec",
          "question": "In a three-member team handling a ground extension ladder, where does the member in charge position themselves?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The member in charge will be in the center on the right beam or at the right butt position.",
          "options": {
            "A": "At the left butt position",
            "B": "At the center on the left beam",
            "C": "At the center on the right beam",
            "D": "At the top of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_198_2c08fafc",
          "question": "When removing the ladder from the apparatus, what is the role of the member on the side of the ladder with two members?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the side of the ladder with two members will continue out with the butt of the ladder.",
          "options": {
            "A": "They will push the ladder back into the rack",
            "B": "They will continue out with the butt of the ladder",
            "C": "They will hold the ladder in place",
            "D": "They will climb up the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_198_0b48f4f8",
          "question": "What is the 'PRE PARE TO LIFT' command used for in the context of ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'PRE PARE TO LIFT' command is used to prepare for a cradle carry.",
          "options": {
            "A": "To signal the start of ladder ascent",
            "B": "To signal the need for additional help",
            "C": "To prepare for a cradle carry",
            "D": "To signal the end of ladder operations"
          }
        },
        {
          "id": "sfd_basic_skills_198_bc32e32b",
          "question": "How many members are needed to handle a 35' or less ground extension ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Three members are needed to handle a 35' or less ground extension ladder.",
          "options": {
            "A": "One",
            "B": "Two",
            "C": "Three",
            "D": "Four"
          }
        },
        {
          "id": "sfd_basic_skills_198_b267db59",
          "question": "What is the first step when removing the ladder from the apparatus?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The first step when removing the ladder from the apparatus is that two of the members grasp the ladder and begin to pull it from the ladder rack.",
          "options": {
            "A": "Two of the members grasp the ladder and begin to pull it from the ladder rack",
            "B": "The member in charge gives the 'PRE PARE TO LIFT' command",
            "C": "All members position themselves at the butt of the ladder",
            "D": "The ladder is pushed back into the rack"
          }
        },
        {
          "id": "sfd_basic_skills_209_f9f47808",
          "question": "What is the purpose of a member placing their inside foot on the bottom rung of the ladder when the command 'OUT FROM THE BUILDING' is given?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member places their inside foot on the bottom rung of the ladder to use the weight of their body to prevent the base of the ladder from sliding.",
          "options": {
            "A": "To maintain balance while climbing the ladder",
            "B": "To prevent the base of the ladder from sliding",
            "C": "To signal to other members that they are ready to ascend",
            "D": "To test the stability of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_209_000067f0",
          "question": "What is the role of the member on the fly side during the movement 'OUT FROM THE BUILDING'?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the fly side assists the movement 'OUT FROM THE BUILDING' with their hands on the beams.",
          "options": {
            "A": "To push the ladder away from the building",
            "B": "To assist the movement with their hands on the beams",
            "C": "To hold the ladder in place while others descend",
            "D": "To signal to other members when the ladder is in a vertical position"
          }
        },
        {
          "id": "sfd_basic_skills_209_87015f01",
          "question": "What is meant by the term 'pivoting' in the context of ladder operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Pivoting is defined as the turning of the ladder in the appropriate direction on a designated spur while it is in the vertical position.",
          "options": {
            "A": "Lifting the ladder to a vertical position",
            "B": "Turning the ladder in the appropriate direction on a designated spur while it is in the vertical position",
            "C": "Moving the ladder away from the building",
            "D": "Adjusting the angle of the ladder for better access"
          }
        },
        {
          "id": "sfd_basic_skills_209_8be11530",
          "question": "When the command 'OUT FROM THE BUILDING' is given, what is the initial position of the member on the fly side of the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When the command 'OUT FROM THE BUILDING' is given, the member on the fly side of the ladder will have both hands grasping the outside of each beam of the bed section.",
          "options": {
            "A": "Both hands grasping the outside of each beam of the bed section",
            "B": "One hand on the beam, the other on the rung",
            "C": "Both hands on the top rung of the ladder",
            "D": "One hand on the beam, the other signaling to other members"
          }
        },
        {
          "id": "sfd_basic_skills_209_a5190629",
          "question": "How is the designated beam for pivoting identified to members on the fly side?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To help avoid confusion for members on the fly side, member(s) on the bed side will slap the beam that is designated for the pivot.",
          "options": {
            "A": "By shouting the command 'PIVOT'",
            "B": "By slapping the beam that is designated for the pivot",
            "C": "By pointing to the beam that is designated for the pivot",
            "D": "By marking the beam that is designated for the pivot with chalk"
          }
        },
        {
          "id": "sfd_basic_skills_248_638dcab8",
          "question": "Who is responsible for securing the tip of the ladder with a ladder anchor?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the text, the member at the left butt when lowering in will secure the tip with a ladder anchor.",
          "options": {
            "A": "The member at the right butt",
            "B": "The member at the left butt",
            "C": "The member on the right beam bed side",
            "D": "The member on the left pole"
          }
        },
        {
          "id": "sfd_basic_skills_248_54509759",
          "question": "What is the responsibility of the member on the right beam bed side during the operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the right beam bed side is responsible for releasing the halyard and lowering the fly.",
          "options": {
            "A": "To secure the tip with a ladder anchor",
            "B": "To release the halyard and lower the fly",
            "C": "To foot the ladder and assist the pole members",
            "D": "To check for obstructions and state 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.'"
          }
        },
        {
          "id": "sfd_basic_skills_248_3097cf2e",
          "question": "What is the role of the member in charge (#1) on the poles during the operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The member in charge (#1) on the poles is responsible for checking the direction in which the ladder will be lowered for obstructions and stating 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.'",
          "options": {
            "A": "To secure the tip with a ladder anchor",
            "B": "To release the halyard and lower the fly",
            "C": "To foot the ladder and assist the pole members",
            "D": "To check for obstructions and state 'OVERHEAD CLEAR, CLEAR BEHIND, LADDER COMING DOWN.'"
          }
        },
        {
          "id": "sfd_basic_skills_248_b4d2f84b",
          "question": "What is the command given when the poles are moved from the butt to a position parallel to the objective?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The command 'SET THE POLES' is given when the poles are moved from the butt to a position parallel to the objective.",
          "options": {
            "A": "SET THE POLES",
            "B": "SECURE THE TIP",
            "C": "RELEASE THE TIP",
            "D": "OUT WITH THE POLES"
          }
        },
        {
          "id": "sfd_basic_skills_248_b8232da8",
          "question": "Who is responsible for surveying the area where the ladder will be lowered?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "It is the responsibility of all personnel to survey the area where the ladder will be lowered.",
          "options": {
            "A": "Only the member in charge (#1) on the poles",
            "B": "Only the member on the right beam bed side",
            "C": "Only the member at the left butt",
            "D": "All personnel"
          }
        },
        {
          "id": "sfd_basic_skills_229_cee07079",
          "question": "What are the three different ladder raises used by the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the content, the Seattle Fire Department uses three different ladder raises: Cradle raise, Beam raise, and Flat raise.",
          "options": {
            "A": "Cradle raise, Beam raise, Flat raise",
            "B": "Cradle raise, Beam raise, High raise",
            "C": "Cradle raise, Flat raise, High raise",
            "D": "Beam raise, Flat raise, High raise"
          }
        },
        {
          "id": "sfd_basic_skills_229_c22af358",
          "question": "Why is it important to watch the tip of the ladder during operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The content mentions several reasons for watching the tip of a ladder, including to watch for falling material, to determine if the ladder is tipping, and to watch for overhead obstructions.",
          "options": {
            "A": "To watch for falling material from the objective",
            "B": "To determine if the ladder is tipping, leaning or beginning to fall",
            "C": "To consistently watch for overhead obstructions",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_229_429c2f43",
          "question": "In what position should the ladder be raised if possible?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The content specifies that the ladder should be raised perpendicular to the building if possible.",
          "options": {
            "A": "Parallel to the building",
            "B": "At a 45-degree angle to the building",
            "C": "Perpendicular to the building",
            "D": "At a 30-degree angle to the building"
          }
        },
        {
          "id": "sfd_basic_skills_229_004de727",
          "question": "During a Beam Raise, where should the bottom spur of the ladder be placed?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "During a Beam Raise, the member places the bottom spur of the ladder on the ground.",
          "options": {
            "A": "Against the building",
            "B": "On the ground",
            "C": "On the roof",
            "D": "On the fire truck"
          }
        },
        {
          "id": "sfd_basic_skills_229_fb8bd778",
          "question": "On flat raises, how are the ladders positioned?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "On flat raises, ladders are placed so that when raised to a vertical position, the fly side of the ladder is toward the building.",
          "options": {
            "A": "The fly side of the ladder is away from the building",
            "B": "The fly side of the ladder is toward the building",
            "C": "The ladder is positioned horizontally",
            "D": "The ladder is positioned diagonally"
          }
        },
        {
          "id": "sfd_basic_skills_252_cd1b2a93",
          "question": "Who is responsible for checking the overhead area for obstructions when positioning the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member in charge, who is on the right beam, is responsible for checking the overhead area for obstructions.",
          "options": {
            "A": "The member on the left beam",
            "B": "The member on the right beam",
            "C": "All personnel present",
            "D": "The member at the butt of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_252_44d4f7ce",
          "question": "What is the correct command to give before placing the ladder on the ground?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The correct command to give before placing the ladder on the ground is 'LOWER THE LADDER'.",
          "options": {
            "A": "PREPARE TO RAISE",
            "B": "OVERHEAD CLEAR",
            "C": "READY HALT",
            "D": "LOWER THE LADDER"
          }
        },
        {
          "id": "sfd_basic_skills_252_42512855",
          "question": "What is the role of the member at the butt of the ladder during the ladder raise?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member at the butt of the ladder has the responsibility to foot the ladder during the ladder raise.",
          "options": {
            "A": "To check for overhead obstructions",
            "B": "To foot the ladder",
            "C": "To lift the ladder",
            "D": "To command the raise"
          }
        },
        {
          "id": "sfd_basic_skills_252_5eb997f2",
          "question": "What is the correct response after checking for overhead wires and obstructions?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The correct response after checking for overhead wires and obstructions is 'OVERHEAD CLEAR'.",
          "options": {
            "A": "READY HALT",
            "B": "LOWER THE LADDER",
            "C": "OVERHEAD CLEAR",
            "D": "PREPARE TO RAISE"
          }
        },
        {
          "id": "sfd_basic_skills_252_9c81ef80",
          "question": "What is the correct position of the ladder when placed on the ground before raising?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The correct position of the ladder when placed on the ground before raising is with the fly side up.",
          "options": {
            "A": "Fly side down",
            "B": "Fly side up",
            "C": "On its side",
            "D": "Upright"
          }
        },
        {
          "id": "sfd_basic_skills_194_99077b27",
          "question": "What is the first step in performing a Low Shoulder Beam Carry with a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The first step in performing a Low Shoulder Beam Carry with a ladder is to unlock the ladders.",
          "options": {
            "A": "Rotate the ladder so the bed section is towards you",
            "B": "Unlock the ladders",
            "C": "Set the butt end on the ground",
            "D": "Grasp the closest beam with your inside hand"
          }
        },
        {
          "id": "sfd_basic_skills_194_4acd7574",
          "question": "Where should you stand when performing a Low Shoulder Beam Carry with a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When performing a Low Shoulder Beam Carry with a ladder, you should stand at the center of the ladder.",
          "options": {
            "A": "At the butt end of the ladder",
            "B": "At the top of the ladder",
            "C": "At the center of the ladder",
            "D": "At the side of the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_194_0fd6fc94",
          "question": "What is the maximum length of a ladder that can be carried by one member of the Engine team?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "One member of the Engine team can carry a ladder of up to 26' in length.",
          "options": {
            "A": "26'",
            "B": "28'",
            "C": "30'",
            "D": "32'"
          }
        },
        {
          "id": "sfd_basic_skills_194_60e42105",
          "question": "What is the difference between the Low Shoulder Beam Carry and the High Shoulder Beam Carry?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The difference between the Low Shoulder Beam Carry and the High Shoulder Beam Carry is the position of the ladder.",
          "options": {
            "A": "The position of the ladder",
            "B": "The length of the ladder",
            "C": "The number of firefighters required",
            "D": "The type of truck used"
          }
        },
        {
          "id": "sfd_basic_skills_194_7d9816e7",
          "question": "What should you do with your inside hand when performing a Low Shoulder Beam Carry?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "When performing a Low Shoulder Beam Carry, you should grasp the closest beam with your inside hand.",
          "options": {
            "A": "Grasp the closest beam",
            "B": "Hold the top of the ladder",
            "C": "Support the butt end of the ladder",
            "D": "Unlock the ladders"
          }
        },
        {
          "id": "sfd_basic_skills_205_d0b70bd5",
          "question": "What is the first step a firefighter should take before raising a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Before raising a ladder, a firefighter should first check the direction in which the ladder will be raised for obstructions and personnel.",
          "options": {
            "A": "Place the appropriate foot on the spur of the beam",
            "B": "Grasp the bed side beam with the outside hand",
            "C": "Check the direction in which the ladder will be raised for obstructions and personnel",
            "D": "Sit in a 'PREPARE TO RAISE' position"
          }
        },
        {
          "id": "sfd_basic_skills_205_12df2235",
          "question": "What is the correct foot placement when raising a ladder on the right beam?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "When raising a ladder on the right beam, the right foot is used for footing.",
          "options": {
            "A": "The left foot is used for footing",
            "B": "The right foot is used for footing",
            "C": "Both feet are used for footing",
            "D": "Foot placement is not important"
          }
        },
        {
          "id": "sfd_basic_skills_205_f9a39d91",
          "question": "What safety measure should be taken to prevent injury when lowering a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "To prevent injury, at no time should the groin, rear leg, or knee be in line with the spur of the ladder.",
          "options": {
            "A": "Ensure the groin, rear leg, or knee are in line with the spur of the ladder",
            "B": "Place both feet one foot out away from the ladder",
            "C": "Ensure the groin, rear leg, or knee are not in line with the spur of the ladder",
            "D": "Place the hands on the same beam"
          }
        },
        {
          "id": "sfd_basic_skills_205_b3caae7f",
          "question": "What is the correct hand placement when lowering a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When lowering a ladder, one hand is placed on the bed section beam at shoulder height; the other hand is placed on the beam of the fly section below the other.",
          "options": {
            "A": "Both hands are placed on the same beam",
            "B": "The hands are placed on the opposite beam designated",
            "C": "One hand is placed on the bed section beam at shoulder height; the other hand is placed on the beam of the fly section below the other",
            "D": "Hand placement is not important"
          }
        },
        {
          "id": "sfd_basic_skills_205_0cb47f1b",
          "question": "What should a firefighter state before lowering a ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Before lowering a ladder, a firefighter should state 'Overhead clear, clear behind, ladder coming down.'",
          "options": {
            "A": "'Overhead clear, clear behind, ladder going up'",
            "B": "'Overhead clear, clear behind, ladder coming down'",
            "C": "'Prepare to lower'",
            "D": "'Clear to lower'"
          }
        },
        {
          "id": "sfd_basic_skills_213_65e2fcc2",
          "question": "What is the purpose of the command 'On the right beam, pivot out' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The command 'On the right beam, pivot out' is given to instruct the member on the right pole to move to the other side of the pole without walking backward.",
          "options": {
            "A": "To instruct the member to let go of the pole",
            "B": "To instruct the member on the right pole to move to the other side of the pole",
            "C": "To instruct the member on the left pole to move to the other side of the pole",
            "D": "To instruct the member to climb the pole"
          }
        },
        {
          "id": "sfd_basic_skills_213_134e281b",
          "question": "What does the member do after the pole is 2 feet past being in line with both beams?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "After the pole is 2 feet past being in line with both beams, the member moves to the other side of the pole while still holding onto it so that both pole members are again facing each other.",
          "options": {
            "A": "The member lets go of the pole",
            "B": "The member climbs the pole",
            "C": "The member moves to the other side of the pole while still holding onto it",
            "D": "The member stands still"
          }
        },
        {
          "id": "sfd_basic_skills_213_e86d015f",
          "question": "Why is it important for the member to move to the other side of the pole without walking backward?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Moving to the other side of the pole without walking backward allows the member to maintain balance and control of the pole, which is crucial for safety and operational efficiency.",
          "options": {
            "A": "To maintain balance and control of the pole",
            "B": "To avoid tripping over the pole",
            "C": "To keep the pole in line with the beams",
            "D": "To ensure the pole does not fall"
          }
        },
        {
          "id": "sfd_basic_skills_213_56f3edbc",
          "question": "What is the significance of the member's hand position in relation to the pivot commands?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member's hand position (in or out) indicates the direction of the pivot in response to the given command.",
          "options": {
            "A": "The hand position determines which pole the member is on",
            "B": "The hand position indicates the direction of the pivot",
            "C": "The hand position has no significance",
            "D": "The hand position signals the end of the pivot"
          }
        },
        {
          "id": "sfd_basic_skills_213_8ab5b632",
          "question": "What is the ultimate goal of the pivot commands during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The pivot commands aim to ensure the pole is in line with the beams, the members are facing each other, and the pole is moved without the members walking backward, all of which contribute to safety and operational efficiency.",
          "options": {
            "A": "To ensure the pole is in line with the beams",
            "B": "To ensure the members are facing each other",
            "C": "To ensure the pole is moved without the members walking backward",
            "D": "All of the above"
          }
        },
        {
          "id": "sfd_basic_skills_244_a35c45de",
          "question": "Who is responsible for checking the overhead area for obstructions before raising the poles?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The member in charge (#1) is responsible for checking the overhead area for obstructions before raising the poles.",
          "options": {
            "A": "The member on the butt (#4)",
            "B": "The members on the beams (#2 and #3)",
            "C": "All personnel",
            "D": "The member in charge (#1)"
          }
        },
        {
          "id": "sfd_basic_skills_244_e8af232a",
          "question": "What is the role of the member on the butt (#4) in the pole raising process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The member on the butt (#4) is responsible for releasing the poles and passing them to the members on the beams.",
          "options": {
            "A": "Checking the overhead area for obstructions",
            "B": "Releasing the poles and passing them to the members on the beams",
            "C": "Grasping a pole in each hand",
            "D": "Surveying the area where the poles are to be passed"
          }
        },
        {
          "id": "sfd_basic_skills_244_ff6c79f0",
          "question": "What is the correct position for the member in charge (#1) when preparing to receive the spikes of the poles?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The member in charge (#1) should stand between the poles with arms on the outside of the poles when preparing to receive the spikes.",
          "options": {
            "A": "Standing between the poles with arms on the outside of the poles",
            "B": "Standing on the side of the poles with arms on the inside of the poles",
            "C": "Standing on the butt of the poles with arms on the outside of the poles",
            "D": "Standing on the tip of the ladder with arms on the inside of the poles"
          }
        },
        {
          "id": "sfd_basic_skills_244_57e8e3cb",
          "question": "What is an alternative way for the member in charge (#1) to hold the poles?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "An alternative way for the member in charge (#1) to hold the poles is with the spikes between the middle and ring fingers.",
          "options": {
            "A": "With the spikes between the index and middle fingers",
            "B": "With the spikes between the middle and ring fingers",
            "C": "With the spikes between the ring and little fingers",
            "D": "With the spikes between the thumb and index fingers"
          }
        },
        {
          "id": "sfd_basic_skills_244_43dbaf14",
          "question": "Who is responsible for passing the poles to the member in charge?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The members on the beams (#2 and #3) are responsible for passing the poles to the member in charge.",
          "options": {
            "A": "The member on the butt (#4)",
            "B": "The members on the beams (#2 and #3)",
            "C": "All personnel",
            "D": "The member in charge (#1)"
          }
        },
        {
          "id": "sfd_basic_skills_182_cfb47a9d",
          "question": "What should you do before adjusting the butt of an extended ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Before adjusting the butt of an extended ladder, it is important to ensure the tip is against the building and the fly is properly secured with the halyard or body loop.",
          "options": {
            "A": "Make sure the ladder is locked in",
            "B": "Ensure the tip is against the building and the fly is properly secured",
            "C": "Check overhead for wires or obstructions",
            "D": "Walk backwards while carrying the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_182_2bd5d44f",
          "question": "What is one thing you should never do with an aerial ladder?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the safety precautions, you should never lock in on an aerial ladder.",
          "options": {
            "A": "Use it to reach high places",
            "B": "Lock in on it",
            "C": "Check it for safety",
            "D": "Use it in firefighting operations"
          }
        },
        {
          "id": "sfd_basic_skills_182_8048920a",
          "question": "What is a safety measure to take when manipulating ladders?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Using approved safety gear is a crucial safety measure when manipulating ladders.",
          "options": {
            "A": "Avoid wearing gloves",
            "B": "Walk backwards while carrying ladders",
            "C": "Use approved safety gear",
            "D": "Step over ladders lying on the ground"
          }
        },
        {
          "id": "sfd_basic_skills_182_ebc8a69e",
          "question": "What should you always watch when the ladder is in the vertical position?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "When the ladder is in the vertical position, it is important to always watch the tip of the ladder.",
          "options": {
            "A": "The base of the ladder",
            "B": "The middle of the ladder",
            "C": "The tip of the ladder",
            "D": "The ladder's surroundings"
          }
        },
        {
          "id": "sfd_basic_skills_182_76d819fc",
          "question": "What should you do if there are ladders lying on the ground?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "For safety reasons, if there are ladders lying on the ground, you should walk around them instead of stepping over them.",
          "options": {
            "A": "Step over them",
            "B": "Walk around them",
            "C": "Pick them up",
            "D": "Ignore them"
          }
        }
      ]
    },
    "6": {
      "chapter_id": "6",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_284_183de6ec",
          "question": "The Square Bend knot is primarily used for life safety situations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Used primarily for non -life safety situations.' This means that the Square Bend knot is not typically used in situations where life safety is a concern. In firefighting, understanding the appropriate use of different knots is crucial for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_284_6cd1ebdd",
          "question": "The Overhand Follow-Through Bend is used to tie two webbing ends together to form a 'runner'.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Overhand Follow-Through Bend Used to tie two webbing ends together to form a \u201crunner,\u201d tie a multipoint anchor together, etc.' This confirms that the Overhand Follow-Through Bend is used for this purpose. In firefighting, this could be used to secure equipment or create anchors.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_284_4677416e",
          "question": "When using Tubular webbing, it is not necessary to leave any tail.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tubular webbing is slippery so leave a hand width, or two inches of tail as a minimum.' This contradicts the statement that it is not necessary to leave any tail. In firefighting, leaving a tail is important to ensure the knot's security and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_284_68b927f7",
          "question": "Dressing and setting the bend is not important when using slippery material like Tubular webbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Also, because of the slippery material, dressing and setting this bend is very important.' This contradicts the statement that dressing and setting the bend is not important. In firefighting, properly dressing and setting knots can prevent failure under load and ensure safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_284_6c67af5e",
          "question": "The Square Bend knot is used to tie two strands together.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'this bend is used to tie two strands together.' This confirms that the Square Bend knot is used for this purpose. In firefighting, this knot could be useful in situations where two ropes need to be joined, such as extending a line.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_288_2aecad5a",
          "question": "The Seattle Fire Department uses the Square Bend knot in their operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Square Bend' in the context of the Seattle Fire Department. This indicates that they use this type of knot in their operations. The ability to tie and use different types of knots is crucial in firefighting for securing equipment, creating anchor points, and rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_288_6924ae34",
          "question": "The Double Overhand Bend is not used by the Seattle Fire Department.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Double Overhand Bend'. This indicates that the Seattle Fire Department does use this type of knot. Knowing how to tie different knots is essential for firefighters as it can affect the safety and efficiency of their operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_288_1f8b9c26",
          "question": "The Double Becket is a type of knot used in firefighting operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Double Becket'. This indicates that it is a type of knot used in firefighting operations. Different knots have different uses and knowing when to use each one can greatly affect the outcome of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_288_f02aa355",
          "question": "The Overhand Follow-Through Bend is not a knot used in firefighting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Overhand Follow-Through Bend'. This indicates that it is indeed a type of knot used in firefighting. Knots are essential in firefighting for various tasks such as securing equipment and rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_288_fe1d1096",
          "question": "Rope is not an important tool in firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Rope' in Chapter 6. This indicates that rope is an important tool in firefighting operations. Rope is used in various ways in firefighting, including securing areas, rescue operations, and providing a means of escape.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_271_1f9dd54f",
          "question": "Static ropes are called so because they do not move.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Static means non-moving. There is no such thing as a static rope system, for example, even steel is not considered to be static.' This contradicts the statement that static ropes are so-called because they do not move. In firefighting scenarios, understanding the properties of the ropes used in rescue operations is crucial for safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_271_b50ee894",
          "question": "High stretch or 'dynamic' ropes have a relatively high stretch ratio due to a spiral constructed core bundle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'High stretch or \u201cdynamic\u201d ropes have a relatively high stretch ratio, (usually between 20 and 50 percent till failure) due to a spiral constructed core bundle.' This supports the statement in the question. In firefighting, knowing the characteristics of the ropes used can influence decisions on their appropriate usage during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_271_b2a6f68c",
          "question": "It is safe to leave a rope under tension for an extended period of time.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Do not leave a rope under tension for any extended period of time unless necessary.' This contradicts the statement in the question. In firefighting, leaving a rope under tension for an extended period could lead to rope failure, endangering lives during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_271_19ca07ee",
          "question": "Ropes should be dried before bagging.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Dry wet rope (hang dry) before bagging.' This supports the statement in the question. In firefighting, proper maintenance of equipment, including ropes, is essential for safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_271_9e06ee86",
          "question": "Exposure to the sun\u2019s ultraviolet radiation has no effect on the rope.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Exposure to the sun\u2019s ultraviolet radiation will damage the rope, keep exposure to a minimum.' This contradicts the statement in the question. In firefighting, understanding the factors that can damage equipment is important for maintaining operational readiness and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_270_f2978409",
          "question": "In the Fire Service, knowing a greater number of knots is more important than being able to tie a few standard knots automatically under stress.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Keep in mind that it is more important to be able to tie these standard knots automatically, while under the stress of an emergency, than to know a greater number of knots and yet have failed to acquire skill in their use.' This implies that in a firefighting scenario, it is crucial to be able to quickly and accurately tie a few standard knots, as this can be a life-saving skill during emergencies.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_270_126e88d0",
          "question": "Ropes and knots in the Fire Service are used only for securing equipment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Ropes and knots are used daily in securing equipment, fire suppression, rescue work, and emergency medical applications.' This shows that ropes and knots have multiple uses in firefighting, not just for securing equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_270_d9d1871c",
          "question": "The Seattle Fire Department separates the use of ropes into two categories: Utility and Life Safety.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The Seattle Fire Department separates the use of ropes into two categories: Utility and Life Safety.' This indicates that the department has specific classifications for ropes based on their intended use, which is important for safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_270_4a6075eb",
          "question": "Life Safety rope is defined as any rope used to support the weight of members or other persons during rescue, fire fighting, other emergency operations, or during training evolutions.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Life Safety rope is defined as any rope used to support the weight of members or other persons during rescue, fire fighting, other emergency operations, or during training evolutions.' This definition highlights the critical role of Life Safety ropes in various firefighting and rescue scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_270_2ae57d5d",
          "question": "All ropes used by the Seattle Fire Department are made of nylon.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The ropes used on operation companies range in size from 1/4\u201d woven cotton tie ropes to \u00bd\u201d kernmantle nylon life safety rescue ropes.' This shows that the department uses a variety of ropes made from different materials, not just nylon.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_285_ebdce914",
          "question": "The Double Overhand Bend is primarily used to tie two ropes together in the fire service.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"This bend is used to tie two ropes together. For the fire service, it is primarily for prusik loops.\" This statement supports the question by confirming that the Double Overhand Bend is primarily used to tie two ropes together in the fire service. This is important for firefighters to understand as it can affect how they use their equipment during operations, particularly when needing to extend the length of a rope.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_285_4a799fb1",
          "question": "The Double Overhand Bend can be easily untied once loaded.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"Because of the tight arcs within the bend, it is very difficult to untie once loaded.\" This statement contradicts the question by stating that the Double Overhand Bend is very difficult to untie once loaded. This is a crucial consideration for firefighters as it can affect rescue operations, particularly when time is of the essence.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_285_e7f3bc2e",
          "question": "The Double Becket Bend is suitable for joining two unequal sized diameter material together.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Double Becket Bend Used for joining two unequal sized diameter material together.\" This statement supports the question by confirming that the Double Becket Bend is used for joining two unequal sized diameter materials together. This is important for firefighters to understand as it can affect how they use their equipment during operations, particularly when needing to join ropes of different diameters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_285_f6c6d177",
          "question": "The Double Becket Bend is difficult to inspect after weighting with a rescue load.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "\"It is easy to tie, inspect, and untie after weighting with a rescue load.\" This statement contradicts the question by stating that the Double Becket Bend is easy to inspect after weighting with a rescue load. This is a crucial consideration for firefighters as it can affect rescue operations, particularly when ensuring the safety of their knots under load.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_285_6c01ef5e",
          "question": "The Double Overhand Bend should be cut out of the rope once it is set with a rescue load.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "\"Otherwise, you may need to cut this bend out of the rope once it is set with a rescue load.\" This statement supports the question by confirming that the Double Overhand Bend may need to be cut out of the rope once it is set with a rescue load. This is important for firefighters to understand as it can affect how they manage their equipment during rescue operations, particularly when dealing with knots that are difficult to untie.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_277_5229d2ba",
          "question": "Carabiners should be loaded from side to side for maximum strength.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'All carabiners should be loaded along the spine, that is, from end to end.' This contradicts the question statement. Loading a carabiner from side to side or across axis can greatly reduce its strength, which could lead to equipment failure during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_277_904a02c4",
          "question": "Incorrect loading can reduce the carabiner\u2019s strength by as much as 50%.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Incorrect loading greatly reduces the carabiner\u2019s strength by as much as 50%.' This supports the question statement. Understanding this is crucial for firefighters as incorrect loading can lead to equipment failure during rescue operations, endangering both the rescuer and the victim.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_277_a940236b",
          "question": "The Locking \u201cD\u201d Rescue Carabiner is the least preferred link in rigging systems.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This carabiner is the preferred link in our rigging systems.' This contradicts the question statement. Choosing the right equipment is vital in firefighting operations to ensure safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_277_588f7e13",
          "question": "The gate of the Locking \u201cD\u201d Rescue Carabiner should always be locked for maximum strength.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Always: Lock the gate for maximum strength.' This supports the question statement. Ensuring the gate is locked can prevent accidental disconnection during rescue operations, enhancing safety for both firefighters and victims.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_277_14e4fca1",
          "question": "Three way loading can reduce the strength of a carabiner by as much as 47%.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Three way loading can reduce the strength of a carabiner by as much as 47%.' This supports the question statement. Understanding the limitations of equipment under different loading conditions is important for firefighters to ensure safety during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_282_d2d48850",
          "question": "The preferred method of storing webbing in the Seattle Fire Department is the Chain Stitch method.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Seattle Fire Department Chain Stitch with Webbing The preferred method of storing webbing.' This directly supports the statement that the Chain Stitch method is the preferred method of storing webbing in the Seattle Fire Department. Proper storage of webbing can affect the speed and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_282_3ef24d5b",
          "question": "The Chain Stitch method starts with a simple knot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Start with an overhand slip knot.' This contradicts the statement that the Chain Stitch method starts with a simple knot. The correct knot to start with is an overhand slip knot. The type of knot used can affect the strength and stability of the webbing, which can have safety implications for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_282_f696861d",
          "question": "The Chain Stitch method involves stitching back through the eye of the slip knot.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'and stitch back through the eye of the slip knot.' This directly supports the statement that the Chain Stitch method involves stitching back through the eye of the slip knot. The way the webbing is stitched can affect its strength and durability, which can have implications for firefighting operations and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_282_5697e2a6",
          "question": "The Chain Stitch method requires repeating the process with each successive loop.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Repeat with each successive loop.' This directly supports the statement that the Chain Stitch method requires repeating the process with each successive loop. Repeating the process ensures the webbing is stored securely and consistently, which can affect the speed and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_282_76649749",
          "question": "The Chain Stitch method is used for storing ropes in the Seattle Fire Department.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Seattle Fire Department Chain Stitch with Webbing The preferred method of storing webbing.' This contradicts the statement that the Chain Stitch method is used for storing ropes. The correct statement is that the Chain Stitch method is used for storing webbing. Understanding the correct use of equipment and storage methods can affect the safety and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_283_df7f864e",
          "question": "The Prusik Hitch is formed from pre-tied 8mm accessory cord and can be used for rescue loads up to 600 lbs.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The prussik hitch or \u201cprussik\u201d is formed from pre -tied 8mm accessory cord. The three wrap Prusik Hitch is for rescue loads up to 600 lbs.' This supports the statement that the Prusik Hitch is formed from pre-tied 8mm accessory cord and can be used for rescue loads up to 600 lbs. This is important for firefighters to know as it informs them about the capacity and suitability of the Prusik Hitch in rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_283_3bc4f3a4",
          "question": "The Clove Hitch is used as a tie-off, or in place of an anchor knot, like the Figure Eight.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is not used as a tie-off, or in place of an anchor knot, like the Figure Eight.' This contradicts the statement that the Clove Hitch is used as a tie-off or in place of an anchor knot. Understanding the correct use of knots is critical for firefighters as it affects the safety and effectiveness of their operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_283_30030702",
          "question": "The Clove Hitch is known for its stability and is unlikely to slip and untie.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'However, the clove hitch has been known to slip and untie.' This contradicts the statement that the Clove Hitch is known for its stability and is unlikely to slip and untie. This is a crucial consideration for firefighters as it can impact the safety and success of their operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_283_807e67ab",
          "question": "A hitch incorporates something within it to maintain shape, if the center element is removed, the hitch will fall apart.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A hitch incorporates something within it to maintain shape, if the center element is removed, the hitch will fall apart.' This supports the statement that a hitch incorporates something within it to maintain shape, and if the center element is removed, the hitch will fall apart. This understanding is important for firefighters as it can affect the stability and reliability of their knots during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_283_88fae0c4",
          "question": "The Clove Hitch is useful to quickly tie-off the end of a rope so it will not fall out of your reach, and is easily adjustable.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It is useful to quickly tie -off the end of a rope so it will not fall out of your reach, and still easily adjustable.' This supports the statement that the Clove Hitch is useful to quickly tie-off the end of a rope so it will not fall out of your reach, and is easily adjustable. This is a useful piece of knowledge for firefighters as it can help them maintain control of their equipment during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_276_8ea0b3b7",
          "question": "The 'running end' of a rope is the end that is not being used in the knot you are tying.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Running End \u2013 (Working End) The end of a rope that you will manipulate the most to actively tie a knot.' This contradicts the statement as the 'running end' is the end you manipulate the most to tie a knot, not the end that is not being used. Understanding the correct usage of rope ends is crucial in firefighting operations for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_276_f9e36559",
          "question": "A 'bight' is any rope that doubles back on itself without actually crossing over.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Bight \u2013 Any rope that doubles back on itself without actually crossing over.' This supports the statement. Understanding different rope configurations like a 'bight' is important for firefighters when tying knots for various operations such as rescue or securing equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_276_64322a99",
          "question": "A 'hitch' will hold its form when not in use or 'wrapped' around something.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A hitch will not hold its form when not in use or \u201cwrapped\u201d around something.' This contradicts the statement. Knowing the properties of a 'hitch' can help firefighters choose the appropriate knot for specific tasks, ensuring safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_276_fd1f558f",
          "question": "A 'splice' is made by untwisting two rope ends and weaving them together.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Splice \u2013 Made by untwisting two rope ends and weaving them together.' This supports the statement. Understanding how to make a 'splice' can be useful for firefighters in situations where they need to extend the length of a rope or repair a damaged section.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_276_8c8945b7",
          "question": "Kernmantle rope is a balanced construction consisting of continuous filament polyester cover braided over a unidirectional nylon core and is designed to meet the rigorous requirements associated with rescue and rappelling operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Kernmantle \u2013 (literally \u201ccore \u2013sheath\u201d) rope is a balanced construction consisting of continuous filament polyester cover braided over a unidirectional nylon core. It is designed to meet the rigorous requirements associated with rescue and rappelling operations.' This supports the statement. Understanding the properties of different types of ropes, like Kernmantle, is essential for firefighters to choose the right rope for specific operations, ensuring safety and effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_275_c7b46110",
          "question": "Webbing is the primary material used for rigging anchors in operations because it is light, versatile, and strong.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Webbing is the primary material used for rigging anchors in operations. It is light, can be used for most rigging situations, and it is strong.' This supports the statement and highlights the importance of understanding the properties of materials used in firefighting operations for effective and safe use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_275_198316b5",
          "question": "The pick-off strap's buckle can withstand the same amount of force as the webbing itself.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Though the webbing is rated at 10,000 lbs., when tested for breaking strength in a slow pull test, the buckle slips at 4500 lbs.' This contradicts the statement and emphasizes the importance of understanding the limitations of equipment components in firefighting operations to ensure safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_275_082f7585",
          "question": "The pick-off strap can be used as an adjustable attachment point for the edge attendant.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Uses for this strap range from clipping an attendant into the litter for high/low angle evacuations, to an adjustable attachment point for the edge attendant.' This supports the statement and underscores the versatility of equipment in firefighting operations, which can influence decision-making during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_275_132d7b5b",
          "question": "Anchor straps are made of 1\u201d tubular webbing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Anchor straps are 2\u201d high strength nylon straps.' This contradicts the statement, emphasizing the need for firefighters to accurately understand and recall the specifications of their equipment for safe and effective operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_275_cb36114b",
          "question": "When used in the 'basket U' configuration, anchor straps are rated at 12,500 lbf.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When used in the \u201cbasket U\u201d configuration as in operations, they are rated at 12,500 lbf.' This supports the statement and highlights the importance of understanding how different configurations can affect the strength and functionality of equipment in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_279_d03faced",
          "question": "A Bowline knot retains more strength than a Figure 8 knot when used on a Single Kernmantle Rope.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states that a 'Bowline' knot retains 70-75% strength while a 'Figure 8' knot retains 75-80% strength. This means a 'Figure 8' knot retains more strength than a 'Bowline' knot. In firefighting operations, understanding the relative strengths of knots is crucial for safety, especially during rescue operations or when securing equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_279_7facab40",
          "question": "A Square Knot has the least strength retention among the knots mentioned for a Single Kernmantle Rope.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states that a 'Square Knot' retains 43-70% strength. This is the lowest range compared to the other knots mentioned. In firefighting, knowing the strength of knots can be critical in situations like high-angle rescues or when securing heavy equipment, where the failure of a knot could lead to serious injury or equipment damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_279_f79f7cbf",
          "question": "Two Half Hitches knot tested over a 16mm diameter ring retains 60-70% strength.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states that 'Two Half Hitches (tested over 16mm diameter ring)' retains 60-70% strength. This is important in firefighting as understanding the strength of knots can impact the safety and effectiveness of operations, particularly in rescue scenarios or when securing equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_279_d2f295ca",
          "question": "The strength of a knot does not affect its application in firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text provides different strength percentages for different knots, implying that the strength of a knot does affect its application. In firefighting, the strength of a knot can directly impact the safety and effectiveness of operations, especially in high-stakes situations like rescues or securing heavy equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_279_4319681e",
          "question": "The strength retention of a Clove Hitch knot is the same as an Overhand knot when used on a Single Kernmantle Rope.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states that both 'Clove Hitch' and 'Overhand' knots retain 60-65% strength. This indicates that they have the same strength retention when used on a Single Kernmantle Rope. In firefighting, understanding the relative strengths of knots is important for safety and operational effectiveness, especially during rescue operations or when securing equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_280_ce5bf7b9",
          "question": "A Round Turn with Two Half Hitches knot is used in life safety situations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A utility knot used in many applications where a quick non-slip attachment is required in non-life safety situations.' This contradicts the statement, as the Round Turn with Two Half Hitches knot is specifically mentioned as being used in non-life safety situations. Understanding the appropriate use of different knots is crucial for firefighters, as using the wrong knot in a life safety situation could have serious consequences.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_280_57b7cee8",
          "question": "The longtail bowline requires a back up knot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The longtail bowline doesn\u2019t require a back up knot.' This contradicts the statement, as it is specifically mentioned that the longtail bowline does not require a back up knot. This is important for firefighters to understand, as unnecessary knots can waste time and resources in emergency situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_280_8d2fa1d3",
          "question": "The end of the bowline must be secured.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The end of the bowline must be secured.' This supports the statement. For firefighters, securing the end of a bowline knot can prevent it from slipping or coming undone, which could compromise safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_280_ebb739b5",
          "question": "The Yosemite Finish is bulkier than a double overhand.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The Yosemite Finish is an easy way to tie off the bowline and is less bulky than a double overhand.' This contradicts the statement, as the Yosemite Finish is specifically mentioned as being less bulky than a double overhand. For firefighters, using a less bulky knot like the Yosemite Finish can save space and make handling ropes easier during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_280_23a7dffa",
          "question": "A bight is a 'U' shape in the rope.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A bight is a \u201cU\u201d shape in the rope.' This supports the statement. Understanding the terminology and characteristics of different rope configurations is important for firefighters, as it can affect the effectiveness and safety of knot tying in various situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_281_11aeaae7",
          "question": "The Double Figure Eight knot is difficult to inspect and untie.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Generally, the Double Figure 8 is an easy knot to tie, inspect, and untie.' This contradicts the statement, implying that the Double Figure Eight knot is not difficult to inspect and untie. This is important for firefighters as it ensures quick and efficient operations during emergencies.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_281_424f5246",
          "question": "The Double Figure Eight knot can be used to prevent a person from sliding off the end of a rappel rope.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It may also be used to tie off the running end of a rappel rope so the person is not able to slide off the end of the rope.' This supports the statement, indicating that the Double Figure Eight knot is a safety measure to prevent a person from sliding off the end of a rappel rope. This is crucial for firefighter safety during rappelling operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_281_4a51fc8b",
          "question": "The In-Line Figure Eight knot is only used for rescue systems.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'In-Line Figure Eight A mid-line attachment point that can be used for rescue systems and life safety or any place where a midline loop may be of use.' This contradicts the statement, indicating that the In-Line Figure Eight knot is not only used for rescue systems but also for life safety and other uses. This versatility is important for firefighters as it allows for flexibility in different operational scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_281_11a8b5cb",
          "question": "The Double Figure Eight knot is recommended for tie-in to a single person belay line.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This is one of two tie-in knots recommended for tie-in to a single person belay line.' This supports the statement, indicating that the Double Figure Eight knot is indeed recommended for tie-in to a single person belay line. This is crucial for firefighter safety during belaying operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_281_2c40b986",
          "question": "The Double Figure Eight knot is used as a mid-line attachment point.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Double Figure Eight is used as an end knot to form a loop to connect the rope to an anchor or harness.' This contradicts the statement, indicating that the Double Figure Eight knot is not used as a mid-line attachment point but as an end knot. Understanding the correct usage of knots is vital for firefighters to ensure proper and safe operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_278_9595c864",
          "question": "Knots in the field are prone to breaking, leading to accidents.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'it is imperative to note that knots do not break in the field. People are not found at the bottom of a fall with a broken knot coming from their harnesses.' This directly contradicts the question statement. In firefighting scenarios, it is crucial to understand that knots are reliable and their failure is not a common cause of accidents. The focus should be on correctly tying, dressing, and setting the knots.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_278_6b9a4f4d",
          "question": "The strength of the knot is the most important criterion for knot selection.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text outlines the criteria for knot selection as: 'The ability to tie, The ability to inspect, The ability to adjust, The ability to untie, The last is the strength of the knot.' This shows that while strength is a factor, it is not the most important one. In firefighting, the ability to quickly and accurately tie, inspect, adjust, and untie knots can have direct implications on safety and effectiveness of operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_278_12d38691",
          "question": "Failure to dress and set the knot, bend, or hitch reduces its strength.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'One theory suggests that failure to dress and set the knot, bend, or hitch reduces its strength.' This directly supports the question statement. In firefighting scenarios, understanding the importance of properly dressing and setting knots can impact the reliability of equipment and safety of personnel.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_278_884e44ff",
          "question": "The touch method is a visual review of each element of the knot.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The touch method is a tactile review of each element. If the component hasn\u2019t been touched by the reviewer, then it hasn\u2019t been checked.' This directly contradicts the question statement. In firefighting, tactile inspection methods like the touch method can be crucial in ensuring the reliability of knots and equipment, particularly in situations with poor visibility.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_278_1c1073b2",
          "question": "Without dressing and setting the knot, it is difficult to inspect and predict its performance.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Without dressing and setting the knot, they are difficult to inspect, and there is little way to determine how the resulting configuration will react once shock loaded.' This directly supports the question statement. In firefighting, the ability to predict the performance of knots under load can be crucial for safety and operational effectiveness.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_274_3af86ec9",
          "question": "Washington State Law requires members to record what the rope was used for after every use.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Washington State Law requires members to record what the rope was used for after every use.' This is important as it helps in maintaining a history of the rope's usage, which can contribute to the decision of when to retire a rope from service.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_274_a0d6e2b2",
          "question": "If a life safety rope becomes dirty, it should be cleaned with a strong detergent.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Should life safety rope become dirty, washing with clean water and allowing to \u201cair\u201d dry. A mild detergent may be used if the rope is extremely dirty and water alone will not remove the dirt/debris.' This indicates that a strong detergent should not be used, as it may damage the rope. Firefighters should be aware of this to ensure the longevity and safety of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_274_795a1b15",
          "question": "Life safety ropes should be removed from service after 6 years.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Washington State mandates that life safety ropes be removed from service as a life safety rope after 6 -years of service.' This is crucial for firefighter safety, as ropes weaken over time and using them beyond their service life can lead to dangerous situations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_274_89584056",
          "question": "Utility ropes require a rope history log that tracks its use.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Additionally, utility ropes do not require a rope history log that tracks its use.' This is important for firefighters to know, as it differentiates the maintenance requirements between life safety ropes and utility ropes.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_274_35814176",
          "question": "A nylon rope should be bagged for storage.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'For instance an old manila roof rope (still carried by some ladder companies) should never be put away wet and is acceptable to be daisy chained for storage whereas a nylon rope is usually bagged for storage.' This is important for firefighters to understand, as improper storage can lead to premature degradation of the rope.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_269_833b9448",
          "question": "Chapter 6 of the textbook covers the topic of Ropes & Knots.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text clearly states '305 Chapter 6 \u2013 Ropes & Knots Chapter 6 Basic Ropes & Knots'. This indicates that Chapter 6 is indeed about Ropes & Knots. Understanding different types of ropes and knots is crucial in firefighting for rescue operations, securing equipment, and ensuring safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_269_cb65ec61",
          "question": "The textbook does not provide any information on ropes and knots.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text '305 Chapter 6 \u2013 Ropes & Knots Chapter 6 Basic Ropes & Knots' contradicts this statement. It clearly shows that there is a chapter dedicated to the topic of ropes and knots. Knowledge of ropes and knots is essential in firefighting for various operations such as rescue, securing equipment, and safety measures.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_269_8ac4c497",
          "question": "The chapter on Ropes & Knots is the first chapter in the textbook.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text '305 Chapter 6 \u2013 Ropes & Knots Chapter 6 Basic Ropes & Knots' contradicts this statement. It clearly shows that the chapter on Ropes & Knots is Chapter 6, not the first chapter. Understanding the order of chapters can help in locating information quickly during study or review.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_269_d0dd58ff",
          "question": "The chapter on Ropes & Knots is likely to cover basic information on the topic.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text '305 Chapter 6 \u2013 Ropes & Knots Chapter 6 Basic Ropes & Knots' supports this statement. The word 'Basic' suggests that fundamental information about ropes and knots is covered in this chapter. This foundational knowledge is important for firefighting students as it can be applied in various firefighting scenarios, including rescue operations and equipment handling.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_269_0e69bd05",
          "question": "The chapter on Ropes & Knots is not relevant to firefighting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text '305 Chapter 6 \u2013 Ropes & Knots Chapter 6 Basic Ropes & Knots' contradicts this statement. The inclusion of a chapter on Ropes & Knots in a firefighting textbook implies its relevance to the field. Ropes and knots are used extensively in firefighting for tasks such as rescue operations, securing equipment, and maintaining safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_286_d80072e8",
          "question": "The 'Round Turn with Two Half Hitches' is a type of knot used in firefighting operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Round Turn with Two Half Hitches' as a term in the glossary. This suggests that it is a type of knot used in firefighting operations. Knots are essential for various firefighting tasks such as securing equipment, creating anchor points, or during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_286_9823da57",
          "question": "The 'Bowline with a Yosemite Finish' is not a knot used in firefighting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text includes 'Bowline with a Yosemite Finish' in the glossary. This indicates that it is a knot used in firefighting. Understanding different types of knots is crucial for firefighters as they can be used in various situations such as securing lines, tying off equipment, or during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_286_99d1c560",
          "question": "The 'Figure-Eight Follow Through' is a type of stitch used in firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Figure-Eight Follow Through' as a term in the glossary. However, it is a type of knot, not a stitch, used in firefighting operations. Knots are important in firefighting for securing equipment, creating anchor points, or during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_286_a0d1f99f",
          "question": "The 'In-Line Figure Eight' is not relevant to firefighting operations.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text includes 'In-Line Figure Eight' in the glossary. This indicates that it is relevant to firefighting operations. Understanding different types of knots is crucial for firefighters as they can be used in various situations such as securing lines, tying off equipment, or during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_286_d32bee77",
          "question": "The 'Chain Stitch with Webbing' is a type of knot used in firefighting operations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Chain Stitch with Webbing' as a term in the glossary. This suggests that it is a type of knot used in firefighting operations. Knots are essential for various firefighting tasks such as securing equipment, creating anchor points, or during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_273_ee560e31",
          "question": "Dynamic energy is the energy generated by movement and can be transferred to a rope used to arrest a falling object.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Dynamic energy may be explained as the energy generated by movement (for example, a falling object). If a rope was attached to this falling object and used to arrest its fall, then the energy of the object would be transferred to the rope.' This implies that during rescue operations, firefighters need to be aware of the dynamic forces at play, especially when using ropes for arresting falls.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_273_b4dc39f4",
          "question": "Sunlight does not affect the residual strength of a rope.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'Factors that affect the residual strength are: arresting falls, corrosive chemicals, sunlight, abrasion, etc.' This contradicts the statement and highlights that firefighters need to consider environmental factors like sunlight when assessing the strength and safety of their equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_273_d8499fd2",
          "question": "Modern rescue ropes can sustain considerable damage without failure.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Demonstrations have shown modern rescue ropes are capable of sustaining considerable damage, without failure.' This supports the statement and emphasizes the resilience of modern rescue ropes, which is crucial for firefighters to trust their equipment during high-stakes rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_273_b7178fca",
          "question": "Ropes used for life safety purposes do not need to be marked for inventory or service date.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text says, 'Low stretch life-safety ropes are marked on each end with a number for inventory and the date the rope was placed in service.' This contradicts the statement and underlines the importance of tracking and maintaining firefighting equipment for safety and operational efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_273_aebcfa4e",
          "question": "To evenly distribute wear along the length of the rope, it is recommended to use the same end after each use.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'To evenly distribute wear along the length of the rope over the life of the rope, alternate ends after each use.' This contradicts the statement and highlights the importance of proper rope care to extend its lifespan and ensure safety during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_272_28d4ced1",
          "question": "All operations ladder companies carry three bags of life safety rope of the same length.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Typically, most ladder companies will carry (1) 150\u2019 and (2) 300\u2019 life safety ropes.' This shows that the lengths of the ropes carried by ladder companies vary, which contradicts the question statement. The different lengths of ropes can be used for different rescue scenarios, making it crucial for firefighters to know which rope to use in a given situation.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_272_2fa9affa",
          "question": "The life safety rescue rope has a breaking strength of 9000 lbs.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'This is a life safety rescue rope that is rated at 9000 lbs. breaking strength.' This directly supports the question statement. Understanding the breaking strength of the rope is important for firefighters as it determines the weight the rope can safely support during rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_272_ada6ac14",
          "question": "The 8mm Accessory Cord is primarily used for tying a load releasing hitch.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'One of the primary uses for 8mm Accessory Cord is the prusik loop and the 25 -30 foot guide -sling. The guide sling is used primarily for tying a load releasing hitch.' This directly supports the question statement. Knowledge of the primary uses of different types of ropes and cords is crucial for firefighters to ensure they use the correct equipment for specific tasks during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_272_e3234afc",
          "question": "Utility ropes are classified as 'life safety' ropes.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Any rope that is not classified as \u201clife safety\u201d rope will fall under the category of \u201cutility\u201d.' This directly contradicts the question statement. Understanding the classification of ropes is important for firefighters as it affects how they are used in operations, with life safety ropes used for rescues and utility ropes used for tasks like hoisting equipment and stabilizing vehicles.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_272_031aab14",
          "question": "A rope can stand more force in a slow pull test than in a shock load situation.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A rope can stand more force in a shock load situation than in a slow pull test.' This directly contradicts the question statement. This knowledge is important for firefighters as it affects how they use ropes in different situations, with shock loads potentially involving more force but less time for the rope fibers to realign.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_287_d72576f7",
          "question": "The Prussik Hitch and Clove Hitch are types of knots discussed in the Seattle Fire Department's training material.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'Prussik Hitch Clove Hitch' in the context of the Seattle Fire Department's training material. These are types of knots used in firefighting operations. Understanding and being able to tie these knots correctly can be crucial in various scenarios, such as securing equipment or creating anchor points for rope rescue operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_287_b21f591e",
          "question": "The content is from Chapter 6 of the textbook, which is focused on firefighting equipment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies 'Chapter 6 \u00b7 Rope 285', indicating that this chapter is focused on ropes, not general firefighting equipment. Understanding ropes and their uses is important in firefighting for tasks such as securing areas, rescue operations, and handling equipment.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_287_fb2f6eaf",
          "question": "The content suggests that the Seattle Fire Department uses a visual teaching method with a step-by-step picture glossary.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions 'STEP BY STEP PICTUR E GLOSS ARY', suggesting that the Seattle Fire Department uses a visual teaching method. This can be particularly effective in teaching practical skills such as knot tying, which are crucial in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_287_a7df57da",
          "question": "The content is from a firefighting textbook used by the New York Fire Department.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Seattle Fire Depart ment', indicating that the content is from a textbook used by the Seattle Fire Department, not the New York Fire Department. The specific procedures and techniques can vary between different fire departments, so it's important for firefighters to study the material relevant to their own department.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_287_a5020c18",
          "question": "The Prussik Hitch and Clove Hitch are types of ventilation strategies used in firefighting.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions 'Prussik Hitch Clove Hitch' in the context of ropes, not ventilation strategies. These are types of knots used in firefighting operations. Understanding the correct context and application of these knots is crucial for effective and safe firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_284_177cbcbe",
          "question": "What is the primary use of a Square Bend knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Square Bend knot is primarily used to tie two strands together in non-life safety situations.",
          "options": {
            "A": "To tie two strands together in life safety situations",
            "B": "To tie two webbing ends together to form a runner",
            "C": "To tie two strands together in non-life safety situations",
            "D": "To tie a multipoint anchor together"
          }
        },
        {
          "id": "sfd_basic_skills_284_4746c597",
          "question": "Why is it important to leave a hand width or two inches of tail when tying an Overhand Follow-Through Bend?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Tubular webbing is slippery, so it's important to leave a hand width or two inches of tail when tying an Overhand Follow-Through Bend.",
          "options": {
            "A": "To make the knot more visible",
            "B": "Because tubular webbing is slippery",
            "C": "To make the knot easier to untie",
            "D": "To make the knot stronger"
          }
        },
        {
          "id": "sfd_basic_skills_284_cefc1f53",
          "question": "What is the purpose of dressing and setting the Overhand Follow-Through Bend?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Given the slippery material of tubular webbing, dressing and setting the Overhand Follow-Through Bend is important to ensure the knot holds.",
          "options": {
            "A": "To make the knot look more aesthetically pleasing",
            "B": "To make the knot easier to untie",
            "C": "To ensure the knot holds, given the slippery material",
            "D": "To make the knot more visible"
          }
        },
        {
          "id": "sfd_basic_skills_284_8c1dd385",
          "question": "What is the use of an Overhand Follow-Through Bend in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Overhand Follow-Through Bend is used to tie two webbing ends together to form a runner.",
          "options": {
            "A": "To tie a multipoint anchor together",
            "B": "To tie two strands together in non-life safety situations",
            "C": "To tie two strands together in life safety situations",
            "D": "To tie two webbing ends together to form a runner"
          }
        },
        {
          "id": "sfd_basic_skills_284_2ce9d526",
          "question": "Why is the Square Bend knot not used in life safety situations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Square Bend knot is historically used for non-life safety situations, not because of its strength, complexity, or slipperiness.",
          "options": {
            "A": "Because it is not strong enough",
            "B": "Because it is too complex to tie quickly",
            "C": "Because it is too slippery",
            "D": "Because it is not traditionally used in such situations"
          }
        },
        {
          "id": "sfd_basic_skills_288_c1fe167d",
          "question": "Which knot is not mentioned in the Seattle Fire Department's step by step picture glossary?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Bowline Knot is not mentioned in the provided content. The mentioned knots are Square Bend, Overhand Follow-Through Bend, and Double Overhand Bend.",
          "options": {
            "A": "Square Bend",
            "B": "Overhand Follow-Through Bend",
            "C": "Double Overhand Bend",
            "D": "Bowline Knot"
          }
        },
        {
          "id": "sfd_basic_skills_288_7504683d",
          "question": "What might be a potential risk when using a poorly tied Double Overhand Bend during a firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A poorly tied knot, such as a Double Overhand Bend, could lead to equipment failure or personal injury due to the knot coming undone under strain.",
          "options": {
            "A": "It may cause a fire to spread more rapidly",
            "B": "It may lead to equipment failure or personal injury",
            "C": "It may cause the fire truck to malfunction",
            "D": "It may attract more smoke"
          }
        },
        {
          "id": "sfd_basic_skills_288_fcc6f9c3",
          "question": "In what chapter of the Seattle Fire Department's guide can you find information about rope knots?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The content mentions that information about rope knots can be found in Chapter 6.",
          "options": {
            "A": "Chapter 5",
            "B": "Chapter 6",
            "C": "Chapter 7",
            "D": "Chapter 8"
          }
        },
        {
          "id": "sfd_basic_skills_288_73d410df",
          "question": "Why is it important for a firefighter to know different types of knots like Square Bend, Overhand Follow-Through Bend, and Double Overhand Bend?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Knowing different types of knots is crucial for firefighters as they are often used to secure firefighting equipment and ensure safety during operations.",
          "options": {
            "A": "To tie their shoelaces properly",
            "B": "To secure firefighting equipment and ensure safety during operations",
            "C": "To perform magic tricks during downtime",
            "D": "To tie a tie for formal events"
          }
        },
        {
          "id": "sfd_basic_skills_288_f334eafd",
          "question": "What might be the implication of not following the Seattle Fire Department's step by step picture glossary when tying a Double Becket?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the Double Becket is not tied correctly as per the guide, the knot may not hold under pressure, leading to potential safety risks.",
          "options": {
            "A": "The knot may not hold under pressure, leading to potential safety risks",
            "B": "The fire hose might spray water uncontrollably",
            "C": "The fire truck's siren might not work",
            "D": "The fire extinguisher might not work"
          }
        },
        {
          "id": "sfd_basic_skills_271_2cd674b9",
          "question": "What is the implication of using a high stretch or 'dynamic' rope in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "High stretch or 'dynamic' ropes have a relatively high stretch ratio, making them ideal for operations utility ropes.",
          "options": {
            "A": "It can be used for life safety operations due to its high stretch ratio",
            "B": "It is ideal for operations utility ropes due to its high stretch ratio",
            "C": "It should be avoided due to its spiral constructed core bundle",
            "D": "It is less durable due to its high stretch ratio"
          }
        },
        {
          "id": "sfd_basic_skills_271_e1c66112",
          "question": "What is a key safety consideration when handling ropes in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Exposure to the sun\u2019s ultraviolet radiation will damage the rope, so it should be kept to a minimum.",
          "options": {
            "A": "Ropes should be left under tension for extended periods",
            "B": "Ropes should be dragged to ensure durability",
            "C": "Knots should be left in the rope to increase strength",
            "D": "Ropes should be kept away from the sun's ultraviolet radiation"
          }
        },
        {
          "id": "sfd_basic_skills_271_a4b217e8",
          "question": "What is the implication of using a low stretch or 'static' rope in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Low stretch or 'static' ropes have a relatively low stretch ratio, making them ideal for life safety operations.",
          "options": {
            "A": "It is ideal for operations utility ropes due to its low stretch ratio",
            "B": "It can be used for life safety operations due to its low stretch ratio",
            "C": "It should be avoided due to its non-spiral constructed core bundle",
            "D": "It is less durable due to its low stretch ratio"
          }
        },
        {
          "id": "sfd_basic_skills_271_319f28e3",
          "question": "What is the effect of abrasion on the rope in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Dragging the rope leads to added abrasion, which in turn leads to less sheath life.",
          "options": {
            "A": "It increases the rope's strength",
            "B": "It leads to less sheath life",
            "C": "It has no effect on the rope",
            "D": "It increases the rope's stretch ratio"
          }
        },
        {
          "id": "sfd_basic_skills_271_352e5369",
          "question": "What is the effect of leaving a rope under tension for an extended period of time in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Leaving a rope under tension for any extended period of time should be avoided unless necessary.",
          "options": {
            "A": "It increases the rope's strength",
            "B": "It has no effect on the rope",
            "C": "It leads to less sheath life",
            "D": "It should be avoided unless necessary"
          }
        },
        {
          "id": "sfd_basic_skills_270_f8cdabf8",
          "question": "What is the primary consideration when working with ropes and knots in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Safety should be the primary consideration when working with ropes and knots in firefighting operations, whether in an emergency or training.",
          "options": {
            "A": "Speed",
            "B": "Versatility",
            "C": "Safety",
            "D": "Strength"
          }
        },
        {
          "id": "sfd_basic_skills_270_45cb2d6b",
          "question": "What is the purpose of a Life Safety rope in the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Life Safety rope is defined as any rope used to support the weight of members or other persons during rescue, fire fighting, other emergency operations, or during training evolutions.",
          "options": {
            "A": "To secure equipment",
            "B": "To support the weight of members or other persons during rescue, fire fighting, or other emergency operations",
            "C": "To tie knots",
            "D": "To be used as a utility rope"
          }
        },
        {
          "id": "sfd_basic_skills_270_e5fb6fc2",
          "question": "Why is it important for firefighters to be able to tie standard knots automatically?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "It's important for firefighters to be able to tie these standard knots automatically to ensure safety and effectiveness while under the stress of an emergency.",
          "options": {
            "A": "To show off their knot-tying skills",
            "B": "To pass the time during quiet periods",
            "C": "To ensure safety and effectiveness under the stress of an emergency",
            "D": "To be able to teach others how to tie knots"
          }
        },
        {
          "id": "sfd_basic_skills_270_ed181669",
          "question": "What is the function of a Utility rope in the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A utility rope is used for any function other than that of life safety. This includes securing equipment, practice ropes, RIG ropes, roof ropes and other ropes that are marked as such.",
          "options": {
            "A": "To support the weight of members during rescue operations",
            "B": "To be used for any function other than that of life safety",
            "C": "To be used as a life safety rope",
            "D": "To tie knots"
          }
        },
        {
          "id": "sfd_basic_skills_270_00a6bbaa",
          "question": "What type of rope do operations companies use for all operations level rescues?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Operations companies use \u00bd\u201d static kernmantle life safety rope for all operations level rescues.",
          "options": {
            "A": "1/4\u201d woven cotton tie ropes",
            "B": "8mm guide sling for the Load Releasing Hitch",
            "C": "Prussik loops",
            "D": "\u00bd\u201d static kernmantle life safety rope"
          }
        },
        {
          "id": "sfd_basic_skills_285_f5a32f98",
          "question": "What is the primary use of the Double Overhand Bend in the fire service?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Double Overhand Bend is primarily used for prusik loops and to tie high/low-stretch materials together in the fire service.",
          "options": {
            "A": "To tie two unequal sized diameter materials together",
            "B": "For prusik loops and tying high/low-stretch materials together",
            "C": "To backup the Double Sheet Bend",
            "D": "To tie two ropes together for rescue loads"
          }
        },
        {
          "id": "sfd_basic_skills_285_bed2a7a8",
          "question": "What is a recommended action if the Double Overhand Bend is used for rescue loads?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If the Double Overhand Bend is used for rescue loads, a prusik by-pass is recommended.",
          "options": {
            "A": "Back it up with Double Overhands on the two tails",
            "B": "Use a prusik by-pass",
            "C": "Untie it after weighting with a rescue load",
            "D": "Tie it with two unequal sized diameter materials"
          }
        },
        {
          "id": "sfd_basic_skills_285_af05a4c2",
          "question": "What is the main characteristic of the Double Becket Bend?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Double Becket Bend is used for joining two unequal sized diameter materials together.",
          "options": {
            "A": "It is difficult to untie once loaded",
            "B": "It is used for joining two unequal sized diameter materials together",
            "C": "It is used for single person loads",
            "D": "It is used to tie high/low-stretch materials together"
          }
        },
        {
          "id": "sfd_basic_skills_285_8feb4420",
          "question": "What is a potential drawback of using the Double Overhand Bend with rescue loads?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the Double Overhand Bend is used with rescue loads, it may need to be cut out of the rope once it is set.",
          "options": {
            "A": "It may need to be cut out of the rope once it is set",
            "B": "It is difficult to inspect",
            "C": "It is not suitable for single person loads",
            "D": "It cannot be used with high/low-stretch materials"
          }
        },
        {
          "id": "sfd_basic_skills_285_698eb232",
          "question": "What is a possible action to take after weighting the Double Becket Bend with a rescue load?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Double Becket Bend is easy to untie after weighting with a rescue load.",
          "options": {
            "A": "Untie it",
            "B": "Cut it out of the rope",
            "C": "Back it up with Double Overhands on the two tails",
            "D": "Use a prusik by-pass"
          }
        },
        {
          "id": "sfd_basic_skills_277_89111fb7",
          "question": "What is the potential consequence of incorrect loading of a carabiner?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Incorrect loading can greatly reduce the carabiner\u2019s strength by as much as 50%.",
          "options": {
            "A": "It increases the carabiner's strength by 50%",
            "B": "It has no effect on the carabiner's strength",
            "C": "It reduces the carabiner's strength by as much as 50%",
            "D": "It makes the carabiner more flexible"
          }
        },
        {
          "id": "sfd_basic_skills_277_631e71f7",
          "question": "What is the preferred link in rigging systems according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Locking 'D' Rescue Carabiner is the preferred link in rigging systems according to the Seattle Fire Department.",
          "options": {
            "A": "Square Rescue Carabiner",
            "B": "Locking 'D' Rescue Carabiner",
            "C": "Three-way Loading Carabiner",
            "D": "Off Axis Loading Carabiner"
          }
        },
        {
          "id": "sfd_basic_skills_277_836d8454",
          "question": "What is the breaking strength of the Locking 'D' Rescue Carabiner?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Locking 'D' Rescue Carabiner has a breaking strength of 9000 lbs.",
          "options": {
            "A": "4700 lbs",
            "B": "10,000 lbs",
            "C": "9000 lbs",
            "D": "5000 lbs"
          }
        },
        {
          "id": "sfd_basic_skills_277_5062f183",
          "question": "What is the maximum width of rigging material that should be used to avoid off axis loading?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "To avoid off axis loading, caution should be used to avoid the use of rigging material more than two fingers wide.",
          "options": {
            "A": "More than two fingers wide",
            "B": "Less than two fingers wide",
            "C": "Exactly two fingers wide",
            "D": "Width does not affect off axis loading"
          }
        },
        {
          "id": "sfd_basic_skills_277_1c74927c",
          "question": "What is the effect of three-way loading on a carabiner's strength?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Three way loading can reduce the strength of a carabiner by as much as 47%.",
          "options": {
            "A": "It increases the strength by 47%",
            "B": "It has no effect on the strength",
            "C": "It reduces the strength by as much as 47%",
            "D": "It makes the carabiner more flexible"
          }
        },
        {
          "id": "sfd_basic_skills_282_7e4c5894",
          "question": "What is the preferred method of storing webbing according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The content specifies that the preferred method of storing webbing according to the Seattle Fire Department is using a chain stitch.",
          "options": {
            "A": "Using a figure eight knot",
            "B": "Using a square knot",
            "C": "Using a chain stitch",
            "D": "Using a clove hitch"
          }
        },
        {
          "id": "sfd_basic_skills_282_9cc748d0",
          "question": "What is the first step in the chain stitch method of storing webbing?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The content specifies that the first step in the chain stitch method of storing webbing is to start with an overhand slip knot.",
          "options": {
            "A": "Start with a square knot",
            "B": "Start with an overhand slip knot",
            "C": "Start with a figure eight knot",
            "D": "Start with a clove hitch"
          }
        },
        {
          "id": "sfd_basic_skills_282_cc338337",
          "question": "What is the next step after creating an overhand slip knot in the chain stitch method?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The content specifies that after creating an overhand slip knot in the chain stitch method, the next step is to stitch back through the eye of the slip knot.",
          "options": {
            "A": "Stitch back through the eye of the slip knot",
            "B": "Tie another overhand slip knot",
            "C": "Create a figure eight knot",
            "D": "Create a square knot"
          }
        },
        {
          "id": "sfd_basic_skills_282_8bda724b",
          "question": "Why is the chain stitch method preferred for storing webbing in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "While the text does not explicitly state why the chain stitch method is preferred, in firefighting operations, quick access to equipment is often vital, making option B the most likely answer.",
          "options": {
            "A": "It is the easiest method",
            "B": "It provides the quickest access to the webbing",
            "C": "It is the most secure method",
            "D": "It is the most visually appealing method"
          }
        },
        {
          "id": "sfd_basic_skills_282_dd7e858b",
          "question": "What should be repeated with each successive loop in the chain stitch method of storing webbing?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The content specifies that with each successive loop in the chain stitch method of storing webbing, you should stitch back through the eye of the slip knot.",
          "options": {
            "A": "Tying an overhand slip knot",
            "B": "Stitching back through the eye of the slip knot",
            "C": "Creating a figure eight knot",
            "D": "Creating a square knot"
          }
        },
        {
          "id": "sfd_basic_skills_283_79b5770a",
          "question": "What is the primary use of the three-wrap Prusik Hitch in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The three-wrap Prusik Hitch is primarily used for rescue loads up to 600 lbs in firefighting operations.",
          "options": {
            "A": "To quickly tie-off the end of a rope",
            "B": "To replace an anchor knot",
            "C": "For rescue loads up to 600 lbs",
            "D": "To maintain the shape of the hitch"
          }
        },
        {
          "id": "sfd_basic_skills_283_59a72a49",
          "question": "Why is the Clove Hitch not used as a tie-off or in place of an anchor knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Clove Hitch is not used as a tie-off or in place of an anchor knot in firefighting operations because it has been known to slip and untie.",
          "options": {
            "A": "Because it is difficult to adjust",
            "B": "Because it has been known to slip and untie",
            "C": "Because it is not strong enough",
            "D": "Because it is not formed from pre-tied 8mm accessory cord"
          }
        },
        {
          "id": "sfd_basic_skills_283_f4d4f4b2",
          "question": "What is the implication of a hitch falling apart if the center element is removed during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the center element of a hitch is removed and it falls apart during firefighting operations, it can lead to equipment failure.",
          "options": {
            "A": "It can lead to equipment failure",
            "B": "It can cause the fire to spread faster",
            "C": "It can lead to a decrease in water pressure",
            "D": "It can cause the rope to fall out of reach"
          }
        },
        {
          "id": "sfd_basic_skills_283_f087dfd7",
          "question": "What is the primary purpose of the Clove Hitch in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The primary purpose of the Clove Hitch in firefighting operations is to quickly tie-off the end of a rope.",
          "options": {
            "A": "To replace an anchor knot",
            "B": "To quickly tie-off the end of a rope",
            "C": "For rescue loads up to 600 lbs",
            "D": "To maintain the shape of the hitch"
          }
        },
        {
          "id": "sfd_basic_skills_283_dd406730",
          "question": "Why should operations company members only use the three-wrap prussik?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Operations company members should only use the three-wrap prussik because it is formed from pre-tied 8mm accessory cord.",
          "options": {
            "A": "Because it is the strongest type of hitch",
            "B": "Because it is the easiest to tie",
            "C": "Because it is formed from pre-tied 8mm accessory cord",
            "D": "Because it is the most adjustable type of hitch"
          }
        },
        {
          "id": "sfd_basic_skills_276_b36b6f7b",
          "question": "What is the primary difference between a knot and a hitch in terms of their form when not in use?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A knot, even when not in use, will hold its shape or form. A hitch will not hold its form when not in use or 'wrapped' around something.",
          "options": {
            "A": "A knot will hold its shape, a hitch will not",
            "B": "A hitch will hold its shape, a knot will not",
            "C": "Both a knot and a hitch will hold their shape",
            "D": "Neither a knot nor a hitch will hold their shape"
          }
        },
        {
          "id": "sfd_basic_skills_276_83d5afad",
          "question": "What is the purpose of a splice in rope work?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A splice is made by untwisting two rope ends and weaving them together.",
          "options": {
            "A": "To create a loop in the rope",
            "B": "To fasten two ropes together by weaving their ends",
            "C": "To create a knot that will hold its shape",
            "D": "To create a bight in the rope"
          }
        },
        {
          "id": "sfd_basic_skills_276_a8ec9394",
          "question": "What is the implication of using a Kernmantle rope in rescue and rappelling operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Kernmantle rope is a balanced construction consisting of continuous filament polyester cover braided over a unidirectional nylon core. It is designed to meet the rigorous requirements associated with rescue and rappelling operations.",
          "options": {
            "A": "It is not suitable due to its unidirectional nylon core",
            "B": "It is designed to meet the rigorous requirements of such operations",
            "C": "It is only suitable for tying knots, not for rescue operations",
            "D": "It is not durable enough for rescue operations"
          }
        },
        {
          "id": "sfd_basic_skills_276_deaf117f",
          "question": "What is the difference between the running end and the bitter end of a rope?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The running end is the end of a rope that you will manipulate the most to actively tie a knot. The bitter end is the end of the rope not being used in the knot you are tying.",
          "options": {
            "A": "The running end is manipulated the most, the bitter end is not used in the knot",
            "B": "The bitter end is manipulated the most, the running end is not used in the knot",
            "C": "Both ends are used equally in knot tying",
            "D": "Neither end is used in knot tying"
          }
        },
        {
          "id": "sfd_basic_skills_276_951d047e",
          "question": "How is a loop created in a rope?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A loop is created when a bight crosses itself.",
          "options": {
            "A": "By intertwining two ropes",
            "B": "By fastening two ropes together",
            "C": "By a bight crossing itself",
            "D": "By weaving two rope ends together"
          }
        },
        {
          "id": "sfd_basic_skills_275_fb3ce09c",
          "question": "Why is 1\u201d Tubular Webbing considered an excellent choice for rigging in rescue operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that 1\u201d Tubular Webbing is light, can be used for most rigging situations, and it is strong, making it an excellent choice for rigging in rescue operations.",
          "options": {
            "A": "It is light and can be used for most rigging situations",
            "B": "It is strong and can withstand high temperatures",
            "C": "It is cheap and easily available",
            "D": "It is resistant to water and fire"
          }
        },
        {
          "id": "sfd_basic_skills_275_29cab343",
          "question": "What is the potential issue with the buckle on the pick-off strap and how can it be mitigated?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that the buckle on the pick-off strap slips at 4500 lbs, but it can be tied off with a double overhand to achieve a strength closer to that of the webbing.",
          "options": {
            "A": "The buckle slips at 4500 lbs, it can be tied off with a double overhand to achieve a strength closer to that of the webbing",
            "B": "The buckle is too large, it can be replaced with a smaller one",
            "C": "The buckle is not strong enough, it can be replaced with a metal one",
            "D": "The buckle is too heavy, it can be replaced with a plastic one"
          }
        },
        {
          "id": "sfd_basic_skills_275_f2e6fd76",
          "question": "What is the rated strength of the anchor straps when used in the 'basket U' configuration?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that when used in the 'basket U' configuration, the anchor straps are rated at 12,500 lbf.",
          "options": {
            "A": "10,000 lbs",
            "B": "12,500 lbf",
            "C": "4500 lbs",
            "D": "5000 lbs"
          }
        },
        {
          "id": "sfd_basic_skills_275_45103486",
          "question": "What is one of the uses for the pick-off strap?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that one of the uses for the pick-off strap is to clip an attendant into the litter for high/low angle evacuations.",
          "options": {
            "A": "To clip an attendant into the litter for high/low angle evacuations",
            "B": "To secure the fire hose",
            "C": "To extinguish fires",
            "D": "To rescue people from water"
          }
        },
        {
          "id": "sfd_basic_skills_275_f4ad6050",
          "question": "What is the primary material used for rigging anchors in operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that webbing is the primary material used for rigging anchors in operations.",
          "options": {
            "A": "Steel cables",
            "B": "Rope",
            "C": "Webbing",
            "D": "Chain"
          }
        },
        {
          "id": "sfd_basic_skills_279_d72d265b",
          "question": "According to the Seattle Fire Department, which knot retains the highest percentage of a single Kernmantle rope's strength?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The strength of a single Kernmantle rope is 100% when there is no knot.",
          "options": {
            "A": "Square Knot",
            "B": "Figure 8",
            "C": "No Knot",
            "D": "Clove Hitch"
          }
        },
        {
          "id": "sfd_basic_skills_279_14ccf4e6",
          "question": "Which knot decreases the strength of a single Kernmantle rope the most, according to the data provided?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the data provided, a Square Knot decreases the strength of a single Kernmantle rope the most, with a relative strength of 43-70%.",
          "options": {
            "A": "Square Knot",
            "B": "Clove Hitch",
            "C": "Ring Bend",
            "D": "Bowline"
          }
        },
        {
          "id": "sfd_basic_skills_279_edc03228",
          "question": "In a rescue operation where maximum rope strength is required, which knot should be avoided?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The Square Knot should be avoided as it retains the least amount of the rope's strength.",
          "options": {
            "A": "Figure 8",
            "B": "Bowline",
            "C": "Double Overhand Bend",
            "D": "Square Knot"
          }
        },
        {
          "id": "sfd_basic_skills_279_c693a10f",
          "question": "Which knot retains approximately the same strength as two half hitches when tested over a 16mm diameter ring?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The Ring Bend and Two Half Hitches both retain 60-70% of the rope's strength when tested over a 16mm diameter ring.",
          "options": {
            "A": "Ring Bend",
            "B": "Clove Hitch",
            "C": "Overhand",
            "D": "Bowline"
          }
        },
        {
          "id": "sfd_basic_skills_279_03a14e13",
          "question": "In a scenario where a balance between knot strength and ease of untying is needed, which knot could be a suitable choice?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Figure 8 knot retains a high percentage of the rope's strength (75-80%) and is also relatively easy to untie, making it a suitable choice in this scenario.",
          "options": {
            "A": "No Knot",
            "B": "Square Knot",
            "C": "Figure 8",
            "D": "Overhand"
          }
        },
        {
          "id": "sfd_basic_skills_280_7789bf09",
          "question": "What is the primary use of the Round Turn with Two Half Hitches knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Round Turn with Two Half Hitches is primarily used for quick non-slip attachment in non-life safety situations.",
          "options": {
            "A": "For life safety situations",
            "B": "For securing the end of the bowline",
            "C": "For quick non-slip attachment in non-life safety situations",
            "D": "For creating a loop in the rope"
          }
        },
        {
          "id": "sfd_basic_skills_280_327157eb",
          "question": "Why is the Bowline with a Yosemite Finish knot preferred in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Bowline with a Yosemite Finish is preferred because of its adjustability, ease of inspection, and ability to be untied after being loaded.",
          "options": {
            "A": "Because it requires a backup knot",
            "B": "Because of its adjustability, ease of inspection, and ability to be untied after being loaded",
            "C": "Because it is less bulky than a double overhand",
            "D": "Because it forms a 'U' shape in the rope"
          }
        },
        {
          "id": "sfd_basic_skills_280_d56f1ad6",
          "question": "What is the purpose of the Yosemite Finish when tying a bowline knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Yosemite Finish is used to secure the end of the bowline and make it less bulky than a double overhand.",
          "options": {
            "A": "To create a 'U' shape in the rope",
            "B": "To secure the end of the bowline and make it less bulky than a double overhand",
            "C": "To form a loop in the rope",
            "D": "To make the knot slip easily"
          }
        },
        {
          "id": "sfd_basic_skills_280_09f8f7a4",
          "question": "What is the implication of a knot that doesn't require a backup in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "A knot that doesn't require a backup, like the longtail bowline, is less bulky and easier to tie.",
          "options": {
            "A": "It is less secure and more likely to slip",
            "B": "It is more secure and less likely to slip",
            "C": "It is more difficult to inspect and adjust",
            "D": "It is less bulky and easier to tie"
          }
        },
        {
          "id": "sfd_basic_skills_280_409e1c36",
          "question": "What is the importance of the standing end in a knot during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In knot tying, the standing end is the non-moving part of the knot.",
          "options": {
            "A": "It is the end actively being tied",
            "B": "It is the non-moving part of the knot",
            "C": "It is the part of the knot that forms a loop",
            "D": "It is the part of the knot that is intertwined with itself"
          }
        },
        {
          "id": "sfd_basic_skills_281_1d6f1a78",
          "question": "What is one of the primary uses of a Double Figure Eight knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The Double Figure Eight knot is primarily used to form a loop to connect the rope to an anchor or harness in firefighting operations.",
          "options": {
            "A": "To tie two ropes together",
            "B": "To create a mid-line attachment point",
            "C": "To form a loop to connect the rope to an anchor or harness",
            "D": "To create a decorative knot for ceremonial purposes"
          }
        },
        {
          "id": "sfd_basic_skills_281_af8c0f40",
          "question": "Why is the Double Figure Eight knot recommended for tie-in to a single person belay line?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The Double Figure Eight knot is recommended for tie-in to a single person belay line because it is easy to tie, inspect, and untie.",
          "options": {
            "A": "Because it is a complex knot that requires skill to tie",
            "B": "Because it is easy to tie, inspect, and untie",
            "C": "Because it is the most aesthetically pleasing knot",
            "D": "Because it is the most difficult knot to untie"
          }
        },
        {
          "id": "sfd_basic_skills_281_6a050fac",
          "question": "What is the primary function of an In-Line Figure Eight knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The In-Line Figure Eight knot is primarily used to create a mid-line attachment point in firefighting operations.",
          "options": {
            "A": "To tie two ropes together",
            "B": "To create a mid-line attachment point",
            "C": "To form a loop to connect the rope to an anchor or harness",
            "D": "To create a decorative knot for ceremonial purposes"
          }
        },
        {
          "id": "sfd_basic_skills_281_0918339a",
          "question": "What is a safety consideration when using a Double Figure Eight knot in rappelling operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "In rappelling operations, a Double Figure Eight knot can be used to tie off the running end of a rappel rope to prevent a person from sliding off the end, enhancing safety.",
          "options": {
            "A": "It can be used to tie off the running end of a rappel rope to prevent sliding off the end",
            "B": "It should be avoided as it is too complex to untie quickly",
            "C": "It should be used to tie two ropes together",
            "D": "It should be used to create a mid-line attachment point"
          }
        },
        {
          "id": "sfd_basic_skills_281_3259cc58",
          "question": "Why is the In-Line Figure Eight knot useful in rescue systems?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The In-Line Figure Eight knot is useful in rescue systems because it can be used to create a mid-line attachment point, which can be crucial in various rescue scenarios.",
          "options": {
            "A": "It is used to tie two ropes together",
            "B": "It is used to create a mid-line attachment point",
            "C": "It is used to form a loop to connect the rope to an anchor or harness",
            "D": "It is used to tie off the running end of a rappel rope"
          }
        },
        {
          "id": "sfd_basic_skills_278_8adb956f",
          "question": "What is the primary reason for dressing and setting a knot in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Dressing and setting a knot is important to ensure that the knot can be properly inspected and to predict how it will perform under load, not necessarily to increase its strength.",
          "options": {
            "A": "To make the knot look neat and tidy",
            "B": "To increase the strength of the knot",
            "C": "To facilitate inspection and predict performance under load",
            "D": "To ensure the knot does not break in the field"
          }
        },
        {
          "id": "sfd_basic_skills_278_7aa0f416",
          "question": "What is the 'touch check' method in relation to knots?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'touch check' method involves a tactile review of each element of the knot to ensure it is tied correctly.",
          "options": {
            "A": "A method to test the strength of the knot",
            "B": "A method to ensure the knot is tied correctly by physically reviewing each element",
            "C": "A method to adjust the knot",
            "D": "A method to untie the knot"
          }
        },
        {
          "id": "sfd_basic_skills_278_e5aa5b32",
          "question": "What is the least important criteria for knot selection in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "While the strength of the knot is important, the text emphasizes that knots do not break in the field, and the ability to tie, inspect, adjust, and untie the knot are more critical.",
          "options": {
            "A": "The ability to tie the knot",
            "B": "The ability to inspect the knot",
            "C": "The ability to untie the knot",
            "D": "The strength of the knot"
          }
        },
        {
          "id": "sfd_basic_skills_278_3cfaf2cf",
          "question": "Why is it important to avoid 'the myth of knot strength' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text emphasizes that knots do not break in the field, and factors such as the ability to tie, inspect, adjust, and untie the knot are more important.",
          "options": {
            "A": "Because knots always break in the field",
            "B": "Because the strength of a knot is irrelevant",
            "C": "Because knots do not break in the field and other factors are more important",
            "D": "Because the strength of a knot can never be accurately measured"
          }
        },
        {
          "id": "sfd_basic_skills_278_1f3285c2",
          "question": "What is the potential consequence of failing to dress and set a knot, bend, or hitch?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Failing to dress and set a knot can result in a contorted configuration that is difficult to inspect and predict how it will perform under load.",
          "options": {
            "A": "The knot will break under load",
            "B": "The knot will end up in a contorted configuration that is difficult to inspect",
            "C": "The knot will untie itself",
            "D": "The knot will lose its strength"
          }
        },
        {
          "id": "sfd_basic_skills_274_f8013096",
          "question": "What is one of the elements that contribute to the decision of when to retire a rope from service?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The rope's history, including its use and condition, is recorded and contributes to the decision of when to retire a rope from service.",
          "options": {
            "A": "The color of the rope",
            "B": "The thickness of the rope",
            "C": "The rope's history",
            "D": "The brand of the rope"
          }
        },
        {
          "id": "sfd_basic_skills_274_3d02128d",
          "question": "What is the maximum temperature of water that should be used to clean a life safety rope?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies not to use water hotter than 110\u02da F to clean a life safety rope.",
          "options": {
            "A": "90\u02da F",
            "B": "110\u02da F",
            "C": "130\u02da F",
            "D": "150\u02da F"
          }
        },
        {
          "id": "sfd_basic_skills_274_813a5c5d",
          "question": "What is the mandated service life of a life safety rope according to Washington State law?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Washington State mandates that life safety ropes be removed from service after 6 years of service.",
          "options": {
            "A": "4 years",
            "B": "6 years",
            "C": "8 years",
            "D": "10 years"
          }
        },
        {
          "id": "sfd_basic_skills_274_660abf42",
          "question": "What is the difference in storage methods between an old manila roof rope and a nylon rope?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that an old manila roof rope is acceptable to be daisy chained for storage whereas a nylon rope is usually bagged for storage.",
          "options": {
            "A": "Manila rope is bagged, nylon rope is daisy chained",
            "B": "Manila rope is daisy chained, nylon rope is bagged",
            "C": "Both are bagged for storage",
            "D": "Both are daisy chained for storage"
          }
        },
        {
          "id": "sfd_basic_skills_274_3166af97",
          "question": "What is a unique requirement for life safety ropes but not for utility ropes?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that life safety ropes require a rope history log that tracks its use, while utility ropes do not have this requirement.",
          "options": {
            "A": "Life safety ropes require a rope history log",
            "B": "Life safety ropes need to be cleaned with detergent",
            "C": "Life safety ropes need to be dried in direct sunlight",
            "D": "Life safety ropes are always bagged for storage"
          }
        },
        {
          "id": "sfd_basic_skills_269_afd653ec",
          "question": "What is the importance of understanding ropes and knots in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding ropes and knots is crucial in firefighting operations to secure firefighting equipment and ensure safety during operations.",
          "options": {
            "A": "To tie up victims for rescue",
            "B": "To secure firefighting equipment",
            "C": "To create a decorative display at the fire station",
            "D": "To make a clothesline for drying fire suits"
          }
        },
        {
          "id": "sfd_basic_skills_269_fc830396",
          "question": "What could be a potential risk if a firefighter does not properly know how to handle ropes and knots?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If a firefighter does not properly know how to handle ropes and knots, the rope could break, leading to potential equipment failure or danger during operations.",
          "options": {
            "A": "The rope could break",
            "B": "The knot could become too tight",
            "C": "The rope could become a tripping hazard",
            "D": "The firefighter could get a rope burn"
          }
        },
        {
          "id": "sfd_basic_skills_269_6722fb52",
          "question": "Why is it important for a firefighter to know different types of knots?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Different knots have different strengths and uses in firefighting operations, making it crucial for firefighters to understand and be able to tie them.",
          "options": {
            "A": "Different knots have different decorative purposes",
            "B": "Different knots have different strengths and uses in firefighting operations",
            "C": "To impress their colleagues with their knot-tying skills",
            "D": "To pass time during downtime at the fire station"
          }
        },
        {
          "id": "sfd_basic_skills_269_6ce42d57",
          "question": "What could be the implications of using the wrong type of knot during a firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Using the wrong type of knot during a firefighting operation could lead to equipment failure or safety hazards, potentially endangering lives.",
          "options": {
            "A": "It could lead to a fashion faux pas",
            "B": "It could lead to equipment failure or safety hazards",
            "C": "It could lead to a delay in lunch break",
            "D": "It could lead to a knot-tying competition"
          }
        },
        {
          "id": "sfd_basic_skills_269_8f7b91fa",
          "question": "What is the role of ropes in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Ropes play a crucial role in firefighting operations, including securing equipment, aiding in rescue operations, and ensuring safety.",
          "options": {
            "A": "To play tug-of-war during downtime",
            "B": "To secure equipment, aid in rescue operations, and ensure safety",
            "C": "To tie up fire hoses",
            "D": "To use as a jump rope for exercise"
          }
        },
        {
          "id": "sfd_basic_skills_286_ca0aa351",
          "question": "Which knot is most suitable for connecting two ropes of similar size in a firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "In-Line Figure Eight is used to join two ropes of similar size. It provides a strong, secure connection that is less likely to jam under pressure.",
          "options": {
            "A": "Bowline with a Yosemite Finish",
            "B": "In-Line Figure Eight",
            "C": "Round Turn with Two Half Hitches",
            "D": "Chain Stitch with Webbing"
          }
        },
        {
          "id": "sfd_basic_skills_286_fe8418f9",
          "question": "What is the primary advantage of using a 'Round Turn with Two Half Hitches' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'Round Turn with Two Half Hitches' is a versatile knot that is easy to untie even after being loaded, making it useful in firefighting operations where quick adjustments may be necessary.",
          "options": {
            "A": "It is used for lifting heavy objects",
            "B": "It is easy to untie after being loaded",
            "C": "It can be used to join two ropes",
            "D": "It is used to create a loop at the end of a rope"
          }
        },
        {
          "id": "sfd_basic_skills_286_0d72ca29",
          "question": "Which knot is best used for creating a secure loop at the end of a rope in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The 'Bowline with a Yosemite Finish' is a strong and secure knot that creates a loop at the end of a rope, making it ideal for various firefighting operations.",
          "options": {
            "A": "Bowline with a Yosemite Finish",
            "B": "Round Turn with Two Half Hitches",
            "C": "In-Line Figure Eight",
            "D": "Chain Stitch with Webbing"
          }
        },
        {
          "id": "sfd_basic_skills_286_913ba030",
          "question": "What is the main purpose of the 'Chain Stitch with Webbing' in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 'Chain Stitch with Webbing' is primarily used to shorten a rope or to store it neatly, which can be crucial in firefighting operations to maintain order and efficiency.",
          "options": {
            "A": "To create a loop at the end of a rope",
            "B": "To join two ropes of similar size",
            "C": "To shorten a rope or to store it neatly",
            "D": "To lift heavy objects"
          }
        },
        {
          "id": "sfd_basic_skills_286_019cbcf3",
          "question": "Which knot is not suitable for joining two ropes together in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The 'Chain Stitch with Webbing' is not suitable for joining two ropes together. It is primarily used to shorten a rope or to store it neatly.",
          "options": {
            "A": "In-Line Figure Eight",
            "B": "Round Turn with Two Half Hitches",
            "C": "Bowline with a Yosemite Finish",
            "D": "Chain Stitch with Webbing"
          }
        },
        {
          "id": "sfd_basic_skills_273_bb01402c",
          "question": "What is the impact of dynamic forces on firefighting operations involving ropes?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Dynamic forces, such as the energy from a falling object, can be transferred to a rope, causing dynamic tensioning. This can affect how the rope is handled during firefighting operations.",
          "options": {
            "A": "Dynamic forces make the rope more resistant to cutting.",
            "B": "Dynamic forces increase the residual strength of the rope.",
            "C": "Dynamic forces can cause tensioning of the rope, affecting its handling.",
            "D": "Dynamic forces have no impact on the rope."
          }
        },
        {
          "id": "sfd_basic_skills_273_48699977",
          "question": "What factors can reduce the residual strength of a rope used in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Several factors can reduce the residual strength of a rope, including high load forces, abrasion, arresting falls, corrosive chemicals, and sunlight.",
          "options": {
            "A": "Sunlight and corrosive chemicals only.",
            "B": "High load forces and abrasion only.",
            "C": "Arresting falls, corrosive chemicals, sunlight, and abrasion.",
            "D": "None of the above."
          }
        },
        {
          "id": "sfd_basic_skills_273_2eeba8f7",
          "question": "Why is it important to protect ropes from sharp objects during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "While modern rescue ropes can sustain considerable damage without failure, sharp objects can still reduce the rope's resistance to cutting, potentially compromising its safety during operations.",
          "options": {
            "A": "Sharp objects can completely cut through the rope instantly.",
            "B": "Sharp objects can reduce the rope's resistance to cutting, compromising its safety.",
            "C": "Sharp objects can cause the rope to stretch and lose its low-stretch properties.",
            "D": "Sharp objects have no effect on ropes."
          }
        },
        {
          "id": "sfd_basic_skills_273_1c4a31e8",
          "question": "What is the purpose of marking the ends and middle of a life-safety rope?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The ends of a life-safety rope are marked to help evenly distribute wear along the length of the rope over its life by alternating ends after each use. The middle is also marked as recommended by the manufacturer.",
          "options": {
            "A": "To identify the rope's manufacturer and date of manufacture.",
            "B": "To evenly distribute wear along the length of the rope over its life.",
            "C": "To indicate the rope's maximum load capacity.",
            "D": "To make the rope more visible during operations."
          }
        },
        {
          "id": "sfd_basic_skills_273_f3368445",
          "question": "What is the implication of a rope's residual strength on firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The residual strength of a rope, which is the remaining strength after it has been used for a period of time, can affect its safety and reliability during firefighting operations. Factors such as high load forces, abrasion, and arresting falls can reduce this strength.",
          "options": {
            "A": "A rope with high residual strength can be used to arrest falls without any risk.",
            "B": "A rope with low residual strength can still hold a 600 lb. rescue load even if it's 88% sawed through.",
            "C": "The residual strength of a rope determines its resistance to cutting.",
            "D": "The residual strength of a rope can affect its safety and reliability during operations."
          }
        },
        {
          "id": "sfd_basic_skills_272_b329b117",
          "question": "What is the primary use of the 8mm Accessory Cord in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The 8mm Accessory Cord is primarily used for tying a load releasing hitch, but can also be used for any accessory rigging need.",
          "options": {
            "A": "Hoisting equipment",
            "B": "Stabilizing vehicles",
            "C": "Tying a load releasing hitch",
            "D": "Slow pull tests"
          }
        },
        {
          "id": "sfd_basic_skills_272_a1466673",
          "question": "Why does a rope stand more force in a shock load situation than in a slow pull test?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In a shock load situation, the shock occurs in less than .5 seconds and the fibers do not have time to realign, allowing the rope to stand more force.",
          "options": {
            "A": "The rope is more elastic in a shock load situation",
            "B": "The fibers have time to realign in a shock load situation",
            "C": "The fibers do not have time to realign in a shock load situation",
            "D": "The rope is less elastic in a slow pull test"
          }
        },
        {
          "id": "sfd_basic_skills_272_2d0a9f3d",
          "question": "What is the breaking strength of the life safety rescue rope used by the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The life safety rescue rope used by the Seattle Fire Department is rated at 9000 lbs. breaking strength in slow pull tests.",
          "options": {
            "A": "600 lbs",
            "B": "9000 lbs",
            "C": "3630 lbf",
            "D": "15:1 safety factor"
          }
        },
        {
          "id": "sfd_basic_skills_272_4a7908d3",
          "question": "What is the purpose of utility ropes in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Utility ropes have multiple uses in firefighting operations such as hoisting equipment, stabilizing vehicles, medical calls, salvage, etc.",
          "options": {
            "A": "Used for tying a load releasing hitch",
            "B": "Used for slow pull tests",
            "C": "Used for hoisting equipment, stabilizing vehicles, medical calls, salvage, etc.",
            "D": "Used for accessory rigging needs"
          }
        },
        {
          "id": "sfd_basic_skills_272_df1b1bf1",
          "question": "What is the strength of 8mm material according to the manufacturer?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "According to the manufacturer, the strength of 8mm material is 3630 lbf.",
          "options": {
            "A": "9000 lbs",
            "B": "600 lbs",
            "C": "15:1 safety factor",
            "D": "3630 lbf"
          }
        },
        {
          "id": "sfd_basic_skills_287_4406663a",
          "question": "What is the potential firefighting application of a Prussik Hitch?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "A Prussik Hitch is a type of knot used in situations such as high-angle rescues to secure a person or object.",
          "options": {
            "A": "To secure a victim during a high-angle rescue",
            "B": "To extinguish a fire",
            "C": "To pump water",
            "D": "To ventilate a building"
          }
        },
        {
          "id": "sfd_basic_skills_287_8a69309f",
          "question": "What is the primary use of a Clove Hitch in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "A Clove Hitch is commonly used in firefighting to secure a line to an object.",
          "options": {
            "A": "To secure a hose to a hydrant",
            "B": "To tie a ladder to a building",
            "C": "To secure a line to an object",
            "D": "To connect two hoses together"
          }
        },
        {
          "id": "sfd_basic_skills_287_d64e4da1",
          "question": "What safety considerations should be taken into account when using a rope in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "In firefighting, safety is paramount. Therefore, using a flame-resistant rope is a crucial safety consideration.",
          "options": {
            "A": "The rope should be flame resistant",
            "B": "The rope should be brightly colored",
            "C": "The rope should be at least 50 feet long",
            "D": "The rope should be made of cotton"
          }
        },
        {
          "id": "sfd_basic_skills_287_160311e5",
          "question": "What is the importance of understanding different types of hitches in firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Understanding different types of hitches is important in firefighting to ensure the correct hitch is used for the task at hand, which can affect both safety and effectiveness of operations.",
          "options": {
            "A": "To ensure proper communication",
            "B": "To ensure the correct hitch is used for the task",
            "C": "To pass the firefighting exam",
            "D": "To make the job easier"
          }
        },
        {
          "id": "sfd_basic_skills_287_d27e05a1",
          "question": "Which chapter of the Seattle Fire Department's guide is dedicated to ropes?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the provided content, ropes are discussed in Chapter 6 of the Seattle Fire Department's guide.",
          "options": {
            "A": "Chapter 1",
            "B": "Chapter 3",
            "C": "Chapter 6",
            "D": "Chapter 9"
          }
        }
      ]
    },
    "7": {
      "chapter_id": "7",
      "trueFalseQuestions": [
        {
          "id": "sfd_basic_skills_292_d94b806d",
          "question": "Canvas tarps are generally repaired by the Fire Fighters on duty in the stations.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Small holes or tears in canvas tarps are generally repaired by the Fire Fighters on duty in the stations.' This indicates that firefighters are responsible for maintaining the condition of canvas tarps, which is important for ensuring they can effectively protect property during salvage and overhaul operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_292_b7e01751",
          "question": "Plastic tarps are not water tight.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Plastic tarps are exceptionally water tight.' This contradicts the statement that plastic tarps are not water tight. Knowing the properties of the tarps is crucial for firefighters as it helps them decide when to use which type of tarp, for instance, in situations where water protection is needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_292_12326da8",
          "question": "Plastic tarps are more expensive than canvas tarps.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Plastic tarps are relatively inexpensive.' This contradicts the statement that plastic tarps are more expensive than canvas tarps. Understanding the cost implications of equipment is important for firefighters in managing resources effectively.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_292_769f791f",
          "question": "Plastic tarps are used almost exclusively as protection from environmental elements for roof or window covers.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Although plastic tarps have some uses in common with canvas tarps, they are used almost exclusively as protection from environmental elements for roof or window covers.' This supports the statement and highlights the specific use of plastic tarps in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_292_59c73376",
          "question": "Canvas tarps are stored on the ladder truck in a duffle bag near other salvage and overhaul equipment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Plastic tarps are cut into 14 X 20 foot sections, rolled, taped and stored on the ladder truck in a duffle bag near other salvage and overhaul equipment.' This contradicts the statement that canvas tarps are stored in this way. Knowing where equipment is stored is vital for firefighters to quickly and efficiently retrieve and use it during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_302_caf41cc7",
          "question": "To construct a baby ladder catchall, a canvas tarp, a pike pole, a baby ladder, and utility rope or several utility straps are required.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states: 'To construct a baby ladder catchall, the following equipment is required: one canvas tarp, a pike pole (12 ft or longer), a baby ladder, and utility rope or several utility straps.' This directly supports the statement in the question. The correct selection and use of equipment is crucial in firefighting operations for safety and efficiency.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_302_125600d1",
          "question": "The pike pole should be placed inside the roll of the tarp to prevent tearing.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states: 'Roll the pike pole into the tarp, keeping the pike end outside of the roll to prevent tearing.' This directly contradicts the statement in the question. Proper handling and placement of equipment can prevent damage and ensure operational effectiveness in firefighting scenarios.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_302_dbe99c34",
          "question": "The utility rope or utility strap is used to tie the rungs together with a clove hitch to form a closed end.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states: 'Using either the utility rope or a utility strap, tie the rungs together with a clove hitch to form a closed end.' This directly supports the statement in the question. Understanding how to use equipment effectively is essential for firefighter safety and operational success.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_302_e6732026",
          "question": "The tarp is tied to the ladder at the base of the triangle.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states: 'Tie the tarp to the ladder at the apex of the triangle.' This directly contradicts the statement in the question. Correct positioning and securing of equipment is important in firefighting to ensure stability and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_302_64a57170",
          "question": "The loops of the clove hitch should straddle the rungs when securing the tarp and pole to the ladder.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states: 'The loops of the clove hitch should straddle the rungs.' This directly supports the statement in the question. Proper knot tying and placement can enhance the stability and safety of firefighting equipment setups.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_303_cc3f56ff",
          "question": "Bed fires do not generate a significant amount of smoke.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Bed fires are a common occurrence that can generate a lot of smoke.' This contradicts the question statement, indicating that bed fires do indeed produce a significant amount of smoke. This is an important consideration for firefighters as it impacts visibility and respiratory safety during operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_303_7155f63c",
          "question": "After extinguishing a bed fire, it should be assumed that the mattress is still smoldering.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'It must always be assumed that the mattress is still smoldering.' This supports the question statement. This is a critical safety consideration for firefighters as a smoldering mattress can re-ignite if exposed to sufficient oxygen.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_303_1364a6b9",
          "question": "A tarp is used after extinguishing a bed fire to wrap and remove the mattress from the structure.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Two members, then unpleat a tarp across the open end of the bed, atop the springs and perpendicular to the mattress.' This supports the question statement. Using a tarp in this manner helps to prevent re-ignition during removal and protects other parts of the structure.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_303_e1f4c68f",
          "question": "The tarp used in the removal of a smoldering mattress should be kept dry.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'then wet the tarp thoroughly with the pump can to protect it from being burned or scorched.' This contradicts the question statement, indicating that the tarp should be wet to prevent it from catching fire. This is an important operational consideration for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_303_c0af97e5",
          "question": "Ventilation strategies are not necessary in the case of a bed fire.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Related rescue, ventilation, extinguishment, salvage, etc. should be carried out as usual for any fire.' This contradicts the question statement, indicating that ventilation strategies are indeed necessary in the case of a bed fire. Proper ventilation can help to control the fire's growth and improve conditions for firefighters and potential victims.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_293_2be8b6fd",
          "question": "In the Accordion Fold method, the tarp should be held lengthwise between the members with the clean side up.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The tarp should be held lengthwise between the members, with the clean side up.' This indicates that the orientation of the tarp and its cleanliness are important factors in the Accordion Fold method. This could affect the effectiveness of the tarp in protecting property from water damage during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_293_89051d83",
          "question": "Both members grasp the tarp with their left hand one quarter distance in from the left edge and their right hand one quarter distance in from the right edge.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Both members grasp the tarp with their left hand one quarter distance in from the left edge and their right hand one quarter distance in from the right edge.' This demonstrates the importance of teamwork and coordination in firefighting operations, particularly when preparing equipment like tarps.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_293_00e96d3d",
          "question": "The person with the tarp\u2019s \u201cears\u201d to their right kneels at the end of the tarp, facing the long way, and grasps the tarp about 8\u201d to 12\u201d from their knee, pulling it toward them to make a 6\u201d fold.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The person with the tarp\u2019s \u201cears\u201d to their right, kneels at the end of the tarp, facing the long way, and grasps the tarp about 8\u201d to 12\u201d from their knee, pulling it toward them to make an 8\u201d to 12\u201d fold.' This contradicts the statement in the question, which incorrectly states a 6\u201d fold. The correct fold size is important for the effectiveness and stability of the tarp during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_293_c65b98ec",
          "question": "The Accordion Fold method begins with two members facing each other at opposite ends of the tarp.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Begin with two members facing each other at opposite ends of the tarp.' This indicates that the Accordion Fold method requires two firefighters and their positioning relative to the tarp is important for the correct execution of the method. This could affect the speed and efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_293_781a5cd8",
          "question": "While pulling against each other, the members flip the outside folds down and into the center.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'While pulling against each other, the members flip the outside folds up and into the center.' This contradicts the statement in the question, which incorrectly states that the folds are flipped down. The correct direction of the folds is important for the effectiveness and stability of the tarp during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_298_6311877b",
          "question": "The member throwing the tarp should hold it in the right hand with the ears towards him/her.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The member throwing the tarp holds it in the left hand with the ears towards him/her.' This contradicts the statement in the question. The correct hand to hold the tarp is the left hand, not the right. This is important for proper tarp deployment and ensuring the object is covered effectively during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_298_16dd686e",
          "question": "If more than one tarp is required to cover an object, a second tarp is thrown alongside the edge of the first tarp and five feet away from it.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If more than one tarp is required to cover an object, a second tarp is thrown alongside the edge of the first tarp and five feet away from it.' This supports the statement in the question. Proper tarp placement is crucial in firefighting to prevent water damage and ensure effective salvage operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_298_9fbc58d7",
          "question": "When using multiple tarps, there is no need to make a water tight roll in the same direction the water will flow.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If more than one tarp is used, make a water tight roll in the same direction the water will flow.' This contradicts the statement in the question. Making a water tight roll is important to prevent water seepage and further damage to the object being covered during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_298_7b053091",
          "question": "Excess tarp, if any, should be left hanging.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Excess tarp, if any, is tucked under.' This contradicts the statement in the question. Tucking under the excess tarp is important to ensure a secure and effective cover during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_298_8b9be7e7",
          "question": "Pieces of wood can be used to indicate glass where required.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Use pieces of wood to indicate glass where required.' This supports the statement in the question. Indicating the presence of glass is important for safety considerations during firefighting operations to prevent injuries from broken or hidden glass pieces.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_294_4dc97f15",
          "question": "The pop flake should be facing a different direction than the bottom flake.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The pop flake should be facing the same direction as the bottom flake.' This means that the direction of the pop flake and the bottom flake should be the same, not different. This is important for the proper formation of the tarp and can affect the efficiency of firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_294_60509320",
          "question": "When the tarp is made up properly, the ears will always be contained in the top and bottom flakes.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "According to the text, 'When made up properly, the ears will always be contained in the top and bottom flakes.' This indicates that the correct placement of the ears is within the top and bottom flakes. This is crucial for the correct setup of the tarp, which can impact the effectiveness of salvage operations during firefighting.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_294_cde47328",
          "question": "The location of the ears does not indicate the center of the tarp.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly states, 'The location of the ears will indicate the center of the tarp.' This contradicts the statement that the location of the ears does not indicate the center of the tarp. Understanding this is important for firefighters as it helps in proper tarp setup, which can be critical during salvage operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_294_2b0efe05",
          "question": "The process of forming pleats continues until the end of the tarp is reached.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, 'Continue grasping and pulling the tarp, stacking and creasing the pleats until the end of the tarp is reached.' This supports the statement that the process of forming pleats continues until the end of the tarp. This knowledge is essential for firefighters as it ensures the proper setup of the tarp, which can aid in protecting property from further damage during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_294_dd7b7813",
          "question": "The ears of the tarp should point in different directions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'the ears will always be contained in the top and bottom flakes, and will both be pointing in the same direction.' This contradicts the statement that the ears should point in different directions. Understanding the correct positioning of the tarp's ears is important for firefighters as it can affect the efficiency and effectiveness of salvage operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_304_13dbdf95",
          "question": "When removing a mattress from a burning building, it is acceptable to throw it out a window or off the fire escape.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Don\u2019t throw it out a window, or off the fire escape. Use the stairs.' This contradicts the statement in the question. It is important for firefighters to follow this guideline to avoid causing additional damage or potential injury.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_304_fef00473",
          "question": "When covering unwanted openings in buildings, using a plastic tarp and lath is the only method available to firefighters.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Although this method works extremely well in most circumstances, and has the benefit of being water tight, it is not the only means available to the fire fighter.' This contradicts the statement in the question. Understanding multiple methods for covering openings can help firefighters adapt to different situations and conditions.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_304_9d9960ed",
          "question": "When covering a hole with a plastic tarp, it should be cut two feet wider and longer than the hole.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'When the equipment is assembled, cut a piece of plastic to the appropriate size. Cut it two feet wider then the width of the hole and two feet longer then the length of the hole.' This supports the statement in the question. Proper sizing of the tarp can ensure a secure and effective cover for the hole, preventing further damage or exposure to elements.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_304_cdc1d412",
          "question": "When removing a mattress from a burning building, both members should twist the tarp in opposite directions.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Both members twist in clockwise direction so that the tarp will not unwind when the mattress is picked up.' This contradicts the statement in the question. Following this guideline can help ensure the mattress is securely wrapped and can be safely removed from the building.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_304_b87b3329",
          "question": "When using lath to secure a plastic tarp, overlapping the ends of the lath by 3 or 4 inches is recommended.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'If more then one piece of lath is used, always overlap the ends of the lath, one on top of the other by 3 or 4 inches.' This supports the statement in the question. Properly overlapping the lath can help ensure the tarp is securely fastened and the hole is effectively covered.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_305_95ef09bb",
          "question": "The lath should span the width of the hole with no excess on each side.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The lath should span the width of the hole with six inches of excess on each side.' This contradicts the statement in the question. The excess lath is important to ensure a secure and taut cover over the hole, which is crucial in preventing further fire spread and maintaining structural integrity.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_305_3992580d",
          "question": "While rolling the lath under the plastic, it is important to maintain tension on the plastic.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text says, 'Pull down while rolling, keeping tension on the plastic. This will ensure a tight roll and a taut surface across the face of the hole.' This supports the statement in the question. Maintaining tension on the plastic while rolling the lath is essential to create a taut surface, which is important in fire control operations to prevent smoke and fire from spreading through the hole.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_305_0ba6e954",
          "question": "The lath should be nailed into place without maintaining any tautness.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Nail the lath into the place while maintaining as much tautness as possible.' This contradicts the statement in the question. Maintaining tautness while nailing the lath into place is crucial to ensure a tight seal over the hole, which can prevent further fire spread and smoke damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_305_7d0fb7ef",
          "question": "Before rolling the lath into the plastic on the left side of the hole, the top and bottom of the left side plastic should be folded in at a slight angle.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text says, 'Before rolling the lath into the plastic, fold the top and bottom of the left side plastic in at a slight angle.' This supports the statement in the question. Folding the plastic at a slight angle before rolling the lath can help maintain a taut and secure cover over the hole, which is important in firefighting operations to prevent fire and smoke spread.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_305_aac0e028",
          "question": "It is not important to maintain tautness while rolling the final side of the lath.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'It is especially important to maintain tautness while rolling the final side.' This contradicts the statement in the question. Maintaining tautness while rolling the final side of the lath is crucial to ensure a tight seal over the hole, which can prevent further fire spread and smoke damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_295_794ef690",
          "question": "Rubber bands are used to hold the ends of the folded tarp ready on the apparatus in the Seattle Fire Department.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Rubber bands (inner tube cross sections) are then placed over the ends of the folded tarp to hold it ready on the apparatus.' This indicates that rubber bands are indeed used to secure the tarp. This is important for firefighting operations as it ensures the tarp is ready for immediate use when needed.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_295_33f89109",
          "question": "The phrase 'Ears towards you, and towards your work' is a reminder of how to hold a hose.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text mentions, 'when holding the accordion folded tarp for use, \"Ears towards you, and towards your work.\"' This phrase is related to holding a tarp, not a hose. Understanding this correctly is crucial for effective use of the tarp during salvage operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_295_da5d6c76",
          "question": "The tarp is held ready on the apparatus without any securing mechanism.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text clearly mentions, 'Rubber bands (inner tube cross sections) are then placed over the ends of the folded tarp to hold it ready on the apparatus.' This contradicts the statement that the tarp is held without any securing mechanism. Properly securing the tarp ensures it stays in place during transit and is ready for use upon arrival at the scene.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_295_a81d1e93",
          "question": "The 'Ears towards you, and towards your work' phrase is a guideline for holding the accordion folded tarp.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'when holding the accordion folded tarp for use, \"Ears towards you, and towards your work.\"' This confirms that the phrase is a guideline for holding the tarp. Following this guideline can ensure the tarp is deployed correctly and efficiently during salvage operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_295_eecd3130",
          "question": "The information provided is from Chapter 7 titled 'Ventilation strategies'.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text indicates, 'Chapter 7 \u00b7 Salvage 293.' This contradicts the statement that the information is from a chapter titled 'Ventilation strategies'. The correct chapter title is 'Salvage'. Understanding the correct chapter title can help students locate and review the relevant information.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_299_b104a670",
          "question": "The doughnut rolls should be positioned at seventeen foot intervals.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'position the doughnut rolls at the seventeen foot intervals.' This indicates that the doughnut rolls should be placed at intervals of seventeen feet. This is important for firefighting operations as it ensures the water can travel the necessary distance.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_299_ceccd25e",
          "question": "The upper chute should be kept outside the lower chute.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'keeping the upper chute within the lower chute.' This contradicts the statement that the upper chute should be kept outside the lower chute. This is crucial for firefighting operations to ensure the water flows correctly down the chute.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_299_55c9cac4",
          "question": "There should be a two-foot aisle way on the inside of the stairwell.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Leave at least a one -foot aisle way on the inside of the stairwell.' This contradicts the statement that there should be a two-foot aisle way. This is important for firefighter safety as it ensures there is enough space for firefighters to move within the stairwell.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_299_668847dd",
          "question": "The bottom tarp should be unrolled first.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Unroll the bottom tarp first.' This supports the statement that the bottom tarp should be unrolled first. This is a key operational consideration to ensure the correct setup of the water chute.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_299_4385dc67",
          "question": "The next highest tarp should not overlap the lower chute.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Unroll the next highest tarp, overlapping it one foot past the top of the lower chute.' This contradicts the statement that the next highest tarp should not overlap the lower chute. This is important for firefighting operations to ensure the water flows correctly down the chute.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_296_bbd433a0",
          "question": "The Doughnut Roll method begins by completely unfolding the tarp.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Two members begin by un-pleating a tarp and laying it, still folded, on the floor.' This contradicts the statement that the method begins by completely unfolding the tarp. In firefighting operations, understanding the correct order of steps in a procedure is crucial for efficiency and safety.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_296_6571790a",
          "question": "In the Doughnut Roll method, both sides of the tarp are rolled to the center.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Both members then move around to the opposite side, unfold the other half of the tarp, and then roll again so that both sides are rolled to the center.' This supports the statement that in the Doughnut Roll method, both sides of the tarp are rolled to the center. This method ensures that the tarp is compact and easy to handle during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_296_bbe82269",
          "question": "The Doughnut Roll method requires only one firefighter to execute.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Two members begin by un-pleating a tarp... The members each grasp a corner... Both members then move around to the opposite side...' This contradicts the statement that only one firefighter is required. Understanding the manpower needed for a task is important for effective resource allocation during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_296_c18ae5ee",
          "question": "The Doughnut Roll method involves rolling the tarp lengthwise.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'The tarp is then rolled lengthwise, much the same as single rolling a length of hose.' This supports the statement that the Doughnut Roll method involves rolling the tarp lengthwise. This step helps to make the tarp easier to transport and deploy during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_296_6e989e8b",
          "question": "In the Doughnut Roll method, tension is not necessary when rolling the tarp.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members each grasp a corner on the long side of the unfolded half of the tarp and, while pulling tension against each other, roll the tarp to the center.' This contradicts the statement that tension is not necessary when rolling the tarp. Maintaining tension ensures a tight roll, which is important for efficient storage and deployment of the tarp in firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_297_33dc124d",
          "question": "The tarp should be held across both arms with the ears facing away from the body and the object to be covered.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'One member holds the tarp across both arms with the ears towards his/her body and toward the object to be covered.' This contradicts the statement in the question. The correct positioning of the tarp is crucial for effective coverage and protection of objects during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_297_da017d63",
          "question": "The center of the tarp should be placed alongside the centerline of the object to be covered.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Place the center of the tarp (marked by the ears) alongside the centerline of the object to be covered.' This supports the statement in the question. Proper positioning of the tarp ensures maximum coverage and protection of objects from water damage during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_297_b0c7bdcc",
          "question": "A piece of lath or scrap wood laid parallel over the tarp indicates that hazardous materials have been covered.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'A piece of lath or scrap wood laid parallel over the tarp indicates glass or fragile objects have been covered.' This contradicts the statement in the question. The correct identification of covered objects is important for the safety of firefighters and the preservation of property.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_297_8ff0a7a0",
          "question": "If more than one tarp is required to cover an object, the edges of the tarps should be overlapped by one foot and rolled together in the opposite direction of the water flow.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'If more than one tarp is required to cover an object, overlap the edges of the tarps by one foot and roll them together in the same direction as the water will flow.' This contradicts the statement in the question. Proper tarp placement and alignment are crucial for preventing water damage during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_297_fdd6091b",
          "question": "The second member grasps the top fold with both hands and walks backward until the tarp is stretched taut.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'A second member then grasps the top fold with both hands and walks backward until the tarp is stretched taut.' This supports the statement in the question. Proper tarp tension is important for ensuring effective coverage and protection during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_300_beab87c9",
          "question": "The source of the water should be reached before water flow is established.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Continue up the stairwell in the same manner until the source of the water is reached and water flow is established.' This means that the firefighters must first locate the source of the water before they can establish a water flow. This is important in firefighting operations as it helps in controlling the spread of water, which can cause additional damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_300_38b7a331",
          "question": "Additional tarps should be used to bank the chutes around the turns to prevent overflow.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Additional tarps, still folded, should be used to bank the chutes around the turns to prevent overflow.' This means that using additional tarps can help in managing water flow and preventing overflow, which is crucial in firefighting operations to avoid unnecessary water damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_300_41c8a823",
          "question": "The tarp is unfolded completely before it is rolled into a point.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members then grasp the corners on the long side of the unfolded half of the tarp and, while pulling against each other, roll the tarp into a point.' This contradicts the statement as it specifies that only half of the tarp is unfolded before it is rolled. This is important in firefighting operations as it affects how the tarp is used to manage water flow.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_300_8ebe7326",
          "question": "The members move counterclockwise to the short edge and roll that side in three feet.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The members then move clockwise to the short edge and roll that side in three feet.' This contradicts the statement as it specifies that the members move clockwise, not counterclockwise. This is important in firefighting operations as it affects the way the tarp is prepared for use.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_300_ff1e77d9",
          "question": "The tarp is rolled into a point one foot short of the first crease.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'roll the tarp into a point one foot short of the first crease.' This supports the statement that the tarp is rolled into a point one foot short of the first crease. This is important in firefighting operations as it affects how the tarp is used to manage water flow.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_290_0cd9921a",
          "question": "Salvage operations only focus on saving the building structure, not the contents inside.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Salvage is the protection of buildings and their contents from unnecessary damage due to water, smoke, and other elements, both during and after a fire.' This contradicts the statement, as it clearly includes the protection of contents inside the building. For firefighters, this means they need to consider not only the structural integrity of the building but also the preservation of the contents inside during salvage operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_290_3f40cef5",
          "question": "Salvage operations can help families return to their homes within a few hours after a fire.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Efficiently performed salvage work can allow families to continue living in their homes within a few hours after a fire has occurred.' This supports the statement and shows the importance of efficient salvage operations in reducing the impact of fire on people's lives. Firefighters should therefore strive to perform salvage operations efficiently to minimize displacement time for affected families.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_290_46fa13e1",
          "question": "Firefighters should only consider salvage considerations after the fire has been completely extinguished.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Salvage considerations should be present during every stage of firefighting operations.' This contradicts the statement, indicating that salvage considerations should be a part of the firefighting strategy from the beginning, not just after the fire is extinguished. This implies that firefighters should always be thinking about how to minimize damage and preserve property, even while actively fighting the fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_290_27264582",
          "question": "One of the performance goals for firefighters is to demonstrate proper tarp folding, rolling, throwing, and deployment.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Firefighters shall be able to: - Demonstrate proper tarp folding, rolling, throwing, and deployment.' This supports the statement, indicating that these skills are important for effective salvage operations. Firefighters should therefore be well-trained in these techniques to protect property from further damage during and after a fire.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_290_a36688f4",
          "question": "Salvage operations do not have any impact on the community's perception of the fire department.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'This in turn promotes community goodwill toward the fire department, and fosters civic appreciation for a job done well under adverse conditions.' This contradicts the statement, showing that effective salvage operations can positively influence the community's perception of the fire department. Firefighters should therefore understand that their actions during salvage operations can have a broader impact on their relationship with the community.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_291_18ad558b",
          "question": "The tarps used by the Seattle Fire Department are resistant to water and mildew.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Seattle Fire Department tarps are treated to be water and mildew resistant.' This means that the tarps can withstand exposure to water and mildew, which is crucial in firefighting operations as it ensures the durability and longevity of the tarps.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_291_f0f51de2",
          "question": "The 'SFD' stenciled logo on the tarp indicates the dirty side of the tarp.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'The 'SFD' stenciled logo is located in the center of the tarp, on one side only, and generally indicates the side of the tarp that is kept clean.' This contradicts the statement in the question, indicating that the logo actually marks the clean side of the tarp. This is important for firefighters to know, as the clean side is typically used to cover upholstered furniture to prevent damage.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_291_e792838f",
          "question": "Tarp inventory is tracked by the Services Division.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'However, tarp inventory is no longer tracked by the Services Division.' This contradicts the statement in the question. This implies that the responsibility of maintaining the tarp inventory lies with the Ladder Company Captains, which is a key operational detail for firefighters.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_291_cc310e6d",
          "question": "Tarps are only carried on ladder trucks and engines.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'Tarps are carried on all ladder trucks and engines, on some aid cars, and on various other special purpose apparatus.' This contradicts the statement in the question, indicating that tarps are also carried on aid cars and other special purpose apparatus. This is important for firefighters to know, as it expands the range of equipment where tarps can be found and used.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_291_5a6d44af",
          "question": "Tarps can be used for the construction of water chutes, dikes, and diverters.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'They are also necessary for the construction of water chutes, dikes, and diverters.' This supports the statement in the question. This is a key tactical consideration for firefighters, as it highlights the versatility of tarps in firefighting operations beyond just covering and protecting items.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_301_79d34d20",
          "question": "The catchall constructed by firefighters can hold approximately 60 gallons of water for each inch of depth.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text states, 'Every 8\u2019 x 12\u2019 foot catchall will hold approximately 60 gallons of water for each inch of depth.' This supports the statement and implies that understanding the capacity of constructed catchalls is important for effective water management during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_301_c24b0209",
          "question": "The Marine Unit should be requested for all water jobs.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text specifies, 'Consider requesting the Marine Unit for larger water jobs.' This contradicts the statement as it indicates that the Marine Unit is not necessary for all water jobs, but rather for larger ones. This is a tactical consideration during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_301_a5ccdd88",
          "question": "The catchalls can be constructed and placed with their edges overlapping to form one large floor.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text mentions, 'Similar catchalls can be constructed and placed with their edges overlapping so that one large floor is formed.' This supports the statement and suggests that understanding how to construct and position catchalls can affect the efficiency of water containment during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_301_94e8eda7",
          "question": "The Marine Unit carries regular de-watering equipment.",
          "type": "true_false",
          "correctAnswer": false,
          "explanation": "The text states, 'They carry specialized de-watering equipment, capable of removing large quantities of water quickly.' This contradicts the statement, indicating that the Marine Unit carries specialized, not regular, de-watering equipment. This is an equipment and operational concern during firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        },
        {
          "id": "sfd_basic_skills_301_75bfdd96",
          "question": "The catchall measures 8\u2019 x 12\u2019 after repeating the operation on the opposite short side.",
          "type": "true_false",
          "correctAnswer": true,
          "explanation": "The text says, 'Repeat the operation on the opposite short side. The resulting catchall measures 8\u2019 x 12\u2019.' This supports the statement and implies that understanding the size of the catchall is important for planning and executing firefighting operations.",
          "options": [
            "True",
            "False"
          ]
        }
      ],
      "multipleChoiceQuestions": [
        {
          "id": "sfd_basic_skills_292_637b6365",
          "question": "What is the primary use of plastic tarps in firefighting operations according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, plastic tarps are used almost exclusively as protection from environmental elements for roof or window covers.",
          "options": {
            "A": "To repair small holes or tears",
            "B": "To protect firefighters from hazardous dust",
            "C": "To protect from environmental elements for roof or window covers",
            "D": "To be used as a fire blanket"
          }
        },
        {
          "id": "sfd_basic_skills_292_767758d1",
          "question": "Why are plastic tarps considered practical for long term uses in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that plastic tarps are exceptionally watertight and relatively inexpensive, making them practical for long term uses.",
          "options": {
            "A": "Because they are watertight and inexpensive",
            "B": "Because they can be repaired by firefighters on duty",
            "C": "Because they can be nailed through the grommet holes",
            "D": "Because they are resistant to sharp or jagged objects"
          }
        },
        {
          "id": "sfd_basic_skills_292_d3f4ad36",
          "question": "What is a disadvantage of using plastic tarps in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that plastic tarps tear easily and are prone to slip off of the objects they are meant to protect.",
          "options": {
            "A": "They are expensive",
            "B": "They tear easily and are prone to slip off",
            "C": "They are not watertight",
            "D": "They are difficult to store"
          }
        },
        {
          "id": "sfd_basic_skills_292_305d0946",
          "question": "How are plastic tarps stored for firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, plastic tarps are stored on the ladder truck in a duffle bag near other salvage and overhaul equipment.",
          "options": {
            "A": "In a duffle bag near other salvage and overhaul equipment",
            "B": "In the fire station",
            "C": "In the fire truck's water tank",
            "D": "In the firefighter's personal bag"
          }
        },
        {
          "id": "sfd_basic_skills_292_4c04908d",
          "question": "Who is generally responsible for repairing small holes or tears in canvas tarps?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that small holes or tears in canvas tarps are generally repaired by the Fire Fighters on duty in the stations.",
          "options": {
            "A": "The fire chief",
            "B": "The Fire Fighters on duty in the stations",
            "C": "The local community",
            "D": "The manufacturer"
          }
        },
        {
          "id": "sfd_basic_skills_302_df5ce9be",
          "question": "What is the purpose of using a pike pole in the construction of a baby ladder catchall?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The pike pole is placed along the edge of the tarp at the base of the ladder triangle and rolled into the tarp. It is then lifted and tied in place across the top of the spread end of the ladder, serving as a support for the tarp.",
          "options": {
            "A": "To serve as a handle for carrying the catchall",
            "B": "To provide a base for the ladder triangle",
            "C": "To secure the tarp to the ladder",
            "D": "To serve as a support for the tarp"
          }
        },
        {
          "id": "sfd_basic_skills_302_7ebf71ea",
          "question": "Why is it important to keep the pike end of the pole outside of the roll when constructing a baby ladder catchall?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Keeping the pike end outside of the roll prevents the sharp end of the pole from tearing the tarp during the construction of the catchall.",
          "options": {
            "A": "To prevent tearing of the tarp",
            "B": "To provide additional support for the ladder",
            "C": "To make the catchall easier to carry",
            "D": "To ensure the stability of the catchall"
          }
        },
        {
          "id": "sfd_basic_skills_302_0d7a3104",
          "question": "What is the role of the utility rope or strap in the construction of a baby ladder catchall?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The utility rope or strap is used to tie the rungs of the ladder together with a clove hitch to form a closed end.",
          "options": {
            "A": "To secure the tarp to the ladder",
            "B": "To tie the rungs together to form a closed end",
            "C": "To provide a handle for carrying the catchall",
            "D": "To secure the pike pole to the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_302_048d66a4",
          "question": "Why is it necessary to dog the fly on the bottom rung of the baby ladder when constructing a catchall?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Dogging the fly on the bottom rung and spreading the top ends helps to create a triangle shape with the ladder, which is essential for the construction of the catchall.",
          "options": {
            "A": "To provide additional support for the tarp",
            "B": "To prevent the ladder from collapsing",
            "C": "To create a triangle shape with the ladder",
            "D": "To secure the pike pole to the ladder"
          }
        },
        {
          "id": "sfd_basic_skills_302_82fc2098",
          "question": "What is the purpose of lifting the catchall and tucking the tarp edges under the ladder?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Lifting the catchall and tucking the tarp edges under the ladder helps to secure the tarp to the ladder, ensuring the stability and effectiveness of the catchall.",
          "options": {
            "A": "To secure the tarp to the ladder",
            "B": "To provide additional support for the catchall",
            "C": "To prevent the tarp from tearing",
            "D": "To make the catchall easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_303_3771707a",
          "question": "What is the primary reason for removing a smoldering or freshly extinguished mattress from a building?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The primary reason for removing a smoldering or freshly extinguished mattress from a building is to prevent it from re-igniting when exposed to oxygen.",
          "options": {
            "A": "To prevent the mattress from re-igniting",
            "B": "To make room for other firefighting activities",
            "C": "To protect the tarp from being burned",
            "D": "To reduce the amount of smoke in the building"
          }
        },
        {
          "id": "sfd_basic_skills_303_46a9953a",
          "question": "Why is it important to wet the tarp thoroughly with the pump can during the mattress removal procedure?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The tarp is wetted thoroughly to protect it from being burned or scorched by the smoldering or freshly extinguished mattress.",
          "options": {
            "A": "To make the tarp easier to unfold",
            "B": "To protect the tarp from being burned or scorched",
            "C": "To cool down the mattress",
            "D": "To make the tarp heavier and more stable"
          }
        },
        {
          "id": "sfd_basic_skills_303_83d62f81",
          "question": "What should always be assumed about a mattress involved in a fire?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "It should always be assumed that a mattress involved in a fire is still smoldering, and the introduction of enough oxygen could cause it to re-ignite.",
          "options": {
            "A": "It is completely extinguished",
            "B": "It is still smoldering",
            "C": "It is safe to touch",
            "D": "It is not a source of smoke"
          }
        },
        {
          "id": "sfd_basic_skills_303_62a429fd",
          "question": "What is the first step in the procedure for removing a smoldering or freshly extinguished mattress from a building?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in the procedure for removing a smoldering or freshly extinguished mattress from a building is to roll the mattress up to one end of the bed.",
          "options": {
            "A": "Unpleat a tarp across the open end of the bed",
            "B": "Wet the tarp thoroughly with the pump can",
            "C": "Roll the mattress up to one end of the bed",
            "D": "Remove the mattress from the building"
          }
        },
        {
          "id": "sfd_basic_skills_303_4295daa7",
          "question": "What is the main goal of the procedure for removing a smoldering or freshly extinguished mattress from a building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The main goal of the procedure for removing a smoldering or freshly extinguished mattress from a building is to protect life safety and conserve property.",
          "options": {
            "A": "To reduce the amount of smoke in the building",
            "B": "To protect life safety and conserve property",
            "C": "To prevent the mattress from re-igniting",
            "D": "To salvage the mattress"
          }
        },
        {
          "id": "sfd_basic_skills_293_f40b62f3",
          "question": "What is the correct initial position for two firefighters preparing to fold a tarp according to the Seattle Fire Department's guidelines?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "According to the guidelines, two firefighters should begin by facing each other at opposite ends of the tarp.",
          "options": {
            "A": "Standing back to back holding the tarp",
            "B": "Facing each other at opposite ends of the tarp",
            "C": "Standing side by side holding the tarp",
            "D": "Facing each other at the same end of the tarp"
          }
        },
        {
          "id": "sfd_basic_skills_293_a7def899",
          "question": "What is the significance of having the clean side of the tarp up when folding it?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Having the clean side up ensures that the tarp is ready for immediate use in salvage operations, preventing further damage to property.",
          "options": {
            "A": "It prevents the tarp from getting dirty",
            "B": "It is easier to fold the tarp this way",
            "C": "It ensures the tarp is ready for immediate use in salvage operations",
            "D": "It is a traditional method with no specific significance"
          }
        },
        {
          "id": "sfd_basic_skills_293_56ff85d2",
          "question": "How should the firefighters grasp the tarp for the Accordion Fold?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The guidelines specify that both members should grasp the tarp with their left hand one quarter distance in from the left edge and their right hand one quarter distance in from the right edge.",
          "options": {
            "A": "Both members grasp the tarp with their left hand at the left edge and their right hand at the right edge",
            "B": "Both members grasp the tarp with their left hand one quarter distance in from the left edge and their right hand one quarter distance in from the right edge",
            "C": "Both members grasp the tarp at the center",
            "D": "Both members grasp the tarp at the corners"
          }
        },
        {
          "id": "sfd_basic_skills_293_133760bf",
          "question": "What is the next step after the firefighters flip the outside folds up and into the center?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "After flipping the outside folds up and into the center, the person with the tarp\u2019s \u201cears\u201d to their right kneels at the end of the tarp and makes a fold.",
          "options": {
            "A": "The person with the tarp\u2019s \u201cears\u201d to their right kneels at the end of the tarp and makes a fold",
            "B": "The person with the tarp\u2019s \u201cears\u201d to their left kneels at the end of the tarp and makes a fold",
            "C": "Both firefighters kneel at their respective ends of the tarp and make a fold",
            "D": "Both firefighters continue to flip the outside folds up and into the center"
          }
        },
        {
          "id": "sfd_basic_skills_293_27390efd",
          "question": "What is the correct size of the fold to be made by the firefighter at the end of the tarp?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The firefighter at the end of the tarp should make an 8\u201d to 12\u201d fold.",
          "options": {
            "A": "4\u201d to 6\u201d fold",
            "B": "8\u201d to 12\u201d fold",
            "C": "16\u201d to 20\u201d fold",
            "D": "24\u201d to 28\u201d fold"
          }
        },
        {
          "id": "sfd_basic_skills_298_f9e83b41",
          "question": "What is the correct method for a firefighter to hold a tarp before throwing it over an object?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The firefighter should hold the tarp in the left hand with the ears towards him/her, as described in the text.",
          "options": {
            "A": "Hold it in the right hand with the ears towards him/her",
            "B": "Hold it in the left hand with the ears towards him/her",
            "C": "Hold it in the right hand with the ears away from him/her",
            "D": "Hold it in the left hand with the ears away from him/her"
          }
        },
        {
          "id": "sfd_basic_skills_298_85469221",
          "question": "What is the correct distance to throw a second tarp alongside the edge of the first tarp?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text specifies that a second tarp should be thrown five feet away from the first one.",
          "options": {
            "A": "One foot away",
            "B": "Three feet away",
            "C": "Five feet away",
            "D": "Seven feet away"
          }
        },
        {
          "id": "sfd_basic_skills_298_ace9e3df",
          "question": "What should be done with excess tarp, if any, after covering an object?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text advises to tuck any excess tarp under.",
          "options": {
            "A": "Leave it hanging",
            "B": "Cut it off",
            "C": "Tuck it under",
            "D": "Roll it up"
          }
        },
        {
          "id": "sfd_basic_skills_298_b16af04c",
          "question": "What should be done if more than one tarp is used to cover an object?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "If more than one tarp is used, a water tight roll should be made in the same direction the water will flow.",
          "options": {
            "A": "Make a water tight roll in the opposite direction the water will flow",
            "B": "Make a water tight roll in the same direction the water will flow",
            "C": "Leave a gap between the tarps",
            "D": "Overlap the tarps without making a water tight roll"
          }
        },
        {
          "id": "sfd_basic_skills_298_b18219a5",
          "question": "What should be used to indicate glass where required?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text specifies that pieces of wood should be used to indicate glass where required.",
          "options": {
            "A": "Pieces of wood",
            "B": "Pieces of metal",
            "C": "Pieces of plastic",
            "D": "Pieces of glass"
          }
        },
        {
          "id": "sfd_basic_skills_294_dcd15c25",
          "question": "What is the significance of the location of the ears in the tarp setup?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "According to the text, the location of the ears will indicate the center of the tarp.",
          "options": {
            "A": "They indicate the direction of the wind",
            "B": "They indicate the direction of the fire",
            "C": "They indicate the center of the tarp",
            "D": "They indicate the size of the tarp"
          }
        },
        {
          "id": "sfd_basic_skills_294_e2e65fb2",
          "question": "What should be the orientation of the pop flake in relation to the bottom flake?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that the pop flake should be facing the same direction as the bottom flake.",
          "options": {
            "A": "They should be facing opposite directions",
            "B": "They should be facing the same direction",
            "C": "The orientation doesn't matter",
            "D": "The pop flake should be facing the wind direction"
          }
        },
        {
          "id": "sfd_basic_skills_294_0f33f414",
          "question": "What is the purpose of forming pleats when setting up a tarp?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "While the text does not explicitly state the purpose of the pleats, it can be inferred that they are used to ensure the tarp is properly aligned and set up.",
          "options": {
            "A": "To make the tarp look aesthetically pleasing",
            "B": "To increase the strength of the tarp",
            "C": "To ensure the tarp is properly aligned",
            "D": "To make the tarp easier to fold"
          }
        },
        {
          "id": "sfd_basic_skills_294_b8c09d8b",
          "question": "What should be the final position of the ears when the tarp is properly made up?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text specifies that when the tarp is properly made up, the ears will both be pointing in the same direction.",
          "options": {
            "A": "They should be pointing in opposite directions",
            "B": "They should be pointing in the same direction",
            "C": "They should be pointing towards the wind",
            "D": "They should be pointing towards the fire"
          }
        },
        {
          "id": "sfd_basic_skills_294_e9c592df",
          "question": "What is the importance of the tarp setup in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The chapter title 'Salvage' suggests that the tarp setup is used for salvage operations in firefighting.",
          "options": {
            "A": "It helps in directing the water flow",
            "B": "It provides a barrier against the fire",
            "C": "It is used for salvage operations",
            "D": "It is used as a makeshift shelter"
          }
        },
        {
          "id": "sfd_basic_skills_304_d364801b",
          "question": "What is the recommended method for removing a rolled mattress from a building during a fire?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text suggests that the safest method for removing a rolled mattress from a building during a fire is to carry it down the stairs. Using the elevator or throwing it out a window are specifically advised against.",
          "options": {
            "A": "Throw it out a window",
            "B": "Use the elevator",
            "C": "Carry it down the stairs",
            "D": "Leave it in the building"
          }
        },
        {
          "id": "sfd_basic_skills_304_8a2472bc",
          "question": "What is one of the benefits of using a plastic tarp and lath to cover unwanted openings in buildings during a fire?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that using a plastic tarp and lath to cover unwanted openings in buildings during a fire is beneficial because it is watertight. It is not always the most secure method, it cannot be nailed to any surface, and it is not the only method available to firefighters.",
          "options": {
            "A": "It is always the most secure method",
            "B": "It is watertight",
            "C": "It can be nailed to any surface",
            "D": "It is the only method available to firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_304_09d4bcad",
          "question": "What should be done with the mattress once it has been safely removed from the building?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Once the mattress has been safely removed from the building, it should be unrolled from the tarp and overhauled as quickly as possible.",
          "options": {
            "A": "Leave it rolled in the tarp",
            "B": "Unroll it from the tarp and overhaul it as quickly as possible",
            "C": "Throw it out a window",
            "D": "Use it to cover unwanted openings in the building"
          }
        },
        {
          "id": "sfd_basic_skills_304_afd685fc",
          "question": "When covering a hole with a plastic tarp, what is the recommended size of the tarp in relation to the hole?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that when covering a hole with a plastic tarp, the tarp should be cut two feet wider and longer than the hole. This will result in a uniform 12 inch overlap on all four sides when the plastic is centered over the hole.",
          "options": {
            "A": "The same size as the hole",
            "B": "Two feet wider and longer than the hole",
            "C": "One foot wider and longer than the hole",
            "D": "Three feet wider and longer than the hole"
          }
        },
        {
          "id": "sfd_basic_skills_304_d64306fc",
          "question": "What is the recommended overlap when using more than one piece of lath to cover a hole?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text suggests that when using more than one piece of lath to cover a hole, the ends of the lath should overlap by 3 or 4 inches.",
          "options": {
            "A": "1 or 2 inches",
            "B": "3 or 4 inches",
            "C": "5 or 6 inches",
            "D": "7 or 8 inches"
          }
        },
        {
          "id": "sfd_basic_skills_305_9047d3f8",
          "question": "What is the importance of maintaining tautness while rolling the plastic during a salvage operation?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Maintaining tautness while rolling the plastic ensures a tight roll and a taut surface across the face of the hole, which is essential for effective salvage operations.",
          "options": {
            "A": "To make the operation look professional",
            "B": "To ensure the plastic is aesthetically pleasing",
            "C": "To prevent the plastic from catching fire",
            "D": "To ensure a tight roll and a taut surface across the face of the hole"
          }
        },
        {
          "id": "sfd_basic_skills_305_e79c6b3b",
          "question": "What is the purpose of rolling the lath under the plastic to a point six inches below the hole?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Rolling the lath under the plastic to a point six inches below the hole provides additional support and tension for the plastic covering, which is crucial for effective salvage operations.",
          "options": {
            "A": "To create a decorative effect",
            "B": "To ensure the lath is hidden from view",
            "C": "To provide additional support and tension for the plastic covering",
            "D": "To make the lath easier to remove later"
          }
        },
        {
          "id": "sfd_basic_skills_305_ed5dab9e",
          "question": "What is the purpose of positioning the lath on the left side of the hole, between the previously nailed sections of lath?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Positioning the lath on the left side of the hole, between the previously nailed sections of lath, indicates the exact length needed to span the length of the hole. This is crucial for ensuring the plastic covering is properly supported.",
          "options": {
            "A": "To indicate the exact length needed to span the length of the hole",
            "B": "To make the operation look more complex",
            "C": "To ensure the lath is visible",
            "D": "To make the lath easier to remove later"
          }
        },
        {
          "id": "sfd_basic_skills_305_f7fe4de3",
          "question": "Why is it important to fold the top and bottom of the left side plastic in at a slight angle before rolling the lath into the plastic?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Folding the top and bottom of the left side plastic in at a slight angle before rolling the lath into the plastic helps to eliminate wrinkles and maintain tautness, which is crucial for effective salvage operations.",
          "options": {
            "A": "To create a decorative effect",
            "B": "To ensure the plastic is aesthetically pleasing",
            "C": "To eliminate wrinkles and maintain tautness",
            "D": "To make the plastic easier to remove later"
          }
        },
        {
          "id": "sfd_basic_skills_305_d01d487e",
          "question": "Why is it especially important to maintain tautness while rolling the final side during a salvage operation?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Maintaining tautness while rolling the final side is especially important to ensure a tight roll and a taut surface across the face of the hole, which is crucial for effective salvage operations.",
          "options": {
            "A": "To ensure the operation looks professional",
            "B": "To make the plastic easier to remove later",
            "C": "To ensure a tight roll and a taut surface across the face of the hole",
            "D": "To make the operation look more complex"
          }
        },
        {
          "id": "sfd_basic_skills_295_d1affb60",
          "question": "What is the purpose of placing rubber bands over the ends of the folded tarp in the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The rubber bands are used to hold the folded tarp ready on the apparatus for quick and efficient use.",
          "options": {
            "A": "To make the tarp look neat",
            "B": "To hold it ready on the apparatus",
            "C": "To increase the weight of the tarp",
            "D": "To make the tarp more visible"
          }
        },
        {
          "id": "sfd_basic_skills_295_fbb4e119",
          "question": "What is the correct way to hold the accordion folded tarp for use according to the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The correct way to hold the accordion folded tarp for use is 'Ears towards you, and towards your work'. This ensures proper deployment of the tarp.",
          "options": {
            "A": "Ears towards the sky",
            "B": "Ears towards your work",
            "C": "Ears towards your feet",
            "D": "Ears towards your colleague"
          }
        },
        {
          "id": "sfd_basic_skills_295_187fa068",
          "question": "Why is it important to hold the accordion folded tarp with 'Ears towards you, and towards your work'?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Holding the tarp in this manner ensures it unfolds correctly and can be deployed quickly and efficiently.",
          "options": {
            "A": "To prevent the tarp from unfolding prematurely",
            "B": "To ensure the tarp is visible to others",
            "C": "To ensure proper deployment of the tarp",
            "D": "To make it easier to carry the tarp"
          }
        },
        {
          "id": "sfd_basic_skills_295_fc6b95e3",
          "question": "What could be a potential risk if the tarp is not held correctly?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If the tarp is not held correctly, it could unfold prematurely, causing delays and potential safety risks during operations.",
          "options": {
            "A": "It could unfold prematurely",
            "B": "It could become too heavy to carry",
            "C": "It could become invisible to others",
            "D": "It could get stuck in the apparatus"
          }
        },
        {
          "id": "sfd_basic_skills_295_1f30d384",
          "question": "What is the primary purpose of the tarp in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The primary purpose of the tarp in firefighting operations is to protect property from water and fire damage during salvage operations.",
          "options": {
            "A": "To provide a surface for firefighters to rest",
            "B": "To protect property from water and fire damage",
            "C": "To act as a barrier against fire",
            "D": "To carry equipment"
          }
        },
        {
          "id": "sfd_basic_skills_299_d60572b9",
          "question": "What is the purpose of constructing doughnut rolls in the stairwell water chute?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The doughnut rolls are constructed to accomplish the necessary distance of water flow at approximately seventeen feet per roll.",
          "options": {
            "A": "To create a barrier for fire spread",
            "B": "To provide a pathway for water flow",
            "C": "To provide a resting area for firefighters",
            "D": "To block smoke from entering the stairwell"
          }
        },
        {
          "id": "sfd_basic_skills_299_9cb96898",
          "question": "How should the doughnut rolls be positioned in the stairwell?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The doughnut rolls should be positioned beginning at the point where the water will be released, and working back up the stairwell toward the water source.",
          "options": {
            "A": "From the bottom of the stairwell working upwards",
            "B": "From the top of the stairwell working downwards",
            "C": "At random intervals along the stairwell",
            "D": "In a zigzag pattern along the stairwell"
          }
        },
        {
          "id": "sfd_basic_skills_299_1daa89bc",
          "question": "What is the importance of maintaining a one-foot aisle way on the inside of the stairwell?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The one-foot aisle way on the inside of the stairwell is maintained to provide space for firefighters to move.",
          "options": {
            "A": "To allow for ventilation",
            "B": "To provide space for firefighters to move",
            "C": "To prevent water from spilling",
            "D": "To provide a pathway for fire spread"
          }
        },
        {
          "id": "sfd_basic_skills_299_d132d7a0",
          "question": "How should the tarps be arranged in the stairwell?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The next highest tarp should be unrolled, overlapping it one foot past the top of the lower chute. It should be spread out across the stairs and the outside edges rolled together, keeping the upper chute within the lower chute.",
          "options": {
            "A": "The top tarp should be rolled outside the lower tarp",
            "B": "The top tarp should be rolled inside the lower tarp",
            "C": "The tarps should be arranged in a crisscross pattern",
            "D": "The tarps should be arranged in a zigzag pattern"
          }
        },
        {
          "id": "sfd_basic_skills_299_2a05b563",
          "question": "What is the approximate distance that each doughnut roll should cover for water flow?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Each doughnut roll should cover an approximate distance of seventeen feet for water flow.",
          "options": {
            "A": "Ten feet",
            "B": "Fifteen feet",
            "C": "Seventeen feet",
            "D": "Twenty feet"
          }
        },
        {
          "id": "sfd_basic_skills_296_3e4dd5c3",
          "question": "What is the first step in the 'doughnut roll' method as described by the Seattle Fire Department?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in the 'doughnut roll' method is to un-pleat a tarp and lay it, still folded, on the floor.",
          "options": {
            "A": "Roll the tarp to the center",
            "B": "Unfold the tarp completely",
            "C": "Un-pleat a tarp and lay it folded on the floor",
            "D": "Roll the tarp lengthwise"
          }
        },
        {
          "id": "sfd_basic_skills_296_f8899200",
          "question": "Why is tension important when rolling the tarp in the 'doughnut roll' method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Pulling tension against each other while rolling the tarp helps to roll the tarp to the center effectively.",
          "options": {
            "A": "It ensures the tarp is completely unfolded",
            "B": "It helps in rolling the tarp to the center",
            "C": "It prevents the tarp from catching fire",
            "D": "It makes the tarp easier to carry"
          }
        },
        {
          "id": "sfd_basic_skills_296_9c564e4e",
          "question": "What is the final step in the 'doughnut roll' method?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "The final step in the 'doughnut roll' method is to roll the tarp lengthwise, similar to single rolling a length of hose.",
          "options": {
            "A": "Unfold the other half of the tarp",
            "B": "Roll the tarp to the center",
            "C": "Straighten the rolls",
            "D": "Roll the tarp lengthwise"
          }
        },
        {
          "id": "sfd_basic_skills_296_4294f916",
          "question": "What is the purpose of the 'doughnut roll' method?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'doughnut roll' method is a way to prepare a tarp for use in salvage operations, not to extinguish fires or rescue individuals.",
          "options": {
            "A": "To extinguish fires",
            "B": "To prepare a tarp for use in salvage operations",
            "C": "To rescue trapped individuals",
            "D": "To create a barrier against fire"
          }
        },
        {
          "id": "sfd_basic_skills_296_7779542b",
          "question": "What is the role of the two members in the 'doughnut roll' method?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "In the 'doughnut roll' method, both members work together to roll the tarp, pulling tension against each other and moving around to unfold and roll both halves of the tarp.",
          "options": {
            "A": "One member rolls the tarp while the other supervises",
            "B": "Both members roll the tarp independently",
            "C": "Both members work together to roll the tarp",
            "D": "One member unfolds the tarp while the other rolls it"
          }
        },
        {
          "id": "sfd_basic_skills_297_8eb707a4",
          "question": "What is the purpose of laying a piece of lath or scrap wood over the tarp during salvage operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A piece of lath or scrap wood laid parallel over the tarp is used to indicate that glass or fragile objects have been covered.",
          "options": {
            "A": "To provide additional weight to the tarp",
            "B": "To indicate that glass or fragile objects have been covered",
            "C": "To secure the tarp in place",
            "D": "To provide a walking path for firefighters"
          }
        },
        {
          "id": "sfd_basic_skills_297_2b14ba70",
          "question": "How should the tarp be positioned in relation to the object to be covered?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The center of the tarp (marked by the ears) should be placed alongside the centerline of the object to be covered.",
          "options": {
            "A": "The center of the tarp should be alongside the centerline of the object",
            "B": "The tarp should be placed at a 45-degree angle to the object",
            "C": "The tarp should be placed randomly over the object",
            "D": "The tarp should be placed diagonally across the object"
          }
        },
        {
          "id": "sfd_basic_skills_297_67a56923",
          "question": "What should be done if more than one tarp is required to cover an object?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "If more than one tarp is required to cover an object, the edges of the tarps should be overlapped by one foot and rolled together in the same direction as the water will flow.",
          "options": {
            "A": "The tarps should be overlapped by one foot and rolled together in the direction the water will flow",
            "B": "The tarps should be placed side by side without any overlap",
            "C": "The tarps should be placed one on top of the other",
            "D": "The tarps should be overlapped by two feet and rolled together against the direction the water will flow"
          }
        },
        {
          "id": "sfd_basic_skills_297_b7f42a26",
          "question": "How should the bottom flake of the tarp be handled during the setup?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The bottom flake of the tarp should be gripped with both hands to maintain tension and control during the setup.",
          "options": {
            "A": "It should be gripped with one hand",
            "B": "It should be gripped with both hands",
            "C": "It should be left loose",
            "D": "It should be tied to a stationary object"
          }
        },
        {
          "id": "sfd_basic_skills_297_34a7e805",
          "question": "What is the role of the second member during the tarp laying process?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The second member's role is to grasp the top fold with both hands and walk backward until the tarp is stretched taut.",
          "options": {
            "A": "To hold the tarp across both arms",
            "B": "To grasp the top fold with both hands and walk backward until the tarp is stretched taut",
            "C": "To place the center of the tarp alongside the centerline of the object",
            "D": "To tuck the excess tarp under the object"
          }
        },
        {
          "id": "sfd_basic_skills_300_270e3994",
          "question": "What is the purpose of using additional tarps in the stairwell during a firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Additional tarps are used to bank the chutes around the turns to prevent overflow, ensuring the water flow is directed towards the source of the fire.",
          "options": {
            "A": "To provide a resting place for firefighters",
            "B": "To bank the chutes around the turns to prevent overflow",
            "C": "To cover the fire and suffocate it",
            "D": "To collect water for firefighting"
          }
        },
        {
          "id": "sfd_basic_skills_300_2333b3aa",
          "question": "What is the first step in preparing a tarp according to the given procedure?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The first step in preparing a tarp is to unpleat it and lay it on the floor.",
          "options": {
            "A": "Roll the tarp into a point",
            "B": "Unfold the tarp completely",
            "C": "Unpleat the tarp and lay it on the floor",
            "D": "Move clockwise to the short edge and roll that side in three feet"
          }
        },
        {
          "id": "sfd_basic_skills_300_89bb441d",
          "question": "What is the purpose of rolling the tarp into a point one foot short of the first crease?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Rolling the tarp into a point one foot short of the first crease helps to create a chute for directing water flow during firefighting operations.",
          "options": {
            "A": "To make the tarp easier to carry",
            "B": "To create a chute for directing water flow",
            "C": "To make the tarp look neat and tidy",
            "D": "To prevent the tarp from catching fire"
          }
        },
        {
          "id": "sfd_basic_skills_300_f280da59",
          "question": "Why is it important to continue up the stairwell until the source of the water is reached during a firefighting operation?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Continuing up the stairwell until the source of the water is reached is important to establish a water flow for firefighting operations.",
          "options": {
            "A": "To ensure the fire is completely extinguished",
            "B": "To establish a water flow",
            "C": "To rescue any trapped individuals",
            "D": "To assess the structural integrity of the building"
          }
        },
        {
          "id": "sfd_basic_skills_300_4c837c83",
          "question": "What is the next step after rolling the tarp into a point one foot short of the first crease?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "After rolling the tarp into a point one foot short of the first crease, the next step is to cross over to the opposite long side, unfold it, and repeat the operation.",
          "options": {
            "A": "Fold the tarp back up",
            "B": "Move clockwise to the short edge and roll that side in three feet",
            "C": "Throw the tarp into the fire",
            "D": "Cross over to the opposite long side, unfold it, and repeat the operation"
          }
        },
        {
          "id": "sfd_basic_skills_290_ddc90e8e",
          "question": "What is the primary purpose of salvage operations during firefighting?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "Salvage operations are primarily aimed at protecting buildings and their contents from unnecessary damage due to water, smoke, and other elements during and after a fire.",
          "options": {
            "A": "To extinguish the fire",
            "B": "To rescue trapped individuals",
            "C": "To protect buildings and contents from unnecessary damage",
            "D": "To assess the cause of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_290_fecd4497",
          "question": "Why is it important for firefighters to have a thorough working knowledge of the available tools during salvage operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A thorough working knowledge of the available tools will help firefighters protect the property from unnecessary damage during salvage operations.",
          "options": {
            "A": "To ensure the safety of the firefighters",
            "B": "To minimize unnecessary damage to property",
            "C": "To speed up the extinguishing process",
            "D": "To identify the cause of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_290_ea6f29ee",
          "question": "Which of the following is NOT a performance goal for firefighters during salvage operations?",
          "type": "multiple_choice",
          "correctAnswer": "D",
          "explanation": "Determining the ignition source of the fire is not listed as a performance goal for firefighters during salvage operations.",
          "options": {
            "A": "Demonstrating proper tarp folding, rolling, throwing, and deployment",
            "B": "Constructing and using water chutes and catchalls",
            "C": "Covering windows, doors, and ventilation openings",
            "D": "Determining the ignition source of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_290_d04cce45",
          "question": "Why should salvage considerations be present during every stage of firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "Salvage considerations should be present during every stage of firefighting operations to prevent a limited amount of fire damage from turning into a large amount of water damage and peripheral destruction.",
          "options": {
            "A": "To ensure the fire is completely extinguished",
            "B": "To prevent a limited amount of fire damage from turning into a large amount of water damage and peripheral destruction",
            "C": "To rescue trapped individuals",
            "D": "To determine the cause of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_290_a272b10a",
          "question": "What is the value of salvage to the public and the Department?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "Salvage allows families to continue living in their homes and businesses to continue operations, preserving jobs and promoting community goodwill toward the fire department.",
          "options": {
            "A": "It allows families to continue living in their homes and businesses to continue operations",
            "B": "It reduces the cost of firefighting operations",
            "C": "It speeds up the process of extinguishing the fire",
            "D": "It helps in identifying the cause of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_291_c539232e",
          "question": "What is the primary use of tarps in firefighting operations according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that tarps are most often utilized as covers, for the protection of furniture, business equipment, warehouse stock, carpeting, or anything else which needs shielding from water or debris.",
          "options": {
            "A": "To create water chutes, dikes, and diverters",
            "B": "To protect furniture, business equipment, warehouse stock, carpeting, or anything else which needs shielding from water or debris",
            "C": "To serve as blankets, padding, or ground covers in first aid applications",
            "D": "To mark the location of the fire"
          }
        },
        {
          "id": "sfd_basic_skills_291_a3384454",
          "question": "What does the 'SFD' stenciled logo on a tarp indicate?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The 'SFD' stenciled logo is located in the center of the tarp, on one side only, and generally indicates the side of the tarp that is kept clean, for use on upholstered furniture.",
          "options": {
            "A": "The side of the tarp that is dirty",
            "B": "The side of the tarp that is kept clean",
            "C": "The side of the tarp that should face the fire",
            "D": "The side of the tarp that should face away from the fire"
          }
        },
        {
          "id": "sfd_basic_skills_291_83a352ed",
          "question": "What is a 'bed fire bundle' according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that two tarps and a hall runner lashed together are called a 'bed fire bundle'.",
          "options": {
            "A": "A bundle of tarps used to smother a fire",
            "B": "Two tarps and a hall runner lashed together",
            "C": "A bundle of tarps used to protect a bed from fire damage",
            "D": "A bundle of tarps and a hall runner used to create a water chute"
          }
        },
        {
          "id": "sfd_basic_skills_291_d4db6fd1",
          "question": "How are standard tarps stored for ready use?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "The text mentions that standard tarps are accordion folded and held ready with two rubber bands per tarp.",
          "options": {
            "A": "Rolled and secured with a single rubber band",
            "B": "Folded in half and secured with a single rubber band",
            "C": "Accordion folded and held ready with two rubber bands per tarp",
            "D": "Rolled and secured with two rubber bands"
          }
        },
        {
          "id": "sfd_basic_skills_291_e58329ad",
          "question": "What is the procedure for cleaning a soiled tarp according to the text?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text mentions that soiled tarps can be easily cleaned with water and a scrub brush. Use mild detergent if necessary. Hang tarps completely dry before folding or storing them.",
          "options": {
            "A": "Wash with water and a scrub brush, use mild detergent if necessary, and hang to dry before folding or storing",
            "B": "Wash with water only and hang to dry before folding or storing",
            "C": "Wash with mild detergent only and hang to dry before folding or storing",
            "D": "Wash with water and a scrub brush only, do not hang to dry before folding or storing"
          }
        },
        {
          "id": "sfd_basic_skills_301_111452b7",
          "question": "What is the purpose of constructing a catchall during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "A catchall is constructed to hold water during firefighting operations. According to the text, an 8' x 12' catchall can hold approximately 60 gallons of water for each inch of depth.",
          "options": {
            "A": "To catch falling debris",
            "B": "To hold water for firefighting",
            "C": "To provide a resting area for firefighters",
            "D": "To store firefighting equipment"
          }
        },
        {
          "id": "sfd_basic_skills_301_f6f2a724",
          "question": "What should be considered for larger water jobs during firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "C",
          "explanation": "For larger water jobs, the text suggests considering requesting the Marine Unit as they carry specialized de-watering equipment capable of removing large quantities of water quickly.",
          "options": {
            "A": "Requesting more firefighters",
            "B": "Using larger catchalls",
            "C": "Requesting the Marine Unit",
            "D": "Using more fire trucks"
          }
        },
        {
          "id": "sfd_basic_skills_301_130d4de0",
          "question": "What is the capacity of an 8' x 12' catchall?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "According to the text, an 8' x 12' catchall can hold approximately 60 gallons of water for each inch of depth.",
          "options": {
            "A": "60 gallons of water for each inch of depth",
            "B": "80 gallons of water for each inch of depth",
            "C": "100 gallons of water for each inch of depth",
            "D": "120 gallons of water for each inch of depth"
          }
        },
        {
          "id": "sfd_basic_skills_301_3a8aa768",
          "question": "What is the procedure to lock the corners of a catchall?",
          "type": "multiple_choice",
          "correctAnswer": "A",
          "explanation": "The text describes the procedure to lock the corners of a catchall as lifting the top roll with one hand, then raising the bottom roll with the other hand to form a pocket for the top roll.",
          "options": {
            "A": "Lift the top roll with one hand, then raise the bottom roll with the other hand to form a pocket for the top roll",
            "B": "Lift the bottom roll with one hand, then raise the top roll with the other hand to form a pocket for the bottom roll",
            "C": "Lift both rolls simultaneously to form a pocket",
            "D": "Fold the corners inwards to lock them"
          }
        },
        {
          "id": "sfd_basic_skills_301_744cd801",
          "question": "What is the advantage of the Marine Unit in firefighting operations?",
          "type": "multiple_choice",
          "correctAnswer": "B",
          "explanation": "The text mentions that the Marine Unit carries specialized de-watering equipment, which can be beneficial in removing large quantities of water quickly during firefighting operations.",
          "options": {
            "A": "They can construct larger catchalls",
            "B": "They carry specialized de-watering equipment",
            "C": "They can provide additional manpower",
            "D": "They have advanced firefighting techniques"
          }
        }
      ]
    }
  }
};

export default booksfd_basic_skills;
